import { DocumentNode } from 'graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** Decimal custom scalar that returns string */
  Decimal: { input: any; output: any; }
};

export enum AcademicLevel {
  HIGH_SCHOOL = 'HIGH_SCHOOL',
  PRIMARY = 'PRIMARY',
  UNIVERSITY = 'UNIVERSITY'
}

export type AccessLoggerAndroidDataType = {
  __typename?: 'AccessLoggerAndroidDataType';
  androidId?: Maybe<Scalars['String']['output']>;
  board?: Maybe<Scalars['String']['output']>;
  bootloader?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  display?: Maybe<Scalars['String']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  hardware?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isPhysicalDevice?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  supported32BitAbis?: Maybe<Array<Scalars['String']['output']>>;
  supported64BitAbis?: Maybe<Array<Scalars['String']['output']>>;
  supportedAbis?: Maybe<Array<Scalars['String']['output']>>;
  systemFeatures?: Maybe<Array<Scalars['String']['output']>>;
  tags?: Maybe<Scalars['String']['output']>;
  versionBaseOS?: Maybe<Scalars['String']['output']>;
  versionCodename?: Maybe<Scalars['String']['output']>;
  versionIncremental?: Maybe<Scalars['String']['output']>;
  versionPreviewSdkInt?: Maybe<Scalars['String']['output']>;
  versionRelease?: Maybe<Scalars['String']['output']>;
  versionSdkInt?: Maybe<Scalars['String']['output']>;
  versionSecurityPatch?: Maybe<Scalars['String']['output']>;
};

export type AccessLoggerClientDataType = {
  __typename?: 'AccessLoggerClientDataType';
  clientType?: Maybe<Scalars['String']['output']>;
  engine?: Maybe<Scalars['String']['output']>;
  engineVersion?: Maybe<Scalars['String']['output']>;
  family?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type AccessLoggerDeviceDataType = {
  __typename?: 'AccessLoggerDeviceDataType';
  androidData: AccessLoggerAndroidDataType;
  client: AccessLoggerClientDataType;
  device: AccessLoggerMachineDataType;
  iosData: AccessLoggerIosDataType;
  os: AccessLoggerOperatingSystemDataType;
};

export type AccessLoggerIosDataType = {
  __typename?: 'AccessLoggerIosDataType';
  identifierForVendor?: Maybe<Scalars['String']['output']>;
  isPhysicalDevice?: Maybe<Scalars['String']['output']>;
  localizedModel?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  systemName?: Maybe<Scalars['String']['output']>;
  systemVersion?: Maybe<Scalars['String']['output']>;
  utsnameMachine?: Maybe<Scalars['String']['output']>;
  utsnameNodename?: Maybe<Scalars['String']['output']>;
  utsnameRelease?: Maybe<Scalars['String']['output']>;
  utsnameSysname?: Maybe<Scalars['String']['output']>;
  utsnameVersion?: Maybe<Scalars['String']['output']>;
};

export type AccessLoggerMachineDataType = {
  __typename?: 'AccessLoggerMachineDataType';
  brand?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
};

export type AccessLoggerOperatingSystemDataType = {
  __typename?: 'AccessLoggerOperatingSystemDataType';
  brand?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type AccessLoggerRequestType = {
  __typename?: 'AccessLoggerRequestType';
  host?: Maybe<Scalars['String']['output']>;
  hostname?: Maybe<Scalars['String']['output']>;
  operationName: Scalars['String']['output'];
  origin?: Maybe<Scalars['String']['output']>;
  pathname?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['String']['output']>;
  protocol?: Maybe<Scalars['String']['output']>;
  query: Scalars['String']['output'];
  referer?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  variables?: Maybe<Scalars['String']['output']>;
};

export type AccountInput = {
  expiresAt: Scalars['DateTime']['input'];
  location?: InputMaybe<Scalars['ID']['input']>;
  permissions?: InputMaybe<Array<Scalars['ID']['input']>>;
  target: TargetAciInput;
  user: Scalars['ID']['input'];
};

export type AccountPaginateType = {
  __typename?: 'AccountPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<AccountType>;
};

export type AccountType = {
  __typename?: 'AccountType';
  createdAt: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<LocationType>;
  permission?: Maybe<PermissionType>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type AccountUpdateInput = {
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  permissions?: InputMaybe<Array<Scalars['ID']['input']>>;
  target?: InputMaybe<TargetAciInput>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type AccountsByRoleCountType = {
  __typename?: 'AccountsByRoleCountType';
  numberOfAccounts: Scalars['Int']['output'];
  role: UserRole;
};

export type AccountsCountType = {
  __typename?: 'AccountsCountType';
  total: Scalars['Int']['output'];
  totalNumberOfManufacturerAccounts: Scalars['Int']['output'];
  totalNumberOfPosAccounts: Scalars['Int']['output'];
  totalNumberOfWholesalerAccounts: Scalars['Int']['output'];
};

export type AccountsWithStatsType = {
  __typename?: 'AccountsWithStatsType';
  createdAt: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  hours?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<LocationType>;
  permission?: Maybe<PermissionType>;
  progress?: Maybe<Scalars['Decimal']['output']>;
  target: TargetType;
  tasks?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type ActionType = {
  __typename?: 'ActionType';
  activity?: Maybe<Scalars['String']['output']>;
  adhocNotification?: Maybe<AdhocNotificationType>;
  adhocOrder?: Maybe<Scalars['String']['output']>;
  booking?: Maybe<BookingType>;
  internalProduct?: Maybe<Scalars['String']['output']>;
  onsite?: Maybe<NotificationOnsiteConverterType>;
  order?: Maybe<Scalars['String']['output']>;
  quest?: Maybe<Scalars['String']['output']>;
  reputationLoss?: Maybe<Scalars['Float']['output']>;
  subscription?: Maybe<Scalars['String']['output']>;
  table?: Maybe<Scalars['String']['output']>;
};

export enum ActionTypeEnum {
  APPLE_LOGIN = 'APPLE_LOGIN',
  COUPON_PURCHASED = 'COUPON_PURCHASED',
  COUPON_REDEEMED = 'COUPON_REDEEMED',
  EMPTY_SHOPPING_CART_FOR_TARGET = 'EMPTY_SHOPPING_CART_FOR_TARGET',
  FACEBOOK_LOGIN = 'FACEBOOK_LOGIN',
  GOOGLE_LOGIN = 'GOOGLE_LOGIN',
  LINK_USER_ACCOUNT = 'LINK_USER_ACCOUNT',
  LOGGED_OUT_BY_TARGET = 'LOGGED_OUT_BY_TARGET',
  LOGGED_OUT_FOR_TARGET = 'LOGGED_OUT_FOR_TARGET',
  LOGIN = 'LOGIN',
  LOGIN_BY_TARGET = 'LOGIN_BY_TARGET',
  LOGIN_FOR_APP = 'LOGIN_FOR_APP',
  LOGIN_FOR_TARGET = 'LOGIN_FOR_TARGET',
  ORDER_CANCELED = 'ORDER_CANCELED',
  ORDER_CREATED = 'ORDER_CREATED',
  ORDER_CREATED_AND_USER_REGISTERED_FOR_TARGET = 'ORDER_CREATED_AND_USER_REGISTERED_FOR_TARGET',
  ORDER_CREATED_FOR_GUEST_USER = 'ORDER_CREATED_FOR_GUEST_USER',
  ORDER_PAID = 'ORDER_PAID',
  PRODUCTS_ADDED_TO_SHOPPING_CART = 'PRODUCTS_ADDED_TO_SHOPPING_CART',
  PRODUCTS_REMOVED_FROM_SHOPPING_CART = 'PRODUCTS_REMOVED_FROM_SHOPPING_CART',
  PRODUCT_CANCELED = 'PRODUCT_CANCELED',
  PRODUCT_CONFIRMED = 'PRODUCT_CONFIRMED',
  PRODUCT_DELIVERED = 'PRODUCT_DELIVERED',
  PRODUCT_OPENED = 'PRODUCT_OPENED',
  PRODUCT_RATED = 'PRODUCT_RATED',
  REGISTER = 'REGISTER',
  REGISTER_FOR_APP = 'REGISTER_FOR_APP',
  REGISTER_FOR_TARGET = 'REGISTER_FOR_TARGET',
  REGISTER_FOR_TARGET_WITH_ONBOARD = 'REGISTER_FOR_TARGET_WITH_ONBOARD',
  SEND_FORGOT_PASSWORD_MAIL_TO_TARGET = 'SEND_FORGOT_PASSWORD_MAIL_TO_TARGET',
  SEND_FORGOT_PASSWORD_SMS_TO_TARGET = 'SEND_FORGOT_PASSWORD_SMS_TO_TARGET',
  SEND_VALIDATION_EMAIL_LOG = 'SEND_VALIDATION_EMAIL_LOG',
  SEND_VALIDATION_SMS_LOG = 'SEND_VALIDATION_SMS_LOG',
  UPDATE_PASSWORD_FOR_TARGET = 'UPDATE_PASSWORD_FOR_TARGET',
  UPDATE_USER = 'UPDATE_USER',
  VALIDATE_EMAIL_FOR_TARGET = 'VALIDATE_EMAIL_FOR_TARGET',
  VALIDATE_SMS_CODE = 'VALIDATE_SMS_CODE'
}

export type ActiveQuestsStatsType = {
  __typename?: 'ActiveQuestsStatsType';
  percentage?: Maybe<Scalars['Decimal']['output']>;
  quests?: Maybe<Array<QuestStatsType>>;
  totalQuests?: Maybe<Scalars['Float']['output']>;
};

export type ActivityLogActionType = {
  __typename?: 'ActivityLogActionType';
  activity?: Maybe<QuestActivityType>;
  order?: Maybe<MarketPlaceOrderDtoType>;
  quest?: Maybe<QuestType>;
};

export type ActivityLogAffectedType = {
  __typename?: 'ActivityLogAffectedType';
  manufacturer?: Maybe<ManufacturerType>;
  pos?: Maybe<PointOfSaleType>;
  user?: Maybe<UserType>;
  wholesaler?: Maybe<WholesalerType>;
};

export type ActivityLogBalanceAmountType = {
  __typename?: 'ActivityLogBalanceAmountType';
  qualitative?: Maybe<Scalars['Decimal']['output']>;
  quantitative?: Maybe<Scalars['Decimal']['output']>;
};

export type ActivityLogBalanceType = {
  __typename?: 'ActivityLogBalanceType';
  amount?: Maybe<ActivityLogBalanceAmountType>;
  sign: TaxSignEnum;
};

export type ActivityLogPaginateType = {
  __typename?: 'ActivityLogPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ActivityLogType>;
};

export type ActivityLogType = {
  __typename?: 'ActivityLogType';
  action?: Maybe<ActivityLogActionType>;
  activityType?: Maybe<ActivityLogTypeEnum>;
  affected?: Maybe<ActivityLogAffectedType>;
  balance?: Maybe<ActivityLogBalanceType>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  target?: Maybe<ActivityLogAffectedType>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum ActivityLogTypeEnum {
  CONVERSION = 'CONVERSION',
  DEAL_ORDER_ADDED = 'DEAL_ORDER_ADDED',
  MOBILE_ONSITE_ACTIVITY = 'MOBILE_ONSITE_ACTIVITY',
  ORDER_ADDED = 'ORDER_ADDED',
  PHYSICAL_ONSITE_ACTIVITY = 'PHYSICAL_ONSITE_ACTIVITY',
  QUEST_FULFILLED = 'QUEST_FULFILLED',
  REDEEM = 'REDEEM',
  REPUTATION_LOST = 'REPUTATION_LOST',
  WALLET_TOPUP = 'WALLET_TOPUP',
  WEB_ONSITE_ACTIVITY = 'WEB_ONSITE_ACTIVITY'
}

export type ActivityTypeDonationInput = {
  cause?: InputMaybe<Scalars['ID']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityTypeDonationType = {
  __typename?: 'ActivityTypeDonationType';
  cause?: Maybe<CauseType>;
  enable?: Maybe<Scalars['Boolean']['output']>;
};

export type ActivityTypeInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  donation?: InputMaybe<ActivityTypeDonationInput>;
  icon?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  predefined?: InputMaybe<PredefinedActionInput>;
  target?: InputMaybe<TargetAciInput>;
  theme?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityTypePaginateType = {
  __typename?: 'ActivityTypePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ActivityTypeType>;
};

export type ActivityTypeType = {
  __typename?: 'ActivityTypeType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  donation?: Maybe<ActivityTypeDonationType>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<MediaType>;
  predefined?: Maybe<PredefinedActionType>;
  target?: Maybe<TargetType>;
  theme?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ActivityTypeUpdateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  donation?: InputMaybe<ActivityTypeDonationInput>;
  icon?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  predefined?: InputMaybe<PredefinedActionInput>;
  target?: InputMaybe<TargetAciInput>;
  theme?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityTypeWithActiveStatusPaginateType = {
  __typename?: 'ActivityTypeWithActiveStatusPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ActivityTypeWithActiveStatusType>;
};

export type ActivityTypeWithActiveStatusType = {
  __typename?: 'ActivityTypeWithActiveStatusType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  donation?: Maybe<ActivityTypeDonationType>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<MediaType>;
  predefined?: Maybe<PredefinedActionType>;
  theme?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AddGameGroupInput = {
  code: Scalars['String']['input'];
  games?: InputMaybe<Array<Scalars['ID']['input']>>;
  leaderboard?: InputMaybe<GameIntegrationLeaderboardInput>;
  name: Scalars['String']['input'];
  picture?: InputMaybe<PictureInput>;
  point?: InputMaybe<GamePointInput>;
  rewardsSchedular?: InputMaybe<Array<GameIntegrationRewardsSchedularInput>>;
  target: TargetAciInput;
};

export type AddGameToGameGroupInput = {
  gameGroupCode: Scalars['String']['input'];
  gameIds: Array<Scalars['ID']['input']>;
  target: TargetAciInput;
};

export type AddReputationInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  frequencyGoalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  inactivityCycle?: InputMaybe<Scalars['Int']['input']>;
  lossAmount?: InputMaybe<Scalars['Int']['input']>;
  lossPoints?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<Scalars['Int']['input']>;
  perks?: InputMaybe<PerksInput>;
  picture?: InputMaybe<PictureInput>;
  points?: InputMaybe<Scalars['Int']['input']>;
  reputationLevel?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
  translation?: InputMaybe<Array<ReputationTranslationInput>>;
  turnoverGoalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  turnoverPoints?: InputMaybe<Scalars['Int']['input']>;
};

export type AdhocCorporateNotificationTestType = {
  __typename?: 'AdhocCorporateNotificationTestType';
  action?: Maybe<CorporateActionType>;
  event?: Maybe<EventTypeEnum>;
  executed?: Maybe<Scalars['Boolean']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  seen?: Maybe<Scalars['Boolean']['output']>;
};

export type AdhocCorporateNotificationType = {
  __typename?: 'AdhocCorporateNotificationType';
  description?: Maybe<Scalars['String']['output']>;
  executed?: Maybe<Scalars['Boolean']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  picture?: Maybe<PictureType>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AdhocNotificationTestType = {
  __typename?: 'AdhocNotificationTestType';
  action?: Maybe<ActionType>;
  event?: Maybe<EventTypeEnum>;
  executed?: Maybe<Scalars['Boolean']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  seen?: Maybe<Scalars['Boolean']['output']>;
};

export type AdhocNotificationType = {
  __typename?: 'AdhocNotificationType';
  description?: Maybe<Scalars['String']['output']>;
  executed?: Maybe<Scalars['Boolean']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  picture?: Maybe<PictureType>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AdhocTransactionInput = {
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  prelevel?: InputMaybe<RemunerationBaseInput>;
  remunerations?: InputMaybe<Array<RemunerationWithReputationInput>>;
  target?: InputMaybe<TargetAciInput>;
  title: Scalars['String']['input'];
  translation?: InputMaybe<Array<AdhocTransactionTranslationInput>>;
  wallet?: InputMaybe<Scalars['ID']['input']>;
};

export type AdhocTransactionPaginateType = {
  __typename?: 'AdhocTransactionPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<AdhocTransactionType>;
};

export type AdhocTransactionTranslationContentInput = {
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type AdhocTransactionTranslationContentType = {
  __typename?: 'AdhocTransactionTranslationContentType';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type AdhocTransactionTranslationInput = {
  content: AdhocTransactionTranslationContentInput;
  language: Scalars['ID']['input'];
};

export type AdhocTransactionTranslationType = {
  __typename?: 'AdhocTransactionTranslationType';
  content: AdhocTransactionTranslationContentType;
  language: LanguageType;
};

export type AdhocTransactionType = {
  __typename?: 'AdhocTransactionType';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  prelevel?: Maybe<RemunerationWithOutReputationDtoType>;
  remunerations?: Maybe<Array<RemunerationWithReputationDtoType>>;
  target: TargetType;
  title: Scalars['String']['output'];
  translation?: Maybe<Array<AdhocTransactionTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  wallet?: Maybe<WalletType>;
};

export type AdhocTransactionUpdateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  prelevel?: InputMaybe<RemunerationBaseInput>;
  remunerations?: InputMaybe<Array<RemunerationWithReputationInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Array<AdhocTransactionTranslationInput>>;
  wallet?: InputMaybe<Scalars['ID']['input']>;
};

export enum AgeGroupBucketEnum {
  AGE_18_24 = 'AGE_18_24',
  AGE_25_34 = 'AGE_25_34',
  AGE_35_44 = 'AGE_35_44',
  AGE_45_54 = 'AGE_45_54',
  AGE_55_64 = 'AGE_55_64',
  AGE_65_PLUS = 'AGE_65_PLUS'
}

export enum AggregatorModelEnum {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL'
}

export type AmazonSesResponseDtoType = {
  __typename?: 'AmazonSesResponseDtoType';
  data?: Maybe<Array<SesSendDataPointDto>>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AmountPercentageDecimalType = {
  __typename?: 'AmountPercentageDecimalType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  percentage?: Maybe<Scalars['Decimal']['output']>;
};

export type AnalyticsAudienceMetricsChartType = {
  __typename?: 'AnalyticsAudienceMetricsChartType';
  conversions: Array<Scalars['Decimal']['output']>;
  impressions: Array<Scalars['Decimal']['output']>;
};

export type AnalyticsAudienceMetricsType = {
  __typename?: 'AnalyticsAudienceMetricsType';
  avgSession?: Maybe<AnalyticsRateCompareType>;
  chart?: Maybe<AnalyticsAudienceMetricsChartType>;
  conversion?: Maybe<AnalyticsRateCompareType>;
  impressions?: Maybe<AnalyticsRateCompareType>;
};

export type AnalyticsAudienceSessionsByCountryChartDataType = {
  __typename?: 'AnalyticsAudienceSessionsByCountryChartDataType';
  value?: Maybe<Scalars['Int']['output']>;
  week?: Maybe<Scalars['String']['output']>;
};

export type AnalyticsAudienceSessionsByCountryType = {
  __typename?: 'AnalyticsAudienceSessionsByCountryType';
  data?: Maybe<Array<AnalyticsAudienceSessionsByCountryChartDataType>>;
  day?: Maybe<DayEnum>;
};

export type AnalyticsDashboardInput = {
  from: Scalars['DateTime']['input'];
  target?: InputMaybe<TargetAciInput>;
  to: Scalars['DateTime']['input'];
};

export type AnalyticsRateCompareType = {
  __typename?: 'AnalyticsRateCompareType';
  compare: Scalars['Decimal']['output'];
  rate: Scalars['Decimal']['output'];
};

export type AnalyticsSessionsByCountriesType = {
  __typename?: 'AnalyticsSessionsByCountriesType';
  color: Scalars['String']['output'];
  country: CountryType;
  value: Scalars['Int']['output'];
};

export type AnalyticsStatsInfoType = {
  __typename?: 'AnalyticsStatsInfoType';
  percentage: Scalars['Decimal']['output'];
  value: Scalars['Decimal']['output'];
};

export type AnalyticsStatsType = {
  __typename?: 'AnalyticsStatsType';
  conversions?: Maybe<AnalyticsStatsInfoType>;
  impressions?: Maybe<AnalyticsStatsInfoType>;
  sessions?: Maybe<AnalyticsStatsInfoType>;
  users?: Maybe<AnalyticsStatsInfoType>;
};

export type AnalyticsTopOperatingSystemSegmentType = {
  __typename?: 'AnalyticsTopOperatingSystemSegmentType';
  color: Scalars['String']['output'];
  source: Scalars['String']['output'];
  value: Scalars['Decimal']['output'];
};

export type AnalyticsTopOperatingSystemsType = {
  __typename?: 'AnalyticsTopOperatingSystemsType';
  compare: Scalars['Decimal']['output'];
  segments: Array<AnalyticsTopOperatingSystemSegmentType>;
  total: Scalars['Int']['output'];
};

export type AnalyticsTopPagesType = {
  __typename?: 'AnalyticsTopPagesType';
  active: Scalars['Int']['output'];
  page: Scalars['String']['output'];
  users: Scalars['Decimal']['output'];
};

export type AnalyticsUsersByCountryLayersType = {
  __typename?: 'AnalyticsUsersByCountryLayersType';
  coordination?: Maybe<LatLngType>;
  radius?: Maybe<Scalars['Float']['output']>;
};

export type AnalyticsUsersByCountrySegmentsType = {
  __typename?: 'AnalyticsUsersByCountrySegmentsType';
  conversions?: Maybe<Scalars['Float']['output']>;
  country: CountryType;
  impressions?: Maybe<Scalars['Float']['output']>;
};

export type AnalyticsUsersByCountryType = {
  __typename?: 'AnalyticsUsersByCountryType';
  layers?: Maybe<Array<AnalyticsUsersByCountryLayersType>>;
  segments?: Maybe<Array<AnalyticsUsersByCountrySegmentsType>>;
};

export type AnalyticsUsersByDeviceDeviceType = {
  __typename?: 'AnalyticsUsersByDeviceDeviceType';
  compare: Scalars['Decimal']['output'];
  value: Scalars['Int']['output'];
};

export type AnalyticsUsersByDeviceType = {
  __typename?: 'AnalyticsUsersByDeviceType';
  desktop?: Maybe<AnalyticsUsersByDeviceDeviceType>;
  mobile?: Maybe<AnalyticsUsersByDeviceDeviceType>;
  tablet?: Maybe<AnalyticsUsersByDeviceDeviceType>;
  unknown?: Maybe<AnalyticsUsersByDeviceDeviceType>;
};

export type AndroidDataType = {
  __typename?: 'AndroidDataType';
  androidId?: Maybe<Scalars['String']['output']>;
  board?: Maybe<Scalars['String']['output']>;
  bootloader?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  display?: Maybe<Scalars['String']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  hardware?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isPhysicalDevice?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  supported32BitAbis?: Maybe<Array<Scalars['String']['output']>>;
  supported64BitAbis?: Maybe<Array<Scalars['String']['output']>>;
  supportedAbis?: Maybe<Array<Scalars['String']['output']>>;
  systemFeatures?: Maybe<Array<Scalars['String']['output']>>;
  tags?: Maybe<Scalars['String']['output']>;
  versionBaseOS?: Maybe<Scalars['String']['output']>;
  versionCodename?: Maybe<Scalars['String']['output']>;
  versionIncremental?: Maybe<Scalars['String']['output']>;
  versionPreviewSdkInt?: Maybe<Scalars['String']['output']>;
  versionRelease?: Maybe<Scalars['String']['output']>;
  versionSdkInt?: Maybe<Scalars['String']['output']>;
  versionSecurityPatch?: Maybe<Scalars['String']['output']>;
};

export type AnswerDtoType = {
  __typename?: 'AnswerDtoType';
  answers: ResponseAnswerType;
  count: Scalars['Int']['output'];
};

export type ApiInput = {
  endPoint: Scalars['String']['input'];
  secretKey: Scalars['String']['input'];
};

export enum ApiMethods {
  DELETE = 'DELETE',
  GET = 'GET',
  HEAD = 'HEAD',
  OPTIONS = 'OPTIONS',
  PATCH = 'PATCH',
  POST = 'POST',
  PUT = 'PUT'
}

export type ApiParamsInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ApiReturnType = {
  __typename?: 'ApiReturnType';
  headers: Scalars['String']['output'];
  request: Scalars['String']['output'];
  status: Scalars['Float']['output'];
  statusText: Scalars['String']['output'];
};

export type ApiTargetType = {
  __typename?: 'ApiTargetType';
  coach?: Maybe<Scalars['Int']['output']>;
  player?: Maybe<Scalars['Int']['output']>;
};

export enum App {
  BOSK = 'BOSK',
  COCKPIT = 'COCKPIT',
  DIKTUP = 'DIKTUP',
  FIGAMY = 'FIGAMY',
  MAGARI = 'MAGARI',
  QUENEY = 'QUENEY',
  RECOLDA = 'RECOLDA',
  SIFCA = 'SIFCA',
  SKUAD = 'SKUAD'
}

export type AppFollowTopChartType = {
  __typename?: 'AppFollowTopChartType';
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  genre?: Maybe<TopChartGenreType>;
  id: Scalars['ID']['output'];
  leaderboard?: Maybe<Array<TopChartLeaderboardType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AppTweakTopChartLeaderboardType = {
  __typename?: 'AppTweakTopChartLeaderboardType';
  developer?: Maybe<Scalars['String']['output']>;
  devices?: Maybe<Array<Scalars['String']['output']>>;
  genres?: Maybe<Array<Scalars['String']['output']>>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  in_apps?: Maybe<Scalars['Boolean']['output']>;
  power?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  ratings_count?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AppTweakTopChartType = {
  __typename?: 'AppTweakTopChartType';
  appType: ChartAppTypeEnum;
  country: CountryType;
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  genre?: Maybe<TopChartGenreType>;
  id: Scalars['ID']['output'];
  leaderboard?: Maybe<Array<AppTweakTopChartLeaderboardType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AppleDataType = {
  __typename?: 'AppleDataType';
  authorizationCode?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  identityToken: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  userIdentifier?: Maybe<Scalars['String']['output']>;
};

export type AssigneeDtoType = {
  __typename?: 'AssigneeDtoType';
  manufacturer?: Maybe<ManufacturerType>;
  pos?: Maybe<PointOfSaleType>;
  user?: Maybe<UserType>;
  wholesaler?: Maybe<WholesalerType>;
};

export type AssigneeInput = {
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  pos?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
  wholesaler?: InputMaybe<Scalars['String']['input']>;
};

export type AttributeBaseType = {
  __typename?: 'AttributeBaseType';
  createdAt: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isMultipleChoice?: Maybe<Scalars['Boolean']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  pixel?: Maybe<AttributePixelType>;
  translation?: Maybe<Array<AttributeTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  variety?: Maybe<ProductVarietyEnum>;
};

export type AttributeCreateInput = {
  externalId: Scalars['String']['input'];
  isMultipleChoice?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  pixel?: InputMaybe<AttributePixelInput>;
  target?: InputMaybe<TargetAciInput>;
  translation?: InputMaybe<Array<AttributeTranslationInput>>;
  variety?: InputMaybe<ProductVarietyEnum>;
};

export type AttributePaginateType = {
  __typename?: 'AttributePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<AttributeType>;
};

export type AttributePixelInput = {
  pixelAttribute?: InputMaybe<Scalars['String']['input']>;
};

export type AttributePixelType = {
  __typename?: 'AttributePixelType';
  pixelAttribute?: Maybe<Scalars['String']['output']>;
};

export type AttributeRawBaseType = {
  __typename?: 'AttributeRawBaseType';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type AttributeTranslationContentInput = {
  label: Scalars['String']['input'];
};

export type AttributeTranslationContentType = {
  __typename?: 'AttributeTranslationContentType';
  label: Scalars['String']['output'];
};

export type AttributeTranslationInput = {
  content: AttributeTranslationContentInput;
  language: Scalars['ID']['input'];
};

export type AttributeTranslationType = {
  __typename?: 'AttributeTranslationType';
  content: AttributeTranslationContentType;
  language: LanguageType;
};

export type AttributeType = {
  __typename?: 'AttributeType';
  createdAt: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isMultipleChoice?: Maybe<Scalars['Boolean']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  pixel?: Maybe<AttributePixelType>;
  target?: Maybe<TargetType>;
  translation?: Maybe<Array<AttributeTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  variety?: Maybe<ProductVarietyEnum>;
};

export type AttributeUpdateInput = {
  id: Scalars['ID']['input'];
  isMultipleChoice?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  pixel?: InputMaybe<AttributePixelInput>;
  translation?: InputMaybe<Array<AttributeTranslationInput>>;
  variety?: InputMaybe<ProductVarietyEnum>;
};

export type AttributeValueBaseRawType = {
  __typename?: 'AttributeValueBaseRawType';
  attribute: AttributeBaseType;
  createdAt: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  price?: Maybe<Scalars['Decimal']['output']>;
  publicPrice?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<AttributeValueTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AttributeValueBaseType = {
  __typename?: 'AttributeValueBaseType';
  createdAt: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  price?: Maybe<Scalars['Decimal']['output']>;
  publicPrice?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<AttributeValueTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AttributeValueFilterType = {
  __typename?: 'AttributeValueFilterType';
  attribute: AttributeRawBaseType;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  price?: Maybe<Scalars['Decimal']['output']>;
  publicPrice?: Maybe<Scalars['Decimal']['output']>;
};

export type AttributeValueInput = {
  attribute: Scalars['ID']['input'];
  externalId: Scalars['String']['input'];
  label: Scalars['String']['input'];
  price?: InputMaybe<Scalars['Decimal']['input']>;
  target: TargetAciInput;
  translation?: InputMaybe<Array<AttributeValueTranslationInput>>;
};

export type AttributeValuePaginateType = {
  __typename?: 'AttributeValuePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<AttributeValueType>;
};

export type AttributeValueTranslationContentInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  label: Scalars['String']['input'];
};

export type AttributeValueTranslationContentType = {
  __typename?: 'AttributeValueTranslationContentType';
  label: Scalars['String']['output'];
};

export type AttributeValueTranslationInput = {
  content: AttributeValueTranslationContentInput;
  language: Scalars['ID']['input'];
};

export type AttributeValueTranslationType = {
  __typename?: 'AttributeValueTranslationType';
  content: AttributeValueTranslationContentType;
  language: LanguageType;
};

export type AttributeValueType = {
  __typename?: 'AttributeValueType';
  attribute: AttributeType;
  createdAt: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  price?: Maybe<Scalars['Decimal']['output']>;
  publicPrice?: Maybe<Scalars['Decimal']['output']>;
  target: TargetType;
  translation?: Maybe<Array<AttributeValueTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AttributeValueUpdateInput = {
  attribute?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  translation?: InputMaybe<Array<AttributeValueTranslationInput>>;
};

export type AttributeWithAttributeValueType = {
  __typename?: 'AttributeWithAttributeValueType';
  createdAt: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isMultipleChoice?: Maybe<Scalars['Boolean']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  pixel?: Maybe<AttributePixelType>;
  productAttributesValues?: Maybe<Array<AttributeValueBaseType>>;
  target?: Maybe<TargetType>;
  translation?: Maybe<Array<AttributeTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  variety?: Maybe<ProductVarietyEnum>;
};

export type AttributeWithValueFilterType = {
  __typename?: 'AttributeWithValueFilterType';
  attributeValues?: Maybe<Array<FilterLabelFieldType>>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type AttributesValidationType = {
  __typename?: 'AttributesValidationType';
  headersValid?: Maybe<Scalars['Boolean']['output']>;
  isIdComplete?: Maybe<Scalars['Boolean']['output']>;
  isLabelComplete?: Maybe<Scalars['Boolean']['output']>;
  isMultipleComplete?: Maybe<Scalars['Boolean']['output']>;
  isRequiredComplete?: Maybe<Scalars['Boolean']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  overallValidation?: Maybe<Scalars['Boolean']['output']>;
};

export type AttributesValuesValidationType = {
  __typename?: 'AttributesValuesValidationType';
  headersValid?: Maybe<Scalars['Boolean']['output']>;
  isAttributeComplete?: Maybe<Scalars['Boolean']['output']>;
  isIdComplete?: Maybe<Scalars['Boolean']['output']>;
  isValueComplete?: Maybe<Scalars['Boolean']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  overallValidation?: Maybe<Scalars['Boolean']['output']>;
};

export enum AudienceCriteriaFieldEnum {
  ABANDONED_CARTS = 'ABANDONED_CARTS',
  ACTIVITY_FREQUENCY = 'ACTIVITY_FREQUENCY',
  AGE = 'AGE',
  BIG_SPENDERS = 'BIG_SPENDERS',
  COUNTRY = 'COUNTRY',
  DISCOUNT_SEEKER = 'DISCOUNT_SEEKER',
  EDUCATION = 'EDUCATION',
  FREQUENT_SHOPPERS = 'FREQUENT_SHOPPERS',
  GENDER = 'GENDER',
  HOBBIES = 'HOBBIES',
  INTERESTS = 'INTERESTS',
  JOIN_DATE = 'JOIN_DATE',
  JOIN_DURATION = 'JOIN_DURATION',
  LANGUAGE = 'LANGUAGE',
  LAPSED_CUSTOMERS = 'LAPSED_CUSTOMERS',
  LOCATION = 'LOCATION',
  MARITAL_STATUS = 'MARITAL_STATUS',
  NO_TRANSACTIONS = 'NO_TRANSACTIONS',
  OCCUPATION = 'OCCUPATION',
  PRODUCT_CATEGORY = 'PRODUCT_CATEGORY',
  QUANTITATIVE_CURRENT = 'QUANTITATIVE_CURRENT',
  QUANTITATIVE_OVERALL = 'QUANTITATIVE_OVERALL',
  QUEST_ACTION = 'QUEST_ACTION',
  REPUTATION_LEVEL = 'REPUTATION_LEVEL',
  SEASONAL_SHOPPERS = 'SEASONAL_SHOPPERS',
  STATE = 'STATE'
}

export type AudienceCriteriaFieldInput = {
  field?: InputMaybe<AudienceCriteriaFieldEnum>;
  operators?: InputMaybe<Array<OperatorEnum>>;
};

export type AudienceCriteriaFieldType = {
  __typename?: 'AudienceCriteriaFieldType';
  field?: Maybe<AudienceCriteriaFieldEnum>;
  operators?: Maybe<Array<OperatorEnum>>;
};

export type AudienceCriteriaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<Array<AudienceCriteriaFieldInput>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  style?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AudienceCriteriaPaginateType = {
  __typename?: 'AudienceCriteriaPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<AudienceCriteriaType>;
};

export type AudienceCriteriaType = {
  __typename?: 'AudienceCriteriaType';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enable?: Maybe<Scalars['Boolean']['output']>;
  fields?: Maybe<Array<AudienceCriteriaFieldType>>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<MediaType>;
  style?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AudienceInput = {
  advertiser?: InputMaybe<TargetAciInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  /** Segments should only be provided if type is "DYNAMIC". */
  questType?: InputMaybe<Scalars['ID']['input']>;
  /** Segments should only be provided if type is "DYNAMIC". */
  segments?: InputMaybe<Array<AudienceSegmentInput>>;
  target?: InputMaybe<TargetAciInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AudienceTypeEnum>;
};

export type AudiencePaginateType = {
  __typename?: 'AudiencePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<AudienceType>;
};

export type AudienceReachInput = {
  reach?: InputMaybe<Scalars['Int']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
};

export type AudienceReachType = {
  __typename?: 'AudienceReachType';
  reach?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum AudienceRelationEnum {
  AND = 'AND',
  OR = 'OR'
}

export type AudienceSegmentFilterFieldInput = {
  value?: InputMaybe<AudienceCriteriaFieldEnum>;
};

export type AudienceSegmentFilterFieldType = {
  __typename?: 'AudienceSegmentFilterFieldType';
  value?: Maybe<AudienceCriteriaFieldEnum>;
};

export type AudienceSegmentFilterInput = {
  field?: InputMaybe<AudienceSegmentFilterFieldInput>;
  operator?: InputMaybe<OperatorEnum>;
};

export type AudienceSegmentFilterType = {
  __typename?: 'AudienceSegmentFilterType';
  field?: Maybe<AudienceSegmentFilterFieldType>;
  operator?: Maybe<OperatorEnum>;
};

export type AudienceSegmentFilterValueInput = {
  catalogueCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  countries?: InputMaybe<Array<Scalars['ID']['input']>>;
  duration?: InputMaybe<QuestAudienceSegmentFrequencyInput>;
  educations?: InputMaybe<Array<AcademicLevel>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  frequency?: InputMaybe<QuestAudienceSegmentFrequencyInput>;
  genders?: InputMaybe<Array<Gender>>;
  languages?: InputMaybe<Array<Scalars['ID']['input']>>;
  maritalStatuses?: InputMaybe<Array<MaritalStatus>>;
  maxValue?: InputMaybe<Scalars['String']['input']>;
  minValue?: InputMaybe<Scalars['String']['input']>;
  quest?: InputMaybe<AudienceSegmentFilterValuesQuestInput>;
  reputations?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  states?: InputMaybe<Array<Scalars['ID']['input']>>;
  transactionsReasons?: InputMaybe<Array<TransactionTypeEnum>>;
  value?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
  zone?: InputMaybe<AudienceSegmentFilterZoneInput>;
};

export type AudienceSegmentFilterValuesQuestActionInput = {
  api?: InputMaybe<QuestActionActionPerformedInput>;
  appDownload?: InputMaybe<QuestActionActionPerformedInput>;
  button?: InputMaybe<QuestActionActionPerformedInput>;
  form?: InputMaybe<AudienceSegmentFilterValuesQuestFormInput>;
  game?: InputMaybe<QuestActionActionGameInput>;
  lead?: InputMaybe<QuestActionActionPerformedInput>;
  socialMedia?: InputMaybe<QuestActionActionPerformedInput>;
  video?: InputMaybe<QuestActionActionPerformedInput>;
};

export type AudienceSegmentFilterValuesQuestActionType = {
  __typename?: 'AudienceSegmentFilterValuesQuestActionType';
  api?: Maybe<QuestActionActionPerformedType>;
  appDownload?: Maybe<QuestActionActionPerformedType>;
  form?: Maybe<AudienceSegmentFilterValuesQuestFormType>;
  game?: Maybe<QuestActionActionGamePerformedType>;
  lead?: Maybe<QuestActionActionPerformedType>;
  socialMedia?: Maybe<QuestActionActionPerformedType>;
  video?: Maybe<QuestActionActionPerformedType>;
};

export type AudienceSegmentFilterValuesQuestAnswersType = {
  __typename?: 'AudienceSegmentFilterValuesQuestAnswersType';
  date?: Maybe<TimeFromToType>;
  multipleChoices?: Maybe<Array<Scalars['String']['output']>>;
  number?: Maybe<QuestAudienceSegmentFilterValuesAnswersNumberType>;
  paragraph?: Maybe<Array<Scalars['String']['output']>>;
  rating?: Maybe<Array<Scalars['Int']['output']>>;
  shortAnswer?: Maybe<Array<Scalars['String']['output']>>;
  singleChoice?: Maybe<Array<Scalars['String']['output']>>;
  smiley?: Maybe<Array<ResponseAnswerSmileyObjType>>;
};

export type AudienceSegmentFilterValuesQuestFormInput = {
  answers?: InputMaybe<QuestAudienceSegmentFilterValuesAnswersInput>;
  question?: InputMaybe<Scalars['ID']['input']>;
};

export type AudienceSegmentFilterValuesQuestFormType = {
  __typename?: 'AudienceSegmentFilterValuesQuestFormType';
  answers?: Maybe<AudienceSegmentFilterValuesQuestAnswersType>;
  question?: Maybe<QuestionDtoType>;
};

export type AudienceSegmentFilterValuesQuestInput = {
  action?: InputMaybe<AudienceSegmentFilterValuesQuestActionInput>;
  activity?: InputMaybe<Scalars['ID']['input']>;
};

export type AudienceSegmentFilterValuesQuestType = {
  __typename?: 'AudienceSegmentFilterValuesQuestType';
  action?: Maybe<AudienceSegmentFilterValuesQuestActionType>;
  activity?: Maybe<QuestActivityType>;
};

export type AudienceSegmentFilterValuesType = {
  __typename?: 'AudienceSegmentFilterValuesType';
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  countries?: Maybe<Array<CountryType>>;
  duration?: Maybe<QuestAudienceSegmentFrequencyType>;
  educations?: Maybe<Array<AcademicLevel>>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  frequency?: Maybe<QuestAudienceSegmentFrequencyType>;
  genders?: Maybe<Array<Gender>>;
  languages?: Maybe<Array<LanguageType>>;
  maritalStatuses?: Maybe<Array<MaritalStatus>>;
  maxValue?: Maybe<Scalars['String']['output']>;
  minValue?: Maybe<Scalars['String']['output']>;
  quest?: Maybe<AudienceSegmentFilterValuesQuestType>;
  reputations?: Maybe<Array<ReputationType>>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  states?: Maybe<Array<StateType>>;
  transactionsReasons?: Maybe<Array<TransactionTypeEnum>>;
  value?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Scalars['String']['output']>>;
  zone?: Maybe<AudienceSegmentFilterZoneType>;
};

export type AudienceSegmentFilterZoneInput = {
  paths?: InputMaybe<Array<DeliveryZonePathInput>>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<ZoneTypesEnum>;
};

export type AudienceSegmentFilterZoneType = {
  __typename?: 'AudienceSegmentFilterZoneType';
  paths?: Maybe<Array<DeliveryZonePathType>>;
  radius?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<ZoneTypesEnum>;
};

export type AudienceSegmentInput = {
  definitions: Array<SegmentsDefinitionsInput>;
  reach?: InputMaybe<AudienceReachInput>;
  relation?: InputMaybe<AudienceRelationEnum>;
};

export type AudienceSegmentType = {
  __typename?: 'AudienceSegmentType';
  definitions: Array<SegmentsDefinitionsType>;
  reach?: Maybe<AudienceReachType>;
  relation?: Maybe<AudienceRelationEnum>;
};

export type AudienceType = {
  __typename?: 'AudienceType';
  advertiser?: Maybe<TargetType>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<MediaType>;
  questType?: Maybe<QuestTypeType>;
  reach?: Maybe<AudienceReachType>;
  segments?: Maybe<Array<AudienceSegmentType>>;
  target?: Maybe<TargetType>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AudienceTypeEnum>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum AudienceTypeEnum {
  DYNAMIC = 'DYNAMIC',
  IMPORTED = 'IMPORTED'
}

export type AudienceUpdateInput = {
  advertiser?: InputMaybe<TargetAciInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  /** Segments should only be provided if type is "DYNAMIC". */
  questType?: InputMaybe<Scalars['ID']['input']>;
  /** Segments should only be provided if type is "DYNAMIC". */
  segments?: InputMaybe<Array<AudienceSegmentInput>>;
  target?: InputMaybe<TargetAciInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AudienceTypeEnum>;
};

export type AuthDashboardAgeByAppType = {
  __typename?: 'AuthDashboardAgeByAppType';
  ageRange: Scalars['String']['output'];
  app: App;
  count: Scalars['Int']['output'];
};

export type AuthDashboardAgeType = {
  __typename?: 'AuthDashboardAgeType';
  ageRange: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type AuthDashboardGenderByAppType = {
  __typename?: 'AuthDashboardGenderByAppType';
  app: App;
  count: Scalars['Int']['output'];
  gender: Gender;
};

export type AuthDashboardGenderType = {
  __typename?: 'AuthDashboardGenderType';
  count: Scalars['Int']['output'];
  gender: Gender;
};

export type AuthDashboardMailValidationByAppType = {
  __typename?: 'AuthDashboardMailValidationByAppType';
  app: App;
  count: Scalars['Int']['output'];
  isMailValid: Scalars['Boolean']['output'];
};

export type AuthDashboardMailValidationType = {
  __typename?: 'AuthDashboardMailValidationType';
  count: Scalars['Int']['output'];
  isMailValid: Scalars['Boolean']['output'];
};

export type AuthDashboardMaritalStatusByAppType = {
  __typename?: 'AuthDashboardMaritalStatusByAppType';
  app: App;
  count: Scalars['Int']['output'];
  maritalStatus: MaritalStatus;
};

export type AuthDashboardMaritalStatusType = {
  __typename?: 'AuthDashboardMaritalStatusType';
  count: Scalars['Int']['output'];
  maritalStatus: MaritalStatus;
};

export type AuthDashboardRoleByAppType = {
  __typename?: 'AuthDashboardRoleByAppType';
  app: App;
  count: Scalars['Int']['output'];
  role: UserRole;
};

export type AuthDashboardRoleType = {
  __typename?: 'AuthDashboardRoleType';
  count: Scalars['Int']['output'];
  role: UserRole;
};

export type AuthDashboardUsersByAppsType = {
  __typename?: 'AuthDashboardUsersByAppsType';
  app: App;
  count: Scalars['Int']['output'];
};

export type AuthDashboardUsersByRegionByAppType = {
  __typename?: 'AuthDashboardUsersByRegionByAppType';
  app: App;
  count: Scalars['Int']['output'];
  region: CountryEnum;
};

export type AuthDashboardUsersByRegionType = {
  __typename?: 'AuthDashboardUsersByRegionType';
  count: Scalars['Int']['output'];
  region: CountryEnum;
};

export type AuthorizationDataInput = {
  authorizationCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  identityToken: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  userIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type AverageRatingType = {
  __typename?: 'AverageRatingType';
  byMark: Array<ByMarkRatingType>;
  overAllAverage: Scalars['Decimal']['output'];
};

export type BadgeDefinitionInput = {
  explanation?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  rank: Scalars['Int']['input'];
  remuneration?: InputMaybe<BadgeDefinitionRemunerationInput>;
};

export type BadgeDefinitionRemunerationInput = {
  qualitative?: InputMaybe<Scalars['Decimal']['input']>;
  quantitative?: InputMaybe<Scalars['Decimal']['input']>;
};

export type BadgeDefinitionRemunerationType = {
  __typename?: 'BadgeDefinitionRemunerationType';
  qualitative?: Maybe<Scalars['Decimal']['output']>;
  quantitative?: Maybe<Scalars['Decimal']['output']>;
};

export type BadgeDefinitionType = {
  __typename?: 'BadgeDefinitionType';
  explanation?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  rank: Scalars['Int']['output'];
  remuneration?: Maybe<BadgeDefinitionRemunerationType>;
};

export type BadgeInput = {
  definition?: InputMaybe<BadgeDefinitionInput>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<TargetAciInput>;
};

export type BadgePaginateType = {
  __typename?: 'BadgePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<BadgeType>;
};

export type BadgeType = {
  __typename?: 'BadgeType';
  createdAt: Scalars['DateTime']['output'];
  definition?: Maybe<BadgeDefinitionType>;
  explanation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BadgeUpdateInput = {
  definition?: InputMaybe<BadgeDefinitionInput>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<TargetAciInput>;
};

export type BankDetailsHolderInput = {
  address?: InputMaybe<FullAddressInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BankDetailsHolderTypeEnum>;
};

export type BankDetailsHolderType = {
  __typename?: 'BankDetailsHolderType';
  address: FullAddressType;
  name: Scalars['String']['output'];
  type?: Maybe<BankDetailsHolderTypeEnum>;
};

export enum BankDetailsHolderTypeEnum {
  COMPANY = 'COMPANY',
  PRIVATE = 'PRIVATE'
}

export type BankDetailsInput = {
  account: Scalars['String']['input'];
  bank: Scalars['ID']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  holder: BankDetailsHolderInput;
  iban?: InputMaybe<Scalars['String']['input']>;
};

export type BankDetailsPaginatedType = {
  __typename?: 'BankDetailsPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<BankDetailsType>;
};

export type BankDetailsType = {
  __typename?: 'BankDetailsType';
  account: Scalars['String']['output'];
  bank: BankType;
  createdAt: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  holder: BankDetailsHolderType;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BankInput = {
  address?: InputMaybe<FullAddressInput>;
  bic?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<BrowserLogoInput>;
  name: Scalars['String']['input'];
};

export type BankPaginatedType = {
  __typename?: 'BankPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<BankType>;
};

export type BankType = {
  __typename?: 'BankType';
  address?: Maybe<FullAddressType>;
  bic?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  logo?: Maybe<BrowserLogoType>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BarcodeBaseRawType = {
  __typename?: 'BarcodeBaseRawType';
  barcode: Scalars['String']['output'];
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<DiscountDtoType>;
  id: Scalars['ID']['output'];
  maintenance?: Maybe<InternalProductMaintenanceType>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  pixel?: Maybe<PixelBarcodeType>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceCredit?: Maybe<Array<BarcodePeriodCreditType>>;
  priceList?: Maybe<Array<ProductPriceListType>>;
  prices?: Maybe<Array<BarcodePricesType>>;
  productAttributesValues?: Maybe<InternalProductAttributesValuesBaseType>;
  status?: Maybe<ProductStatusEnum>;
  supplier?: Maybe<CompanyType>;
  taxes?: Maybe<Array<ProductTaxesType>>;
  translation?: Maybe<Array<BarcodeTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BarcodeFilterInput = {
  barcode?: InputMaybe<Array<Scalars['String']['input']>>;
  condition?: InputMaybe<Array<ProductConditionEnum>>;
  status?: InputMaybe<Array<ProductStatusEnum>>;
};

export type BarcodeFilterResponseType = {
  __typename?: 'BarcodeFilterResponseType';
  /** list of catalogueCategories */
  catalogueCategories?: Maybe<Array<FilterNameFieldType>>;
  createdAtRange?: Maybe<DateRangeType>;
  priceRange?: Maybe<PriceRangeType>;
};

export type BarcodeFindInput = {
  internalProduct?: InputMaybe<Scalars['ID']['input']>;
  product?: InputMaybe<Scalars['ID']['input']>;
  productAttributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  productAttributesValues?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type BarcodeInput = {
  barcode: Scalars['String']['input'];
  catalogueCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  condition?: InputMaybe<ProductConditionEnum>;
  discount?: InputMaybe<DiscountDtoInput>;
  internalProduct?: InputMaybe<Scalars['ID']['input']>;
  maintenance?: InputMaybe<InternalProductMaintenanceInput>;
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  pixel?: InputMaybe<PixelBarcodeInput>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  priceCredit?: InputMaybe<Array<BarcodePeriodCreditInput>>;
  priceList?: InputMaybe<Array<ProductPriceListInput>>;
  prices?: InputMaybe<Array<BarcodePricesInput>>;
  product?: InputMaybe<Scalars['ID']['input']>;
  productAttributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  productAttributesValues?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<ProductStatusEnum>;
  supplier?: InputMaybe<Scalars['ID']['input']>;
  taxes?: InputMaybe<Array<ProductTaxesInput>>;
  translation?: InputMaybe<Array<BarcodeTranslationInput>>;
};

export type BarcodePaginateType = {
  __typename?: 'BarcodePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<BarcodeType>;
};

export type BarcodePeriodCreditInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  periodCycle: RecurrenceType;
  periodValue: Scalars['Int']['input'];
};

export type BarcodePeriodCreditType = {
  __typename?: 'BarcodePeriodCreditType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  periodCycle: RecurrenceType;
  periodValue: Scalars['Int']['output'];
};

export type BarcodePricesInput = {
  currency?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
};

export type BarcodePricesType = {
  __typename?: 'BarcodePricesType';
  currency?: Maybe<CurrencyType>;
  price?: Maybe<Scalars['Decimal']['output']>;
};

export enum BarcodeRepresentationTyeEnum {
  AZTECCODE = 'AZTECCODE',
  CODABAR = 'CODABAR',
  CODE11 = 'CODE11',
  CODE39 = 'CODE39',
  CODE93 = 'CODE93',
  CODE128 = 'CODE128',
  DATAMATRIX = 'DATAMATRIX',
  EAN8 = 'EAN8',
  EAN13 = 'EAN13',
  GRIDMATRIX = 'GRIDMATRIX',
  GS1 = 'GS1',
  ITF14 = 'ITF14',
  MAXICODE = 'MAXICODE',
  PATCHCODE = 'PATCHCODE',
  PDF417 = 'PDF417',
  PHARMACODE = 'PHARMACODE',
  UPCA = 'UPCA',
  UPCE = 'UPCE'
}

export type BarcodeStatsType = {
  __typename?: 'BarcodeStatsType';
  numberOfOrders: Scalars['Int']['output'];
  totalRevenue: Scalars['Decimal']['output'];
};

export type BarcodeTranslationContentInput = {
  name: Scalars['String']['input'];
};

export type BarcodeTranslationContentType = {
  __typename?: 'BarcodeTranslationContentType';
  name: Scalars['String']['output'];
};

export type BarcodeTranslationInput = {
  content: BarcodeTranslationContentInput;
  language: Scalars['ID']['input'];
};

export type BarcodeTranslationType = {
  __typename?: 'BarcodeTranslationType';
  content: BarcodeTranslationContentType;
  language: LanguageType;
};

export type BarcodeType = {
  __typename?: 'BarcodeType';
  barcode: Scalars['String']['output'];
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<DiscountDtoType>;
  id: Scalars['ID']['output'];
  internalProduct?: Maybe<InternalProductType>;
  maintenance?: Maybe<InternalProductMaintenanceType>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  pixel?: Maybe<PixelBarcodeType>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceCredit?: Maybe<Array<BarcodePeriodCreditType>>;
  priceList?: Maybe<Array<ProductPriceListType>>;
  prices?: Maybe<Array<BarcodePricesType>>;
  product?: Maybe<ProductType>;
  productAttributes?: Maybe<Array<AttributeWithAttributeValueType>>;
  productAttributesValues?: Maybe<InternalProductAttributesValuesType>;
  status?: Maybe<ProductStatusEnum>;
  supplier?: Maybe<CompanyType>;
  taxes?: Maybe<Array<ProductTaxesType>>;
  translation?: Maybe<Array<BarcodeTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BarcodeUpdateInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  catalogueCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  condition?: InputMaybe<ProductConditionEnum>;
  discount?: InputMaybe<DiscountDtoInput>;
  id: Scalars['ID']['input'];
  internalProduct?: InputMaybe<Scalars['ID']['input']>;
  maintenance?: InputMaybe<InternalProductMaintenanceInput>;
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  pixel?: InputMaybe<PixelBarcodeInput>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  priceCredit?: InputMaybe<Array<BarcodePeriodCreditInput>>;
  priceList?: InputMaybe<Array<ProductPriceListInput>>;
  prices?: InputMaybe<Array<BarcodePricesInput>>;
  product?: InputMaybe<Scalars['ID']['input']>;
  productAttributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  productAttributesValues?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<ProductStatusEnum>;
  supplier?: InputMaybe<Scalars['ID']['input']>;
  taxes?: InputMaybe<Array<ProductTaxesInput>>;
  translation?: InputMaybe<Array<BarcodeTranslationInput>>;
};

export type BarcodeValidationType = {
  __typename?: 'BarcodeValidationType';
  headersValid?: Maybe<Scalars['Boolean']['output']>;
  isIdComplete?: Maybe<Scalars['Boolean']['output']>;
  isNameComplete?: Maybe<Scalars['Boolean']['output']>;
  isPricesComplete?: Maybe<Scalars['Boolean']['output']>;
  isProductsComplete?: Maybe<Scalars['Boolean']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  numBarcodesWithAttributes?: Maybe<Scalars['Int']['output']>;
  overallValidation?: Maybe<Scalars['Boolean']['output']>;
};

export type BarcodeWithPublicPriceAndPriceInCoinsType = {
  __typename?: 'BarcodeWithPublicPriceAndPriceInCoinsType';
  barcode: Scalars['String']['output'];
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<DiscountDtoType>;
  id: Scalars['ID']['output'];
  internalProduct?: Maybe<InternalProductType>;
  maintenance?: Maybe<InternalProductMaintenanceType>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  pixel?: Maybe<PixelBarcodeType>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceCredit?: Maybe<Array<BarcodePeriodCreditType>>;
  priceInCoins?: Maybe<Scalars['Decimal']['output']>;
  priceList?: Maybe<Array<ProductPriceListType>>;
  prices?: Maybe<Array<BarcodePricesType>>;
  product?: Maybe<ProductType>;
  productAttributes?: Maybe<Array<AttributeWithAttributeValueType>>;
  productAttributesValues?: Maybe<InternalProductAttributesValuesType>;
  publicPrice?: Maybe<Scalars['Decimal']['output']>;
  publicPriceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  status?: Maybe<ProductStatusEnum>;
  supplier?: Maybe<CompanyType>;
  translation?: Maybe<Array<BarcodeTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BarcodeWithPublicPriceAndRemunerationsType = {
  __typename?: 'BarcodeWithPublicPriceAndRemunerationsType';
  barcode: Scalars['String']['output'];
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<DiscountDtoType>;
  id: Scalars['ID']['output'];
  internalProduct?: Maybe<InternalProductType>;
  maintenance?: Maybe<InternalProductMaintenanceType>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  pixel?: Maybe<PixelBarcodeType>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceCredit?: Maybe<Array<BarcodePeriodCreditType>>;
  priceList?: Maybe<Array<ProductPriceListType>>;
  priceRemunerations?: Maybe<RemunerationWithOutReputationDtoType>;
  prices?: Maybe<Array<BarcodePricesType>>;
  product?: Maybe<ProductType>;
  productAttributes?: Maybe<Array<AttributeWithAttributeValueType>>;
  productAttributesValues?: Maybe<InternalProductAttributesValuesType>;
  publicPrice?: Maybe<Scalars['Decimal']['output']>;
  publicPriceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  status?: Maybe<ProductStatusEnum>;
  supplier?: Maybe<CompanyType>;
  translation?: Maybe<Array<BarcodeTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BarcodeWithPublicPriceFullType = {
  __typename?: 'BarcodeWithPublicPriceFullType';
  barcode: Scalars['String']['output'];
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<DiscountDtoType>;
  id: Scalars['ID']['output'];
  internalProduct?: Maybe<InternalProductType>;
  maintenance?: Maybe<InternalProductMaintenanceType>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  pixel?: Maybe<PixelBarcodeType>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceCredit?: Maybe<Array<BarcodePeriodCreditType>>;
  priceList?: Maybe<Array<ProductPriceListType>>;
  prices?: Maybe<Array<BarcodePricesType>>;
  product?: Maybe<ProductType>;
  productAttributes?: Maybe<Array<AttributeWithAttributeValueType>>;
  productAttributesValues?: Maybe<InternalProductAttributesValuesType>;
  publicPrice?: Maybe<Scalars['Decimal']['output']>;
  publicPriceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  status?: Maybe<ProductStatusEnum>;
  supplier?: Maybe<CompanyType>;
  taxes?: Maybe<Array<ProductTaxesType>>;
  translation?: Maybe<Array<BarcodeTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BarcodeWithPublicPricePaginateType = {
  __typename?: 'BarcodeWithPublicPricePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<BarcodeWithPublicPriceFullType>;
};

export type BarcodeWithPublicPriceType = {
  __typename?: 'BarcodeWithPublicPriceType';
  barcode: Scalars['String']['output'];
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<DiscountDtoType>;
  id: Scalars['ID']['output'];
  internalProduct?: Maybe<InternalProductType>;
  maintenance?: Maybe<InternalProductMaintenanceType>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  pixel?: Maybe<PixelBarcodeType>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceCredit?: Maybe<Array<BarcodePeriodCreditType>>;
  priceList?: Maybe<Array<ProductPriceListType>>;
  prices?: Maybe<Array<BarcodePricesType>>;
  product?: Maybe<ProductType>;
  productAttributes?: Maybe<Array<AttributeWithAttributeValueType>>;
  productAttributesValues?: Maybe<InternalProductAttributesValuesType>;
  publicPrice?: Maybe<Scalars['Decimal']['output']>;
  publicPriceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  status?: Maybe<ProductStatusEnum>;
  supplier?: Maybe<CompanyType>;
  translation?: Maybe<Array<BarcodeTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BarcodeWithStockDataPaginatedType = {
  __typename?: 'BarcodeWithStockDataPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<BarcodeWithStockDataType>;
};

export type BarcodeWithStockDataType = {
  __typename?: 'BarcodeWithStockDataType';
  barcode: Scalars['String']['output'];
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  currentStock?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<DiscountDtoType>;
  id: Scalars['ID']['output'];
  internalProduct?: Maybe<InternalProductType>;
  maintenance?: Maybe<InternalProductMaintenanceType>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  outOfStock?: Maybe<Scalars['Boolean']['output']>;
  pixel?: Maybe<PixelBarcodeType>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceCredit?: Maybe<Array<BarcodePeriodCreditType>>;
  priceList?: Maybe<Array<ProductPriceListType>>;
  prices?: Maybe<Array<BarcodePricesType>>;
  product?: Maybe<ProductType>;
  productAttributes?: Maybe<Array<AttributeWithAttributeValueType>>;
  productAttributesValues?: Maybe<InternalProductAttributesValuesType>;
  status?: Maybe<ProductStatusEnum>;
  supplier?: Maybe<CompanyType>;
  taxes?: Maybe<Array<ProductTaxesType>>;
  translation?: Maybe<Array<BarcodeTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BarcodeWithStockPaginatedType = {
  __typename?: 'BarcodeWithStockPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<BarcodeWithStockType>;
};

export type BarcodeWithStockType = {
  __typename?: 'BarcodeWithStockType';
  barcode: Scalars['String']['output'];
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<DiscountDtoType>;
  id: Scalars['ID']['output'];
  internalProduct?: Maybe<InternalProductType>;
  maintenance?: Maybe<InternalProductMaintenanceType>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  pixel?: Maybe<PixelBarcodeType>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceCredit?: Maybe<Array<BarcodePeriodCreditType>>;
  priceList?: Maybe<Array<ProductPriceListType>>;
  prices?: Maybe<Array<BarcodePricesType>>;
  product?: Maybe<ProductType>;
  productAttributes?: Maybe<Array<AttributeWithAttributeValueType>>;
  productAttributesValues?: Maybe<InternalProductAttributesValuesType>;
  status?: Maybe<ProductStatusEnum>;
  stock?: Maybe<StockRawType>;
  supplier?: Maybe<CompanyType>;
  taxes?: Maybe<Array<ProductTaxesType>>;
  translation?: Maybe<Array<BarcodeTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BarcodeWithVarietyAndStructureFilterInput = {
  barcode?: InputMaybe<Array<Scalars['String']['input']>>;
  condition?: InputMaybe<Array<ProductConditionEnum>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<ProductStatusEnum>>;
  structure?: InputMaybe<Array<ProductStructureEnum>>;
  variety?: InputMaybe<Array<ProductVarietyEnum>>;
};

export type BarcodesFilterInput = {
  /** list of catalogueCategories ids */
  catalogueCategory?: InputMaybe<Array<Scalars['ID']['input']>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  fromPrice?: InputMaybe<Scalars['Decimal']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  toPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type BarcodesPaginatedWithFilterType = {
  __typename?: 'BarcodesPaginatedWithFilterType';
  count?: Maybe<Scalars['Int']['output']>;
  filter?: Maybe<BarcodeFilterResponseType>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<BarcodeType>;
};

export type BetOrderOddsOddsType = {
  __typename?: 'BetOrderOddsOddsType';
  bet: Scalars['Float']['output'];
  gains?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  odd: Scalars['Decimal']['output'];
  status?: Maybe<OddStatusEnum>;
  value: Scalars['String']['output'];
};

export type BetOrderType = {
  __typename?: 'BetOrderType';
  createdAt: Scalars['DateTime']['output'];
  finalWin?: Maybe<Scalars['Decimal']['output']>;
  fixture: FixtureType;
  id: Scalars['ID']['output'];
  maxWin: Scalars['Float']['output'];
  odds: Array<BetOrderOddsOddsType>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type BetsBookmakersType = {
  __typename?: 'BetsBookmakersType';
  createdAt: Scalars['DateTime']['output'];
  extId?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BlogDataInput = {
  sectionContent?: InputMaybe<Scalars['String']['input']>;
  sectionPictures?: InputMaybe<Array<PictureInput>>;
  sectionReference?: InputMaybe<Scalars['String']['input']>;
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
};

export type BlogDataType = {
  __typename?: 'BlogDataType';
  sectionContent?: Maybe<Scalars['String']['output']>;
  sectionPictures?: Maybe<Array<PictureType>>;
  sectionReference?: Maybe<Scalars['String']['output']>;
  sectionTitle?: Maybe<Scalars['String']['output']>;
};

export type BlogInput = {
  pictures?: InputMaybe<Array<PictureInput>>;
  sectionData?: InputMaybe<Array<BlogDataInput>>;
  seo?: InputMaybe<SeoComponentInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  target: TargetAciInput;
  title: Scalars['String']['input'];
  translation?: InputMaybe<Array<BlogTranslationInput>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type BlogTranslationContentInput = {
  sectionData: Array<BlogDataInput>;
  title: Scalars['String']['input'];
};

export type BlogTranslationContentType = {
  __typename?: 'BlogTranslationContentType';
  sectionData: Array<BlogDataType>;
  title: Scalars['String']['output'];
};

export type BlogTranslationInput = {
  content: BlogTranslationContentInput;
  language: Scalars['ID']['input'];
};

export type BlogTranslationType = {
  __typename?: 'BlogTranslationType';
  content: BlogTranslationContentType;
  language: LanguageType;
};

export type BlogType = {
  __typename?: 'BlogType';
  author: UserType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  pictures?: Maybe<Array<PictureType>>;
  sectionData?: Maybe<Array<BlogDataType>>;
  seo?: Maybe<SeoComponentType>;
  status: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetType;
  title: Scalars['String']['output'];
  translation?: Maybe<Array<BlogTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type BoardCardFilterInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assignedTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  barcode?: InputMaybe<Array<Scalars['ID']['input']>>;
  boardList?: InputMaybe<Array<Scalars['ID']['input']>>;
  customer?: InputMaybe<Array<Scalars['ID']['input']>>;
  priority?: InputMaybe<Array<BoardCardPriorityEnum>>;
  procedure?: InputMaybe<Array<BoardCardProcedureEnum>>;
  project?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type BoardCardForListType = {
  __typename?: 'BoardCardForListType';
  archived?: Maybe<Scalars['Boolean']['output']>;
  assignedTo?: Maybe<Array<UserType>>;
  attachments?: Maybe<Array<DocumentType>>;
  barcode?: Maybe<BarcodeType>;
  budget?: Maybe<Array<Scalars['Decimal']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<CompanyType>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  labels?: Maybe<Array<LabelType>>;
  pictures?: Maybe<Array<PictureType>>;
  priority?: Maybe<BoardCardPriorityEnum>;
  procedure?: Maybe<Array<BoardCardProcedureType>>;
  project?: Maybe<ProjectType>;
  rank?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tasks?: Maybe<Array<BoardCardTasksType>>;
  tasksStats?: Maybe<TasksStatsType>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BoardCardPaginateType = {
  __typename?: 'BoardCardPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<BoardCardType>;
};

export enum BoardCardPriorityEnum {
  CRITICAL = 'CRITICAL',
  HIGH = 'HIGH',
  LOW = 'LOW',
  NORMAL = 'NORMAL'
}

export enum BoardCardProcedureEnum {
  CALL = 'CALL',
  CHAT = 'CHAT',
  CONFERENCE = 'CONFERENCE',
  DEMO = 'DEMO',
  MEETING = 'MEETING'
}

export type BoardCardProcedureInput = {
  task?: InputMaybe<BoardCardProcedureEnum>;
  time?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BoardCardProcedurePaginateType = {
  __typename?: 'BoardCardProcedurePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<BoardCardProcedureType>;
};

export type BoardCardProcedureType = {
  __typename?: 'BoardCardProcedureType';
  task?: Maybe<BoardCardProcedureEnum>;
  time?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type BoardCardStatsFilterInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assignedTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  barcode?: InputMaybe<Array<Scalars['ID']['input']>>;
  boardList?: InputMaybe<Array<Scalars['ID']['input']>>;
  customer?: InputMaybe<Array<Scalars['ID']['input']>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  priority?: InputMaybe<Array<BoardCardPriorityEnum>>;
  procedure?: InputMaybe<Array<BoardCardProcedureEnum>>;
  project?: InputMaybe<Array<Scalars['ID']['input']>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BoardCardTasksInput = {
  done?: InputMaybe<Scalars['Boolean']['input']>;
  task?: InputMaybe<Scalars['String']['input']>;
};

export type BoardCardTasksType = {
  __typename?: 'BoardCardTasksType';
  done?: Maybe<Scalars['Boolean']['output']>;
  task?: Maybe<Scalars['String']['output']>;
};

export type BoardCardType = {
  __typename?: 'BoardCardType';
  archived?: Maybe<Scalars['Boolean']['output']>;
  assignedTo?: Maybe<Array<UserType>>;
  attachments?: Maybe<Array<DocumentType>>;
  barcode?: Maybe<BarcodeType>;
  boardList: BoardListType;
  budget?: Maybe<Array<Scalars['Decimal']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<CompanyType>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  labels?: Maybe<Array<LabelType>>;
  pictures?: Maybe<Array<PictureType>>;
  priority?: Maybe<BoardCardPriorityEnum>;
  procedure?: Maybe<Array<BoardCardProcedureType>>;
  project?: Maybe<ProjectType>;
  rank?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tasks?: Maybe<Array<BoardCardTasksType>>;
  tasksStats?: Maybe<TasksStatsType>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BoardCardsStatsResponseType = {
  __typename?: 'BoardCardsStatsResponseType';
  CRITICAL: CurrentPreviousType;
  HIGH: CurrentPreviousType;
  LOW: CurrentPreviousType;
  NORMAL: CurrentPreviousType;
};

export type BoardCardsStatsType = {
  __typename?: 'BoardCardsStatsType';
  archived: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum BoardCategoryEnum {
  CRM = 'CRM',
  MAINTENANCE = 'MAINTENANCE',
  PROJECTS = 'PROJECTS'
}

export type BoardListType = {
  __typename?: 'BoardListType';
  board: BoardType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  identifier?: Maybe<MaintenanceBoardListEnum>;
  name: Scalars['String']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
  theme?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BoardPaginateType = {
  __typename?: 'BoardPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<BoardType>;
};

export type BoardType = {
  __typename?: 'BoardType';
  boardCardsStats?: Maybe<BoardCardsStatsType>;
  category?: Maybe<BoardCategoryEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  members?: Maybe<Array<UserType>>;
  projects?: Maybe<Array<ProjectType>>;
  target: TargetType;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BoardWithListsAndCardsType = {
  __typename?: 'BoardWithListsAndCardsType';
  boardCardsStats?: Maybe<BoardCardsStatsType>;
  boardLists?: Maybe<Array<ListWithCardsType>>;
  category?: Maybe<BoardCategoryEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  members?: Maybe<Array<UserType>>;
  projects?: Maybe<Array<ProjectType>>;
  target: TargetType;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BoardsFilterInput = {
  members?: InputMaybe<Array<Scalars['ID']['input']>>;
  projects?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type BookingAttributeType = {
  __typename?: 'BookingAttributeType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum BookingStatusEnum {
  CANCELED = 'CANCELED',
  CLOSED = 'CLOSED',
  CONFIRMED = 'CONFIRMED',
  OPEN = 'OPEN'
}

export type BookingType = {
  __typename?: 'BookingType';
  attributes?: Maybe<Array<SettingsAttributeType>>;
  bookingNumber?: Maybe<Scalars['Float']['output']>;
  bookingTime?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  people?: Maybe<Scalars['Int']['output']>;
  pos: PointOfSaleType;
  status?: Maybe<BookingStatusEnum>;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type BookingTypeType = {
  __typename?: 'BookingTypeType';
  createdAt: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BookingsCountType = {
  __typename?: 'BookingsCountType';
  bookingSources: BookingsSourcesCountType;
  bookingStatuses: BookingsStatusesCountType;
  numberOfPeople: Array<NumberOfPeopleCountType>;
  total: Scalars['Int']['output'];
};

export type BookingsSourcesCountType = {
  __typename?: 'BookingsSourcesCountType';
  APP: Scalars['Int']['output'];
  EMAIL: Scalars['Int']['output'];
  FACEBOOK: Scalars['Int']['output'];
  INSTAGRAM: Scalars['Int']['output'];
  PHONE: Scalars['Int']['output'];
};

export type BookingsStatusesCountType = {
  __typename?: 'BookingsStatusesCountType';
  CANCELED: Scalars['Int']['output'];
  CLOSED: Scalars['Int']['output'];
  CONFIRMED: Scalars['Int']['output'];
  OPEN: Scalars['Int']['output'];
};

export type BrandInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  picture?: InputMaybe<PictureInput>;
  target?: InputMaybe<TargetAciInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type BrandPaginateType = {
  __typename?: 'BrandPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<BrandType>;
};

export type BrandType = {
  __typename?: 'BrandType';
  createdAt: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  manufacturer?: Maybe<ManufacturerType>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type BrandUpdateInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type BrandValidationType = {
  __typename?: 'BrandValidationType';
  headersValid: Scalars['Boolean']['output'];
  isIdComplete: Scalars['Boolean']['output'];
  isNameComplete: Scalars['Boolean']['output'];
  length: Scalars['Int']['output'];
  overallValidation: Scalars['Boolean']['output'];
};

export type BrowserInput = {
  code: Scalars['String']['input'];
  logo?: InputMaybe<BrowserLogoInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BrowserLogoInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  png?: InputMaybe<BrowserLogoPngInput>;
  svg?: InputMaybe<PictureInput>;
};

export type BrowserLogoPngInput = {
  default?: InputMaybe<PictureInput>;
  size16?: InputMaybe<PictureInput>;
  size24?: InputMaybe<PictureInput>;
  size32?: InputMaybe<PictureInput>;
  size48?: InputMaybe<PictureInput>;
  size64?: InputMaybe<PictureInput>;
  size128?: InputMaybe<PictureInput>;
  size256?: InputMaybe<PictureInput>;
  size512?: InputMaybe<PictureInput>;
};

export type BrowserLogoPngType = {
  __typename?: 'BrowserLogoPngType';
  default?: Maybe<PictureType>;
  size16?: Maybe<PictureType>;
  size24?: Maybe<PictureType>;
  size32?: Maybe<PictureType>;
  size48?: Maybe<PictureType>;
  size64?: Maybe<PictureType>;
  size128?: Maybe<PictureType>;
  size256?: Maybe<PictureType>;
  size512?: Maybe<PictureType>;
};

export type BrowserLogoType = {
  __typename?: 'BrowserLogoType';
  icon?: Maybe<Scalars['String']['output']>;
  png?: Maybe<BrowserLogoPngType>;
  svg?: Maybe<PictureType>;
};

export type BrowserPaginatedType = {
  __typename?: 'BrowserPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<BrowserType>;
};

export type BrowserType = {
  __typename?: 'BrowserType';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  logo?: Maybe<BrowserLogoType>;
  name?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ByMarkRatingType = {
  __typename?: 'ByMarkRatingType';
  count: Scalars['Int']['output'];
  mark: Scalars['Int']['output'];
};

export type CrmDashboardInput = {
  from: Scalars['DateTime']['input'];
  target?: InputMaybe<TargetAciInput>;
  to: Scalars['DateTime']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type CrmDashboardWithFilterInput = {
  from: Scalars['DateTime']['input'];
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  target?: InputMaybe<TargetAciInput>;
  to: Scalars['DateTime']['input'];
};

export type CrmDashboardWithTaskFilterInput = {
  from: Scalars['DateTime']['input'];
  target?: InputMaybe<TargetAciInput>;
  task?: InputMaybe<Array<BoardCardProcedureEnum>>;
  to: Scalars['DateTime']['input'];
};

export type CalculateTargetShoppingCartInput = {
  deliveryAddress?: InputMaybe<FullAddressInput>;
  discount?: InputMaybe<DiscountDtoInput>;
  extraFees?: InputMaybe<Array<MarketPlaceOrderDtoExtraFeesInput>>;
  fees?: InputMaybe<MarketPlaceOrderDtoFeesInput>;
  orderType: OrderTypeEnum;
  products: Array<CartProductInput>;
  target?: InputMaybe<TargetAciInput>;
};

export type CalculatedShoppingCartType = {
  __typename?: 'CalculatedShoppingCartType';
  discount?: Maybe<DiscountDtoType>;
  price?: Maybe<PriceFullType>;
  products?: Maybe<Array<CartProductType>>;
  target?: Maybe<TargetType>;
  taxValue?: Maybe<ReduciblePriceType>;
  user?: Maybe<UserType>;
};

export type CalculationsInput = {
  discount?: InputMaybe<DiscountDtoInput>;
  isAvoir?: InputMaybe<Scalars['Boolean']['input']>;
  products: Array<InvoicingProductsInput>;
  taxes: Array<ProductTaxesInput>;
};

export type CampaignsStatsDashboardType = {
  __typename?: 'CampaignsStatsDashboardType';
  campaigns: AnalyticsStatsInfoType;
  questActions: AnalyticsStatsInfoType;
};

export enum CardRepresentationEnum {
  CARD = 'CARD',
  EMAIL = 'EMAIL',
  IDENTIFIER = 'IDENTIFIER',
  PHONE = 'PHONE'
}

export enum CardTypeEnum {
  PHYSICAL = 'PHYSICAL',
  VIRTUAL = 'VIRTUAL'
}

export type CartProductForTargetType = {
  __typename?: 'CartProductForTargetType';
  barcode?: Maybe<BarcodeWithPublicPriceType>;
  price: ProductPriceType;
  priceCredit?: Maybe<PriceCreditType>;
  quantity: Scalars['Int']['output'];
  taxValue: TaxValueType;
};

export type CartProductInput = {
  /** barcode local db id */
  barcode: Scalars['ID']['input'];
  priceCredit?: InputMaybe<PriceCreditInput>;
  productAttributesValues?: InputMaybe<Array<Scalars['ID']['input']>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  rent?: InputMaybe<RentalRefInput>;
};

export type CartProductType = {
  __typename?: 'CartProductType';
  barcode?: Maybe<BarcodeWithPublicPriceType>;
  price: ProductPriceType;
  priceCredit?: Maybe<PriceCreditType>;
  productAttributesValues?: Maybe<Array<AttributeValueType>>;
  quantity: Scalars['Int']['output'];
  rent?: Maybe<RentalRefType>;
  taxValue: TaxValueType;
};

export type CartProductUpdateCreditInput = {
  /** barcode local db id */
  barcode: Scalars['ID']['input'];
  priceCredit: PriceCreditInput;
  productAttributesValues?: InputMaybe<Array<Scalars['ID']['input']>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  rent?: InputMaybe<RentalRefInput>;
};

export type CatalogueCategoryBaseType = {
  __typename?: 'CatalogueCategoryBaseType';
  booking?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  delivery?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  hasChildren: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  layer: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<CatalogueCategoryBaseType>;
  pickup?: Maybe<Scalars['Boolean']['output']>;
  pictures?: Maybe<Array<PictureType>>;
  portal?: Maybe<Scalars['Boolean']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  translation?: Maybe<Array<CatalogueCategoryTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  variety?: Maybe<ProductVarietyEnum>;
};

export type CatalogueCategoryBulkInput = {
  booking?: InputMaybe<Scalars['Boolean']['input']>;
  delivery?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  hasChildren: Scalars['Boolean']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  layer: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  parent?: InputMaybe<Scalars['ID']['input']>;
  pickup?: InputMaybe<Scalars['Boolean']['input']>;
  pictures?: InputMaybe<Array<PictureInput>>;
  portal?: InputMaybe<Scalars['Boolean']['input']>;
  rank: Scalars['Int']['input'];
  seo?: InputMaybe<CatalogueCategorySeoInput>;
  target: TargetAciInput;
  translation?: InputMaybe<Array<CatalogueCategoryTranslationInput>>;
  variety?: InputMaybe<ProductVarietyEnum>;
};

export type CatalogueCategoryInput = {
  booking?: InputMaybe<Scalars['Boolean']['input']>;
  delivery?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  layer: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  parent?: InputMaybe<Scalars['String']['input']>;
  pickup?: InputMaybe<Scalars['Boolean']['input']>;
  pictures?: InputMaybe<Array<PictureInput>>;
  portal?: InputMaybe<Scalars['Boolean']['input']>;
  seo?: InputMaybe<CatalogueCategorySeoInput>;
  target: TargetAciInput;
  translation?: InputMaybe<Array<CatalogueCategoryTranslationInput>>;
  variety?: InputMaybe<ProductVarietyEnum>;
};

export type CatalogueCategoryPaginateType = {
  __typename?: 'CatalogueCategoryPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CatalogueCategoryType>;
};

export type CatalogueCategorySeoInput = {
  metaDesription?: InputMaybe<Scalars['String']['input']>;
  metaKeywords?: InputMaybe<Array<MetaKeywordsInput>>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  urlKey?: InputMaybe<Scalars['String']['input']>;
};

export type CatalogueCategorySeoType = {
  __typename?: 'CatalogueCategorySeoType';
  metaDesription?: Maybe<Scalars['String']['output']>;
  metaKeywords?: Maybe<Array<MetaKeywordsType>>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  urlKey?: Maybe<Scalars['String']['output']>;
};

export type CatalogueCategoryTranslationContentInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CatalogueCategoryTranslationContentType = {
  __typename?: 'CatalogueCategoryTranslationContentType';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CatalogueCategoryTranslationInput = {
  content: CatalogueCategoryTranslationContentInput;
  language: Scalars['ID']['input'];
};

export type CatalogueCategoryTranslationType = {
  __typename?: 'CatalogueCategoryTranslationType';
  content: CatalogueCategoryTranslationContentType;
  language: LanguageType;
};

export type CatalogueCategoryType = {
  __typename?: 'CatalogueCategoryType';
  booking?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  delivery?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  hasChildren: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  layer: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<CatalogueCategoryBaseType>;
  pickup?: Maybe<Scalars['Boolean']['output']>;
  pictures?: Maybe<Array<PictureType>>;
  portal?: Maybe<Scalars['Boolean']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  target: TargetType;
  translation?: Maybe<Array<CatalogueCategoryTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  variety?: Maybe<ProductVarietyEnum>;
};

export type CatalogueCategoryUpdateInput = {
  booking?: InputMaybe<Scalars['Boolean']['input']>;
  delivery?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  layer?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['String']['input']>;
  pickup?: InputMaybe<Scalars['Boolean']['input']>;
  pictures?: InputMaybe<Array<PictureInput>>;
  portal?: InputMaybe<Scalars['Boolean']['input']>;
  seo?: InputMaybe<CatalogueCategorySeoInput>;
  translation?: InputMaybe<Array<CatalogueCategoryTranslationInput>>;
  variety?: InputMaybe<ProductVarietyEnum>;
};

export type CatalogueCategoryWithChildrenType = {
  __typename?: 'CatalogueCategoryWithChildrenType';
  booking?: Maybe<Scalars['Boolean']['output']>;
  children?: Maybe<Array<CatalogueCategoryWithChildrenType>>;
  createdAt: Scalars['DateTime']['output'];
  delivery?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  hasChildren: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  layer: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<CatalogueCategoryBaseType>;
  pickup?: Maybe<Scalars['Boolean']['output']>;
  pictures?: Maybe<Array<PictureType>>;
  portal?: Maybe<Scalars['Boolean']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  target: TargetType;
  translation?: Maybe<Array<CatalogueCategoryTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  variety?: Maybe<ProductVarietyEnum>;
};

export type CatalogueImportValidationType = {
  __typename?: 'CatalogueImportValidationType';
  attributesValidation: AttributesValidationType;
  attributesValuesValidation: AttributesValuesValidationType;
  barcodeValidation: BarcodeValidationType;
  brandValidation: BrandValidationType;
  categoriesValidation: CategoriesValidationType;
  notRecognizedSheets: Array<Scalars['String']['output']>;
  overallValidation: Scalars['Boolean']['output'];
  productValidation: ProductValidationType;
  stockValidation: StockValidationType;
};

export type CategoriesValidationType = {
  __typename?: 'CategoriesValidationType';
  headersValid?: Maybe<Scalars['Boolean']['output']>;
  isIdComplete?: Maybe<Scalars['Boolean']['output']>;
  isLayerComplete?: Maybe<Scalars['Boolean']['output']>;
  isNameComplete?: Maybe<Scalars['Boolean']['output']>;
  isParentComplete?: Maybe<Scalars['Boolean']['output']>;
  isRankComplete?: Maybe<Scalars['Boolean']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  overallValidation?: Maybe<Scalars['Boolean']['output']>;
};

export type CauseInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  coin?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  organization?: InputMaybe<TargetAciInput>;
  qualitativeRatio?: InputMaybe<Scalars['Decimal']['input']>;
  target: TargetAciInput;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CausePaginateType = {
  __typename?: 'CausePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CauseType>;
};

export type CauseType = {
  __typename?: 'CauseType';
  code?: Maybe<Scalars['String']['output']>;
  coin?: Maybe<CoinType>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<MediaType>;
  organization?: Maybe<TargetType>;
  qualitativeRatio?: Maybe<Scalars['Decimal']['output']>;
  target: TargetType;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CauseUpdateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  coin?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  organization?: InputMaybe<TargetAciInput>;
  qualitativeRatio?: InputMaybe<Scalars['Decimal']['input']>;
  target?: InputMaybe<TargetAciInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ChallengeActivitiesInput = {
  activityType?: InputMaybe<TransactionChallengeTypeEnum>;
  predefined?: InputMaybe<Scalars['ID']['input']>;
};

export type ChallengeActivitiesType = {
  __typename?: 'ChallengeActivitiesType';
  activityType?: Maybe<TransactionChallengeTypeEnum>;
  predefined?: Maybe<PredefinedType>;
};

export type ChallengeByAudienceFilterInput = {
  isDonation?: InputMaybe<Scalars['Boolean']['input']>;
  target: TargetAciInput;
};

export type ChallengeDonationInput = {
  donation?: InputMaybe<Scalars['ID']['input']>;
  objective?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ChallengeDonationType = {
  __typename?: 'ChallengeDonationType';
  currentAmount?: Maybe<Scalars['Decimal']['output']>;
  donation?: Maybe<ActivityTypeType>;
  numberOfParticipants?: Maybe<Scalars['Int']['output']>;
  objective?: Maybe<Scalars['Decimal']['output']>;
  progress?: Maybe<Scalars['Decimal']['output']>;
};

export type ChallengeFilterInput = {
  endDate?: InputMaybe<FromToInput>;
  startDate?: InputMaybe<FromToInput>;
  status?: InputMaybe<Array<ChallengeStatusEnum>>;
};

export type ChallengeInput = {
  activities?: InputMaybe<Array<ChallengeActivitiesInput>>;
  audience?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  donation?: InputMaybe<ChallengeDonationInput>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  leaderboard?: InputMaybe<ChallengeLeaderboardInput>;
  media?: InputMaybe<MediaInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ChallengeStatusEnum>;
  target?: InputMaybe<TargetAciInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  winners?: InputMaybe<Array<ChallengeInputWinner>>;
};

export type ChallengeInputWinner = {
  rank: Scalars['Int']['input'];
  reward?: InputMaybe<Scalars['ID']['input']>;
};

export type ChallengeLeaderboardInput = {
  blur: Scalars['Boolean']['input'];
};

export type ChallengeLeaderboardType = {
  __typename?: 'ChallengeLeaderboardType';
  blur: Scalars['Boolean']['output'];
};

export type ChallengePaginateType = {
  __typename?: 'ChallengePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ChallengeType>;
};

export enum ChallengeStatusEnum {
  DRAFT = 'DRAFT',
  FINISHED = 'FINISHED',
  ONGOING = 'ONGOING'
}

export type ChallengeType = {
  __typename?: 'ChallengeType';
  activities?: Maybe<Array<ChallengeActivitiesType>>;
  audience?: Maybe<AudienceType>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  description?: Maybe<Scalars['String']['output']>;
  donation?: Maybe<ChallengeDonationType>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  leaderboard: ChallengeLeaderboardType;
  media?: Maybe<MediaType>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ChallengeStatusEnum>;
  target?: Maybe<TargetType>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  winners?: Maybe<Array<ChallengeTypeWinner>>;
};

export type ChallengeTypeWinner = {
  __typename?: 'ChallengeTypeWinner';
  rank: Scalars['Int']['output'];
  reward?: Maybe<BarcodeType>;
  user?: Maybe<UserType>;
};

export type ChallengeWithLinkedAccountsType = {
  __typename?: 'ChallengeWithLinkedAccountsType';
  activities?: Maybe<Array<ChallengeActivitiesType>>;
  audience?: Maybe<AudienceType>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  description?: Maybe<Scalars['String']['output']>;
  donation?: Maybe<ChallengeDonationType>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isAccountLinked?: Maybe<Scalars['Boolean']['output']>;
  leaderboard: ChallengeLeaderboardType;
  media?: Maybe<MediaType>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ChallengeStatusEnum>;
  target?: Maybe<TargetType>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  winners?: Maybe<Array<ChallengeTypeWinner>>;
};

export enum ChannelEnum {
  EMAIL = 'EMAIL',
  PUSH = 'PUSH',
  SMS = 'SMS',
  WIDGET = 'WIDGET'
}

export enum ChartAppTypeEnum {
  FREE = 'FREE',
  GROSSING = 'GROSSING',
  PAID = 'PAID'
}

export enum ChartPlatformEnum {
  AMAZON = 'AMAZON',
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  IPAD = 'IPAD',
  IPHONE = 'IPHONE'
}

export type CheckWalletAndReputationType = {
  __typename?: 'CheckWalletAndReputationType';
  currentReputation: ReputationSimpleType;
  maxDiscount?: Maybe<Scalars['Decimal']['output']>;
  redeemRate?: Maybe<Scalars['Int']['output']>;
  user: UserCheckType;
  wallet: WalletCheckType;
};

export type ClientDataType = {
  __typename?: 'ClientDataType';
  clientType?: Maybe<Scalars['String']['output']>;
  engine?: Maybe<Scalars['String']['output']>;
  engineVersion?: Maybe<Scalars['String']['output']>;
  family?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type CloudinaryResourceType = {
  __typename?: 'CloudinaryResourceType';
  bytes?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  public_id?: Maybe<Scalars['String']['output']>;
  resource_type?: Maybe<Scalars['String']['output']>;
  secure_url?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['String']['output']>;
};

export type CloudinarySignatureType = {
  __typename?: 'CloudinarySignatureType';
  folder?: Maybe<Scalars['String']['output']>;
  public_id?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Float']['output']>;
};

export type CoachsBirthType = {
  __typename?: 'CoachsBirthType';
  country?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  place?: Maybe<Scalars['String']['output']>;
};

export type CoachsCareerType = {
  __typename?: 'CoachsCareerType';
  end?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
  team?: Maybe<CoachsTeamType>;
};

export type CoachsTeamType = {
  __typename?: 'CoachsTeamType';
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CoachsType = {
  __typename?: 'CoachsType';
  age?: Maybe<Scalars['Float']['output']>;
  birth?: Maybe<CoachsBirthType>;
  career?: Maybe<Array<CoachsCareerType>>;
  coachId?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  firstname?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  photo64?: Maybe<Scalars['String']['output']>;
  team?: Maybe<CoachsTeamType>;
  updatedAt: Scalars['DateTime']['output'];
  weight?: Maybe<Scalars['String']['output']>;
};

export enum CodeFormatEnum {
  ALPHANUMERIC = 'ALPHANUMERIC',
  NUMERIC = 'NUMERIC'
}

export enum CodeRepresentationEnum {
  BARCODE = 'BARCODE',
  QRCODE = 'QRCODE'
}

export type CoinApiCheckInput = {
  headers: Array<CoinApiHeadersInput>;
  link: Scalars['String']['input'];
  method: ApiMethods;
  params: Array<CoinApiHeadersInput>;
};

export type CoinApiCheckType = {
  __typename?: 'CoinApiCheckType';
  headers?: Maybe<Array<CoinApiHeadersType>>;
  link?: Maybe<Scalars['String']['output']>;
  method?: Maybe<ApiMethods>;
  params?: Maybe<Array<CoinApiHeadersType>>;
};

export type CoinApiHeadersInput = {
  key: Scalars['String']['input'];
  user: Scalars['Boolean']['input'];
  value: Scalars['String']['input'];
};

export type CoinApiHeadersType = {
  __typename?: 'CoinApiHeadersType';
  key?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CoinApiInput = {
  check?: InputMaybe<CoinApiCheckInput>;
  deduct?: InputMaybe<CoinApiMethodInput>;
  push?: InputMaybe<CoinApiMethodInput>;
};

export type CoinApiMethodInput = {
  headers: Array<CoinApiParamsInput>;
  link: Scalars['String']['input'];
  method: ApiMethods;
  params: Array<CoinApiParamsInput>;
};

export type CoinApiMethodType = {
  __typename?: 'CoinApiMethodType';
  headers?: Maybe<Array<CoinApiParamsType>>;
  link?: Maybe<Scalars['String']['output']>;
  method?: Maybe<ApiMethods>;
  params?: Maybe<Array<CoinApiParamsType>>;
};

export type CoinApiParamsInput = {
  amount: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  user: Scalars['Boolean']['input'];
  value: Scalars['String']['input'];
};

export type CoinApiParamsType = {
  __typename?: 'CoinApiParamsType';
  amount?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CoinApiType = {
  __typename?: 'CoinApiType';
  check?: Maybe<CoinApiCheckType>;
  deduct?: Maybe<CoinApiMethodType>;
  push?: Maybe<CoinApiMethodType>;
};

export enum CoinCategoryEnum {
  CLASSIC = 'CLASSIC',
  CRYPTO = 'CRYPTO'
}

export enum CoinHandleEnum {
  API = 'API',
  INTERNAL = 'INTERNAL'
}

export type CoinInput = {
  api?: InputMaybe<CoinApiInput>;
  category?: InputMaybe<CoinCategoryEnum>;
  code?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['ID']['input']>;
  handle?: InputMaybe<CoinHandleEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<TargetAciInput>;
  picture?: InputMaybe<PictureInput>;
  unitValue?: InputMaybe<CoinValueInput>;
};

export type CoinPaginateType = {
  __typename?: 'CoinPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CoinType>;
};

export type CoinSimpleType = {
  __typename?: 'CoinSimpleType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  picture?: Maybe<PictureType>;
  unitValue?: Maybe<CoinValueType>;
};

export type CoinType = {
  __typename?: 'CoinType';
  api?: Maybe<CoinApiType>;
  category?: Maybe<CoinCategoryEnum>;
  code?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryType>;
  createdAt: Scalars['DateTime']['output'];
  handle?: Maybe<CoinHandleEnum>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner?: Maybe<TargetType>;
  picture?: Maybe<PictureType>;
  unitValue?: Maybe<CoinValueType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CoinValueInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  currency?: InputMaybe<Scalars['ID']['input']>;
};

export type CoinValueType = {
  __typename?: 'CoinValueType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  currency?: Maybe<CurrencyType>;
};

export type CollaborationAnalyticsProjectsOverviewChartType = {
  __typename?: 'CollaborationAnalyticsProjectsOverviewChartType';
  activeProjects?: Maybe<Array<Scalars['Int']['output']>>;
  revenue?: Maybe<Array<Scalars['Decimal']['output']>>;
  totalProjects?: Maybe<Array<Scalars['Int']['output']>>;
};

export type CollaborationAnalyticsProjectsOverviewType = {
  __typename?: 'CollaborationAnalyticsProjectsOverviewType';
  activeProjects?: Maybe<Scalars['Int']['output']>;
  chart?: Maybe<CollaborationAnalyticsProjectsOverviewChartType>;
  hours?: Maybe<Scalars['Int']['output']>;
  revenue?: Maybe<Scalars['Decimal']['output']>;
  totalProjects?: Maybe<Scalars['Int']['output']>;
};

export type CollaborationAnalyticsProjectsStatusChartDetailType = {
  __typename?: 'CollaborationAnalyticsProjectsStatusChartDetailType';
  count?: Maybe<Scalars['Int']['output']>;
  hours?: Maybe<Scalars['Int']['output']>;
};

export type CollaborationAnalyticsProjectsStatusChartType = {
  __typename?: 'CollaborationAnalyticsProjectsStatusChartType';
  ACTIVE?: Maybe<CollaborationAnalyticsProjectsStatusChartDetailType>;
  BLOCKED?: Maybe<CollaborationAnalyticsProjectsStatusChartDetailType>;
  CANCELLED?: Maybe<CollaborationAnalyticsProjectsStatusChartDetailType>;
  DELIVERED?: Maybe<CollaborationAnalyticsProjectsStatusChartDetailType>;
};

export type CollaborationAnalyticsProjectsStatusType = {
  __typename?: 'CollaborationAnalyticsProjectsStatusType';
  chart?: Maybe<CollaborationAnalyticsProjectsStatusChartType>;
  newProjects?: Maybe<Scalars['Int']['output']>;
  totalProjects?: Maybe<Scalars['Int']['output']>;
};

export type CollaborationAnalyticsStatsType = {
  __typename?: 'CollaborationAnalyticsStatsType';
  activeBoardCards?: Maybe<AnalyticsStatsInfoType>;
  activeProjects?: Maybe<AnalyticsStatsInfoType>;
  totalHours?: Maybe<AnalyticsStatsInfoType>;
};

export type CommentBaseType = {
  __typename?: 'CommentBaseType';
  attachments?: Maybe<Array<DocumentType>>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  holder?: Maybe<CommentHolderType>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type CommentHolderInput = {
  card?: InputMaybe<Scalars['ID']['input']>;
  project?: InputMaybe<Scalars['ID']['input']>;
  purchaseDeliveryNote?: InputMaybe<Scalars['ID']['input']>;
  purchaseInvoice?: InputMaybe<Scalars['ID']['input']>;
  purchaseOrder?: InputMaybe<Scalars['ID']['input']>;
  quotation?: InputMaybe<Scalars['ID']['input']>;
  saleDeliveryNote?: InputMaybe<Scalars['ID']['input']>;
  saleInvoice?: InputMaybe<Scalars['ID']['input']>;
  saleIssueNote?: InputMaybe<Scalars['ID']['input']>;
  saleOrder?: InputMaybe<Scalars['ID']['input']>;
  ticket?: InputMaybe<Scalars['ID']['input']>;
};

export type CommentHolderType = {
  __typename?: 'CommentHolderType';
  card?: Maybe<BoardCardType>;
  project?: Maybe<ProjectType>;
  purchaseDeliveryNote?: Maybe<PurchaseDeliveryNoteType>;
  purchaseInvoice?: Maybe<PurchaseInvoiceType>;
  purchaseOrder?: Maybe<PurchaseOrderType>;
  quotation?: Maybe<QuotationType>;
  saleDeliveryNote?: Maybe<SaleDeliveryNoteType>;
  saleInvoice?: Maybe<SaleInvoiceType>;
  saleIssueNote?: Maybe<SaleIssueNoteType>;
  saleOrder?: Maybe<SaleOrderType>;
  ticket?: Maybe<TicketType>;
};

export type CommentInput = {
  attachments?: InputMaybe<Array<Scalars['ID']['input']>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  holder?: InputMaybe<CommentHolderInput>;
  replyTo?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type CommentPaginateType = {
  __typename?: 'CommentPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CommentType>;
};

export type CommentType = {
  __typename?: 'CommentType';
  attachments?: Maybe<Array<DocumentType>>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  firstReply?: Maybe<FirstReplyType>;
  holder?: Maybe<CommentHolderType>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type CompanyContactDetailsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<PhoneInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyContactDetailsType = {
  __typename?: 'CompanyContactDetailsType';
  email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<PhoneType>;
  website?: Maybe<Scalars['String']['output']>;
};

export type CompanyContactInput = {
  address?: InputMaybe<FullAddressInput>;
  chatContact?: InputMaybe<Array<SocialValueInput>>;
  company?: InputMaybe<Scalars['ID']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastContacted?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  leadScore?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  phone?: InputMaybe<IPhoneInput>;
  socialMedia?: InputMaybe<Array<SocialValueInput>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CompanyContactPaginateType = {
  __typename?: 'CompanyContactPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CompanyContactType>;
};

export type CompanyContactType = {
  __typename?: 'CompanyContactType';
  address?: Maybe<FullAddressType>;
  chatContact?: Maybe<Array<SocialValueType>>;
  company?: Maybe<CompanyType>;
  createdAt: Scalars['DateTime']['output'];
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastContacted?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  leadScore?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  phone?: Maybe<IPhoneType>;
  socialMedia?: Maybe<Array<SocialValueType>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CompanyContactUpdateInput = {
  address?: InputMaybe<FullAddressInput>;
  chatContact?: InputMaybe<Array<SocialValueInput>>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastContacted?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  leadScore?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  phone?: InputMaybe<IPhoneInput>;
  socialMedia?: InputMaybe<Array<SocialValueInput>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CompanyCustomerInput = {
  phase?: InputMaybe<CustomerPhaseEnum>;
  score?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyCustomerType = {
  __typename?: 'CompanyCustomerType';
  phase?: Maybe<CustomerPhaseEnum>;
  score?: Maybe<Scalars['String']['output']>;
};

export type CompanyInput = {
  address?: InputMaybe<FullAddressInput>;
  banks?: InputMaybe<Array<Scalars['String']['input']>>;
  contact?: InputMaybe<CompanyContactDetailsInput>;
  customer?: InputMaybe<CompanyCustomerInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  legal?: InputMaybe<CompanyLegalInput>;
  logistic?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<CompanySupplierInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  target?: InputMaybe<TargetAciInput>;
};

export type CompanyLegalInput = {
  licence?: InputMaybe<Scalars['String']['input']>;
  register?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyLegalType = {
  __typename?: 'CompanyLegalType';
  licence?: Maybe<Scalars['String']['output']>;
  register?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['String']['output']>;
};

export type CompanyPaginateType = {
  __typename?: 'CompanyPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CompanyType>;
};

export type CompanySupplierInput = {
  kind?: InputMaybe<SupplierTypeEnum>;
};

export type CompanySupplierType = {
  __typename?: 'CompanySupplierType';
  kind?: Maybe<SupplierTypeEnum>;
};

export type CompanyType = {
  __typename?: 'CompanyType';
  address?: Maybe<FullAddressType>;
  banks?: Maybe<Array<BankDetailsType>>;
  contact?: Maybe<CompanyContactDetailsType>;
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<CompanyCustomerType>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  legal?: Maybe<CompanyLegalType>;
  logistic?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<CompanySupplierType>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CompanyUpdateInput = {
  address?: InputMaybe<FullAddressInput>;
  banks?: InputMaybe<Array<Scalars['String']['input']>>;
  contact?: InputMaybe<CompanyContactDetailsInput>;
  customer?: InputMaybe<CompanyCustomerInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  legal?: InputMaybe<CompanyLegalInput>;
  logistic?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<CompanySupplierInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CompareProductInput = {
  limit: Scalars['Int']['input'];
  product: Scalars['ID']['input'];
};

export type CompareProductType = {
  __typename?: 'CompareProductType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  products: InternalProductType;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type CompareRankType = {
  __typename?: 'CompareRankType';
  change: Scalars['Int']['output'];
  direction: LeaderboardCompareEnum;
};

export type ComplaintTargetType = {
  __typename?: 'ComplaintTargetType';
  manufacturer?: Maybe<ManufacturerType>;
  pos?: Maybe<PointOfSaleType>;
  user?: Maybe<UserType>;
  wholesaler?: Maybe<WholesalerType>;
};

export type ComplaintType = {
  __typename?: 'ComplaintType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  report: Scalars['String']['output'];
  reporter: UserType;
  target: ComplaintTargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ContentJsonType = {
  __typename?: 'ContentJSONType';
  description?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<LinkItemType>>;
  metas?: Maybe<Array<MetaItemType>>;
  scripts?: Maybe<Array<ScriptItemType>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ContentType = {
  __typename?: 'ContentType';
  content?: Maybe<Scalars['String']['output']>;
};

export type ContentTypeImageFormatInput = {
  png?: InputMaybe<PictureInput>;
  svg?: InputMaybe<PictureInput>;
};

export type ContentTypeImageFormatType = {
  __typename?: 'ContentTypeImageFormatType';
  png?: Maybe<PictureType>;
  svg?: Maybe<PictureType>;
};

export type ContentTypeImageInput = {
  background?: InputMaybe<ContentTypeImageFormatInput>;
  black?: InputMaybe<ContentTypeImageFormatInput>;
  icon?: InputMaybe<Scalars['String']['input']>;
  white?: InputMaybe<ContentTypeImageFormatInput>;
};

export type ContentTypeImageType = {
  __typename?: 'ContentTypeImageType';
  background?: Maybe<ContentTypeImageFormatType>;
  black?: Maybe<ContentTypeImageFormatType>;
  icon?: Maybe<Scalars['String']['output']>;
  white?: Maybe<ContentTypeImageFormatType>;
};

export type ContentTypeInput = {
  image?: InputMaybe<ContentTypeImageInput>;
  name: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ContentTypePaginatedType = {
  __typename?: 'ContentTypePaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ContentTypeType>;
};

export type ContentTypeType = {
  __typename?: 'ContentTypeType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<ContentTypeImageType>;
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ConversionByAgeType = {
  __typename?: 'ConversionByAgeType';
  bucket: AgeGroupBucketEnum;
  count: Scalars['Int']['output'];
};

export type ConversionByGenderType = {
  __typename?: 'ConversionByGenderType';
  count: Scalars['Int']['output'];
  gender: Gender;
};

export type ConversionsFieldType = {
  __typename?: 'ConversionsFieldType';
  current: Scalars['Int']['output'];
  percentage?: Maybe<Scalars['Decimal']['output']>;
  previous: Scalars['Int']['output'];
  weeklyConversions: Array<PeriodStatsType>;
};

export type CorporateActionType = {
  __typename?: 'CorporateActionType';
  activity?: Maybe<Scalars['String']['output']>;
  adhocNotification?: Maybe<AdhocCorporateNotificationType>;
  adhocOrder?: Maybe<Scalars['String']['output']>;
  booking?: Maybe<BookingType>;
  currentPoints?: Maybe<Scalars['Float']['output']>;
  internalProduct?: Maybe<Scalars['String']['output']>;
  onsite?: Maybe<CorporateNotificationOnsiteConverterType>;
  order?: Maybe<Scalars['String']['output']>;
  outboundId?: Maybe<Scalars['String']['output']>;
  quest?: Maybe<Scalars['String']['output']>;
  redeemAmount?: Maybe<Scalars['Decimal']['output']>;
  reputationLoss?: Maybe<Scalars['Float']['output']>;
  reputationLossDate?: Maybe<Scalars['DateTime']['output']>;
  reward?: Maybe<CouponNotificationActionType>;
  subscription?: Maybe<Scalars['String']['output']>;
  table?: Maybe<Scalars['String']['output']>;
  turnoverPoints?: Maybe<Scalars['Float']['output']>;
};

export type CorporateDashboardType = {
  __typename?: 'CorporateDashboardType';
  accountsCount: AccountsCountType;
  numberOfInternalProducts: NumberOfInternalProductsType;
  numberOfPointOfSales: NumberOfPointOfSalesType;
  rolesCount: RolesCountType;
  totalNumberOfCompanies: Scalars['Int']['output'];
  totalNumberOfManufacturers: Scalars['Int']['output'];
  totalNumberOfWholesalers: Scalars['Int']['output'];
};

export type CorporateEmailTempInput = {
  attachments?: InputMaybe<Array<MailAttachmentInput>>;
  content?: InputMaybe<EmailContentInput>;
  langauge?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  target: TargetAciInput;
  template?: InputMaybe<EmailTemplateTypeEnum>;
  to: Array<Scalars['String']['input']>;
  variables?: InputMaybe<EmailTempVariablesInput>;
};

export type CorporateEmailTemplateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<EmailTemplateTypeEnum>;
  picture?: InputMaybe<PictureInput>;
  style?: InputMaybe<CorporateEmailTemplateStyleInput>;
  target?: InputMaybe<TargetAciInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Array<CorporateEmailTemplateTranslationInput>>;
};

export type CorporateEmailTemplatePaginateType = {
  __typename?: 'CorporateEmailTemplatePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CorporateEmailTemplateType>;
};

export type CorporateEmailTemplateStyleInput = {
  desktop?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
};

export type CorporateEmailTemplateStyleType = {
  __typename?: 'CorporateEmailTemplateStyleType';
  desktop?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
};

export type CorporateEmailTemplateTranslationInput = {
  content: Scalars['String']['input'];
  language: Scalars['ID']['input'];
};

export type CorporateEmailTemplateTranslationType = {
  __typename?: 'CorporateEmailTemplateTranslationType';
  content: Scalars['String']['output'];
  language: LanguageType;
};

export type CorporateEmailTemplateType = {
  __typename?: 'CorporateEmailTemplateType';
  color?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<EmailTemplateTypeEnum>;
  picture?: Maybe<PictureType>;
  style?: Maybe<CorporateEmailTemplateStyleType>;
  target?: Maybe<TargetType>;
  title?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Array<CorporateEmailTemplateTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CorporateLoginType = {
  __typename?: 'CorporateLoginType';
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Float']['output'];
  user?: Maybe<CorporateUserType>;
};

export type CorporateLoginWithActionTypeType = {
  __typename?: 'CorporateLoginWithActionTypeType';
  accessToken: Scalars['String']['output'];
  actionType?: Maybe<ActionTypeEnum>;
  expiresIn: Scalars['Float']['output'];
  user?: Maybe<CorporateUserType>;
};

export type CorporateNotificationFullType = {
  __typename?: 'CorporateNotificationFullType';
  action?: Maybe<CorporateActionType>;
  audience?: Maybe<AudienceType>;
  createdAt: Scalars['DateTime']['output'];
  event?: Maybe<EventTypeEnum>;
  executed?: Maybe<Scalars['Boolean']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  seen?: Maybe<Scalars['Boolean']['output']>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type CorporateNotificationInput = {
  audience?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  executedAt?: InputMaybe<Scalars['DateTime']['input']>;
  picture?: InputMaybe<PictureInput>;
  target?: InputMaybe<TargetAciInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CorporateNotificationOnsiteConverterType = {
  __typename?: 'CorporateNotificationOnsiteConverterType';
  qualitativeAmount: Scalars['Decimal']['output'];
  quantitativeAmount: Scalars['Decimal']['output'];
  source: Scalars['String']['output'];
};

export type CorporateNotificationPaginateType = {
  __typename?: 'CorporateNotificationPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CorporateNotificationType>;
};

export type CorporateNotificationResponse = {
  __typename?: 'CorporateNotificationResponse';
  success: Scalars['Boolean']['output'];
};

export type CorporateNotificationType = {
  __typename?: 'CorporateNotificationType';
  action?: Maybe<CorporateActionType>;
  audience?: Maybe<AudienceType>;
  createdAt: Scalars['DateTime']['output'];
  event?: Maybe<EventTypeEnum>;
  executed?: Maybe<Scalars['Boolean']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  seen?: Maybe<Scalars['Boolean']['output']>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type CorporateOutboundNotificationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  outbound?: InputMaybe<Scalars['ID']['input']>;
  picture?: InputMaybe<PictureInput>;
  target?: InputMaybe<TargetAciInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorporateRatingAssignmentInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  reviewDefinition: Scalars['ID']['input'];
  target: TargetAciInput;
};

export type CorporateRatingAssignmentPaginateType = {
  __typename?: 'CorporateRatingAssignmentPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CorporateRatingAssignmentType>;
};

export type CorporateRatingAssignmentType = {
  __typename?: 'CorporateRatingAssignmentType';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  reviewDefinition?: Maybe<CorporateRatingDefinitionType>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CorporateRatingDefinitionPaginateType = {
  __typename?: 'CorporateRatingDefinitionPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CorporateRatingDefinitionType>;
};

export type CorporateRatingDefinitionType = {
  __typename?: 'CorporateRatingDefinitionType';
  id?: Maybe<Scalars['ID']['output']>;
  reviewType?: Maybe<Scalars['String']['output']>;
};

export type CorporateRatingInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  /** an integer minimum 1 and maximum 5. */
  mark: Scalars['Float']['input'];
  product: Scalars['ID']['input'];
  /** Corporate Rating review type. */
  reviewType: Scalars['String']['input'];
  source?: InputMaybe<UserEventsSourceEnum>;
  target: TargetAciInput;
};

export type CorporateRatingPaginateType = {
  __typename?: 'CorporateRatingPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CorporateRatingType>;
};

export type CorporateRatingType = {
  __typename?: 'CorporateRatingType';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mark: Scalars['Int']['output'];
  product?: Maybe<InternalProductType>;
  reviewType: CorporateRatingDefinitionType;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type CorporateRatingWithStatsPaginatedType = {
  __typename?: 'CorporateRatingWithStatsPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CorporateRatingType>;
  stats?: Maybe<Array<ByMarkRatingType>>;
};

export type CorporateTargetDashboardType = {
  __typename?: 'CorporateTargetDashboardType';
  numberOfInternalProducts: NumberOfProductsType;
  numberOfRoles: Array<AccountsByRoleCountType>;
};

export type CorporateTemplateInput = {
  content: Scalars['String']['input'];
  name: CorporateTemplateTypeEnum;
  target: TargetAciInput;
};

export type CorporateTemplateType = {
  __typename?: 'CorporateTemplateType';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: CorporateTemplateTypeEnum;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum CorporateTemplateTypeEnum {
  ADS = 'ADS',
  BROWSER_CONFIG = 'BROWSER_CONFIG',
  ROBOTS = 'ROBOTS',
  SITE_MAP = 'SITE_MAP',
  WEB_MANIFEST = 'WEB_MANIFEST',
  WELL_KNOWN_ANDROID = 'WELL_KNOWN_ANDROID',
  WELL_KNOWN_APPLE = 'WELL_KNOWN_APPLE'
}

export type CorporateUpdateRatingInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  /** an integer minimum 1 and maximum 5. */
  mark?: InputMaybe<Scalars['Float']['input']>;
  /** Corporate Rating review type. */
  reviewType?: InputMaybe<Scalars['String']['input']>;
};

export type CorporateUserCardFilterInput = {
  cardType?: InputMaybe<Array<CardTypeEnum>>;
  validUntil?: InputMaybe<FromToInput>;
};

export type CorporateUserCardFullPaginatedType = {
  __typename?: 'CorporateUserCardFullPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CorporateUserCardType>;
};

export type CorporateUserCardFullWithReputationPaginatedType = {
  __typename?: 'CorporateUserCardFullWithReputationPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CorporateUserCardWithReputationType>;
};

export type CorporateUserCardType = {
  __typename?: 'CorporateUserCardType';
  cardType: CardTypeEnum;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
  validUntil: Scalars['DateTime']['output'];
};

export type CorporateUserCardWithExtrasType = {
  __typename?: 'CorporateUserCardWithExtrasType';
  cardType: CardTypeEnum;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  prelevel?: Maybe<LoyaltySettingsPrelevelType>;
  reputationLevels?: Maybe<Array<ReputationWithoutTargetType>>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
  validUntil: Scalars['DateTime']['output'];
  visualRepresentation?: Maybe<CodeRepresentationEnum>;
  walletAmount?: Maybe<Scalars['Decimal']['output']>;
};

export type CorporateUserCardWithReputationType = {
  __typename?: 'CorporateUserCardWithReputationType';
  cardType: CardTypeEnum;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
  validUntil: Scalars['DateTime']['output'];
  wallet?: Maybe<WalletBaseType>;
};

export type CorporateUserDashType = {
  __typename?: 'CorporateUserDashType';
  createdAt: Scalars['DateTime']['output'];
  dashboard: DashboardEnum;
  id: Scalars['ID']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type CorporateUserDashboardInput = {
  dashboard?: InputMaybe<DashboardEnum>;
  rank: Scalars['Int']['input'];
  target: TargetAciInput;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type CorporateUserDashboardType = {
  __typename?: 'CorporateUserDashboardType';
  age: Array<AuthDashboardAgeType>;
  gender: Array<AuthDashboardGenderType>;
  mailValidation: Array<AuthDashboardMailValidationType>;
  newUsers: Scalars['Int']['output'];
  returningUsers: Scalars['Int']['output'];
};

export type CorporateUserDashboardUpdateInput = {
  dashboard?: InputMaybe<DashboardEnum>;
  id: Scalars['ID']['input'];
  rank: Scalars['Int']['input'];
  user?: InputMaybe<Scalars['String']['input']>;
};

export type CorporateUserExistType = {
  __typename?: 'CorporateUserExistType';
  exist: Scalars['Boolean']['output'];
  user?: Maybe<CorporateUserType>;
};

export type CorporateUserPaginateType = {
  __typename?: 'CorporateUserPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CorporateUserType>;
};

export type CorporateUserType = {
  __typename?: 'CorporateUserType';
  about?: Maybe<Scalars['String']['output']>;
  apps?: Maybe<Array<App>>;
  billingAddress?: Maybe<Array<FullAddressType>>;
  chatContact?: Maybe<Array<SocialValueType>>;
  covers?: Maybe<Array<PictureType>>;
  createdAt: Scalars['DateTime']['output'];
  custom?: Maybe<Array<UserCustomType>>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  education?: Maybe<Array<UserEducationType>>;
  email?: Maybe<Scalars['String']['output']>;
  fcmTokens?: Maybe<Array<FcmTokenType>>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  hasAutoGeneratedEmail?: Maybe<Scalars['Boolean']['output']>;
  hobbies?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  interests?: Maybe<Array<Scalars['String']['output']>>;
  isMailValid?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Array<LanguageType>>;
  lastName?: Maybe<Scalars['String']['output']>;
  lived?: Maybe<Array<StateType>>;
  locale?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<MaritalStatus>;
  mobileTheme?: Maybe<MobileThemesEnum>;
  nationality?: Maybe<CountryType>;
  newsletterSubs?: Maybe<Scalars['Boolean']['output']>;
  permission?: Maybe<PermissionType>;
  phone?: Maybe<PhoneType>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  placeOfBirth?: Maybe<Scalars['String']['output']>;
  plugged?: Maybe<Scalars['Boolean']['output']>;
  residentialAddress?: Maybe<Array<FullAddressType>>;
  roles?: Maybe<Array<UserRole>>;
  shippingAddress?: Maybe<Array<FullAddressType>>;
  socialLoginData?: Maybe<SocialLoginDataType>;
  socialMedia?: Maybe<Array<SocialValueType>>;
  source?: Maybe<SourcesEnum>;
  status?: Maybe<UserStatus>;
  target?: Maybe<TargetType>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  username?: Maybe<Scalars['String']['output']>;
  widget?: Maybe<Scalars['Boolean']['output']>;
  work?: Maybe<Array<UserWorkType>>;
};

export type CorporateUsersStatsType = {
  __typename?: 'CorporateUsersStatsType';
  current: Scalars['Int']['output'];
  percentage?: Maybe<Scalars['Decimal']['output']>;
  previous: Scalars['Int']['output'];
};

export type CountType = {
  __typename?: 'CountType';
  count: Scalars['Int']['output'];
};

export enum CountryEnum {
  AFGHANISTAN = 'AFGHANISTAN',
  ALBANIA = 'ALBANIA',
  ALGERIA = 'ALGERIA',
  ANDORRA = 'ANDORRA',
  ANGOLA = 'ANGOLA',
  ANTIGUA_AND_BARBUDA = 'ANTIGUA_AND_BARBUDA',
  ARGENTINA = 'ARGENTINA',
  ARMENIA = 'ARMENIA',
  AUSTRALIA = 'AUSTRALIA',
  AUSTRIA = 'AUSTRIA',
  AZERBAIJAN = 'AZERBAIJAN',
  BAHAMAS = 'BAHAMAS',
  BAHRAIN = 'BAHRAIN',
  BANGLADESH = 'BANGLADESH',
  BARBADOS = 'BARBADOS',
  BELARUS = 'BELARUS',
  BELGIUM = 'BELGIUM',
  BELIZE = 'BELIZE',
  BENIN = 'BENIN',
  BHUTAN = 'BHUTAN',
  BOLIVIA = 'BOLIVIA',
  BOSNIA_AND_HERZEGOVINA = 'BOSNIA_AND_HERZEGOVINA',
  BOTSWANA = 'BOTSWANA',
  BRAZIL = 'BRAZIL',
  BRUNEI = 'BRUNEI',
  BULGARIA = 'BULGARIA',
  BURKINA_FASO = 'BURKINA_FASO',
  BURUNDI = 'BURUNDI',
  CABO_VERDE = 'CABO_VERDE',
  CAMBODIA = 'CAMBODIA',
  CAMEROON = 'CAMEROON',
  CANADA = 'CANADA',
  CENTRALA_FRICAN_REPUBLIC = 'CENTRALA_FRICAN_REPUBLIC',
  CHAD = 'CHAD',
  CHILE = 'CHILE',
  CHINA = 'CHINA',
  COLOMBIA = 'COLOMBIA',
  COMOROS = 'COMOROS',
  CONGO_BRAZZAVILLE = 'CONGO_BRAZZAVILLE',
  COSTA_RICA = 'COSTA_RICA',
  CROATIA = 'CROATIA',
  CUBA = 'CUBA',
  CYPRUS = 'CYPRUS',
  CZECH_REPUBLIC = 'CZECH_REPUBLIC',
  DEMOCRATIC_REPUBLIC_OF_THE_CONGO = 'DEMOCRATIC_REPUBLIC_OF_THE_CONGO',
  DENMARK = 'DENMARK',
  DJIBOUTI = 'DJIBOUTI',
  DOMINICA = 'DOMINICA',
  DOMINICAN_REPUBLIC = 'DOMINICAN_REPUBLIC',
  ECUADOR = 'ECUADOR',
  EGYPT = 'EGYPT',
  EL_SALVADOR = 'EL_SALVADOR',
  EQUATORIAL_GUINEA = 'EQUATORIAL_GUINEA',
  ERITREA = 'ERITREA',
  ESTONIA = 'ESTONIA',
  ESWATINI = 'ESWATINI',
  ETHIOPIA = 'ETHIOPIA',
  FIJI = 'FIJI',
  FINLAND = 'FINLAND',
  FRANCE = 'FRANCE',
  GABON = 'GABON',
  GAMBIA = 'GAMBIA',
  GEORGIA = 'GEORGIA',
  GERMANY = 'GERMANY',
  GHANA = 'GHANA',
  GREECE = 'GREECE',
  GRENADA = 'GRENADA',
  GUATEMALA = 'GUATEMALA',
  GUINEA = 'GUINEA',
  GUINEA_BISSAU = 'GUINEA_BISSAU',
  GUYANA = 'GUYANA',
  HAITI = 'HAITI',
  HOLY_SEE = 'HOLY_SEE',
  HONDURAS = 'HONDURAS',
  HUNGARY = 'HUNGARY',
  ICELAND = 'ICELAND',
  INDIA = 'INDIA',
  INDONESIA = 'INDONESIA',
  IRAN = 'IRAN',
  IRAQ = 'IRAQ',
  IRELAND = 'IRELAND',
  ISRAEL = 'ISRAEL',
  ITALY = 'ITALY',
  IVORY_COAST = 'IVORY_COAST',
  JAMAICA = 'JAMAICA',
  JAPAN = 'JAPAN',
  JORDAN = 'JORDAN',
  KAZAKHSTAN = 'KAZAKHSTAN',
  KENYA = 'KENYA',
  KIRIBATI = 'KIRIBATI',
  KUWAIT = 'KUWAIT',
  KYRGYZSTAN = 'KYRGYZSTAN',
  LAOS = 'LAOS',
  LATVIA = 'LATVIA',
  LEBANON = 'LEBANON',
  LESOTHO = 'LESOTHO',
  LIBERIA = 'LIBERIA',
  LIBYA = 'LIBYA',
  LIECHTENSTEIN = 'LIECHTENSTEIN',
  LITHUANIA = 'LITHUANIA',
  LUXEMBOURG = 'LUXEMBOURG',
  MADAGASCAR = 'MADAGASCAR',
  MALAWI = 'MALAWI',
  MALAYSIA = 'MALAYSIA',
  MALDIVES = 'MALDIVES',
  MALI = 'MALI',
  MALTA = 'MALTA',
  MARSHALL_ISLANDS = 'MARSHALL_ISLANDS',
  MAURITANIA = 'MAURITANIA',
  MAURITIUS = 'MAURITIUS',
  MEXICO = 'MEXICO',
  MICRONESIA = 'MICRONESIA',
  MOLDOVA = 'MOLDOVA',
  MONACO = 'MONACO',
  MONGOLIA = 'MONGOLIA',
  MONTENEGRO = 'MONTENEGRO',
  MOROCCO = 'MOROCCO',
  MOZAMBIQUE = 'MOZAMBIQUE',
  MYANMAR = 'MYANMAR',
  NAMIBIA = 'NAMIBIA',
  NAURU = 'NAURU',
  NEPAL = 'NEPAL',
  NETHERLANDS = 'NETHERLANDS',
  NEW_ZEALAND = 'NEW_ZEALAND',
  NICARAGUA = 'NICARAGUA',
  NIGER = 'NIGER',
  NIGERIA = 'NIGERIA',
  NORTH_KOREA = 'NORTH_KOREA',
  NORTH_MACEDONIA = 'NORTH_MACEDONIA',
  NORWAY = 'NORWAY',
  NOT_SPECIFIED = 'NOT_SPECIFIED',
  OMAN = 'OMAN',
  PAKISTAN = 'PAKISTAN',
  PALAU = 'PALAU',
  PALESTINE_STATE = 'PALESTINE_STATE',
  PANAMA = 'PANAMA',
  PAPUA_NEW_GUINEA = 'PAPUA_NEW_GUINEA',
  PARAGUAY = 'PARAGUAY',
  PERU = 'PERU',
  PHILIPPINES = 'PHILIPPINES',
  POLAND = 'POLAND',
  PORTUGAL = 'PORTUGAL',
  QATAR = 'QATAR',
  ROMANIA = 'ROMANIA',
  RUSSIA = 'RUSSIA',
  RWANDA = 'RWANDA',
  SAINT_KITTS_AND_NEVIS = 'SAINT_KITTS_AND_NEVIS',
  SAINT_LUCIA = 'SAINT_LUCIA',
  SAINT_VINCENT_AND_THE_GRENADINES = 'SAINT_VINCENT_AND_THE_GRENADINES',
  SAMOA = 'SAMOA',
  SAN_MARINO = 'SAN_MARINO',
  SAO_TOME_AND_PRINCIPE = 'SAO_TOME_AND_PRINCIPE',
  SAUDI_ARABIA = 'SAUDI_ARABIA',
  SENEGAL = 'SENEGAL',
  SERBIA = 'SERBIA',
  SEYCHELLES = 'SEYCHELLES',
  SIERRA_LEONE = 'SIERRA_LEONE',
  SINGAPORE = 'SINGAPORE',
  SLOVAKIA = 'SLOVAKIA',
  SLOVENIA = 'SLOVENIA',
  SOLOMON_ISLANDS = 'SOLOMON_ISLANDS',
  SOMALIA = 'SOMALIA',
  SOUTH_AFRICA = 'SOUTH_AFRICA',
  SOUTH_KOREA = 'SOUTH_KOREA',
  SOUTH_SUDAN = 'SOUTH_SUDAN',
  SPAIN = 'SPAIN',
  SRI_LANKA = 'SRI_LANKA',
  SUDAN = 'SUDAN',
  SURINAME = 'SURINAME',
  SWEDEN = 'SWEDEN',
  SWITZERLAND = 'SWITZERLAND',
  SYRIA = 'SYRIA',
  TAJIKISTAN = 'TAJIKISTAN',
  TANZANIA = 'TANZANIA',
  THAILAND = 'THAILAND',
  TIMOR_LESTE = 'TIMOR_LESTE',
  TOGO = 'TOGO',
  TONGA = 'TONGA',
  TRINIDAD_AND_TOBAGO = 'TRINIDAD_AND_TOBAGO',
  TUNISIA = 'TUNISIA',
  TURKEY = 'TURKEY',
  TURKMENISTAN = 'TURKMENISTAN',
  TUVALU = 'TUVALU',
  UGANDA = 'UGANDA',
  UKRAINE = 'UKRAINE',
  UNITED_ARAB_EMIRATES = 'UNITED_ARAB_EMIRATES',
  UNITED_KINGDOM = 'UNITED_KINGDOM',
  UNITED_STATES_OF_AMERICA = 'UNITED_STATES_OF_AMERICA',
  URUGUAY = 'URUGUAY',
  UZBEKISTAN = 'UZBEKISTAN',
  VANUATU = 'VANUATU',
  VENEZUELA = 'VENEZUELA',
  VIETNAM = 'VIETNAM',
  YEMEN = 'YEMEN',
  ZAMBIA = 'ZAMBIA',
  ZIMBABWE = 'ZIMBABWE'
}

export type CountryInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  dialCode?: InputMaybe<Scalars['String']['input']>;
  flagSquare?: InputMaybe<PictureInput>;
  flagWide?: InputMaybe<PictureInput>;
  iconFlag?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CountryPaginatedType = {
  __typename?: 'CountryPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CountryType>;
};

export type CountryProviderType = {
  __typename?: 'CountryProviderType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  flag?: Maybe<Scalars['String']['output']>;
  flag64?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CountryType = {
  __typename?: 'CountryType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dialCode?: Maybe<Scalars['String']['output']>;
  flagSquare?: Maybe<PictureType>;
  flagWide?: Maybe<PictureType>;
  iconFlag?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CouponFilterInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<DiscountType>;
  expired?: InputMaybe<Scalars['Boolean']['input']>;
  isOffline?: InputMaybe<Scalars['Boolean']['input']>;
  redeemed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CouponInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  couponPrefix?: InputMaybe<Scalars['String']['input']>;
  discount: DiscountDtoInput;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  isOffline?: InputMaybe<Scalars['Boolean']['input']>;
  max?: InputMaybe<Scalars['String']['input']>;
  min?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CouponNotificationActionType = {
  __typename?: 'CouponNotificationActionType';
  betSlip?: Maybe<Scalars['String']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  credit?: Maybe<Scalars['Decimal']['output']>;
  cycle?: Maybe<LeaderboardCycleEnum>;
  cycleNumber?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<DiscountDtoType>;
  game?: Maybe<GameType>;
  picture?: Maybe<PictureType>;
  rank?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type CouponSettingsInput = {
  amount: Scalars['Decimal']['input'];
  discount: DiscountDtoInput;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<NumberInput>;
  target: TargetAciInput;
};

export type CouponSettingsType = {
  __typename?: 'CouponSettingsType';
  amount: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<DiscountDtoType>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  number?: Maybe<NumberType>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type CouponSimpleType = {
  __typename?: 'CouponSimpleType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<DiscountDtoType>;
  from?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isOffline?: Maybe<Scalars['Boolean']['output']>;
  redeemed?: Maybe<Scalars['Boolean']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type CouponType = {
  __typename?: 'CouponType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<DiscountDtoType>;
  from?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isOffline?: Maybe<Scalars['Boolean']['output']>;
  redeemed?: Maybe<Scalars['Boolean']['output']>;
  target: TargetType;
  to?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type CouponsInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  couponPrefix?: InputMaybe<Scalars['String']['input']>;
  discount: DiscountDtoInput;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  isOffline?: InputMaybe<Scalars['Boolean']['input']>;
  max?: InputMaybe<Scalars['String']['input']>;
  min?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  target: TargetAciInput;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CouponsSettingsType = {
  __typename?: 'CouponsSettingsType';
  enabled: Scalars['Boolean']['output'];
  entries?: Maybe<Array<CouponSimpleType>>;
};

export type CoverageType = {
  __typename?: 'CoverageType';
  fixtures?: Maybe<LeagueFixtureType>;
  injuries?: Maybe<Scalars['Boolean']['output']>;
  odds?: Maybe<Scalars['Boolean']['output']>;
  players?: Maybe<Scalars['Boolean']['output']>;
  predictions?: Maybe<Scalars['Boolean']['output']>;
  standings?: Maybe<Scalars['Boolean']['output']>;
  top_assists?: Maybe<Scalars['Boolean']['output']>;
  top_cards?: Maybe<Scalars['Boolean']['output']>;
  top_scorers?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateCustomInternalProductInput = {
  /** list of barcodes ids */
  barcodes?: InputMaybe<Array<Scalars['ID']['input']>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  catalogueCategory: Array<Scalars['String']['input']>;
  classification?: InputMaybe<Array<ProductClassEnum>>;
  condition?: InputMaybe<ProductConditionEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionList?: InputMaybe<Array<Scalars['String']['input']>>;
  discount?: InputMaybe<DiscountDtoInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Array<ProductFlagEnum>>;
  globalCategory?: InputMaybe<GlobalCategoryInput>;
  internalProductAttributes?: InputMaybe<InternalProductAttributeInput>;
  longdesc?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<Array<PictureInput>>;
  price: Scalars['Decimal']['input'];
  product?: InputMaybe<Scalars['String']['input']>;
  productInput?: InputMaybe<ProductInput>;
  rent?: InputMaybe<Scalars['Boolean']['input']>;
  seo?: InputMaybe<CatalogueCategorySeoInput>;
  sku?: InputMaybe<Scalars['String']['input']>;
  specs?: InputMaybe<Array<ProductSpecsInput>>;
  status?: InputMaybe<ProductStatusEnum>;
  structure?: InputMaybe<ProductStructureEnum>;
  /** list of suppliers ids */
  suppliers?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  target: TargetAciInput;
  translation?: InputMaybe<Array<InternalProductTranslationInput>>;
  url?: InputMaybe<Scalars['String']['input']>;
  variety?: InputMaybe<ProductVarietyEnum>;
};

export type CreateFormInput = {
  description: Scalars['String']['input'];
  owner: FormOwnerInput;
  status?: InputMaybe<FormStatus>;
  title: Scalars['String']['input'];
  type?: InputMaybe<FormType>;
};

export type CreateInternalProductInput = {
  /** list of barcodes ids */
  barcodes?: InputMaybe<Array<Scalars['ID']['input']>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  catalogueCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  classification?: InputMaybe<Array<ProductClassEnum>>;
  condition?: InputMaybe<ProductConditionEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionList?: InputMaybe<Array<Scalars['String']['input']>>;
  discount?: InputMaybe<DiscountDtoInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Array<ProductFlagEnum>>;
  globalCategory?: InputMaybe<GlobalCategoryInput>;
  internalProductAttributes?: InputMaybe<InternalProductAttributeInput>;
  longdesc?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<Array<PictureInput>>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  product: Scalars['String']['input'];
  rent?: InputMaybe<Scalars['Boolean']['input']>;
  seo?: InputMaybe<CatalogueCategorySeoInput>;
  sku?: InputMaybe<Scalars['String']['input']>;
  specs?: InputMaybe<Array<ProductSpecsInput>>;
  status?: InputMaybe<ProductStatusEnum>;
  structure?: InputMaybe<ProductStructureEnum>;
  /** list of suppliers ids */
  suppliers?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  target: TargetAciInput;
  translation?: InputMaybe<Array<InternalProductTranslationInput>>;
  url?: InputMaybe<Scalars['String']['input']>;
  variety?: InputMaybe<ProductVarietyEnum>;
};

export type CreateSimpleProductInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  catalogueCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  classification?: InputMaybe<Array<ProductClassEnum>>;
  condition?: InputMaybe<ProductConditionEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionList?: InputMaybe<Array<Scalars['String']['input']>>;
  discount?: InputMaybe<DiscountDtoInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Array<ProductFlagEnum>>;
  globalCategory?: InputMaybe<GlobalCategoryInput>;
  longdesc?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<Array<PictureInput>>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  rent?: InputMaybe<Scalars['Boolean']['input']>;
  seo?: InputMaybe<CatalogueCategorySeoInput>;
  sku?: InputMaybe<Scalars['String']['input']>;
  specs?: InputMaybe<Array<ProductSpecsInput>>;
  status?: InputMaybe<ProductStatusEnum>;
  structure?: InputMaybe<ProductStructureEnum>;
  /** list of suppliers ids */
  suppliers?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  target: TargetAciInput;
  translation?: InputMaybe<Array<InternalProductTranslationInput>>;
  url?: InputMaybe<Scalars['String']['input']>;
  variety?: InputMaybe<ProductVarietyEnum>;
};

export type CrmAnalyticsBalanceOverviewChartType = {
  __typename?: 'CrmAnalyticsBalanceOverviewChartType';
  data?: Maybe<Array<Scalars['Decimal']['output']>>;
  kind?: Maybe<CrmKindEnum>;
};

export type CrmAnalyticsBalanceOverviewType = {
  __typename?: 'CrmAnalyticsBalanceOverviewType';
  chart?: Maybe<Array<CrmAnalyticsBalanceOverviewChartType>>;
  conversionRate?: Maybe<Scalars['Decimal']['output']>;
  pending?: Maybe<Scalars['Decimal']['output']>;
  revenue?: Maybe<Scalars['Decimal']['output']>;
};

export type CrmAnalyticsDealTypeType = {
  __typename?: 'CrmAnalyticsDealTypeType';
  classification?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

export type CrmAnalyticsSalesForecastType = {
  __typename?: 'CrmAnalyticsSalesForecastType';
  goal?: Maybe<Scalars['Float']['output']>;
  pending?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

export type CrmAnalyticsStatsInfoType = {
  __typename?: 'CrmAnalyticsStatsInfoType';
  dailyIncome?: Maybe<Scalars['Decimal']['output']>;
  leadConversion?: Maybe<Scalars['Decimal']['output']>;
  sent?: Maybe<Scalars['Float']['output']>;
  totalDeals?: Maybe<Scalars['Float']['output']>;
  totalProfit?: Maybe<Scalars['Decimal']['output']>;
};

export enum CrmKindEnum {
  PENDING = 'PENDING',
  REVENUE = 'REVENUE'
}

export type CurrencyIdNameType = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CurrencyInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  flagSquare?: InputMaybe<PictureInput>;
  flagWide?: InputMaybe<PictureInput>;
  iconFlag?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  symbol?: InputMaybe<Scalars['String']['input']>;
};

export type CurrencyPaginatedType = {
  __typename?: 'CurrencyPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CurrencyType>;
};

export type CurrencyType = {
  __typename?: 'CurrencyType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  flagSquare?: Maybe<PictureType>;
  flagWide?: Maybe<PictureType>;
  iconFlag?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  symbol?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CurrentPreviousPercentageType = {
  __typename?: 'CurrentPreviousPercentageType';
  current?: Maybe<Scalars['Decimal']['output']>;
  percentage?: Maybe<Scalars['Decimal']['output']>;
  previous?: Maybe<Scalars['Decimal']['output']>;
};

export type CurrentPreviousType = {
  __typename?: 'CurrentPreviousType';
  current: PriceCountType;
  difference?: Maybe<DifferenceType>;
  previous?: Maybe<PriceCountType>;
};

export type CurrentRewardsFilterInput = {
  /** game code */
  gameCode?: InputMaybe<Scalars['String']['input']>;
  /** game group code */
  gameGroup?: InputMaybe<Scalars['String']['input']>;
  /** game id */
  gameId?: InputMaybe<Scalars['ID']['input']>;
  target: TargetAciInput;
};

export type CurrentUserDailyStatsType = {
  __typename?: 'CurrentUserDailyStatsType';
  currentDay: StatsEntry;
  firstUser: DailyStatsFirstUserType;
  overall: StatsEntry;
};

export type CurrentUserRankType = {
  __typename?: 'CurrentUserRankType';
  closingDate: Scalars['DateTime']['output'];
  credit: Scalars['Decimal']['output'];
  overallCredit: Scalars['Decimal']['output'];
  overallRank: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
};

export type CurrentUserReputationsLossDateType = {
  __typename?: 'CurrentUserReputationsLossDateType';
  lossAmount?: Maybe<Scalars['Int']['output']>;
  lossDate?: Maybe<Scalars['DateTime']['output']>;
};

export type CurrentUserReputationsTurnoverLossDateType = {
  __typename?: 'CurrentUserReputationsTurnoverLossDateType';
  currentPoints?: Maybe<Scalars['Int']['output']>;
  lossAmount?: Maybe<Scalars['Int']['output']>;
  lossDate?: Maybe<Scalars['DateTime']['output']>;
  turnoverPoints?: Maybe<Scalars['Int']['output']>;
};

export type CurrentUserWeeklyStatsType = {
  __typename?: 'CurrentUserWeeklyStatsType';
  currentWeek: StatsEntry;
  firstUser: WeeklyStatsFirstUserType;
  overall: StatsEntry;
};

export type CustomMessageInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CustomMessageType = {
  __typename?: 'CustomMessageType';
  id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum CustomerPhaseEnum {
  CUSTOMER = 'CUSTOMER',
  LEAD = 'LEAD',
  TERMINATION = 'TERMINATION'
}

export type DailyCountType = {
  __typename?: 'DailyCountType';
  date: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type DailyStatsFirstUserType = {
  __typename?: 'DailyStatsFirstUserType';
  currentDay: StatsEntry;
  email: Scalars['String']['output'];
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastname: Scalars['String']['output'];
  picture: Scalars['String']['output'];
};

export enum DashboardEnum {
  ANALYTICS = 'ANALYTICS',
  CAMPAIGNS = 'CAMPAIGNS',
  COLLABORATION = 'COLLABORATION',
  CRM = 'CRM',
  ECOMMERCE = 'ECOMMERCE',
  ENGAGEMENT = 'ENGAGEMENT',
  KYC = 'KYC',
  SALES = 'SALES'
}

export type DateRangeType = {
  __typename?: 'DateRangeType';
  max?: Maybe<Scalars['DateTime']['output']>;
  min?: Maybe<Scalars['DateTime']['output']>;
};

export type DateStatsType = {
  __typename?: 'DateStatsType';
  current: Scalars['Decimal']['output'];
  percentage: Scalars['Decimal']['output'];
  previous: Scalars['Decimal']['output'];
};

export type DateValueChartType = {
  __typename?: 'DateValueChartType';
  chart: Array<Array<Scalars['Float']['output']>>;
};

export enum DayEnum {
  FRIDAY = 'FRIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY'
}

export type DebitorWalletWithStringCoinType = {
  __typename?: 'DebitorWalletWithStringCoinType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  coin?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentReputationLevel?: Maybe<ReputationWithoutTargetType>;
  fee?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  nextReputationLevel?: Maybe<ReputationWithoutTargetType>;
  owner?: Maybe<SimpleTargetWithUserType>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  usage?: Maybe<WalletUsageEnum>;
  walletType?: Maybe<WalletTypeEnum>;
};

export type DeductAmountFromUserInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  card?: InputMaybe<Scalars['String']['input']>;
  game?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<TransactionTypeEnum>;
  target: TargetAciInput;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeductAmountSuccessType = {
  __typename?: 'DeductAmountSuccessType';
  deductedAmount?: Maybe<Scalars['Decimal']['output']>;
  fundsWallet?: Maybe<PushResponseWalletType>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  wallet?: Maybe<PushResponseWalletType>;
};

export type DefaultAudienceInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  /** Segments should only be provided if type is "DYNAMIC". */
  segments?: InputMaybe<Array<AudienceSegmentInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AudienceTypeEnum>;
};

export type DefaultAudiencePaginateType = {
  __typename?: 'DefaultAudiencePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<DefaultAudienceType>;
};

export type DefaultAudienceType = {
  __typename?: 'DefaultAudienceType';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<MediaType>;
  reach?: Maybe<AudienceReachType>;
  segments?: Maybe<Array<AudienceSegmentType>>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AudienceTypeEnum>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DeleteResponseDtoType = {
  __typename?: 'DeleteResponseDtoType';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum DeleteUserReasonEnum {
  LACK_OF_CONTENT = 'LACK_OF_CONTENT',
  SIZE_AND_COMPATIBILITY = 'SIZE_AND_COMPATIBILITY',
  SOMETHING_IS_BROKEN = 'SOMETHING_IS_BROKEN'
}

export type DeliveryZonePathInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  order: Scalars['Float']['input'];
};

export type DeliveryZonePathType = {
  __typename?: 'DeliveryZonePathType';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  order: Scalars['Float']['output'];
};

export type DeliveryZonesInput = {
  category: ZoneTypesCategoryEnum;
  color: Scalars['String']['input'];
  extraFees: Scalars['Decimal']['input'];
  minPrice: Scalars['Decimal']['input'];
  paths: Array<DeliveryZonePathInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  target: TargetAciInput;
  type: ZoneTypesEnum;
};

export type DeliveryZonesType = {
  __typename?: 'DeliveryZonesType';
  category: ZoneTypesCategoryEnum;
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  extraFees?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['ID']['output'];
  minPrice?: Maybe<Scalars['Decimal']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  paths: Array<DeliveryZonePathType>;
  radius?: Maybe<Scalars['Float']['output']>;
  target: TargetType;
  type: ZoneTypesEnum;
  updatedAt: Scalars['DateTime']['output'];
};

export type DepartmentBaseType = {
  __typename?: 'DepartmentBaseType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DepartmentInput = {
  name: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
};

export type DepartmentPaginatedType = {
  __typename?: 'DepartmentPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<DepartmentType>;
};

export type DepartmentType = {
  __typename?: 'DepartmentType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type DeviceBrandLogoInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  png?: InputMaybe<DeviceBrandLogoPngInput>;
  svg?: InputMaybe<PictureInput>;
};

export type DeviceBrandLogoPngInput = {
  default?: InputMaybe<PictureInput>;
  size16?: InputMaybe<PictureInput>;
  size24?: InputMaybe<PictureInput>;
  size32?: InputMaybe<PictureInput>;
  size48?: InputMaybe<PictureInput>;
  size64?: InputMaybe<PictureInput>;
  size128?: InputMaybe<PictureInput>;
  size256?: InputMaybe<PictureInput>;
  size512?: InputMaybe<PictureInput>;
};

export type DeviceBrandLogoPngType = {
  __typename?: 'DeviceBrandLogoPngType';
  default?: Maybe<PictureType>;
  size16?: Maybe<PictureType>;
  size24?: Maybe<PictureType>;
  size32?: Maybe<PictureType>;
  size48?: Maybe<PictureType>;
  size64?: Maybe<PictureType>;
  size128?: Maybe<PictureType>;
  size256?: Maybe<PictureType>;
  size512?: Maybe<PictureType>;
};

export type DeviceBrandLogoType = {
  __typename?: 'DeviceBrandLogoType';
  icon?: Maybe<Scalars['String']['output']>;
  png?: Maybe<DeviceBrandLogoPngType>;
  svg?: Maybe<PictureType>;
};

export type DeviceDataType = {
  __typename?: 'DeviceDataType';
  androidData: AndroidDataType;
  client: ClientDataType;
  device: MachineDataType;
  iosData: IosDataType;
  os: OperatingSystemDataType;
};

export enum DeviceTypeEnum {
  CAMERA = 'CAMERA',
  CAR_BROWSER = 'CAR_BROWSER',
  CONSOLE = 'CONSOLE',
  DESKTOP = 'DESKTOP',
  FEATURE_PHONE = 'FEATURE_PHONE',
  NO_DATA = 'NO_DATA',
  PERIPHERAL = 'PERIPHERAL',
  PHABLET = 'PHABLET',
  PORTABLE_MEDIA_PLAYER = 'PORTABLE_MEDIA_PLAYER',
  SMARTPHONE = 'SMARTPHONE',
  SMART_DISPLAY = 'SMART_DISPLAY',
  SMART_SPEAKER = 'SMART_SPEAKER',
  TABLET = 'TABLET',
  TV = 'TV',
  WEARABLE = 'WEARABLE'
}

export type DifferenceType = {
  __typename?: 'DifferenceType';
  count?: Maybe<AmountPercentageDecimalType>;
  price?: Maybe<AmountPercentageDecimalType>;
};

export type DirectMessageInput = {
  custom?: InputMaybe<CustomMessageInput>;
  gif?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LonLatInput>;
  media?: InputMaybe<MessageMediaInput>;
  receiver: Scalars['ID']['input'];
  seenBy?: InputMaybe<Array<Scalars['ID']['input']>>;
  sticker?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<TargetAciInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MessageGroupTypeEnum>;
};

export type DiscountDtoInput = {
  amount: Scalars['Decimal']['input'];
  discountType: DiscountType;
};

export type DiscountDtoType = {
  __typename?: 'DiscountDtoType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  discountType?: Maybe<DiscountType>;
};

export enum DiscountType {
  AMOUNT = 'AMOUNT',
  PERCENTAGE = 'PERCENTAGE'
}

export type DocumentContentInput = {
  base64?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['ID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentContentType = {
  __typename?: 'DocumentContentType';
  base64?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ContentTypeType>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DocumentInput = {
  content?: InputMaybe<DocumentContentInput>;
  name: Scalars['String']['input'];
  owner?: InputMaybe<Scalars['ID']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
};

export type DocumentPaginatedType = {
  __typename?: 'DocumentPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<DocumentType>;
};

export enum DocumentReferenceModelEnum {
  WITHOUT_PREFIX = 'WITHOUT_PREFIX',
  WITH_DATE = 'WITH_DATE',
  WITH_DATE_WITHOUT_HYPHEN = 'WITH_DATE_WITHOUT_HYPHEN',
  WITH_PREFIX = 'WITH_PREFIX',
  WITH_PREFIX_AND_DATE = 'WITH_PREFIX_AND_DATE'
}

export type DocumentResultType = {
  __typename?: 'DocumentResultType';
  doc?: Maybe<Scalars['String']['output']>;
};

export type DocumentType = {
  __typename?: 'DocumentType';
  content?: Maybe<DocumentContentType>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner?: Maybe<UserType>;
  size?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type EcommerceAnalyticsBestSellerPaginatedType = {
  __typename?: 'EcommerceAnalyticsBestSellerPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<EcommerceAnalyticsBestSellerType>;
};

export type EcommerceAnalyticsBestSellerType = {
  __typename?: 'EcommerceAnalyticsBestSellerType';
  amount: Scalars['Decimal']['output'];
  barcode: BarcodeType;
  orders: Scalars['Decimal']['output'];
  stock: Scalars['Decimal']['output'];
};

export type EcommerceVarietyDashboardInput = {
  from: Scalars['DateTime']['input'];
  target?: InputMaybe<TargetAciInput>;
  to: Scalars['DateTime']['input'];
  variety?: InputMaybe<ProductVarietyEnum>;
};

export type EmailContentInput = {
  base64?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
};

export type EmailIntegrationInput = {
  server?: InputMaybe<EmailIntegrationServerInput>;
  target?: InputMaybe<TargetAciInput>;
};

export type EmailIntegrationServerAuthInput = {
  pass?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type EmailIntegrationServerAuthType = {
  __typename?: 'EmailIntegrationServerAuthType';
  pass?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type EmailIntegrationServerInput = {
  auth?: InputMaybe<EmailIntegrationServerAuthInput>;
  host?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  secure?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmailIntegrationServerType = {
  __typename?: 'EmailIntegrationServerType';
  auth?: Maybe<EmailIntegrationServerAuthType>;
  host?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['Int']['output']>;
  secure?: Maybe<Scalars['Boolean']['output']>;
};

export type EmailIntegrationType = {
  __typename?: 'EmailIntegrationType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  server?: Maybe<EmailIntegrationServerType>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type EmailTempInput = {
  attachments?: InputMaybe<Array<MailAttachmentInput>>;
  content?: InputMaybe<EmailContentInput>;
  subject: Scalars['String']['input'];
  template?: InputMaybe<EmailTemplateTypeEnum>;
  to: Array<Scalars['String']['input']>;
  variables?: InputMaybe<EmailTempVariablesInput>;
};

export type EmailTempVariablesBrandInput = {
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type EmailTempVariablesCompanyInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type EmailTempVariablesDocumentInput = {
  category: SequenceCategoryEnum;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type EmailTempVariablesInput = {
  actionUrl?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<EmailTempVariablesBrandInput>;
  company?: InputMaybe<EmailTempVariablesCompanyInput>;
  document?: InputMaybe<EmailTempVariablesDocumentInput>;
  user?: InputMaybe<EmailTempVariablesUserInput>;
  variables?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EmailTempVariablesUserInput = {
  billingAddress?: InputMaybe<FullAddressInput>;
  deliveryAddress?: InputMaybe<FullAddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type EmailTemplateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: EmailTemplateTypeEnum;
};

export type EmailTemplateType = {
  __typename?: 'EmailTemplateType';
  color?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name: EmailTemplateTypeEnum;
};

export enum EmailTemplateTypeEnum {
  ARTICLE_CANCELED = 'ARTICLE_CANCELED',
  ARTICLE_CONFIRMED = 'ARTICLE_CONFIRMED',
  ARTICLE_DELIVERED = 'ARTICLE_DELIVERED',
  ARTICLE_READY_FOR_PICKUP = 'ARTICLE_READY_FOR_PICKUP',
  BLOG = 'BLOG',
  CONFIRM_PASSWORD = 'CONFIRM_PASSWORD',
  CONTACT_REQUEST = 'CONTACT_REQUEST',
  DEMO_BOOKING = 'DEMO_BOOKING',
  DOCUMENT = 'DOCUMENT',
  EXPORT = 'EXPORT',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  FORM_EXPORT = 'FORM_EXPORT',
  INVOICE = 'INVOICE',
  LINK_ACCOUNT = 'LINK_ACCOUNT',
  MERGE_ACCOUNTS = 'MERGE_ACCOUNTS',
  NEWSLETTER = 'NEWSLETTER',
  OTHER = 'OTHER',
  PARTNERSHIP_REFERRAL = 'PARTNERSHIP_REFERRAL',
  PARTNERSHIP_REQUEST = 'PARTNERSHIP_REQUEST',
  PAYMENT_CONFIRMED = 'PAYMENT_CONFIRMED',
  PAYMENT_DECLINED = 'PAYMENT_DECLINED',
  POS_CONTACT_REQUEST = 'POS_CONTACT_REQUEST',
  PROMOTION = 'PROMOTION',
  STYLE = 'STYLE',
  SUBSCRIPTION = 'SUBSCRIPTION',
  TABLE_GUIDANCE = 'TABLE_GUIDANCE',
  VALIDATE_EMAIL = 'VALIDATE_EMAIL',
  WELCOME_USER = 'WELCOME_USER'
}

export type EnableableFieldInput = {
  enable: Scalars['Boolean']['input'];
};

export type EnableableFieldType = {
  __typename?: 'EnableableFieldType';
  enable: Scalars['Boolean']['output'];
};

export enum ErpElementsEnum {
  CONTACTS = 'CONTACTS',
  CUSTOMERS = 'CUSTOMERS',
  EQUIPMENTS = 'EQUIPMENTS',
  PRODUCTS = 'PRODUCTS',
  PURCHASE_DELIVERY_NOTES = 'PURCHASE_DELIVERY_NOTES',
  PURCHASE_INVOICES = 'PURCHASE_INVOICES',
  PURCHASE_ORDERS = 'PURCHASE_ORDERS',
  QUOTATIONS = 'QUOTATIONS',
  SALE_DELIVERY_NOTES = 'SALE_DELIVERY_NOTES',
  SALE_INVOICES = 'SALE_INVOICES',
  SALE_ISSUE_NOTES = 'SALE_ISSUE_NOTES',
  SALE_ORDERS = 'SALE_ORDERS',
  SERVICES = 'SERVICES',
  SUPPLIERS = 'SUPPLIERS'
}

export enum ErpIntegrationCycleEnum {
  DAILY = 'DAILY',
  HOURLY = 'HOURLY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY'
}

export type ErpIntegrationEventType = {
  __typename?: 'ErpIntegrationEventType';
  active: Scalars['Boolean']['output'];
  event: ErpElementsEnum;
};

export type ErpIntegrationType = {
  __typename?: 'ErpIntegrationType';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  events: Array<ErpIntegrationEventType>;
  id: Scalars['ID']['output'];
  password?: Maybe<Scalars['String']['output']>;
  recurrence: ErpIntegrationCycleEnum;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
  vendor: ErpVendorEnum;
};

export type ErpIntegrationUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  recurrence?: InputMaybe<ErpIntegrationCycleEnum>;
  target?: InputMaybe<TargetAciInput>;
  url?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<ErpVendorEnum>;
};

export enum ErpVendorEnum {
  ODOO = 'ODOO',
  SAGE = 'SAGE',
  SAP = 'SAP'
}

export type EventDurationInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<PeriodCycleEnum>;
};

export type EventDurationType = {
  __typename?: 'EventDurationType';
  amount?: Maybe<Scalars['Int']['output']>;
  unit?: Maybe<PeriodCycleEnum>;
};

export type EventInput = {
  code: Scalars['String']['input'];
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<EventDurationInput>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  emailTemplate?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  segments?: InputMaybe<Array<EventSegmentInput>>;
  target: TargetAciInput;
  ticketBundles?: InputMaybe<Array<EventTicketBundleInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Array<EventTranslationInput>>;
};

export type EventInviteFilterInput = {
  program?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<EventInviteStatusEnum>;
  target?: InputMaybe<TargetAciInput>;
  user?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type EventInviteInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  program?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<EventInviteStatusEnum>;
  target: TargetAciInput;
  title?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type EventInvitePaginateType = {
  __typename?: 'EventInvitePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<EventInviteType>;
};

export enum EventInviteStatusEnum {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export type EventInviteType = {
  __typename?: 'EventInviteType';
  createdAt: Scalars['DateTime']['output'];
  from?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invitee: UserType;
  invitor: EventInvitorType;
  status: EventInviteStatusEnum;
  target?: Maybe<TargetType>;
  title: Scalars['String']['output'];
  to?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type EventInviteUpdateInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  invitee?: InputMaybe<Scalars['ID']['input']>;
  invitor?: InputMaybe<EventInvitorInput>;
  program?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EventInvitorInput = {
  program?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type EventInvitorType = {
  __typename?: 'EventInvitorType';
  program?: Maybe<ProgramType>;
  user?: Maybe<UserType>;
};

export type EventLogBaseType = {
  __typename?: 'EventLogBaseType';
  barcode?: Maybe<BarcodeType>;
  coupon?: Maybe<CouponType>;
  email?: Maybe<Scalars['String']['output']>;
  event: ActionTypeEnum;
  fields?: Maybe<Array<Scalars['String']['output']>>;
  order?: Maybe<MarketPlaceOrderDtoType>;
  phone?: Maybe<IPhoneType>;
  productRating?: Maybe<CorporateRatingType>;
  products?: Maybe<Array<EventLogProductType>>;
  source: UserEventsSourceEnum;
  target: TargetType;
  user?: Maybe<UserType>;
};

export type EventLogPaginateType = {
  __typename?: 'EventLogPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<EventLogType>;
};

export type EventLogProductType = {
  __typename?: 'EventLogProductType';
  barcode: BarcodeType;
  quantity: Scalars['Int']['output'];
};

export type EventLogType = {
  __typename?: 'EventLogType';
  barcode?: Maybe<BarcodeType>;
  coupon?: Maybe<CouponType>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  event: ActionTypeEnum;
  fields?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  order?: Maybe<MarketPlaceOrderDtoType>;
  phone?: Maybe<IPhoneType>;
  productRating?: Maybe<CorporateRatingType>;
  products?: Maybe<Array<EventLogProductType>>;
  source: UserEventsSourceEnum;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type EventPaginateType = {
  __typename?: 'EventPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<EventType>;
};

export enum EventProgramStatusEnum {
  AVAILABLE = 'AVAILABLE',
  CLOSED = 'CLOSED'
}

export type EventSegmentInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Array<EventSegmentTranslateInput>>;
};

export type EventSegmentTranslateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EventSegmentType = {
  __typename?: 'EventSegmentType';
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  title?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Array<EventSegmentsTranslationType>>;
};

export type EventSegmentsTranslationType = {
  __typename?: 'EventSegmentsTranslationType';
  description?: Maybe<Scalars['String']['output']>;
  language?: Maybe<LanguageType>;
  title?: Maybe<Scalars['String']['output']>;
};

export type EventSubscriptionType = {
  __typename?: 'EventSubscriptionType';
  createdAt: Scalars['DateTime']['output'];
  fixture: FixtureType;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type EventTicketBundleInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  price: Scalars['Decimal']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  zone?: InputMaybe<Scalars['String']['input']>;
};

export type EventTicketBundleType = {
  __typename?: 'EventTicketBundleType';
  from?: Maybe<Scalars['DateTime']['output']>;
  price: Scalars['Decimal']['output'];
  title?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
  zone?: Maybe<Scalars['String']['output']>;
};

export type EventTicketFilterInput = {
  event?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Array<EventTicketStatusEnum>>;
  target?: InputMaybe<TargetAciInput>;
  user?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type EventTicketInput = {
  email: Scalars['String']['input'];
  event: Scalars['ID']['input'];
  price?: InputMaybe<Scalars['Decimal']['input']>;
  sendEmail?: Scalars['Boolean']['input'];
  status: EventTicketStatusEnum;
  target: TargetAciInput;
  title?: InputMaybe<Scalars['String']['input']>;
  users: Array<EventTicketUserInput>;
  validity: EventTicketValidityInput;
  zone?: InputMaybe<Scalars['String']['input']>;
};

export type EventTicketPaginateType = {
  __typename?: 'EventTicketPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<EventTicketType>;
};

export enum EventTicketStatusEnum {
  ATTENDED = 'ATTENDED',
  OPEN = 'OPEN',
  PAID = 'PAID'
}

export type EventTicketType = {
  __typename?: 'EventTicketType';
  createdAt: Scalars['DateTime']['output'];
  event: EventType;
  id: Scalars['ID']['output'];
  price?: Maybe<Scalars['Decimal']['output']>;
  reference: Scalars['String']['output'];
  status: EventTicketStatusEnum;
  target?: Maybe<TargetType>;
  ticketUser: EventTicketUserType;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
  validity: EventTicketValidityType;
  zone?: Maybe<Scalars['String']['output']>;
};

export type EventTicketUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<EventTicketUserInput>>;
  validity?: InputMaybe<EventTicketValidityInput>;
  zone?: InputMaybe<Scalars['String']['input']>;
};

export type EventTicketUserInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type EventTicketUserType = {
  __typename?: 'EventTicketUserType';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type EventTicketValidityInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EventTicketValidityType = {
  __typename?: 'EventTicketValidityType';
  from?: Maybe<Scalars['DateTime']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
};

export type EventTranslationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  emailTemplate?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EventTranslationType = {
  __typename?: 'EventTranslationType';
  description?: Maybe<Scalars['String']['output']>;
  emailSubject?: Maybe<Scalars['String']['output']>;
  emailTemplate?: Maybe<Scalars['String']['output']>;
  language?: Maybe<LanguageType>;
  title?: Maybe<Scalars['String']['output']>;
};

export type EventType = {
  __typename?: 'EventType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<EventDurationType>;
  emailSubject?: Maybe<Scalars['String']['output']>;
  emailTemplate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  picture?: Maybe<PictureType>;
  segments?: Maybe<Array<EventSegmentType>>;
  target?: Maybe<TargetType>;
  ticketBundles?: Maybe<Array<EventTicketBundleType>>;
  title?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Array<EventTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum EventTypeEnum {
  ADHOC_NOTIFICATION = 'ADHOC_NOTIFICATION',
  APP_LOG = 'APP_LOG',
  BET_LOST = 'BET_LOST',
  BET_WON = 'BET_WON',
  BOOKING_CANCELLED_BY_CONSUMER = 'BOOKING_CANCELLED_BY_CONSUMER',
  BOOKING_CANCELLED_BY_POS = 'BOOKING_CANCELLED_BY_POS',
  BOOKING_CONFIRMED = 'BOOKING_CONFIRMED',
  BOOKING_CREATED = 'BOOKING_CREATED',
  CALL_WAITER_FOR_CHECK = 'CALL_WAITER_FOR_CHECK',
  CHALLENGE_WON = 'CHALLENGE_WON',
  DEAL_CONFIRMED = 'DEAL_CONFIRMED',
  DELIVERY_MAN_ASSIGNED = 'DELIVERY_MAN_ASSIGNED',
  ORDER_CREATED = 'ORDER_CREATED',
  OUTBOUND_WIDGET = 'OUTBOUND_WIDGET',
  PRODUCT_CANCELLED = 'PRODUCT_CANCELLED',
  PRODUCT_PAYMENT_STATUS_UPDATED = 'PRODUCT_PAYMENT_STATUS_UPDATED',
  PRODUCT_STATUS_UPDATED = 'PRODUCT_STATUS_UPDATED',
  PUSH_AMOUNT = 'PUSH_AMOUNT',
  QUEST_ACTIVITY_FULFILLED = 'QUEST_ACTIVITY_FULFILLED',
  QUEST_FULFILLED = 'QUEST_FULFILLED',
  REDEEM = 'REDEEM',
  REPUTATION_ALMOST_LOST = 'REPUTATION_ALMOST_LOST',
  REPUTATION_LOST = 'REPUTATION_LOST',
  REWARD = 'REWARD',
  SUBSCRIPTION_APPROVED = 'SUBSCRIPTION_APPROVED',
  SUBSCRIPTION_REJECTED = 'SUBSCRIPTION_REJECTED',
  SUBSCRIPTION_REQUESTED = 'SUBSCRIPTION_REQUESTED',
  TURNOVER_ALMOST_LOST = 'TURNOVER_ALMOST_LOST',
  TURNOVER_LOST = 'TURNOVER_LOST',
  TURNOVER_MAINTAINED = 'TURNOVER_MAINTAINED',
  WAITER_CALLED = 'WAITER_CALLED',
  WALLET_TOPUP = 'WALLET_TOPUP',
  WALLET_TOPUP_CONFIRMED = 'WALLET_TOPUP_CONFIRMED',
  WALLET_TOPUP_DELIVERED = 'WALLET_TOPUP_DELIVERED'
}

export type EventUpdateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<EventDurationInput>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  emailTemplate?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  segments?: InputMaybe<Array<EventSegmentInput>>;
  ticketBundles?: InputMaybe<Array<EventTicketBundleInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Array<EventTranslationInput>>;
};

export type EventsPlayerType = {
  __typename?: 'EventsPlayerType';
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type EventsTeamType = {
  __typename?: 'EventsTeamType';
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type EventsTimeType = {
  __typename?: 'EventsTimeType';
  elapsed?: Maybe<Scalars['Float']['output']>;
  extra?: Maybe<Scalars['Float']['output']>;
};

export type EventsType = {
  __typename?: 'EventsType';
  assist?: Maybe<EventsPlayerType>;
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  detail?: Maybe<Scalars['String']['output']>;
  fixture?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  player?: Maybe<EventsPlayerType>;
  team?: Maybe<EventsTeamType>;
  time?: Maybe<EventsTimeType>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ExplanationAiType = {
  __typename?: 'ExplanationAiType';
  ar?: Maybe<Scalars['String']['output']>;
  de?: Maybe<Scalars['String']['output']>;
  en?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
};

export type ExternalIdType = {
  __typename?: 'ExternalIdType';
  reference?: Maybe<Scalars['String']['output']>;
  target?: Maybe<TargetType>;
};

export type FbCatalogSyncAttributesInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  ageGroup?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['Boolean']['input']>;
  gender?: InputMaybe<Scalars['Boolean']['input']>;
  material?: InputMaybe<Scalars['Boolean']['input']>;
  pattern?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FbCatalogSyncAttributesType = {
  __typename?: 'FBCatalogSyncAttributesType';
  active: Scalars['Boolean']['output'];
  ageGroup: Scalars['Boolean']['output'];
  color: Scalars['Boolean']['output'];
  gender: Scalars['Boolean']['output'];
  material: Scalars['Boolean']['output'];
  pattern: Scalars['Boolean']['output'];
  size: Scalars['Boolean']['output'];
};

export type FbCatalogSyncShippingInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
};

export type FbCatalogSyncShippingType = {
  __typename?: 'FBCatalogSyncShippingType';
  active: Scalars['Boolean']['output'];
  country?: Maybe<CountryType>;
  price?: Maybe<Scalars['Decimal']['output']>;
  service?: Maybe<Scalars['String']['output']>;
};

export type FbCatalogSyncType = {
  __typename?: 'FBCatalogSyncType';
  attributes?: Maybe<FbCatalogSyncAttributesType>;
  createdAt: Scalars['DateTime']['output'];
  fbCategory?: Maybe<Scalars['Boolean']['output']>;
  googleCategory?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  sale?: Maybe<Scalars['Boolean']['output']>;
  sell?: Maybe<Scalars['Boolean']['output']>;
  shipping?: Maybe<FbCatalogSyncShippingType>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type FbCatalogSyncUpdateInput = {
  attributes?: InputMaybe<FbCatalogSyncAttributesInput>;
  fbCategory?: InputMaybe<Scalars['Boolean']['input']>;
  googleCategory?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  sale?: InputMaybe<Scalars['Boolean']['input']>;
  sell?: InputMaybe<Scalars['Boolean']['input']>;
  shipping?: InputMaybe<FbCatalogSyncShippingInput>;
};

export type FbPixelEventDataAddPaymentInfoInput = {
  shoppingCart: Scalars['ID']['input'];
};

export type FbPixelEventDataAddToCartInfoInput = {
  product: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type FbPixelEventDataAddToWishlistInfoInput = {
  product: Scalars['ID']['input'];
};

export type FbPixelEventDataCompleteRegistrationInfoInput = {
  status: Scalars['Boolean']['input'];
};

export type FbPixelEventDataInititeCheckoutInfoInput = {
  shoppingCart: Scalars['ID']['input'];
};

export type FbPixelEventDataInput = {
  AddPaymentInfo?: InputMaybe<FbPixelEventDataAddPaymentInfoInput>;
  AddToCart?: InputMaybe<FbPixelEventDataAddToCartInfoInput>;
  AddToWishlist?: InputMaybe<FbPixelEventDataAddToWishlistInfoInput>;
  CompleteRegistration?: InputMaybe<FbPixelEventDataCompleteRegistrationInfoInput>;
  InitiateCheckout?: InputMaybe<FbPixelEventDataInititeCheckoutInfoInput>;
  Lead?: InputMaybe<FbPixelEventDataLeadInfoInput>;
  Purchase?: InputMaybe<FbPixelEventDataInititeCheckoutInfoInput>;
  Search?: InputMaybe<FbPixelEventDataSearchInfoInput>;
  StartTrial?: InputMaybe<FbPixelEventDataTrialSubInfoInput>;
  Subscribe?: InputMaybe<FbPixelEventDataTrialSubInfoInput>;
  ViewContent?: InputMaybe<FbPixelEventDataViewContentInfoInput>;
};

export type FbPixelEventDataLeadInfoInput = {
  name: Scalars['String']['input'];
};

export type FbPixelEventDataSearchInfoInput = {
  category: Scalars['String']['input'];
  searchString: Scalars['String']['input'];
};

export type FbPixelEventDataTrialSubInfoInput = {
  currency: Scalars['String']['input'];
  predicted_ltv: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type FbPixelEventDataViewContentInfoInput = {
  page?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
};

export type FbPixelEventType = {
  __typename?: 'FBPixelEventType';
  active: Scalars['Boolean']['output'];
  event: PixelRecommendedEventsEnum;
};

export type FbPixelType = {
  __typename?: 'FBPixelType';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  events: Array<FbPixelEventType>;
  id: Scalars['ID']['output'];
  pixelId: Scalars['String']['output'];
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type FbPixelUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  pixelId?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<TargetAciInput>;
};

export type FacebookDataType = {
  __typename?: 'FacebookDataType';
  email: Scalars['String']['output'];
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export type FacebookProfileAuditDataType = {
  __typename?: 'FacebookProfileAuditDataType';
  address?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Array<Scalars['String']['output']>>;
  checkins?: Maybe<Scalars['String']['output']>;
  delivery_options?: Maybe<Scalars['String']['output']>;
  delivery_settings?: Maybe<FacebookProfileAuditDeliverySettingsType>;
  email?: Maybe<Scalars['String']['output']>;
  formatted_cuisines?: Maybe<Scalars['String']['output']>;
  impressum?: Maybe<Array<Scalars['String']['output']>>;
  info?: Maybe<Array<Scalars['String']['output']>>;
  instagram?: Maybe<Scalars['String']['output']>;
  is_delegate_page_with_linked_profile?: Maybe<Scalars['Boolean']['output']>;
  likes?: Maybe<Scalars['Float']['output']>;
  menu?: Maybe<FacebookProfileAuditMenuType>;
  messenger?: Maybe<Scalars['String']['output']>;
  mission?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  overview?: Maybe<Array<Scalars['String']['output']>>;
  pageId?: Maybe<Scalars['String']['output']>;
  pageName?: Maybe<Scalars['String']['output']>;
  pageUrl?: Maybe<Scalars['String']['output']>;
  payment?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  posts?: Maybe<Array<FacebookProfilePostsType>>;
  priceRange?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Scalars['String']['output']>>;
  rating?: Maybe<Scalars['String']['output']>;
  reviews?: Maybe<Array<FacebookProfileAuditReviewType>>;
  services?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  transit?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  wifi?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type FacebookProfileAuditDeliverySettingsType = {
  __typename?: 'FacebookProfileAuditDeliverySettingsType';
  delivery_details?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type FacebookProfileAuditMenuImagesPhotosImageType = {
  __typename?: 'FacebookProfileAuditMenuImagesPhotosImageType';
  height?: Maybe<Scalars['Float']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type FacebookProfileAuditMenuImagesPhotosOwnerType = {
  __typename?: 'FacebookProfileAuditMenuImagesPhotosOwnerType';
  additional_profile_has_taggable_products?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type FacebookProfileAuditMenuImagesPhotosType = {
  __typename?: 'FacebookProfileAuditMenuImagesPhotosType';
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<FacebookProfileAuditMenuImagesPhotosImageType>;
  isPlayable?: Maybe<Scalars['Boolean']['output']>;
  likes?: Maybe<Scalars['Float']['output']>;
  ocrText?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<FacebookProfileAuditMenuImagesPhotosOwnerType>;
  timestamp?: Maybe<Scalars['Float']['output']>;
};

export type FacebookProfileAuditMenuImagesType = {
  __typename?: 'FacebookProfileAuditMenuImagesType';
  id?: Maybe<Scalars['String']['output']>;
  menu_image_title?: Maybe<Scalars['String']['output']>;
  menu_photo?: Maybe<FacebookProfileAuditMenuImagesPhotosType>;
};

export type FacebookProfileAuditMenuType = {
  __typename?: 'FacebookProfileAuditMenuType';
  id?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<FacebookProfileAuditMenuImagesType>>;
  share_page_menu_link?: Maybe<Scalars['String']['output']>;
  structured_menu_program?: Maybe<Scalars['String']['output']>;
};

export type FacebookProfileAuditReviewType = {
  __typename?: 'FacebookProfileAuditReviewType';
  commentsCount?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  legacyId?: Maybe<Scalars['String']['output']>;
  likesCount?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  user?: Maybe<FacebookProfileAuditReviewUserType>;
};

export type FacebookProfileAuditReviewUserType = {
  __typename?: 'FacebookProfileAuditReviewUserType';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profilePic?: Maybe<Scalars['String']['output']>;
  profileUrl?: Maybe<Scalars['String']['output']>;
};

export type FacebookProfilePostsCommentsType = {
  __typename?: 'FacebookProfilePostsCommentsType';
  count?: Maybe<Scalars['Float']['output']>;
};

export type FacebookProfilePostsStatsType = {
  __typename?: 'FacebookProfilePostsStatsType';
  comments?: Maybe<Scalars['Float']['output']>;
  likes?: Maybe<Scalars['Float']['output']>;
  shares?: Maybe<Scalars['Float']['output']>;
};

export type FacebookProfilePostsType = {
  __typename?: 'FacebookProfilePostsType';
  alt?: Maybe<Scalars['String']['output']>;
  postComments?: Maybe<FacebookProfilePostsCommentsType>;
  postDate?: Maybe<Scalars['DateTime']['output']>;
  postId?: Maybe<Scalars['String']['output']>;
  postLinks?: Maybe<Array<Scalars['String']['output']>>;
  postStats?: Maybe<FacebookProfilePostsStatsType>;
  postText?: Maybe<Scalars['String']['output']>;
  postUrl?: Maybe<Scalars['String']['output']>;
  postsImages?: Maybe<Array<Scalars['String']['output']>>;
  timestamp?: Maybe<Scalars['Float']['output']>;
};

export type FavoriteInternalProductInput = {
  product?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type FavoriteInternalProductType = {
  __typename?: 'FavoriteInternalProductType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  products?: Maybe<Array<InternalProductType>>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type FavoriteLeagueDefinitionType = {
  __typename?: 'FavoriteLeagueDefinitionType';
  createdAt: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  league?: Maybe<LeagueType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FavoriteLeagueType = {
  __typename?: 'FavoriteLeagueType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  league: LeagueType;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type FavoriteProductInput = {
  product?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type FavoriteProductType = {
  __typename?: 'FavoriteProductType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  products?: Maybe<Array<ProductType>>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type FavoriteTeamDefinitionType = {
  __typename?: 'FavoriteTeamDefinitionType';
  createdAt: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  teamInformation?: Maybe<TeamInformationType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FavoriteTeamType = {
  __typename?: 'FavoriteTeamType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  team: TeamInformationType;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type FcmAndroidDataType = {
  __typename?: 'FcmAndroidDataType';
  androidId?: Maybe<Scalars['String']['output']>;
  board?: Maybe<Scalars['String']['output']>;
  bootloader?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  display?: Maybe<Scalars['String']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  hardware?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isPhysicalDevice?: Maybe<Scalars['Boolean']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  supported32BitAbis?: Maybe<Array<Scalars['String']['output']>>;
  supported64BitAbis?: Maybe<Array<Scalars['String']['output']>>;
  supportedAbis?: Maybe<Array<Scalars['String']['output']>>;
  systemFeatures?: Maybe<Array<Scalars['String']['output']>>;
  tags?: Maybe<Scalars['String']['output']>;
  versionBaseOS?: Maybe<Scalars['String']['output']>;
  versionCodename?: Maybe<Scalars['String']['output']>;
  versionIncremental?: Maybe<Scalars['String']['output']>;
  versionPreviewSdkInt?: Maybe<Scalars['Float']['output']>;
  versionRelease?: Maybe<Scalars['String']['output']>;
  versionSdkInt?: Maybe<Scalars['Float']['output']>;
  versionSecurityPatch?: Maybe<Scalars['String']['output']>;
};

export type FcmClientType = {
  __typename?: 'FcmClientType';
  clientType?: Maybe<Scalars['String']['output']>;
  engine?: Maybe<Scalars['String']['output']>;
  engineVersion?: Maybe<Scalars['String']['output']>;
  family?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type FcmDeviceDataType = {
  __typename?: 'FcmDeviceDataType';
  androidData?: Maybe<FcmAndroidDataType>;
  client?: Maybe<FcmClientType>;
  device?: Maybe<FcmDeviceType>;
  iosData?: Maybe<FcmIosDataType>;
  os?: Maybe<FcmOsType>;
};

export type FcmDeviceType = {
  __typename?: 'FcmDeviceType';
  brand?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
};

export type FcmIosDataType = {
  __typename?: 'FcmIosDataType';
  identifierForVendor?: Maybe<Scalars['String']['output']>;
  isPhysicalDevice?: Maybe<Scalars['Boolean']['output']>;
  localizedModel?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  systemName?: Maybe<Scalars['String']['output']>;
  systemVersion?: Maybe<Scalars['String']['output']>;
  utsnameMachine?: Maybe<Scalars['String']['output']>;
  utsnameNodename?: Maybe<Scalars['String']['output']>;
  utsnameRelease?: Maybe<Scalars['String']['output']>;
  utsnameSysname?: Maybe<Scalars['String']['output']>;
  utsnameVersion?: Maybe<Scalars['String']['output']>;
};

export type FcmOsType = {
  __typename?: 'FcmOsType';
  family?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type FcmTokenType = {
  __typename?: 'FcmTokenType';
  deviceData: FcmDeviceDataType;
  token: Scalars['String']['output'];
};

export type FeaturedCorporateInput = {
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  pos?: InputMaybe<Scalars['String']['input']>;
  rank: Scalars['Int']['input'];
  wholesaler?: InputMaybe<Scalars['String']['input']>;
};

export type FeaturedCorporatePaginateType = {
  __typename?: 'FeaturedCorporatePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<FeaturedCorporateType>;
};

export enum FeaturedCorporateTargetEnum {
  MANUFACTURER = 'manufacturer',
  POS = 'pos',
  WHOLESALER = 'wholesaler'
}

export type FeaturedCorporateType = {
  __typename?: 'FeaturedCorporateType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  manufacturer?: Maybe<ManufacturerType>;
  pos?: Maybe<PointOfSaleType>;
  rank: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  wholesaler?: Maybe<WholesalerType>;
};

export type FigamyIntegratioConverterType = {
  __typename?: 'FigamyIntegratioConverterType';
  active: Scalars['Boolean']['output'];
  rate?: Maybe<Scalars['String']['output']>;
};

export type FigamyIntegratioMarketplaceType = {
  __typename?: 'FigamyIntegratioMarketplaceType';
  active?: Maybe<Scalars['Boolean']['output']>;
  comission?: Maybe<Scalars['String']['output']>;
  paymentCycle?: Maybe<RecurrenceType>;
};

export type FigamyIntegrationAuthType = {
  __typename?: 'FigamyIntegrationAuthType';
  publicKey?: Maybe<Scalars['String']['output']>;
  secretKey?: Maybe<Scalars['String']['output']>;
};

export type FigamyIntegrationAuthenticationLoginType = {
  __typename?: 'FigamyIntegrationAuthenticationLoginType';
  active: Scalars['Boolean']['output'];
};

export type FigamyIntegrationAuthenticationType = {
  __typename?: 'FigamyIntegrationAuthenticationType';
  active: Scalars['Boolean']['output'];
  appAuth?: Maybe<FigamyIntegrationAuthType>;
  figamyAuth?: Maybe<FigamyIntegrationAuthType>;
  login?: Maybe<FigamyIntegrationAuthenticationLoginType>;
};

export type FigamyIntegrationCatalogType = {
  __typename?: 'FigamyIntegrationCatalogType';
  active: Scalars['Boolean']['output'];
  auth?: Maybe<FigamyIntegrationAuthType>;
  sale: Scalars['Boolean']['output'];
  sell: Scalars['Boolean']['output'];
  shipping: Scalars['Boolean']['output'];
  syncTime?: Maybe<RecurrenceType>;
};

export type FigamyIntegrationDealsType = {
  __typename?: 'FigamyIntegrationDealsType';
  active: Scalars['Boolean']['output'];
  monthlyAmount?: Maybe<Scalars['String']['output']>;
  selfManaging: Scalars['Boolean']['output'];
};

export type FigamyIntegrationWalletReputationType = {
  __typename?: 'FigamyIntegrationWalletReputationType';
  active: Scalars['Boolean']['output'];
  inactivityCycle: Scalars['Boolean']['output'];
  lossAmount: Scalars['Boolean']['output'];
  perks: Scalars['Boolean']['output'];
};

export type FigamyIntegrationWalletType = {
  __typename?: 'FigamyIntegrationWalletType';
  active: Scalars['Boolean']['output'];
  qualitative?: Maybe<FigamyIntegrationAuthenticationLoginType>;
  quantitative?: Maybe<FigamyIntegrationAuthenticationLoginType>;
  reputation?: Maybe<FigamyIntegrationWalletReputationType>;
};

export type FilterLabelFieldType = {
  __typename?: 'FilterLabelFieldType';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type FilterNameFieldType = {
  __typename?: 'FilterNameFieldType';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type FilterNamePictureFieldType = {
  __typename?: 'FilterNamePictureFieldType';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  title?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type FirstReplyType = {
  __typename?: 'FirstReplyType';
  hasMoreReplies: Scalars['Boolean']['output'];
  reply?: Maybe<CommentBaseType>;
};

export type FixtureGoalsType = {
  __typename?: 'FixtureGoalsType';
  away?: Maybe<Scalars['Float']['output']>;
  home?: Maybe<Scalars['Float']['output']>;
};

export type FixtureHaType = {
  __typename?: 'FixtureHAType';
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logo64?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  winner?: Maybe<Scalars['Boolean']['output']>;
};

export type FixtureLeagueType = {
  __typename?: 'FixtureLeagueType';
  country?: Maybe<Scalars['String']['output']>;
  flag?: Maybe<Scalars['String']['output']>;
  flag64?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logo64?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  round?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
};

export type FixturePeriodType = {
  __typename?: 'FixturePeriodType';
  first?: Maybe<Scalars['Float']['output']>;
  second?: Maybe<Scalars['String']['output']>;
};

export type FixtureScoreType = {
  __typename?: 'FixtureScoreType';
  extratime?: Maybe<FixtureGoalsType>;
  fulltime?: Maybe<FixtureGoalsType>;
  halftime?: Maybe<FixtureGoalsType>;
  penalty?: Maybe<FixtureGoalsType>;
};

export type FixtureStatusType = {
  __typename?: 'FixtureStatusType';
  elapsed?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['String']['output']>;
  short?: Maybe<Scalars['String']['output']>;
};

export type FixtureSubType = {
  __typename?: 'FixtureSubType';
  date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  periods?: Maybe<FixturePeriodType>;
  referee?: Maybe<Scalars['String']['output']>;
  status?: Maybe<FixtureStatusType>;
  timestamp?: Maybe<Scalars['Float']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  venue?: Maybe<FixtureVenueType>;
};

export type FixtureTeamsType = {
  __typename?: 'FixtureTeamsType';
  away?: Maybe<FixtureHaType>;
  home?: Maybe<FixtureHaType>;
};

export type FixtureType = {
  __typename?: 'FixtureType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fixture?: Maybe<FixtureSubType>;
  goals?: Maybe<FixtureGoalsType>;
  id: Scalars['ID']['output'];
  isUserSubscribedToFixtureEvents?: Maybe<Scalars['Boolean']['output']>;
  league?: Maybe<FixtureLeagueType>;
  score?: Maybe<FixtureScoreType>;
  teams?: Maybe<FixtureTeamsType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FixtureVenueType = {
  __typename?: 'FixtureVenueType';
  city?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FixtureWithOddsType = {
  __typename?: 'FixtureWithOddsType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fixture?: Maybe<FixtureSubType>;
  goals?: Maybe<FixtureGoalsType>;
  id: Scalars['ID']['output'];
  isUserSubscribedToFixtureEvents?: Maybe<Scalars['Boolean']['output']>;
  league?: Maybe<FixtureLeagueType>;
  odds?: Maybe<OddsBookmakersBetsType>;
  score?: Maybe<FixtureScoreType>;
  teams?: Maybe<FixtureTeamsType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum FlowAudienceTriggerEnum {
  JOIN = 'JOIN',
  LEAVE = 'LEAVE'
}

export enum FlowCategoryEnum {
  BADGE = 'BADGE',
  DEFAULT = 'DEFAULT'
}

export enum FlowDateTriggerEnum {
  BIRTHDATE = 'BIRTHDATE',
  CREATED = 'CREATED',
  FIRST_ACTIVE = 'FIRST_ACTIVE'
}

export type FlowFlowActionActionEmailInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type FlowFlowActionActionEmailType = {
  __typename?: 'FlowFlowActionActionEmailType';
  content?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type FlowFlowActionActionInput = {
  email?: InputMaybe<FlowFlowActionActionEmailInput>;
  internal?: InputMaybe<FlowFlowActionActionInternalInput>;
  profile?: InputMaybe<Array<FlowFlowActionActionProfileInput>>;
  push?: InputMaybe<FlowFlowActionActionPushInput>;
  sms?: InputMaybe<FlowFlowActionActionSmsInput>;
};

export type FlowFlowActionActionInternalInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type FlowFlowActionActionInternalType = {
  __typename?: 'FlowFlowActionActionInternalType';
  content?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type FlowFlowActionActionProfileInput = {
  action?: InputMaybe<FlowProfileActionEnum>;
  property?: InputMaybe<FlowFlowActionActionProfilePropertyInput>;
  value?: InputMaybe<FlowFlowActionActionProfileValueInput>;
};

export type FlowFlowActionActionProfilePropertyCustomInput = {
  category?: InputMaybe<FlowProfileCategoryEnum>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FlowFlowActionActionProfilePropertyCustomType = {
  __typename?: 'FlowFlowActionActionProfilePropertyCustomType';
  category?: Maybe<FlowProfileCategoryEnum>;
  label?: Maybe<Scalars['String']['output']>;
};

export type FlowFlowActionActionProfilePropertyInput = {
  custom?: InputMaybe<FlowFlowActionActionProfilePropertyCustomInput>;
  existing?: InputMaybe<FlowProfilePropertyEnum>;
};

export type FlowFlowActionActionProfilePropertyType = {
  __typename?: 'FlowFlowActionActionProfilePropertyType';
  custom?: Maybe<FlowFlowActionActionProfilePropertyCustomType>;
  existing?: Maybe<FlowProfilePropertyEnum>;
};

export type FlowFlowActionActionProfileType = {
  __typename?: 'FlowFlowActionActionProfileType';
  action?: Maybe<FlowProfileActionEnum>;
  property?: Maybe<FlowFlowActionActionProfilePropertyType>;
  value?: Maybe<FlowFlowActionActionProfileValueType>;
};

export type FlowFlowActionActionProfileValueInput = {
  custom?: InputMaybe<Scalars['String']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
};

export type FlowFlowActionActionProfileValueType = {
  __typename?: 'FlowFlowActionActionProfileValueType';
  custom?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['String']['output']>;
};

export type FlowFlowActionActionPushInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FlowFlowActionActionPushType = {
  __typename?: 'FlowFlowActionActionPushType';
  description?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  title?: Maybe<Scalars['String']['output']>;
};

export type FlowFlowActionActionSmsInput = {
  content?: InputMaybe<Scalars['String']['input']>;
};

export type FlowFlowActionActionSmsType = {
  __typename?: 'FlowFlowActionActionSmsType';
  content?: Maybe<Scalars['String']['output']>;
};

export type FlowFlowActionActionType = {
  __typename?: 'FlowFlowActionActionType';
  email?: Maybe<FlowFlowActionActionEmailType>;
  internal?: Maybe<FlowFlowActionActionInternalType>;
  profile?: Maybe<Array<FlowFlowActionActionProfileType>>;
  push?: Maybe<FlowFlowActionActionPushType>;
  sms?: Maybe<FlowFlowActionActionSmsType>;
};

export type FlowFlowActionInput = {
  action?: InputMaybe<FlowFlowActionActionInput>;
  logic?: InputMaybe<FlowFlowActionLogicInput>;
  timing?: InputMaybe<Scalars['Int']['input']>;
};

export type FlowFlowActionLogicInput = {
  condition: Array<AudienceSegmentInput>;
  no?: InputMaybe<Array<FlowFlowActionInput>>;
  rejoin?: InputMaybe<Array<FlowFlowActionInput>>;
  yes?: InputMaybe<Array<FlowFlowActionInput>>;
};

export type FlowFlowActionLogicType = {
  __typename?: 'FlowFlowActionLogicType';
  condition?: Maybe<Array<AudienceSegmentType>>;
  no?: Maybe<Array<FlowFlowActionType>>;
  rejoin?: Maybe<Array<FlowFlowActionType>>;
  yes?: Maybe<Array<FlowFlowActionType>>;
};

export type FlowFlowActionType = {
  __typename?: 'FlowFlowActionType';
  action?: Maybe<FlowFlowActionActionType>;
  logic?: Maybe<FlowFlowActionLogicType>;
  timing?: Maybe<Scalars['Int']['output']>;
};

export type FlowFlowInput = {
  actions?: InputMaybe<Array<FlowFlowActionInput>>;
  trigger?: InputMaybe<FlowFlowTriggerInput>;
};

export type FlowFlowTriggerAudienceInput = {
  audience?: InputMaybe<Scalars['ID']['input']>;
  trigger?: InputMaybe<FlowAudienceTriggerEnum>;
};

export type FlowFlowTriggerAudienceType = {
  __typename?: 'FlowFlowTriggerAudienceType';
  audience?: Maybe<AudienceType>;
  trigger?: Maybe<FlowAudienceTriggerEnum>;
};

export type FlowFlowTriggerDateExecutionInput = {
  instant?: InputMaybe<Scalars['Boolean']['input']>;
  schedule?: InputMaybe<FlowFlowTriggerDateExecutionScheduleInput>;
};

export type FlowFlowTriggerDateExecutionScheduleInput = {
  schedule?: InputMaybe<FlowScheduleTriggerEnum>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FlowFlowTriggerDateExecutionScheduleType = {
  __typename?: 'FlowFlowTriggerDateExecutionScheduleType';
  schedule?: Maybe<FlowScheduleTriggerEnum>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type FlowFlowTriggerDateExecutionType = {
  __typename?: 'FlowFlowTriggerDateExecutionType';
  instant?: Maybe<Scalars['Boolean']['output']>;
  schedule?: Maybe<FlowFlowTriggerDateExecutionScheduleType>;
};

export type FlowFlowTriggerDateInput = {
  date?: InputMaybe<FlowDateTriggerEnum>;
  execution?: InputMaybe<FlowFlowTriggerDateExecutionInput>;
};

export type FlowFlowTriggerDateType = {
  __typename?: 'FlowFlowTriggerDateType';
  date?: Maybe<FlowDateTriggerEnum>;
  execution?: Maybe<FlowFlowTriggerDateExecutionType>;
};

export type FlowFlowTriggerInput = {
  audience?: InputMaybe<FlowFlowTriggerAudienceInput>;
  date?: InputMaybe<FlowFlowTriggerDateInput>;
  metric?: InputMaybe<FlowFlowTriggerMetricInput>;
  reputation?: InputMaybe<FlowFlowTriggerReputationInput>;
};

export type FlowFlowTriggerMetricInput = {
  metric?: InputMaybe<FlowMetricTriggerEnum>;
};

export type FlowFlowTriggerMetricType = {
  __typename?: 'FlowFlowTriggerMetricType';
  metric?: Maybe<FlowMetricTriggerEnum>;
};

export type FlowFlowTriggerReputationInput = {
  reputation?: InputMaybe<Scalars['ID']['input']>;
  trigger?: InputMaybe<FlowReputationTriggerEnum>;
};

export type FlowFlowTriggerReputationType = {
  __typename?: 'FlowFlowTriggerReputationType';
  reputation?: Maybe<ReputationType>;
  trigger?: Maybe<FlowReputationTriggerEnum>;
};

export type FlowFlowTriggerType = {
  __typename?: 'FlowFlowTriggerType';
  audience?: Maybe<FlowFlowTriggerAudienceType>;
  date?: Maybe<FlowFlowTriggerDateType>;
  metric?: Maybe<FlowFlowTriggerMetricType>;
  reputation?: Maybe<FlowFlowTriggerReputationType>;
};

export type FlowFlowType = {
  __typename?: 'FlowFlowType';
  actions?: Maybe<Array<FlowFlowActionType>>;
  trigger?: Maybe<FlowFlowTriggerType>;
};

export type FlowInput = {
  category?: InputMaybe<FlowCategoryEnum>;
  conversion?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  flow?: InputMaybe<FlowFlowInput>;
  icon?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  status?: InputMaybe<FlowStatusEnum>;
  target?: InputMaybe<TargetAciInput>;
  title: Scalars['String']['input'];
};

export enum FlowMetricTriggerEnum {
  MOBILE_ORDER = 'MOBILE_ORDER',
  ORDER = 'ORDER',
  PHYSICAL_ORDER = 'PHYSICAL_ORDER',
  WEB_ORDER = 'WEB_ORDER'
}

export type FlowPaginateType = {
  __typename?: 'FlowPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<FlowType>;
};

export enum FlowProfileActionEnum {
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  UPDATE = 'UPDATE'
}

export enum FlowProfileCategoryEnum {
  BOOLEAN = 'BOOLEAN',
  DATE = 'DATE',
  LIST = 'LIST',
  NUMBER = 'NUMBER',
  TEXT = 'TEXT'
}

export enum FlowProfilePropertyEnum {
  CREATED = 'CREATED',
  EMAIL = 'EMAIL',
  FIRST_ACTIVE = 'FIRST_ACTIVE',
  FIRST_NAME = 'FIRST_NAME',
  LAST_ACTIVE = 'LAST_ACTIVE',
  LAST_NAME = 'LAST_NAME',
  ORGANIZATION = 'ORGANIZATION',
  PHONE_NUMBER = 'PHONE_NUMBER',
  TITLE = 'TITLE'
}

export enum FlowReputationTriggerEnum {
  LOST = 'LOST',
  WON = 'WON'
}

export enum FlowScheduleTriggerEnum {
  DAYS = 'DAYS',
  HOURS = 'HOURS',
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS'
}

export enum FlowStatusEnum {
  ARCHIVED = 'ARCHIVED',
  DRAFT = 'DRAFT',
  LIVE = 'LIVE'
}

export type FlowType = {
  __typename?: 'FlowType';
  category?: Maybe<FlowCategoryEnum>;
  conversion?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  flow?: Maybe<FlowFlowType>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  picture?: Maybe<PictureType>;
  status?: Maybe<FlowStatusEnum>;
  target?: Maybe<TargetType>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FollowType = {
  __typename?: 'FollowType';
  id: Scalars['ID']['output'];
  target: TargetWithGroupType;
  user: UserType;
};

export type FollowerType = {
  __typename?: 'FollowerType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type FontInput = {
  family?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FontPaginatedType = {
  __typename?: 'FontPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<FontType>;
};

export type FontType = {
  __typename?: 'FontType';
  createdAt: Scalars['DateTime']['output'];
  family?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  preview?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type FormDtoType = {
  __typename?: 'FormDtoType';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  owner: FormOwnerDtoType;
  status?: Maybe<FormStatus>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<FormType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FormFiltersInput = {
  owner?: InputMaybe<FormOwnerFilterInput>;
  statuses?: InputMaybe<Array<FormStatus>>;
  types?: InputMaybe<Array<FormType>>;
};

export type FormOwnerDtoType = {
  __typename?: 'FormOwnerDtoType';
  manufacturer?: Maybe<ManufacturerType>;
  pos?: Maybe<PointOfSaleType>;
  wholesaler?: Maybe<WholesalerType>;
};

export type FormOwnerFilterInput = {
  manufacturers?: InputMaybe<Array<Scalars['String']['input']>>;
  pos?: InputMaybe<Array<Scalars['String']['input']>>;
  wholesaler?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FormOwnerInput = {
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  pos?: InputMaybe<Scalars['String']['input']>;
  wholesaler?: InputMaybe<Scalars['String']['input']>;
};

export type FormPaginateType = {
  __typename?: 'FormPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<FormResponseType>;
};

export type FormResponseType = {
  __typename?: 'FormResponseType';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  owner: FormOwnerDtoType;
  questions: Array<QuestionDtoType>;
  status: FormStatus;
  title: Scalars['String']['output'];
  type: FormType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum FormStatus {
  CHECKED = 'CHECKED',
  DRAFT = 'DRAFT',
  FINISHED = 'FINISHED',
  ONGOING = 'ONGOING'
}

export enum FormType {
  AUTONOMOUS = 'AUTONOMOUS',
  GUIDED = 'GUIDED'
}

export type FreebieInput = {
  amount: Scalars['Decimal']['input'];
  enable: Scalars['Boolean']['input'];
  frequency: RecurrenceType;
  rate: Scalars['Int']['input'];
  schedular?: InputMaybe<Array<FreebieSchedularInput>>;
  target?: InputMaybe<TargetAciInput>;
};

export type FreebieSchedularActionsInput = {
  amount: Scalars['Decimal']['input'];
  count: Scalars['Int']['input'];
  time: Scalars['String']['input'];
};

export type FreebieSchedularActionsType = {
  __typename?: 'FreebieSchedularActionsType';
  amount: Scalars['Decimal']['output'];
  count: Scalars['Int']['output'];
  time: Scalars['String']['output'];
};

export type FreebieSchedularInput = {
  actions?: InputMaybe<Array<FreebieSchedularActionsInput>>;
  dayOfWeek?: InputMaybe<DayEnum>;
};

export type FreebieSchedularType = {
  __typename?: 'FreebieSchedularType';
  actions?: Maybe<Array<FreebieSchedularActionsType>>;
  dayOfWeek?: Maybe<DayEnum>;
};

export type FreebieTransactionInput = {
  amount?: Scalars['Decimal']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  target?: InputMaybe<TargetAciInput>;
};

export type FreebieTransactionPaginateType = {
  __typename?: 'FreebieTransactionPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<FreebieTransactionType>;
};

export type FreebieTransactionType = {
  __typename?: 'FreebieTransactionType';
  amount: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  quantity?: Maybe<Scalars['Float']['output']>;
  receiverAmount: Scalars['Decimal']['output'];
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FreebieType = {
  __typename?: 'FreebieType';
  amount: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  enable?: Maybe<Scalars['Boolean']['output']>;
  frequency?: Maybe<RecurrenceType>;
  id: Scalars['ID']['output'];
  rate: Scalars['Int']['output'];
  schedular?: Maybe<Array<FreebieSchedularType>>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FreebieUpdateInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  frequency?: InputMaybe<RecurrenceType>;
  rate?: InputMaybe<Scalars['Int']['input']>;
  schedular?: InputMaybe<Array<FreebieSchedularInput>>;
};

export type FromToInput = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type FullAddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<LonLatInput>;
  owner?: InputMaybe<FullAddressOwnerInput>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['ID']['input']>;
};

export type FullAddressOwnerInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<FullAddressOwnerPhoneInput>;
};

export type FullAddressOwnerPhoneInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
};

export type FullAddressOwnerPhoneType = {
  __typename?: 'FullAddressOwnerPhoneType';
  countryCode?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type FullAddressOwnerType = {
  __typename?: 'FullAddressOwnerType';
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<FullAddressOwnerPhoneType>;
};

export type FullAddressType = {
  __typename?: 'FullAddressType';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryType>;
  location?: Maybe<LonLatType>;
  owner?: Maybe<FullAddressOwnerType>;
  postCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<StateType>;
};

export enum GaRecommendedEventsEnum {
  ADD_PAYMENT_INFO = 'ADD_PAYMENT_INFO',
  ADD_SHIPPING_INFO = 'ADD_SHIPPING_INFO',
  ADD_TO_CART = 'ADD_TO_CART',
  ADD_TO_WISHLIST = 'ADD_TO_WISHLIST',
  BEGIN_CHECKOUT = 'BEGIN_CHECKOUT',
  EARN_VIRTUAL_CURRENCY = 'EARN_VIRTUAL_CURRENCY',
  GENERATE_LEAD = 'GENERATE_LEAD',
  LOGIN = 'LOGIN',
  PURCHASE = 'PURCHASE',
  REFUND = 'REFUND',
  REMOVE_FROM_CART = 'REMOVE_FROM_CART',
  SEARCH = 'SEARCH',
  SELECT_ITEM = 'SELECT_ITEM',
  SELECT_PROMOTION = 'SELECT_PROMOTION',
  SHARE = 'SHARE',
  SIGN_UP = 'SIGN_UP',
  SPEND_VIRTUAL_CURRENCY = 'SPEND_VIRTUAL_CURRENCY',
  VIEW_CART = 'VIEW_CART',
  VIEW_ITEM = 'VIEW_ITEM',
  VIEW_PROMOTION = 'VIEW_PROMOTION'
}

export type GameAssetDetailInput = {
  reference: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type GameAssetDetailType = {
  __typename?: 'GameAssetDetailType';
  reference: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GameAssetsInput = {
  font?: InputMaybe<Scalars['ID']['input']>;
  images?: InputMaybe<Array<GameAssetDetailInput>>;
  sound?: InputMaybe<Array<GameAssetDetailInput>>;
};

export type GameAssetsType = {
  __typename?: 'GameAssetsType';
  font?: Maybe<FontType>;
  images?: Maybe<Array<GameAssetDetailType>>;
  sound?: Maybe<Array<GameAssetDetailType>>;
};

export type GameContentInput = {
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type GameContentType = {
  __typename?: 'GameContentType';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type GameGroupInput = {
  code: Scalars['String']['input'];
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  games?: InputMaybe<Array<Scalars['ID']['input']>>;
  leaderboard?: InputMaybe<GameIntegrationLeaderboardInput>;
  name: Scalars['String']['input'];
  picture?: InputMaybe<PictureInput>;
  point?: InputMaybe<GamePointInput>;
  rewardsSchedular?: InputMaybe<Array<GameIntegrationRewardsSchedularInput>>;
};

export type GameGroupType = {
  __typename?: 'GameGroupType';
  code: Scalars['String']['output'];
  enable?: Maybe<Scalars['Boolean']['output']>;
  games?: Maybe<Array<GameType>>;
  leaderboard?: Maybe<GameIntegrationLeaderboardType>;
  name: Scalars['String']['output'];
  picture?: Maybe<PictureType>;
  point?: Maybe<GamePointType>;
  rewardsSchedular?: Maybe<Array<GameIntegrationRewardsSchedularType>>;
};

export type GameInput = {
  assets?: InputMaybe<GameAssetsInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  globalRatio?: InputMaybe<Scalars['Int']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  point?: InputMaybe<GamePointInput>;
  settings?: InputMaybe<GameSettingsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Array<GameTranslationInput>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type GameIntegrationCustomInput = {
  assets?: InputMaybe<GameAssetsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  point?: InputMaybe<GamePointInput>;
  settings?: InputMaybe<GameSettingsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Array<GameTranslationInput>>;
};

export type GameIntegrationCustomType = {
  __typename?: 'GameIntegrationCustomType';
  assets?: Maybe<GameAssetsType>;
  description?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  point?: Maybe<GamePointType>;
  settings?: Maybe<GameSettingsType>;
  title?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Array<GameTranslationType>>;
};

export type GameIntegrationLeaderboardInput = {
  active?: Scalars['Boolean']['input'];
  blur?: Scalars['Boolean']['input'];
  daily?: Scalars['Boolean']['input'];
  monthly?: Scalars['Boolean']['input'];
  overall?: Scalars['Boolean']['input'];
  weekly?: Scalars['Boolean']['input'];
};

export type GameIntegrationLeaderboardType = {
  __typename?: 'GameIntegrationLeaderboardType';
  active: Scalars['Boolean']['output'];
  blur: Scalars['Boolean']['output'];
  daily: Scalars['Boolean']['output'];
  monthly: Scalars['Boolean']['output'];
  overall: Scalars['Boolean']['output'];
  weekly: Scalars['Boolean']['output'];
};

export type GameIntegrationRewardCouponInput = {
  discount?: InputMaybe<DiscountDtoInput>;
  isOffline?: InputMaybe<Scalars['Boolean']['input']>;
  target?: InputMaybe<TargetAciInput>;
};

export type GameIntegrationRewardCouponType = {
  __typename?: 'GameIntegrationRewardCouponType';
  discount?: Maybe<DiscountDtoType>;
  isOffline: Scalars['Boolean']['output'];
  target?: Maybe<TargetType>;
};

export type GameIntegrationRewardInnerInput = {
  coupon?: InputMaybe<GameIntegrationRewardCouponInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  rank?: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GameIntegrationRewardInnerType = {
  __typename?: 'GameIntegrationRewardInnerType';
  coupon?: Maybe<GameIntegrationRewardCouponType>;
  description?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  rank: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type GameIntegrationRewardType = {
  __typename?: 'GameIntegrationRewardType';
  createdAt: Scalars['DateTime']['output'];
  cycle: LeaderboardCycleEnum;
  cycleNumber: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  rewards: Array<GameIntegrationRewardInnerType>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  year: Scalars['Int']['output'];
};

export type GameIntegrationRewardsSchedularInput = {
  dayOfWeek: DayEnum;
  rewards: Array<GameIntegrationRewardInnerInput>;
};

export type GameIntegrationRewardsSchedularType = {
  __typename?: 'GameIntegrationRewardsSchedularType';
  dayOfWeek: DayEnum;
  rewards: Array<GameIntegrationRewardInnerType>;
};

export type GameIntegrationSettingsInput = {
  custom?: InputMaybe<GameIntegrationCustomInput>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  game?: InputMaybe<Scalars['ID']['input']>;
  leaderboard?: InputMaybe<GameIntegrationLeaderboardInput>;
  rewardsSchedular?: InputMaybe<Array<GameIntegrationRewardsSchedularInput>>;
};

export type GameIntegrationSettingsType = {
  __typename?: 'GameIntegrationSettingsType';
  custom?: Maybe<GameIntegrationCustomType>;
  enable?: Maybe<Scalars['Boolean']['output']>;
  game?: Maybe<GameType>;
  leaderboard?: Maybe<GameIntegrationLeaderboardType>;
  rewardsSchedular?: Maybe<Array<GameIntegrationRewardsSchedularType>>;
};

export type GameIntegrationType = {
  __typename?: 'GameIntegrationType';
  createdAt: Scalars['DateTime']['output'];
  gameGroups?: Maybe<Array<GameGroupType>>;
  games?: Maybe<Array<GameIntegrationSettingsType>>;
  id: Scalars['ID']['output'];
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type GameIntegrationUpdateInput = {
  gameGroups?: InputMaybe<Array<GameGroupInput>>;
  games?: InputMaybe<Array<GameIntegrationSettingsInput>>;
};

export type GameOrderInput = {
  game?: InputMaybe<Scalars['ID']['input']>;
  qualitativeItem?: InputMaybe<GameOrderQualitativeItemInput>;
  standardItem?: InputMaybe<GameOrderStandardItemInput>;
  target: TargetAciInput;
};

export type GameOrderPaginateType = {
  __typename?: 'GameOrderPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<GameOrderType>;
};

export type GameOrderQualitativeItemInput = {
  qualitative?: InputMaybe<Scalars['String']['input']>;
};

export type GameOrderSettingsItemType = {
  __typename?: 'GameOrderSettingsItemType';
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  emoji?: Maybe<Scalars['String']['output']>;
  fallback?: Maybe<Scalars['String']['output']>;
  isRare?: Maybe<Scalars['Boolean']['output']>;
  picture?: Maybe<PictureType>;
  points?: Maybe<Scalars['Decimal']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
  qualitative?: Maybe<Scalars['Decimal']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type GameOrderStandardItemInput = {
  description: Scalars['String']['input'];
  picture?: InputMaybe<PictureInput>;
  price?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export enum GameOrderStatusEnum {
  DELIVERED = 'DELIVERED',
  PENDING = 'PENDING'
}

export type GameOrderType = {
  __typename?: 'GameOrderType';
  createdAt: Scalars['DateTime']['output'];
  game?: Maybe<GameType>;
  id: Scalars['ID']['output'];
  item?: Maybe<GameOrderSettingsItemType>;
  status?: Maybe<GameOrderStatusEnum>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type GamePaginateType = {
  __typename?: 'GamePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<GameType>;
};

export type GamePointInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
  picture: PictureInput;
};

export type GamePointType = {
  __typename?: 'GamePointType';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  picture: PictureType;
};

export type GameRewardType = {
  __typename?: 'GameRewardType';
  id: Scalars['ID']['output'];
  rewards: Array<GameIntegrationRewardInnerType>;
};

export type GameRewardWithGameAndClosingDateType = {
  __typename?: 'GameRewardWithGameAndClosingDateType';
  closingDate: Scalars['DateTime']['output'];
  data?: Maybe<Array<GameRewardWithGameType>>;
};

export type GameRewardWithGameType = {
  __typename?: 'GameRewardWithGameType';
  game?: Maybe<GameType>;
  gameGroup?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  rewards: Array<GameIntegrationRewardInnerType>;
};

export type GameRewardsFilterInput = {
  cycle: LeaderboardCycleEnum;
  cycleNumber: Scalars['Int']['input'];
  /** game id */
  game?: InputMaybe<Scalars['ID']['input']>;
  /** game group code */
  gameGroup?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
  year: Scalars['Int']['input'];
};

export type GameSettingsCostInput = {
  amount: Scalars['String']['input'];
  coin: Scalars['ID']['input'];
};

export type GameSettingsCostType = {
  __typename?: 'GameSettingsCostType';
  amount: Scalars['String']['output'];
  coin: CoinType;
};

export type GameSettingsInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<GameSettingsCostInput>;
  /** game specific settings in base64 format for json */
  gameConfigs?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<GameSettingsItemInput>>;
};

export type GameSettingsItemInput = {
  again?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  empty?: InputMaybe<Scalars['Boolean']['input']>;
  fallback?: InputMaybe<Scalars['String']['input']>;
  isRare?: InputMaybe<Scalars['Boolean']['input']>;
  picture?: InputMaybe<PictureInput>;
  points?: InputMaybe<Scalars['Decimal']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  qualitative?: InputMaybe<Scalars['Decimal']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type GameSettingsItemType = {
  __typename?: 'GameSettingsItemType';
  again?: Maybe<Scalars['Boolean']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  emoji?: Maybe<Scalars['String']['output']>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  fallback?: Maybe<Scalars['String']['output']>;
  isRare?: Maybe<Scalars['Boolean']['output']>;
  picture?: Maybe<PictureType>;
  points?: Maybe<Scalars['Decimal']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
  qualitative?: Maybe<Scalars['Decimal']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type GameSettingsType = {
  __typename?: 'GameSettingsType';
  color?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<GameSettingsCostType>;
  /** game specific settings in base64 format for json */
  gameConfigs?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<GameSettingsItemType>>;
};

export enum GameTimerEnum {
  FIVE_MINUTES = 'FIVE_MINUTES',
  HALF_MINUTE = 'HALF_MINUTE',
  MINUTE = 'MINUTE',
  TWO_MINUTES = 'TWO_MINUTES'
}

export type GameTranslationInput = {
  content: GameContentInput;
  language: Scalars['ID']['input'];
};

export type GameTranslationType = {
  __typename?: 'GameTranslationType';
  content: GameContentType;
  language: LanguageType;
};

export type GameType = {
  __typename?: 'GameType';
  assets?: Maybe<GameAssetsType>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  globalRatio?: Maybe<Scalars['Int']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<MediaType>;
  point: GamePointType;
  settings?: Maybe<GameSettingsType>;
  title?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Array<GameTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export enum GameTypeEnum {
  FIND_HIDDEN_OBJECT = 'FIND_HIDDEN_OBJECT',
  GUESS_MISSING_ELEMENT = 'GUESS_MISSING_ELEMENT',
  GUESS_THE_PRICE = 'GUESS_THE_PRICE',
  JIGSAW = 'JIGSAW',
  MEMORY_GAME = 'MEMORY_GAME',
  SLIDING = 'SLIDING',
  TRIVIA_QUIZ = 'TRIVIA_QUIZ'
}

export type GameUpdateInput = {
  assets?: InputMaybe<GameAssetsInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  globalRatio?: InputMaybe<Scalars['Int']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  point?: InputMaybe<GamePointInput>;
  settings?: InputMaybe<GameSettingsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Array<GameTranslationInput>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type GamificationDashboardKycCompletedType = {
  __typename?: 'GamificationDashboardKYCCompletedType';
  count: Scalars['Int']['output'];
  percentage: Scalars['String']['output'];
};

export type GamificationDashboardKycIncompletedType = {
  __typename?: 'GamificationDashboardKYCIncompletedType';
  average: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  percentage: Scalars['String']['output'];
};

export type GamificationDashboardKycTotalType = {
  __typename?: 'GamificationDashboardKYCTotalType';
  average: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type GamificationDashboardKycType = {
  __typename?: 'GamificationDashboardKYCType';
  KYCIndex: Scalars['String']['output'];
  completed: GamificationDashboardKycCompletedType;
  inactiveIncompleted: GamificationDashboardKycIncompletedType;
  incompleted: GamificationDashboardKycIncompletedType;
  total: GamificationDashboardKycTotalType;
};

export type GamificationEngagmentPointsEarnedPerActivityDashboardType = {
  __typename?: 'GamificationEngagmentPointsEarnedPerActivityDashboardType';
  activity: TransactionTypeEnum;
  points: Scalars['Decimal']['output'];
};

export type GamificationEngagmentProgressionOverTimeDashboardType = {
  __typename?: 'GamificationEngagmentProgressionOverTimeDashboardType';
  data: Array<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type GamificationEngagmentProgressionStatsDashboardType = {
  __typename?: 'GamificationEngagmentProgressionStatsDashboardType';
  averageEngagmentActions: Scalars['Decimal']['output'];
  engagedUserPercentage: Scalars['Decimal']['output'];
  levelProgressionRate: Scalars['Decimal']['output'];
  retentionRate: Scalars['Decimal']['output'];
};

export type GamificationEngagmentStatsDashboardType = {
  __typename?: 'GamificationEngagmentStatsDashboardType';
  averageDailyUsersEarnings: Scalars['Decimal']['output'];
  averageDailyUsersPercentage: Scalars['Decimal']['output'];
  averageQualitativePoints: Scalars['Decimal']['output'];
  averageQuantitativePoints: Scalars['Decimal']['output'];
  quantitativePointsRedemptionRate: Scalars['Decimal']['output'];
};

export type GamificationGetCorporateUsersStatsDashboardType = {
  __typename?: 'GamificationGetCorporateUsersStatsDashboardType';
  activeUsersLast60Days: CurrentPreviousPercentageType;
  newUsersThisMonth: CurrentPreviousPercentageType;
  newUsersToday: CurrentPreviousPercentageType;
  returningUsersLast60Days: CurrentPreviousPercentageType;
  usersCount: Scalars['Float']['output'];
};

export type GamificationTopPerformingQuestsDashboardType = {
  __typename?: 'GamificationTopPerformingQuestsDashboardType';
  percentage: Scalars['Decimal']['output'];
  quests: Array<QuestWithActionsType>;
  totalQuests: Scalars['Int']['output'];
};

export type GamificationUserDistributionsByLevelDashboardType = {
  __typename?: 'GamificationUserDistributionsByLevelDashboardType';
  color: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  level: Scalars['String']['output'];
  percentage: Scalars['String']['output'];
};

export type GamificationUserDistributionsByStateDashboardType = {
  __typename?: 'GamificationUserDistributionsByStateDashboardType';
  layers: Array<AnalyticsUsersByCountryLayersType>;
  segments: Array<UserByStatesType>;
  total: Scalars['Int']['output'];
};

export type GamificationUsersMissingFieldsDashboardType = {
  __typename?: 'GamificationUsersMissingFieldsDashboardType';
  missingBirthdate: AmountPercentageDecimalType;
  missingCity: AmountPercentageDecimalType;
  missingCountry: AmountPercentageDecimalType;
  missingEducation: AmountPercentageDecimalType;
  missingHobbies: AmountPercentageDecimalType;
  missingInterests: AmountPercentageDecimalType;
  missingLocation: AmountPercentageDecimalType;
  missingMaritalStatus: AmountPercentageDecimalType;
  missingPhone: AmountPercentageDecimalType;
  missingWork: AmountPercentageDecimalType;
  total: Scalars['Decimal']['output'];
};

export type GamificationUsersProfilesCompletnessByStageDashboardType = {
  __typename?: 'GamificationUsersProfilesCompletnessByStageDashboardType';
  p0_25: AmountPercentageDecimalType;
  p25_50: AmountPercentageDecimalType;
  p50_75: AmountPercentageDecimalType;
  p75_100: AmountPercentageDecimalType;
};

export enum Gender {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  PREFER_NOT_TO_SAY = 'PREFER_NOT_TO_SAY',
  UNKNOWN = 'UNKNOWN'
}

export type GenerateInsightsInput = {
  breakdowns: InsightsBreakdownsInput;
  kpis: InsightsKpisInput;
  language?: InputMaybe<Scalars['String']['input']>;
  tone?: InputMaybe<Scalars['String']['input']>;
  topCampaigns: Array<Scalars['String']['input']>;
  underperformingCampaigns: Array<Scalars['String']['input']>;
};

export type GenerateInsightsType = {
  __typename?: 'GenerateInsightsType';
  generationDetails: InsightsGenerationDetailsType;
  insights: Array<Scalars['String']['output']>;
};

export type GenerationDetailsAiType = {
  __typename?: 'GenerationDetailsAiType';
  ollamaModel?: Maybe<Scalars['String']['output']>;
  usedOllama?: Maybe<Scalars['Boolean']['output']>;
};

export enum GenericInvoicingStatusEnum {
  CANCELED = 'CANCELED',
  CONFIRMED = 'CONFIRMED',
  DELIVERED = 'DELIVERED',
  DRAFT = 'DRAFT',
  ISSUED = 'ISSUED',
  NEGOCIATION = 'NEGOCIATION',
  OPEN = 'OPEN'
}

export type GenericTaskType = {
  __typename?: 'GenericTaskType';
  archived: Scalars['Boolean']['output'];
  completed: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  priority: TaskPriorityEnum;
  rank: Scalars['Int']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type GetCorporateUserAnalyticsType = {
  __typename?: 'GetCorporateUserAnalyticsType';
  activeUsers: CorporateUsersStatsType;
  overAllUsers: CorporateUsersStatsType;
  returningUsers: CorporateUsersStatsType;
};

export type GetCorporateUserByDayInPeriodAnalyticsType = {
  __typename?: 'GetCorporateUserByDayInPeriodAnalyticsType';
  activeUsers: Array<PeriodStatsType>;
  newUsers: Array<PeriodStatsType>;
};

export type GetCorporateUsersRequestsAnalyticsType = {
  __typename?: 'GetCorporateUsersRequestsAnalyticsType';
  conversions: ConversionsFieldType;
  impressions: ImpressionsFieldType;
  visits: VisitsFieldType;
};

export type GetCorporateUsersTechnologiesDashboardDataType = {
  __typename?: 'GetCorporateUsersTechnologiesDashboardDataType';
  mobile: Scalars['Int']['output'];
  mobileDaily: Array<PeriodStatsType>;
  unknown: Scalars['Int']['output'];
  unknownDaily: Array<PeriodStatsType>;
  web: Scalars['Int']['output'];
  webDaily: Array<PeriodStatsType>;
};

export type GetCorporateWarehouseDashboardDataType = {
  __typename?: 'GetCorporateWarehouseDashboardDataType';
  categoriesCount: TotalAndInPeriodCountsType;
  productsCount: TotalAndInPeriodCountsType;
  ratingsCount: RatingsCountType;
  stocksCount: StocksCountType;
};

export type GetEcommerceFinanceDashboardDataType = {
  __typename?: 'GetEcommerceFinanceDashboardDataType';
  cancelledOrdersCount?: Maybe<DateStatsType>;
  cancelledOrdersWeeklyCount?: Maybe<Array<PeriodStatsType>>;
  customersCount?: Maybe<DateStatsType>;
  customersWeeklyCount?: Maybe<Array<PeriodStatsType>>;
  openInstallments?: Maybe<Scalars['Decimal']['output']>;
  openInstallmentsDaily?: Maybe<Array<PeriodStatsType>>;
  ordersCount?: Maybe<DateStatsType>;
  ordersWeeklyCount?: Maybe<Array<PeriodStatsType>>;
  paidInstallments?: Maybe<Scalars['Decimal']['output']>;
  paidInstallmentsDaily?: Maybe<Array<PeriodStatsType>>;
  paymentMethods?: Maybe<PaymentMethodsStatsType>;
  profits?: Maybe<Scalars['Decimal']['output']>;
  purchasesStatuses?: Maybe<PurchasesStatusesFinanceDashboardDataType>;
  suppliersCount?: Maybe<Scalars['Int']['output']>;
  totalRevenu?: Maybe<DateStatsType>;
  totalSpendings?: Maybe<DateStatsType>;
  totalSpendingsDaily?: Maybe<Array<PeriodStatsType>>;
};

export type GetInternalProductForPartnershipNetworkWithFilterPaginatedInput = {
  filter?: InputMaybe<InternalProductForPartnershipNetworkFilterInput>;
  language?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<ProductSortInput>>;
  target: TargetAciInput;
};

export type GetInternalProductWithFilterPaginatedInput = {
  filter?: InputMaybe<GetSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusInput>;
  language?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<ProductSortInput>>;
};

export type GetLeaderboardByDatesAndCycleInput = {
  cycle: LeaderboardCycleEnum;
  cycleNumber?: InputMaybe<Scalars['Int']['input']>;
  end: Scalars['String']['input'];
  /** game code */
  game?: InputMaybe<Scalars['String']['input']>;
  /** game group code */
  gameGroup?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['String']['input'];
  target: TargetAciInput;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type GetMenuBadgesType = {
  __typename?: 'GetMenuBadgesType';
  allCorporateUsersCount?: Maybe<Scalars['Int']['output']>;
  internalProductsCount?: Maybe<Scalars['Int']['output']>;
  targetOutOFStockItemsCount?: Maybe<Scalars['Int']['output']>;
  uncompletedTasksCount?: Maybe<Scalars['Int']['output']>;
  unreadMessagesCount?: Maybe<Scalars['Int']['output']>;
};

export type GetProductWithClicksCountInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GetProductsWithClicksCountByOwnerPaginatedFilterInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  owner?: InputMaybe<TargetAciInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<TargetAciInput>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GetQuestionResponsesPaginateType = {
  __typename?: 'GetQuestionResponsesPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  question?: Maybe<QuestionDtoType>;
  results: Array<AnswerDtoType>;
};

export type GetSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusInput = {
  /** list of catalogueCategories ids */
  catalogueCategory?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** list of internalProduct classes */
  classification?: InputMaybe<Array<ProductClassEnum>>;
  condition?: InputMaybe<Array<ProductConditionEnum>>;
  rent?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<ProductStatusEnum>>;
  structure?: InputMaybe<Array<ProductStructureEnum>>;
  target: TargetsInput;
  variety?: InputMaybe<Array<ProductVarietyEnum>>;
};

export type GetTargetSubscribersByExcelInput = {
  isPrelevel?: InputMaybe<Scalars['Boolean']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  reputationsLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<SubscriptionStatus>>;
  target: TargetAciInput;
};

export type GetWidgetForTargetType = {
  __typename?: 'GetWidgetForTargetType';
  aggregatorLoyaltySettings?: Maybe<LoyaltySettingsType>;
  loyaltySettings?: Maybe<LoyaltySettingsType>;
  visuals?: Maybe<WidgetVisualsPaginateType>;
  widgetIntegrationSettings?: Maybe<WidgetIntegrationType>;
};

export type GetWidgetGuestUserForTargetType = {
  __typename?: 'GetWidgetGuestUserForTargetType';
  clientIp: Scalars['String']['output'];
  outbound?: Maybe<OutboundType>;
};

export type GetWidgetUserForTargetType = {
  __typename?: 'GetWidgetUserForTargetType';
  aggregatorUser?: Maybe<UserType>;
  clientIp: Scalars['String']['output'];
  currentUser: UserType;
  notificationsCount: Scalars['Int']['output'];
  outbound?: Maybe<OutboundType>;
  predefinedQuests?: Maybe<Array<QuestWithRepeatDateType>>;
  wallet?: Maybe<WalletWithReputationDtoType>;
};

export type GlobalCategoryInput = {
  facebookCategory?: InputMaybe<Scalars['ID']['input']>;
  googleCategory?: InputMaybe<Scalars['ID']['input']>;
};

export type GlobalCategoryPaginatedType = {
  __typename?: 'GlobalCategoryPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<GlobalCategoryType>;
};

export type GlobalCategoryProductType = {
  __typename?: 'GlobalCategoryProductType';
  facebookCategory?: Maybe<GlobalCategoryType>;
  googleCategory?: Maybe<GlobalCategoryType>;
};

export enum GlobalCategoryProviderEnum {
  FACEBOOK = 'FACEBOOK',
  GOOGLE = 'GOOGLE'
}

export type GlobalCategoryType = {
  __typename?: 'GlobalCategoryType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  identifier: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  provider?: Maybe<GlobalCategoryProviderEnum>;
  updatedAt: Scalars['DateTime']['output'];
};

export type GlobalProviderCategoryInput = {
  identifier: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  provider?: InputMaybe<GlobalCategoryProviderEnum>;
};

export type GmailDraftType = {
  __typename?: 'GmailDraftType';
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<GmailMessageType>;
};

export type GmailHeaderType = {
  __typename?: 'GmailHeaderType';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GmailMessagePartBodyType = {
  __typename?: 'GmailMessagePartBodyType';
  data?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
};

export type GmailMessagePartType = {
  __typename?: 'GmailMessagePartType';
  body?: Maybe<GmailMessagePartBodyType>;
  filename?: Maybe<Scalars['String']['output']>;
  headers?: Maybe<Array<GmailHeaderType>>;
  mimeType?: Maybe<Scalars['String']['output']>;
  partId?: Maybe<Scalars['String']['output']>;
  parts?: Maybe<Array<GmailMessagePartType>>;
};

export type GmailMessageType = {
  __typename?: 'GmailMessageType';
  historyId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  internalDate?: Maybe<Scalars['String']['output']>;
  labelIds?: Maybe<Array<Scalars['String']['output']>>;
  payload?: Maybe<GmailMessagePartType>;
  raw?: Maybe<Scalars['String']['output']>;
  sizeEstimate?: Maybe<Scalars['Int']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
};

export type GmailThreadType = {
  __typename?: 'GmailThreadType';
  historyId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  messages?: Maybe<Array<GmailMessageType>>;
  snippet?: Maybe<Scalars['String']['output']>;
};

export type GoogleAnalyticsEventDataAddPaymentInfoInput = {
  coupon: Scalars['ID']['input'];
  payment: Scalars['ID']['input'];
  shoppingCart: Scalars['ID']['input'];
};

export type GoogleAnalyticsEventDataAddShippingInfoInput = {
  coupon: Scalars['ID']['input'];
  shipping_tier: ShippingTierTypeEnum;
  shoppingCart: Scalars['ID']['input'];
};

export type GoogleAnalyticsEventDataAddToCartInput = {
  coupon: Scalars['ID']['input'];
  shoppingCart: Scalars['ID']['input'];
};

export type GoogleAnalyticsEventDataBeginCheckoutInput = {
  coupon: Scalars['ID']['input'];
  shoppingCart: Scalars['ID']['input'];
};

export type GoogleAnalyticsEventDataEarnVirtualCurrencyInput = {
  value: Scalars['Float']['input'];
  virtual_currency_name: WalletTypeEnum;
};

export type GoogleAnalyticsEventDataGenerateLeadInput = {
  value: Scalars['String']['input'];
};

export type GoogleAnalyticsEventDataInput = {
  add_payment_info?: InputMaybe<GoogleAnalyticsEventDataAddPaymentInfoInput>;
  add_shipping_info?: InputMaybe<GoogleAnalyticsEventDataAddShippingInfoInput>;
  add_to_cart?: InputMaybe<GoogleAnalyticsEventDataAddToCartInput>;
  add_to_wishlist?: InputMaybe<GoogleAnalyticsEventDataWishlistInput>;
  begin_checkout?: InputMaybe<GoogleAnalyticsEventDataBeginCheckoutInput>;
  earn_virtual_currency?: InputMaybe<GoogleAnalyticsEventDataEarnVirtualCurrencyInput>;
  generate_lead?: InputMaybe<GoogleAnalyticsEventDataGenerateLeadInput>;
  login?: InputMaybe<GoogleAnalyticsEventDataLoginInput>;
  purchase?: InputMaybe<GoogleAnalyticsEventDataPurchaseInput>;
  refund?: InputMaybe<GoogleAnalyticsEventDataRefundInput>;
  remove_from_cart?: InputMaybe<GoogleAnalyticsEventDataRemoveFromCartInput>;
  search?: InputMaybe<GoogleAnalyticsEventDataSearchInput>;
  select_item?: InputMaybe<GoogleAnalyticsEventDataRemoveFromCartInput>;
  share?: InputMaybe<GoogleAnalyticsEventDataShareInput>;
  signup?: InputMaybe<GoogleAnalyticsEventDataLoginInput>;
  spend_virtual_currency?: InputMaybe<GoogleAnalyticsEventDataSpendVirtualCurrencyInput>;
  view_cart?: InputMaybe<GoogleAnalyticsEventDataViewCartInput>;
  view_item?: InputMaybe<GoogleAnalyticsEventDataSelectItemInput>;
};

export type GoogleAnalyticsEventDataLoginInput = {
  method: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type GoogleAnalyticsEventDataPurchaseInput = {
  coupon: Scalars['ID']['input'];
  order: Scalars['ID']['input'];
};

export type GoogleAnalyticsEventDataRefundInput = {
  coupon: Scalars['ID']['input'];
  order: Scalars['ID']['input'];
  product: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type GoogleAnalyticsEventDataRemoveFromCartInput = {
  product: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  shoppingCart: Scalars['ID']['input'];
};

export type GoogleAnalyticsEventDataSearchInput = {
  query: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type GoogleAnalyticsEventDataSelectItemInput = {
  product: Scalars['ID']['input'];
};

export type GoogleAnalyticsEventDataShareInput = {
  content_type: ShareContentTypeEnum;
  item_id: Scalars['String']['input'];
  method: ShareMethodEnum;
};

export type GoogleAnalyticsEventDataSpendVirtualCurrencyInput = {
  item_name: Scalars['String']['input'];
  value: Scalars['Float']['input'];
  virtual_currency_name: WalletTypeEnum;
};

export type GoogleAnalyticsEventDataViewCartInput = {
  shoppingCart: Scalars['ID']['input'];
};

export type GoogleAnalyticsEventDataWishlistInput = {
  product: Scalars['ID']['input'];
};

export type GoogleAnalyticsEventType = {
  __typename?: 'GoogleAnalyticsEventType';
  active: Scalars['Boolean']['output'];
  event: GaRecommendedEventsEnum;
};

export type GoogleAnalyticsType = {
  __typename?: 'GoogleAnalyticsType';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  events: Array<GoogleAnalyticsEventType>;
  googleTagId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type GoogleAnalyticsUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  googleTagId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  target?: InputMaybe<TargetAciInput>;
};

export type GoogleCalendarBackForType = {
  __typename?: 'GoogleCalendarBackForType';
  background: Scalars['String']['output'];
  foreground?: Maybe<Scalars['String']['output']>;
};

export type GoogleCalendarConferencePropertiesType = {
  __typename?: 'GoogleCalendarConferencePropertiesType';
  allowedConferenceSolutionTypes: Array<Scalars['String']['output']>;
};

export type GoogleCalendarDefaultReminderType = {
  __typename?: 'GoogleCalendarDefaultReminderType';
  method: Scalars['String']['output'];
  minutes?: Maybe<Scalars['Int']['output']>;
};

export type GoogleCalendarEventAttachmentType = {
  __typename?: 'GoogleCalendarEventAttachmentType';
  fileId?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  iconLink?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type GoogleCalendarEventAttendeeType = {
  __typename?: 'GoogleCalendarEventAttendeeType';
  additionalGuests?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  optional?: Maybe<Scalars['Boolean']['output']>;
  organizer?: Maybe<Scalars['Boolean']['output']>;
  resource?: Maybe<Scalars['Boolean']['output']>;
  responseStatus?: Maybe<Scalars['String']['output']>;
  self?: Maybe<Scalars['Boolean']['output']>;
};

export type GoogleCalendarEventConferenceDataConferenceSolutionKeyType = {
  __typename?: 'GoogleCalendarEventConferenceDataConferenceSolutionKeyType';
  type?: Maybe<Scalars['String']['output']>;
};

export type GoogleCalendarEventConferenceDataConferenceSolutionType = {
  __typename?: 'GoogleCalendarEventConferenceDataConferenceSolutionType';
  iconUri?: Maybe<Scalars['String']['output']>;
  key?: Maybe<GoogleCalendarEventConferenceDataConferenceSolutionKeyType>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GoogleCalendarEventConferenceDataCreateRequesStatusType = {
  __typename?: 'GoogleCalendarEventConferenceDataCreateRequesStatusType';
  statusCode?: Maybe<Scalars['String']['output']>;
};

export type GoogleCalendarEventConferenceDataCreateRequestSolutionKeyType = {
  __typename?: 'GoogleCalendarEventConferenceDataCreateRequestSolutionKeyType';
  type?: Maybe<Scalars['String']['output']>;
};

export type GoogleCalendarEventConferenceDataCreateRequestType = {
  __typename?: 'GoogleCalendarEventConferenceDataCreateRequestType';
  conferenceSolutionKey?: Maybe<GoogleCalendarEventConferenceDataCreateRequestSolutionKeyType>;
  requestId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<GoogleCalendarEventConferenceDataCreateRequesStatusType>;
};

export type GoogleCalendarEventConferenceDataEntryPointsType = {
  __typename?: 'GoogleCalendarEventConferenceDataEntryPointsType';
  accessCode?: Maybe<Scalars['String']['output']>;
  entryPointType?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  meetingCode?: Maybe<Scalars['String']['output']>;
  passcode?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
};

export type GoogleCalendarEventConferenceDataType = {
  __typename?: 'GoogleCalendarEventConferenceDataType';
  conferenceId?: Maybe<Scalars['String']['output']>;
  conferenceSolution?: Maybe<GoogleCalendarEventConferenceDataConferenceSolutionType>;
  createRequest?: Maybe<GoogleCalendarEventConferenceDataCreateRequestType>;
  entryPoints?: Maybe<Array<GoogleCalendarEventConferenceDataEntryPointsType>>;
  notes?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
};

export type GoogleCalendarEventCreatorType = {
  __typename?: 'GoogleCalendarEventCreatorType';
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  self?: Maybe<Scalars['Boolean']['output']>;
};

export type GoogleCalendarEventGadgetType = {
  __typename?: 'GoogleCalendarEventGadgetType';
  display?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  iconLink?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type GoogleCalendarEventReminderOverridesType = {
  __typename?: 'GoogleCalendarEventReminderOverridesType';
  method?: Maybe<Scalars['String']['output']>;
  minutes?: Maybe<Scalars['Float']['output']>;
};

export type GoogleCalendarEventReminderType = {
  __typename?: 'GoogleCalendarEventReminderType';
  overrides?: Maybe<GoogleCalendarEventReminderOverridesType>;
  useDefault?: Maybe<Scalars['Boolean']['output']>;
};

export type GoogleCalendarEventSourceType = {
  __typename?: 'GoogleCalendarEventSourceType';
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GoogleCalendarEventStartEndType = {
  __typename?: 'GoogleCalendarEventStartEndType';
  date?: Maybe<Scalars['String']['output']>;
  dateTime?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type GoogleCalendarEventType = {
  __typename?: 'GoogleCalendarEventType';
  anyoneCanAddSelf?: Maybe<Scalars['Boolean']['output']>;
  attachments?: Maybe<Array<GoogleCalendarEventAttachmentType>>;
  attendees?: Maybe<Array<GoogleCalendarEventAttendeeType>>;
  attendeesOmitted?: Maybe<Scalars['Boolean']['output']>;
  colorId?: Maybe<Scalars['String']['output']>;
  conferenceData?: Maybe<GoogleCalendarEventConferenceDataType>;
  created?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<GoogleCalendarEventCreatorType>;
  description?: Maybe<Scalars['String']['output']>;
  end?: Maybe<GoogleCalendarEventStartEndType>;
  endTimeUnspecified?: Maybe<Scalars['Boolean']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  gadget?: Maybe<GoogleCalendarEventGadgetType>;
  guestsCanInviteOthers?: Maybe<Scalars['Boolean']['output']>;
  guestsCanModify?: Maybe<Scalars['Boolean']['output']>;
  guestsCanSeeOtherGuests?: Maybe<Scalars['Boolean']['output']>;
  hangoutLink?: Maybe<Scalars['String']['output']>;
  htmlLink?: Maybe<Scalars['String']['output']>;
  iCalUID?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  organizer?: Maybe<GoogleCalendarEventCreatorType>;
  originalStartTime?: Maybe<GoogleCalendarEventStartEndType>;
  privateCopy?: Maybe<Scalars['Boolean']['output']>;
  recurrence?: Maybe<Array<Scalars['String']['output']>>;
  recurringEventId?: Maybe<Scalars['String']['output']>;
  reminders?: Maybe<GoogleCalendarEventReminderType>;
  sequence?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<GoogleCalendarEventSourceType>;
  start?: Maybe<GoogleCalendarEventStartEndType>;
  status?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  transparency?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

export type GoogleCalendarListResourceType = {
  __typename?: 'GoogleCalendarListResourceType';
  accessRole?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  colorId?: Maybe<Scalars['String']['output']>;
  conferenceProperties?: Maybe<GoogleCalendarConferencePropertiesType>;
  defaultReminders?: Maybe<Array<GoogleCalendarDefaultReminderType>>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  foregroundColor?: Maybe<Scalars['String']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  location?: Maybe<Scalars['String']['output']>;
  notificationSettings?: Maybe<GoogleCalendarNotificationSettingsType>;
  primary?: Maybe<Scalars['Boolean']['output']>;
  selected?: Maybe<Scalars['Boolean']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  summaryOverride?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type GoogleCalendarNotificationSettingsNotificationType = {
  __typename?: 'GoogleCalendarNotificationSettingsNotificationType';
  method: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type GoogleCalendarNotificationSettingsType = {
  __typename?: 'GoogleCalendarNotificationSettingsType';
  notifications: Array<GoogleCalendarNotificationSettingsNotificationType>;
};

export type GoogleCalendarSettingsType = {
  __typename?: 'GoogleCalendarSettingsType';
  etag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GoogleColorType = {
  __typename?: 'GoogleColorType';
  backgroundColor: Scalars['String']['output'];
  textColor: Scalars['String']['output'];
};

export type GoogleDataType = {
  __typename?: 'GoogleDataType';
  email: Scalars['String']['output'];
  email_verified?: Maybe<Scalars['Boolean']['output']>;
  family_name?: Maybe<Scalars['String']['output']>;
  given_name?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  sub: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type GoogleDriveAboutChangesResourceType = {
  __typename?: 'GoogleDriveAboutChangesResourceType';
  changeType?: Maybe<Scalars['String']['output']>;
  drive?: Maybe<GoogleDriveTeamDriveResourceType>;
  driveId?: Maybe<Scalars['String']['output']>;
  file?: Maybe<GoogleDriveFileResourceType>;
  fileId?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  removed?: Maybe<Scalars['Boolean']['output']>;
  teamDrive?: Maybe<GoogleDriveTeamDriveResourceType>;
  teamDriveId?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GoogleDriveAboutStorageQuotaType = {
  __typename?: 'GoogleDriveAboutStorageQuotaType';
  limit?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['String']['output']>;
  usageInDrive?: Maybe<Scalars['String']['output']>;
  usageInDriveTrash?: Maybe<Scalars['String']['output']>;
};

export type GoogleDriveAboutTeamDriveThemesType = {
  __typename?: 'GoogleDriveAboutTeamDriveThemesType';
  backgroundImageLink?: Maybe<Scalars['String']['output']>;
  colorRgb?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type GoogleDriveAboutUserType = {
  __typename?: 'GoogleDriveAboutUserType';
  displayName?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  me?: Maybe<Scalars['Boolean']['output']>;
  permissionId?: Maybe<Scalars['String']['output']>;
  photoLink?: Maybe<Scalars['String']['output']>;
};

export type GoogleDriveBackgroundImageFileType = {
  __typename?: 'GoogleDriveBackgroundImageFileType';
  id?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  xCoordinate?: Maybe<Scalars['Float']['output']>;
  yCoordinate?: Maybe<Scalars['Float']['output']>;
};

export type GoogleDriveContentHintsType = {
  __typename?: 'GoogleDriveContentHintsType';
  indexableText?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<GoogleDriveThumbnailType>;
};

export type GoogleDriveContentRestrictionsType = {
  __typename?: 'GoogleDriveContentRestrictionsType';
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  restrictingUser?: Maybe<GoogleDriveAboutUserType>;
  restrictionTime?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GoogleDriveFileCapabilitiesType = {
  __typename?: 'GoogleDriveFileCapabilitiesType';
  canAddChildren?: Maybe<Scalars['Boolean']['output']>;
  canAddFolderFromAnotherDrive?: Maybe<Scalars['Boolean']['output']>;
  canAddMyDriveParent?: Maybe<Scalars['Boolean']['output']>;
  canChangeCopyRequiresWriterPermission?: Maybe<Scalars['Boolean']['output']>;
  canChangeSecurityUpdateEnabled?: Maybe<Scalars['Boolean']['output']>;
  canChangeViewersCanCopyContent?: Maybe<Scalars['Boolean']['output']>;
  canComment?: Maybe<Scalars['Boolean']['output']>;
  canCopy?: Maybe<Scalars['Boolean']['output']>;
  canDelete?: Maybe<Scalars['Boolean']['output']>;
  canDeleteChildren?: Maybe<Scalars['Boolean']['output']>;
  canDownload?: Maybe<Scalars['Boolean']['output']>;
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  canListChildren?: Maybe<Scalars['Boolean']['output']>;
  canModifyContent?: Maybe<Scalars['Boolean']['output']>;
  canModifyContentRestriction?: Maybe<Scalars['Boolean']['output']>;
  canMoveChildrenOutOfDrive?: Maybe<Scalars['Boolean']['output']>;
  canMoveChildrenOutOfTeamDrive?: Maybe<Scalars['Boolean']['output']>;
  canMoveChildrenWithinDrive?: Maybe<Scalars['Boolean']['output']>;
  canMoveChildrenWithinTeamDrive?: Maybe<Scalars['Boolean']['output']>;
  canMoveItemIntoTeamDrive?: Maybe<Scalars['Boolean']['output']>;
  canMoveItemOutOfDrive?: Maybe<Scalars['Boolean']['output']>;
  canMoveItemOutOfTeamDrive?: Maybe<Scalars['Boolean']['output']>;
  canMoveItemWithinDrive?: Maybe<Scalars['Boolean']['output']>;
  canMoveItemWithinTeamDrive?: Maybe<Scalars['Boolean']['output']>;
  canMoveTeamDriveItem?: Maybe<Scalars['Boolean']['output']>;
  canReadDrive?: Maybe<Scalars['Boolean']['output']>;
  canReadRevisions?: Maybe<Scalars['Boolean']['output']>;
  canReadTeamDrive?: Maybe<Scalars['Boolean']['output']>;
  canRemoveChildren?: Maybe<Scalars['Boolean']['output']>;
  canRemoveMyDriveParent?: Maybe<Scalars['Boolean']['output']>;
  canRename?: Maybe<Scalars['Boolean']['output']>;
  canShare?: Maybe<Scalars['Boolean']['output']>;
  canTrash?: Maybe<Scalars['Boolean']['output']>;
  canTrashChildren?: Maybe<Scalars['Boolean']['output']>;
  canUntrash?: Maybe<Scalars['Boolean']['output']>;
};

export type GoogleDriveFilePermissionsType = {
  __typename?: 'GoogleDriveFilePermissionsType';
  allowFileDiscovery?: Maybe<Scalars['Boolean']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  expirationTime?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  permissionDetails?: Maybe<Array<GoogleDriveTeamDrivePermissionDetailsType>>;
  photoLink?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  teamDrivePermissionDetails?: Maybe<Array<GoogleDriveTeamDrivePermissionDetailsType>>;
  type?: Maybe<Scalars['String']['output']>;
  view?: Maybe<Scalars['String']['output']>;
};

export type GoogleDriveFileResourceType = {
  __typename?: 'GoogleDriveFileResourceType';
  capabilities?: Maybe<GoogleDriveFileCapabilitiesType>;
  contentHints?: Maybe<GoogleDriveContentHintsType>;
  contentRestrictions?: Maybe<Array<GoogleDriveContentRestrictionsType>>;
  copyRequiresWriterPermission?: Maybe<Scalars['Boolean']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  driveId?: Maybe<Scalars['String']['output']>;
  explicitlyTrashed?: Maybe<Scalars['Boolean']['output']>;
  fileExtension?: Maybe<Scalars['String']['output']>;
  folderColorRgb?: Maybe<Scalars['String']['output']>;
  fullFileExtension?: Maybe<Scalars['String']['output']>;
  hasAugmentedPermissions?: Maybe<Scalars['Boolean']['output']>;
  hasThumbnail?: Maybe<Scalars['Boolean']['output']>;
  headRevisionId?: Maybe<Scalars['String']['output']>;
  iconLink?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageMediaMetadata?: Maybe<GoogleDriveImageMediaMetaDataType>;
  isAppAuthorized?: Maybe<Scalars['Boolean']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  lastModifyingUser?: Maybe<GoogleDriveAboutUserType>;
  linkShareMetadata?: Maybe<GoogleDriveLinkShareMetadataType>;
  md5Checksum?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  modifiedByMe?: Maybe<Scalars['Boolean']['output']>;
  modifiedByMeTime?: Maybe<Scalars['String']['output']>;
  modifiedTime?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  originalFilename?: Maybe<Scalars['String']['output']>;
  ownedByMe?: Maybe<Scalars['Boolean']['output']>;
  owners?: Maybe<Array<GoogleDriveAboutUserType>>;
  permissionIds?: Maybe<Array<Scalars['String']['output']>>;
  permissions?: Maybe<Array<GoogleDriveFilePermissionsType>>;
  resourceKey?: Maybe<Scalars['String']['output']>;
  shared?: Maybe<Scalars['Boolean']['output']>;
  sharedWithMeTime?: Maybe<Scalars['String']['output']>;
  sharingUser?: Maybe<GoogleDriveAboutUserType>;
  shortcutDetails?: Maybe<GoogleDriveShortcutDetailsType>;
  spaces?: Maybe<Array<Scalars['String']['output']>>;
  starred?: Maybe<Scalars['Boolean']['output']>;
  teamDriveId?: Maybe<Scalars['String']['output']>;
  thumbnailLink?: Maybe<Scalars['String']['output']>;
  trashed?: Maybe<Scalars['Boolean']['output']>;
  trashedTime?: Maybe<Scalars['String']['output']>;
  trashingUser?: Maybe<GoogleDriveAboutUserType>;
  viewedByMe?: Maybe<Scalars['Boolean']['output']>;
  viewedByMeTime?: Maybe<Scalars['String']['output']>;
  viewersCanCopyContent?: Maybe<Scalars['Boolean']['output']>;
  webContentLink?: Maybe<Scalars['String']['output']>;
  webViewLink?: Maybe<Scalars['String']['output']>;
  writersCanShare?: Maybe<Scalars['Boolean']['output']>;
};

export type GoogleDriveImageMediaMetaDataType = {
  __typename?: 'GoogleDriveImageMediaMetaDataType';
  aperture?: Maybe<Scalars['Float']['output']>;
  cameraMake?: Maybe<Scalars['String']['output']>;
  cameraModel?: Maybe<Scalars['String']['output']>;
  colorSpace?: Maybe<Scalars['String']['output']>;
  exposureBias?: Maybe<Scalars['Float']['output']>;
  exposureMode?: Maybe<Scalars['String']['output']>;
  exposureTime?: Maybe<Scalars['Float']['output']>;
  flashUsed?: Maybe<Scalars['Boolean']['output']>;
  focalLength?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  isoSpeed?: Maybe<Scalars['Int']['output']>;
  lens?: Maybe<Scalars['String']['output']>;
  location?: Maybe<GoogleDriveLocationType>;
  maxApertureValue?: Maybe<Scalars['Float']['output']>;
  meteringMode?: Maybe<Scalars['String']['output']>;
  rotation?: Maybe<Scalars['Int']['output']>;
  sensor?: Maybe<Scalars['String']['output']>;
  subjectDistance?: Maybe<Scalars['Int']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  whiteBalance?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type GoogleDriveLinkShareMetadataType = {
  __typename?: 'GoogleDriveLinkShareMetadataType';
  securityUpdateEligible?: Maybe<Scalars['Boolean']['output']>;
  securityUpdateEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type GoogleDriveLocationType = {
  __typename?: 'GoogleDriveLocationType';
  altitude?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type GoogleDriveRestrictionsType = {
  __typename?: 'GoogleDriveRestrictionsType';
  adminManagedRestrictions?: Maybe<Scalars['Boolean']['output']>;
  copyRequiresWriterPermission?: Maybe<Scalars['Boolean']['output']>;
  domainUsersOnly?: Maybe<Scalars['Boolean']['output']>;
  driveMembersOnly?: Maybe<Scalars['Boolean']['output']>;
};

export type GoogleDriveShortcutDetailsType = {
  __typename?: 'GoogleDriveShortcutDetailsType';
  targetId?: Maybe<Scalars['String']['output']>;
  targetMimeType?: Maybe<Scalars['String']['output']>;
  targetResourceKey?: Maybe<Scalars['String']['output']>;
};

export type GoogleDriveTeamDrivePermissionDetailsType = {
  __typename?: 'GoogleDriveTeamDrivePermissionDetailsType';
  inherited?: Maybe<Scalars['Boolean']['output']>;
  inheritedFrom?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  teamDrivePermissionType?: Maybe<Scalars['String']['output']>;
};

export type GoogleDriveTeamDriveResourceType = {
  __typename?: 'GoogleDriveTeamDriveResourceType';
  backgroundImageFile?: Maybe<GoogleDriveBackgroundImageFileType>;
  capabilities?: Maybe<GoogleDriveFileCapabilitiesType>;
  colorRgb?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  restrictions?: Maybe<GoogleDriveRestrictionsType>;
  themeId?: Maybe<Scalars['String']['output']>;
};

export type GoogleDriveThumbnailType = {
  __typename?: 'GoogleDriveThumbnailType';
  image?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
};

export type GoogleMapsAuditDataLocationType = {
  __typename?: 'GoogleMapsAuditDataLocationType';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type GoogleMapsAuditDataOrderType = {
  __typename?: 'GoogleMapsAuditDataOrderType';
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GoogleMapsAuditDataReviewsType = {
  __typename?: 'GoogleMapsAuditDataReviewsType';
  fiveStar?: Maybe<Scalars['Float']['output']>;
  fourStar?: Maybe<Scalars['Float']['output']>;
  oneStar?: Maybe<Scalars['Float']['output']>;
  threeStar?: Maybe<Scalars['Float']['output']>;
  twoStar?: Maybe<Scalars['Float']['output']>;
};

export type GoogleMapsAuditDataType = {
  __typename?: 'GoogleMapsAuditDataType';
  address?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Array<Scalars['String']['output']>>;
  categoryName?: Maybe<Scalars['String']['output']>;
  cid?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  isAdvertisement?: Maybe<Scalars['Boolean']['output']>;
  locatedIn?: Maybe<Scalars['String']['output']>;
  location?: Maybe<GoogleMapsAuditDataLocationType>;
  menu?: Maybe<Scalars['String']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  orderBy?: Maybe<GoogleMapsAuditDataOrderType>;
  permanentlyClosed?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  plusCode?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  reviews?: Maybe<Array<Scalars['String']['output']>>;
  reviewsCount?: Maybe<Scalars['Float']['output']>;
  reviewsDistribution?: Maybe<GoogleMapsAuditDataReviewsType>;
  scrapedAt?: Maybe<Scalars['DateTime']['output']>;
  searchPageUrl?: Maybe<Scalars['String']['output']>;
  searchString?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  temporarilyClosed?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalScore?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type GoogleSearchAuditDataCustomDataType = {
  __typename?: 'GoogleSearchAuditDataCustomDataType';
  pageTitle?: Maybe<Scalars['String']['output']>;
};

export type GoogleSearchAuditDataDebugType = {
  __typename?: 'GoogleSearchAuditDataDebugType';
  durationSecs?: Maybe<Scalars['Float']['output']>;
  errorMessages?: Maybe<Array<Scalars['String']['output']>>;
  method?: Maybe<Scalars['String']['output']>;
  requestId?: Maybe<Scalars['String']['output']>;
  retryCount?: Maybe<Scalars['Float']['output']>;
  statusCode?: Maybe<Scalars['Float']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GoogleSearchAuditDataRelatedQueriesType = {
  __typename?: 'GoogleSearchAuditDataRelatedQueriesType';
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GoogleSearchAuditDataResultsProductType = {
  __typename?: 'GoogleSearchAuditDataResultsProductType';
  numberOfReviews?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

export type GoogleSearchAuditDataResultsType = {
  __typename?: 'GoogleSearchAuditDataResultsType';
  description?: Maybe<Scalars['String']['output']>;
  displayedUrl?: Maybe<Scalars['String']['output']>;
  emphasizedKeywords?: Maybe<Array<Scalars['String']['output']>>;
  productInfo?: Maybe<GoogleSearchAuditDataResultsProductType>;
  siteLinks?: Maybe<Array<GoogleSearchAuditDataSiteLinksType>>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GoogleSearchAuditDataSearchQueryType = {
  __typename?: 'GoogleSearchAuditDataSearchQueryType';
  countryCode?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  locationUule?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Scalars['Float']['output']>;
  resultsPerPage?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GoogleSearchAuditDataSiteLinksType = {
  __typename?: 'GoogleSearchAuditDataSiteLinksType';
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type GoogleSearchAuditDataType = {
  __typename?: 'GoogleSearchAuditDataType';
  customData?: Maybe<GoogleSearchAuditDataCustomDataType>;
  debug?: Maybe<GoogleSearchAuditDataDebugType>;
  error?: Maybe<Scalars['Boolean']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  htmlSnapshotUrl?: Maybe<Scalars['String']['output']>;
  organicResults?: Maybe<Array<GoogleSearchAuditDataResultsType>>;
  paidProducts?: Maybe<Array<GoogleSearchAuditDataResultsType>>;
  paidResults?: Maybe<Array<GoogleSearchAuditDataResultsType>>;
  relatedQueries?: Maybe<Array<GoogleSearchAuditDataRelatedQueriesType>>;
  resultsTotal?: Maybe<Scalars['Float']['output']>;
  searchQuery?: Maybe<GoogleSearchAuditDataSearchQueryType>;
  serpProviderCode?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum GroupInviteStatusEnum {
  CANCELED = 'CANCELED',
  CONFIRMED = 'CONFIRMED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export type GroupInviteType = {
  __typename?: 'GroupInviteType';
  createdAt: Scalars['DateTime']['output'];
  group?: Maybe<GroupType>;
  id: Scalars['ID']['output'];
  requestor?: Maybe<UserType>;
  status?: Maybe<GroupInviteStatusEnum>;
  updatedAt: Scalars['DateTime']['output'];
};

export type GroupLeaderboardBaseType = {
  __typename?: 'GroupLeaderboardBaseType';
  credit: Scalars['Decimal']['output'];
  effectiveDate: Scalars['DateTime']['output'];
  group: GroupType;
  rank: Scalars['Int']['output'];
  rankDifference: Scalars['Int']['output'];
  user: UserType;
};

export type GroupLeaderboardType = {
  __typename?: 'GroupLeaderboardType';
  createdAt: Scalars['DateTime']['output'];
  credit: Scalars['Decimal']['output'];
  effectiveDate: Scalars['DateTime']['output'];
  group: GroupType;
  id: Scalars['ID']['output'];
  rank: Scalars['Int']['output'];
  rankDifference: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export enum GroupPrivacyEnum {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export type GroupType = {
  __typename?: 'GroupType';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  members: Array<UserType>;
  moderators: Array<UserType>;
  name: Scalars['String']['output'];
  picture?: Maybe<NestedPicturesType>;
  privacy: GroupPrivacyEnum;
  updatedAt: Scalars['DateTime']['output'];
};

export type GuestUserType = {
  __typename?: 'GuestUserType';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<IPhoneType>;
};

export type HeadToHeadType = {
  __typename?: 'HeadToHeadType';
  createdAt: Scalars['DateTime']['output'];
  fixture?: Maybe<FixtureSubType>;
  goals?: Maybe<FixtureGoalsType>;
  id: Scalars['ID']['output'];
  league?: Maybe<FixtureLeagueType>;
  score?: Maybe<FixtureScoreType>;
  teams?: Maybe<FixtureTeamsType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type HelpdeskIntegrationInput = {
  prefix?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<TargetAciInput>;
};

export type HelpdeskIntegrationType = {
  __typename?: 'HelpdeskIntegrationType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  prefix?: Maybe<Scalars['String']['output']>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type IPhoneInput = {
  /** Phone country code */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  number?: InputMaybe<Scalars['String']['input']>;
};

export type IPhoneType = {
  __typename?: 'IPhoneType';
  countryCode?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type IQuestActivityActivitiesConditionConditionActionType = {
  __typename?: 'IQuestActivityActivitiesConditionConditionActionType';
  action?: Maybe<QuestActionActionType>;
  definition?: Maybe<QuestActivityIntType>;
};

export type IQuestActivityActivitiesConditionConditionScoreType = {
  __typename?: 'IQuestActivityActivitiesConditionConditionScoreType';
  operator?: Maybe<OperatorEnum>;
  value?: Maybe<OperatorEnum>;
};

export type IQuestActivityActivitiesConditionTransitionGotoType = {
  __typename?: 'IQuestActivityActivitiesConditionTransitionGotoType';
  action?: Maybe<QuestActivityIntType>;
};

export type IQuestActivityActivitiesInput = {
  action?: InputMaybe<Scalars['ID']['input']>;
  transition?: InputMaybe<IQuestActivityActivitiesTransitionInput>;
};

export type IQuestActivityActivitiesTransitionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IQuestActivityActivitiesTransitionType = {
  __typename?: 'IQuestActivityActivitiesTransitionType';
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type IQuestActivityActivitiesType = {
  __typename?: 'IQuestActivityActivitiesType';
  action?: Maybe<QuestActionDefinitionType>;
  transition?: Maybe<IQuestActivityActivitiesTransitionType>;
};

export type ImpressionsFieldType = {
  __typename?: 'ImpressionsFieldType';
  current: Scalars['Int']['output'];
  percentage?: Maybe<Scalars['Decimal']['output']>;
  previous: Scalars['Int']['output'];
  weeklyImpressions: Array<PeriodStatsType>;
};

export type InPlayOddsBookmakersType = {
  __typename?: 'InPlayOddsBookmakersType';
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<InPlayOddsBookmakersValueType>>;
};

export type InPlayOddsBookmakersValueType = {
  __typename?: 'InPlayOddsBookmakersValueType';
  handicap?: Maybe<Scalars['String']['output']>;
  main?: Maybe<Scalars['Boolean']['output']>;
  odd?: Maybe<Scalars['String']['output']>;
  suspended?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InPlayOddsFixtureStatusType = {
  __typename?: 'InPlayOddsFixtureStatusType';
  elapsed?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['String']['output']>;
  seconds?: Maybe<Scalars['String']['output']>;
};

export type InPlayOddsFixtureType = {
  __typename?: 'InPlayOddsFixtureType';
  id?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<InPlayOddsFixtureStatusType>;
};

export type InPlayOddsLeagueType = {
  __typename?: 'InPlayOddsLeagueType';
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
};

export type InPlayOddsStatusType = {
  __typename?: 'InPlayOddsStatusType';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  finished?: Maybe<Scalars['Boolean']['output']>;
  stopped?: Maybe<Scalars['Boolean']['output']>;
};

export type InPlayOddsTeamsHaType = {
  __typename?: 'InPlayOddsTeamsHAType';
  goals?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type InPlayOddsTeamsType = {
  __typename?: 'InPlayOddsTeamsType';
  away?: Maybe<InPlayOddsTeamsHaType>;
  home?: Maybe<InPlayOddsTeamsHaType>;
};

export type InPlayOddsType = {
  __typename?: 'InPlayOddsType';
  fixture?: Maybe<InPlayOddsFixtureType>;
  id: Scalars['ID']['output'];
  league?: Maybe<InPlayOddsLeagueType>;
  odds?: Maybe<Array<InPlayOddsBookmakersType>>;
  status?: Maybe<InPlayOddsStatusType>;
  teams?: Maybe<InPlayOddsTeamsType>;
  update?: Maybe<Scalars['DateTime']['output']>;
};

export type InactivityInput = {
  actions?: InputMaybe<Array<TransactionTypeEnum>>;
};

export type InactivityType = {
  __typename?: 'InactivityType';
  actions?: Maybe<Array<TransactionTypeEnum>>;
};

export type InjuriesFixtureType = {
  __typename?: 'InjuriesFixtureType';
  date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  timestamp?: Maybe<Scalars['Float']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type InjuriesLeagueType = {
  __typename?: 'InjuriesLeagueType';
  country?: Maybe<Scalars['String']['output']>;
  flag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
};

export type InjuriesPlayerType = {
  __typename?: 'InjuriesPlayerType';
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type InjuriesTeamType = {
  __typename?: 'InjuriesTeamType';
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type InjuriesType = {
  __typename?: 'InjuriesType';
  createdAt: Scalars['DateTime']['output'];
  fixture?: Maybe<InjuriesFixtureType>;
  id: Scalars['ID']['output'];
  league?: Maybe<InjuriesLeagueType>;
  player?: Maybe<InjuriesPlayerType>;
  team?: Maybe<InjuriesTeamType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type InsightsBreakdownsInput = {
  topCountries: Array<Scalars['String']['input']>;
  topDevice: Scalars['String']['input'];
  weakDevice: Scalars['String']['input'];
};

export type InsightsGenerationDetailsType = {
  __typename?: 'InsightsGenerationDetailsType';
  ollamaModel?: Maybe<Scalars['String']['output']>;
  usedOllama: Scalars['Boolean']['output'];
};

export type InsightsKpisInput = {
  clicks: Scalars['Float']['input'];
  clicks_change: Scalars['Float']['input'];
  conversion_rate: Scalars['Float']['input'];
  conversion_rate_change: Scalars['Float']['input'];
  conversions: Scalars['Float']['input'];
  conversions_change: Scalars['Float']['input'];
  ctr: Scalars['Float']['input'];
  ctr_change: Scalars['Float']['input'];
  impressions: Scalars['Float']['input'];
  impressions_change: Scalars['Float']['input'];
  revenue: Scalars['Float']['input'];
  revenue_change: Scalars['Float']['input'];
  rpm: Scalars['Float']['input'];
  rpm_change: Scalars['Float']['input'];
};

export type InstagramProfileAuditDataIvgType = {
  __typename?: 'InstagramProfileAuditDataIVGType';
  caption?: Maybe<Scalars['String']['output']>;
  commentsCount?: Maybe<Scalars['Float']['output']>;
  commentsDisabled?: Maybe<Scalars['Boolean']['output']>;
  dimensionsHeight?: Maybe<Scalars['Float']['output']>;
  dimensionsWidth?: Maybe<Scalars['Float']['output']>;
  displayUrl?: Maybe<Scalars['String']['output']>;
  likesCount?: Maybe<Scalars['Float']['output']>;
  shortCode?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  videoDuration?: Maybe<Scalars['Float']['output']>;
  videoViewCount?: Maybe<Scalars['Float']['output']>;
};

export type InstagramProfileAuditDataLatestType = {
  __typename?: 'InstagramProfileAuditDataLatestType';
  alt?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  childPosts?: Maybe<Array<Scalars['String']['output']>>;
  commentsCount?: Maybe<Scalars['Float']['output']>;
  dimensionsHeight?: Maybe<Scalars['Float']['output']>;
  dimensionsWidth?: Maybe<Scalars['Float']['output']>;
  displayUrl?: Maybe<Scalars['String']['output']>;
  firstComment?: Maybe<Scalars['String']['output']>;
  hashtags?: Maybe<Array<Scalars['String']['output']>>;
  id?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Scalars['String']['output']>>;
  latestComments?: Maybe<Array<Scalars['String']['output']>>;
  likesCount?: Maybe<Scalars['Float']['output']>;
  mentions?: Maybe<Array<Scalars['String']['output']>>;
  ownerId?: Maybe<Scalars['String']['output']>;
  ownerUsername?: Maybe<Scalars['String']['output']>;
  shortCode?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type InstagramProfileAuditDataType = {
  __typename?: 'InstagramProfileAuditDataType';
  biography?: Maybe<Scalars['String']['output']>;
  businessCategoryName?: Maybe<Scalars['String']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  externalUrlShimmed?: Maybe<Scalars['String']['output']>;
  facebookPage?: Maybe<Scalars['String']['output']>;
  followersCount?: Maybe<Scalars['Float']['output']>;
  followsCount?: Maybe<Scalars['Float']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  hasChannel?: Maybe<Scalars['Boolean']['output']>;
  highlightReelCount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  igtvVideoCount?: Maybe<Scalars['Float']['output']>;
  isBusinessAccount?: Maybe<Scalars['Boolean']['output']>;
  joinedRecently?: Maybe<Scalars['Boolean']['output']>;
  latestIgtvVideos?: Maybe<Array<InstagramProfileAuditDataIvgType>>;
  latestPosts?: Maybe<Array<InstagramProfileAuditDataLatestType>>;
  postsCount?: Maybe<Scalars['Float']['output']>;
  private?: Maybe<Scalars['Boolean']['output']>;
  profilePicUrl?: Maybe<Scalars['String']['output']>;
  profilePicUrlHD?: Maybe<Scalars['String']['output']>;
  relatedProfiles?: Maybe<Array<Scalars['String']['output']>>;
  username?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type InstallmentInput = {
  amount: Scalars['Decimal']['input'];
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  paidAt?: InputMaybe<Scalars['DateTime']['input']>;
  paymentMethod: Scalars['ID']['input'];
  paymentStatus: PaymentStatusEnum;
  wallet?: InputMaybe<Scalars['ID']['input']>;
};

export type InstallmentPaymentInput = {
  installmentId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
  source?: InputMaybe<UserEventsSourceEnum>;
};

export type InstallmentType = {
  __typename?: 'InstallmentType';
  _id: Scalars['ID']['output'];
  amount: Scalars['Decimal']['output'];
  deadline?: Maybe<Scalars['DateTime']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paymentMethod: PaymentType;
  paymentStatus: PaymentStatusEnum;
  user?: Maybe<UserType>;
  wallet?: Maybe<WalletType>;
};

export type InstallmentUpdateInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  paidAt?: InputMaybe<Scalars['DateTime']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationIntegrationAccessType = {
  __typename?: 'IntegrationIntegrationAccessType';
  publicKey?: Maybe<Scalars['String']['output']>;
  secretKey?: Maybe<Scalars['String']['output']>;
};

export type IntegrationIntegrationEndpointsInput = {
  loyalty?: InputMaybe<IntegrationIntegrationEndpointsLoyaltyInput>;
  purchase?: InputMaybe<Scalars['Boolean']['input']>;
  sales?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IntegrationIntegrationEndpointsLoyaltyInput = {
  onsiteconverter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IntegrationIntegrationEndpointsLoyaltyType = {
  __typename?: 'IntegrationIntegrationEndpointsLoyaltyType';
  onsiteconverter?: Maybe<Scalars['Boolean']['output']>;
};

export type IntegrationIntegrationEndpointsType = {
  __typename?: 'IntegrationIntegrationEndpointsType';
  loyalty?: Maybe<IntegrationIntegrationEndpointsLoyaltyType>;
  purchase?: Maybe<Scalars['Boolean']['output']>;
  sales?: Maybe<Scalars['Boolean']['output']>;
};

export type IntegrationIntegrationInput = {
  endpoints?: InputMaybe<IntegrationIntegrationEndpointsInput>;
  target?: InputMaybe<TargetAciInput>;
};

export type IntegrationIntegrationType = {
  __typename?: 'IntegrationIntegrationType';
  access?: Maybe<Array<IntegrationIntegrationAccessType>>;
  createdAt: Scalars['DateTime']['output'];
  endpoints?: Maybe<IntegrationIntegrationEndpointsType>;
  id: Scalars['ID']['output'];
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type InternalProductAttributeInnerInput = {
  price?: InputMaybe<Scalars['Decimal']['input']>;
  productAttribute: Scalars['String']['input'];
  selectedValue: Scalars['String']['input'];
};

export type InternalProductAttributeInnerType = {
  __typename?: 'InternalProductAttributeInnerType';
  price?: Maybe<Scalars['Decimal']['output']>;
  productAttribute?: Maybe<ProductAttributeType>;
  selectedValue?: Maybe<Scalars['String']['output']>;
};

export type InternalProductAttributeInput = {
  attributes?: InputMaybe<Array<InternalProductAttributeInnerInput>>;
};

export type InternalProductAttributeType = {
  __typename?: 'InternalProductAttributeType';
  attributes?: Maybe<Array<InternalProductAttributeInnerType>>;
};

export type InternalProductAttributesValuesBaseType = {
  __typename?: 'InternalProductAttributesValuesBaseType';
  attributesValues?: Maybe<Array<AttributeValueBaseRawType>>;
};

export type InternalProductAttributesValuesFilterType = {
  __typename?: 'InternalProductAttributesValuesFilterType';
  attributesValues?: Maybe<Array<AttributeValueFilterType>>;
};

export type InternalProductAttributesValuesType = {
  __typename?: 'InternalProductAttributesValuesType';
  attributesValues?: Maybe<Array<AttributeValueType>>;
};

export type InternalProductByClassType = {
  __typename?: 'InternalProductByClassType';
  BEST_SELLERS?: Maybe<Array<InternalProductWithoutClassType>>;
  FEATURED_PRODUCTS?: Maybe<Array<InternalProductWithoutClassType>>;
  NEW_ARRIVALS?: Maybe<Array<InternalProductWithoutClassType>>;
  PROMO?: Maybe<Array<InternalProductWithoutClassType>>;
  TOP_PRODUCTS?: Maybe<Array<InternalProductWithoutClassType>>;
};

export type InternalProductByClassTypeWithFavoriteStatus = {
  __typename?: 'InternalProductByClassTypeWithFavoriteStatus';
  BEST_SELLERS?: Maybe<Array<InternalProductWithoutClassWithFavoriteStatusType>>;
  FEATURED_PRODUCTS?: Maybe<Array<InternalProductWithoutClassWithFavoriteStatusType>>;
  NEW_ARRIVALS?: Maybe<Array<InternalProductWithoutClassWithFavoriteStatusType>>;
  PROMO?: Maybe<Array<InternalProductWithoutClassWithFavoriteStatusType>>;
  TOP_PRODUCTS?: Maybe<Array<InternalProductWithoutClassWithFavoriteStatusType>>;
};

export type InternalProductFilterInput = {
  attributesValues?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** list of brands ids */
  brand?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** list of catalogueCategories ids */
  catalogueCategory?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** list of inventoryCategories ids */
  category?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** list of internalProduct classes */
  classification?: InputMaybe<Array<ProductClassEnum>>;
  condition?: InputMaybe<Array<ProductConditionEnum>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  fromPrice?: InputMaybe<Scalars['Decimal']['input']>;
  rent?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<ProductStatusEnum>>;
  structure?: InputMaybe<Array<ProductStructureEnum>>;
  target: TargetsInput;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  toPrice?: InputMaybe<Scalars['Decimal']['input']>;
  variety?: InputMaybe<Array<ProductVarietyEnum>>;
};

export type InternalProductFilterType = {
  __typename?: 'InternalProductFilterType';
  /** list of brands */
  brands?: Maybe<Array<FilterNameFieldType>>;
  /** list of catalogueCategories */
  catalogueCategories?: Maybe<Array<FilterNameFieldType>>;
  createdAtRange?: Maybe<DateRangeType>;
  priceRange?: Maybe<PriceRangeType>;
  /** list of AttributeValues */
  productAttributesValues?: Maybe<Array<AttributeWithValueFilterType>>;
  targets?: Maybe<TargetsType>;
  updatedAtRange?: Maybe<DateRangeType>;
};

export type InternalProductForPartnershipNetworkFilterInput = {
  fromPrice?: InputMaybe<Scalars['Decimal']['input']>;
  partners?: InputMaybe<TargetsInput>;
  toPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type InternalProductForPartnershipNetworkFilterType = {
  __typename?: 'InternalProductForPartnershipNetworkFilterType';
  priceRange?: Maybe<PriceRangeType>;
  targets?: Maybe<TargetsType>;
};

export type InternalProductForPartnershipNetworkWithTargetPictureAndRatingsPaginateWithFavoriteStatusWithFilterType = {
  __typename?: 'InternalProductForPartnershipNetworkWithTargetPictureAndRatingsPaginateWithFavoriteStatusWithFilterType';
  count?: Maybe<Scalars['Int']['output']>;
  filter?: Maybe<InternalProductForPartnershipNetworkFilterType>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<InternalProductWithRatingsTargetPictureWithFavoriteStatusType>;
};

export type InternalProductMaintenanceInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  expectedMeantime?: InputMaybe<Scalars['Int']['input']>;
  maintenanceDuration?: InputMaybe<Scalars['Int']['input']>;
  owner?: InputMaybe<Scalars['ID']['input']>;
  prevMaintenanceDuration?: InputMaybe<Scalars['Int']['input']>;
  technician?: InputMaybe<Scalars['ID']['input']>;
};

export type InternalProductMaintenanceType = {
  __typename?: 'InternalProductMaintenanceType';
  active?: Maybe<Scalars['Boolean']['output']>;
  expectedMeantime?: Maybe<Scalars['Int']['output']>;
  maintenanceDuration?: Maybe<Scalars['Int']['output']>;
  owner?: Maybe<UserType>;
  prevMaintenanceDuration?: Maybe<Scalars['Int']['output']>;
  technician?: Maybe<UserType>;
};

export type InternalProductPaginateType = {
  __typename?: 'InternalProductPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<InternalProductType>;
};

export type InternalProductPaginateWithFilterType = {
  __typename?: 'InternalProductPaginateWithFilterType';
  count?: Maybe<Scalars['Int']['output']>;
  filter?: Maybe<InternalProductFilterType>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<InternalProductType>;
};

export type InternalProductTranslationContentInput = {
  description: Scalars['String']['input'];
  descriptionList?: InputMaybe<Array<Scalars['String']['input']>>;
  longdesc?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  specs?: InputMaybe<Array<ProductSpecsInput>>;
};

export type InternalProductTranslationContentType = {
  __typename?: 'InternalProductTranslationContentType';
  description: Scalars['String']['output'];
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  longdesc?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  specs?: Maybe<Array<ProductSpecsType>>;
};

export type InternalProductTranslationInput = {
  content: InternalProductTranslationContentInput;
  language: Scalars['ID']['input'];
};

export type InternalProductTranslationType = {
  __typename?: 'InternalProductTranslationType';
  content: InternalProductTranslationContentType;
  language: LanguageType;
};

export type InternalProductType = {
  __typename?: 'InternalProductType';
  barcodes?: Maybe<Array<BarcodeWithPublicPriceType>>;
  brand?: Maybe<BrandType>;
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  classification?: Maybe<Array<ProductClassEnum>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  discount?: Maybe<DiscountDtoType>;
  externalId?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<ProductFlagEnum>>;
  globalCategory?: Maybe<GlobalCategoryProductType>;
  id?: Maybe<Scalars['ID']['output']>;
  longdesc?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<ProductType>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  sku?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<Array<ProductSpecsType>>;
  status?: Maybe<ProductStatusEnum>;
  structure?: Maybe<ProductStructureEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetType;
  tax?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<InternalProductTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variety?: Maybe<ProductVarietyEnum>;
};

export type InternalProductWithBarcodesWithPublicPricePaginateType = {
  __typename?: 'InternalProductWithBarcodesWithPublicPricePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<InternalProductWithBarcodesWithPublicPriceType>;
};

export type InternalProductWithBarcodesWithPublicPriceType = {
  __typename?: 'InternalProductWithBarcodesWithPublicPriceType';
  barcodes?: Maybe<Array<BarcodeWithPublicPriceType>>;
  brand?: Maybe<BrandType>;
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  classification?: Maybe<Array<ProductClassEnum>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  discount?: Maybe<DiscountDtoType>;
  externalId?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<ProductFlagEnum>>;
  globalCategory?: Maybe<GlobalCategoryProductType>;
  id?: Maybe<Scalars['ID']['output']>;
  longdesc?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<ProductType>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  sku?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<Array<ProductSpecsType>>;
  status?: Maybe<ProductStatusEnum>;
  structure?: Maybe<ProductStructureEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetType;
  tax?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<InternalProductTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variety?: Maybe<ProductVarietyEnum>;
};

export type InternalProductWithFavoriteStatusPaginateType = {
  __typename?: 'InternalProductWithFavoriteStatusPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<InternalProductWithFavoriteStatusType>;
};

export type InternalProductWithFavoriteStatusType = {
  __typename?: 'InternalProductWithFavoriteStatusType';
  barcodes?: Maybe<Array<BarcodeWithPublicPriceType>>;
  brand?: Maybe<BrandType>;
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  classification?: Maybe<Array<ProductClassEnum>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  discount?: Maybe<DiscountDtoType>;
  externalId?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<ProductFlagEnum>>;
  globalCategory?: Maybe<GlobalCategoryProductType>;
  id?: Maybe<Scalars['ID']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  longdesc?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<ProductType>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  sku?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<Array<ProductSpecsType>>;
  status?: Maybe<ProductStatusEnum>;
  structure?: Maybe<ProductStructureEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetType;
  tax?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<InternalProductTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variety?: Maybe<ProductVarietyEnum>;
};

export type InternalProductWithRatingsPaginateWithFavoriteStatusType = {
  __typename?: 'InternalProductWithRatingsPaginateWithFavoriteStatusType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<InternalProductWithRatingsWithFavoriteStatusType>;
};

export type InternalProductWithRatingsPaginateWithFavoriteStatusWithFilterType = {
  __typename?: 'InternalProductWithRatingsPaginateWithFavoriteStatusWithFilterType';
  count?: Maybe<Scalars['Int']['output']>;
  filter?: Maybe<InternalProductFilterType>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<InternalProductWithRatingsWithFavoriteStatusType>;
};

export type InternalProductWithRatingsPaginateWithFilterType = {
  __typename?: 'InternalProductWithRatingsPaginateWithFilterType';
  count?: Maybe<Scalars['Int']['output']>;
  filter?: Maybe<InternalProductFilterType>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<InternalProductWithRatingsType>;
};

export type InternalProductWithRatingsTargetPictureWithFavoriteStatusType = {
  __typename?: 'InternalProductWithRatingsTargetPictureWithFavoriteStatusType';
  barcodes?: Maybe<Array<BarcodeWithPublicPriceType>>;
  brand?: Maybe<SimpleBrandType>;
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  classification?: Maybe<Array<ProductClassEnum>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  discount?: Maybe<DiscountDtoType>;
  externalId?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<ProductFlagEnum>>;
  id?: Maybe<Scalars['ID']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  longdesc?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<ProductType>;
  ratings?: Maybe<Scalars['Decimal']['output']>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  sku?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<Array<ProductSpecsType>>;
  status?: Maybe<ProductStatusEnum>;
  structure?: Maybe<ProductStructureEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetWithPictureFilterType;
  tax?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<InternalProductTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variety?: Maybe<ProductVarietyEnum>;
};

export type InternalProductWithRatingsType = {
  __typename?: 'InternalProductWithRatingsType';
  barcodes?: Maybe<Array<BarcodeWithPublicPriceType>>;
  brand?: Maybe<BrandType>;
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  classification?: Maybe<Array<ProductClassEnum>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  discount?: Maybe<DiscountDtoType>;
  externalId?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<ProductFlagEnum>>;
  id?: Maybe<Scalars['ID']['output']>;
  longdesc?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<ProductType>;
  ratings?: Maybe<Scalars['Decimal']['output']>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  sku?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<Array<ProductSpecsType>>;
  status?: Maybe<ProductStatusEnum>;
  structure?: Maybe<ProductStructureEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetFilterType;
  tax?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<InternalProductTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variety?: Maybe<ProductVarietyEnum>;
};

export type InternalProductWithRatingsWithFavoriteStatusType = {
  __typename?: 'InternalProductWithRatingsWithFavoriteStatusType';
  barcodes?: Maybe<Array<BarcodeWithPublicPriceType>>;
  brand?: Maybe<BrandType>;
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  classification?: Maybe<Array<ProductClassEnum>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  discount?: Maybe<DiscountDtoType>;
  externalId?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<ProductFlagEnum>>;
  id?: Maybe<Scalars['ID']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  longdesc?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<ProductType>;
  ratings?: Maybe<Scalars['Decimal']['output']>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  sku?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<Array<ProductSpecsType>>;
  status?: Maybe<ProductStatusEnum>;
  structure?: Maybe<ProductStructureEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetFilterType;
  tax?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<InternalProductTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variety?: Maybe<ProductVarietyEnum>;
};

export type InternalProductWithStatsType = {
  __typename?: 'InternalProductWithStatsType';
  barcodes?: Maybe<Array<BarcodeWithPublicPriceType>>;
  brand?: Maybe<BrandType>;
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  classification?: Maybe<Array<ProductClassEnum>>;
  clicks?: Maybe<Array<Array<Scalars['Float']['output']>>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  discount?: Maybe<DiscountDtoType>;
  externalId?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<ProductFlagEnum>>;
  globalCategory?: Maybe<GlobalCategoryProductType>;
  id?: Maybe<Scalars['ID']['output']>;
  longdesc?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<ProductType>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  sku?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<Array<ProductSpecsType>>;
  status?: Maybe<ProductStatusEnum>;
  structure?: Maybe<ProductStructureEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetType;
  tax?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<InternalProductTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variety?: Maybe<ProductVarietyEnum>;
};

export type InternalProductWithStockType = {
  __typename?: 'InternalProductWithStockType';
  barcodes?: Maybe<Array<BarcodeWithPublicPriceType>>;
  brand?: Maybe<BrandType>;
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  classification?: Maybe<Array<ProductClassEnum>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  discount?: Maybe<DiscountDtoType>;
  externalId?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<ProductFlagEnum>>;
  globalCategory?: Maybe<GlobalCategoryProductType>;
  id?: Maybe<Scalars['ID']['output']>;
  longdesc?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<ProductType>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  sku?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<Array<ProductSpecsType>>;
  status?: Maybe<ProductStatusEnum>;
  stock?: Maybe<StockRawType>;
  structure?: Maybe<ProductStructureEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetType;
  tax?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<InternalProductTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variety?: Maybe<ProductVarietyEnum>;
};

export type InternalProductWithTargetPictureAndFilterAndPriceInCoinsType = {
  __typename?: 'InternalProductWithTargetPictureAndFilterAndPriceInCoinsType';
  barcodes?: Maybe<Array<BarcodeWithPublicPriceAndPriceInCoinsType>>;
  brand?: Maybe<BrandType>;
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  classification?: Maybe<Array<ProductClassEnum>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  discount?: Maybe<DiscountDtoType>;
  externalId?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<ProductFlagEnum>>;
  id?: Maybe<Scalars['ID']['output']>;
  longdesc?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<ProductType>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  sku?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<Array<ProductSpecsType>>;
  status?: Maybe<ProductStatusEnum>;
  structure?: Maybe<ProductStructureEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetWithPictureFilterType;
  tax?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<InternalProductTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variety?: Maybe<ProductVarietyEnum>;
};

export type InternalProductWithTargetPictureAndFilterAndPriceInCoinsTypePaginationType = {
  __typename?: 'InternalProductWithTargetPictureAndFilterAndPriceInCoinsTypePaginationType';
  count?: Maybe<Scalars['Int']['output']>;
  filter?: Maybe<InternalProductFilterType>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<InternalProductWithTargetPictureAndFilterAndPriceInCoinsType>;
};

export type InternalProductWithoutClassType = {
  __typename?: 'InternalProductWithoutClassType';
  barcodes?: Maybe<Array<BarcodeWithPublicPriceType>>;
  brand?: Maybe<BrandType>;
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  discount?: Maybe<DiscountDtoType>;
  externalId?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<ProductFlagEnum>>;
  globalCategory?: Maybe<GlobalCategoryProductType>;
  id?: Maybe<Scalars['ID']['output']>;
  internalProductAttributes?: Maybe<InternalProductAttributeType>;
  longdesc?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<ProductType>;
  ratings?: Maybe<Scalars['Decimal']['output']>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  sku?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<Array<ProductSpecsType>>;
  status?: Maybe<ProductStatusEnum>;
  structure?: Maybe<ProductStructureEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetType;
  tax?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<InternalProductTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variety?: Maybe<ProductVarietyEnum>;
};

export type InternalProductWithoutClassWithFavoriteStatusType = {
  __typename?: 'InternalProductWithoutClassWithFavoriteStatusType';
  barcodes?: Maybe<Array<BarcodeWithPublicPriceType>>;
  brand?: Maybe<BrandType>;
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  discount?: Maybe<DiscountDtoType>;
  externalId?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<ProductFlagEnum>>;
  globalCategory?: Maybe<GlobalCategoryProductType>;
  id?: Maybe<Scalars['ID']['output']>;
  internalProductAttributes?: Maybe<InternalProductAttributeType>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  longdesc?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<ProductType>;
  ratings?: Maybe<Scalars['Decimal']['output']>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  sku?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<Array<ProductSpecsType>>;
  status?: Maybe<ProductStatusEnum>;
  structure?: Maybe<ProductStructureEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetType;
  tax?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<InternalProductTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variety?: Maybe<ProductVarietyEnum>;
};

export type InternalProductsByCatalogueCategoryCountType = {
  __typename?: 'InternalProductsByCatalogueCategoryCountType';
  booking?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  delivery?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  hasChildren: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  layer: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  numberOfProducts: Scalars['Int']['output'];
  parent?: Maybe<CatalogueCategoryBaseType>;
  pickup?: Maybe<Scalars['Boolean']['output']>;
  pictures?: Maybe<Array<PictureType>>;
  portal?: Maybe<Scalars['Boolean']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  translation?: Maybe<Array<CatalogueCategoryTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  variety?: Maybe<ProductVarietyEnum>;
};

export type InternalProductsByInventoryCategoryCountType = {
  __typename?: 'InternalProductsByInventoryCategoryCountType';
  createdAt: Scalars['DateTime']['output'];
  hasChildren: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  layer: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  numberOfProducts: Scalars['Int']['output'];
  picture?: Maybe<PictureType>;
  rank: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InternalProductsByManufacturerCountType = {
  __typename?: 'InternalProductsByManufacturerCountType';
  address?: Maybe<FullAddressType>;
  contactEmails?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  currencies?: Maybe<Array<TargetCurrencyType>>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  numberOfManufacturerProducts: Scalars['Int']['output'];
  picture?: Maybe<PictureType>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type InternalProductsByPosCountType = {
  __typename?: 'InternalProductsByPOSCountType';
  aggregator?: Maybe<Scalars['Boolean']['output']>;
  apps?: Maybe<Array<PointOfSaleAppsType>>;
  averageCustomers?: Maybe<Scalars['Float']['output']>;
  brandColor?: Maybe<Scalars['String']['output']>;
  chatContact?: Maybe<Array<SocialValueType>>;
  contactEmails?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  currencies?: Maybe<Array<TargetCurrencyType>>;
  dashboard?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  insidePictures?: Maybe<Array<PictureType>>;
  isFollowed?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Array<LanguageType>>;
  locations?: Maybe<Array<FullAddressType>>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfPosProducts: Scalars['Int']['output'];
  openingHours?: Maybe<OpeningHoursType>;
  outsidePictures?: Maybe<Array<PictureType>>;
  phone?: Maybe<Array<Scalars['String']['output']>>;
  picture?: Maybe<PictureType>;
  published?: Maybe<Scalars['Boolean']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  socialMedia?: Maybe<Array<SocialValueType>>;
  specialOffers?: Maybe<Array<SpecialOfferType>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
  turnover?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type InternalProductsByWholesalerCountType = {
  __typename?: 'InternalProductsByWholesalerCountType';
  address?: Maybe<FullAddressType>;
  contactEmails?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  currencies?: Maybe<Array<TargetCurrencyType>>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<IPhoneType>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  numberOfWholesalerProducts: Scalars['Int']['output'];
  phone?: Maybe<IPhoneType>;
  picture?: Maybe<PictureType>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type InventoryCategoryCountType = {
  __typename?: 'InventoryCategoryCountType';
  createdAt: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['String']['output']>;
  layer?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfProducts?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  rank?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type InventoryCategoryInput = {
  hasChildren: Scalars['Boolean']['input'];
  layer: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  parent?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  rank: Scalars['Int']['input'];
};

export type InventoryCategoryPaginateType = {
  __typename?: 'InventoryCategoryPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<InventoryCategoryType>;
};

export type InventoryCategoryType = {
  __typename?: 'InventoryCategoryType';
  createdAt: Scalars['DateTime']['output'];
  hasChildren: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  layer: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  picture?: Maybe<PictureType>;
  rank: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InventoryIntegrationImportInput = {
  articles?: InputMaybe<Scalars['String']['input']>;
  attributes?: InputMaybe<Scalars['String']['input']>;
  attributesvalues?: InputMaybe<Scalars['String']['input']>;
  brands?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Scalars['String']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  products?: InputMaybe<Scalars['String']['input']>;
};

export type InventoryIntegrationImportType = {
  __typename?: 'InventoryIntegrationImportType';
  articles?: Maybe<Scalars['String']['output']>;
  attributes?: Maybe<Scalars['String']['output']>;
  attributesvalues?: Maybe<Scalars['String']['output']>;
  brands?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Scalars['String']['output']>;
  enable?: Maybe<Scalars['Boolean']['output']>;
  products?: Maybe<Scalars['String']['output']>;
};

export type InventoryIntegrationInput = {
  import?: InputMaybe<InventoryIntegrationImportInput>;
  target?: InputMaybe<TargetAciInput>;
};

export type InventoryIntegrationType = {
  __typename?: 'InventoryIntegrationType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  import?: Maybe<InventoryIntegrationImportType>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type InvoicePdfType = {
  __typename?: 'InvoicePDFType';
  content?: Maybe<Scalars['String']['output']>;
};

export enum InvoiceStatus {
  CANCELED = 'CANCELED',
  DRAFT = 'DRAFT',
  ISSUED = 'ISSUED'
}

export type InvoiceType = {
  __typename?: 'InvoiceType';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  order: MarketPlaceOrderDtoType;
  sequence?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<InvoiceStatus>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  year?: Maybe<Scalars['Int']['output']>;
};

export type InvoicingAddressInput = {
  billing?: InputMaybe<FullAddressInput>;
  shipping?: InputMaybe<FullAddressInput>;
};

export type InvoicingAddressType = {
  __typename?: 'InvoicingAddressType';
  billing?: Maybe<FullAddressType>;
  shipping?: Maybe<FullAddressType>;
};

export type InvoicingFilterInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  number?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<GenericInvoicingStatusEnum>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type InvoicingPriceType = {
  __typename?: 'InvoicingPriceType';
  gross?: Maybe<Scalars['Decimal']['output']>;
  net?: Maybe<Scalars['Decimal']['output']>;
};

export type InvoicingPricesCalculationType = {
  __typename?: 'InvoicingPricesCalculationType';
  toPay?: Maybe<Scalars['Decimal']['output']>;
  totalPrice?: Maybe<TotalPriceType>;
  totalTax?: Maybe<Scalars['Decimal']['output']>;
};

export type InvoicingProductsBundleInput = {
  kind: ProductKindEnum;
  product?: InputMaybe<InvoicingProductsInput>;
  rank: Scalars['Int']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Decimal']['input']>;
};

export type InvoicingProductsBundleType = {
  __typename?: 'InvoicingProductsBundleType';
  kind: ProductKindEnum;
  product?: Maybe<InvoicingProductsType>;
  rank: Scalars['Decimal']['output'];
  text?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Decimal']['output']>;
};

export type InvoicingProductsInput = {
  article: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<DiscountDtoInput>;
  label: Scalars['String']['input'];
  price: Scalars['Decimal']['input'];
  quantity: Scalars['Int']['input'];
  rent?: InputMaybe<RentalRefInput>;
  taxes: Array<ProductTaxesInput>;
  total: Scalars['Decimal']['input'];
};

export type InvoicingProductsType = {
  __typename?: 'InvoicingProductsType';
  article?: Maybe<BarcodeType>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<DiscountDtoType>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  rent?: Maybe<RentalRefType>;
  taxes?: Maybe<Array<ProductTaxesType>>;
  total?: Maybe<Scalars['Decimal']['output']>;
};

export type InvoicingStatsFilterInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  number?: InputMaybe<Array<Scalars['String']['input']>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type IosDataType = {
  __typename?: 'IosDataType';
  identifierForVendor?: Maybe<Scalars['String']['output']>;
  isPhysicalDevice?: Maybe<Scalars['String']['output']>;
  localizedModel?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  systemName?: Maybe<Scalars['String']['output']>;
  systemVersion?: Maybe<Scalars['String']['output']>;
  utsnameMachine?: Maybe<Scalars['String']['output']>;
  utsnameNodename?: Maybe<Scalars['String']['output']>;
  utsnameRelease?: Maybe<Scalars['String']['output']>;
  utsnameSysname?: Maybe<Scalars['String']['output']>;
  utsnameVersion?: Maybe<Scalars['String']['output']>;
};

export type IpDtoType = {
  __typename?: 'IpDtoType';
  ip: Scalars['String']['output'];
};

export type IplocType = {
  __typename?: 'IplocType';
  country?: Maybe<CountryType>;
  createdAt: Scalars['DateTime']['output'];
  from: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  to?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type IsCouponValidType = {
  __typename?: 'IsCouponValidType';
  coupon?: Maybe<CouponType>;
  isValid: Scalars['Boolean']['output'];
};

export type IsFavoriteInternalProductType = {
  __typename?: 'IsFavoriteInternalProductType';
  isFavorite: Scalars['Boolean']['output'];
};

export type IsFavoriteProductType = {
  __typename?: 'IsFavoriteProductType';
  isFavorite: Scalars['Boolean']['output'];
};

export type IsLinkedAccountType = {
  __typename?: 'IsLinkedAccountType';
  isLinked: Scalars['Boolean']['output'];
};

export type IsLoggedInType = {
  __typename?: 'IsLoggedInType';
  expired: Scalars['Boolean']['output'];
};

export type IsLoginExistInput = {
  /** Login email or username. */
  login?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<IPhoneInput>;
};

export type IsLoginForTargetExistInput = {
  /** Login email or username. */
  login?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<IPhoneInput>;
  target: TargetAciInput;
};

export type IsUserNearPosDtoType = {
  __typename?: 'IsUserNearPOSDtoType';
  isUserNearPOS: Scalars['Boolean']['output'];
};

export type IsUserSubscribedToTargetType = {
  __typename?: 'IsUserSubscribedToTargetType';
  isSubscribed: Scalars['Boolean']['output'];
  status?: Maybe<SubscriptionStatus>;
};

export type JwtTokenType = {
  __typename?: 'JWTTokenType';
  token: Scalars['String']['output'];
};

export type JobApplicationBasePaginatedType = {
  __typename?: 'JobApplicationBasePaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<JobApplicationBaseType>;
};

export type JobApplicationBaseType = {
  __typename?: 'JobApplicationBaseType';
  cover?: Maybe<DocumentType>;
  createdAt: Scalars['DateTime']['output'];
  cv?: Maybe<DocumentType>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  jobDefinition: JobDefinitionBaseType;
  lastName: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: JobApplicationStatusEnum;
  updatedAt: Scalars['DateTime']['output'];
};

export type JobApplicationFilterInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  jobDefinition?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<JobApplicationStatusEnum>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type JobApplicationInput = {
  cover: Scalars['ID']['input'];
  cv: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  jobDefinition: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  message: Scalars['String']['input'];
  status: JobApplicationStatusEnum;
};

export type JobApplicationPaginatedType = {
  __typename?: 'JobApplicationPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<JobApplicationType>;
};

export enum JobApplicationStatusEnum {
  HIRED = 'HIRED',
  NEW = 'NEW',
  NOT_CONSIDERED = 'NOT_CONSIDERED',
  SHORTLISTED = 'SHORTLISTED'
}

export type JobApplicationType = {
  __typename?: 'JobApplicationType';
  cover?: Maybe<DocumentType>;
  createdAt: Scalars['DateTime']['output'];
  cv?: Maybe<DocumentType>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  jobDefinition: JobDefinitionType;
  lastName: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: JobApplicationStatusEnum;
  updatedAt: Scalars['DateTime']['output'];
};

export type JobApplicationUpdateInput = {
  cover?: InputMaybe<Scalars['ID']['input']>;
  cv?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  jobDefinition?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<JobApplicationStatusEnum>;
};

export type JobDefinitionBaseType = {
  __typename?: 'JobDefinitionBaseType';
  createdAt: Scalars['DateTime']['output'];
  department: DepartmentBaseType;
  description?: Maybe<JobDescriptionType>;
  id: Scalars['ID']['output'];
  offer?: Maybe<JobDescriptionType>;
  responsibility?: Maybe<JobDescriptionType>;
  specs?: Maybe<Array<JobSpecsType>>;
  status: JobDefinitionStatusEnum;
  title: Scalars['String']['output'];
  translation?: Maybe<Array<JobDefinitionTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type JobDefinitionInput = {
  department: Scalars['ID']['input'];
  description?: InputMaybe<JobDescriptionInput>;
  offer?: InputMaybe<JobDescriptionInput>;
  responsibility?: InputMaybe<JobDescriptionInput>;
  specs?: InputMaybe<Array<JobSpecsInput>>;
  status?: InputMaybe<JobDefinitionStatusEnum>;
  target: TargetAciInput;
  title: Scalars['String']['input'];
  translation?: InputMaybe<Array<JobDefinitionTranslationInput>>;
};

export type JobDefinitionPaginatedType = {
  __typename?: 'JobDefinitionPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<JobDefinitionType>;
};

export enum JobDefinitionSpecEnum {
  HOLIDAYS = 'HOLIDAYS',
  HOMEOFFICE = 'HOMEOFFICE',
  LOCATION = 'LOCATION',
  PERKS = 'PERKS',
  SALARY = 'SALARY',
  SKILLS = 'SKILLS'
}

export enum JobDefinitionStatusEnum {
  CANCELED = 'CANCELED',
  DRAFT = 'DRAFT',
  HIRED = 'HIRED',
  ONGOING = 'ONGOING'
}

export type JobDefinitionTranslationContentInput = {
  description?: InputMaybe<JobDescriptionInput>;
  offer?: InputMaybe<JobDescriptionInput>;
  responsibility?: InputMaybe<JobDescriptionInput>;
  specs?: InputMaybe<Array<JobSpecsInput>>;
  title: Scalars['String']['input'];
};

export type JobDefinitionTranslationContentType = {
  __typename?: 'JobDefinitionTranslationContentType';
  description?: Maybe<JobDescriptionType>;
  offer?: Maybe<JobDescriptionType>;
  responsibility?: Maybe<JobDescriptionType>;
  specs?: Maybe<Array<JobSpecsType>>;
  title: Scalars['String']['output'];
};

export type JobDefinitionTranslationInput = {
  content: JobDefinitionTranslationContentInput;
  language: Scalars['ID']['input'];
};

export type JobDefinitionTranslationType = {
  __typename?: 'JobDefinitionTranslationType';
  content: JobDefinitionTranslationContentType;
  language: LanguageType;
};

export type JobDefinitionType = {
  __typename?: 'JobDefinitionType';
  createdAt: Scalars['DateTime']['output'];
  department: DepartmentType;
  description?: Maybe<JobDescriptionType>;
  id: Scalars['ID']['output'];
  offer?: Maybe<JobDescriptionType>;
  responsibility?: Maybe<JobDescriptionType>;
  specs?: Maybe<Array<JobSpecsType>>;
  status: JobDefinitionStatusEnum;
  target: TargetType;
  title: Scalars['String']['output'];
  translation?: Maybe<Array<JobDefinitionTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type JobDefinitionUpdateInput = {
  department?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<JobDescriptionInput>;
  offer?: InputMaybe<JobDescriptionInput>;
  responsibility?: InputMaybe<JobDescriptionInput>;
  specs?: InputMaybe<Array<JobSpecsInput>>;
  status?: InputMaybe<JobDefinitionStatusEnum>;
  title?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Array<JobDefinitionTranslationInput>>;
};

export type JobDescriptionInput = {
  description: Scalars['String']['input'];
  descriptionList: Array<Scalars['String']['input']>;
};

export type JobDescriptionType = {
  __typename?: 'JobDescriptionType';
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
};

export type JobSpecsInput = {
  key: JobDefinitionSpecEnum;
  value: Scalars['String']['input'];
};

export type JobSpecsType = {
  __typename?: 'JobSpecsType';
  key?: Maybe<JobDefinitionSpecEnum>;
  value?: Maybe<Scalars['String']['output']>;
};

export type KeyValueInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type KeyValueListType = {
  __typename?: 'KeyValueListType';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type KeyValueType = {
  __typename?: 'KeyValueType';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type LabelType = {
  __typename?: 'LabelType';
  category?: Maybe<LabelTypeEnum>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum LabelTypeEnum {
  NOTES = 'NOTES',
  SCRUM = 'SCRUM'
}

export enum LandingPageTypeEnum {
  ABOUT = 'ABOUT',
  BLOG = 'BLOG',
  CAREER = 'CAREER',
  CATALOG = 'CATALOG',
  CONTACT = 'CONTACT',
  COPYRIGHT = 'COPYRIGHT',
  FAQ = 'FAQ',
  POPUP = 'POPUP',
  PRIVACY = 'PRIVACY',
  PROJECT = 'PROJECT',
  PROJECTS = 'PROJECTS',
  RETURN_EXCHANGE = 'RETURN_EXCHANGE',
  SHIPPING = 'SHIPPING',
  TERMS = 'TERMS'
}

export type LandingPagesDataInput = {
  sectionContent?: InputMaybe<Scalars['String']['input']>;
  sectionPictures?: InputMaybe<Array<PictureInput>>;
  sectionReference?: InputMaybe<Scalars['String']['input']>;
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
};

export type LandingPagesDataType = {
  __typename?: 'LandingPagesDataType';
  sectionContent?: Maybe<Scalars['String']['output']>;
  sectionPictures?: Maybe<Array<PictureType>>;
  sectionReference?: Maybe<Scalars['String']['output']>;
  sectionTitle?: Maybe<Scalars['String']['output']>;
};

export type LandingPagesInput = {
  pageDescription?: InputMaybe<Scalars['String']['input']>;
  pageReference: Scalars['String']['input'];
  pageTitle: Scalars['String']['input'];
  pageType: LandingPageTypeEnum;
  sectionData?: InputMaybe<Array<LandingPagesDataInput>>;
  seo?: InputMaybe<SeoComponentInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  target: TargetAciInput;
  translation?: InputMaybe<Array<LandingPagesTranslationInput>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LandingPagesTranslationContentInput = {
  pageDescription: Scalars['String']['input'];
  pageTitle: Scalars['String']['input'];
  sectionData: Array<LandingPagesDataInput>;
};

export type LandingPagesTranslationContentType = {
  __typename?: 'LandingPagesTranslationContentType';
  pageDescription: Scalars['String']['output'];
  pageTitle: Scalars['String']['output'];
  sectionData: Array<LandingPagesDataType>;
};

export type LandingPagesTranslationInput = {
  content: LandingPagesTranslationContentInput;
  language: Scalars['ID']['input'];
};

export type LandingPagesTranslationType = {
  __typename?: 'LandingPagesTranslationType';
  content: LandingPagesTranslationContentType;
  language: LanguageType;
};

export type LandingPagesType = {
  __typename?: 'LandingPagesType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  pageDescription?: Maybe<Scalars['String']['output']>;
  pageReference: Scalars['String']['output'];
  pageTitle: Scalars['String']['output'];
  pageType: LandingPageTypeEnum;
  sectionData?: Maybe<Array<LandingPagesDataType>>;
  seo?: Maybe<SeoComponentType>;
  status: VisibilityStatusEnum;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetType;
  translation?: Maybe<Array<LandingPagesTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type LandingPagesWithoutTranslationType = {
  __typename?: 'LandingPagesWithoutTranslationType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  pageDescription?: Maybe<Scalars['String']['output']>;
  pageReference: Scalars['String']['output'];
  pageTitle: Scalars['String']['output'];
  pageType: LandingPageTypeEnum;
  sectionData?: Maybe<Array<LandingPagesDataType>>;
  seo?: Maybe<SeoComponentType>;
  status: VisibilityStatusEnum;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type LanguageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  flagSquare?: InputMaybe<PictureInput>;
  flagWide?: InputMaybe<PictureInput>;
  iconFlag?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type LanguagePaginatedType = {
  __typename?: 'LanguagePaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<LanguageType>;
};

export type LanguageType = {
  __typename?: 'LanguageType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  flagSquare?: Maybe<PictureType>;
  flagWide?: Maybe<PictureType>;
  iconFlag?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type LastMessageType = {
  __typename?: 'LastMessageType';
  createdAt: Scalars['DateTime']['output'];
  custom?: Maybe<CustomMessageType>;
  gif?: Maybe<Scalars['String']['output']>;
  location?: Maybe<LonLatType>;
  media?: Maybe<MessageMediaType>;
  sticker?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  unread?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LatLngType = {
  __typename?: 'LatLngType';
  lat?: Maybe<Scalars['Decimal']['output']>;
  lng?: Maybe<Scalars['Decimal']['output']>;
};

export type LeaderboardBaseType = {
  __typename?: 'LeaderboardBaseType';
  compare?: Maybe<CompareRankType>;
  credit: Scalars['Decimal']['output'];
  currentReputationLevel?: Maybe<ReputationWithoutTargetType>;
  entryDate: Scalars['DateTime']['output'];
  game?: Maybe<GameType>;
  /** game group code */
  gameGroup?: Maybe<Scalars['String']['output']>;
  nextReputationLevel?: Maybe<ReputationWithoutTargetType>;
  rank: Scalars['Int']['output'];
  reward?: Maybe<GameIntegrationRewardInnerType>;
  target?: Maybe<TargetType>;
  user?: Maybe<UserType>;
  userData?: Maybe<UserDataType>;
};

export type LeaderboardChallengePaginateType = {
  __typename?: 'LeaderboardChallengePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<LeaderboardChallengeType>;
};

export type LeaderboardChallengeType = {
  __typename?: 'LeaderboardChallengeType';
  credit?: Maybe<Scalars['Decimal']['output']>;
  rank: Scalars['Int']['output'];
  user: UserType;
};

export type LeaderboardChallengeWithCurrentUserPaginateType = {
  __typename?: 'LeaderboardChallengeWithCurrentUserPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  currentUser?: Maybe<LeaderboardChallengeType>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<LeaderboardChallengeType>;
};

export enum LeaderboardCompareEnum {
  DOWN = 'DOWN',
  NEW = 'NEW',
  SAME = 'SAME',
  UP = 'UP'
}

export enum LeaderboardCycleEnum {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  OVERALL = 'OVERALL',
  WEEKLY = 'WEEKLY'
}

export type LeaderboardPaginatedType = {
  __typename?: 'LeaderboardPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<LeaderboardType>;
};

export type LeaderboardType = {
  __typename?: 'LeaderboardType';
  compare?: Maybe<CompareRankType>;
  createdAt: Scalars['DateTime']['output'];
  credit: Scalars['Decimal']['output'];
  currentReputationLevel?: Maybe<ReputationWithoutTargetType>;
  entryDate: Scalars['DateTime']['output'];
  game?: Maybe<GameType>;
  /** game group code */
  gameGroup?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  nextReputationLevel?: Maybe<ReputationWithoutTargetType>;
  rank: Scalars['Int']['output'];
  reward?: Maybe<GameIntegrationRewardInnerType>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
  userData?: Maybe<UserDataType>;
};

export type LeaderboardWithClosingDateType = {
  __typename?: 'LeaderboardWithClosingDateType';
  closingDate?: Maybe<Scalars['DateTime']['output']>;
  data: Array<LeaderboardType>;
};

export type LeaderboardWithCycleNumbersAndClosingdateAndCurrentUserPaginatedType = {
  __typename?: 'LeaderboardWithCycleNumbersAndClosingdateAndCurrentUserPaginatedType';
  closingDate?: Maybe<Scalars['DateTime']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  currentUser?: Maybe<LeaderboardBaseType>;
  cycleNumber?: Maybe<Scalars['Int']['output']>;
  cycleNumbers?: Maybe<Array<Scalars['Int']['output']>>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<LeaderboardBaseType>;
  rewards?: Maybe<Array<GameIntegrationRewardInnerType>>;
};

export type LeaderboardWithCycleNumbersAndClosingdatePaginatedType = {
  __typename?: 'LeaderboardWithCycleNumbersAndClosingdatePaginatedType';
  closingDate?: Maybe<Scalars['DateTime']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  cycleNumber?: Maybe<Scalars['Int']['output']>;
  cycleNumbers?: Maybe<Array<Scalars['Int']['output']>>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<LeaderboardBaseType>;
  rewards?: Maybe<Array<GameIntegrationRewardInnerType>>;
};

export type LeaderboardWithRequiredCycleInput = {
  cycle: LeaderboardCycleEnum;
  cycleNumber?: InputMaybe<Scalars['Int']['input']>;
  /** game code */
  game?: InputMaybe<Scalars['String']['input']>;
  /** game group code */
  gameGroup?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type LeagueFixtureType = {
  __typename?: 'LeagueFixtureType';
  events?: Maybe<Scalars['Boolean']['output']>;
  lineups?: Maybe<Scalars['Boolean']['output']>;
  statistics_fixtures?: Maybe<Scalars['Boolean']['output']>;
  statistics_players?: Maybe<Scalars['Boolean']['output']>;
};

export type LeagueObjType = {
  __typename?: 'LeagueObjType';
  id: Scalars['Int']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  logo64?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<LeagueTypeEnum>;
};

export type LeagueType = {
  __typename?: 'LeagueType';
  country?: Maybe<CountryProviderType>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  league?: Maybe<LeagueObjType>;
  seasons?: Maybe<Array<SeasonsType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum LeagueTypeEnum {
  CUP = 'Cup',
  LEAGUE = 'League'
}

export type LevelDefinitionAiType = {
  __typename?: 'LevelDefinitionAiType';
  color: Scalars['String']['output'];
  description: Scalars['String']['output'];
  maxPoints?: Maybe<Scalars['Float']['output']>;
  minPoints?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  rewardRateMoney: Scalars['Float']['output'];
  rewardRateStatus: Scalars['Float']['output'];
};

export type LevelIntervalType = {
  __typename?: 'LevelIntervalType';
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
};

export type LineupCoachType = {
  __typename?: 'LineupCoachType';
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
};

export type LineupColorIntType = {
  __typename?: 'LineupColorIntType';
  border?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['String']['output']>;
};

export type LineupColorType = {
  __typename?: 'LineupColorType';
  goalkeeper?: Maybe<LineupColorIntType>;
  player?: Maybe<LineupColorIntType>;
};

export type LineupPlayerType = {
  __typename?: 'LineupPlayerType';
  grid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
  pos?: Maybe<Scalars['String']['output']>;
};

export type LineupStartXiType = {
  __typename?: 'LineupStartXIType';
  player?: Maybe<LineupPlayerType>;
};

export type LineupTeamType = {
  __typename?: 'LineupTeamType';
  colors?: Maybe<LineupColorType>;
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LineupsType = {
  __typename?: 'LineupsType';
  coach?: Maybe<LineupCoachType>;
  createdAt: Scalars['DateTime']['output'];
  fixture?: Maybe<Scalars['Int']['output']>;
  formation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  startXI?: Maybe<Array<LineupStartXiType>>;
  substitutes?: Maybe<Array<LineupStartXiType>>;
  team?: Maybe<LineupTeamType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LinkAccountInput = {
  /** language of the email. */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Login email or username. */
  login?: InputMaybe<Scalars['String']['input']>;
  /** Message Text for sms or subject for email. */
  messageText: Scalars['String']['input'];
  phone?: InputMaybe<IPhoneInput>;
  target: TargetAciInput;
};

export enum LinkAccountStatusEnum {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING'
}

export type LinkAccountType = {
  __typename?: 'LinkAccountType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  status: LinkAccountStatusEnum;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type LinkAccountWithLoginInput = {
  /** Login phone number/username or email. */
  login?: InputMaybe<Scalars['String']['input']>;
  /** password for login */
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<IPhoneInput>;
  /** reference to subscribe to */
  reference: Scalars['ID']['input'];
  source?: InputMaybe<UserEventsSourceEnum>;
  target: TargetAciInput;
};

export type LinkItemType = {
  __typename?: 'LinkItemType';
  href?: Maybe<Scalars['String']['output']>;
  rel?: Maybe<Scalars['String']['output']>;
  sizes?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ListWithCardsType = {
  __typename?: 'ListWithCardsType';
  boardCards?: Maybe<Array<BoardCardForListType>>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  identifier?: Maybe<MaintenanceBoardListEnum>;
  name: Scalars['String']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
  theme?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ListenForAmountPushedEventType = {
  __typename?: 'ListenForAmountPushedEventType';
  qualitativeAmount?: Maybe<Scalars['Decimal']['output']>;
  quantitativeAmount?: Maybe<Scalars['Decimal']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
};

export type LocationFilterInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  locationType?: InputMaybe<Array<LocationTypeEnum>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LocationInput = {
  address?: InputMaybe<FullAddressInput>;
  company?: InputMaybe<Scalars['ID']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  locationType?: InputMaybe<LocationTypeEnum>;
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LocationPaginateType = {
  __typename?: 'LocationPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<LocationType>;
};

export type LocationType = {
  __typename?: 'LocationType';
  address?: Maybe<FullAddressType>;
  company?: Maybe<CompanyType>;
  createdAt: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locationType?: Maybe<LocationTypeEnum>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum LocationTypeEnum {
  FACTORY = 'FACTORY',
  OFFICE = 'OFFICE',
  STORAGE = 'STORAGE',
  STORE = 'STORE',
  WAREHOUSE = 'WAREHOUSE'
}

export type LoginInput = {
  /** Login email or username. */
  login?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phone?: InputMaybe<IPhoneInput>;
};

export enum LoginSourceEnum {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  USERNAME = 'USERNAME'
}

export type LoginType = {
  __typename?: 'LoginType';
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Float']['output'];
  user: UserType;
};

export type LoginUserByTargetInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  phone?: InputMaybe<IPhoneInput>;
  reference?: InputMaybe<Scalars['String']['input']>;
  referral?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<UserEventsSourceEnum>;
  target?: InputMaybe<TargetAciInput>;
  theme: MobileThemesEnum;
  token?: InputMaybe<Scalars['String']['input']>;
  widget?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LogisticInput = {
  company?: InputMaybe<Scalars['ID']['input']>;
  driver?: InputMaybe<Scalars['ID']['input']>;
  tracker?: InputMaybe<Array<LogisticTrackerInput>>;
  warehouse?: InputMaybe<Scalars['ID']['input']>;
};

export enum LogisticStatus {
  DELIVERED = 'DELIVERED',
  OUT_FOR_DELIVERY = 'OUT_FOR_DELIVERY',
  PACKED = 'PACKED',
  PLACED = 'PLACED'
}

export type LogisticTrackerInput = {
  date: Scalars['DateTime']['input'];
  status?: InputMaybe<LogisticStatus>;
};

export type LogisticTrackerType = {
  __typename?: 'LogisticTrackerType';
  date: Scalars['DateTime']['output'];
  status?: Maybe<LogisticStatus>;
};

export type LogisticType = {
  __typename?: 'LogisticType';
  company?: Maybe<CompanyType>;
  createdAt: Scalars['DateTime']['output'];
  driver?: Maybe<UserType>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  tracker?: Maybe<Array<LogisticTrackerType>>;
  updatedAt: Scalars['DateTime']['output'];
  warehouse?: Maybe<WarehouseType>;
};

export type LogisticsIntegrationInput = {
  prefix?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<TargetAciInput>;
};

export type LogisticsIntegrationType = {
  __typename?: 'LogisticsIntegrationType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  prefix?: Maybe<Scalars['String']['output']>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type LogoutUserByTargetInput = {
  identifier?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<UserEventsSourceEnum>;
  target: TargetAciInput;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type LonLatInput = {
  coordinates: Array<Scalars['Float']['input']>;
  type?: InputMaybe<ZoneTypesEnum>;
};

export type LonLatType = {
  __typename?: 'LonLatType';
  coordinates?: Maybe<Array<Scalars['Float']['output']>>;
  type?: Maybe<ZoneTypesEnum>;
};

export type LossRuleAiType = {
  __typename?: 'LossRuleAiType';
  downgradeOnLoss: Scalars['Boolean']['output'];
  intervalDays: Scalars['Float']['output'];
  level: Scalars['Float']['output'];
  pointsLost: Scalars['Float']['output'];
};

export type LoyaltyProgramInput = {
  company: Scalars['String']['input'];
  picture?: InputMaybe<PictureInput>;
  programName: Scalars['String']['input'];
};

export type LoyaltyProgramPaginateType = {
  __typename?: 'LoyaltyProgramPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<LoyaltyProgramType>;
};

export type LoyaltyProgramType = {
  __typename?: 'LoyaltyProgramType';
  company?: Maybe<CompanyType>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  picture?: Maybe<PictureType>;
  programName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LoyaltySettingsAccelerateInput = {
  mobile?: InputMaybe<LoyaltySettingsAcceleratePlatformInput>;
  physical?: InputMaybe<LoyaltySettingsAcceleratePlatformInput>;
  web?: InputMaybe<LoyaltySettingsAcceleratePlatformInput>;
};

export type LoyaltySettingsAcceleratePaginateType = {
  __typename?: 'LoyaltySettingsAcceleratePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<LoyaltySettingsAccelerateType>;
};

export type LoyaltySettingsAcceleratePlatformInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  slots?: InputMaybe<Array<LoyaltySettingsAccelerateSlotsInput>>;
};

export type LoyaltySettingsAcceleratePlatformType = {
  __typename?: 'LoyaltySettingsAcceleratePlatformType';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  slots?: Maybe<Array<LoyaltySettingsAccelerateSlotType>>;
};

export type LoyaltySettingsAccelerateSlotType = {
  __typename?: 'LoyaltySettingsAccelerateSlotType';
  period?: Maybe<OpeningHoursDayType>;
  ratio?: Maybe<Scalars['Float']['output']>;
};

export type LoyaltySettingsAccelerateSlotsInput = {
  period?: InputMaybe<OpeningHoursDayInput>;
  ratio?: InputMaybe<Scalars['Float']['input']>;
};

export type LoyaltySettingsAccelerateType = {
  __typename?: 'LoyaltySettingsAccelerateType';
  mobile?: Maybe<LoyaltySettingsAcceleratePlatformType>;
  physical?: Maybe<LoyaltySettingsAcceleratePlatformType>;
  web?: Maybe<LoyaltySettingsAcceleratePlatformType>;
};

export type LoyaltySettingsAggregatorInput = {
  coin?: InputMaybe<Scalars['ID']['input']>;
  model?: InputMaybe<AggregatorModelEnum>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<TargetAciInput>;
};

export type LoyaltySettingsAggregatorType = {
  __typename?: 'LoyaltySettingsAggregatorType';
  coin?: Maybe<CoinType>;
  model?: Maybe<AggregatorModelEnum>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  target?: Maybe<TargetType>;
};

export type LoyaltySettingsCardLevelInput = {
  picture?: InputMaybe<PictureInput>;
  reputationLevel?: InputMaybe<Scalars['String']['input']>;
};

export type LoyaltySettingsCardLevelLeanType = {
  __typename?: 'LoyaltySettingsCardLevelLeanType';
  picture?: Maybe<PictureType>;
  reputationLevel?: Maybe<Scalars['ID']['output']>;
};

export type LoyaltySettingsCardLevelRepresentationInput = {
  representation?: InputMaybe<CardRepresentationEnum>;
  style?: InputMaybe<BarcodeRepresentationTyeEnum>;
  visual?: InputMaybe<CodeRepresentationEnum>;
};

export type LoyaltySettingsCardLevelRepresentationType = {
  __typename?: 'LoyaltySettingsCardLevelRepresentationType';
  representation?: Maybe<CardRepresentationEnum>;
  style?: Maybe<BarcodeRepresentationTyeEnum>;
  visual?: Maybe<CodeRepresentationEnum>;
};

export type LoyaltySettingsCardLevelType = {
  __typename?: 'LoyaltySettingsCardLevelType';
  picture?: Maybe<PictureType>;
  reputationLevel?: Maybe<ReputationType>;
};

export type LoyaltySettingsDonationInput = {
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  qualitative?: InputMaybe<Scalars['Decimal']['input']>;
};

export type LoyaltySettingsDonationType = {
  __typename?: 'LoyaltySettingsDonationType';
  enable?: Maybe<Scalars['Boolean']['output']>;
  qualitative: Scalars['Decimal']['output'];
};

export type LoyaltySettingsLoginInput = {
  method?: InputMaybe<Array<LoginSourceEnum>>;
};

export type LoyaltySettingsLoginType = {
  __typename?: 'LoyaltySettingsLoginType';
  method?: Maybe<Array<LoginSourceEnum>>;
};

export type LoyaltySettingsOnsiteConverterInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  remunerations?: InputMaybe<Array<RemunerationWithReputationInput>>;
};

export type LoyaltySettingsOnsiteConverterLeanType = {
  __typename?: 'LoyaltySettingsOnsiteConverterLeanType';
  active: Scalars['Boolean']['output'];
  remunerations: Array<RemunerationWithReputationLeanDtoType>;
};

export type LoyaltySettingsOnsiteConverterPrelevelInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  qualitative?: InputMaybe<RemunerationWithReputationAmountInput>;
  quantitative?: InputMaybe<RemunerationWithReputationQuantitativeInput>;
};

export type LoyaltySettingsOnsiteConverterPrelevelRemunerationType = {
  __typename?: 'LoyaltySettingsOnsiteConverterPrelevelRemunerationType';
  qualitative?: Maybe<RemunerationWithReputationAmountType>;
  quantitative?: Maybe<RemunerationWithReputationQuantitativeType>;
};

export type LoyaltySettingsOnsiteConverterPrelevelType = {
  __typename?: 'LoyaltySettingsOnsiteConverterPrelevelType';
  active: Scalars['Boolean']['output'];
  qualitative?: Maybe<RemunerationWithReputationAmountType>;
  quantitative?: Maybe<RemunerationWithReputationQuantitativeType>;
};

export type LoyaltySettingsOnsiteConverterPrelevelWelcomeType = {
  __typename?: 'LoyaltySettingsOnsiteConverterPrelevelWelcomeType';
  active: Scalars['Boolean']['output'];
  remuneration?: Maybe<LoyaltySettingsOnsiteConverterPrelevelRemunerationType>;
};

export type LoyaltySettingsOnsiteConverterSetInput = {
  mobile?: InputMaybe<LoyaltySettingsOnsiteConverterInput>;
  physical?: InputMaybe<LoyaltySettingsOnsiteConverterInput>;
  web?: InputMaybe<LoyaltySettingsOnsiteConverterInput>;
};

export type LoyaltySettingsOnsiteConverterSetLeanType = {
  __typename?: 'LoyaltySettingsOnsiteConverterSetLeanType';
  mobile?: Maybe<LoyaltySettingsOnsiteConverterLeanType>;
  physical?: Maybe<LoyaltySettingsOnsiteConverterLeanType>;
  web?: Maybe<LoyaltySettingsOnsiteConverterLeanType>;
};

export type LoyaltySettingsOnsiteConverterSetPrelevelInput = {
  mobile?: InputMaybe<LoyaltySettingsOnsiteConverterPrelevelInput>;
  physical?: InputMaybe<LoyaltySettingsOnsiteConverterPrelevelInput>;
  web?: InputMaybe<LoyaltySettingsOnsiteConverterPrelevelInput>;
};

export type LoyaltySettingsOnsiteConverterSetPrelevelType = {
  __typename?: 'LoyaltySettingsOnsiteConverterSetPrelevelType';
  mobile?: Maybe<LoyaltySettingsOnsiteConverterPrelevelType>;
  physical?: Maybe<LoyaltySettingsOnsiteConverterPrelevelType>;
  web?: Maybe<LoyaltySettingsOnsiteConverterPrelevelType>;
};

export type LoyaltySettingsOnsiteConverterSetType = {
  __typename?: 'LoyaltySettingsOnsiteConverterSetType';
  mobile?: Maybe<LoyaltySettingsOnsiteConverterType>;
  physical?: Maybe<LoyaltySettingsOnsiteConverterType>;
  web?: Maybe<LoyaltySettingsOnsiteConverterType>;
};

export type LoyaltySettingsOnsiteConverterType = {
  __typename?: 'LoyaltySettingsOnsiteConverterType';
  active: Scalars['Boolean']['output'];
  remunerations: Array<RemunerationWithReputationDtoType>;
};

export type LoyaltySettingsOnsiteConverterWelcomeInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  remuneration?: InputMaybe<LoyaltySettingsOnsiteConverterWelcomeRemunerationInput>;
};

export type LoyaltySettingsOnsiteConverterWelcomeRemunerationInput = {
  qualitative?: InputMaybe<RemunerationWithReputationAmountInput>;
  quantitative?: InputMaybe<RemunerationWithReputationQuantitativeInput>;
};

export type LoyaltySettingsPrelevelConverterInput = {
  qualitative?: InputMaybe<RemunerationWithReputationAmountInput>;
  quantitative?: InputMaybe<RemunerationWithReputationQuantitativeInput>;
};

export type LoyaltySettingsPrelevelConverterType = {
  __typename?: 'LoyaltySettingsPrelevelConverterType';
  qualitative?: Maybe<RemunerationWithReputationAmountType>;
  quantitative?: Maybe<RemunerationWithReputationQuantitativeType>;
};

export type LoyaltySettingsPrelevelInput = {
  cardPicture?: InputMaybe<PictureInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  frequencyGoalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  inactivityCycle?: InputMaybe<Scalars['Int']['input']>;
  lossAmount?: InputMaybe<Scalars['Int']['input']>;
  lossPoints?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onsiteConverter?: InputMaybe<LoyaltySettingsOnsiteConverterSetPrelevelInput>;
  period?: InputMaybe<Scalars['Int']['input']>;
  perks?: InputMaybe<LoyaltySettingsPrelevelPerksInput>;
  picture?: InputMaybe<PictureInput>;
  translation?: InputMaybe<Array<PrelevelTranslationInput>>;
  turnoverGoalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  turnoverPoints?: InputMaybe<Scalars['Int']['input']>;
};

export type LoyaltySettingsPrelevelPerksInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
};

export type LoyaltySettingsPrelevelPerksType = {
  __typename?: 'LoyaltySettingsPrelevelPerksType';
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Decimal']['output']>;
};

export type LoyaltySettingsPrelevelType = {
  __typename?: 'LoyaltySettingsPrelevelType';
  cardPicture?: Maybe<PictureType>;
  color?: Maybe<Scalars['String']['output']>;
  frequencyGoalEnabled?: Maybe<Scalars['Boolean']['output']>;
  inactivityCycle?: Maybe<Scalars['Int']['output']>;
  lossAmount?: Maybe<Scalars['Int']['output']>;
  lossPoints?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onsiteConverter?: Maybe<LoyaltySettingsOnsiteConverterSetPrelevelType>;
  period?: Maybe<Scalars['Int']['output']>;
  perks?: Maybe<LoyaltySettingsPrelevelPerksType>;
  picture?: Maybe<PictureType>;
  translation?: Maybe<Array<PrelevelTranslationType>>;
  turnoverGoalEnabled?: Maybe<Scalars['Boolean']['output']>;
  turnoverPoints?: Maybe<Scalars['Int']['output']>;
};

export type LoyaltySettingsProfileCompleteInput = {
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  levels?: InputMaybe<Array<LoyaltySettingsProfileCompleteLevelsInput>>;
};

export type LoyaltySettingsProfileCompleteLevelsInput = {
  elements?: InputMaybe<Array<ProfileCompleteElementsEnum>>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Decimal']['input']>;
  remuneration?: InputMaybe<LoyaltySettingsPrelevelConverterInput>;
};

export type LoyaltySettingsProfileCompleteLevelsType = {
  __typename?: 'LoyaltySettingsProfileCompleteLevelsType';
  elements?: Maybe<Array<ProfileCompleteElementsEnum>>;
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Decimal']['output']>;
  remuneration?: Maybe<LoyaltySettingsPrelevelConverterType>;
};

export type LoyaltySettingsProfileCompleteType = {
  __typename?: 'LoyaltySettingsProfileCompleteType';
  enable?: Maybe<Scalars['Boolean']['output']>;
  levels?: Maybe<Array<LoyaltySettingsProfileCompleteLevelsType>>;
};

export type LoyaltySettingsRedeemInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  editor?: InputMaybe<OutboundEditorEnum>;
  translation?: InputMaybe<Array<LoyaltySettingsRedeemTranslationInput>>;
};

export type LoyaltySettingsRedeemTranslationInput = {
  content: Scalars['String']['input'];
  language?: InputMaybe<Scalars['ID']['input']>;
};

export type LoyaltySettingsRedeemTranslationType = {
  __typename?: 'LoyaltySettingsRedeemTranslationType';
  _id?: Maybe<Scalars['ID']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  language?: Maybe<LanguageType>;
};

export type LoyaltySettingsRedeemType = {
  __typename?: 'LoyaltySettingsRedeemType';
  content?: Maybe<Scalars['String']['output']>;
  editor?: Maybe<OutboundEditorEnum>;
  rate?: Maybe<Scalars['Float']['output']>;
  translation?: Maybe<Array<LoyaltySettingsRedeemTranslationType>>;
};

export type LoyaltySettingsReferralInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<LoyaltySettingsReferralLimitInput>;
  remuneration?: InputMaybe<LoyaltySettingsReferralRemunerationInput>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LoyaltySettingsReferralLimitInput = {
  period?: InputMaybe<PeriodCycleEnum>;
  rate?: InputMaybe<Scalars['Int']['input']>;
};

export type LoyaltySettingsReferralLimitType = {
  __typename?: 'LoyaltySettingsReferralLimitType';
  period?: Maybe<PeriodCycleEnum>;
  rate?: Maybe<Scalars['Int']['output']>;
};

export type LoyaltySettingsReferralPaginateType = {
  __typename?: 'LoyaltySettingsReferralPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<LoyaltySettingsReferralType>;
};

export type LoyaltySettingsReferralRemunerationInput = {
  referred?: InputMaybe<RemunerationBaseInput>;
  referrer?: InputMaybe<RemunerationBaseInput>;
};

export type LoyaltySettingsReferralRemunerationType = {
  __typename?: 'LoyaltySettingsReferralRemunerationType';
  referred?: Maybe<LoyaltySettingsPrelevelConverterType>;
  referrer?: Maybe<LoyaltySettingsPrelevelConverterType>;
};

export type LoyaltySettingsReferralType = {
  __typename?: 'LoyaltySettingsReferralType';
  content?: Maybe<Scalars['String']['output']>;
  enable?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<LoyaltySettingsReferralLimitType>;
  remuneration?: Maybe<LoyaltySettingsReferralRemunerationType>;
  url?: Maybe<Scalars['String']['output']>;
};

export type LoyaltySettingsType = {
  __typename?: 'LoyaltySettingsType';
  accelerate?: Maybe<LoyaltySettingsAccelerateType>;
  aggregator?: Maybe<LoyaltySettingsAggregatorType>;
  createdAt: Scalars['DateTime']['output'];
  donation?: Maybe<LoyaltySettingsDonationType>;
  id: Scalars['ID']['output'];
  inactivity?: Maybe<InactivityType>;
  leaderboard?: Maybe<LoyaltySettingsWalletLeaderboardType>;
  login?: Maybe<LoyaltySettingsLoginType>;
  loyaltyCard?: Maybe<LoyaltySettingsWalletCardType>;
  onsiteConverter?: Maybe<LoyaltySettingsOnsiteConverterSetType>;
  prelevel?: Maybe<LoyaltySettingsPrelevelType>;
  profileComplete?: Maybe<LoyaltySettingsProfileCompleteType>;
  qualitative?: Maybe<LoyaltySettingsWalletQualitativeType>;
  quantitative?: Maybe<LoyaltySettingsWalletQuantitativeType>;
  redeem?: Maybe<LoyaltySettingsRedeemType>;
  referral?: Maybe<LoyaltySettingsReferralType>;
  subscribers?: Maybe<LoyaltySettingsWalletSubscribersType>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  welcome?: Maybe<LoyaltySettingsOnsiteConverterPrelevelWelcomeType>;
};

export type LoyaltySettingsUpdateInput = {
  accelerate?: InputMaybe<LoyaltySettingsAccelerateInput>;
  aggregator?: InputMaybe<LoyaltySettingsAggregatorInput>;
  donation?: InputMaybe<LoyaltySettingsDonationInput>;
  id: Scalars['ID']['input'];
  inactivity?: InputMaybe<InactivityInput>;
  leaderboard?: InputMaybe<LoyaltySettingsWalletLeaderboardInput>;
  login?: InputMaybe<LoyaltySettingsLoginInput>;
  loyaltyCard?: InputMaybe<LoyaltySettingsWalletCardInput>;
  onsiteConverter?: InputMaybe<LoyaltySettingsOnsiteConverterSetInput>;
  prelevel?: InputMaybe<LoyaltySettingsPrelevelInput>;
  profileComplete?: InputMaybe<LoyaltySettingsProfileCompleteInput>;
  qualitative?: InputMaybe<LoyaltySettingsWalletQualitativeInput>;
  quantitative?: InputMaybe<LoyaltySettingsWalletQuantitativeInput>;
  redeem?: InputMaybe<LoyaltySettingsRedeemInput>;
  referral?: InputMaybe<LoyaltySettingsReferralInput>;
  subscribers?: InputMaybe<LoyaltySettingsWalletSubscribersInput>;
  welcome?: InputMaybe<LoyaltySettingsOnsiteConverterWelcomeInput>;
};

export type LoyaltySettingsWalletCardInput = {
  digital?: InputMaybe<Scalars['Boolean']['input']>;
  levels?: InputMaybe<Array<LoyaltySettingsCardLevelInput>>;
  number?: InputMaybe<NumberInput>;
  physical?: InputMaybe<Scalars['Boolean']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  representation?: InputMaybe<LoyaltySettingsCardLevelRepresentationInput>;
  validity?: InputMaybe<Scalars['Int']['input']>;
};

export type LoyaltySettingsWalletCardLeanType = {
  __typename?: 'LoyaltySettingsWalletCardLeanType';
  digital: Scalars['Boolean']['output'];
  levels: Array<LoyaltySettingsCardLevelLeanType>;
  number?: Maybe<NumberType>;
  physical: Scalars['Boolean']['output'];
  prefix?: Maybe<Scalars['String']['output']>;
  representation?: Maybe<LoyaltySettingsCardLevelRepresentationType>;
  validity: Scalars['Int']['output'];
};

export type LoyaltySettingsWalletCardType = {
  __typename?: 'LoyaltySettingsWalletCardType';
  digital: Scalars['Boolean']['output'];
  levels: Array<LoyaltySettingsCardLevelType>;
  number?: Maybe<NumberType>;
  physical: Scalars['Boolean']['output'];
  prefix?: Maybe<Scalars['String']['output']>;
  representation?: Maybe<LoyaltySettingsCardLevelRepresentationType>;
  validity: Scalars['Int']['output'];
};

export type LoyaltySettingsWalletLeaderboardInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  blur?: InputMaybe<Scalars['Boolean']['input']>;
  daily?: InputMaybe<Scalars['Boolean']['input']>;
  monthly?: InputMaybe<Scalars['Boolean']['input']>;
  overall?: InputMaybe<Scalars['Boolean']['input']>;
  weekly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LoyaltySettingsWalletLeaderboardType = {
  __typename?: 'LoyaltySettingsWalletLeaderboardType';
  active: Scalars['Boolean']['output'];
  blur: Scalars['Boolean']['output'];
  daily: Scalars['Boolean']['output'];
  monthly: Scalars['Boolean']['output'];
  overall: Scalars['Boolean']['output'];
  weekly: Scalars['Boolean']['output'];
};

export type LoyaltySettingsWalletQualitativeInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  aggregator?: InputMaybe<Scalars['Boolean']['input']>;
  picture?: InputMaybe<PictureInput>;
};

export type LoyaltySettingsWalletQualitativeType = {
  __typename?: 'LoyaltySettingsWalletQualitativeType';
  active: Scalars['Boolean']['output'];
  aggregator: Scalars['Boolean']['output'];
  picture?: Maybe<PictureType>;
};

export type LoyaltySettingsWalletQuantitativeInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  coin?: InputMaybe<Scalars['ID']['input']>;
};

export type LoyaltySettingsWalletQuantitativeType = {
  __typename?: 'LoyaltySettingsWalletQuantitativeType';
  active: Scalars['Boolean']['output'];
  coin?: Maybe<CoinType>;
};

export type LoyaltySettingsWalletSubscribersInput = {
  verification?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LoyaltySettingsWalletSubscribersType = {
  __typename?: 'LoyaltySettingsWalletSubscribersType';
  verification: Scalars['Boolean']['output'];
};

export type MachineDataType = {
  __typename?: 'MachineDataType';
  brand?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
};

export type MailAttachmentInput = {
  content: Scalars['String']['input'];
  encoding: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

export type MailResponseDto = {
  __typename?: 'MailResponseDto';
  accepted: Array<Scalars['String']['output']>;
  envelopeTime: Scalars['Float']['output'];
  messageId: Scalars['String']['output'];
  messageSize: Scalars['Float']['output'];
  messageTime: Scalars['Float']['output'];
  rejected: Array<Scalars['String']['output']>;
  response: Scalars['String']['output'];
};

export type MainDashboardStatsType = {
  __typename?: 'MainDashboardStatsType';
  campaigns?: Maybe<AnalyticsStatsInfoType>;
  customers?: Maybe<AnalyticsStatsInfoType>;
  products?: Maybe<AnalyticsStatsInfoType>;
  team?: Maybe<AnalyticsStatsInfoType>;
};

export type MaintenanceBoardCardInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assignedTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  attachments?: InputMaybe<Array<Scalars['ID']['input']>>;
  barcode?: InputMaybe<Scalars['ID']['input']>;
  budget?: Scalars['Decimal']['input'];
  customer?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  labels?: InputMaybe<Array<Scalars['ID']['input']>>;
  pictures?: InputMaybe<Array<PictureInput>>;
  priority?: InputMaybe<BoardCardPriorityEnum>;
  procedure?: InputMaybe<Array<BoardCardProcedureInput>>;
  project?: InputMaybe<Scalars['ID']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  target: TargetAciInput;
  tasks?: InputMaybe<Array<BoardCardTasksInput>>;
  title: Scalars['String']['input'];
};

export enum MaintenanceBoardListEnum {
  IN_PROGRESS = 'IN_PROGRESS',
  NEW_REQUEST = 'NEW_REQUEST',
  REPLACED = 'REPLACED',
  SCRAP = 'SCRAP'
}

export type ManufacturerCreateInput = {
  address?: InputMaybe<FullAddressInput>;
  company?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  currencies?: InputMaybe<Array<TargetCurrencyInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type ManufacturerPaginateType = {
  __typename?: 'ManufacturerPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ManufacturerType>;
};

export type ManufacturerType = {
  __typename?: 'ManufacturerType';
  address?: Maybe<FullAddressType>;
  company?: Maybe<CompanyType>;
  contactEmails?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  currencies?: Maybe<Array<TargetCurrencyType>>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type ManufacturerUpdateInput = {
  address?: InputMaybe<FullAddressInput>;
  company?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  currencies?: InputMaybe<Array<TargetCurrencyInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type MappingFixtureType = {
  __typename?: 'MappingFixtureType';
  date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  timestamp?: Maybe<Scalars['Float']['output']>;
};

export type MappingLeagueType = {
  __typename?: 'MappingLeagueType';
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
};

export type MappingType = {
  __typename?: 'MappingType';
  createdAt: Scalars['DateTime']['output'];
  fixture?: Maybe<MappingFixtureType>;
  id: Scalars['ID']['output'];
  league?: Maybe<MappingLeagueType>;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum MaritalStatus {
  DIVORCED = 'DIVORCED',
  ENGAGED = 'ENGAGED',
  IN_RELATIONSHIP = 'IN_RELATIONSHIP',
  MARRIED = 'MARRIED',
  PREFER_NOT_TO_SAY = 'PREFER_NOT_TO_SAY',
  SEPERATED = 'SEPERATED',
  SINGLE = 'SINGLE',
  WIDOWED = 'WIDOWED'
}

export type MarketPlaceOrderControllerInput = {
  card?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['ID']['input']>;
  deliveryFees?: InputMaybe<Scalars['Decimal']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  orderTime?: InputMaybe<Scalars['DateTime']['input']>;
  orderType?: InputMaybe<OrderTypeEnum>;
  shoppingCart: MarketPlaceOrderShoppingCartControllerInput;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type MarketPlaceOrderDtoExtraFeesInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MarketPlaceOrderDtoFeesInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  feesType?: InputMaybe<MarketPlaceOrderWithCartFeesEnum>;
};

export type MarketPlaceOrderDtoFeesType = {
  __typename?: 'MarketPlaceOrderDtoFeesType';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Decimal']['output']>;
};

export type MarketPlaceOrderDtoType = {
  __typename?: 'MarketPlaceOrderDtoType';
  affiliateId?: Maybe<Scalars['ID']['output']>;
  billingAddress?: Maybe<FullAddressType>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<CurrencyType>;
  deliveryAddress?: Maybe<FullAddressType>;
  deliveryFees?: Maybe<Scalars['Decimal']['output']>;
  extraFees?: Maybe<Array<MarketPlaceOrderDtoFeesType>>;
  guestUser?: Maybe<GuestUserType>;
  hasInvoice?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  installments?: Maybe<Array<InstallmentType>>;
  notes?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  orderTime?: Maybe<Scalars['DateTime']['output']>;
  orderType?: Maybe<OrderTypeEnum>;
  shoppingCart: MarketPlaceOrderShoppingCartType;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type MarketPlaceOrderFilterConsumerInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  number?: InputMaybe<Array<Scalars['String']['input']>>;
  orderStatus?: InputMaybe<Array<OrderStatus>>;
  orderType?: InputMaybe<Array<OrderTypeEnum>>;
  paymentMethod?: InputMaybe<Array<PaymentMethodsEnum>>;
  paymentStatus?: InputMaybe<Array<PaymentStatusEnum>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MarketPlaceOrderFilterInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  number?: InputMaybe<Array<Scalars['String']['input']>>;
  orderStatus?: InputMaybe<Array<OrderStatus>>;
  orderType?: InputMaybe<Array<OrderTypeEnum>>;
  paymentMethod?: InputMaybe<Array<PaymentMethodsEnum>>;
  paymentStatus?: InputMaybe<Array<PaymentStatusEnum>>;
  target?: InputMaybe<TargetAciInput>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MarketPlaceOrderInput = {
  currency: CurrencyIdNameType;
  deliveryAddress?: InputMaybe<FullAddressInput>;
  extraFees?: InputMaybe<Array<MarketPlaceOrderDtoExtraFeesInput>>;
  fees?: InputMaybe<MarketPlaceOrderDtoFeesInput>;
  installments?: InputMaybe<Array<InstallmentInput>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderTime: Scalars['DateTime']['input'];
  orderType: OrderTypeEnum;
  paymentMethod: Scalars['String']['input'];
  user?: InputMaybe<Scalars['String']['input']>;
};

export type MarketPlaceOrderPaginateType = {
  __typename?: 'MarketPlaceOrderPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<MarketPlaceOrderDtoType>;
};

export type MarketPlaceOrderPriceInput = {
  gross?: InputMaybe<ReduciblePriceInput>;
  net?: InputMaybe<ReduciblePriceInput>;
  toPay?: InputMaybe<ReduciblePriceInput>;
};

export type MarketPlaceOrderProductInput = {
  barcodeId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  source?: InputMaybe<UserEventsSourceEnum>;
};

export type MarketPlaceOrderShoppingCartControllerInput = {
  discount?: InputMaybe<DiscountDtoInput>;
  price?: InputMaybe<MarketPlaceOrderPriceInput>;
  products: Array<MarketPlaceOrderShoppingCartProductControllerInput>;
  taxValue?: InputMaybe<ReduciblePriceInput>;
};

export type MarketPlaceOrderShoppingCartProductControllerInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<OrderProductPriceInput>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type MarketPlaceOrderShoppingCartType = {
  __typename?: 'MarketPlaceOrderShoppingCartType';
  discount?: Maybe<DiscountDtoType>;
  price?: Maybe<PriceFullType>;
  products?: Maybe<Array<OrderShoppingCartProductType>>;
  target?: Maybe<TargetType>;
  taxValue?: Maybe<ReduciblePriceType>;
};

export type MarketPlaceOrderStatusByPosInput = {
  barcodeId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  source?: InputMaybe<UserEventsSourceEnum>;
  status: UpdateOrderProductStatusForPosEnum;
};

export type MarketPlaceOrderWithCartAfterRegisterInput = {
  apps?: InputMaybe<Array<App>>;
  currency: CurrencyIdNameType;
  deliveryAddress?: InputMaybe<FullAddressInput>;
  discount?: InputMaybe<DiscountDtoInput>;
  email: Scalars['String']['input'];
  extraFees?: InputMaybe<Array<MarketPlaceOrderDtoExtraFeesInput>>;
  fees?: InputMaybe<MarketPlaceOrderDtoFeesInput>;
  firstName: Scalars['String']['input'];
  installments?: InputMaybe<Array<InstallmentInput>>;
  lastName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  orderSubject?: InputMaybe<Scalars['String']['input']>;
  orderTime: Scalars['DateTime']['input'];
  orderType: OrderTypeEnum;
  password: Scalars['String']['input'];
  phone: IPhoneInput;
  products: Array<CartProductInput>;
  roles: Array<UserRole>;
  shippingAddress: Array<FullAddressInput>;
  source?: InputMaybe<UserEventsSourceEnum>;
  target?: InputMaybe<TargetAciInput>;
  userSubject?: InputMaybe<Scalars['String']['input']>;
};

export type MarketPlaceOrderWithCartAndCoinsInput = {
  currency?: InputMaybe<Scalars['ID']['input']>;
  deliveryAddress?: InputMaybe<FullAddressInput>;
  installment?: InputMaybe<InstallmentInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderTime: Scalars['DateTime']['input'];
  orderType: OrderTypeEnum;
  product: CartProductInput;
  target?: InputMaybe<TargetAciInput>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export enum MarketPlaceOrderWithCartFeesEnum {
  CUSTOM = 'CUSTOM',
  DEFAULT = 'DEFAULT'
}

export type MarketPlaceOrderWithCartForGuestInput = {
  apps?: InputMaybe<Array<App>>;
  billingAddress?: InputMaybe<Array<FullAddressInput>>;
  currency: CurrencyIdNameType;
  deliveryAddress?: InputMaybe<FullAddressInput>;
  discount?: InputMaybe<DiscountDtoInput>;
  email: Scalars['String']['input'];
  extraFees?: InputMaybe<Array<MarketPlaceOrderDtoExtraFeesInput>>;
  fees?: InputMaybe<MarketPlaceOrderDtoFeesInput>;
  firstName: Scalars['String']['input'];
  installments?: InputMaybe<Array<InstallmentInput>>;
  lastName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  orderSubject?: InputMaybe<Scalars['String']['input']>;
  orderTime: Scalars['DateTime']['input'];
  orderType: OrderTypeEnum;
  phone: IPhoneInput;
  products: Array<CartProductInput>;
  source?: InputMaybe<UserEventsSourceEnum>;
  target?: InputMaybe<TargetAciInput>;
};

export type MarketPlaceOrderWithCartInput = {
  currency: CurrencyIdNameType;
  deliveryAddress?: InputMaybe<FullAddressInput>;
  discount?: InputMaybe<DiscountDtoInput>;
  extraFees?: InputMaybe<Array<MarketPlaceOrderDtoExtraFeesInput>>;
  fees?: InputMaybe<MarketPlaceOrderDtoFeesInput>;
  installments?: InputMaybe<Array<InstallmentInput>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderTime: Scalars['DateTime']['input'];
  orderType: OrderTypeEnum;
  products: Array<CartProductInput>;
  source?: InputMaybe<UserEventsSourceEnum>;
  target?: InputMaybe<TargetAciInput>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type MarketPlaceOrderWithLoginType = {
  __typename?: 'MarketPlaceOrderWithLoginType';
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Float']['output'];
  orderId: Scalars['ID']['output'];
  user: UserType;
};

export type MarketPlaceOrdersCountType = {
  __typename?: 'MarketPlaceOrdersCountType';
  orderTypes: MarketplaceOrdersTypesCountType;
  paymentMethods: MarketplacePaymentMethodsCountType;
  productsMarketplaceOrderByPaymentStatus: MarketplaceOrderByProductsMarketplaceOrderByPaymentStatusCountType;
  productsMarketplaceOrderByStatus: MarketplaceOrderByProductsMarketplaceOrderByStatusCountType;
  total: Scalars['Int']['output'];
  totalProducts: Scalars['Int']['output'];
};

export type MarketPlaceProductFilterType = {
  __typename?: 'MarketPlaceProductFilterType';
  /** list of brands */
  brands?: Maybe<Array<BrandType>>;
  /** list of inventoryCategories */
  categories?: Maybe<Array<InventoryCategoryType>>;
  createdAtRange?: Maybe<DateRangeType>;
  priceRange?: Maybe<PriceRangeType>;
  targets?: Maybe<TargetsType>;
  updatedAtRange?: Maybe<DateRangeType>;
};

export type MarketPlaceProductType = {
  __typename?: 'MarketPlaceProductType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  internalProducts: Array<InternalProductType>;
  product: ProductType;
  updatedAt: Scalars['DateTime']['output'];
};

export type MarketplaceOrderByProductsMarketplaceOrderByPaymentStatusCountType = {
  __typename?: 'MarketplaceOrderByProductsMarketplaceOrderByPaymentStatusCountType';
  CANCELED: Scalars['Int']['output'];
  OPEN: Scalars['Int']['output'];
  PAID: Scalars['Int']['output'];
};

export type MarketplaceOrderByProductsMarketplaceOrderByStatusCountType = {
  __typename?: 'MarketplaceOrderByProductsMarketplaceOrderByStatusCountType';
  CANCELED: Scalars['Int']['output'];
  CONFIRMED: Scalars['Int']['output'];
  DELIVERED: Scalars['Int']['output'];
  OPEN: Scalars['Int']['output'];
};

export type MarketplaceOrdersTypesCountType = {
  __typename?: 'MarketplaceOrdersTypesCountType';
  DELIVERY: Scalars['Int']['output'];
  IN_HOUSE: Scalars['Int']['output'];
  ORDER_AHEAD: Scalars['Int']['output'];
  PICKUP: Scalars['Int']['output'];
};

export type MarketplacePaymentMethodsCountType = {
  __typename?: 'MarketplacePaymentMethodsCountType';
  APP_COINS: Scalars['Int']['output'];
  CASH: Scalars['Int']['output'];
};

export type MediaInput = {
  deg360?: InputMaybe<Array<PictureInput>>;
  pictures?: InputMaybe<Array<PictureInput>>;
  videos?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MediaType = {
  __typename?: 'MediaType';
  deg360?: Maybe<Array<PictureType>>;
  pictures?: Maybe<Array<PictureType>>;
  videos?: Maybe<Array<Scalars['String']['output']>>;
};

export enum MediaTypeEnum {
  PICTURE = 'PICTURE',
  VIDEO = 'VIDEO'
}

export type MembersType = {
  __typename?: 'MembersType';
  users?: Maybe<Array<UserType>>;
};

export enum MemorySetupEnum {
  EIGHT = 'EIGHT',
  FOUR = 'FOUR',
  SIXTEEN = 'SIXTEEN',
  TWELVE = 'TWELVE'
}

export type MessageGroupInput = {
  creator?: InputMaybe<Scalars['String']['input']>;
  members?: InputMaybe<Array<Scalars['String']['input']>>;
  mute?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<PictureInput>;
  sound?: InputMaybe<MessageSoundEnum>;
  status?: InputMaybe<MessageGroupStatusEnum>;
  target?: InputMaybe<TargetAciInput>;
  type?: InputMaybe<MessageGroupTypeEnum>;
  wallpaper?: InputMaybe<MessageGroupWallpaperInput>;
};

export type MessageGroupPaginateType = {
  __typename?: 'MessageGroupPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<MessageGroupType>;
};

export enum MessageGroupStatusEnum {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED'
}

export type MessageGroupType = {
  __typename?: 'MessageGroupType';
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  id: Scalars['ID']['output'];
  isDirectMessage?: Maybe<Scalars['Boolean']['output']>;
  lastMessage?: Maybe<LastMessageType>;
  members?: Maybe<MembersType>;
  mute?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<PictureType>;
  sound?: Maybe<MessageSoundEnum>;
  status?: Maybe<MessageGroupStatusEnum>;
  target?: Maybe<TargetType>;
  type?: Maybe<MessageGroupTypeEnum>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  wallpaper?: Maybe<MessageGroupWallpaperType>;
};

export enum MessageGroupTypeEnum {
  INTERNAL = 'INTERNAL',
  SUPPORT = 'SUPPORT'
}

export type MessageGroupUpdateInput = {
  creator?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<PictureInput>;
  sound?: InputMaybe<MessageSoundEnum>;
  type?: InputMaybe<MessageGroupTypeEnum>;
  wallpaper?: InputMaybe<MessageGroupWallpaperInput>;
};

export type MessageGroupWallpaperInput = {
  assetImage?: InputMaybe<Scalars['String']['input']>;
  gradientColors?: InputMaybe<Array<Scalars['String']['input']>>;
  picture?: InputMaybe<PictureInput>;
};

export type MessageGroupWallpaperType = {
  __typename?: 'MessageGroupWallpaperType';
  assetImage?: Maybe<Scalars['String']['output']>;
  gradientColors?: Maybe<Array<Scalars['String']['output']>>;
  picture?: Maybe<PictureType>;
};

export type MessageInput = {
  custom?: InputMaybe<CustomMessageInput>;
  gif?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LonLatInput>;
  media?: InputMaybe<MessageMediaInput>;
  messageGroup: Scalars['ID']['input'];
  seenBy?: InputMaybe<Array<Scalars['ID']['input']>>;
  sticker?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type MessageMediaInput = {
  picture?: InputMaybe<Array<PictureInput>>;
  video?: InputMaybe<Array<PictureInput>>;
};

export type MessageMediaPaginateType = {
  __typename?: 'MessageMediaPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PictureType>;
};

export type MessageMediaType = {
  __typename?: 'MessageMediaType';
  picture?: Maybe<Array<PictureType>>;
  video?: Maybe<Array<PictureType>>;
};

export type MessagePaginateType = {
  __typename?: 'MessagePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<MessageType>;
};

export enum MessageSoundEnum {
  AURORA = 'AURORA',
  DEFAULT = 'DEFAULT',
  NONE = 'NONE'
}

export type MessageType = {
  __typename?: 'MessageType';
  createdAt: Scalars['DateTime']['output'];
  custom?: Maybe<CustomMessageType>;
  gif?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<LonLatType>;
  media?: Maybe<MessageMediaType>;
  messageGroup: MessageGroupType;
  seenBy?: Maybe<Array<UserType>>;
  sender: UserType;
  sticker?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MetaItemType = {
  __typename?: 'MetaItemType';
  content?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  property?: Maybe<Scalars['String']['output']>;
};

export type MetaKeywordsInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MetaKeywordsType = {
  __typename?: 'MetaKeywordsType';
  content?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MilitaryTimeFromToInput = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type MilitaryTimeFromToType = {
  __typename?: 'MilitaryTimeFromToType';
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export enum MobileThemesEnum {
  DARK = 'DARK',
  LIGHT = 'LIGHT',
  SYSTEM = 'SYSTEM'
}

export type ModulesAssignmentInput = {
  assignee?: InputMaybe<AssigneeInput>;
  module: Scalars['String']['input'];
};

export type ModulesAssignmentType = {
  __typename?: 'ModulesAssignmentType';
  assignee?: Maybe<AssigneeDtoType>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  module: ModulesDefinitionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ModulesDefinitionInput = {
  name: Scalars['String']['input'];
  target?: InputMaybe<TargetTypeEnum>;
};

export type ModulesDefinitionType = {
  __typename?: 'ModulesDefinitionType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  target?: Maybe<TargetTypeEnum>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MonthDaysInput = {
  days?: InputMaybe<Array<Scalars['Int']['input']>>;
  month: Scalars['Int']['input'];
};

export type MonthDaysType = {
  __typename?: 'MonthDaysType';
  days?: Maybe<Array<Scalars['Int']['output']>>;
  month: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptMarketplaceOrderDelivery: MarketPlaceOrderDtoType;
  activateOutbound: OutboundType;
  activateWidgetIntegrationAction: WidgetIntegrationType;
  addAccessApiToTarget: IntegrationIntegrationType;
  addAccountPermission: AccountType;
  addBarcodeToInternalProductAndProduct: InternalProductType;
  addBudgetToQuest: QuestType;
  addDiscountToCart: ShoppingCartType;
  addFcmToken: SuccessResponseDtoType;
  addGameGroup: DeleteResponseDtoType;
  addGameReward: GameIntegrationRewardType;
  addGameToGameGroup: DeleteResponseDtoType;
  addMemeberToMessageGroup: MessageGroupType;
  addProductToComparator: InternalProductType;
  addProductsToCart: ShoppingCartType;
  addReputationLevel: ReputationType;
  addTargetToAccount: AccountType;
  addToCart: ShoppingCartType;
  addToStock: StockType;
  addToStockCustom: StockType;
  addUserForTarget: CorporateUserType;
  addUserToNewsLetter: NewsletterType;
  approveLinkCorporateAccount: LinkAccountType;
  approveLoyaltySubscription: SubscribersFullType;
  approveSubscription: SubscribersFullType;
  archiveMessageGroup: MessageGroupType;
  assignDefaultAudienceToTarget: AudienceType;
  bulkUpdateBarcodeMedia: Array<BarcodeType>;
  bulkUpdateCompanyMedia: Array<CompanyType>;
  bulkUpdateProjectMedia: Array<ProjectType>;
  bulkUpdateTicketMedia: Array<TicketType>;
  bulkUpdateWarehouseMedia: Array<WarehouseType>;
  cancelMarketplaceOrderDelivery: MarketPlaceOrderDtoType;
  cancelOrderByTarget: MarketPlaceOrderDtoType;
  cancelProductByConsumer: MarketPlaceOrderDtoType;
  cancelProductByDeliveryMan: MarketPlaceOrderDtoType;
  cancelProductByTarget: MarketPlaceOrderDtoType;
  cancelSubscription: SubscribersFullType;
  confirmWalletTopup: WalletTopupType;
  convertWalletPoints: SuccessResponseDtoType;
  createAccount: AccountType;
  createActivityType: ActivityTypeType;
  createAdhocCorporateNotification: Array<CorporateNotificationFullType>;
  createAdhocNotification: NotificationFullType;
  createAdhocTransaction: AdhocTransactionType;
  createAttribute: AttributeType;
  createAttributeValue: AttributeValueType;
  createAudience: AudienceType;
  createAudienceCriteria: AudienceCriteriaType;
  createBadge: BadgeType;
  createBank: BankType;
  createBankDetails: BankDetailsType;
  createBarcode: BarcodeType;
  createBarcodeForTarget: BarcodeType;
  createBarcodeForTargetWithStock: BarcodeType;
  createBlog: BlogType;
  createBoard: BoardType;
  createBoardCard: BoardCardType;
  createBoardList: BoardListType;
  createBrand: BrandType;
  createBrowser: BrowserType;
  createCatalogueCategory: CatalogueCategoryType;
  createCause: CauseType;
  createChallenge: ChallengeType;
  createCoin: CoinType;
  createComment: CommentType;
  createCompany: CompanyType;
  createCompanyContact: CompanyContactType;
  createContentType: ContentTypeType;
  createCorporateDashboard: CorporateUserDashType;
  createCorporateEmailTemplate: CorporateEmailTemplateType;
  createCorporateRating: CorporateRatingType;
  createCorporateRatingAssignment: CorporateRatingAssignmentType;
  createCorporateRatingDefinition: CorporateRatingDefinitionType;
  createCorporateTemplate: CorporateTemplateType;
  createCountry: CountryType;
  createCoupon: CouponType;
  createCouponSettings: CouponSettingsType;
  createCurrency: CurrencyType;
  createCustomInternalProduct: InternalProductType;
  createDefaultAudience: DefaultAudienceType;
  createDeliveryZone: DeliveryZonesType;
  createDepartment: DepartmentType;
  createDirectMessage: MessageType;
  createDocument: DocumentType;
  createEmailTemplate: EmailTemplateType;
  createEventInvite: EventInviteType;
  createFeaturedCorporate: FeaturedCorporateType;
  createFont: FontType;
  createForm: FormResponseType;
  createFreebie: FreebieType;
  createFreebieTransaction: FreebieTransactionType;
  createGame: GameType;
  createGameOrder: SuccessResponseDtoType;
  createGlobalCategory: GlobalCategoryType;
  createInternalProduct: InternalProductType;
  createInternalProductAndProduct: InternalProductType;
  createInventoryCategory: InventoryCategoryType;
  createJobApplication: JobApplicationType;
  createJobDefinition: JobDefinitionType;
  createLabel: LabelType;
  createLandingPage: LandingPagesType;
  createLanguage: LanguageType;
  createLocation: LocationType;
  createLogistic: LogisticType;
  createLoyaltyProgram: LoyaltyProgramType;
  createMaintenanceBoardCard: BoardCardType;
  createManufacturer: ManufacturerType;
  createMarketPlaceOrder: Array<MarketPlaceOrderDtoType>;
  createMessage: MessageType;
  createMessageGroup: MessageGroupType;
  createModuleAssignment: ModulesAssignmentType;
  createModuleDefinition: ModulesDefinitionType;
  createNewVersion: VersionType;
  createNote: NotesType;
  createOperatingSystem: OperatingSystemType;
  createOrUpdateFavoriteInternalProducts: FavoriteInternalProductType;
  createOrUpdateFavoriteProducts: FavoriteProductType;
  createOrderSettings: OrderSettingsFullType;
  createOutboundCorporateNotification: CorporateNotificationFullType;
  createPOSCategory: PosCategoryType;
  createPOSServices: PosServicesType;
  createPartnerReferral: PartnerReferralType;
  createPartnershipNetwork: PartnershipNetworkType;
  createPayment: PaymentType;
  createPermission: PermissionType;
  createPermissionDefinition: PermissionDefinitionType;
  createPlugin: PluginType;
  createPointOfSale: PointOfSaleType;
  createPredefined: PredefinedType;
  createPrice: PriceType;
  createProduct: ProductType;
  createProductAttribute: ProductAttributeType;
  createProductClicks: ProductClicksType;
  createProductRating: ProductRatingType;
  createProductRatingDefinition: ProductRatingDefinitionType;
  createProject: ProjectType;
  createPromotion: PromotionType;
  createPurchaseDeliveryNote: PurchaseDeliveryNoteType;
  createPurchaseInvoice: PurchaseInvoiceType;
  createPurchaseOrder: PurchaseOrderType;
  createQuest: QuestType;
  createQuestActionDefinition: QuestActionDefinitionType;
  createQuestActivity: QuestActivityType;
  createQuestType: QuestTypeType;
  createQuestion: QuestionDtoType;
  createQuotation: QuotationType;
  createRecentlyViewed: SuccessResponseDtoType;
  createRequest: RequestType;
  createResponse: ResponseDtoType;
  createSEO: SeoType;
  createSaleAvoir: SaleInvoiceType;
  createSaleDeliveryNote: SaleDeliveryNoteType;
  createSaleInvoice: SaleInvoiceType;
  createSaleIssueNote: SaleIssueNoteType;
  createSaleOrder: SaleOrderType;
  createServiceProduct: BarcodeType;
  createSimpleProduct: InternalProductType;
  createSlides: SlidesType;
  createSocial: SocialType;
  createState: StateType;
  createStaticTranslation: StaticTranslationType;
  createStock: StockType;
  createSupplier: SupplierType;
  createTargetOrderByCart: SuccessResponseWithOrderIdType;
  createTargetOrderWithCart: MarketPlaceOrderDtoType;
  createTargetOrderWithCartAndCoins: MarketPlaceOrderDtoType;
  createTargetOrderWithCartAndRegisterUser: MarketPlaceOrderWithLoginType;
  createTargetOrderWithCartForGuestUser: MarketPlaceOrderDtoType;
  createTargetPlugin: TargetPluginType;
  createTask: TaskType;
  createTaskSection: TaskSectionType;
  createTax: TaxType;
  createTechDevice: TechDeviceType;
  createTechDeviceBrand: TechDeviceBrandType;
  createTechDeviceType: TechDeviceTypeType;
  createTicket: TicketType;
  createTimeTrack: TimeTrackType;
  createUser: UserType;
  createUserForApp: UserType;
  createVisuals: VisualsType;
  createWallet: WalletType;
  createWalletTopup: WalletTopupType;
  createWalletTopupSettings: WalletTopupSettingsType;
  createWarehouse: WarehouseType;
  createWholesaler: WholesalerType;
  createWidgetVisuals: WidgetVisualsType;
  deductAmountFromUser: DeductAmountSuccessType;
  deductCoinsFromUser: SuccessResponseDtoType;
  deleteAccount: DeleteResponseDtoType;
  deleteAccountPermission: DeleteResponseDtoType;
  deleteActivityType: DeleteResponseDtoType;
  deleteAdhocTransaction: DeleteResponseDtoType;
  deleteAttribute: DeleteResponseDtoType;
  deleteAttributeValue: DeleteResponseDtoType;
  deleteAudience: DeleteResponseDtoType;
  deleteAudienceCriteria: DeleteResponseDtoType;
  deleteBadge: DeleteResponseDtoType;
  deleteBank: DeleteResponseDtoType;
  deleteBankDetails: DeleteResponseDtoType;
  deleteBarcode: DeleteResponseDtoType;
  deleteBarcodeWithstock: DeleteResponseDtoType;
  deleteBlog: BlogType;
  deleteBoard: DeleteResponseDtoType;
  deleteBoardCard: DeleteResponseDtoType;
  deleteBoardList: DeleteResponseDtoType;
  deleteBrand: DeleteResponseDtoType;
  deleteBrowser: DeleteResponseDtoType;
  deleteCatalogueCategory: DeleteResponseDtoType;
  deleteCause: DeleteResponseDtoType;
  deleteChallenge: DeleteResponseDtoType;
  deleteCoin: DeleteResponseDtoType;
  deleteComment: DeleteResponseDtoType;
  deleteCompany: DeleteResponseDtoType;
  deleteCompanyContact: DeleteResponseDtoType;
  deleteContentType: DeleteResponseDtoType;
  deleteCorporateDashboard: DeleteResponseDtoType;
  deleteCorporateEmailTemplate: DeleteResponseDtoType;
  deleteCorporateNotification: DeleteResponseDtoType;
  deleteCorporateRating: DeleteResponseDtoType;
  deleteCorporateRatingAssignment: DeleteResponseDtoType;
  deleteCorporateRatingDefinition: DeleteResponseDtoType;
  deleteCorporateTemplate: DeleteResponseDtoType;
  deleteCountry: DeleteResponseDtoType;
  deleteCurrency: DeleteResponseDtoType;
  deleteDeliveryZone: DeleteResponseDtoType;
  deleteDepartment: DeleteResponseDtoType;
  deleteDocument: DeleteResponseDtoType;
  deleteEmailIntegration: DeleteResponseDtoType;
  deleteEmailTemplate: DeleteResponseDtoType;
  deleteErpIntegration: DeleteResponseDtoType;
  deleteEvent: DeleteResponseDtoType;
  deleteEventInvite: DeleteResponseDtoType;
  deleteEventTicket: DeleteResponseDtoType;
  deleteFBCatalogSync: DeleteResponseDtoType;
  deleteFBPixel: DeleteResponseDtoType;
  deleteFeaturedCorporate: DeleteResponseDtoType;
  deleteFlow: DeleteResponseDtoType;
  deleteFont: DeleteResponseDtoType;
  deleteForm: DeleteResponseDtoType;
  deleteFormAndQuestions: DeleteResponseDtoType;
  deleteFreebie: DeleteResponseDtoType;
  deleteFreebieTransaction: DeleteResponseDtoType;
  deleteGame: DeleteResponseDtoType;
  deleteGameIntegration: DeleteResponseDtoType;
  deleteGameReward: DeleteResponseDtoType;
  deleteGlobalCategory: DeleteResponseDtoType;
  deleteGoogleAnalytics: DeleteResponseDtoType;
  deleteHelpdeskIntegration: DeleteResponseDtoType;
  deleteIntegrationIntegration: DeleteResponseDtoType;
  deleteInternalProduct: DeleteResponseDtoType;
  deleteInventoryCategory: InventoryCategoryType;
  deleteInventoryIntegration: DeleteResponseDtoType;
  deleteJobApplication: DeleteResponseDtoType;
  deleteJobDefinition: DeleteResponseDtoType;
  deleteLabel: DeleteResponseDtoType;
  deleteLandingPage: LandingPagesType;
  deleteLanguage: DeleteResponseDtoType;
  deleteLinkCorporateAccount: DeleteResponseDtoType;
  deleteLocation: DeleteResponseDtoType;
  deleteLogistic: DeleteResponseDtoType;
  deleteLogisticsIntegration: DeleteResponseDtoType;
  deleteLoyaltyProgram: LoyaltyProgramType;
  deleteManufacturer: ManufacturerType;
  deleteModuleAssignment: ModulesAssignmentType;
  deleteModuleDefinition: ModulesDefinitionType;
  deleteNote: DeleteResponseDtoType;
  deleteNotificationIntegration: DeleteResponseDtoType;
  deleteOperatingSystem: DeleteResponseDtoType;
  deleteOutbound: DeleteResponseDtoType;
  deletePOSCategory: PosCategoryType;
  deletePOSServices: PosServicesType;
  deletePartnerReferral: PartnerReferralType;
  deletePartnershipNetwork: DeleteResponseDtoType;
  deletePayment: DeleteResponseDtoType;
  deletePermission: DeleteResponseDtoType;
  deletePermissionDefinition: DeleteResponseDtoType;
  deletePlugin: DeleteResponseDtoType;
  deletePointOfSale: PointOfSaleType;
  deletePredefined: DeleteResponseDtoType;
  deletePrice: DeleteResponseDtoType;
  deleteProduct: ProductType;
  deleteProductAttribute: DeleteResponseDtoType;
  deleteProductRating: DeleteResponseDtoType;
  deleteProductRatingDefinition: DeleteResponseDtoType;
  deleteProgram: DeleteResponseDtoType;
  deleteProject: DeleteResponseDtoType;
  deletePromotion: DeleteResponseDtoType;
  deletePurchaseDeliveryNote: DeleteResponseDtoType;
  deletePurchaseIntegration: DeleteResponseDtoType;
  deletePurchaseInvoice: DeleteResponseDtoType;
  deletePurchaseOrder: DeleteResponseDtoType;
  deleteQuest: DeleteResponseDtoType;
  deleteQuestActionDefinition: DeleteResponseDtoType;
  deleteQuestActivity: DeleteResponseDtoType;
  deleteQuestType: DeleteResponseDtoType;
  deleteQuestion: DeleteResponseDtoType;
  deleteQuotation: DeleteResponseDtoType;
  deleteResponse: DeleteResponseDtoType;
  deleteSEO: DeleteResponseDtoType;
  deleteSaleDeliveryNote: DeleteResponseDtoType;
  deleteSaleInvoice: DeleteResponseDtoType;
  deleteSaleIssueNote: DeleteResponseDtoType;
  deleteSaleOrder: DeleteResponseDtoType;
  deleteSalesIntegration: DeleteResponseDtoType;
  deleteShortcut: DeleteResponseDtoType;
  deleteSlides: DeleteResponseDtoType;
  deleteSmsIntegration: DeleteResponseDtoType;
  deleteSocial: DeleteResponseDtoType;
  deleteState: DeleteResponseDtoType;
  deleteStaticTranslation: DeleteResponseDtoType;
  deleteStock: DeleteResponseDtoType;
  deleteStory: DeleteResponseDtoType;
  deleteSubscriber: DeleteResponseDtoType;
  deleteSupplier: DeleteResponseDtoType;
  deleteTargetFromAccount: DeleteResponseDtoType;
  deleteTargetPlugin: DeleteResponseDtoType;
  deleteTargetReputation: DeleteResponseDtoType;
  deleteTask: DeleteResponseDtoType;
  deleteTaskSection: DeleteResponseDtoType;
  deleteTax: DeleteResponseDtoType;
  deleteTechDevice: DeleteResponseDtoType;
  deleteTechDeviceBrand: DeleteResponseDtoType;
  deleteTechDeviceType: DeleteResponseDtoType;
  deleteTicket: DeleteResponseDtoType;
  deleteTimeTrack: DeleteResponseDtoType;
  deleteUser: DeleteResponseDtoType;
  deleteUserWithData: DeleteResponseDtoType;
  deleteVisuals: DeleteResponseDtoType;
  deleteWalletTopup: DeleteResponseDtoType;
  deleteWalletTopupSettings: DeleteResponseDtoType;
  deleteWarehouse: DeleteResponseDtoType;
  deleteWebsiteIntegration: DeleteResponseDtoType;
  deleteWholesaler: WholesalerType;
  deleteWidgetIntegration: DeleteResponseDtoType;
  deleteWidgetVisuals: DeleteResponseDtoType;
  deliverWalletTopup: WalletTopupType;
  disableAdhocTransaction: AdhocTransactionType;
  disableCoupon: CouponType;
  disableCouponSettings: CouponSettingsType;
  disableWidgetIntegrationAction: WidgetIntegrationType;
  emptyCart: ShoppingCartType;
  emptyTargetCart: ShoppingCartType;
  enableAdhocTransaction: AdhocTransactionType;
  enableCouponSettings: CouponSettingsType;
  expireCorporateUserCard: DeleteResponseDtoType;
  finishOutbound: OutboundType;
  generateCoupons: SuccessResponseDtoType;
  generateEcomSitemapXml: CorporateTemplateType;
  generateTargetUserCards: SuccessResponseDtoType;
  generateTargetUserCardsBatch: SuccessResponseDtoType;
  getProgramsByEvent: Array<ProgramType>;
  getShortcutsByUser: Array<ShortcutType>;
  importAudienceUsersByExcel: SuccessResponseDtoType;
  importCustomersByExcel: SuccessResponseDtoType;
  importFullCorporateCatalogueByExcel: SuccessResponseDtoType;
  importInvoicingByExcel: SuccessResponseDtoType;
  importPosByExcel: SuccessResponseDtoType;
  importProjectsByExcel: SuccessResponseDtoType;
  importServicesCatalogueByExcel: SuccessResponseDtoType;
  importSimpleFullCatalogueByXmlLink: SuccessResponseDtoType;
  importSimpleFullCorporateCatalogueByExcel: SuccessResponseDtoType;
  importSuppliersByExcel: SuccessResponseDtoType;
  importTargetOrdersByExcel: SuccessResponseDtoType;
  importTargetOrdersByXmlLink: SuccessResponseDtoType;
  importTargetUserCardsByExcel: SuccessResponseDtoType;
  importTargetUsersByExcel: SuccessResponseDtoType;
  importTargetUsersWithConventionByExcel: SuccessResponseDtoType;
  initReputations: Array<ReputationType>;
  initStaticTranslations: StaticTranslationPaginateType;
  initStock: StockType;
  initWidgetVisuals: WidgetVisualsPaginateType;
  insertEvent: EventType;
  insertEventTickets: Array<EventTicketType>;
  insertFlow: FlowType;
  insertOrigin: OriginType;
  insertOutbound: OutboundType;
  insertProgram: ProgramType;
  insertShortcut: ShortcutType;
  insertStaticData: StaticDataType;
  insertStory: StoriesType;
  invitePartnerToNetwork: PartnershipNetworkType;
  linkUserAccount: SuccessResponseWithTokenDtoType;
  loginUserByTarget: LoginType;
  loginWithPartner: LoginType;
  markAllAsSeenForPOS: NotificationResponse;
  markAllAsSeenForUser: NotificationResponse;
  markAllCorporateNotificationsAsSeenForUser: CorporateNotificationResponse;
  markAllCorporateNotificationsAsSeenForUserWithLinkedAccounts: CorporateNotificationResponse;
  markAllMessageAsSeen: DeleteResponseDtoType;
  markAllMessagesAsSeenForTarget: DeleteResponseDtoType;
  markEventInviteAsApproved: EventInviteType;
  markEventInviteAsOpen: EventInviteType;
  markEventInviteAsRejected: EventInviteType;
  markInternalProductAsFavorite: InternalProductType;
  markMessageAsSeen: MessageType;
  markProductAsFavorite: ProductType;
  markSimpleProductAsFavorite: InternalProductWithBarcodesWithPublicPriceType;
  markStoryAsSeen: StoriesType;
  markTicketAsAttended: EventTicketType;
  markTicketAsOpen: EventTicketType;
  markTicketAsPaid: EventTicketType;
  mergeAccounts: UserType;
  muteMessageGroup: MessageGroupType;
  onboardUserToTargetLoyalty: SuccessResponseDtoType;
  payMarketplaceOrderInstallments: MarketPlaceOrderDtoType;
  performDirectDonation: SuccessResponseWithAmountPushedDtoType;
  performDonationActivity: SuccessResponseDtoType;
  performNonPredefinedQuestByUser: SuccessResponseDtoType;
  performOnsiteActivity: QuestActionSuccessType;
  performPredefinedQuestByUser: SuccessResponseDtoType;
  processWelcomeMail: UserType;
  processWelcomeMailForTarget: CorporateUserType;
  publishBlog: BlogType;
  publishLandingPage: LandingPagesType;
  purchaseCoupon: CouponType;
  redeemCoupon: CouponType;
  redeemCouponByTarget: CouponType;
  redeemFrebies: SuccessResponseDtoType;
  redeemReferral: ReferralType;
  refreshSitemapXml: CorporateTemplateType;
  refreshStaticTranslations: StaticTranslationPaginateType;
  refreshWidgetVisuals: WidgetVisualsPaginateType;
  register: LoginType;
  registerAccountForApp: AccountType;
  registerApiForTarget: LoginType;
  registerForApp: LoginType;
  registerForTarget: LoginType;
  registerForTargetWithOnboard: CorporateLoginType;
  registerForTargetWithWholesaler: LoginType;
  rejectSubscription: SubscribersFullType;
  removeAllFromStock: DeleteResponseDtoType;
  removeAudienceFromChallenge: ChallengeType;
  removeAudienceFromCorporateNotification: CorporateNotificationFullType;
  removeAudienceFromOutbound: OutboundType;
  removeAudienceFromQuest: QuestType;
  removeExecutionDateFromCorporateNotification: CorporateNotificationFullType;
  removeFromCart: ShoppingCartType;
  removeFromStock: StockType;
  removeFromStockCustom: StockType;
  removeGameFromGameGroup: DeleteResponseDtoType;
  removeGameGroup: DeleteResponseDtoType;
  removeInternalProductFromFavorites: InternalProductType;
  removeMemberFromMessageGroup: MessageGroupType;
  removeProductCompareFromList: DeleteResponseDtoType;
  removeProductFromFavorites: ProductType;
  removeReputationLevel: DeleteResponseDtoType;
  removeSimpleProductFromFavorites: InternalProductWithBarcodesWithPublicPriceType;
  removeUserFromNewsLetter: DeleteResponseDtoType;
  reorderBoardCards: Array<BoardCardType>;
  reorderBoardList: Array<BoardListType>;
  reorderCatalogueCategories: Array<CatalogueCategoryType>;
  reorderCorporateDashboard: Array<CorporateUserDashType>;
  reorderDeliveryZones: Array<DeliveryZonesType>;
  reorderQuestActivity: QuestActivityType;
  reorderQuestion: QuestionDtoType;
  reorderQuestionOfForm: Array<QuestionDtoType>;
  reorderTask: Array<TaskType>;
  reorderTaskSections: Array<TaskSectionType>;
  requestLinkCorporateAccount: LinkAccountType;
  requestSubscription: SubscribersFullType;
  resendApproveCode: SuccessResponseDtoType;
  resetFeaturedCorporateRank: Array<FeaturedCorporateType>;
  resetPassword: UserType;
  resetPasswordForTarget: CorporateUserType;
  resetPasswordWithMailForApp: UserType;
  resetPasswordWithSmsForApp: UserType;
  resetStaticTranslation: StaticTranslationType;
  resetStock: StockType;
  resetWidgetVisual: WidgetVisualsType;
  saveCurrentCorporateUserStatus: UserType;
  saveCurrentUserStatus: UserType;
  saveLeaderboard: SuccessResponseDtoType;
  sendBatchNotifications: DeleteResponseDtoType;
  sendForgotPasswordMail: MailResponseDto;
  sendForgotPasswordMailOrSmsToTarget: SuccessResponseDtoType;
  sendForgotPasswordMailToTarget: MailResponseDto;
  sendHttpRequest: ApiReturnType;
  sendMergeAccountsEmail: MailResponseDto;
  sendMessageToTarget: MessageType;
  sendRegistrationValidationSms: SmsIntegrationResponseType;
  sendSimpleNotification: DeleteResponseDtoType;
  sendTestQuestApi: ApiReturnType;
  sendValidMail: MailResponseDto;
  sendValidSms: SmsIntegrationResponseType;
  sendValidationCode: SuccessResponseDtoType;
  sendValidationEmail: SuccessResponseDtoType;
  sendValidationEmailForTarget: MailResponseDto;
  setProductReadyForPickup: MarketPlaceOrderDtoType;
  subscribeUserToTarget: SubscribersFullType;
  syncOneAttribute: AttributeType;
  syncOneAttributeValue: AttributeValueType;
  syncOneBrand: BrandType;
  syncOneCategory: CatalogueCategoryType;
  topupWallet: QuestActionSuccessType;
  unarchiveMessageGroup: MessageGroupType;
  unmuteMessageGroup: MessageGroupType;
  updateAccount: AccountType;
  updateAccountByAdmin: AccountType;
  updateActivityType: ActivityTypeType;
  updateAdhocTransaction: AdhocTransactionType;
  updateAttribute: AttributeType;
  updateAttributeValue: AttributeValueType;
  updateAudience: AudienceType;
  updateAudienceCriteria: AudienceCriteriaType;
  updateBadge: BadgeType;
  updateBank: BankType;
  updateBankDetails: BankDetailsType;
  updateBarcode: BarcodeWithPublicPriceType;
  updateBlog: BlogType;
  updateBoard: BoardType;
  updateBoardCard: BoardCardType;
  updateBoardCardList: Array<BoardCardType>;
  updateBoardList: BoardListType;
  updateBrand: BrandType;
  updateBrowser: BrowserType;
  updateCatalogueCategory: CatalogueCategoryType;
  updateCause: CauseType;
  updateChallenge: ChallengeType;
  updateCoin: CoinType;
  updateComment: CommentType;
  updateCompany: CompanyType;
  updateCompanyContact: CompanyContactType;
  updateContentType: ContentTypeType;
  updateCorporateDashboard: CorporateUserDashType;
  updateCorporateEmailTemplate: CorporateEmailTemplateType;
  updateCorporateNotification: CorporateNotificationFullType;
  updateCorporateRating: CorporateRatingType;
  updateCorporateRatingAssignmentStatus: CorporateRatingAssignmentType;
  updateCorporateRatingDefinition: CorporateRatingDefinitionType;
  updateCorporateTemplate: CorporateTemplateType;
  updateCorporateUserCard: CorporateUserCardType;
  updateCorporateUserProfile: UserType;
  updateCountry: CountryType;
  updateCoupon: CouponType;
  updateCouponSettings: CouponSettingsType;
  updateCurrency: CurrencyType;
  updateCurrentUser: UserType;
  updateCurrentUserApp: UserType;
  updateCurrentUserEmail: LoginType;
  updateCurrentUserLogins: LoginType;
  updateCurrentUserPassword: UserType;
  updateCurrentUserPasswordForApp: UserType;
  updateDeliveryZone: DeliveryZonesType;
  updateDepartment: DepartmentType;
  updateDocument: DocumentType;
  updateEmailIntegration: EmailIntegrationType;
  updateEmailTemplate: EmailTemplateType;
  updateErpIntegration: ErpIntegrationType;
  updateErpIntegrationEventStatus: ErpIntegrationType;
  updateEvent: EventType;
  updateEventInvite: EventInviteType;
  updateEventTicket: EventTicketType;
  updateFBCatalogSync: FbCatalogSyncType;
  updateFacebookPixel: FbPixelType;
  updateFacebookPixelEventStatus: FbPixelType;
  updateFeaturedCorporateRank: FeaturedCorporateType;
  updateFlow: FlowType;
  updateFont: FontType;
  updateForm: FormResponseType;
  updateFormStatus: FormResponseType;
  updateFreebie: FreebieType;
  updateFreebieTransaction: FreebieTransactionType;
  updateGame: GameType;
  updateGameIntegration: GameIntegrationType;
  updateGameOrderStatus: SuccessResponseDtoType;
  updateGameRewards: GameIntegrationRewardType;
  updateGlobalCategory: GlobalCategoryType;
  updateGoogleAnalytics: GoogleAnalyticsType;
  updateGoogleAnalyticsEventStatus: GoogleAnalyticsType;
  updateHelpdeskIntegration: HelpdeskIntegrationType;
  updateIntegrationIntegration: IntegrationIntegrationType;
  updateInternalProduct: InternalProductType;
  updateInternalProductAndProduct: InternalProductType;
  updateInventoryCategory: InventoryCategoryType;
  updateInventoryIntegration: InventoryIntegrationType;
  updateJobApplication: JobApplicationType;
  updateJobDefinition: JobDefinitionType;
  updateLabel: LabelType;
  updateLandingPage: LandingPagesType;
  updateLandingPageStatus: LandingPagesType;
  updateLanguage: LanguageType;
  updateLocation: LocationType;
  updateLogistic: LogisticType;
  updateLogisticsIntegration: LogisticsIntegrationType;
  updateLoyaltyProgram: LoyaltyProgramType;
  updateLoyaltySettings: LoyaltySettingsType;
  updateManufacturer: ManufacturerType;
  updateMarketplaceOrderInstallments: MarketPlaceOrderDtoType;
  updateMessageGroup: MessageGroupType;
  updateModuleAssignment: ModulesAssignmentType;
  updateModuleDefinition: ModulesDefinitionType;
  updateNote: NotesType;
  updateNotificationIntegration: NotificationIntegrationType;
  updateOperatingSystem: OperatingSystemType;
  updateOrderSettings: OrderSettingsFullType;
  updateOutbound: OutboundType;
  updatePOSCategory: PosCategoryType;
  updatePOSServices: PosServicesType;
  updatePartnerReferral: PartnerReferralType;
  updatePartnershipNetwork: PartnershipNetworkType;
  updatePayment: PaymentType;
  updatePermission: PermissionType;
  updatePermissionDefinition: PermissionDefinitionType;
  updatePlugin: PluginType;
  updatePointOfSale: PointOfSaleType;
  updatePreLevelGoalStatus: Array<LoyaltySettingsType>;
  updatePredefined: PredefinedType;
  updatePrice: PriceType;
  updateProduct: ProductType;
  updateProductAttribute: ProductAttributeType;
  updateProductCredit: ShoppingCartType;
  updateProductRating: ProductRatingType;
  updateProductRatingDefinition: ProductRatingDefinitionType;
  updateProductStatus: MarketPlaceOrderDtoType;
  updateProgram: ProgramType;
  updateProject: ProjectType;
  updatePromotion: PromotionType;
  updatePurchaseDeliveryNote: PurchaseDeliveryNoteType;
  updatePurchaseIntegration: PurchaseIntegrationType;
  updatePurchaseInvoice: PurchaseInvoiceType;
  updatePurchaseOrder: PurchaseOrderType;
  updateQuest: QuestType;
  updateQuestActionDefinition: QuestActionDefinitionType;
  updateQuestActivity: QuestActivityType;
  updateQuestType: QuestTypeType;
  updateQuestion: QuestionDtoType;
  updateQuotation: QuotationType;
  updateRentalDetails: RentalRefType;
  updateRentalStatus: RentalRefType;
  updateReputationLevelGoalStatus: ReputationType;
  updateReputationLevelPoints: Array<ReputationType>;
  updateRequestStatus: RequestType;
  updateSEO: SeoType;
  updateSaleDeliveryNote: SaleDeliveryNoteType;
  updateSaleInvoice: SaleInvoiceType;
  updateSaleIssueNote: SaleIssueNoteType;
  updateSaleOrder: SaleOrderType;
  updateSalesIntegration: SalesIntegrationType;
  updateShortcut: ShortcutType;
  updateSimpleProduct: InternalProductType;
  updateSlides: SlidesType;
  updateSmsIntegration: SmsIntegrationType;
  updateSocial: SocialType;
  updateState: StateType;
  updateStaticTranslation: StaticTranslationType;
  updateStock: StockType;
  updateSupplier: SupplierType;
  updateTargetPlugin: TargetPluginType;
  updateTargetReputation: ReputationType;
  updateTask: TaskType;
  updateTaskSection: TaskSectionType;
  updateTax: TaxType;
  updateTechDevice: TechDeviceType;
  updateTechDeviceBrand: TechDeviceBrandType;
  updateTechDeviceType: TechDeviceTypeType;
  updateTicket: TicketType;
  updateTimeTrack: TimeTrackType;
  updateUser: UserType;
  updateUserApp: UserType;
  updateUserPasswordForApp: UserType;
  updateVapidKey: VapidKeyType;
  updateVersion: VersionType;
  updateVisuals: VisualsType;
  updateWalletTopup: WalletTopupType;
  updateWalletTopupSettings: WalletTopupSettingsType;
  updateWarehouse: WarehouseType;
  updateWebsiteIntegration: WebsiteIntegrationType;
  updateWholesaler: WholesalerType;
  updateWidgetIntegration: WidgetIntegrationType;
  updateWidgetVisuals: WidgetVisualsType;
  upsertQuestAnalytics: QuestAnalyticsType;
  validateEmailForTarget: CorporateUserType;
  validateLinkOrCodeForTarget: SuccessResponseDtoType;
  validateMail: UserType;
  validatePhoneNumber: UserType;
};


export type MutationAcceptMarketplaceOrderDeliveryArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationActivateOutboundArgs = {
  id: Scalars['ID']['input'];
};


export type MutationActivateWidgetIntegrationActionArgs = {
  id: Scalars['ID']['input'];
  input: WidgetIntegrationActionsInput;
};


export type MutationAddAccessApiToTargetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAddAccountPermissionArgs = {
  permissionId: Scalars['ID']['input'];
  target: TargetAciInput;
  userId: Scalars['ID']['input'];
};


export type MutationAddBarcodeToInternalProductAndProductArgs = {
  barcodeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};


export type MutationAddBudgetToQuestArgs = {
  id: Scalars['ID']['input'];
  maxAnswers: Scalars['Int']['input'];
};


export type MutationAddDiscountToCartArgs = {
  id: Scalars['ID']['input'];
  input: DiscountDtoInput;
};


export type MutationAddFcmTokenArgs = {
  fcmToken: Scalars['String']['input'];
};


export type MutationAddGameGroupArgs = {
  input: AddGameGroupInput;
};


export type MutationAddGameRewardArgs = {
  input: AddRewardInput;
};


export type MutationAddGameToGameGroupArgs = {
  input: AddGameToGameGroupInput;
};


export type MutationAddMemeberToMessageGroupArgs = {
  id: Scalars['ID']['input'];
  user: Array<Scalars['ID']['input']>;
};


export type MutationAddProductToComparatorArgs = {
  input: CompareProductInput;
};


export type MutationAddProductsToCartArgs = {
  products: Array<CartProductInput>;
  target?: InputMaybe<TargetAciInput>;
};


export type MutationAddReputationLevelArgs = {
  input: AddReputationInput;
};


export type MutationAddTargetToAccountArgs = {
  permission?: InputMaybe<Scalars['ID']['input']>;
  target: TargetAciInput;
  userId: Scalars['ID']['input'];
};


export type MutationAddToCartArgs = {
  product: CartProductInput;
  target?: InputMaybe<TargetAciInput>;
};


export type MutationAddToStockArgs = {
  id: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  warehouse?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAddToStockCustomArgs = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  barcodeId?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['Int']['input'];
  target: TargetAciInput;
  warehouse?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAddUserForTargetArgs = {
  input: UserWithTargetInput;
};


export type MutationAddUserToNewsLetterArgs = {
  email: Scalars['String']['input'];
  target: TargetAciInput;
};


export type MutationApproveLinkCorporateAccountArgs = {
  code: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationApproveLoyaltySubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApproveSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveMessageGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAssignDefaultAudienceToTargetArgs = {
  id: Scalars['ID']['input'];
  target: TargetAciInput;
};


export type MutationBulkUpdateBarcodeMediaArgs = {
  input: Array<UpdateMediaInput>;
};


export type MutationBulkUpdateCompanyMediaArgs = {
  input: Array<UpdateMediaInput>;
};


export type MutationBulkUpdateProjectMediaArgs = {
  input: Array<UpdateMediaInput>;
};


export type MutationBulkUpdateTicketMediaArgs = {
  input: Array<UpdateMediaInput>;
};


export type MutationBulkUpdateWarehouseMediaArgs = {
  input: Array<UpdateMediaInput>;
};


export type MutationCancelMarketplaceOrderDeliveryArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationCancelOrderByTargetArgs = {
  id: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
};


export type MutationCancelProductByConsumerArgs = {
  input: MarketPlaceOrderProductInput;
};


export type MutationCancelProductByDeliveryManArgs = {
  input: MarketPlaceOrderProductInput;
};


export type MutationCancelProductByTargetArgs = {
  input: MarketPlaceOrderProductInput;
  subject: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
};


export type MutationCancelSubscriptionArgs = {
  target: TargetAciInput;
  userId: Scalars['ID']['input'];
};


export type MutationConfirmWalletTopupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConvertWalletPointsArgs = {
  input: WalletConversionInput;
};


export type MutationCreateAccountArgs = {
  input: AccountInput;
};


export type MutationCreateActivityTypeArgs = {
  input: ActivityTypeInput;
};


export type MutationCreateAdhocCorporateNotificationArgs = {
  input: CorporateNotificationInput;
};


export type MutationCreateAdhocNotificationArgs = {
  description: Scalars['String']['input'];
  executedAt?: InputMaybe<Scalars['DateTime']['input']>;
  picture: PictureInput;
  target: TargetAciInput;
  title: Scalars['String']['input'];
};


export type MutationCreateAdhocTransactionArgs = {
  input: AdhocTransactionInput;
};


export type MutationCreateAttributeArgs = {
  input: AttributeCreateInput;
};


export type MutationCreateAttributeValueArgs = {
  input: AttributeValueInput;
};


export type MutationCreateAudienceArgs = {
  input: AudienceInput;
};


export type MutationCreateAudienceCriteriaArgs = {
  input: AudienceCriteriaInput;
};


export type MutationCreateBadgeArgs = {
  input: BadgeInput;
};


export type MutationCreateBankArgs = {
  input: BankInput;
};


export type MutationCreateBankDetailsArgs = {
  input: BankDetailsInput;
};


export type MutationCreateBarcodeArgs = {
  input: BarcodeInput;
  target?: InputMaybe<TargetAciInput>;
};


export type MutationCreateBarcodeForTargetArgs = {
  input: BarcodeInput;
  target?: InputMaybe<TargetAciInput>;
};


export type MutationCreateBarcodeForTargetWithStockArgs = {
  input: BarcodeInput;
  target?: InputMaybe<TargetAciInput>;
};


export type MutationCreateBlogArgs = {
  input: BlogInput;
};


export type MutationCreateBoardArgs = {
  category?: InputMaybe<BoardCategoryEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  members?: InputMaybe<Array<Scalars['ID']['input']>>;
  projects?: InputMaybe<Array<Scalars['ID']['input']>>;
  target: TargetAciInput;
  title: Scalars['String']['input'];
};


export type MutationCreateBoardCardArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assignedTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  attachments?: InputMaybe<Array<Scalars['ID']['input']>>;
  barcode?: InputMaybe<Scalars['ID']['input']>;
  boardList?: InputMaybe<Scalars['ID']['input']>;
  budget?: Scalars['Decimal']['input'];
  customer?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  labels?: InputMaybe<Array<Scalars['ID']['input']>>;
  pictures?: InputMaybe<Array<PictureInput>>;
  priority?: InputMaybe<BoardCardPriorityEnum>;
  procedure?: InputMaybe<Array<BoardCardProcedureInput>>;
  project?: InputMaybe<Scalars['ID']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tasks?: InputMaybe<Array<BoardCardTasksInput>>;
  title: Scalars['String']['input'];
};


export type MutationCreateBoardListArgs = {
  board: Scalars['ID']['input'];
  identifier?: InputMaybe<MaintenanceBoardListEnum>;
  name: Scalars['String']['input'];
  rank?: InputMaybe<Scalars['Int']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateBrandArgs = {
  input: BrandInput;
};


export type MutationCreateBrowserArgs = {
  input: BrowserInput;
};


export type MutationCreateCatalogueCategoryArgs = {
  input: CatalogueCategoryInput;
};


export type MutationCreateCauseArgs = {
  input: CauseInput;
};


export type MutationCreateChallengeArgs = {
  input: ChallengeInput;
};


export type MutationCreateCoinArgs = {
  input: CoinInput;
};


export type MutationCreateCommentArgs = {
  input: CommentInput;
};


export type MutationCreateCompanyArgs = {
  input: CompanyInput;
};


export type MutationCreateCompanyContactArgs = {
  input: CompanyContactInput;
};


export type MutationCreateContentTypeArgs = {
  input: ContentTypeInput;
};


export type MutationCreateCorporateDashboardArgs = {
  input: CorporateUserDashboardInput;
};


export type MutationCreateCorporateEmailTemplateArgs = {
  input: CorporateEmailTemplateInput;
};


export type MutationCreateCorporateRatingArgs = {
  input: CorporateRatingInput;
};


export type MutationCreateCorporateRatingAssignmentArgs = {
  input: CorporateRatingAssignmentInput;
};


export type MutationCreateCorporateRatingDefinitionArgs = {
  reviewType: Scalars['String']['input'];
};


export type MutationCreateCorporateTemplateArgs = {
  input: CorporateTemplateInput;
};


export type MutationCreateCountryArgs = {
  input: CountryInput;
};


export type MutationCreateCouponArgs = {
  input: CouponInput;
};


export type MutationCreateCouponSettingsArgs = {
  input: CouponSettingsInput;
};


export type MutationCreateCurrencyArgs = {
  input: CurrencyInput;
};


export type MutationCreateCustomInternalProductArgs = {
  input: CreateCustomInternalProductInput;
};


export type MutationCreateDefaultAudienceArgs = {
  input: DefaultAudienceInput;
};


export type MutationCreateDeliveryZoneArgs = {
  input: DeliveryZonesInput;
};


export type MutationCreateDepartmentArgs = {
  input: DepartmentInput;
};


export type MutationCreateDirectMessageArgs = {
  input: DirectMessageInput;
};


export type MutationCreateDocumentArgs = {
  input: DocumentInput;
};


export type MutationCreateEmailTemplateArgs = {
  input: EmailTemplateInput;
};


export type MutationCreateEventInviteArgs = {
  input: EventInviteInput;
};


export type MutationCreateFeaturedCorporateArgs = {
  input: FeaturedCorporateInput;
};


export type MutationCreateFontArgs = {
  input: FontInput;
};


export type MutationCreateFormArgs = {
  input: CreateFormInput;
};


export type MutationCreateFreebieArgs = {
  input: FreebieInput;
};


export type MutationCreateFreebieTransactionArgs = {
  input: FreebieTransactionInput;
};


export type MutationCreateGameArgs = {
  input: GameInput;
};


export type MutationCreateGameOrderArgs = {
  input: GameOrderInput;
};


export type MutationCreateGlobalCategoryArgs = {
  input: GlobalProviderCategoryInput;
};


export type MutationCreateInternalProductArgs = {
  input: CreateInternalProductInput;
};


export type MutationCreateInternalProductAndProductArgs = {
  barcodes?: InputMaybe<Array<Scalars['ID']['input']>>;
  brand?: InputMaybe<Scalars['ID']['input']>;
  catalogueCategory: Array<Scalars['ID']['input']>;
  category?: InputMaybe<Array<Scalars['ID']['input']>>;
  classification?: InputMaybe<Array<ProductClassEnum>>;
  condition?: InputMaybe<ProductConditionEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionList?: InputMaybe<Array<Scalars['String']['input']>>;
  discount?: InputMaybe<DiscountDtoInput>;
  ean?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  factoryPrice?: InputMaybe<Scalars['Decimal']['input']>;
  flags?: InputMaybe<ProductFlagEnum>;
  globalCategory?: InputMaybe<GlobalCategoryInput>;
  internalProductAttributes?: InputMaybe<InternalProductAttributeInput>;
  longdesc?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  name: Scalars['String']['input'];
  picture?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<Array<PictureInput>>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  specs?: InputMaybe<Array<ProductSpecsInput>>;
  status?: InputMaybe<ProductStatusEnum>;
  structure?: InputMaybe<ProductStructureEnum>;
  suppliers?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  target: TargetAciInput;
  tax: Scalars['Decimal']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  wholesalerPrice?: InputMaybe<Scalars['Decimal']['input']>;
};


export type MutationCreateInventoryCategoryArgs = {
  input: InventoryCategoryInput;
};


export type MutationCreateJobApplicationArgs = {
  input: JobApplicationInput;
};


export type MutationCreateJobDefinitionArgs = {
  input: JobDefinitionInput;
};


export type MutationCreateLabelArgs = {
  category: LabelTypeEnum;
  color?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  target: TargetAciInput;
};


export type MutationCreateLandingPageArgs = {
  input: LandingPagesInput;
};


export type MutationCreateLanguageArgs = {
  input: LanguageInput;
};


export type MutationCreateLocationArgs = {
  input: LocationInput;
};


export type MutationCreateLogisticArgs = {
  input: LogisticInput;
};


export type MutationCreateLoyaltyProgramArgs = {
  input: LoyaltyProgramInput;
};


export type MutationCreateMaintenanceBoardCardArgs = {
  input: MaintenanceBoardCardInput;
};


export type MutationCreateManufacturerArgs = {
  input: ManufacturerCreateInput;
};


export type MutationCreateMarketPlaceOrderArgs = {
  input: MarketPlaceOrderInput;
};


export type MutationCreateMessageArgs = {
  input: MessageInput;
};


export type MutationCreateMessageGroupArgs = {
  input?: InputMaybe<MessageGroupInput>;
};


export type MutationCreateModuleAssignmentArgs = {
  input: ModulesAssignmentInput;
};


export type MutationCreateModuleDefinitionArgs = {
  input: ModulesDefinitionInput;
};


export type MutationCreateNewVersionArgs = {
  input: NewVersionInput;
};


export type MutationCreateNoteArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  labels: Array<Scalars['ID']['input']>;
  picture?: InputMaybe<PictureInput>;
  target: TargetAciInput;
  tasks?: InputMaybe<Array<TaskInput>>;
  title: Scalars['String']['input'];
};


export type MutationCreateOperatingSystemArgs = {
  input: OperatingSystemInput;
};


export type MutationCreateOrUpdateFavoriteInternalProductsArgs = {
  input: FavoriteInternalProductInput;
};


export type MutationCreateOrUpdateFavoriteProductsArgs = {
  input: FavoriteProductInput;
};


export type MutationCreateOrderSettingsArgs = {
  input: OrderSettingsInput;
};


export type MutationCreateOutboundCorporateNotificationArgs = {
  input: CorporateOutboundNotificationInput;
};


export type MutationCreatePosCategoryArgs = {
  input: PosCategoryInput;
};


export type MutationCreatePosServicesArgs = {
  input: PosServicesInput;
};


export type MutationCreatePartnerReferralArgs = {
  input: PartnerReferralInput;
};


export type MutationCreatePartnershipNetworkArgs = {
  input: NewPartnershipNetworkInput;
};


export type MutationCreatePaymentArgs = {
  input: PaymentInput;
};


export type MutationCreatePermissionArgs = {
  input: PermissionInput;
};


export type MutationCreatePermissionDefinitionArgs = {
  input: PermissionDefinitionInput;
};


export type MutationCreatePluginArgs = {
  input: PluginInput;
};


export type MutationCreatePointOfSaleArgs = {
  input: PointOfSaleInput;
};


export type MutationCreatePredefinedArgs = {
  input: PredefinedInput;
};


export type MutationCreatePriceArgs = {
  input: PriceInput;
};


export type MutationCreateProductArgs = {
  input: ProductInput;
};


export type MutationCreateProductAttributeArgs = {
  input: ProductAttributeInput;
};


export type MutationCreateProductClicksArgs = {
  input: ProductClicksInput;
};


export type MutationCreateProductRatingArgs = {
  input: ProductRatingInput;
};


export type MutationCreateProductRatingDefinitionArgs = {
  input: ProductRatingDefinitionInput;
};


export type MutationCreateProjectArgs = {
  input: ProjectInput;
};


export type MutationCreatePromotionArgs = {
  input: PromotionInput;
};


export type MutationCreatePurchaseDeliveryNoteArgs = {
  input: PurchaseDeliveryNoteInput;
};


export type MutationCreatePurchaseInvoiceArgs = {
  input: PurchaseInvoiceInput;
};


export type MutationCreatePurchaseOrderArgs = {
  input: PurchaseOrderInput;
};


export type MutationCreateQuestArgs = {
  input: QuestInput;
};


export type MutationCreateQuestActionDefinitionArgs = {
  input: QuestActionDefinitionInput;
};


export type MutationCreateQuestActivityArgs = {
  input: QuestActivityInput;
};


export type MutationCreateQuestTypeArgs = {
  input: QuestTypeInput;
};


export type MutationCreateQuestionArgs = {
  input: QuestionInput;
};


export type MutationCreateQuotationArgs = {
  input: QuotationInput;
};


export type MutationCreateRecentlyViewedArgs = {
  product: Scalars['ID']['input'];
};


export type MutationCreateRequestArgs = {
  input: RequestInput;
};


export type MutationCreateResponseArgs = {
  input: ResponseInput;
};


export type MutationCreateSeoArgs = {
  input: SeoInput;
};


export type MutationCreateSaleAvoirArgs = {
  input: SaleAvoirInput;
};


export type MutationCreateSaleDeliveryNoteArgs = {
  input: SaleDeliveryNoteInput;
};


export type MutationCreateSaleInvoiceArgs = {
  input: SaleInvoiceInput;
};


export type MutationCreateSaleIssueNoteArgs = {
  input: SaleIssueNoteInput;
};


export type MutationCreateSaleOrderArgs = {
  input: SaleOrderInput;
};


export type MutationCreateServiceProductArgs = {
  input: BarcodeInput;
  target?: InputMaybe<TargetAciInput>;
};


export type MutationCreateSimpleProductArgs = {
  input: CreateSimpleProductInput;
};


export type MutationCreateSlidesArgs = {
  input: SlidesInput;
};


export type MutationCreateSocialArgs = {
  input: SocialInput;
};


export type MutationCreateStateArgs = {
  input: StateInput;
};


export type MutationCreateStaticTranslationArgs = {
  input: StaticTranslationInput;
};


export type MutationCreateStockArgs = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  barcodeId?: InputMaybe<Scalars['ID']['input']>;
  target: TargetAciInput;
  warehouse?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateSupplierArgs = {
  input: SupplierInput;
};


export type MutationCreateTargetOrderByCartArgs = {
  input: MarketPlaceOrderInput;
  source?: InputMaybe<UserEventsSourceEnum>;
  target: TargetAciInput;
};


export type MutationCreateTargetOrderWithCartArgs = {
  input: MarketPlaceOrderWithCartInput;
};


export type MutationCreateTargetOrderWithCartAndCoinsArgs = {
  input: MarketPlaceOrderWithCartAndCoinsInput;
};


export type MutationCreateTargetOrderWithCartAndRegisterUserArgs = {
  input: MarketPlaceOrderWithCartAfterRegisterInput;
};


export type MutationCreateTargetOrderWithCartForGuestUserArgs = {
  input: MarketPlaceOrderWithCartForGuestInput;
};


export type MutationCreateTargetPluginArgs = {
  input: TargetPluginInput;
};


export type MutationCreateTaskArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  priority: TaskPriorityEnum;
  rank?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  taskSection: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationCreateTaskSectionArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  priority: TaskPriorityEnum;
  rank?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  target: TargetAciInput;
  title: Scalars['String']['input'];
};


export type MutationCreateTaxArgs = {
  input: TaxInput;
};


export type MutationCreateTechDeviceArgs = {
  input: TechDeviceInput;
};


export type MutationCreateTechDeviceBrandArgs = {
  input: TechDeviceBrandInput;
};


export type MutationCreateTechDeviceTypeArgs = {
  input: TechDeviceTypeInput;
};


export type MutationCreateTicketArgs = {
  input: TicketInput;
};


export type MutationCreateTimeTrackArgs = {
  input: TimeTrackInput;
};


export type MutationCreateUserArgs = {
  input: UserInput;
  subject: Scalars['String']['input'];
  variables?: InputMaybe<EmailTempVariablesInput>;
};


export type MutationCreateUserForAppArgs = {
  input: UserInput;
  subject: Scalars['String']['input'];
  variables?: InputMaybe<EmailTempVariablesInput>;
};


export type MutationCreateVisualsArgs = {
  input: VisualsInput;
};


export type MutationCreateWalletArgs = {
  input: WalletInput;
};


export type MutationCreateWalletTopupArgs = {
  input: WalletTopupInput;
};


export type MutationCreateWalletTopupSettingsArgs = {
  input: WalletTopupSettingsInput;
};


export type MutationCreateWarehouseArgs = {
  input: WarehouseInput;
};


export type MutationCreateWholesalerArgs = {
  input: WholesalerCreateInput;
};


export type MutationCreateWidgetVisualsArgs = {
  input: WidgetVisualsInput;
};


export type MutationDeductAmountFromUserArgs = {
  input: DeductAmountFromUserInput;
};


export type MutationDeductCoinsFromUserArgs = {
  amount: Scalars['String']['input'];
  coin?: InputMaybe<Scalars['String']['input']>;
  game?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<TransactionTypeEnum>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteAccountArgs = {
  accountId: Scalars['String']['input'];
};


export type MutationDeleteAccountPermissionArgs = {
  target: TargetAciInput;
  userId: Scalars['ID']['input'];
};


export type MutationDeleteActivityTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAdhocTransactionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAttributeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAttributeValueArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAudienceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAudienceCriteriaArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBadgeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBankArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBankDetailsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBarcodeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteBarcodeWithstockArgs = {
  barcodeId: Scalars['ID']['input'];
};


export type MutationDeleteBlogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBoardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBoardCardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBoardListArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBrandArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteBrowserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCatalogueCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCauseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteChallengeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCoinArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCompanyContactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContentTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCorporateDashboardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCorporateEmailTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCorporateNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCorporateRatingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCorporateRatingAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCorporateRatingDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCorporateTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCountryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCurrencyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDeliveryZoneArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDepartmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmailIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmailTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteErpIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEventArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEventInviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEventTicketArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFbCatalogSyncArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFbPixelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFeaturedCorporateArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteFlowArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFontArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFormArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFormAndQuestionsArgs = {
  form: Scalars['ID']['input'];
};


export type MutationDeleteFreebieArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFreebieTransactionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGameArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGameIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGameRewardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGlobalCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGoogleAnalyticsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteHelpdeskIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteIntegrationIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInternalProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInventoryCategoryArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteInventoryIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteJobApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteJobDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLabelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLandingPageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLanguageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLinkCorporateAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLocationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLogisticArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLogisticsIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLoyaltyProgramArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteManufacturerArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteModuleAssignmentArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteModuleDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteNoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteNotificationIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOperatingSystemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOutboundArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePosCategoryArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePosServicesArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePartnerReferralArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePartnershipNetworkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePaymentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePermissionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePermissionDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePluginArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePointOfSaleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePredefinedArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePriceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProductArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteProductAttributeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteProductRatingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProductRatingDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProgramArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePromotionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePurchaseDeliveryNoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePurchaseIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePurchaseInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePurchaseOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteQuestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteQuestActionDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteQuestActivityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteQuestTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteQuotationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteResponseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSeoArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSaleDeliveryNoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSaleInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSaleIssueNoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSaleOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSalesIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteShortcutArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSlidesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSmsIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSocialArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStaticTranslationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStockArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSubscriberArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSupplierArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTargetFromAccountArgs = {
  target: TargetAciInput;
  userId: Scalars['ID']['input'];
};


export type MutationDeleteTargetPluginArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTargetReputationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaskSectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaxArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTechDeviceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTechDeviceBrandArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTechDeviceTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTicketArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTimeTrackArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  password: Scalars['String']['input'];
  reason: DeleteUserReasonEnum;
};


export type MutationDeleteUserWithDataArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVisualsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWalletTopupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWalletTopupSettingsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWarehouseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWebsiteIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWholesalerArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteWidgetIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWidgetVisualsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeliverWalletTopupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisableAdhocTransactionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisableCouponArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisableCouponSettingsArgs = {
  id: Scalars['String']['input'];
};


export type MutationDisableWidgetIntegrationActionArgs = {
  id: Scalars['ID']['input'];
  input: WidgetIntegrationActionsBaseInput;
};


export type MutationEmptyTargetCartArgs = {
  target: TargetAciInput;
};


export type MutationEnableAdhocTransactionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEnableCouponSettingsArgs = {
  id: Scalars['String']['input'];
};


export type MutationExpireCorporateUserCardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFinishOutboundArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGenerateCouponsArgs = {
  input: CouponsInput;
};


export type MutationGenerateEcomSitemapXmlArgs = {
  target: TargetAciInput;
};


export type MutationGenerateTargetUserCardsArgs = {
  target: TargetAciInput;
};


export type MutationGenerateTargetUserCardsBatchArgs = {
  target: TargetAciInput;
};


export type MutationGetProgramsByEventArgs = {
  event: Scalars['ID']['input'];
};


export type MutationGetShortcutsByUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationImportAudienceUsersByExcelArgs = {
  audienceId: Scalars['ID']['input'];
  base64?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
};


export type MutationImportCustomersByExcelArgs = {
  base64?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type MutationImportFullCorporateCatalogueByExcelArgs = {
  base64?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
  variety: ProductVarietyEnum;
};


export type MutationImportInvoicingByExcelArgs = {
  base64?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<TargetAciInput>;
  type?: InputMaybe<SequenceCategoryEnum>;
};


export type MutationImportPosByExcelArgs = {
  base64?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
};


export type MutationImportProjectsByExcelArgs = {
  base64?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<TargetAciInput>;
};


export type MutationImportServicesCatalogueByExcelArgs = {
  base64?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
  variety: ProductVarietyEnum;
};


export type MutationImportSimpleFullCatalogueByXmlLinkArgs = {
  target: TargetAciInput;
  variety?: InputMaybe<ProductVarietyEnum>;
};


export type MutationImportSimpleFullCorporateCatalogueByExcelArgs = {
  base64?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
  variety: ProductVarietyEnum;
};


export type MutationImportSuppliersByExcelArgs = {
  base64?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type MutationImportTargetOrdersByExcelArgs = {
  base64?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type MutationImportTargetOrdersByXmlLinkArgs = {
  target: TargetAciInput;
};


export type MutationImportTargetUserCardsByExcelArgs = {
  base64?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type MutationImportTargetUsersByExcelArgs = {
  base64?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type MutationImportTargetUsersWithConventionByExcelArgs = {
  base64?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type MutationInitReputationsArgs = {
  target: TargetAciInput;
};


export type MutationInitStaticTranslationsArgs = {
  app: TranslationAppEnum;
  language: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type MutationInitStockArgs = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  barcodeId?: InputMaybe<Scalars['ID']['input']>;
  target: TargetAciInput;
  warehouse?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationInitWidgetVisualsArgs = {
  app: TranslationAppEnum;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type MutationInsertEventArgs = {
  input: EventInput;
};


export type MutationInsertEventTicketsArgs = {
  input: EventTicketInput;
};


export type MutationInsertFlowArgs = {
  input: FlowInput;
};


export type MutationInsertOriginArgs = {
  url: Scalars['String']['input'];
};


export type MutationInsertOutboundArgs = {
  input: OutboundInput;
};


export type MutationInsertProgramArgs = {
  input: ProgramInput;
};


export type MutationInsertShortcutArgs = {
  input: ShortcutInput;
};


export type MutationInsertStaticDataArgs = {
  input: StaticDataInput;
};


export type MutationInsertStoryArgs = {
  input: StoriesInput;
};


export type MutationInvitePartnerToNetworkArgs = {
  input: PartnershipNetworkInput;
};


export type MutationLinkUserAccountArgs = {
  input: LinkAccountWithLoginInput;
};


export type MutationLoginUserByTargetArgs = {
  input: LoginUserByTargetInput;
};


export type MutationLoginWithPartnerArgs = {
  input: LoginUserByTargetInput;
};


export type MutationMarkAllAsSeenForPosArgs = {
  posId: Scalars['String']['input'];
};


export type MutationMarkAllCorporateNotificationsAsSeenForUserArgs = {
  target: TargetAciInput;
};


export type MutationMarkAllCorporateNotificationsAsSeenForUserWithLinkedAccountsArgs = {
  target: TargetAciInput;
};


export type MutationMarkAllMessageAsSeenArgs = {
  messageGroup: Scalars['ID']['input'];
};


export type MutationMarkAllMessagesAsSeenForTargetArgs = {
  messageGroup: Scalars['ID']['input'];
  target: TargetAciInput;
};


export type MutationMarkEventInviteAsApprovedArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkEventInviteAsOpenArgs = {
  id: Scalars['String']['input'];
};


export type MutationMarkEventInviteAsRejectedArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkInternalProductAsFavoriteArgs = {
  productId: Scalars['ID']['input'];
};


export type MutationMarkMessageAsSeenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkProductAsFavoriteArgs = {
  productId: Scalars['String']['input'];
};


export type MutationMarkSimpleProductAsFavoriteArgs = {
  productId: Scalars['ID']['input'];
};


export type MutationMarkStoryAsSeenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkTicketAsAttendedArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkTicketAsOpenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkTicketAsPaidArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMergeAccountsArgs = {
  token: Scalars['String']['input'];
};


export type MutationMuteMessageGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOnboardUserToTargetLoyaltyArgs = {
  id: Scalars['ID']['input'];
  target: TargetAciInput;
};


export type MutationPayMarketplaceOrderInstallmentsArgs = {
  input: InstallmentPaymentInput;
};


export type MutationPerformDirectDonationArgs = {
  amount: Scalars['Decimal']['input'];
  wallet: Scalars['ID']['input'];
};


export type MutationPerformDonationActivityArgs = {
  amount: Scalars['String']['input'];
  challengeId: Scalars['ID']['input'];
};


export type MutationPerformNonPredefinedQuestByUserArgs = {
  input: PerformNonPredefinedQuestByUserInput;
  userToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPerformOnsiteActivityArgs = {
  input: PushAmountInput;
};


export type MutationPerformPredefinedQuestByUserArgs = {
  quest: Scalars['ID']['input'];
};


export type MutationProcessWelcomeMailArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationProcessWelcomeMailForTargetArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationPublishBlogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPublishLandingPageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPurchaseCouponArgs = {
  amount: Scalars['String']['input'];
  discount: DiscountDtoInput;
  target: TargetAciInput;
};


export type MutationRedeemCouponArgs = {
  couponCode: Scalars['String']['input'];
  target: TargetAciInput;
};


export type MutationRedeemCouponByTargetArgs = {
  couponCode: Scalars['String']['input'];
  target: TargetAciInput;
};


export type MutationRedeemFrebiesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRedeemReferralArgs = {
  card: Scalars['String']['input'];
  reference: Scalars['String']['input'];
};


export type MutationRefreshSitemapXmlArgs = {
  hostname: Scalars['String']['input'];
  target: TargetAciInput;
  urls: Array<Scalars['String']['input']>;
};


export type MutationRefreshStaticTranslationsArgs = {
  app: TranslationAppEnum;
  language: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type MutationRefreshWidgetVisualsArgs = {
  app: TranslationAppEnum;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type MutationRegisterArgs = {
  brand: EmailTempVariablesBrandInput;
  input: UserInput;
  subject: Scalars['String']['input'];
};


export type MutationRegisterAccountForAppArgs = {
  brand: EmailTempVariablesBrandInput;
  input: UserAccountInput;
  subject: Scalars['String']['input'];
};


export type MutationRegisterApiForTargetArgs = {
  publicKey?: InputMaybe<Scalars['String']['input']>;
  secretKey?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type MutationRegisterForAppArgs = {
  brand: EmailTempVariablesBrandInput;
  input: UserInput;
  subject: Scalars['String']['input'];
};


export type MutationRegisterForTargetArgs = {
  input: UserWithTargetInput;
};


export type MutationRegisterForTargetWithOnboardArgs = {
  input: UserWithTargetInput;
  source?: InputMaybe<UserEventsSourceEnum>;
};


export type MutationRegisterForTargetWithWholesalerArgs = {
  input: UserWithTargetInput;
};


export type MutationRejectSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveAllFromStockArgs = {
  barcode: Scalars['ID']['input'];
};


export type MutationRemoveAudienceFromChallengeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveAudienceFromCorporateNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveAudienceFromOutboundArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveAudienceFromQuestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveExecutionDateFromCorporateNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveFromCartArgs = {
  product: CartProductInput;
  target?: InputMaybe<TargetAciInput>;
};


export type MutationRemoveFromStockArgs = {
  id: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  warehouse?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRemoveFromStockCustomArgs = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  barcodeId?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['Int']['input'];
  target: TargetAciInput;
  warehouse?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRemoveGameFromGameGroupArgs = {
  input: RemoveGameFromGameGroupInput;
};


export type MutationRemoveGameGroupArgs = {
  input: RemoveGameGroupInput;
};


export type MutationRemoveInternalProductFromFavoritesArgs = {
  productId: Scalars['ID']['input'];
};


export type MutationRemoveMemberFromMessageGroupArgs = {
  id: Scalars['ID']['input'];
  user: Array<Scalars['ID']['input']>;
};


export type MutationRemoveProductCompareFromListArgs = {
  product: Scalars['ID']['input'];
};


export type MutationRemoveProductFromFavoritesArgs = {
  productId: Scalars['String']['input'];
};


export type MutationRemoveReputationLevelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveSimpleProductFromFavoritesArgs = {
  productId: Scalars['ID']['input'];
};


export type MutationRemoveUserFromNewsLetterArgs = {
  email: Scalars['String']['input'];
  target: TargetAciInput;
};


export type MutationReorderBoardCardsArgs = {
  id: Scalars['ID']['input'];
  rank: Scalars['Int']['input'];
};


export type MutationReorderBoardListArgs = {
  id: Scalars['ID']['input'];
  rank: Scalars['Int']['input'];
};


export type MutationReorderCatalogueCategoriesArgs = {
  catalogCategoryId: Scalars['ID']['input'];
  newRank: Scalars['Float']['input'];
  target: TargetAciInput;
};


export type MutationReorderCorporateDashboardArgs = {
  dashboardId: Scalars['String']['input'];
  newRank: Scalars['Float']['input'];
  target: TargetAciInput;
};


export type MutationReorderDeliveryZonesArgs = {
  deliveryZoneId: Scalars['String']['input'];
  newOrder: Scalars['Float']['input'];
  target: TargetAciInput;
};


export type MutationReorderQuestActivityArgs = {
  id: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
};


export type MutationReorderQuestionArgs = {
  id: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
};


export type MutationReorderQuestionOfFormArgs = {
  id: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
};


export type MutationReorderTaskArgs = {
  id: Scalars['ID']['input'];
  rank: Scalars['Int']['input'];
};


export type MutationReorderTaskSectionsArgs = {
  id: Scalars['ID']['input'];
  rank: Scalars['Int']['input'];
};


export type MutationRequestLinkCorporateAccountArgs = {
  input: LinkAccountInput;
};


export type MutationRequestSubscriptionArgs = {
  input: SubscribersInput;
};


export type MutationResendApproveCodeArgs = {
  input: LinkAccountInput;
};


export type MutationResetPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationResetPasswordForTargetArgs = {
  password: Scalars['String']['input'];
  source?: InputMaybe<UserEventsSourceEnum>;
  target: TargetAciInput;
  token: Scalars['String']['input'];
};


export type MutationResetPasswordWithMailForAppArgs = {
  input: ResetPasswordForAppInput;
};


export type MutationResetPasswordWithSmsForAppArgs = {
  input: ResetPasswordForAppInput;
};


export type MutationResetStaticTranslationArgs = {
  app: TranslationAppEnum;
  language: Scalars['ID']['input'];
  reference: Scalars['String']['input'];
  target: TargetAciInput;
};


export type MutationResetStockArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetWidgetVisualArgs = {
  app: TranslationAppEnum;
  reference: Scalars['String']['input'];
  target: TargetAciInput;
};


export type MutationSaveCurrentCorporateUserStatusArgs = {
  status: UserStatus;
  target: TargetAciInput;
};


export type MutationSaveCurrentUserStatusArgs = {
  status: UserStatus;
};


export type MutationSaveLeaderboardArgs = {
  credit: Scalars['Decimal']['input'];
  gameCode: Scalars['String']['input'];
};


export type MutationSendBatchNotificationsArgs = {
  appName: Scalars['String']['input'];
  body: Scalars['String']['input'];
  settings: NotificationIntegrationFirebaseInput;
  title: Scalars['String']['input'];
  tokens: Array<Scalars['String']['input']>;
};


export type MutationSendForgotPasswordMailArgs = {
  brand?: InputMaybe<EmailTempVariablesBrandInput>;
  email: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};


export type MutationSendForgotPasswordMailOrSmsToTargetArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<IPhoneInput>;
  source?: InputMaybe<UserEventsSourceEnum>;
  subject?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type MutationSendForgotPasswordMailToTargetArgs = {
  email: Scalars['String']['input'];
  origin?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type MutationSendHttpRequestArgs = {
  headers: Array<ApiParamsInput>;
  method: ApiMethods;
  params: Array<ApiParamsInput>;
  url: Scalars['String']['input'];
};


export type MutationSendMergeAccountsEmailArgs = {
  app: App;
  email: Scalars['String']['input'];
  ooredooId: Scalars['String']['input'];
};


export type MutationSendMessageToTargetArgs = {
  input: SendMessageToTargetInput;
};


export type MutationSendRegistrationValidationSmsArgs = {
  phone: IPhoneInput;
  target: TargetAciInput;
};


export type MutationSendSimpleNotificationArgs = {
  appName: Scalars['String']['input'];
  body: Scalars['String']['input'];
  settings: NotificationIntegrationFirebaseInput;
  title: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSendTestQuestApiArgs = {
  api: QuestActionDefinitionDefinitionApiInput;
  params?: InputMaybe<Array<KeyValueInput>>;
};


export type MutationSendValidMailArgs = {
  subject: Scalars['String']['input'];
  variables?: InputMaybe<EmailTempVariablesInput>;
};


export type MutationSendValidSmsArgs = {
  target: TargetAciInput;
};


export type MutationSendValidationCodeArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<IPhoneInput>;
  source?: InputMaybe<UserEventsSourceEnum>;
  subject?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type MutationSendValidationEmailArgs = {
  email: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  target: TargetAciInput;
};


export type MutationSendValidationEmailForTargetArgs = {
  email: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  target: TargetAciInput;
};


export type MutationSetProductReadyForPickupArgs = {
  input: MarketPlaceOrderProductInput;
};


export type MutationSubscribeUserToTargetArgs = {
  target: TargetAciInput;
  user: Scalars['String']['input'];
};


export type MutationSyncOneAttributeArgs = {
  input: AttributeCreateInput;
};


export type MutationSyncOneAttributeValueArgs = {
  input: AttributeValueInput;
};


export type MutationSyncOneBrandArgs = {
  input: BrandInput;
};


export type MutationSyncOneCategoryArgs = {
  input: CatalogueCategoryBulkInput;
};


export type MutationTopupWalletArgs = {
  input: TopupWalletInput;
};


export type MutationUnarchiveMessageGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnmuteMessageGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateAccountArgs = {
  accountId: Scalars['String']['input'];
  expiresAt: Scalars['DateTime']['input'];
};


export type MutationUpdateAccountByAdminArgs = {
  accountId: Scalars['String']['input'];
  input: AccountUpdateInput;
};


export type MutationUpdateActivityTypeArgs = {
  id: Scalars['ID']['input'];
  input: ActivityTypeUpdateInput;
};


export type MutationUpdateAdhocTransactionArgs = {
  id: Scalars['ID']['input'];
  input: AdhocTransactionUpdateInput;
};


export type MutationUpdateAttributeArgs = {
  input: AttributeUpdateInput;
};


export type MutationUpdateAttributeValueArgs = {
  input: AttributeValueUpdateInput;
};


export type MutationUpdateAudienceArgs = {
  id: Scalars['ID']['input'];
  input: AudienceUpdateInput;
};


export type MutationUpdateAudienceCriteriaArgs = {
  id: Scalars['ID']['input'];
  input: AudienceCriteriaInput;
};


export type MutationUpdateBadgeArgs = {
  id: Scalars['ID']['input'];
  input: BadgeUpdateInput;
};


export type MutationUpdateBankArgs = {
  id: Scalars['ID']['input'];
  input: BankInput;
};


export type MutationUpdateBankDetailsArgs = {
  id: Scalars['ID']['input'];
  input: BankDetailsInput;
};


export type MutationUpdateBarcodeArgs = {
  input: BarcodeUpdateInput;
};


export type MutationUpdateBlogArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBlogInput;
};


export type MutationUpdateBoardArgs = {
  category?: InputMaybe<BoardCategoryEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  members?: InputMaybe<Array<Scalars['ID']['input']>>;
  projects?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateBoardCardArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assignedTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  attachments?: InputMaybe<Array<Scalars['ID']['input']>>;
  barcode?: InputMaybe<Scalars['ID']['input']>;
  boardList?: InputMaybe<Scalars['ID']['input']>;
  budget?: InputMaybe<Scalars['Decimal']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  labels?: InputMaybe<Array<Scalars['ID']['input']>>;
  pictures?: InputMaybe<Array<PictureInput>>;
  priority?: InputMaybe<BoardCardPriorityEnum>;
  procedure?: InputMaybe<Array<BoardCardProcedureInput>>;
  project?: InputMaybe<Scalars['ID']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tasks?: InputMaybe<Array<BoardCardTasksInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateBoardCardListArgs = {
  boardList: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  rank: Scalars['Int']['input'];
};


export type MutationUpdateBoardListArgs = {
  board?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  identifier?: InputMaybe<MaintenanceBoardListEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateBrandArgs = {
  id: Scalars['String']['input'];
  input: BrandUpdateInput;
};


export type MutationUpdateBrowserArgs = {
  id: Scalars['ID']['input'];
  input: BrowserInput;
};


export type MutationUpdateCatalogueCategoryArgs = {
  input: CatalogueCategoryUpdateInput;
};


export type MutationUpdateCauseArgs = {
  id: Scalars['ID']['input'];
  input: CauseUpdateInput;
};


export type MutationUpdateChallengeArgs = {
  id: Scalars['ID']['input'];
  input: ChallengeInput;
};


export type MutationUpdateCoinArgs = {
  id: Scalars['ID']['input'];
  input: CoinInput;
};


export type MutationUpdateCommentArgs = {
  id: Scalars['ID']['input'];
  input: CommentInput;
};


export type MutationUpdateCompanyArgs = {
  id: Scalars['ID']['input'];
  input: CompanyUpdateInput;
};


export type MutationUpdateCompanyContactArgs = {
  id: Scalars['ID']['input'];
  input: CompanyContactUpdateInput;
};


export type MutationUpdateContentTypeArgs = {
  id: Scalars['ID']['input'];
  input: ContentTypeInput;
};


export type MutationUpdateCorporateDashboardArgs = {
  input: CorporateUserDashboardUpdateInput;
};


export type MutationUpdateCorporateEmailTemplateArgs = {
  id: Scalars['ID']['input'];
  input: CorporateEmailTemplateInput;
};


export type MutationUpdateCorporateNotificationArgs = {
  id: Scalars['ID']['input'];
  input: CorporateNotificationInput;
};


export type MutationUpdateCorporateRatingArgs = {
  id: Scalars['ID']['input'];
  input: CorporateUpdateRatingInput;
};


export type MutationUpdateCorporateRatingAssignmentStatusArgs = {
  active: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateCorporateRatingDefinitionArgs = {
  id: Scalars['String']['input'];
  reviewType: Scalars['String']['input'];
};


export type MutationUpdateCorporateTemplateArgs = {
  id: Scalars['ID']['input'];
  input: CorporateTemplateInput;
};


export type MutationUpdateCorporateUserCardArgs = {
  id: Scalars['ID']['input'];
  validUntil: Scalars['DateTime']['input'];
};


export type MutationUpdateCorporateUserProfileArgs = {
  id: Scalars['ID']['input'];
  input: UserUpdateInput;
};


export type MutationUpdateCountryArgs = {
  id: Scalars['ID']['input'];
  input: CountryInput;
};


export type MutationUpdateCouponArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCouponInput;
};


export type MutationUpdateCouponSettingsArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCouponSettingsInput;
};


export type MutationUpdateCurrencyArgs = {
  id: Scalars['ID']['input'];
  input: CurrencyInput;
};


export type MutationUpdateCurrentUserArgs = {
  input: UserUpdateInput;
  source?: InputMaybe<UserEventsSourceEnum>;
};


export type MutationUpdateCurrentUserAppArgs = {
  app: App;
};


export type MutationUpdateCurrentUserEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationUpdateCurrentUserLoginsArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<IPhoneInput>;
  username?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCurrentUserPasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationUpdateCurrentUserPasswordForAppArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationUpdateDeliveryZoneArgs = {
  id: Scalars['String']['input'];
  input: OrderDeliveryZonesUpdateInput;
};


export type MutationUpdateDepartmentArgs = {
  id: Scalars['ID']['input'];
  input: DepartmentInput;
};


export type MutationUpdateDocumentArgs = {
  id: Scalars['ID']['input'];
  input: DocumentInput;
};


export type MutationUpdateEmailIntegrationArgs = {
  id: Scalars['ID']['input'];
  input: EmailIntegrationInput;
};


export type MutationUpdateEmailTemplateArgs = {
  id: Scalars['ID']['input'];
  input: EmailTemplateInput;
};


export type MutationUpdateErpIntegrationArgs = {
  input: ErpIntegrationUpdateInput;
};


export type MutationUpdateErpIntegrationEventStatusArgs = {
  event: ErpElementsEnum;
  id: Scalars['ID']['input'];
  status: Scalars['Boolean']['input'];
};


export type MutationUpdateEventArgs = {
  id: Scalars['String']['input'];
  input: EventUpdateInput;
};


export type MutationUpdateEventInviteArgs = {
  id: Scalars['String']['input'];
  input: EventInviteUpdateInput;
};


export type MutationUpdateEventTicketArgs = {
  id: Scalars['ID']['input'];
  input: EventTicketUpdateInput;
};


export type MutationUpdateFbCatalogSyncArgs = {
  input: FbCatalogSyncUpdateInput;
};


export type MutationUpdateFacebookPixelArgs = {
  input: FbPixelUpdateInput;
};


export type MutationUpdateFacebookPixelEventStatusArgs = {
  event: PixelRecommendedEventsEnum;
  id: Scalars['ID']['input'];
  status: Scalars['Boolean']['input'];
};


export type MutationUpdateFeaturedCorporateRankArgs = {
  id: Scalars['String']['input'];
  rank: Scalars['Float']['input'];
};


export type MutationUpdateFlowArgs = {
  id: Scalars['String']['input'];
  input: FlowInput;
};


export type MutationUpdateFontArgs = {
  id: Scalars['ID']['input'];
  input: FontInput;
};


export type MutationUpdateFormArgs = {
  input: UpdateFormInput;
};


export type MutationUpdateFormStatusArgs = {
  id: Scalars['String']['input'];
  status: FormStatus;
};


export type MutationUpdateFreebieArgs = {
  id: Scalars['ID']['input'];
  input: FreebieUpdateInput;
};


export type MutationUpdateFreebieTransactionArgs = {
  id: Scalars['ID']['input'];
  input: FreebieTransactionInput;
};


export type MutationUpdateGameArgs = {
  id: Scalars['ID']['input'];
  input: GameUpdateInput;
};


export type MutationUpdateGameIntegrationArgs = {
  id: Scalars['ID']['input'];
  input: GameIntegrationUpdateInput;
};


export type MutationUpdateGameOrderStatusArgs = {
  id: Scalars['ID']['input'];
  status: GameOrderStatusEnum;
};


export type MutationUpdateGameRewardsArgs = {
  input: UpdateRewardInput;
};


export type MutationUpdateGlobalCategoryArgs = {
  id: Scalars['ID']['input'];
  input: GlobalProviderCategoryInput;
};


export type MutationUpdateGoogleAnalyticsArgs = {
  input: GoogleAnalyticsUpdateInput;
};


export type MutationUpdateGoogleAnalyticsEventStatusArgs = {
  event: GaRecommendedEventsEnum;
  id: Scalars['ID']['input'];
  status: Scalars['Boolean']['input'];
};


export type MutationUpdateHelpdeskIntegrationArgs = {
  id: Scalars['ID']['input'];
  input: HelpdeskIntegrationInput;
};


export type MutationUpdateIntegrationIntegrationArgs = {
  id: Scalars['ID']['input'];
  input: IntegrationIntegrationInput;
};


export type MutationUpdateInternalProductArgs = {
  input: UpdateInternalProductInput;
};


export type MutationUpdateInternalProductAndProductArgs = {
  barcodes?: InputMaybe<Array<Scalars['ID']['input']>>;
  brand?: InputMaybe<Scalars['ID']['input']>;
  catalogueCategory?: InputMaybe<Array<Scalars['ID']['input']>>;
  category?: InputMaybe<Array<Scalars['ID']['input']>>;
  classification?: InputMaybe<Array<ProductClassEnum>>;
  condition?: InputMaybe<ProductConditionEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionList?: InputMaybe<Array<Scalars['String']['input']>>;
  discount?: InputMaybe<DiscountDtoInput>;
  ean?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  factoryPrice?: InputMaybe<Scalars['Decimal']['input']>;
  flags?: InputMaybe<ProductFlagEnum>;
  globalCategory?: InputMaybe<GlobalCategoryInput>;
  id: Scalars['ID']['input'];
  internalProductAttributes?: InputMaybe<InternalProductAttributeInput>;
  longdesc?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<Array<PictureInput>>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  specs?: InputMaybe<Array<ProductSpecsInput>>;
  status?: InputMaybe<ProductStatusEnum>;
  structure?: InputMaybe<ProductStructureEnum>;
  suppliers?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tax?: InputMaybe<Scalars['Decimal']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  wholesalerPrice?: InputMaybe<Scalars['Decimal']['input']>;
};


export type MutationUpdateInventoryCategoryArgs = {
  id: Scalars['String']['input'];
  input: InventoryCategoryInput;
};


export type MutationUpdateInventoryIntegrationArgs = {
  id: Scalars['ID']['input'];
  input: InventoryIntegrationInput;
};


export type MutationUpdateJobApplicationArgs = {
  id: Scalars['ID']['input'];
  input: JobApplicationUpdateInput;
};


export type MutationUpdateJobDefinitionArgs = {
  id: Scalars['ID']['input'];
  input: JobDefinitionUpdateInput;
};


export type MutationUpdateLabelArgs = {
  category?: InputMaybe<LabelTypeEnum>;
  color?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<TargetAciInput>;
};


export type MutationUpdateLandingPageArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLandingPagesInput;
};


export type MutationUpdateLandingPageStatusArgs = {
  id: Scalars['ID']['input'];
  status: VisibilityStatusEnum;
};


export type MutationUpdateLanguageArgs = {
  id: Scalars['ID']['input'];
  input: LanguageInput;
};


export type MutationUpdateLocationArgs = {
  id: Scalars['ID']['input'];
  input: LocationInput;
};


export type MutationUpdateLogisticArgs = {
  id: Scalars['ID']['input'];
  input: LogisticInput;
};


export type MutationUpdateLogisticsIntegrationArgs = {
  id: Scalars['ID']['input'];
  input: LogisticsIntegrationInput;
};


export type MutationUpdateLoyaltyProgramArgs = {
  id: Scalars['String']['input'];
  input: LoyaltyProgramInput;
};


export type MutationUpdateLoyaltySettingsArgs = {
  input: LoyaltySettingsUpdateInput;
};


export type MutationUpdateManufacturerArgs = {
  input: ManufacturerUpdateInput;
};


export type MutationUpdateMarketplaceOrderInstallmentsArgs = {
  input: Array<InstallmentUpdateInput>;
  orderId: Scalars['ID']['input'];
};


export type MutationUpdateMessageGroupArgs = {
  input: MessageGroupUpdateInput;
};


export type MutationUpdateModuleAssignmentArgs = {
  id: Scalars['String']['input'];
  input: ModulesAssignmentInput;
};


export type MutationUpdateModuleDefinitionArgs = {
  id: Scalars['String']['input'];
  input: ModulesDefinitionInput;
};


export type MutationUpdateNoteArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<Scalars['ID']['input']>>;
  picture?: InputMaybe<PictureInput>;
  target?: InputMaybe<TargetAciInput>;
  tasks?: InputMaybe<Array<TaskInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateNotificationIntegrationArgs = {
  id: Scalars['ID']['input'];
  input: NotificationIntegrationInput;
};


export type MutationUpdateOperatingSystemArgs = {
  id: Scalars['ID']['input'];
  input: OperatingSystemInput;
};


export type MutationUpdateOrderSettingsArgs = {
  id: Scalars['String']['input'];
  input: OrderSettingsUpdateInput;
};


export type MutationUpdateOutboundArgs = {
  id: Scalars['String']['input'];
  input: OutboundInput;
};


export type MutationUpdatePosCategoryArgs = {
  id: Scalars['String']['input'];
  input: PosCategoryInput;
};


export type MutationUpdatePosServicesArgs = {
  id: Scalars['String']['input'];
  input: PosServicesInput;
};


export type MutationUpdatePartnerReferralArgs = {
  id: Scalars['String']['input'];
  input: PartnerReferralInput;
};


export type MutationUpdatePartnershipNetworkArgs = {
  id: Scalars['String']['input'];
  input: PartnershipNetworkInput;
};


export type MutationUpdatePaymentArgs = {
  id: Scalars['ID']['input'];
  input: PaymentInput;
};


export type MutationUpdatePermissionArgs = {
  id: Scalars['ID']['input'];
  input: PermissionInput;
};


export type MutationUpdatePermissionDefinitionArgs = {
  id: Scalars['ID']['input'];
  input: PermissionDefinitionInput;
};


export type MutationUpdatePluginArgs = {
  id: Scalars['ID']['input'];
  input: PluginInput;
};


export type MutationUpdatePointOfSaleArgs = {
  id: Scalars['ID']['input'];
  input: PointOfSaleInput;
};


export type MutationUpdatePreLevelGoalStatusArgs = {
  frequencyGoalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  turnoverGoalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdatePredefinedArgs = {
  id: Scalars['ID']['input'];
  input: PredefinedUpdateInput;
};


export type MutationUpdatePriceArgs = {
  id: Scalars['ID']['input'];
  input: PriceInput;
};


export type MutationUpdateProductArgs = {
  id: Scalars['String']['input'];
  input: ProductUpdateInput;
};


export type MutationUpdateProductAttributeArgs = {
  input: ProductAttributeUpdateInput;
};


export type MutationUpdateProductCreditArgs = {
  productToAdd: CartProductUpdateCreditInput;
  productToRemove: CartProductInput;
};


export type MutationUpdateProductRatingArgs = {
  id: Scalars['String']['input'];
  input: UpdateProductRatingInput;
};


export type MutationUpdateProductRatingDefinitionArgs = {
  id: Scalars['String']['input'];
  input: UpdateProductRatingDefinitionInput;
};


export type MutationUpdateProductStatusArgs = {
  input: MarketPlaceOrderStatusByPosInput;
  source?: InputMaybe<UserEventsSourceEnum>;
  subject: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
};


export type MutationUpdateProgramArgs = {
  id: Scalars['String']['input'];
  input: ProgramUpdateInput;
};


export type MutationUpdateProjectArgs = {
  input: ProjectUpdateInput;
};


export type MutationUpdatePromotionArgs = {
  id: Scalars['ID']['input'];
  input: PromotionUpdateInput;
};


export type MutationUpdatePurchaseDeliveryNoteArgs = {
  id: Scalars['ID']['input'];
  input: PurchaseDeliveryNoteInput;
};


export type MutationUpdatePurchaseIntegrationArgs = {
  id: Scalars['ID']['input'];
  input: PurchaseIntegrationInput;
};


export type MutationUpdatePurchaseInvoiceArgs = {
  id: Scalars['ID']['input'];
  input: PurchaseInvoiceInput;
};


export type MutationUpdatePurchaseOrderArgs = {
  id: Scalars['ID']['input'];
  input: PurchaseOrderInput;
};


export type MutationUpdateQuestArgs = {
  id: Scalars['ID']['input'];
  input: QuestUpdateInput;
};


export type MutationUpdateQuestActionDefinitionArgs = {
  id: Scalars['ID']['input'];
  input: QuestActionDefinitionInput;
};


export type MutationUpdateQuestActivityArgs = {
  id: Scalars['ID']['input'];
  input: QuestActivityInput;
};


export type MutationUpdateQuestTypeArgs = {
  id: Scalars['ID']['input'];
  input: QuestTypeInput;
};


export type MutationUpdateQuestionArgs = {
  id: Scalars['ID']['input'];
  input: QuestionInput;
};


export type MutationUpdateQuotationArgs = {
  input: QuotationUpdateInput;
};


export type MutationUpdateRentalDetailsArgs = {
  id: Scalars['ID']['input'];
  input: RentalUpdateInput;
};


export type MutationUpdateRentalStatusArgs = {
  id: Scalars['ID']['input'];
  status: RentalStatusEnum;
};


export type MutationUpdateReputationLevelGoalStatusArgs = {
  frequencyGoalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  turnoverGoalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateReputationLevelPointsArgs = {
  id: Scalars['ID']['input'];
  points: Scalars['Float']['input'];
};


export type MutationUpdateRequestStatusArgs = {
  id: Scalars['ID']['input'];
  status: RequestStatusEnum;
};


export type MutationUpdateSeoArgs = {
  id: Scalars['String']['input'];
  input: UpdateSeoInput;
};


export type MutationUpdateSaleDeliveryNoteArgs = {
  id: Scalars['ID']['input'];
  input: SaleDeliveryNoteInput;
};


export type MutationUpdateSaleInvoiceArgs = {
  id: Scalars['ID']['input'];
  input: SaleInvoiceInput;
};


export type MutationUpdateSaleIssueNoteArgs = {
  id: Scalars['ID']['input'];
  input: SaleIssueNoteInput;
};


export type MutationUpdateSaleOrderArgs = {
  id: Scalars['ID']['input'];
  input: SaleOrderInput;
};


export type MutationUpdateSalesIntegrationArgs = {
  id: Scalars['ID']['input'];
  input: SalesIntegrationInput;
};


export type MutationUpdateShortcutArgs = {
  id: Scalars['String']['input'];
  input: ShortcutUpdateInput;
};


export type MutationUpdateSimpleProductArgs = {
  input: UpdateSimpleProductInput;
};


export type MutationUpdateSlidesArgs = {
  id: Scalars['String']['input'];
  input: UpdateSlidesInput;
};


export type MutationUpdateSmsIntegrationArgs = {
  id: Scalars['ID']['input'];
  input: SmsIntegrationInput;
};


export type MutationUpdateSocialArgs = {
  id: Scalars['ID']['input'];
  input: SocialInput;
};


export type MutationUpdateStateArgs = {
  id: Scalars['ID']['input'];
  input: StateInput;
};


export type MutationUpdateStaticTranslationArgs = {
  input: UpdateStaticTranslationInput;
};


export type MutationUpdateStockArgs = {
  id: Scalars['ID']['input'];
  minimumStockQuantity?: InputMaybe<Scalars['Int']['input']>;
  outOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  pixel?: InputMaybe<StockPixelInput>;
  stockCapacity?: InputMaybe<Scalars['Int']['input']>;
  warehouse?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateSupplierArgs = {
  id: Scalars['String']['input'];
  input: UpdateSupplierInput;
};


export type MutationUpdateTargetPluginArgs = {
  input: TargetPluginUpdateInput;
};


export type MutationUpdateTargetReputationArgs = {
  input: UpdateReputationInput;
};


export type MutationUpdateTaskArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  priority?: InputMaybe<TaskPriorityEnum>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  taskSection?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateTaskSectionArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  priority?: InputMaybe<TaskPriorityEnum>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateTaxArgs = {
  id: Scalars['ID']['input'];
  input: TaxInput;
};


export type MutationUpdateTechDeviceArgs = {
  id: Scalars['ID']['input'];
  input: TechDeviceInput;
};


export type MutationUpdateTechDeviceBrandArgs = {
  id: Scalars['ID']['input'];
  input: TechDeviceBrandInput;
};


export type MutationUpdateTechDeviceTypeArgs = {
  id: Scalars['ID']['input'];
  input: TechDeviceTypeInput;
};


export type MutationUpdateTicketArgs = {
  input: TicketUpdateInput;
};


export type MutationUpdateTimeTrackArgs = {
  id: Scalars['ID']['input'];
  input: TimeTrackInput;
};


export type MutationUpdateUserArgs = {
  id: Scalars['ID']['input'];
  input: UserUpdateInput;
  source?: InputMaybe<UserEventsSourceEnum>;
};


export type MutationUpdateUserAppArgs = {
  app: App;
  id: Scalars['String']['input'];
};


export type MutationUpdateUserPasswordForAppArgs = {
  id: Scalars['ID']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationUpdateVapidKeyArgs = {
  input: VapidKeyInput;
};


export type MutationUpdateVersionArgs = {
  input: UpdateVersionInput;
};


export type MutationUpdateVisualsArgs = {
  id: Scalars['String']['input'];
  input: UpdateVisualsInput;
};


export type MutationUpdateWalletTopupArgs = {
  id: Scalars['ID']['input'];
  input: WalletTopupInput;
};


export type MutationUpdateWalletTopupSettingsArgs = {
  id: Scalars['ID']['input'];
  input: WalletTopupSettingsUpdateInput;
};


export type MutationUpdateWarehouseArgs = {
  id: Scalars['ID']['input'];
  input: WarehouseUpdateInput;
};


export type MutationUpdateWebsiteIntegrationArgs = {
  id: Scalars['ID']['input'];
  input: WebsiteIntegrationInput;
};


export type MutationUpdateWholesalerArgs = {
  input: WholesalerUpdateInput;
};


export type MutationUpdateWidgetIntegrationArgs = {
  id: Scalars['ID']['input'];
  input: WidgetIntegrationInput;
};


export type MutationUpdateWidgetVisualsArgs = {
  id: Scalars['ID']['input'];
  input: WidgetVisualsInput;
};


export type MutationUpsertQuestAnalyticsArgs = {
  input: QuestAnalyticsUpdateInput;
};


export type MutationValidateEmailForTargetArgs = {
  token: Scalars['String']['input'];
};


export type MutationValidateLinkOrCodeForTargetArgs = {
  code?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<IPhoneInput>;
  source?: InputMaybe<UserEventsSourceEnum>;
  target: TargetAciInput;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationValidateMailArgs = {
  token: Scalars['String']['input'];
};


export type MutationValidatePhoneNumberArgs = {
  smsNumber: Scalars['Int']['input'];
};

export type NestedPicturesType = {
  __typename?: 'NestedPicturesType';
  cover?: Maybe<PictureType>;
  profile?: Maybe<PictureType>;
};

export type NewPartnershipNetworkInput = {
  app: App;
  partner: TargetCreateInput;
  partnership: Array<PartnershipTypeEnum>;
  subject: Scalars['String']['input'];
  target: TargetAciInput;
  variables: EmailTempVariablesInput;
};

export type NewVersionInput = {
  platform?: InputMaybe<PlatformEnum>;
  requireUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  target: TargetAciInput;
  version: Scalars['String']['input'];
  versionContent?: InputMaybe<Array<VersionContentInput>>;
};

export type NewsletterType = {
  __typename?: 'NewsletterType';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type NotesTaskType = {
  __typename?: 'NotesTaskType';
  done?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
};

export type NotesType = {
  __typename?: 'NotesType';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  labels: Array<LabelType>;
  picture?: Maybe<PictureType>;
  target: TargetType;
  tasks?: Maybe<Array<NotesTaskType>>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type NotificationFullType = {
  __typename?: 'NotificationFullType';
  action?: Maybe<ActionType>;
  createdAt: Scalars['DateTime']['output'];
  event?: Maybe<EventTypeEnum>;
  executed?: Maybe<Scalars['Boolean']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  seen?: Maybe<Scalars['Boolean']['output']>;
  subjects?: Maybe<SubjectsFullType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type NotificationIntegrationFirebaseInput = {
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientX509CertUrl?: InputMaybe<Scalars['String']['input']>;
  privateKey?: InputMaybe<Scalars['String']['input']>;
  privateKeyId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationIntegrationFirebaseType = {
  __typename?: 'NotificationIntegrationFirebaseType';
  clientEmail?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  clientX509CertUrl?: Maybe<Scalars['String']['output']>;
  privateKey?: Maybe<Scalars['String']['output']>;
  privateKeyId?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
};

export type NotificationIntegrationInput = {
  mobile?: InputMaybe<NotificationIntegrationPlatformInput>;
  target?: InputMaybe<TargetAciInput>;
  web?: InputMaybe<NotificationIntegrationPlatformInput>;
};

export type NotificationIntegrationPlatformApiInput = {
  headers?: InputMaybe<Array<KeyValueInput>>;
  link?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<ApiMethods>;
  params?: InputMaybe<Array<KeyValueInput>>;
  paramsConfig?: InputMaybe<NotificationIntegrationPlatformApiParamsInput>;
};

export type NotificationIntegrationPlatformApiType = {
  __typename?: 'NotificationIntegrationPlatformAPIType';
  headers?: Maybe<Array<KeyValueType>>;
  link?: Maybe<Scalars['String']['output']>;
  method?: Maybe<ApiMethods>;
  params?: Maybe<Array<KeyValueType>>;
  paramsConfig?: Maybe<NotificationIntegrationPlatformApiParamsType>;
};

export type NotificationIntegrationPlatformApiParamsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationIntegrationPlatformApiParamsType = {
  __typename?: 'NotificationIntegrationPlatformApiParamsType';
  description?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type NotificationIntegrationPlatformInput = {
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  provider?: InputMaybe<ProvidersEnum>;
  settings?: InputMaybe<NotificationIntegrationSettingsInput>;
};

export type NotificationIntegrationSettingsInput = {
  api?: InputMaybe<NotificationIntegrationPlatformApiInput>;
  firebase?: InputMaybe<NotificationIntegrationFirebaseInput>;
};

export type NotificationIntegrationSettingsType = {
  __typename?: 'NotificationIntegrationSettingsType';
  api?: Maybe<NotificationIntegrationPlatformApiType>;
  firebase?: Maybe<NotificationIntegrationFirebaseType>;
};

export type NotificationIntegrationType = {
  __typename?: 'NotificationIntegrationType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mobile?: Maybe<NotificationIntegrationTypeType>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  web?: Maybe<NotificationIntegrationTypeType>;
};

export type NotificationIntegrationTypeType = {
  __typename?: 'NotificationIntegrationTypeType';
  enable?: Maybe<Scalars['Boolean']['output']>;
  provider?: Maybe<ProvidersEnum>;
  settings?: Maybe<NotificationIntegrationSettingsType>;
};

export type NotificationIntergrationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  tokens?: InputMaybe<Array<Scalars['String']['input']>>;
  topic?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationOnsiteConverterType = {
  __typename?: 'NotificationOnsiteConverterType';
  qualitativeAmountPushed?: Maybe<Scalars['Decimal']['output']>;
  quantitativeAmountPushed?: Maybe<Scalars['Decimal']['output']>;
};

export type NotificationResponse = {
  __typename?: 'NotificationResponse';
  success: Scalars['Boolean']['output'];
};

export type NotificationType = {
  __typename?: 'NotificationType';
  action?: Maybe<ActionType>;
  createdAt: Scalars['DateTime']['output'];
  event?: Maybe<EventTypeEnum>;
  executed?: Maybe<Scalars['Boolean']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  seen?: Maybe<Scalars['Boolean']['output']>;
  subjects?: Maybe<SubjectsType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type NumberInput = {
  format?: InputMaybe<CodeFormatEnum>;
  length?: InputMaybe<Scalars['Int']['input']>;
};

export type NumberOfInternalProductsType = {
  __typename?: 'NumberOfInternalProductsType';
  byCatalogueCategory: Array<InternalProductsByCatalogueCategoryCountType>;
  byInventoryCategory: Array<InternalProductsByInventoryCategoryCountType>;
  byManufacturers: Array<InternalProductsByManufacturerCountType>;
  byPos: Array<InternalProductsByPosCountType>;
  byWholesalers: Array<InternalProductsByWholesalerCountType>;
  total: Scalars['Int']['output'];
};

export type NumberOfInventoryCategoriesType = {
  __typename?: 'NumberOfInventoryCategoriesType';
  layer: Scalars['Int']['output'];
  numberOfInventoryCategories: Scalars['Int']['output'];
};

export type NumberOfPeopleCountType = {
  __typename?: 'NumberOfPeopleCountType';
  numberOfBookings: Scalars['Int']['output'];
  numberOfPeopleRange: Array<Scalars['Int']['output']>;
};

export type NumberOfPointOfSalesType = {
  __typename?: 'NumberOfPointOfSalesType';
  byPosCategory: Array<PosByPosCategoryCountType>;
  total: Scalars['Int']['output'];
};

export type NumberOfProductsInventoryDashboardType = {
  __typename?: 'NumberOfProductsInventoryDashboardType';
  byFactoryPriceRange: Array<PriceRangeCountType>;
  byInventoryCategory: Array<InventoryCategoryCountType>;
  byPriceRange: Array<PriceRangeCountType>;
  byWholesalerPriceRange: Array<PriceRangeCountType>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type NumberOfProductsType = {
  __typename?: 'NumberOfProductsType';
  byCatalogueCategory: Array<ProductsByCatalogueCategoryCountType>;
  byInventoryCategory: Array<InventoryCategoryCountType>;
  total: Scalars['Int']['output'];
};

export type NumberRangeInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type NumberType = {
  __typename?: 'NumberType';
  format?: Maybe<CodeFormatEnum>;
  length?: Maybe<Scalars['Int']['output']>;
};

export type OsLogoInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  png?: InputMaybe<OsLogoPngInput>;
  svg?: InputMaybe<PictureInput>;
};

export type OsLogoPngInput = {
  default?: InputMaybe<PictureInput>;
  size16?: InputMaybe<PictureInput>;
  size24?: InputMaybe<PictureInput>;
  size32?: InputMaybe<PictureInput>;
  size48?: InputMaybe<PictureInput>;
  size64?: InputMaybe<PictureInput>;
  size128?: InputMaybe<PictureInput>;
};

export type OsLogoPngType = {
  __typename?: 'OSLogoPngType';
  default?: Maybe<PictureType>;
  size16?: Maybe<PictureType>;
  size24?: Maybe<PictureType>;
  size32?: Maybe<PictureType>;
  size48?: Maybe<PictureType>;
  size64?: Maybe<PictureType>;
  size128?: Maybe<PictureType>;
};

export type OsLogoType = {
  __typename?: 'OSLogoType';
  icon?: Maybe<Scalars['String']['output']>;
  png?: Maybe<OsLogoPngType>;
  svg?: Maybe<PictureType>;
};

export enum OddStatusEnum {
  LOST = 'LOST',
  WON = 'WON'
}

export type OddsBookmakersBetsType = {
  __typename?: 'OddsBookmakersBetsType';
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<OddsBookmakersBetsValuesType>>;
};

export type OddsBookmakersBetsValuesType = {
  __typename?: 'OddsBookmakersBetsValuesType';
  odd?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type OddsBookmakersType = {
  __typename?: 'OddsBookmakersType';
  bets?: Maybe<Array<OddsBookmakersBetsType>>;
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type OddsFixtureType = {
  __typename?: 'OddsFixtureType';
  date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type OddsLeagueType = {
  __typename?: 'OddsLeagueType';
  country?: Maybe<Scalars['String']['output']>;
  flag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
};

export type OddsType = {
  __typename?: 'OddsType';
  bookmakers?: Maybe<Array<OddsBookmakersType>>;
  createdAt: Scalars['DateTime']['output'];
  fixture?: Maybe<OddsFixtureType>;
  id: Scalars['ID']['output'];
  league?: Maybe<OddsLeagueType>;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type OnlineUsersByDeviceTypeType = {
  __typename?: 'OnlineUsersByDeviceTypeType';
  deviceType: DeviceTypeEnum;
  onlineUsers: Scalars['Int']['output'];
};

export enum OnsiteConverterTypeEnum {
  MOBILE = 'MOBILE',
  PHYSICAL = 'PHYSICAL',
  WEB = 'WEB'
}

export type OoredooDataType = {
  __typename?: 'OoredooDataType';
  id?: Maybe<Scalars['String']['output']>;
};

export type OpeningHoursDayInput = {
  day: DayEnum;
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type OpeningHoursDayType = {
  __typename?: 'OpeningHoursDayType';
  day?: Maybe<DayEnum>;
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type OpeningHoursInput = {
  hours: Array<OpeningHoursDayInput>;
  status: OpeningStatus;
};

export type OpeningHoursType = {
  __typename?: 'OpeningHoursType';
  hours?: Maybe<Array<OpeningHoursDayType>>;
  status?: Maybe<OpeningStatus>;
};

export enum OpeningStatus {
  ALWAYS_OPEN = 'ALWAYS_OPEN',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  PERMANENTLY_CLOSED = 'PERMANENTLY_CLOSED',
  SELECTED_HOURS = 'SELECTED_HOURS'
}

export type OperatingSystemDataType = {
  __typename?: 'OperatingSystemDataType';
  brand?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type OperatingSystemInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<OsLogoInput>;
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OperatingSystemPaginatedType = {
  __typename?: 'OperatingSystemPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<OperatingSystemType>;
};

export type OperatingSystemType = {
  __typename?: 'OperatingSystemType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  logo?: Maybe<OsLogoType>;
  name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum OperatorEnum {
  AT_LEAST_ONE = 'AT_LEAST_ONE',
  BETWEEN = 'BETWEEN',
  DIFFERENT = 'DIFFERENT',
  EQUAL = 'EQUAL',
  GREATER = 'GREATER',
  INCLUDED_IN = 'INCLUDED_IN',
  LESSER = 'LESSER',
  NOT_BETWEEN = 'NOT_BETWEEN',
  NOT_EQUAL = 'NOT_EQUAL',
  NOT_INCLUDED_IN = 'NOT_INCLUDED_IN',
  NOT_SPECIFIED = 'NOT_SPECIFIED'
}

export type OrderDeliveryZonesUpdateInput = {
  category?: InputMaybe<ZoneTypesCategoryEnum>;
  color?: InputMaybe<Scalars['String']['input']>;
  extraFees?: InputMaybe<Scalars['Decimal']['input']>;
  minPrice?: InputMaybe<Scalars['Decimal']['input']>;
  paths?: InputMaybe<Array<DeliveryZonePathInput>>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<ZoneTypesEnum>;
};

export enum OrderEmailActionEnum {
  ORDER_CREATED = 'ORDER_CREATED',
  PRODUCT_CANCELED = 'PRODUCT_CANCELED',
  PRODUCT_CONFIRMED = 'PRODUCT_CONFIRMED',
  PRODUCT_DELIVERED = 'PRODUCT_DELIVERED',
  PRODUCT_PICKUP_READY = 'PRODUCT_PICKUP_READY'
}

export type OrderProductPriceInput = {
  gross?: InputMaybe<Scalars['Decimal']['input']>;
  net?: InputMaybe<Scalars['Decimal']['input']>;
  unitGross?: InputMaybe<Scalars['Decimal']['input']>;
  unitNet?: InputMaybe<Scalars['Decimal']['input']>;
};

export type OrderSettingsEmailsInput = {
  definition?: InputMaybe<OrderEmailActionEnum>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderSettingsEmailsType = {
  __typename?: 'OrderSettingsEmailsType';
  definition?: Maybe<OrderEmailActionEnum>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type OrderSettingsExtraFeesInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Decimal']['input']>;
};

export type OrderSettingsExtraFeesType = {
  __typename?: 'OrderSettingsExtraFeesType';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Decimal']['output']>;
};

export type OrderSettingsFullType = {
  __typename?: 'OrderSettingsFullType';
  createdAt: Scalars['DateTime']['output'];
  delivery?: Maybe<Scalars['Boolean']['output']>;
  deliveryCountries?: Maybe<Array<CountryType>>;
  deliveryStates?: Maybe<Array<StateType>>;
  deliveryTime?: Maybe<MilitaryTimeFromToType>;
  emails?: Maybe<Array<OrderSettingsEmailsType>>;
  extraFees?: Maybe<Array<OrderSettingsExtraFeesType>>;
  facebookDelivery?: Maybe<Scalars['Boolean']['output']>;
  facebookPickup?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  import?: Maybe<OrderSettingsImportType>;
  mobileDelivery?: Maybe<Scalars['Boolean']['output']>;
  mobilePickup?: Maybe<Scalars['Boolean']['output']>;
  nonDeliveryDays?: Maybe<Array<MonthDaysType>>;
  nonPickupDays?: Maybe<Array<MonthDaysType>>;
  pickup?: Maybe<Scalars['Boolean']['output']>;
  pickupTime?: Maybe<MilitaryTimeFromToType>;
  portalDelivery?: Maybe<Scalars['Boolean']['output']>;
  portalPickup?: Maybe<Scalars['Boolean']['output']>;
  showMenuInPortal?: Maybe<Scalars['Boolean']['output']>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderSettingsImportInput = {
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type OrderSettingsImportType = {
  __typename?: 'OrderSettingsImportType';
  enable?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type OrderSettingsInput = {
  delivery?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryCountries?: InputMaybe<Array<Scalars['ID']['input']>>;
  deliveryStates?: InputMaybe<Array<Scalars['ID']['input']>>;
  deliveryTime?: InputMaybe<MilitaryTimeFromToInput>;
  emails?: InputMaybe<Array<OrderSettingsEmailsInput>>;
  extraFees?: InputMaybe<Array<OrderSettingsExtraFeesInput>>;
  facebookDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  facebookPickup?: InputMaybe<Scalars['Boolean']['input']>;
  import?: InputMaybe<OrderSettingsImportInput>;
  mobileDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  mobilePickup?: InputMaybe<Scalars['Boolean']['input']>;
  nonDeliveryDays?: InputMaybe<Array<MonthDaysInput>>;
  nonPickupDays?: InputMaybe<Array<MonthDaysInput>>;
  pickup?: InputMaybe<Scalars['Boolean']['input']>;
  pickupTime?: InputMaybe<MilitaryTimeFromToInput>;
  portalDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  portalPickup?: InputMaybe<Scalars['Boolean']['input']>;
  showMenuInPortal?: InputMaybe<Scalars['Boolean']['input']>;
  target: TargetAciInput;
};

export type OrderSettingsType = {
  __typename?: 'OrderSettingsType';
  createdAt: Scalars['DateTime']['output'];
  delivery?: Maybe<Scalars['Boolean']['output']>;
  deliveryCountries?: Maybe<Array<CountryType>>;
  deliveryStates?: Maybe<Array<StateType>>;
  deliveryTime?: Maybe<MilitaryTimeFromToType>;
  emails?: Maybe<Array<OrderSettingsEmailsType>>;
  extraFees?: Maybe<Array<OrderSettingsExtraFeesType>>;
  facebookDelivery?: Maybe<Scalars['Boolean']['output']>;
  facebookPickup?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  import?: Maybe<OrderSettingsImportType>;
  mobileDelivery?: Maybe<Scalars['Boolean']['output']>;
  mobilePickup?: Maybe<Scalars['Boolean']['output']>;
  nonDeliveryDays?: Maybe<Array<MonthDaysType>>;
  nonPickupDays?: Maybe<Array<MonthDaysType>>;
  pickup?: Maybe<Scalars['Boolean']['output']>;
  pickupTime?: Maybe<MilitaryTimeFromToType>;
  portalDelivery?: Maybe<Scalars['Boolean']['output']>;
  portalPickup?: Maybe<Scalars['Boolean']['output']>;
  showMenuInPortal?: Maybe<Scalars['Boolean']['output']>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderSettingsUpdateInput = {
  delivery?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryCountries?: InputMaybe<Array<Scalars['ID']['input']>>;
  deliveryStates?: InputMaybe<Array<Scalars['ID']['input']>>;
  deliveryTime?: InputMaybe<MilitaryTimeFromToInput>;
  emails?: InputMaybe<Array<OrderSettingsEmailsInput>>;
  extraFees?: InputMaybe<Array<OrderSettingsExtraFeesInput>>;
  facebookDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  facebookPickup?: InputMaybe<Scalars['Boolean']['input']>;
  import?: InputMaybe<OrderSettingsImportInput>;
  mobileDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  mobilePickup?: InputMaybe<Scalars['Boolean']['input']>;
  nonDeliveryDays?: InputMaybe<Array<MonthDaysInput>>;
  nonPickupDays?: InputMaybe<Array<MonthDaysInput>>;
  pickup?: InputMaybe<Scalars['Boolean']['input']>;
  pickupTime?: InputMaybe<MilitaryTimeFromToInput>;
  portalDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  portalPickup?: InputMaybe<Scalars['Boolean']['input']>;
  showMenuInPortal?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderShoppingCartAttributeType = {
  __typename?: 'OrderShoppingCartAttributeType';
  externalId: Scalars['String']['output'];
  isMultipleChoice: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
};

export type OrderShoppingCartAttributesValuesType = {
  __typename?: 'OrderShoppingCartAttributesValuesType';
  attribute: OrderShoppingCartAttributeType;
  externalId: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type OrderShoppingCartProductType = {
  __typename?: 'OrderShoppingCartProductType';
  barcode: BarcodeWithPublicPriceType;
  deliveryMan?: Maybe<UserType>;
  name?: Maybe<Scalars['String']['output']>;
  orderProductStatus: OrderStatus;
  pickupTime?: Maybe<Scalars['DateTime']['output']>;
  price: ProductPriceType;
  productAttributesValues?: Maybe<Array<AttributeValueType>>;
  quantity: Scalars['Int']['output'];
  target?: Maybe<TargetType>;
  taxValue: TaxValueType;
};

export enum OrderStatus {
  ASSIGNED = 'ASSIGNED',
  CANCELED = 'CANCELED',
  CONFIRMED = 'CONFIRMED',
  DELIVERED = 'DELIVERED',
  OPEN = 'OPEN',
  READY_FOR_PICKUP = 'READY_FOR_PICKUP'
}

export enum OrderTypeEnum {
  DELIVERY = 'DELIVERY',
  IN_HOUSE = 'IN_HOUSE',
  ORDER_AHEAD = 'ORDER_AHEAD',
  PICKUP = 'PICKUP'
}

export type OriginType = {
  __typename?: 'OriginType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type OutboundContentEmailInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  editor?: InputMaybe<OutboundEditorEnum>;
  preview?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type OutboundContentEmailType = {
  __typename?: 'OutboundContentEmailType';
  content?: Maybe<Scalars['String']['output']>;
  editor?: Maybe<OutboundEditorEnum>;
  preview?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type OutboundContentInput = {
  email?: InputMaybe<OutboundContentEmailInput>;
  push?: InputMaybe<OutboundContentPushInput>;
  sms?: InputMaybe<OutboundContentSmsInput>;
  widget?: InputMaybe<OutboundContentWidgetInput>;
};

export type OutboundContentPushInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type OutboundContentPushType = {
  __typename?: 'OutboundContentPushType';
  description?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  title?: Maybe<Scalars['String']['output']>;
};

export type OutboundContentSmsInput = {
  content?: InputMaybe<Scalars['String']['input']>;
};

export type OutboundContentSmsType = {
  __typename?: 'OutboundContentSmsType';
  content?: Maybe<Scalars['String']['output']>;
};

export type OutboundContentType = {
  __typename?: 'OutboundContentType';
  email?: Maybe<OutboundContentEmailType>;
  push?: Maybe<OutboundContentPushType>;
  sms?: Maybe<OutboundContentSmsType>;
  widget?: Maybe<OutboundContentWidgetType>;
};

export type OutboundContentWidgetCallToActionActionInput = {
  leaderboard?: InputMaybe<LeaderboardCycleEnum>;
  paramId?: InputMaybe<Scalars['String']['input']>;
  widgetAction?: InputMaybe<OutboundWidgetActionsEnum>;
};

export type OutboundContentWidgetCallToActionActionType = {
  __typename?: 'OutboundContentWidgetCallToActionActionType';
  leaderboard?: Maybe<LeaderboardCycleEnum>;
  paramId?: Maybe<Scalars['String']['output']>;
  widgetAction?: Maybe<OutboundWidgetActionsEnum>;
};

export type OutboundContentWidgetCallToActionInput = {
  action?: InputMaybe<OutboundContentWidgetCallToActionActionInput>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type OutboundContentWidgetCallToActionType = {
  __typename?: 'OutboundContentWidgetCallToActionType';
  action?: Maybe<OutboundContentWidgetCallToActionActionType>;
  label?: Maybe<Scalars['String']['output']>;
};

export type OutboundContentWidgetContentInput = {
  description: Scalars['String']['input'];
  label: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type OutboundContentWidgetInput = {
  callToAction?: InputMaybe<OutboundContentWidgetCallToActionInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Array<OutboundContentWidgetTranslationInput>>;
};

export type OutboundContentWidgetTranslationContentType = {
  __typename?: 'OutboundContentWidgetTranslationContentType';
  description: Scalars['String']['output'];
  label: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type OutboundContentWidgetTranslationInput = {
  content: OutboundContentWidgetContentInput;
  language: Scalars['ID']['input'];
};

export type OutboundContentWidgetTranslationType = {
  __typename?: 'OutboundContentWidgetTranslationType';
  content: OutboundContentWidgetTranslationContentType;
  language: LanguageType;
};

export type OutboundContentWidgetType = {
  __typename?: 'OutboundContentWidgetType';
  callToAction?: Maybe<OutboundContentWidgetCallToActionType>;
  description?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  title?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Array<OutboundContentWidgetTranslationType>>;
};

export enum OutboundEditorEnum {
  HTML = 'HTML',
  TEXT = 'TEXT'
}

export enum OutboundEnum {
  DRAFT = 'DRAFT',
  FINISHED = 'FINISHED',
  LIVE = 'LIVE'
}

export type OutboundInput = {
  audience?: InputMaybe<Scalars['ID']['input']>;
  channel?: InputMaybe<ChannelEnum>;
  clicked?: InputMaybe<Scalars['Float']['input']>;
  content?: InputMaybe<OutboundContentInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  executedAt?: InputMaybe<Scalars['DateTime']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  sent?: InputMaybe<Scalars['Float']['input']>;
  smart?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OutboundEnum>;
  target?: InputMaybe<TargetAciInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<TriggerEnum>;
};

export type OutboundPaginateType = {
  __typename?: 'OutboundPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<OutboundType>;
};

export type OutboundType = {
  __typename?: 'OutboundType';
  audience?: Maybe<AudienceType>;
  channel?: Maybe<ChannelEnum>;
  clicked?: Maybe<Scalars['Float']['output']>;
  content?: Maybe<OutboundContentType>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  picture?: Maybe<PictureType>;
  sent?: Maybe<Scalars['Float']['output']>;
  smart?: Maybe<Scalars['String']['output']>;
  status?: Maybe<OutboundEnum>;
  target?: Maybe<TargetType>;
  title: Scalars['String']['output'];
  tracking?: Maybe<Scalars['String']['output']>;
  trigger?: Maybe<TriggerEnum>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum OutboundWidgetActionsEnum {
  BADGES = 'BADGES',
  CHALLENGES = 'CHALLENGES',
  HOME = 'HOME',
  LEADERBOARD = 'LEADERBOARD',
  LEVELS = 'LEVELS',
  NOTIFICATION = 'NOTIFICATION',
  PROFILE = 'PROFILE',
  QUESTS = 'QUESTS',
  REDEEM = 'REDEEM',
  URL = 'URL',
  WIN = 'WIN'
}

export type PosByPosCategoryCountType = {
  __typename?: 'POSByPOSCategoryCountType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mapPicture?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfPos: Scalars['Int']['output'];
  picture?: Maybe<PictureType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PosCategoryInput = {
  mapPicture: Scalars['String']['input'];
  name: Scalars['String']['input'];
  picture?: InputMaybe<PictureInput>;
};

export type PosCategoryPaginateType = {
  __typename?: 'POSCategoryPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PosCategoryType>;
};

export type PosCategoryType = {
  __typename?: 'POSCategoryType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mapPicture?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PosContactRequestType = {
  __typename?: 'POSContactRequestType';
  companyName?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  pos?: Maybe<PointOfSaleType>;
  subject: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PosLoyaltyInput = {
  from: Scalars['DateTime']['input'];
  loyaltyProgram?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};

export type PosLoyaltyType = {
  __typename?: 'POSLoyaltyType';
  from: Scalars['DateTime']['output'];
  loyaltyProgram?: Maybe<LoyaltyProgramType>;
  to: Scalars['DateTime']['output'];
};

export type PosServicesInput = {
  index: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type PosServicesPaginateType = {
  __typename?: 'POSServicesPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PosServicesType>;
};

export type PosServicesType = {
  __typename?: 'POSServicesType';
  createdAt: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PackageType = {
  __typename?: 'PackageType';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  delivrable: Scalars['Decimal']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  perks?: Maybe<Array<Scalars['String']['output']>>;
  price: Scalars['Decimal']['output'];
  subscriptionCycle: SubscriptionCycleEnum;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PaginatedAccountsWithStatsType = {
  __typename?: 'PaginatedAccountsWithStatsType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<AccountsWithStatsType>;
};

export type PaginatedBlogsType = {
  __typename?: 'PaginatedBlogsType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<BlogType>;
};

export type PaginatedChallengesWithLinkedAccountsType = {
  __typename?: 'PaginatedChallengesWithLinkedAccountsType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ChallengeWithLinkedAccountsType>;
};

export type PaginatedCouponType = {
  __typename?: 'PaginatedCouponType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CouponType>;
};

export type PaginatedInternalProductWithStatsType = {
  __typename?: 'PaginatedInternalProductWithStatsType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<InternalProductWithStatsType>;
};

export type PaginatedLandingPagesType = {
  __typename?: 'PaginatedLandingPagesType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<LandingPagesType>;
};

export type PaginatedLandingPagesWithoutTranslationType = {
  __typename?: 'PaginatedLandingPagesWithoutTranslationType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<LandingPagesWithoutTranslationType>;
};

export type PaginatedNewslettersType = {
  __typename?: 'PaginatedNewslettersType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<NewsletterType>;
};

export type PaginatedProductClicksType = {
  __typename?: 'PaginatedProductClicksType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ProductClicksType>;
};

export type PaginatedQuestWithQualitativePictureType = {
  __typename?: 'PaginatedQuestWithQualitativePictureType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<QuestWithQualitativePictureType>;
};

export type PaginatedSeoType = {
  __typename?: 'PaginatedSEOType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<SeoType>;
};

export type PaginatedSlidesType = {
  __typename?: 'PaginatedSlidesType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<SlidesType>;
};

export type PaginatedSupplierType = {
  __typename?: 'PaginatedSupplierType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<SupplierType>;
};

export type PaginatedVisualsType = {
  __typename?: 'PaginatedVisualsType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<VisualsType>;
};

export type PaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type PartnerLoginType = {
  __typename?: 'PartnerLoginType';
  identifier?: Maybe<Scalars['String']['output']>;
};

export type PartnerReferralInput = {
  address?: InputMaybe<FullAddressInput>;
  app: App;
  content?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  posTitle?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerReferralPaginateType = {
  __typename?: 'PartnerReferralPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PartnerReferralType>;
};

export type PartnerReferralType = {
  __typename?: 'PartnerReferralType';
  address?: Maybe<FullAddressType>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  picture?: Maybe<PictureType>;
  posTitle?: Maybe<Scalars['String']['output']>;
  referralReference?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PartnershipNetworkInput = {
  partner: TargetAciInput;
  partnership: Array<PartnershipTypeEnum>;
  target: TargetAciInput;
};

export type PartnershipNetworkPaginateType = {
  __typename?: 'PartnershipNetworkPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PartnershipNetworkType>;
};

export type PartnershipNetworkType = {
  __typename?: 'PartnershipNetworkType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  partner?: Maybe<TargetType>;
  partnership?: Maybe<Array<PartnershipTypeEnum>>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PartnershipNetworkWithAcceleratePaginateType = {
  __typename?: 'PartnershipNetworkWithAcceleratePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PartnershipNetworkWithAccelerateType>;
};

export type PartnershipNetworkWithAccelerateType = {
  __typename?: 'PartnershipNetworkWithAccelerateType';
  accelerate: LoyaltySettingsAccelerateType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  partner?: Maybe<TargetType>;
  partnership?: Maybe<Array<PartnershipTypeEnum>>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PartnershipNetworkWithLinkedAccountStatusAndSettingsPaginateType = {
  __typename?: 'PartnershipNetworkWithLinkedAccountStatusAndSettingsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PartnershipNetworkWithLinkedAccountStatusAndSettingsType>;
};

export type PartnershipNetworkWithLinkedAccountStatusAndSettingsType = {
  __typename?: 'PartnershipNetworkWithLinkedAccountStatusAndSettingsType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  linkedAccountStatus?: Maybe<LinkAccountStatusEnum>;
  partner?: Maybe<TargetType>;
  partnership?: Maybe<Array<PartnershipTypeEnum>>;
  settings: TargetSettingsType;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PartnershipNetworkWithLinkedAccountStatusPaginateType = {
  __typename?: 'PartnershipNetworkWithLinkedAccountStatusPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PartnershipNetworkWithLinkedAccountStatusType>;
};

export type PartnershipNetworkWithLinkedAccountStatusType = {
  __typename?: 'PartnershipNetworkWithLinkedAccountStatusType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  linkedAccountStatus?: Maybe<LinkAccountStatusEnum>;
  partner?: Maybe<TargetType>;
  partnership?: Maybe<Array<PartnershipTypeEnum>>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PartnershipNetworkWithReferralPaginateType = {
  __typename?: 'PartnershipNetworkWithReferralPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PartnershipNetworkWithReferralType>;
};

export type PartnershipNetworkWithReferralType = {
  __typename?: 'PartnershipNetworkWithReferralType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  partner?: Maybe<TargetType>;
  partnership?: Maybe<Array<PartnershipTypeEnum>>;
  referral: LoyaltySettingsReferralType;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum PartnershipTypeEnum {
  ADVERTISER = 'ADVERTISER',
  CONVERSION = 'CONVERSION',
  DONATION = 'DONATION',
  MARKETPLACE = 'MARKETPLACE'
}

export type PaymentImagesInput = {
  png?: InputMaybe<PaymentImagesPngInput>;
  svg?: InputMaybe<PaymentImagesSvgInput>;
};

export type PaymentImagesPngInput = {
  alt?: InputMaybe<PictureInput>;
  alt2x?: InputMaybe<PictureInput>;
  alt_128?: InputMaybe<PictureInput>;
  alt_256?: InputMaybe<PictureInput>;
  alt_512?: InputMaybe<PictureInput>;
  card_flat?: InputMaybe<PictureInput>;
  card_flat2x?: InputMaybe<PictureInput>;
  card_flat_128?: InputMaybe<PictureInput>;
  card_flat_256?: InputMaybe<PictureInput>;
  card_flat_512?: InputMaybe<PictureInput>;
  dark?: InputMaybe<PictureInput>;
  dark2x?: InputMaybe<PictureInput>;
  dark_128?: InputMaybe<PictureInput>;
  dark_256?: InputMaybe<PictureInput>;
  dark_512?: InputMaybe<PictureInput>;
  default?: InputMaybe<PictureInput>;
  default2x?: InputMaybe<PictureInput>;
  default_128?: InputMaybe<PictureInput>;
  default_256?: InputMaybe<PictureInput>;
  default_512?: InputMaybe<PictureInput>;
  flat?: InputMaybe<PictureInput>;
  flat2x?: InputMaybe<PictureInput>;
  flat_128?: InputMaybe<PictureInput>;
  flat_256?: InputMaybe<PictureInput>;
  flat_512?: InputMaybe<PictureInput>;
  light?: InputMaybe<PictureInput>;
  light2x?: InputMaybe<PictureInput>;
  light_128?: InputMaybe<PictureInput>;
  light_256?: InputMaybe<PictureInput>;
  light_512?: InputMaybe<PictureInput>;
};

export type PaymentImagesPngType = {
  __typename?: 'PaymentImagesPngType';
  alt?: Maybe<PictureType>;
  alt2x?: Maybe<PictureType>;
  alt_128?: Maybe<PictureType>;
  alt_256?: Maybe<PictureType>;
  alt_512?: Maybe<PictureType>;
  card_flat?: Maybe<PictureType>;
  card_flat2x?: Maybe<PictureType>;
  card_flat_128?: Maybe<PictureType>;
  card_flat_256?: Maybe<PictureType>;
  card_flat_512?: Maybe<PictureType>;
  dark?: Maybe<PictureType>;
  dark2x?: Maybe<PictureType>;
  dark_128?: Maybe<PictureType>;
  dark_256?: Maybe<PictureType>;
  dark_512?: Maybe<PictureType>;
  default?: Maybe<PictureType>;
  default2x?: Maybe<PictureType>;
  default_128?: Maybe<PictureType>;
  default_256?: Maybe<PictureType>;
  default_512?: Maybe<PictureType>;
  flat?: Maybe<PictureType>;
  flat2x?: Maybe<PictureType>;
  flat_128?: Maybe<PictureType>;
  flat_256?: Maybe<PictureType>;
  flat_512?: Maybe<PictureType>;
  light?: Maybe<PictureType>;
  light2x?: Maybe<PictureType>;
  light_128?: Maybe<PictureType>;
  light_256?: Maybe<PictureType>;
  light_512?: Maybe<PictureType>;
};

export type PaymentImagesSvgInput = {
  alt?: InputMaybe<PictureInput>;
  card_flat?: InputMaybe<PictureInput>;
  dark?: InputMaybe<PictureInput>;
  default?: InputMaybe<PictureInput>;
  flat?: InputMaybe<PictureInput>;
  light?: InputMaybe<PictureInput>;
};

export type PaymentImagesSvgType = {
  __typename?: 'PaymentImagesSvgType';
  alt?: Maybe<PictureType>;
  card_flat?: Maybe<PictureType>;
  dark?: Maybe<PictureType>;
  default?: Maybe<PictureType>;
  flat?: Maybe<PictureType>;
  light?: Maybe<PictureType>;
};

export type PaymentImagesType = {
  __typename?: 'PaymentImagesType';
  png?: Maybe<PaymentImagesPngType>;
  svg?: Maybe<PaymentImagesSvgType>;
};

export type PaymentInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<PaymentImagesInput>;
  materialIcon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  paymentType?: InputMaybe<PaymentTypeEnum>;
};

export enum PaymentMethodsEnum {
  APP_COINS = 'APP_COINS',
  AUTOMATIC_DEBIT = 'AUTOMATIC_DEBIT',
  BANK_TRANSFER = 'BANK_TRANSFER',
  BILL_OF_EXCHANGE = 'BILL_OF_EXCHANGE',
  CASH = 'CASH',
  CHECK = 'CHECK',
  CREDIT_CARD = 'CREDIT_CARD',
  MOBILE_PAYMENT = 'MOBILE_PAYMENT'
}

export type PaymentMethodsFinanceDashboardDataType = {
  __typename?: 'PaymentMethodsFinanceDashboardDataType';
  APP_COINS?: Maybe<Scalars['Int']['output']>;
  AUTOMATIC_DEBIT?: Maybe<Scalars['Int']['output']>;
  BANK_TRANSFER?: Maybe<Scalars['Int']['output']>;
  BILL_OF_EXCHANGE?: Maybe<Scalars['Int']['output']>;
  CASH?: Maybe<Scalars['Int']['output']>;
  CHECK?: Maybe<Scalars['Int']['output']>;
  CREDIT_CARD?: Maybe<Scalars['Int']['output']>;
  MOBILE_PAYMENT?: Maybe<Scalars['Int']['output']>;
};

export type PaymentMethodsStatsType = {
  __typename?: 'PaymentMethodsStatsType';
  current: PaymentMethodsFinanceDashboardDataType;
  percentage: PaymentMethodsFinanceDashboardDataType;
  previous: PaymentMethodsFinanceDashboardDataType;
};

export type PaymentPaginatedType = {
  __typename?: 'PaymentPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PaymentType>;
};

export enum PaymentStatusEnum {
  CANCELED = 'CANCELED',
  OPEN = 'OPEN',
  PAID = 'PAID',
  REFUNDED = 'REFUNDED',
  REFUND_REQUESTED = 'REFUND_REQUESTED'
}

export type PaymentType = {
  __typename?: 'PaymentType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<PaymentImagesType>;
  materialIcon?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  paymentType?: Maybe<PaymentTypeEnum>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum PaymentTypeEnum {
  COIN = 'COIN',
  CREDIT_CARD = 'CREDIT_CARD',
  METHODS = 'METHODS',
  PAYMENT = 'PAYMENT'
}

export type PerformNonPredefinedQuestByUserInput = {
  api?: InputMaybe<Array<QuestActionActivityApiInput>>;
  game?: InputMaybe<Array<QuestActionGameInput>>;
  quest: Scalars['ID']['input'];
  responses?: InputMaybe<Array<ResponseInput>>;
  watched?: InputMaybe<Array<QuestActionActivityWatchedInput>>;
};

export type PerformanceByMetricType = {
  __typename?: 'PerformanceByMetricType';
  chart?: Maybe<Array<Array<Scalars['Float']['output']>>>;
  metric: PerformanceMetricEnum;
};

export enum PerformanceMetricEnum {
  CLICKS = 'CLICKS',
  CONVERSIONS = 'CONVERSIONS',
  CPA = 'CPA',
  IMPRESSIONS = 'IMPRESSIONS'
}

export type PerformanceMetricInput = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  metric: PerformanceMetricEnum;
  questTypes?: InputMaybe<QuestDashboardTypesFilterInput>;
  quests?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Source IDs to filter - references nested source in dashboard data (getQuestConversionStats, etc.), NOT quest source */
  sources?: InputMaybe<Array<Scalars['ID']['input']>>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum PeriodCycleEnum {
  DAY = 'DAY',
  HOUR = 'HOUR',
  MONTH = 'MONTH',
  WEEK = 'WEEK'
}

export type PeriodStatsType = {
  __typename?: 'PeriodStatsType';
  date: Scalars['String']['output'];
  total?: Maybe<Scalars['Decimal']['output']>;
};

export type PerksInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
};

export type PerksType = {
  __typename?: 'PerksType';
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Decimal']['output']>;
};

export type PermissionDefinitionInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PermissionDefinitionType = {
  __typename?: 'PermissionDefinitionType';
  category?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PermissionInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<PermissionPermissionsInput>>;
  target?: InputMaybe<TargetAciInput>;
};

export type PermissionPermissionsInput = {
  create?: InputMaybe<Scalars['Boolean']['input']>;
  permission: Scalars['ID']['input'];
  read?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PermissionPermissionsType = {
  __typename?: 'PermissionPermissionsType';
  create?: Maybe<Scalars['Boolean']['output']>;
  permission: PermissionDefinitionType;
  read?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<Scalars['Boolean']['output']>;
};

export type PermissionType = {
  __typename?: 'PermissionType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<PermissionPermissionsType>>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type PhoneInput = {
  /** Phone country code */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  /** Phone number */
  number?: InputMaybe<Scalars['String']['input']>;
};

export type PhoneType = {
  __typename?: 'PhoneType';
  countryCode?: Maybe<Scalars['String']['output']>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  validationNumber?: Maybe<Scalars['Int']['output']>;
};

export type PictureInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  baseUrl: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Int']['input']>;
  path: Scalars['String']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
  x?: InputMaybe<Scalars['Int']['input']>;
  y?: InputMaybe<Scalars['Int']['input']>;
};

export type PictureType = {
  __typename?: 'PictureType';
  alt?: Maybe<Scalars['String']['output']>;
  baseUrl?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
  x?: Maybe<Scalars['Int']['output']>;
  y?: Maybe<Scalars['Int']['output']>;
};

export type PixelBarcodeInput = {
  include?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PixelBarcodeType = {
  __typename?: 'PixelBarcodeType';
  include?: Maybe<Scalars['Boolean']['output']>;
};

export enum PixelRecommendedEventsEnum {
  ADD_PAYMENT_INFO = 'ADD_PAYMENT_INFO',
  ADD_TO_CART = 'ADD_TO_CART',
  ADD_TO_WISHLIST = 'ADD_TO_WISHLIST',
  COMPLETE_REGISTRATION = 'COMPLETE_REGISTRATION',
  CONTACT = 'CONTACT',
  FIND_LOCATION = 'FIND_LOCATION',
  INITIATE_CHECKOUT = 'INITIATE_CHECKOUT',
  LEAD = 'LEAD',
  PURCHASE = 'PURCHASE',
  SCHEDULE = 'SCHEDULE',
  SEARCH = 'SEARCH',
  START_TRIAL = 'START_TRIAL',
  SUBSCRIBE = 'SUBSCRIBE',
  VIEW_CONTENT = 'VIEW_CONTENT'
}

export enum PlatformEnum {
  ANDROID = 'ANDROID',
  DESKTOP = 'DESKTOP',
  IOS = 'IOS',
  WEB = 'WEB'
}

export type PlayerSeasonType = {
  __typename?: 'PlayerSeasonType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  player: Scalars['Float']['output'];
  season: Array<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PlayerStatisticsCardsType = {
  __typename?: 'PlayerStatisticsCardsType';
  red?: Maybe<Scalars['Float']['output']>;
  yellow?: Maybe<Scalars['Float']['output']>;
};

export type PlayerStatisticsDribblesType = {
  __typename?: 'PlayerStatisticsDribblesType';
  attempts?: Maybe<Scalars['Float']['output']>;
  past?: Maybe<Scalars['Float']['output']>;
  success?: Maybe<Scalars['Float']['output']>;
};

export type PlayerStatisticsDuelsType = {
  __typename?: 'PlayerStatisticsDuelsType';
  total?: Maybe<Scalars['Float']['output']>;
  won?: Maybe<Scalars['Float']['output']>;
};

export type PlayerStatisticsFoulsType = {
  __typename?: 'PlayerStatisticsFoulsType';
  committed?: Maybe<Scalars['Float']['output']>;
  drawn?: Maybe<Scalars['Float']['output']>;
};

export type PlayerStatisticsGamesType = {
  __typename?: 'PlayerStatisticsGamesType';
  captain?: Maybe<Scalars['Boolean']['output']>;
  minutes?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  substitute?: Maybe<Scalars['Boolean']['output']>;
};

export type PlayerStatisticsGoalsType = {
  __typename?: 'PlayerStatisticsGoalsType';
  assists?: Maybe<Scalars['Float']['output']>;
  conceded?: Maybe<Scalars['Float']['output']>;
  saves?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type PlayerStatisticsPassesType = {
  __typename?: 'PlayerStatisticsPassesType';
  accuracy?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type PlayerStatisticsPenaltyType = {
  __typename?: 'PlayerStatisticsPenaltyType';
  commited?: Maybe<Scalars['Float']['output']>;
  missed?: Maybe<Scalars['Float']['output']>;
  saved?: Maybe<Scalars['Float']['output']>;
  scored?: Maybe<Scalars['Float']['output']>;
  won?: Maybe<Scalars['Float']['output']>;
};

export type PlayerStatisticsPlayerType = {
  __typename?: 'PlayerStatisticsPlayerType';
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
};

export type PlayerStatisticsPlayersType = {
  __typename?: 'PlayerStatisticsPlayersType';
  player?: Maybe<PlayerStatisticsPlayerType>;
  statistics?: Maybe<Array<PlayerStatisticsStatisticsType>>;
};

export type PlayerStatisticsShotsType = {
  __typename?: 'PlayerStatisticsShotsType';
  on?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type PlayerStatisticsStatisticsType = {
  __typename?: 'PlayerStatisticsStatisticsType';
  cards?: Maybe<PlayerStatisticsCardsType>;
  dribbles?: Maybe<PlayerStatisticsDribblesType>;
  duels?: Maybe<PlayerStatisticsDuelsType>;
  fouls?: Maybe<PlayerStatisticsFoulsType>;
  games?: Maybe<PlayerStatisticsGamesType>;
  goals?: Maybe<PlayerStatisticsGoalsType>;
  offsides?: Maybe<Scalars['Float']['output']>;
  passes?: Maybe<PlayerStatisticsPassesType>;
  penalty?: Maybe<PlayerStatisticsPenaltyType>;
  shots?: Maybe<PlayerStatisticsShotsType>;
  tackles?: Maybe<PlayerStatisticsTacklesType>;
};

export type PlayerStatisticsTacklesType = {
  __typename?: 'PlayerStatisticsTacklesType';
  blocks?: Maybe<Scalars['Float']['output']>;
  interceptions?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type PlayerStatisticsTeamType = {
  __typename?: 'PlayerStatisticsTeamType';
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  update?: Maybe<Scalars['DateTime']['output']>;
};

export type PlayerStatisticsType = {
  __typename?: 'PlayerStatisticsType';
  createdAt: Scalars['DateTime']['output'];
  fixture?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  players?: Maybe<Array<PlayerStatisticsPlayersType>>;
  team?: Maybe<PlayerStatisticsTeamType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PlayersPlayerBirthType = {
  __typename?: 'PlayersPlayerBirthType';
  country?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  place?: Maybe<Scalars['String']['output']>;
};

export type PlayersPlayerType = {
  __typename?: 'PlayersPlayerType';
  age?: Maybe<Scalars['Float']['output']>;
  birth?: Maybe<PlayersPlayerBirthType>;
  firstname?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  injured?: Maybe<Scalars['String']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  photo64?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['String']['output']>;
};

export type PlayersStatisticsCardsType = {
  __typename?: 'PlayersStatisticsCardsType';
  red?: Maybe<Scalars['Float']['output']>;
  yellow?: Maybe<Scalars['Float']['output']>;
  yellowred?: Maybe<Scalars['Float']['output']>;
};

export type PlayersStatisticsDribblesType = {
  __typename?: 'PlayersStatisticsDribblesType';
  attempts?: Maybe<Scalars['Float']['output']>;
  past?: Maybe<Scalars['Float']['output']>;
  success?: Maybe<Scalars['Float']['output']>;
};

export type PlayersStatisticsDuelsType = {
  __typename?: 'PlayersStatisticsDuelsType';
  total?: Maybe<Scalars['Float']['output']>;
  won?: Maybe<Scalars['Float']['output']>;
};

export type PlayersStatisticsFoulsType = {
  __typename?: 'PlayersStatisticsFoulsType';
  committed?: Maybe<Scalars['Float']['output']>;
  drawn?: Maybe<Scalars['Float']['output']>;
};

export type PlayersStatisticsGamesType = {
  __typename?: 'PlayersStatisticsGamesType';
  appearences?: Maybe<Scalars['Float']['output']>;
  captain?: Maybe<Scalars['Boolean']['output']>;
  lineups?: Maybe<Scalars['Float']['output']>;
  minutes?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
};

export type PlayersStatisticsGoalsType = {
  __typename?: 'PlayersStatisticsGoalsType';
  assists?: Maybe<Scalars['Float']['output']>;
  conceded?: Maybe<Scalars['Float']['output']>;
  saves?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type PlayersStatisticsLeagueType = {
  __typename?: 'PlayersStatisticsLeagueType';
  country?: Maybe<Scalars['String']['output']>;
  flag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['String']['output']>;
};

export type PlayersStatisticsPassesType = {
  __typename?: 'PlayersStatisticsPassesType';
  accuracy?: Maybe<Scalars['Float']['output']>;
  key?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type PlayersStatisticsPenaltyType = {
  __typename?: 'PlayersStatisticsPenaltyType';
  commited?: Maybe<Scalars['Float']['output']>;
  missed?: Maybe<Scalars['Float']['output']>;
  saved?: Maybe<Scalars['Float']['output']>;
  scored?: Maybe<Scalars['Float']['output']>;
  won?: Maybe<Scalars['Float']['output']>;
};

export type PlayersStatisticsShotsType = {
  __typename?: 'PlayersStatisticsShotsType';
  on?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type PlayersStatisticsSubstituesType = {
  __typename?: 'PlayersStatisticsSubstituesType';
  bench?: Maybe<Scalars['Float']['output']>;
  teamIn?: Maybe<Scalars['Float']['output']>;
  teamOut?: Maybe<Scalars['Float']['output']>;
};

export type PlayersStatisticsTacklesType = {
  __typename?: 'PlayersStatisticsTacklesType';
  blocks?: Maybe<Scalars['Float']['output']>;
  interceptions?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type PlayersStatisticsTeamType = {
  __typename?: 'PlayersStatisticsTeamType';
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PlayersStatisticsType = {
  __typename?: 'PlayersStatisticsType';
  cards?: Maybe<PlayersStatisticsCardsType>;
  dribbles?: Maybe<PlayersStatisticsDribblesType>;
  duels?: Maybe<PlayersStatisticsDuelsType>;
  fouls?: Maybe<PlayersStatisticsFoulsType>;
  games?: Maybe<PlayersStatisticsGamesType>;
  goals?: Maybe<PlayersStatisticsGoalsType>;
  league?: Maybe<PlayersStatisticsLeagueType>;
  passes?: Maybe<PlayersStatisticsPassesType>;
  penalty?: Maybe<PlayersStatisticsPenaltyType>;
  shots?: Maybe<PlayersStatisticsShotsType>;
  substitutes?: Maybe<PlayersStatisticsSubstituesType>;
  tackles?: Maybe<PlayersStatisticsTacklesType>;
  team?: Maybe<PlayersStatisticsTeamType>;
};

export type PlayersStatsType = {
  __typename?: 'PlayersStatsType';
  id: Scalars['ID']['output'];
  player?: Maybe<PlayersPlayerType>;
  statistics?: Maybe<Array<PlayersStatisticsType>>;
};

export type PluginInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  info?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pictures?: InputMaybe<PluginPicturesInput>;
  recommended?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type PluginPaginatedType = {
  __typename?: 'PluginPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PluginType>;
};

export type PluginPicturesInput = {
  square?: InputMaybe<PictureInput>;
  wide?: InputMaybe<PictureInput>;
};

export type PluginPicturesType = {
  __typename?: 'PluginPicturesType';
  square?: Maybe<PictureType>;
  wide?: Maybe<PictureType>;
};

export type PluginType = {
  __typename?: 'PluginType';
  category?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  info?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pictures?: Maybe<PluginPicturesType>;
  recommended: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type PointOfSaleAppsInput = {
  platform?: InputMaybe<PlatformEnum>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type PointOfSaleAppsType = {
  __typename?: 'PointOfSaleAppsType';
  platform?: Maybe<PlatformEnum>;
  url?: Maybe<Scalars['String']['output']>;
};

export type PointOfSaleInput = {
  aggregator?: InputMaybe<Scalars['Boolean']['input']>;
  apps?: InputMaybe<Array<PointOfSaleAppsInput>>;
  averageCustomers?: InputMaybe<Scalars['Float']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  chatContact?: InputMaybe<Array<SocialValueInput>>;
  company?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  currencies?: InputMaybe<Array<TargetCurrencyInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  insidePictures?: InputMaybe<Array<PictureInput>>;
  languages?: InputMaybe<Array<Scalars['ID']['input']>>;
  locations?: InputMaybe<Array<FullAddressInput>>;
  loyaltyPrograms?: InputMaybe<Array<PosLoyaltyInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  openingHours?: InputMaybe<OpeningHoursInput>;
  outsidePictures?: InputMaybe<Array<PictureInput>>;
  paymentMethods?: InputMaybe<Array<Scalars['ID']['input']>>;
  phone?: InputMaybe<Array<Scalars['String']['input']>>;
  picture?: InputMaybe<PictureInput>;
  posCategory?: InputMaybe<Array<Scalars['ID']['input']>>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Array<Scalars['ID']['input']>>;
  socialMedia?: InputMaybe<Array<SocialValueInput>>;
  specialOffers?: InputMaybe<Array<SpecilOfferInput>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  turnover?: InputMaybe<Scalars['Decimal']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type PointOfSalePaginateType = {
  __typename?: 'PointOfSalePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PointOfSaleType>;
};

export type PointOfSaleType = {
  __typename?: 'PointOfSaleType';
  aggregator?: Maybe<Scalars['Boolean']['output']>;
  apps?: Maybe<Array<PointOfSaleAppsType>>;
  averageCustomers?: Maybe<Scalars['Float']['output']>;
  brandColor?: Maybe<Scalars['String']['output']>;
  chatContact?: Maybe<Array<SocialValueType>>;
  company?: Maybe<CompanyType>;
  contactEmails?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  currencies?: Maybe<Array<TargetCurrencyType>>;
  dashboard?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  insidePictures?: Maybe<Array<PictureType>>;
  isFollowed?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Array<LanguageType>>;
  locations?: Maybe<Array<FullAddressType>>;
  loyaltyPrograms?: Maybe<Array<PosLoyaltyType>>;
  name?: Maybe<Scalars['String']['output']>;
  openingHours?: Maybe<OpeningHoursType>;
  outsidePictures?: Maybe<Array<PictureType>>;
  paymentMethods?: Maybe<Array<PaymentType>>;
  phone?: Maybe<Array<Scalars['String']['output']>>;
  picture?: Maybe<PictureType>;
  posCategory?: Maybe<Array<PosCategoryType>>;
  published?: Maybe<Scalars['Boolean']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Array<PosServicesType>>;
  socialMedia?: Maybe<Array<SocialValueType>>;
  specialOffers?: Maybe<Array<SpecialOfferType>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
  turnover?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type PointOfSaleWithFollowShipStatusPaginateType = {
  __typename?: 'PointOfSaleWithFollowShipStatusPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PointOfSaleWithFollowShipStatusType>;
};

export type PointOfSaleWithFollowShipStatusType = {
  __typename?: 'PointOfSaleWithFollowShipStatusType';
  aggregator?: Maybe<Scalars['Boolean']['output']>;
  apps?: Maybe<Array<PointOfSaleAppsType>>;
  averageCustomers?: Maybe<Scalars['Float']['output']>;
  brandColor?: Maybe<Scalars['String']['output']>;
  chatContact?: Maybe<Array<SocialValueType>>;
  company?: Maybe<CompanyType>;
  contactEmails?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  currencies?: Maybe<Array<TargetCurrencyType>>;
  dashboard?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  insidePictures?: Maybe<Array<PictureType>>;
  isFollowed: Scalars['Boolean']['output'];
  languages?: Maybe<Array<LanguageType>>;
  locations?: Maybe<Array<FullAddressType>>;
  loyaltyPrograms?: Maybe<Array<PosLoyaltyType>>;
  name?: Maybe<Scalars['String']['output']>;
  openingHours?: Maybe<OpeningHoursType>;
  outsidePictures?: Maybe<Array<PictureType>>;
  paymentMethods?: Maybe<Array<PaymentType>>;
  phone?: Maybe<Array<Scalars['String']['output']>>;
  picture?: Maybe<PictureType>;
  posCategory?: Maybe<Array<PosCategoryType>>;
  published?: Maybe<Scalars['Boolean']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Array<PosServicesType>>;
  socialMedia?: Maybe<Array<SocialValueType>>;
  specialOffers?: Maybe<Array<SpecialOfferType>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
  turnover?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export enum PositionEnum {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}

export type PredefinedActionInput = {
  action?: InputMaybe<Scalars['ID']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PredefinedActionType = {
  __typename?: 'PredefinedActionType';
  action?: Maybe<PredefinedType>;
  enable?: Maybe<Scalars['Boolean']['output']>;
};

export type PredefinedInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PredefinedPaginateType = {
  __typename?: 'PredefinedPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PredefinedType>;
};

export type PredefinedType = {
  __typename?: 'PredefinedType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<MediaType>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PredefinedUpdateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PredictionsComparisonType = {
  __typename?: 'PredictionsComparisonType';
  att?: Maybe<StatHaType>;
  def?: Maybe<StatHaType>;
  form?: Maybe<StatHaType>;
  goals?: Maybe<StatHaType>;
  h2h?: Maybe<StatHaType>;
  poisson_distribution?: Maybe<StatHaType>;
  total?: Maybe<StatHaType>;
};

export type PredictionsH2HFixturePeriodsType = {
  __typename?: 'PredictionsH2HFixturePeriodsType';
  first?: Maybe<Scalars['Float']['output']>;
  second?: Maybe<Scalars['Float']['output']>;
};

export type PredictionsH2HFixtureStatusType = {
  __typename?: 'PredictionsH2HFixtureStatusType';
  elapsed?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['String']['output']>;
  short?: Maybe<Scalars['String']['output']>;
};

export type PredictionsH2HFixtureType = {
  __typename?: 'PredictionsH2HFixtureType';
  date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  periods?: Maybe<PredictionsH2HFixturePeriodsType>;
  referee?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PredictionsH2HFixtureStatusType>;
  timestamp?: Maybe<Scalars['Float']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  venue?: Maybe<PredictionsH2HFixtureVenueType>;
};

export type PredictionsH2HFixtureVenueType = {
  __typename?: 'PredictionsH2HFixtureVenueType';
  city?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PredictionsH2HLeagueType = {
  __typename?: 'PredictionsH2HLeagueType';
  country?: Maybe<Scalars['String']['output']>;
  flag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  round?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
};

export type PredictionsH2HScoreType = {
  __typename?: 'PredictionsH2HScoreType';
  extratime?: Maybe<StatHaType>;
  fulltime?: Maybe<StatHaType>;
  halftime?: Maybe<StatHaType>;
  penalty?: Maybe<StatHaType>;
};

export type PredictionsH2HTeamsHaType = {
  __typename?: 'PredictionsH2HTeamsHAType';
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  winner?: Maybe<Scalars['Boolean']['output']>;
};

export type PredictionsH2HTeamsType = {
  __typename?: 'PredictionsH2HTeamsType';
  away?: Maybe<PredictionsH2HTeamsHaType>;
  home?: Maybe<PredictionsH2HTeamsHaType>;
};

export type PredictionsH2HType = {
  __typename?: 'PredictionsH2HType';
  fixture?: Maybe<PredictionsH2HFixtureType>;
  goals?: Maybe<StatHaType>;
  league?: Maybe<PredictionsH2HLeagueType>;
  score?: Maybe<PredictionsH2HScoreType>;
  teams?: Maybe<PredictionsH2HTeamsType>;
};

export type PredictionsLeagueType = {
  __typename?: 'PredictionsLeagueType';
  country?: Maybe<Scalars['String']['output']>;
  flag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
};

export type PredictionsPercentType = {
  __typename?: 'PredictionsPercentType';
  away?: Maybe<Scalars['String']['output']>;
  draw?: Maybe<Scalars['String']['output']>;
  home?: Maybe<Scalars['String']['output']>;
};

export type PredictionsPredictionsType = {
  __typename?: 'PredictionsPredictionsType';
  advice?: Maybe<Scalars['String']['output']>;
  goals?: Maybe<StatHaType>;
  percent?: Maybe<PredictionsPercentType>;
  under_over?: Maybe<Scalars['String']['output']>;
  win_or_draw?: Maybe<Scalars['Boolean']['output']>;
  winner?: Maybe<PredictionsWinnerType>;
};

export type PredictionsTamType = {
  __typename?: 'PredictionsTAMType';
  average?: Maybe<StatHatType>;
  minute?: Maybe<StatMinuteType>;
  total?: Maybe<StatHatType>;
};

export type PredictionsTeamsHomeLast5GoalsType = {
  __typename?: 'PredictionsTeamsHomeLast5GoalsType';
  against?: Maybe<StatTaType>;
  forstat?: Maybe<StatTaType>;
};

export type PredictionsTeamsHomeLast5Type = {
  __typename?: 'PredictionsTeamsHomeLast5Type';
  att?: Maybe<Scalars['String']['output']>;
  def?: Maybe<Scalars['String']['output']>;
  form?: Maybe<Scalars['String']['output']>;
  goals?: Maybe<PredictionsTeamsHomeLast5GoalsType>;
};

export type PredictionsTeamsHomeLeagueBiggestGoalsType = {
  __typename?: 'PredictionsTeamsHomeLeagueBiggestGoalsType';
  against?: Maybe<StatHaType>;
  forstat?: Maybe<StatHaType>;
};

export type PredictionsTeamsHomeLeagueBiggestStreakType = {
  __typename?: 'PredictionsTeamsHomeLeagueBiggestStreakType';
  draws?: Maybe<Scalars['Float']['output']>;
  loses?: Maybe<Scalars['Float']['output']>;
  wins?: Maybe<Scalars['Float']['output']>;
};

export type PredictionsTeamsHomeLeagueBiggestType = {
  __typename?: 'PredictionsTeamsHomeLeagueBiggestType';
  goals?: Maybe<PredictionsTeamsHomeLeagueBiggestGoalsType>;
  loses?: Maybe<StatHaType>;
  streak?: Maybe<PredictionsTeamsHomeLeagueBiggestStreakType>;
  wins?: Maybe<StatHaType>;
};

export type PredictionsTeamsHomeLeagueCardsType = {
  __typename?: 'PredictionsTeamsHomeLeagueCardsType';
  red?: Maybe<StatMinuteType>;
  yellow?: Maybe<StatMinuteType>;
};

export type PredictionsTeamsHomeLeagueFixturesType = {
  __typename?: 'PredictionsTeamsHomeLeagueFixturesType';
  draws?: Maybe<StatHatType>;
  loses?: Maybe<StatHatType>;
  played?: Maybe<StatHatType>;
  wins?: Maybe<StatHatType>;
};

export type PredictionsTeamsHomeLeagueGoalsType = {
  __typename?: 'PredictionsTeamsHomeLeagueGoalsType';
  against?: Maybe<PredictionsTamType>;
  forstat?: Maybe<PredictionsTamType>;
};

export type PredictionsTeamsHomeLeaguePenaltyType = {
  __typename?: 'PredictionsTeamsHomeLeaguePenaltyType';
  missed?: Maybe<StatTpType>;
  scored?: Maybe<StatTpType>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type PredictionsTeamsHomeLeagueType = {
  __typename?: 'PredictionsTeamsHomeLeagueType';
  biggest?: Maybe<PredictionsTeamsHomeLeagueBiggestType>;
  cards?: Maybe<PredictionsTeamsHomeLeagueCardsType>;
  clean_sheet?: Maybe<StatHatType>;
  failed_to_score?: Maybe<StatHatType>;
  fixtures?: Maybe<PredictionsTeamsHomeLeagueFixturesType>;
  form?: Maybe<Scalars['String']['output']>;
  goals?: Maybe<PredictionsTeamsHomeLeagueGoalsType>;
  penalty?: Maybe<PredictionsTeamsHomeLeaguePenaltyType>;
};

export type PredictionsTeamsHomeType = {
  __typename?: 'PredictionsTeamsHomeType';
  id?: Maybe<Scalars['Float']['output']>;
  last_5?: Maybe<PredictionsTeamsHomeLast5Type>;
  league?: Maybe<PredictionsTeamsHomeLeagueType>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PredictionsTeamsType = {
  __typename?: 'PredictionsTeamsType';
  away?: Maybe<PredictionsTeamsHomeType>;
  home?: Maybe<PredictionsTeamsHomeType>;
};

export type PredictionsType = {
  __typename?: 'PredictionsType';
  comparison?: Maybe<PredictionsComparisonType>;
  createdAt: Scalars['DateTime']['output'];
  fixture: Scalars['Int']['output'];
  h2h?: Maybe<Array<PredictionsH2HType>>;
  id: Scalars['ID']['output'];
  league?: Maybe<PredictionsLeagueType>;
  predictions?: Maybe<PredictionsPredictionsType>;
  teams?: Maybe<PredictionsTeamsType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PredictionsWinnerType = {
  __typename?: 'PredictionsWinnerType';
  comment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PrelevelContentInput = {
  description: Scalars['String']['input'];
  reputationLevel: Scalars['String']['input'];
};

export type PrelevelTranslationContentType = {
  __typename?: 'PrelevelTranslationContentType';
  description: Scalars['String']['output'];
  reputationLevel: Scalars['String']['output'];
};

export type PrelevelTranslationInput = {
  content: PrelevelContentInput;
  language: Scalars['ID']['input'];
};

export type PrelevelTranslationType = {
  __typename?: 'PrelevelTranslationType';
  content: PrelevelTranslationContentType;
  language: LanguageType;
};

export type PriceCountType = {
  __typename?: 'PriceCountType';
  count?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
};

export type PriceCreditInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  periodCycle?: InputMaybe<RecurrenceType>;
  periodValue?: InputMaybe<Scalars['Int']['input']>;
};

export type PriceCreditType = {
  __typename?: 'PriceCreditType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  periodCycle?: Maybe<RecurrenceType>;
  periodValue?: Maybe<Scalars['Int']['output']>;
};

export type PriceFullType = {
  __typename?: 'PriceFullType';
  gross?: Maybe<ReduciblePriceType>;
  net?: Maybe<ReduciblePriceType>;
  toPay?: Maybe<ReduciblePriceType>;
};

export type PriceInput = {
  company?: InputMaybe<Scalars['ID']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type PricePaginateType = {
  __typename?: 'PricePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PriceType>;
};

export type PriceRangeCountType = {
  __typename?: 'PriceRangeCountType';
  numberOfProducts: Scalars['Int']['output'];
  priceRange?: Maybe<Array<Scalars['Float']['output']>>;
};

export type PriceRangeType = {
  __typename?: 'PriceRangeType';
  max?: Maybe<Scalars['Decimal']['output']>;
  min?: Maybe<Scalars['Decimal']['output']>;
};

export type PriceType = {
  __typename?: 'PriceType';
  company?: Maybe<CompanyType>;
  createdAt: Scalars['DateTime']['output'];
  enable?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductAttributeInput = {
  attribute: Scalars['String']['input'];
  isMultipleChoice?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  possibleValues: Array<Scalars['String']['input']>;
  reference: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
};

export type ProductAttributePaginateType = {
  __typename?: 'ProductAttributePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ProductAttributeType>;
};

export type ProductAttributeType = {
  __typename?: 'ProductAttributeType';
  attribute: AttributeType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isMultipleChoice: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  possibleValues: Array<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductAttributeUpdateInput = {
  attribute?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isMultipleChoice?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  possibleValues?: InputMaybe<Array<Scalars['String']['input']>>;
  reference?: InputMaybe<Scalars['String']['input']>;
};

export enum ProductClassEnum {
  BEST_SELLERS = 'BEST_SELLERS',
  FEATURED_PRODUCTS = 'FEATURED_PRODUCTS',
  NEW_ARRIVALS = 'NEW_ARRIVALS',
  PROMO = 'PROMO',
  TOP_PRODUCTS = 'TOP_PRODUCTS'
}

export type ProductClicksInput = {
  product: Scalars['ID']['input'];
  target: TargetAciInput;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type ProductClicksType = {
  __typename?: 'ProductClicksType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  product: InternalProductType;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export enum ProductConditionEnum {
  NEW = 'NEW',
  REFURBISHED = 'REFURBISHED',
  USED = 'USED'
}

export type ProductFilterInput = {
  /** list of barcodes ids */
  barcodes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** list of brands ids */
  brand?: InputMaybe<Array<Scalars['String']['input']>>;
  /** list of inventoryCategories ids */
  category?: InputMaybe<Array<Scalars['String']['input']>>;
  classification?: InputMaybe<Array<ProductClassEnum>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  fromPrice?: InputMaybe<Scalars['Decimal']['input']>;
  /** list of productAttributes ids */
  productAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  rent?: InputMaybe<Scalars['Boolean']['input']>;
  structure?: InputMaybe<Array<ProductStructureEnum>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  toPrice?: InputMaybe<Scalars['Decimal']['input']>;
  variety?: InputMaybe<Array<ProductVarietyEnum>>;
};

export type ProductFilterType = {
  __typename?: 'ProductFilterType';
  /** list of barcodes */
  barcodes?: Maybe<Array<BarcodeType>>;
  /** list of brands */
  brands?: Maybe<Array<BrandType>>;
  /** list of inventoryCategories */
  categories?: Maybe<Array<InventoryCategoryType>>;
  createdAtRange?: Maybe<DateRangeType>;
  priceRange?: Maybe<PriceRangeType>;
  /** list of productAttributes */
  productAttributes?: Maybe<Array<ProductAttributeType>>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  structure?: Maybe<Array<ProductStructureEnum>>;
  updatedAtRange?: Maybe<DateRangeType>;
  variety?: Maybe<Array<ProductVarietyEnum>>;
};

export enum ProductFlagEnum {
  AFFORDABLE = 'AFFORDABLE',
  AFFORDABLE_LUXURY = 'AFFORDABLE_LUXURY',
  ANNIVERSARY_SPECIAL = 'ANNIVERSARY_SPECIAL',
  AUTUMN_COLLECTION = 'AUTUMN_COLLECTION',
  AVAILABLE_NOW = 'AVAILABLE_NOW',
  AWARD_WINNING = 'AWARD_WINNING',
  BACK_IN_FASHION = 'BACK_IN_FASHION',
  BACK_IN_STOCK = 'BACK_IN_STOCK',
  BACK_TO_SCHOOL = 'BACK_TO_SCHOOL',
  BEST_SELLER = 'BEST_SELLER',
  BIRTHDAY_SPECIAL = 'BIRTHDAY_SPECIAL',
  BLACK_FRIDAY = 'BLACK_FRIDAY',
  BUDGET_FRIENDLY = 'BUDGET_FRIENDLY',
  BUY_ONE_GET_ONE = 'BUY_ONE_GET_ONE',
  CHRISTMAS_SPECIAL = 'CHRISTMAS_SPECIAL',
  CLEARANCE = 'CLEARANCE',
  CLEARANCE_PRICE = 'CLEARANCE_PRICE',
  COMING_SOON = 'COMING_SOON',
  CUSTOMER_FAVORITE = 'CUSTOMER_FAVORITE',
  CYBER_MONDAY = 'CYBER_MONDAY',
  DEAL_OF_THE_DAY = 'DEAL_OF_THE_DAY',
  DISCOUNTED = 'DISCOUNTED',
  EASTER_SPECIAL = 'EASTER_SPECIAL',
  ECO_FRIENDLY = 'ECO_FRIENDLY',
  EDITORS_PICK = 'EDITORS_PICK',
  EXCLUSIVE = 'EXCLUSIVE',
  EXCLUSIVE_ONLINE = 'EXCLUSIVE_ONLINE',
  FATHERS_DAY = 'FATHERS_DAY',
  FEATURED = 'FEATURED',
  FLASH_SALE = 'FLASH_SALE',
  FREE_SHIPPING = 'FREE_SHIPPING',
  GIFT_IDEAS = 'GIFT_IDEAS',
  GIFT_WITH_PURCHASE = 'GIFT_WITH_PURCHASE',
  GRADUATION_GIFT = 'GRADUATION_GIFT',
  HALLOWEEN_SPECIAL = 'HALLOWEEN_SPECIAL',
  HANDMADE = 'HANDMADE',
  HIGH_END = 'HIGH_END',
  HIGH_QUALITY = 'HIGH_QUALITY',
  HOLIDAY_SPECIAL = 'HOLIDAY_SPECIAL',
  HOT = 'HOT',
  HOT_DEAL = 'HOT_DEAL',
  INNOVATIVE = 'INNOVATIVE',
  IN_STOCK = 'IN_STOCK',
  JUST_ARRIVED = 'JUST_ARRIVED',
  LAST_CHANCE = 'LAST_CHANCE',
  LIMITED_EDITION = 'LIMITED_EDITION',
  LIMITED_RELEASE = 'LIMITED_RELEASE',
  LIMITED_STOCK = 'LIMITED_STOCK',
  LIMITED_TIME_OFFER = 'LIMITED_TIME_OFFER',
  LOW_STOCK = 'LOW_STOCK',
  LUXURY = 'LUXURY',
  MEMBER_EXCLUSIVE = 'MEMBER_EXCLUSIVE',
  MOST_WISHED_FOR = 'MOST_WISHED_FOR',
  MOTHERS_DAY = 'MOTHERS_DAY',
  MUST_HAVE = 'MUST_HAVE',
  NEW = 'NEW',
  NEW_ARRIVAL = 'NEW_ARRIVAL',
  NEW_SEASON = 'NEW_SEASON',
  NEW_YEAR_SALE = 'NEW_YEAR_SALE',
  ORGANIC = 'ORGANIC',
  OUT_OF_STOCK = 'OUT_OF_STOCK',
  POPULAR = 'POPULAR',
  PREMIUM = 'PREMIUM',
  PRE_ORDER = 'PRE_ORDER',
  PRE_SALE = 'PRE_SALE',
  PRICE_DROP = 'PRICE_DROP',
  REDUCED_PRICE = 'REDUCED_PRICE',
  SALE = 'SALE',
  SPECIAL_OFFER = 'SPECIAL_OFFER',
  SPRING_COLLECTION = 'SPRING_COLLECTION',
  SUMMER_COLLECTION = 'SUMMER_COLLECTION',
  SUSTAINABLE = 'SUSTAINABLE',
  TOP_RATED = 'TOP_RATED',
  TRENDING = 'TRENDING',
  UNDER_50 = 'UNDER_50',
  VALENTINES_DAY = 'VALENTINES_DAY',
  VALUE_PACK = 'VALUE_PACK',
  WEDDING_COLLECTION = 'WEDDING_COLLECTION',
  WEEKEND_SALE = 'WEEKEND_SALE',
  WINTER_COLLECTION = 'WINTER_COLLECTION'
}

export type ProductInput = {
  /** list of barcodes ids */
  barcodes?: InputMaybe<Array<Scalars['ID']['input']>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  category: Array<Scalars['String']['input']>;
  classification?: InputMaybe<Array<ProductClassEnum>>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionList?: InputMaybe<Array<Scalars['String']['input']>>;
  ean?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  factoryPrice?: InputMaybe<Scalars['Decimal']['input']>;
  media?: InputMaybe<MediaInput>;
  name: Scalars['String']['input'];
  picture?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<Array<PictureInput>>;
  price: Scalars['Decimal']['input'];
  productAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  sku?: InputMaybe<Scalars['String']['input']>;
  specs?: InputMaybe<Array<ProductSpecsInput>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tax: Scalars['Decimal']['input'];
  taxes?: InputMaybe<Array<ProductTaxesInput>>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  wholesalerPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export enum ProductKindEnum {
  PRODUCT = 'PRODUCT',
  SECTION = 'SECTION',
  SEPARATOR = 'SEPARATOR',
  SUBTOTAL = 'SUBTOTAL',
  TEXT = 'TEXT'
}

export type ProductPaginateType = {
  __typename?: 'ProductPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ProductType>;
};

export type ProductPaginateWithFilterType = {
  __typename?: 'ProductPaginateWithFilterType';
  count?: Maybe<Scalars['Int']['output']>;
  filter?: Maybe<ProductFilterType>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ProductType>;
};

export type ProductPriceListInput = {
  price: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ProductPriceListType = {
  __typename?: 'ProductPriceListType';
  price?: Maybe<PriceType>;
  value?: Maybe<Scalars['Decimal']['output']>;
};

export type ProductPriceType = {
  __typename?: 'ProductPriceType';
  gross?: Maybe<Scalars['Decimal']['output']>;
  net?: Maybe<Scalars['Decimal']['output']>;
  unitGross?: Maybe<Scalars['Decimal']['output']>;
  unitNet?: Maybe<Scalars['Decimal']['output']>;
};

export type ProductRatingDefinitionInput = {
  active: Scalars['Boolean']['input'];
  reviewType: Scalars['String']['input'];
};

export type ProductRatingDefinitionPaginateType = {
  __typename?: 'ProductRatingDefinitionPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ProductRatingDefinitionType>;
};

export type ProductRatingDefinitionType = {
  __typename?: 'ProductRatingDefinitionType';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  reviewType?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductRatingInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  mark: Scalars['Int']['input'];
  product: Scalars['ID']['input'];
  reviewType: Scalars['ID']['input'];
  user: Scalars['ID']['input'];
};

export type ProductRatingPaginateType = {
  __typename?: 'ProductRatingPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ProductRatingType>;
};

export type ProductRatingType = {
  __typename?: 'ProductRatingType';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mark: Scalars['Int']['output'];
  product: ProductType;
  reviewType: ProductRatingDefinitionType;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type ProductRatingWithStatsPaginatedType = {
  __typename?: 'ProductRatingWithStatsPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ProductRatingType>;
  stats?: Maybe<Array<ByMarkRatingType>>;
};

export type ProductSortInput = {
  /** 1 for sort by createdAt ascending and -1 for descending */
  createdAt?: InputMaybe<Scalars['Float']['input']>;
  /** 1 for sort by name ascending and -1 for descending */
  name?: InputMaybe<Scalars['Float']['input']>;
  /** 1 for sort by price ascending and -1 for descending */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** 1 for sort by updatedAt ascending and -1 for descending */
  updatedAt?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductSpecsInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ProductSpecsType = {
  __typename?: 'ProductSpecsType';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum ProductStatusEnum {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED'
}

export enum ProductStructureEnum {
  CONSUMABLE = 'CONSUMABLE',
  SERVICE = 'SERVICE',
  STOCKABLE = 'STOCKABLE'
}

export type ProductTaxesInput = {
  rank: Scalars['Int']['input'];
  tax: Scalars['ID']['input'];
};

export type ProductTaxesType = {
  __typename?: 'ProductTaxesType';
  rank?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<TaxType>;
};

export type ProductType = {
  __typename?: 'ProductType';
  /** list of barcodes */
  barcodes?: Maybe<Array<BarcodeType>>;
  brand?: Maybe<BrandType>;
  category?: Maybe<Array<InventoryCategoryType>>;
  classification?: Maybe<Array<ProductClassEnum>>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  ean?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  factoryPrice?: Maybe<Scalars['Decimal']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  pictures?: Maybe<Array<PictureType>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  productAttributes?: Maybe<Array<ProductAttributeType>>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  specs?: Maybe<Array<ProductSpecsType>>;
  structure?: Maybe<ProductStructureEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tax?: Maybe<Scalars['Decimal']['output']>;
  taxes?: Maybe<Array<ProductTaxesType>>;
  updatedAt: Scalars['DateTime']['output'];
  variety?: Maybe<ProductVarietyEnum>;
  weight?: Maybe<Scalars['Float']['output']>;
  wholesalerPrice?: Maybe<Scalars['Decimal']['output']>;
};

export type ProductUpdateInput = {
  /** list of barcodes ids */
  barcodes?: InputMaybe<Array<Scalars['ID']['input']>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Array<Scalars['String']['input']>>;
  classification?: InputMaybe<Array<ProductClassEnum>>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionList?: InputMaybe<Array<Scalars['String']['input']>>;
  ean?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  factoryPrice?: InputMaybe<Scalars['Decimal']['input']>;
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<Array<PictureInput>>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  productAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  sku?: InputMaybe<Scalars['String']['input']>;
  specs?: InputMaybe<Array<ProductSpecsInput>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tax?: InputMaybe<Scalars['Decimal']['input']>;
  taxes?: InputMaybe<Array<ProductTaxesInput>>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  wholesalerPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ProductValidationType = {
  __typename?: 'ProductValidationType';
  headersValid?: Maybe<Scalars['Boolean']['output']>;
  isBrandsComplete?: Maybe<Scalars['Boolean']['output']>;
  isCategoriesComplete?: Maybe<Scalars['Boolean']['output']>;
  isIdComplete?: Maybe<Scalars['Boolean']['output']>;
  isNameComplete?: Maybe<Scalars['Boolean']['output']>;
  isVATComplete?: Maybe<Scalars['Boolean']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  overallValidation?: Maybe<Scalars['Boolean']['output']>;
};

export enum ProductVarietyEnum {
  EQUIPMENT = 'EQUIPMENT',
  PRODUCT = 'PRODUCT',
  SERVICE = 'SERVICE',
  VEHICULE = 'VEHICULE'
}

export type ProductsByCatalogueCategoryCountType = {
  __typename?: 'ProductsByCatalogueCategoryCountType';
  booking?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  delivery?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  hasChildren: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  layer: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  numberOfProducts: Scalars['Int']['output'];
  parent?: Maybe<CatalogueCategoryBaseType>;
  pickup?: Maybe<Scalars['Boolean']['output']>;
  pictures?: Maybe<Array<PictureType>>;
  portal?: Maybe<Scalars['Boolean']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  translation?: Maybe<Array<CatalogueCategoryTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  variety?: Maybe<ProductVarietyEnum>;
};

export enum ProfileCompleteElementsEnum {
  ABOUT = 'ABOUT',
  BIRTHDATE = 'BIRTHDATE',
  EDUCATION = 'EDUCATION',
  EMAIL = 'EMAIL',
  GENDER = 'GENDER',
  GEOLOCATION = 'GEOLOCATION',
  HOBBIES = 'HOBBIES',
  INTERESTS = 'INTERESTS',
  JOBS = 'JOBS',
  MARITAL_STATUS = 'MARITAL_STATUS',
  PHONE = 'PHONE',
  PROFILE_PICTURE = 'PROFILE_PICTURE',
  RESIDENTIAL_ADDRESS = 'RESIDENTIAL_ADDRESS',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  VERIFY_EMAIL = 'VERIFY_EMAIL',
  VERIFY_PHONE = 'VERIFY_PHONE'
}

export type ProfileCompletnessProgressType = {
  __typename?: 'ProfileCompletnessProgressType';
  levels?: Maybe<Array<LoyaltySettingsProfileCompleteLevelsType>>;
  progress: Scalars['Decimal']['output'];
};

export type ProgramBookingInput = {
  capacity?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<EventProgramStatusEnum>;
};

export type ProgramBookingType = {
  __typename?: 'ProgramBookingType';
  capacity?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<EventProgramStatusEnum>;
};

export type ProgramInput = {
  address?: InputMaybe<FullAddressInput>;
  booking?: InputMaybe<ProgramBookingInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  event: Scalars['ID']['input'];
  from: Scalars['DateTime']['input'];
  picture?: InputMaybe<PictureInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
  translation?: InputMaybe<Array<ProgramTranslationInput>>;
};

export type ProgramPaginateType = {
  __typename?: 'ProgramPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ProgramType>;
};

export type ProgramTranslationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramTranslationType = {
  __typename?: 'ProgramTranslationType';
  description?: Maybe<Scalars['String']['output']>;
  language?: Maybe<LanguageType>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ProgramType = {
  __typename?: 'ProgramType';
  address?: Maybe<FullAddressType>;
  booking?: Maybe<ProgramBookingType>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  event?: Maybe<EventType>;
  from?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  picture?: Maybe<PictureType>;
  title?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
  translation?: Maybe<Array<ProgramTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProgramUpdateInput = {
  address?: InputMaybe<FullAddressInput>;
  booking?: InputMaybe<ProgramBookingInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  picture?: InputMaybe<PictureInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<Array<ProgramTranslationInput>>;
};

export type ProjectFilterInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  members?: InputMaybe<Array<Scalars['ID']['input']>>;
  priority?: InputMaybe<Array<ProjectPriorityEnum>>;
  privacy?: InputMaybe<Array<ProjectPrivacyEnum>>;
  status?: InputMaybe<Array<ProjectStatusEnum>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProjectInput = {
  attachments?: InputMaybe<Array<Scalars['ID']['input']>>;
  color?: InputMaybe<Scalars['String']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  members?: InputMaybe<Array<ProjectMemberInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  priority?: InputMaybe<ProjectPriorityEnum>;
  privacy?: InputMaybe<ProjectPrivacyEnum>;
  resources?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<ProjectStatusEnum>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  target?: InputMaybe<TargetAciInput>;
};

export type ProjectMemberInput = {
  member?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<ProjectRoleEnum>;
};

export type ProjectMemberType = {
  __typename?: 'ProjectMemberType';
  member?: Maybe<UserType>;
  role?: Maybe<ProjectRoleEnum>;
};

export type ProjectPaginateType = {
  __typename?: 'ProjectPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ProjectType>;
};

export enum ProjectPriorityEnum {
  CRITICAL = 'CRITICAL',
  HIGH = 'HIGH',
  LOW = 'LOW',
  NORMAL = 'NORMAL'
}

export enum ProjectPrivacyEnum {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export enum ProjectRoleEnum {
  LEAD = 'LEAD',
  MEMBER = 'MEMBER'
}

export enum ProjectStatusEnum {
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED',
  CANCELLED = 'CANCELLED',
  DELIVERED = 'DELIVERED'
}

export type ProjectType = {
  __typename?: 'ProjectType';
  attachments?: Maybe<Array<DocumentType>>;
  boardCardsStats?: Maybe<BoardCardsStatsType>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deadline?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<MediaType>;
  members?: Maybe<Array<ProjectMemberType>>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  priority?: Maybe<ProjectPriorityEnum>;
  privacy?: Maybe<ProjectPrivacyEnum>;
  resources?: Maybe<Array<DocumentType>>;
  status?: Maybe<ProjectStatusEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProjectUpdateInput = {
  attachments?: InputMaybe<Array<Scalars['ID']['input']>>;
  color?: InputMaybe<Scalars['String']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  media?: InputMaybe<MediaInput>;
  members?: InputMaybe<Array<ProjectMemberInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  priority?: InputMaybe<ProjectPriorityEnum>;
  privacy?: InputMaybe<ProjectPrivacyEnum>;
  resources?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<ProjectStatusEnum>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  target?: InputMaybe<TargetAciInput>;
};

export type ProjectsBoardCardFilterInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  target: TargetAciInput;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PromotionFilterBaseInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<PromotionStatusEnum>>;
};

export type PromotionFilterInput = {
  barcodes?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<PromotionStatusEnum>>;
};

export type PromotionInput = {
  endDate: Scalars['DateTime']['input'];
  promotion: Array<PromotionProductsInput>;
  startDate: Scalars['DateTime']['input'];
  status?: InputMaybe<PromotionStatusEnum>;
  target: TargetAciInput;
};

export type PromotionPaginateType = {
  __typename?: 'PromotionPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PromotionType>;
};

export type PromotionProductsInput = {
  barcode: Scalars['ID']['input'];
  discount: DiscountDtoInput;
};

export type PromotionProductsType = {
  __typename?: 'PromotionProductsType';
  barcode: BarcodeType;
  discount: DiscountDtoType;
};

export type PromotionProductsWithInternalProductType = {
  __typename?: 'PromotionProductsWithInternalProductType';
  barcode: BarcodeBaseRawType;
  discount: DiscountDtoType;
  internalProduct: InternalProductType;
};

export enum PromotionStatusEnum {
  DRAFT = 'DRAFT',
  EXPIRED = 'EXPIRED',
  ONGOING = 'ONGOING'
}

export type PromotionType = {
  __typename?: 'PromotionType';
  createdAt: Scalars['DateTime']['output'];
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  promotion: Array<PromotionProductsType>;
  startDate: Scalars['DateTime']['output'];
  status: PromotionStatusEnum;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type PromotionUpdateInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  promotion?: InputMaybe<Array<PromotionProductsInput>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<PromotionStatusEnum>;
};

export type PromotionWithInternalProductPaginateType = {
  __typename?: 'PromotionWithInternalProductPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PromotionWithInternalProductType>;
};

export type PromotionWithInternalProductType = {
  __typename?: 'PromotionWithInternalProductType';
  createdAt: Scalars['DateTime']['output'];
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  promotion: Array<PromotionProductsWithInternalProductType>;
  startDate: Scalars['DateTime']['output'];
  status: PromotionStatusEnum;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum ProvidersEnum {
  API = 'API',
  FIREBASE = 'FIREBASE'
}

export type PurchaseDeliveryNoteInput = {
  address?: InputMaybe<InvoicingAddressInput>;
  bank?: InputMaybe<Scalars['ID']['input']>;
  company: Scalars['ID']['input'];
  currency: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['DateTime']['input']>;
  details?: InputMaybe<Array<KeyValueInput>>;
  discount?: InputMaybe<DiscountDtoInput>;
  installments?: InputMaybe<Array<InstallmentInput>>;
  logistic?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<PurchaseDeliveryNoteOriginInput>;
  products: Array<InvoicingProductsBundleInput>;
  project?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<GenericInvoicingStatusEnum>;
  supplier?: InputMaybe<PurchaseSupplierInput>;
  target: TargetAciInput;
  taxes?: InputMaybe<Array<TaxRankInput>>;
  toPay?: InputMaybe<Scalars['Decimal']['input']>;
  totalPrice?: InputMaybe<TotalPriceInput>;
  totalReductions?: InputMaybe<Scalars['Decimal']['input']>;
  totalTax?: InputMaybe<Scalars['Decimal']['input']>;
  warehouse?: InputMaybe<Scalars['ID']['input']>;
};

export type PurchaseDeliveryNoteOriginInput = {
  order?: InputMaybe<Scalars['ID']['input']>;
  quotation?: InputMaybe<Scalars['ID']['input']>;
};

export type PurchaseDeliveryNoteOriginType = {
  __typename?: 'PurchaseDeliveryNoteOriginType';
  order?: Maybe<PurchaseOrderType>;
};

export type PurchaseDeliveryNotePaginateType = {
  __typename?: 'PurchaseDeliveryNotePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PurchaseDeliveryNoteType>;
};

export type PurchaseDeliveryNoteType = {
  __typename?: 'PurchaseDeliveryNoteType';
  address?: Maybe<InvoicingAddressType>;
  bank?: Maybe<BankDetailsType>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  currency: CurrencyType;
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<KeyValueType>>;
  id: Scalars['ID']['output'];
  installments?: Maybe<Array<InstallmentType>>;
  logistic?: Maybe<LogisticType>;
  note?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  origin?: Maybe<PurchaseDeliveryNoteOriginType>;
  products?: Maybe<Array<InvoicingProductsBundleType>>;
  project?: Maybe<ProjectType>;
  status?: Maybe<GenericInvoicingStatusEnum>;
  supplier?: Maybe<PurchaseSupplierType>;
  target: TargetType;
  taxes?: Maybe<Array<TaxRankType>>;
  toPay?: Maybe<Scalars['Decimal']['output']>;
  totalPrice?: Maybe<InvoicingPriceType>;
  totalTax?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  warehouse?: Maybe<WarehouseType>;
};

export type PurchaseIntegrationDocumentInput = {
  deliveryNote?: InputMaybe<PurchaseIntegrationDocumentPurchaseNoteInput>;
  inventory?: InputMaybe<PurchaseIntegrationDocumentPurchaseNoteInput>;
  invoice?: InputMaybe<PurchaseIntegrationDocumentPurchaseNoteInput>;
  order?: InputMaybe<PurchaseIntegrationDocumentPurchaseNoteInput>;
};

export type PurchaseIntegrationDocumentPurchaseNoteInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<DocumentReferenceModelEnum>;
};

export type PurchaseIntegrationDocumentPurchaseNoteType = {
  __typename?: 'PurchaseIntegrationDocumentPurchaseNoteType';
  note?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<DocumentReferenceModelEnum>;
};

export type PurchaseIntegrationDocumentType = {
  __typename?: 'PurchaseIntegrationDocumentType';
  deliveryNote?: Maybe<PurchaseIntegrationDocumentPurchaseNoteType>;
  inventory?: Maybe<PurchaseIntegrationDocumentPurchaseNoteType>;
  invoice?: Maybe<PurchaseIntegrationDocumentPurchaseNoteType>;
  order?: Maybe<PurchaseIntegrationDocumentPurchaseNoteType>;
};

export type PurchaseIntegrationInput = {
  document?: InputMaybe<PurchaseIntegrationDocumentInput>;
  multicurrency?: InputMaybe<WebsiteIntegrationMulticurrencyInput>;
  picture?: InputMaybe<PictureInput>;
  target?: InputMaybe<TargetAciInput>;
};

export type PurchaseIntegrationType = {
  __typename?: 'PurchaseIntegrationType';
  createdAt: Scalars['DateTime']['output'];
  document?: Maybe<PurchaseIntegrationDocumentType>;
  id: Scalars['ID']['output'];
  multicurrency?: Maybe<WebsiteIntegrationMulticurrencyType>;
  picture?: Maybe<PictureType>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type PurchaseInvoiceInput = {
  address?: InputMaybe<InvoicingAddressInput>;
  bank?: InputMaybe<Scalars['ID']['input']>;
  company: Scalars['ID']['input'];
  currency: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['DateTime']['input']>;
  details?: InputMaybe<Array<KeyValueInput>>;
  discount?: InputMaybe<DiscountDtoInput>;
  installments?: InputMaybe<Array<InstallmentInput>>;
  logistic?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<PurchaseInvoiceOriginInput>;
  products: Array<InvoicingProductsBundleInput>;
  project?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<GenericInvoicingStatusEnum>;
  supplier?: InputMaybe<PurchaseSupplierInput>;
  target: TargetAciInput;
  taxes?: InputMaybe<Array<TaxRankInput>>;
  toPay?: InputMaybe<Scalars['Decimal']['input']>;
  totalPrice?: InputMaybe<TotalPriceInput>;
  totalReductions?: InputMaybe<Scalars['Decimal']['input']>;
  totalTax?: InputMaybe<Scalars['Decimal']['input']>;
};

export type PurchaseInvoiceOriginInput = {
  order?: InputMaybe<Scalars['ID']['input']>;
  quotation?: InputMaybe<Scalars['ID']['input']>;
};

export type PurchaseInvoiceOriginType = {
  __typename?: 'PurchaseInvoiceOriginType';
  order?: Maybe<PurchaseOrderType>;
};

export type PurchaseInvoicePaginateType = {
  __typename?: 'PurchaseInvoicePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PurchaseInvoiceType>;
};

export type PurchaseInvoiceType = {
  __typename?: 'PurchaseInvoiceType';
  address?: Maybe<InvoicingAddressType>;
  bank?: Maybe<BankDetailsType>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  currency: CurrencyType;
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<KeyValueType>>;
  id: Scalars['ID']['output'];
  installments?: Maybe<Array<InstallmentType>>;
  logistic?: Maybe<LogisticType>;
  note?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  origin?: Maybe<PurchaseInvoiceOriginType>;
  products?: Maybe<Array<InvoicingProductsBundleType>>;
  project?: Maybe<ProjectType>;
  status?: Maybe<GenericInvoicingStatusEnum>;
  supplier?: Maybe<PurchaseSupplierType>;
  target: TargetType;
  taxes?: Maybe<Array<TaxRankType>>;
  toPay?: Maybe<Scalars['Decimal']['output']>;
  totalPrice?: Maybe<InvoicingPriceType>;
  totalTax?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PurchaseOrderConversionInput = {
  deliveryNote?: InputMaybe<Scalars['ID']['input']>;
  invoice?: InputMaybe<Scalars['ID']['input']>;
};

export type PurchaseOrderConversionType = {
  __typename?: 'PurchaseOrderConversionType';
  deliveryNote?: Maybe<PurchaseDeliveryNoteType>;
  invoice?: Maybe<PurchaseInvoiceType>;
};

export type PurchaseOrderInput = {
  address?: InputMaybe<InvoicingAddressInput>;
  bank?: InputMaybe<Scalars['ID']['input']>;
  company: Scalars['ID']['input'];
  conversion?: InputMaybe<PurchaseOrderConversionInput>;
  currency: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['DateTime']['input']>;
  details?: InputMaybe<Array<KeyValueInput>>;
  discount?: InputMaybe<DiscountDtoInput>;
  installments?: InputMaybe<Array<InstallmentInput>>;
  logistic?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<PurchaseOrderOriginInput>;
  products: Array<InvoicingProductsBundleInput>;
  project?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<GenericInvoicingStatusEnum>;
  supplier?: InputMaybe<PurchaseSupplierInput>;
  target: TargetAciInput;
  taxes?: InputMaybe<Array<TaxRankInput>>;
  toPay?: InputMaybe<Scalars['Decimal']['input']>;
  totalPrice?: InputMaybe<TotalPriceInput>;
  totalReductions?: InputMaybe<Scalars['Decimal']['input']>;
  totalTax?: InputMaybe<Scalars['Decimal']['input']>;
};

export type PurchaseOrderOriginInput = {
  quotation?: InputMaybe<Scalars['ID']['input']>;
};

export type PurchaseOrderPaginateType = {
  __typename?: 'PurchaseOrderPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PurchaseOrderType>;
};

export type PurchaseOrderType = {
  __typename?: 'PurchaseOrderType';
  address?: Maybe<InvoicingAddressType>;
  bank?: Maybe<BankDetailsType>;
  conversion?: Maybe<PurchaseOrderConversionType>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  currency: CurrencyType;
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<KeyValueType>>;
  id: Scalars['ID']['output'];
  installments?: Maybe<Array<InstallmentType>>;
  logistic?: Maybe<LogisticType>;
  note?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  products?: Maybe<Array<InvoicingProductsBundleType>>;
  project?: Maybe<ProjectType>;
  status?: Maybe<GenericInvoicingStatusEnum>;
  supplier?: Maybe<PurchaseSupplierType>;
  target: TargetType;
  taxes?: Maybe<Array<TaxRankType>>;
  toPay?: Maybe<Scalars['Decimal']['output']>;
  totalPrice?: Maybe<InvoicingPriceType>;
  totalTax?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum PurchaseStatusEnum {
  CANCELED = 'CANCELED',
  CONFIRMED = 'CONFIRMED',
  DELIVERED = 'DELIVERED',
  OPEN = 'OPEN'
}

export type PurchaseSupplierInput = {
  details?: InputMaybe<Array<KeyValueInput>>;
  supplier?: InputMaybe<Scalars['ID']['input']>;
};

export type PurchaseSupplierType = {
  __typename?: 'PurchaseSupplierType';
  details?: Maybe<Array<KeyValueType>>;
  supplier?: Maybe<CompanyType>;
};

export type PurchaseType = {
  __typename?: 'PurchaseType';
  attachments?: Maybe<Array<DocumentType>>;
  createdAt: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  installments: Array<InstallmentType>;
  notes?: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  status: PurchaseStatusEnum;
  supplier: SupplierType;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type PurchasesStatusesFinanceDashboardDataType = {
  __typename?: 'PurchasesStatusesFinanceDashboardDataType';
  ASSIGNED?: Maybe<Scalars['Decimal']['output']>;
  CANCELED?: Maybe<Scalars['Decimal']['output']>;
  CONFIRMED?: Maybe<Scalars['Decimal']['output']>;
  DELIVERED?: Maybe<Scalars['Decimal']['output']>;
  OPEN?: Maybe<Scalars['Decimal']['output']>;
  READY_FOR_PICKUP?: Maybe<Scalars['Decimal']['output']>;
};

export type PushAmountInput = {
  adhocTransactionCode?: InputMaybe<Scalars['String']['input']>;
  amount: Scalars['Decimal']['input'];
  card?: InputMaybe<Scalars['String']['input']>;
  deductAmount?: InputMaybe<Scalars['Decimal']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<MarketPlaceOrderControllerInput>;
  source: OnsiteConverterTypeEnum;
  target: TargetAciInput;
  transactionId?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type PushResponseWalletType = {
  __typename?: 'PushResponseWalletType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  coin?: Maybe<CoinSimpleType>;
  oldAmount?: Maybe<Scalars['Decimal']['output']>;
  walletType?: Maybe<WalletTypeEnum>;
};

export type Query = {
  __typename?: 'Query';
  ActivityLog: ActivityLogType;
  account: AccountType;
  accountByUserId: Array<AccountType>;
  activityType: ActivityTypeType;
  adhocTransaction: AdhocTransactionType;
  attribute: AttributeType;
  attributeValue: AttributeValueType;
  audience: AudienceType;
  audienceCriteria: AudienceCriteriaType;
  badge: BadgeType;
  barcode: BarcodeType;
  blog: BlogType;
  brand: BrandType;
  calculateQuestBudget: QuestBudgetType;
  calculateShoppingCart: CalculatedShoppingCartType;
  calculateTargetShoppingCart: TargetShoppingCartType;
  catalogueCategory: CatalogueCategoryType;
  catalogueCategoryCache: CatalogueCategoryType;
  cause: CauseType;
  challenge: ChallengeType;
  checkWalletAndReputation: CheckWalletAndReputationType;
  coin: CoinType;
  comment: CommentType;
  company: CompanyType;
  companyContact: CompanyContactType;
  corporateRating: CorporateRatingType;
  corporateRatingAssignment: CorporateRatingAssignmentType;
  corporateRatingDefinition: CorporateRatingDefinitionType;
  corporateUserCard: CorporateUserCardType;
  corporateUserCardByIdentifier: CorporateUserCardType;
  countUnseenCorporateNotificationsByTarget: UnseenCorporateNotificationCountType;
  countUnseenCorporateNotificationsByTargetWithLinkedAccounts: UnseenCorporateNotificationCountType;
  countUnseenCorporateNotificationsForUser: UnseenCorporateNotificationCountType;
  countUnseenMessages: UnseenMessagesCountType;
  countUnseenNotificationsByPOS: CountType;
  countUnseenNotificationsByUser: CountType;
  coupon: CouponType;
  createInvoicingPDFDocument: InvoicePdfType;
  createSnsTestMessage: SesSnsNotificationDto;
  currentAccount: Array<AccountType>;
  currentCorporateUser: CorporateUserType;
  currentUser: UserType;
  currentUserComplete: UserType;
  deleteFileFromAws: DeleteResponseDtoType;
  department: DepartmentType;
  emailIntegration: EmailIntegrationType;
  emailTemplate: CorporateEmailTemplateType;
  erpIntegration: ErpIntegrationType;
  eventLog: EventLogType;
  exportMarketPlaceOrdersWithFilter: DocumentResultType;
  exportMarketPlaceOrdersWithFilterByMail: MailResponseDto;
  exportMarketPlaceOrdersWithFilterCsv: DocumentResultType;
  exportResponsesByMail: MailResponseDto;
  favoriteInternalProduct: FavoriteInternalProductType;
  favoriteProduct: FavoriteProductType;
  fbCatalog: FbCatalogSyncType;
  fbPixel: FbPixelType;
  findAllCoinsWithoutCountry: CoinPaginateType;
  findAttributeByExternalIdAndTarget: AttributeType;
  findAttributeValueByExternalIdAndTarget: AttributeValueType;
  findBankById: BankType;
  findBankDetailsById: BankDetailsType;
  findBanksDetailsPagination: BankDetailsPaginatedType;
  findBanksPagination: BankPaginatedType;
  findBlogsByAuthor: Array<BlogType>;
  findBlogsByAuthorPaginated: PaginatedBlogsType;
  findBlogsByTarget: Array<BlogType>;
  findBlogsByTargetAndUrl: BlogType;
  findBlogsByTargetPaginated: PaginatedBlogsType;
  findBrandByExternalIdAndTarget: BrandType;
  findBrowserById: BrowserType;
  findBrowsersPagination: BrowserPaginatedType;
  findCatalogueCategoryByExternalIdAndTarget: CatalogueCategoryType;
  findContentTypeById: ContentTypeType;
  findContentTypeByName: ContentTypeType;
  findContentTypeByType: ContentTypeType;
  findContentTypesPagination: ContentTypePaginatedType;
  findCorporateEmailTemplateByName: CorporateEmailTemplateType;
  findCorporateTemplateByName: CorporateTemplateType;
  findCorporateTemplateByNameAndTarget: CorporateTemplateType;
  findCorporateTemplateByTarget: Array<CorporateTemplateType>;
  findCounteryById: CountryType;
  findCountriesPagination: CountryPaginatedType;
  findCouponByTargetAndCode: CouponType;
  findCouponSettingsByTarget: Array<CouponSettingsType>;
  findCouponsByTarget: Array<CouponType>;
  findCouponsByTargetWithFilterPaginated: PaginatedCouponType;
  findCurrenciesPagination: CurrencyPaginatedType;
  findCurrencyById: CurrencyType;
  findCurrentCorporateUserCards: Array<CorporateUserCardType>;
  findCurrentCorporateUserCardsByTarget: Array<CorporateUserCardType>;
  findDeliveryZonesByTarget: Array<DeliveryZonesType>;
  findDeliveryZonesByTargetCache: Array<DeliveryZonesType>;
  findDeviceTypeById: TechDeviceTypeType;
  findDeviceTypesPagination: TechDeviceTypePaginatedType;
  findDocumentById: DocumentType;
  findDocumentsByOwnerPagination: DocumentPaginatedType;
  findDocumentsPagination: DocumentPaginatedType;
  findEmailTemplateByName: EmailTemplateType;
  findFavoriteInternalProductByCurrentUser: InternalProductPaginateType;
  findFavoriteProductByCurrentUser: ProductPaginateType;
  findFontById: FontType;
  findGlobalCategoriesByProviderPagination: GlobalCategoryPaginatedType;
  findGlobalCategoriesPagination: GlobalCategoryPaginatedType;
  findGlobalCategoryById: GlobalCategoryType;
  findGlobalCategoryByProviderAndIdentifier: GlobalCategoryType;
  findInternalProductByExternalIdAndTarget: InternalProductType;
  findLabelsByCategoryAndTarget: Array<LabelType>;
  findLandingPagesByTarget: Array<LandingPagesType>;
  findLandingPagesByTargetAndTypeAndStatusPaginated: PaginatedLandingPagesType;
  findLandingPagesByTargetAndTypeAndStatusPaginatedCache: PaginatedLandingPagesType;
  findLandingPagesByTargetAndTypePaginated: PaginatedLandingPagesWithoutTranslationType;
  findLandingPagesByTargetPaginated: PaginatedLandingPagesType;
  findLandingPagesByUrl: LandingPagesType;
  findLanguageById: LanguageType;
  findLoyaltySettingsByTarget: LoyaltySettingsType;
  findLoyaltySettingsByTargetCache: LoyaltySettingsType;
  findLoyaltySettingsRedeemByTarget: LoyaltySettingsRedeemType;
  findMarketPlaceOrdersByUser: MarketPlaceOrderPaginateType;
  findModuleAssignmentsByOrigin: Array<ModulesAssignmentType>;
  findModuleAssignmentsforFrame: Array<ModulesAssignmentType>;
  findModuleDefinitionsByTarget: Array<ModulesDefinitionType>;
  findNonPredefinedQuestsByTarget: QuestPaginateType;
  findNotesByLabelAndTarget: Array<NotesType>;
  findOneByEAN: ProductType;
  findOperatingSystemById: OperatingSystemType;
  findOperatingSystemsPagination: OperatingSystemPaginatedType;
  findOrderSettingsByQuery: Array<OrderSettingsType>;
  findPOSNearbyPagination: PointOfSalePaginateType;
  findPOSNearbyWithFollowersPagination: PointOfSaleWithFollowShipStatusPaginateType;
  findPaymentById: PaymentType;
  findPayments: Array<PaymentType>;
  findPaymentsCache: Array<PaymentType>;
  findPaymentsPagination: PaymentPaginatedType;
  findPluginById: PluginType;
  findPluginByTargetAndPlugin: TargetPluginType;
  findPluginByURL: PluginType;
  findPluginsPagination: PluginPaginatedType;
  findPredefinedQuestsByTarget: QuestPaginateType;
  findPredefinedQuestsByTargetWithRepeatDate: Array<QuestWithRepeatDateType>;
  findProductClicksByOwnerPaginated: PaginatedProductClicksType;
  findProductClicksByProductPaginated: PaginatedProductClicksType;
  findProductClicksByTargetPaginated: PaginatedProductClicksType;
  findProductsToCompareByUserPaginate: InternalProductPaginateType;
  findQuestsByCategoryAndTarget: Array<QuestType>;
  findSEOByTarget: SeoType;
  findSEOByTargetCache: SeoType;
  findSEOByTargetPaginated: PaginatedSeoType;
  findShoppingCartByUser: ShoppingCartType;
  findShoppingCartByUserAndTarget: ShoppingCartType;
  findSlideByTargetAndReference: SlidesType;
  findSlideByTargetAndReferenceCache: SlidesType;
  findSlidesByTarget: Array<SlidesWithoutTranslationType>;
  findSlidesByTargetCache: Array<SlidesWithoutTranslationType>;
  findSlidesByTargetPaginated: PaginatedSlidesType;
  findSocialByCode: SocialType;
  findSocialById: SocialType;
  findSocialsPagination: SocialPaginatedType;
  findStateById: StateType;
  findStatesByCountryPagination: StatePaginatedType;
  findStatesPagination: StatePaginatedType;
  findSuppliersByTarget: Array<SupplierType>;
  findSuppliersByTargetPaginated: PaginatedSupplierType;
  findTargetOrders: MarketPlaceOrderPaginateType;
  findTargetOrdersByCurrentUser: MarketPlaceOrderPaginateType;
  findTargetPartnersAccelerateCount: CountType;
  findTargetPartnersReferralCount: CountType;
  findTargetPartnersWithAccelerateSettings: PartnershipNetworkWithAcceleratePaginateType;
  findTargetPartnersWithReferralSettings: PartnershipNetworkWithReferralPaginateType;
  findTargetShoppingCarts: ShoppingCartsForTargetPaginatedType;
  findTechDeviceBrandById: TechDeviceBrandType;
  findTechDeviceBrandsPagination: TechDeviceBrandPaginatedType;
  findTechDeviceById: TechDeviceType;
  findTechDevicesPagination: TechDevicePaginatedType;
  findVisualsByTarget: VisualsType;
  findVisualsByTargetCache: VisualsType;
  findVisualsByTargetPaginated: PaginatedVisualsType;
  findWarehousesByLocation: Array<WarehouseType>;
  findWarehousesByLocationPaginated: WarehousePaginateType;
  findfontsPagination: FontPaginatedType;
  findlanguagesPagination: LanguagePaginatedType;
  form: FormResponseType;
  freebie: FreebieType;
  freebietransaction: FreebieTransactionType;
  game: GameType;
  gameOrder: GameOrderType;
  generateCampaignInsights: GenerateInsightsType;
  generateCloudinarySignature: CloudinarySignatureType;
  generateJWTToken: JwtTokenType;
  generateLoyaltySettingsByAi: SetupLoyaltyLevelsAiType;
  generateS3SignedUrl: DeleteResponseDtoType;
  getAccelerationSettingsByTargetWithLinkedAccount: LoyaltySettingsAcceleratePaginateType;
  getAccounts: AccountPaginateType;
  getAccountsByTargetAndRoles: AccountPaginateType;
  getAccountsByTargetWithStatsPaginate: PaginatedAccountsWithStatsType;
  getActiveQuestsStats: ActiveQuestsStatsType;
  getActivityLogs: Array<ActivityLogType>;
  getActivityLogsPagination: ActivityLogPaginateType;
  getActivityTypes: Array<ActivityTypeType>;
  getActivityTypesPaginated: ActivityTypePaginateType;
  getAdhocTransactionsByTargetPaginated: AdhocTransactionPaginateType;
  getAllCorporateRatingAssignments: Array<CorporateRatingAssignmentType>;
  getAllCorporateRatingDefinitions: Array<CorporateRatingDefinitionType>;
  getAllCorporateRatings: Array<CorporateRatingType>;
  getAllInternalProducts: Array<InternalProductType>;
  getAllInternalProductsByTargetGroupedByClass: InternalProductByClassType;
  getAllInternalProductsByTargetGroupedByClassWithFavoriteStatus: InternalProductByClassTypeWithFavoriteStatus;
  getAllProductRatingDefinitions: Array<ProductRatingDefinitionType>;
  getAllProductRatings: Array<ProductRatingType>;
  getAnalyticsAudienceMetrics: AnalyticsAudienceMetricsType;
  getAnalyticsAudienceSessionsByCountry: Array<AnalyticsAudienceSessionsByCountryType>;
  getAnalyticsSessionsByCountries: Array<AnalyticsSessionsByCountriesType>;
  getAnalyticsStats: AnalyticsStatsType;
  getAnalyticsTopOperatingSystems: AnalyticsTopOperatingSystemsType;
  getAnalyticsTopPages: Array<AnalyticsTopPagesType>;
  getAnalyticsUserByCountry: AnalyticsUsersByCountryType;
  getAnalyticsUsersByDevice: AnalyticsUsersByDeviceType;
  getAppCorporateEmailsPaginated: CorporateEmailTemplatePaginateType;
  getApps: StringListType;
  getArchivedBoardCardsPaginated: BoardCardPaginateType;
  getArchivedMessageGroupsPagination: MessageGroupPaginateType;
  getAttributeValues: Array<AttributeValueType>;
  getAttributeValuesByAttribute: Array<AttributeValueType>;
  getAttributeValuesByAttributePaginated: AttributeValuePaginateType;
  getAttributeValuesByTarget: Array<AttributeValueType>;
  getAttributeValuesByTargetPaginated: AttributeValuePaginateType;
  getAttributeValuesPagination: AttributeValuePaginateType;
  getAttributes: Array<AttributeType>;
  getAttributesByTarget: Array<AttributeType>;
  getAttributesPagination: AttributePaginateType;
  getAttributesTargetPaginated: AttributePaginateType;
  getAudienceCriterias: Array<AudienceCriteriaType>;
  getAudienceCriteriasPaginated: AudienceCriteriaPaginateType;
  getAudienceReach: AudienceReachType;
  getAudienceUsersPaginated: CorporateUserPaginateType;
  getAudiences: Array<AudienceType>;
  getAudiencesByTargetPaginated: AudiencePaginateType;
  getAudiencesPaginated: AudiencePaginateType;
  getAuthEventLogsByTargetPaginated: EventLogPaginateType;
  getAverageCorporateProductRatingsByProduct: AverageRatingType;
  getAverageProductRatingsByProduct: AverageRatingType;
  getBadges: Array<BadgeType>;
  getBadgesByTargetPaginated: BadgePaginateType;
  getBadgesPaginated: BadgePaginateType;
  getBanks: Array<BankType>;
  getBarcodeByBarcodeAndTarget: BarcodeType;
  getBarcodeByProductAndAttributes: BarcodeType;
  getBarcodeByProductAndAttributesCache: BarcodeType;
  getBarcodeStats: BarcodeStatsType;
  getBarcodeWithProductAttributesAndStock: BarcodeWithStockType;
  getBarcodeWithStock: BarcodeWithStockType;
  getBarcodes: Array<BarcodeType>;
  getBarcodesByBarcodesAndTarget: Array<BarcodeType>;
  getBarcodesByTargetPaginated: BarcodePaginateType;
  getBarcodesByTargetWithInternalProductPaginated: BarcodePaginateType;
  getBarcodesPagination: BarcodePaginateType;
  getBarcodesWithFilter: BarcodePaginateType;
  getBarcodesWithVarietyAndStructureWithFilter: BarcodeWithPublicPricePaginateType;
  getBlogSEOJSON: ContentJsonType;
  getBlogs: Array<BlogType>;
  getBoard: BoardType;
  getBoardCard: BoardCardType;
  getBoardCards: Array<BoardCardType>;
  getBoardCardsByBoardList: Array<BoardCardType>;
  getBoardCardsByBoardWithFilterPaginated: BoardCardPaginateType;
  getBoardCardsByCRMBoardWithFilterPaginated: BoardCardPaginateType;
  getBoardCardsStatsWithFilter: BoardCardsStatsResponseType;
  getBoardList: BoardListType;
  getBoardListByBoard: Array<BoardListType>;
  getBoardLists: Array<BoardListType>;
  getBoardWithListsAndCards: BoardWithListsAndCardsType;
  getBoards: Array<BoardType>;
  getBoardsByMemberAndTarget: Array<BoardType>;
  getBoardsByMemberAndTargetPaginated: BoardPaginateType;
  getBoardsByTarget: Array<BoardType>;
  getBoardsByTargetPaginated: BoardPaginateType;
  getBrandColors: Array<KeyValueListType>;
  getBrands: Array<BrandType>;
  getBrandsByTarget: Array<BrandType>;
  getBrandsByTargetPaginated: BrandPaginateType;
  getBrandsPagination: BrandPaginateType;
  getBudgetStatsCharts: QuestBudgetStatsChartsReturnType;
  getByVersion: VersionType;
  getCRMBoard: BoardWithListsAndCardsType;
  getCRMBoardCardProceduresWithFilter: BoardCardProcedurePaginateType;
  getCampaignsStats: CampaignsStatsDashboardType;
  getCatalogueCategories: Array<CatalogueCategoryType>;
  getCatalogueCategoriesByLayerAndParent: Array<CatalogueCategoryType>;
  getCatalogueCategoriesByLayerAndParentCache: Array<CatalogueCategoryType>;
  getCatalogueCategoriesByLayerAndParentForPortal: Array<CatalogueCategoryType>;
  getCatalogueCategoriesByTargetAndUrlKey: CatalogueCategoryType;
  getCatalogueCategoriesByTargetForPortal: Array<CatalogueCategoryType>;
  getCatalogueCategoriesByTargetPaginated: CatalogueCategoryPaginateType;
  getCatalogueCategoriesByTargetWithChildren: Array<CatalogueCategoryWithChildrenType>;
  getCatalogueCategoriesByTargetWithChildrenCache: Array<CatalogueCategoryWithChildrenType>;
  getCatalogueCategoryPath: Array<CatalogueCategoryType>;
  getCatalogueTemplateByExcel: InvoicePdfType;
  getCauses: Array<CauseType>;
  getCausesByOrganizationPaginated: CausePaginateType;
  getCausesByTargetAndOrganizationPaginated: CausePaginateType;
  getCausesByTargetPaginated: CausePaginateType;
  getCausesPaginated: CausePaginateType;
  getChallengeLeaderboard: LeaderboardChallengePaginateType;
  getChallengeLeaderboardWithCurrentUser: LeaderboardChallengeWithCurrentUserPaginateType;
  getChallenges: Array<ChallengeType>;
  getChallengesByTargetAndCreatorPaginated: ChallengePaginateType;
  getChallengesByTargetPaginated: ChallengePaginateType;
  getChallengesByTargetWithDonationProgressPaginated: ChallengePaginateType;
  getChallengesPaginated: ChallengePaginateType;
  getChatContacts: StringListType;
  getClientIp: IpDtoType;
  getCoinOneByOwner: CoinType;
  getCoinsByCategoryPaginated: CoinPaginateType;
  getCoinsByCountryAndCategoryPaginated: CoinPaginateType;
  getCoinsByCountryPaginated: CoinPaginateType;
  getCoinsPagination: CoinPaginateType;
  getCollaborationAnalyticsStats: CollaborationAnalyticsStatsType;
  getCollaborationProjectsOverview: CollaborationAnalyticsProjectsOverviewType;
  getCollaborationProjectsStatus: CollaborationAnalyticsProjectsStatusType;
  getComingSoonQuestsByTargetAndUserAudiencePaginated: QuestPaginateType;
  getComingSoonQuestsByTargetAndUserAudienceWithLinkedAccountsPaginated: PaginatedQuestWithQualitativePictureType;
  getComments: Array<CommentType>;
  getCommentsByHolder: Array<CommentType>;
  getCommentsByHolderPaginated: CommentPaginateType;
  getCommentsReplies: CommentPaginateType;
  getCompanies: Array<CompanyType>;
  getCompaniesByTarget: CompanyPaginateType;
  getCompaniesPagination: CompanyPaginateType;
  getCompanyContacts: Array<CompanyContactType>;
  getCompanyContactsByCompany: Array<CompanyContactType>;
  getCompanyContactsByCompanyPaginated: CompanyContactPaginateType;
  getCompanyContactsByTargetPaginated: CompanyContactPaginateType;
  getContentTypes: Array<ContentTypeType>;
  getConversionsByAge: Array<ConversionByAgeType>;
  getConversionsByGender: Array<ConversionByGenderType>;
  getCorporateDashboardByTargetAndUser: Array<CorporateUserDashType>;
  getCorporateDashboardData: CorporateDashboardType;
  getCorporateEmailTemplate: Array<CorporateEmailTemplateType>;
  getCorporateEmailsByTargetPaginated: CorporateEmailTemplatePaginateType;
  getCorporateNotificationsById: CorporateNotificationType;
  getCorporateNotificationsByTargetPaginated: CorporateNotificationPaginateType;
  getCorporateNotificationsByUser: CorporateNotificationPaginateType;
  getCorporateNotificationsForUserPaginated: CorporateNotificationPaginateType;
  getCorporateNotificationsForUserWithLinkedAccountsPaginated: CorporateNotificationPaginateType;
  getCorporateRatingAssignmentByTarget: Array<CorporateRatingAssignmentType>;
  getCorporateRatingAssignmentByTargetCache: Array<CorporateRatingAssignmentType>;
  getCorporateRatingAssignments: CorporateRatingAssignmentPaginateType;
  getCorporateRatingDefinitionByReviewType: CorporateRatingDefinitionType;
  getCorporateRatingDefinitionByReviewTypeCache: CorporateRatingDefinitionType;
  getCorporateRatingDefinitions: CorporateRatingDefinitionPaginateType;
  getCorporateRatings: CorporateRatingPaginateType;
  getCorporateRatingsByProduct: CorporateRatingPaginateType;
  getCorporateRatingsByProductWithStats: CorporateRatingWithStatsPaginatedType;
  getCorporateRatingsBytarget: CorporateRatingPaginateType;
  getCorporateTargetDashboardData: CorporateTargetDashboardType;
  getCorporateTemplate: Array<CorporateTemplateType>;
  getCorporateUserAnalytics: GetCorporateUserAnalyticsType;
  getCorporateUserByDayInPeriodAnalytics: GetCorporateUserByDayInPeriodAnalyticsType;
  getCorporateUserCardByUserAndTarget: Array<CorporateUserCardType>;
  getCorporateUserCards: Array<CorporateUserCardType>;
  getCorporateUserCardsByTarget: Array<CorporateUserCardType>;
  getCorporateUserCardsByTargetPaginated: CorporateUserCardFullPaginatedType;
  getCorporateUserCardsByTargetWithReputationsPaginated: CorporateUserCardFullWithReputationPaginatedType;
  getCorporateUserCardsByUser: Array<CorporateUserCardType>;
  getCorporateUsersByTarget: Array<CorporateUserType>;
  getCorporateUsersByTargetAndWholesaler: Array<CorporateUserType>;
  getCorporateUsersDashboardData: CorporateUserDashboardType;
  getCorporateUsersRequestsAnalytics: GetCorporateUsersRequestsAnalyticsType;
  getCorporateUsersStats: GamificationGetCorporateUsersStatsDashboardType;
  getCorporateUsersTechnologiesDashboardData: GetCorporateUsersTechnologiesDashboardDataType;
  getCorporateWarehouseDashboardData: GetCorporateWarehouseDashboardDataType;
  getCountries: Array<CountryType>;
  getCouponSettings: CouponSettingsType;
  getCoupons: Array<CouponType>;
  getCouponsByCsv: InvoicePdfType;
  getCouponsByExcel: InvoicePdfType;
  getCrmAnalyticsBalanceOverview: CrmAnalyticsBalanceOverviewType;
  getCrmAnalyticsDealType: Array<CrmAnalyticsDealTypeType>;
  getCrmAnalyticsSalesForecast: CrmAnalyticsSalesForecastType;
  getCrmAnalyticsStats: CrmAnalyticsStatsInfoType;
  getCurrencies: Array<CurrencyType>;
  getCurrentDayRewards: GameRewardWithGameAndClosingDateType;
  getCurrentUserCorporateRatingsByProduct: CorporateRatingType;
  getCurrentUserCoupons: PaginatedCouponType;
  getCurrentUserDailyStats: CurrentUserDailyStatsType;
  getCurrentUserLastUnredeemedCoupon: CouponType;
  getCurrentUserLinkedCorporateAccountByTarget: LinkAccountType;
  getCurrentUserQualitativeWallet: WalletType;
  getCurrentUserQuantitativeWallets: WalletPaginateType;
  getCurrentUserRank: CurrentUserRankType;
  getCurrentUserReputationsLossDate: CurrentUserReputationsLossDateType;
  getCurrentUserReputationsTurnoverLossDate: CurrentUserReputationsTurnoverLossDateType;
  getCurrentUserWeeklyStats: CurrentUserWeeklyStatsType;
  getCurrentWeekRewards: GameRewardWithGameAndClosingDateType;
  getCustomers: CompanyPaginateType;
  getCustomersTemplateByExcel: InvoicePdfType;
  getDefaultAudiencesPaginated: DefaultAudiencePaginateType;
  getDefaultBadgesPaginated: BadgePaginateType;
  getDeliveryManByPos: AccountPaginateType;
  getDeliveryTargetOrders: MarketPlaceOrderPaginateType;
  getDeliveryZone: DeliveryZonesType;
  getDeliveryZones: Array<DeliveryZonesType>;
  getDepartments: Array<DepartmentType>;
  getDepartmentsByTarget: Array<DepartmentType>;
  getDirectMessageGroup: MessageGroupType;
  getDiscountTypes: StringListType;
  getDocuments: Array<DocumentType>;
  getDonationActivityTypesByTargetPaginated: ActivityTypePaginateType;
  getEcommerceAnalyticsStats: SalesAnalyticsStatsType;
  getEcommerceBestSellerProductsWithFilterPaginated: EcommerceAnalyticsBestSellerPaginatedType;
  getEcommerceEventLogsByTargetPaginated: EventLogPaginateType;
  getEcommerceFinanceDashboardData: GetEcommerceFinanceDashboardDataType;
  getEcommerceRevenueChartStats: SalesAnalyticsRevenueStatsType;
  getEcommerceSalesByLocation: SalesAnalyticsSalesByCountryType;
  getEcommerceTopCatalogueCategories: Array<SalesAnalyticsTopCatalogueCategoriesType>;
  getEmailIntegration: Array<EmailIntegrationType>;
  getEmailIntegrationByTarget: EmailIntegrationType;
  getEmailTemplate: Array<EmailTemplateType>;
  getEnabledPricesByCompany: Array<PriceType>;
  getEngagementProgressionOverTime: Array<GamificationEngagmentProgressionOverTimeDashboardType>;
  getEngagementProgressionStats: GamificationEngagmentProgressionStatsDashboardType;
  getEngagmentPointsEarnedPerActivity: Array<GamificationEngagmentPointsEarnedPerActivityDashboardType>;
  getEngagmentStats: GamificationEngagmentStatsDashboardType;
  getErpIntegration: Array<ErpIntegrationType>;
  getErpIntegrationByTarget: ErpIntegrationType;
  getEventByTargetAndCode: EventType;
  getEventInvitesWithFilter: Array<EventInviteType>;
  getEventInvitesWithFilterPaginated: EventInvitePaginateType;
  getEventLogs: Array<EventLogType>;
  getEventLogsByTargetPaginated: EventLogPaginateType;
  getEventLogsPaginated: EventLogPaginateType;
  getEventTicketByReference: EventTicketType;
  getEventTicketsWithFilter: Array<EventTicketType>;
  getEventTicketsWithFilterPaginated: EventTicketPaginateType;
  getEventsByTargetPagination: EventPaginateType;
  getEventsByUserPagination: EventPaginateType;
  getFBCatalogSync: Array<FbCatalogSyncType>;
  getFBCatalogSyncByTarget: FbCatalogSyncType;
  getFBPixel: Array<FbPixelType>;
  getFBPixelByTarget: FbPixelType;
  getFacebookPixelSourceForEvent: ContentType;
  getFavoriteInternalProduct: Array<FavoriteInternalProductType>;
  getFavoriteProduct: Array<FavoriteProductType>;
  getFavoriteSimpleProductByCurrentUser: InternalProductWithBarcodesWithPublicPricePaginateType;
  getFeaturedCorporates: Array<FeaturedCorporateType>;
  getFeaturedCorporatesByTarget: FeaturedCorporatePaginateType;
  getFlowsByTargetPagination: FlowPaginateType;
  getFlowsPagination: FlowPaginateType;
  getFonts: Array<FontType>;
  getFormResponses: QuestionSimplePaginateType;
  getForms: Array<FormResponseType>;
  getFormsPagination: FormPaginateType;
  getFormsWithFilters: FormPaginateType;
  getFreebie: Array<FreebieType>;
  getFreebieByTarget: FreebieType;
  getFreebieTransaction: Array<FreebieTransactionType>;
  getFreebieTransactionByByPartnershipNetwork: Array<FreebieTransactionType>;
  getFreebieTransactionByByPartnershipNetworkPast45Minutes: FreebieTransactionPaginateType;
  getFreebieTransactionByTarget: Array<FreebieTransactionType>;
  getFreebieTransactionByTargetCache: Array<FreebieTransactionType>;
  getFreebieTransactionByTargetPaginated: FreebieTransactionPaginateType;
  getFreebieTransactionByTargetPast45Minutes: FreebieTransactionPaginateType;
  getFullCatalogueByExcel: InvoicePdfType;
  getFuturePromotionsByTargetPagination: PromotionPaginateType;
  getGameByCode: GameType;
  getGameIntegrationByTarget: GameIntegrationType;
  getGameOrdersByTargetAndGamePaginated: GameOrderPaginateType;
  getGameRewardsWithFilter: GameRewardType;
  getGameWinners: Array<LeaderboardType>;
  getGames: Array<GameType>;
  getGamesPaginated: GamePaginateType;
  getGenders: StringListType;
  getGeneralSEO: ContentType;
  getGeneralSEOJSON: ContentJsonType;
  getGlobalPurchasesTaxesByCompany: Array<TaxType>;
  getGlobalSalesTaxesByCompany: Array<TaxType>;
  getGoogleAnalytics: Array<GoogleAnalyticsType>;
  getGoogleAnalyticsByTarget: GoogleAnalyticsType;
  getGoogleTagsSourceForEvent: ContentType;
  getGuidanceTypes: StringListType;
  getHelpdeskIntegration: Array<HelpdeskIntegrationType>;
  getHelpdeskIntegrationByTarget: HelpdeskIntegrationType;
  getImagesFromFolder: Array<CloudinaryResourceType>;
  getIntegrationIntegration: Array<IntegrationIntegrationType>;
  getIntegrationIntegrationByTarget: IntegrationIntegrationType;
  getInternalProduct: InternalProductType;
  getInternalProductBarcodes: Array<BarcodeType>;
  getInternalProductBarcodesPaginated: BarcodePaginateType;
  getInternalProductStats: BarcodeStatsType;
  getInternalProductWithFavoriteStatus: InternalProductWithFavoriteStatusType;
  getInternalProductWithFilter: InternalProductPaginateWithFilterType;
  getInternalProductWithStock: InternalProductWithStockType;
  getInternalProducts: InternalProductPaginateType;
  getInternalProductsByCatalogueCategory: InternalProductPaginateType;
  getInternalProductsByCatalogueCategoryForPortal: InternalProductPaginateType;
  getInternalProductsByCatalogueCategoryWithFavoriteStatus: InternalProductWithFavoriteStatusPaginateType;
  getInternalProductsByCategory: InternalProductPaginateType;
  getInternalProductsByClass: InternalProductPaginateType;
  getInternalProductsByProduct: InternalProductPaginateType;
  getInternalProductsByTargetAndCatalogueCategory: InternalProductPaginateType;
  getInternalProductsByTargetAndCatalogueCategoryUrlKey: InternalProductPaginateType;
  getInternalProductsByTargetAndCatalogueCategoryUrlKeyWithFavoriteStatus: InternalProductWithFavoriteStatusPaginateType;
  getInternalProductsWithRatingsWithFavoriteStatusWithFilter: InternalProductWithRatingsPaginateWithFavoriteStatusWithFilterType;
  getInternalProductsWithRatingsWithFilter: InternalProductWithRatingsPaginateWithFilterType;
  getInventoryCategories: Array<InventoryCategoryType>;
  getInventoryCategoriesByLayerandParent: Array<InventoryCategoryType>;
  getInventoryCategoriesByParent: Array<InventoryCategoryType>;
  getInventoryCategoriesPagination: InventoryCategoryPaginateType;
  getInventoryIntegration: Array<InventoryIntegrationType>;
  getInventoryIntegrationByTarget: InventoryIntegrationType;
  getInvoicingByExcel: InvoicePdfType;
  getInvoicingTemplateByExcel: InvoicePdfType;
  getJobApplications: Array<JobApplicationType>;
  getJobApplicationsByCsv: InvoicePdfType;
  getJobApplicationsByExcel: InvoicePdfType;
  getJobApplicationsByJobDefinition: JobApplicationPaginatedType;
  getJobApplicationsByTarget: Array<JobApplicationType>;
  getJobApplicationsByTargetAndStatusPagination: JobApplicationPaginatedType;
  getJobApplicationsByTargetPagination: JobApplicationBasePaginatedType;
  getJobApplicationsByTargetWithFilterPagination: JobApplicationBasePaginatedType;
  getJobDefinitions: Array<JobDefinitionType>;
  getJobDefinitionsByCsv: InvoicePdfType;
  getJobDefinitionsByExcel: InvoicePdfType;
  getJobDefinitionsByTarget: Array<JobDefinitionType>;
  getJobDefinitionsByTargetAndStatusPagination: JobDefinitionPaginatedType;
  getJobDefinitionsByTargetPagination: JobDefinitionPaginatedType;
  getKYCDashboard: GamificationDashboardKycType;
  getLabels: Array<LabelType>;
  getLabelsByTarget: Array<LabelType>;
  getLandingPages: Array<LandingPagesType>;
  getLandingPagesPaginated: PaginatedLandingPagesType;
  getLanguages: Array<LanguageType>;
  getLanguagesCache: Array<LanguageType>;
  getLastReferral: ReferralType;
  getLastVersion: VersionType;
  getLastVersionByPlatform: VersionType;
  getLastVersionByPlatformAndTarget: VersionType;
  getLastWidgetOutboundsByTarget: OutboundType;
  getLeaderboard: LeaderboardType;
  getLeaderboardByCyclePaginated: LeaderboardPaginatedType;
  getLeaderboardByDatesAndCyclePaginated: LeaderboardPaginatedType;
  getLinkedAccountsCorporateUserCardsByTarget: Array<CorporateUserCardWithExtrasType>;
  getLiveLeaderboardByCycleByExcel: InvoicePdfType;
  getLiveLeaderboardByCycleForCurrentUserPaginated: LeaderboardWithCycleNumbersAndClosingdateAndCurrentUserPaginatedType;
  getLiveLeaderboardByCyclePaginated: LeaderboardWithCycleNumbersAndClosingdatePaginatedType;
  getLiveTopGamesLeaderboardByCycle: TopLeaderboardsType;
  getLocations: Array<LocationType>;
  getLocationsByCompany: Array<LocationType>;
  getLocationsByCompanyPaginated: LocationPaginateType;
  getLogistics: Array<LogisticType>;
  getLogisticsIntegration: Array<LogisticsIntegrationType>;
  getLogisticsIntegrationByTarget: LogisticsIntegrationType;
  getLoyaltyProgramsPagination: LoyaltyProgramPaginateType;
  getMainCategorySEO: ContentType;
  getMainCategorySEOJSON: ContentJsonType;
  getMainDashboardStats: MainDashboardStatsType;
  getMainPageSEO: ContentType;
  getMainPageSEOJSON: ContentJsonType;
  getMaintenanceBoard: BoardWithListsAndCardsType;
  getManufacturersPagination: ManufacturerPaginateType;
  getMaritalStatuses: StringListType;
  getMarketPlaceOrders: Array<MarketPlaceOrderDtoType>;
  getMediaOfMessageGroupPagination: MessageMediaPaginateType;
  getMenuBadges: GetMenuBadgesType;
  getMessageGroup: MessageGroupType;
  getMessageGroupByMember: MessageGroupType;
  getMessageGroupMembers: UserPaginateType;
  getMessageGroupsPagination: MessageGroupPaginateType;
  getMessagesByMember: Array<MessageType>;
  getMessagesByMemberPaginated: MessagePaginateType;
  getMessagesByMessageGroupPagination: MessagePaginateType;
  getModuleAssignmentsByAssignee: Array<ModulesAssignmentType>;
  getModuleDefinitions: Array<ModulesDefinitionType>;
  getModulesAssignment: Array<ModulesAssignmentType>;
  getNewslettersByExcel: InvoicePdfType;
  getNonPredefinedActivityTypesPaginated: ActivityTypePaginateType;
  getNote: NotesType;
  getNotes: Array<NotesType>;
  getNotesByTarget: Array<NotesType>;
  getNotificationIntegration: Array<NotificationIntegrationType>;
  getNotificationIntegrationByTarget: NotificationIntegrationType;
  getOneInternalProductByBarcodeAndTarget: InternalProductType;
  getOngoingChallengesByTargetAndUserAudiencePaginated: ChallengePaginateType;
  getOngoingChallengesByTargetAndUserAudienceWithLinkedAccountsPaginated: PaginatedChallengesWithLinkedAccountsType;
  getOngoingPromotionsByTargetPagination: PromotionWithInternalProductPaginateType;
  getOpeningStatuses: StringListType;
  getOrderInstallment: InstallmentType;
  getOrderSettings: Array<OrderSettingsType>;
  getOrderSettingsByTarget: OrderSettingsFullType;
  getOrderSettingsByTargetCache: OrderSettingsFullType;
  getOrderStatuses: StringListType;
  getOrigins: Array<OriginType>;
  getOutboundsByTargetPagination: OutboundPaginateType;
  getOutboundsPagination: OutboundPaginateType;
  getPOSCategories: Array<PosCategoryType>;
  getPOSCategoriesPagination: PosCategoryPaginateType;
  getPOSServicesPagination: PosServicesPaginateType;
  getPOSWithFollowersPagination: PointOfSaleWithFollowShipStatusPaginateType;
  getPOSservices: Array<PosServicesType>;
  getPagesSEO: ContentType;
  getPagesSEOJSON: ContentJsonType;
  getPaginatedBlogs: PaginatedBlogsType;
  getPaginatedCoupons: PaginatedCouponType;
  getPaginatedProductClicks: PaginatedProductClicksType;
  getPaginatedSuppliers: PaginatedSupplierType;
  getPaginatedVisuals: PaginatedVisualsType;
  getPartnerReferrals: Array<PartnerReferralType>;
  getPartnerReferralsPagination: PartnerReferralPaginateType;
  getPartnershipNetworksById: PartnershipNetworkType;
  getPartnershipNetworksByPartnerAndPartnershipPagination: PartnershipNetworkPaginateType;
  getPartnershipNetworksByTargetAndPartnershipPagination: PartnershipNetworkWithLinkedAccountStatusPaginateType;
  getPartnershipNetworksByTargetAndPartnershipWithSettingsPagination: PartnershipNetworkWithLinkedAccountStatusAndSettingsPaginateType;
  getPartnershipNetworksByTargetPagination: PartnershipNetworkPaginateType;
  getPerformanceByMetric: PerformanceByMetricType;
  getPermission: Array<PermissionType>;
  getPermissionDefinition: Array<PermissionDefinitionType>;
  getPermissionsByTarget: Array<PermissionType>;
  getPointOfSalesAggregatorPagination: PointOfSalePaginateType;
  getPointOfSalesPagination: PointOfSalePaginateType;
  getPosTemplateByExcel: InvoicePdfType;
  getPosTransactions: ActivityLogPaginateType;
  getPredefinedActivityTypesByTargetPaginated: ActivityTypePaginateType;
  getPredefinedActivityTypesByTargetWithActiveStatusPaginated: ActivityTypeWithActiveStatusPaginateType;
  getPredefinedActivityTypesPaginated: ActivityTypePaginateType;
  getPredefinedPaginated: PredefinedPaginateType;
  getPriceTypes: StringListType;
  getPrices: Array<PriceType>;
  getPricesByCompanyPaginated: PricePaginateType;
  getPricesCalculations: InvoicingPricesCalculationType;
  getProductAttributes: Array<ProductAttributeType>;
  getProductAttributesByAttribute: Array<ProductAttributeType>;
  getProductAttributesByAttributeAndTarget: Array<ProductAttributeType>;
  getProductAttributesByTarget: Array<ProductAttributeType>;
  getProductAttributesByTargetPaginated: ProductAttributePaginateType;
  getProductAttributesCache: Array<ProductAttributeType>;
  getProductAttributesPagination: ProductAttributePaginateType;
  getProductBarcodes: Array<BarcodeType>;
  getProductBarcodesCache: Array<BarcodeType>;
  getProductClicks: Array<ProductClicksType>;
  getProductPurchasesTaxesByCompany: Array<TaxType>;
  getProductRatingDefinitionByReviewType: ProductRatingDefinitionType;
  getProductRatingDefinitions: ProductRatingDefinitionPaginateType;
  getProductRatings: ProductRatingPaginateType;
  getProductRatingsByProduct: ProductRatingPaginateType;
  getProductRatingsByProductWithStats: ProductRatingWithStatsPaginatedType;
  getProductSEO: ContentType;
  getProductSEOJSON: ContentJsonType;
  getProductSalesTaxesByCompany: Array<TaxType>;
  getProductWithClickCount: InternalProductWithStatsType;
  getProductWithFilter: ProductPaginateWithFilterType;
  getProducts: Array<ProductType>;
  getProductsByCategoryPagination: ProductPaginateType;
  getProductsByClass: ProductPaginateType;
  getProductsPagination: ProductPaginateType;
  getProductsWithClicksCountByOwnerPaginated: PaginatedInternalProductWithStatsType;
  getProfileCompletnessProgress: ProfileCompletnessProgressType;
  getProgramsByEventPagination: ProgramPaginateType;
  getProjects: Array<ProjectType>;
  getProjectsBoardCardsByTargetPaginated: BoardCardPaginateType;
  getProjectsByExcel: InvoicePdfType;
  getProjectsByTarget: Array<ProjectType>;
  getProjectsByTargetWithFilter: ProjectPaginateType;
  getProjectsTemplateByExcel: InvoicePdfType;
  getPromotions: Array<PromotionType>;
  getPromotionsByTarget: Array<PromotionType>;
  getPromotionsByTargetPagination: PromotionPaginateType;
  getPurchaseDeliveryNoteStatsWithFilter: SaleInvoicesStatsType;
  getPurchaseDeliveryNotes: Array<PurchaseDeliveryNoteType>;
  getPurchaseDeliveryNotesByTarget: Array<PurchaseDeliveryNoteType>;
  getPurchaseDeliveryNotesByTargetPaginated: PurchaseDeliveryNotePaginateType;
  getPurchaseIntegration: Array<PurchaseIntegrationType>;
  getPurchaseIntegrationByTarget: PurchaseIntegrationType;
  getPurchaseInvoices: Array<PurchaseInvoiceType>;
  getPurchaseInvoicesByTarget: Array<PurchaseInvoiceType>;
  getPurchaseInvoicesByTargetPaginated: PurchaseInvoicePaginateType;
  getPurchaseInvoicesStatsWithFilter: SaleInvoicesStatsType;
  getPurchaseOrderesByTarget: Array<PurchaseOrderType>;
  getPurchaseOrders: Array<PurchaseOrderType>;
  getPurchaseOrdersByTargetPaginated: PurchaseOrderPaginateType;
  getPurchaseOrdersStatsWithFilter: SaleOrdersStatsType;
  getQuestActionDefinitions: Array<QuestActionDefinitionType>;
  getQuestActionDefinitionsPaginated: QuestActionDefinitionPaginateType;
  getQuestActions: Array<QuestActionType>;
  getQuestActionsByQuestPaginated: QuestActionPaginateType;
  getQuestActionsPaginated: QuestActionPaginateType;
  getQuestActivities: Array<QuestActivityType>;
  getQuestActivitiesByQuest: Array<QuestActivityType>;
  getQuestActivitiesByQuestCache: Array<QuestActivityType>;
  getQuestActivitiesByQuestPaginated: QuestActivityPaginateType;
  getQuestActivitiesPaginated: QuestActivityPaginateType;
  getQuestByActivityType: QuestType;
  getQuestConversionStats: QuestConversionStatsSummedType;
  getQuestDashboardChartData: Array<GamificationEngagmentProgressionOverTimeDashboardType>;
  getQuestDashboardData: QuestDashboardType;
  getQuestKPIDashboardData: QuestKpiDashboardType;
  getQuestOverview: QuestOverviewType;
  getQuestPerformanceMetricsChartDashboardData: Array<GamificationEngagmentProgressionOverTimeDashboardType>;
  getQuestPerformanceMetricsStatsDashboardData: QuestPerformanceMetricsStatsDashboardType;
  getQuestPerformanceOverTimeChart: QuestPerformanceOverTimeChartType;
  getQuestReccurencyStatus: QuestRecurrencyStatusType;
  getQuestStatistics: QuestStatisticsType;
  getQuestTopAggregateDashboardData: QuestTopAggregateDashboardType;
  getQuestTypes: Array<QuestTypeType>;
  getQuestTypesByTargetAndAdvertiserPaginated: QuestTypePaginateType;
  getQuestTypesByTargetPaginated: QuestTypePaginateType;
  getQuestTypesPaginated: QuestTypePaginateType;
  getQuestTypesStatsDashboardData: QuestTypesStatsDashboardType;
  getQuestionResponses: GetQuestionResponsesPaginateType;
  getQuestions: Array<QuestionDtoType>;
  getQuestionsByChallengeStep: QuestionPaginateType;
  getQuestionsByForm: QuestionPaginateType;
  getQuestionsPagination: QuestionPaginateType;
  getQuestionsbyFormWithResponsesStatsPaginated: QuestionWithResponsesStatsPaginateType;
  getQuests: Array<QuestType>;
  getQuestsByTarget: Array<QuestType>;
  getQuestsByTargetAndCreatorPaginated: QuestPaginateType;
  getQuestsByTargetAndUserAudiencePaginated: QuestWithPerformedPaginateType;
  getQuestsByTargetAndUserAudienceWithLinkedAccountsPaginated: PaginatedQuestWithQualitativePictureType;
  getQuestsByTargetPaginated: QuestPaginateType;
  getQuotations: Array<QuotationType>;
  getQuotationsByTarget: Array<QuotationType>;
  getQuotationsByTargetPaginated: QuotationPaginateType;
  getQuotationsStatsWithFilter: QuotationsStatsType;
  getRecentlyViewedProductsByUserPaginated: RecentlyViewedInternalProductWithFavoriteStatusPaginateType;
  getReferralSettingsByTargetWithLinkedAccount: LoyaltySettingsReferralPaginateType;
  getReferralsByTargetPagination: ReferralPaginateType;
  getRental: RentalRefType;
  getRentals: Array<RentalRefType>;
  getRentalsInPeriod: Array<RentalType>;
  getRentalsInPeriodPaginated: RentalPaginateType;
  getReputations: Array<ReputationType>;
  getReputationsByTarget: Array<ReputationType>;
  getReputationsByTargetCache: Array<ReputationType>;
  getReputationsPagination: ReputationPaginateType;
  getRequest: RequestType;
  getRequests: Array<RequestType>;
  getRequestsByExcel: InvoicePdfType;
  getRequestsByPlatformAndTargetPaginated: VersionsPaginateType;
  getRequestsByTypeAndTargetPaginated: RequestPaginateType;
  getRequestsByTypePaginated: RequestPaginateType;
  getRequestsPaginated: RequestPaginateType;
  getResponses: Array<ResponseDtoType>;
  getResponsesPagination: ResponsePaginateType;
  getResponsesWithFilter: ResponsePaginateType;
  getRoles: StringListType;
  getSEO: SeoType;
  getSEOPaginated: PaginatedSeoType;
  getSEOs: Array<SeoType>;
  getSaleDeliveryNoteStatsWithFilter: SaleInvoicesStatsType;
  getSaleDeliveryNotes: Array<SaleDeliveryNoteType>;
  getSaleDeliveryNotesByTarget: Array<SaleDeliveryNoteType>;
  getSaleDeliveryNotesByTargetPaginated: SaleDeliveryNotePaginateType;
  getSaleInvoices: Array<SaleInvoiceType>;
  getSaleInvoicesByTarget: Array<SaleInvoiceType>;
  getSaleInvoicesByTargetPaginated: SaleInvoicePaginateType;
  getSaleInvoicesStatsWithFilter: SaleInvoicesStatsType;
  getSaleIssueNotes: Array<SaleIssueNoteType>;
  getSaleIssueNotesByTarget: Array<SaleIssueNoteType>;
  getSaleIssueNotesByTargetPaginated: SaleIssueNotePaginateType;
  getSaleIssueNotesStatsWithFilter: SaleIssueNoteStatsType;
  getSaleOrderesByTarget: Array<SaleOrderType>;
  getSaleOrders: Array<SaleOrderType>;
  getSaleOrdersByTargetPaginated: SaleOrderPaginateType;
  getSaleOrdersStatsWithFilter: SaleOrdersStatsType;
  getSalesAnalyticsStats: SalesAnalyticsStatsType;
  getSalesByLocation: SalesAnalyticsSalesByCountryType;
  getSalesIntegration: Array<SalesIntegrationType>;
  getSalesIntegrationByTarget: SalesIntegrationType;
  getSalesOrdersBestSellerProductsWithFilterPaginated: EcommerceAnalyticsBestSellerPaginatedType;
  getSalesRevenueChartStats: SalesAnalyticsRevenueStatsType;
  getSalesTopCatalogueCategories: Array<SalesAnalyticsTopCatalogueCategoriesType>;
  getServiceProduct: InternalProductType;
  getServicesCatalogueTemplateByExcel: InvoicePdfType;
  getSesStats: AmazonSesResponseDtoType;
  getShortcutsByUserAndTargetPagination: ShortcutPaginateType;
  getShortcutsByUserPagination: ShortcutPaginateType;
  getSimpleBarcodeByBarcodeAndTarget: BarcodeType;
  getSimpleBarcodesByBarcodesAndTarget: Array<BarcodeType>;
  getSimpleCatalogueByCsv: InvoicePdfType;
  getSimpleCatalogueByExcel: InvoicePdfType;
  getSimpleOngoingPromotionsByTargetPaginate: PromotionPaginateType;
  getSimpleProductSEOJSON: ContentJsonType;
  getSimpleProductWithFavoriteStatus: InternalProductWithFavoriteStatusType;
  getSimpleProductWithFavoriteStatusByUrlKey: InternalProductWithFavoriteStatusType;
  getSimpleProductWithFilter: InternalProductPaginateWithFilterType;
  getSimpleProductWithProductAttributesAndFavoriteStatus: InternalProductWithFavoriteStatusType;
  getSimpleProductWithProductAttributesAndFavoriteStatusByUrlKey: InternalProductWithFavoriteStatusType;
  getSimpleProductsByCatalogueCategoryWithFavoriteStatus: InternalProductWithFavoriteStatusPaginateType;
  getSimpleProductsByTargetAndCatalogueCategoryUrlKeyWithFavoriteStatus: InternalProductWithFavoriteStatusPaginateType;
  getSimpleProductsByTargetAndCatalogueCategoryUrlKeyWithProductAttributesAndFavoriteStatus: InternalProductWithFavoriteStatusPaginateType;
  getSimpleProductsByTargetGroupedByClassWithFavoriteStatus: InternalProductByClassTypeWithFavoriteStatus;
  getSimpleProductsByTargetGroupedByClassWithProductAttributesAndFavoriteStatus: InternalProductByClassTypeWithFavoriteStatus;
  getSimpleProductsForPartnerhipNetworkAsGiftsForCurrentUser: InternalProductWithTargetPictureAndFilterAndPriceInCoinsTypePaginationType;
  getSimpleProductsForPartnerhipNetworkWithRatingsAndFavoriteStatusAndRemunerationsAndFilter: SimpleProductsForPartnerhipNetworkWithRatingsAndFavoriteStatusAndRemunerationsAndFilterPaginationType;
  getSimpleProductsForPartnerhipNetworkWithRatingsWithFavoriteStatusWithFilter: InternalProductForPartnershipNetworkWithTargetPictureAndRatingsPaginateWithFavoriteStatusWithFilterType;
  getSimpleProductsWithRatingsWithFavoriteStatus: InternalProductWithRatingsPaginateWithFavoriteStatusType;
  getSimpleProductsWithRatingsWithFavoriteStatusWithFilter: InternalProductWithRatingsPaginateWithFavoriteStatusWithFilterType;
  getSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatus: InternalProductWithRatingsPaginateWithFavoriteStatusType;
  getSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusWithFilter: InternalProductWithRatingsPaginateWithFavoriteStatusWithFilterType;
  getSimpleServicesWithFilter: BarcodesPaginatedWithFilterType;
  getSlides: Array<SlidesType>;
  getSlidesPaginated: PaginatedSlidesType;
  getSmsIntegration: Array<SmsIntegrationType>;
  getSmsIntegrationByTarget: SmsIntegrationType;
  getSocialMedias: StringListType;
  getSpecialOffersTypes: StringListType;
  getStates: Array<StateType>;
  getStaticData: Array<StaticDataType>;
  getStaticDataByKey: StaticDataType;
  getStaticTranslationsByTargetAndLanguage: Array<StaticTranslationSimpleType>;
  getStaticTranslationsByTargetAndLanguageCache: Array<StaticTranslationSimpleType>;
  getStaticTranslationsByTargetAndLanguagePaginated: StaticTranslationSimplePaginateType;
  getStaticTranslationsByTargetPaginated: StaticTranslationPaginateType;
  getStock: StockType;
  getStockByTargetAndBarcode: StockType;
  getStockByTargetAndBarcodeCache: StockType;
  getStocks: Array<StockType>;
  getStocksByTarget: StockPaginateType;
  getStocksByTargetInAllWarehouses: BarcodeWithStockDataPaginatedType;
  getStories: Array<StoriesType>;
  getStoriesByTarget: StoriesPaginatedType;
  getStoriesViewsStatus: Array<StoriesViewsStatusType>;
  getStory: Array<StoriesType>;
  getSubCategorySEO: ContentType;
  getSubCategorySEOJSON: ContentJsonType;
  getSubscribersToNewsletter: Array<NewsletterType>;
  getSubscribersToNewsletterPaginated: PaginatedNewslettersType;
  getSuppliers: Array<SupplierType>;
  getSuppliersStats: SupplliersDashboardType;
  getSuppliersTemplateByExcel: InvoicePdfType;
  getTargetFreebiesWallet: WalletType;
  getTargetFundsWallet: WalletType;
  getTargetOrderInvoice: InvoicePdfType;
  getTargetOrdersByExcel: InvoicePdfType;
  getTargetPlugins: Array<TargetPluginType>;
  getTargetPluginsByTarget: Array<TargetPluginType>;
  getTargetStats: TargetStatsType;
  getTargetSubscribersByCsv: InvoicePdfType;
  getTargetSubscribersByExcel: InvoicePdfType;
  getTargetSubscribersPagination: SubscribersWithReputationsPaginateType;
  getTargetTransactions: ActivityLogPaginateType;
  getTargetTransactionsByExcel: InvoicePdfType;
  getTargetUserCardsByCsv: InvoicePdfType;
  getTargetUserCardsByExcel: InvoicePdfType;
  getTargetUsersByCsv: InvoicePdfType;
  getTargetUsersByExcel: InvoicePdfType;
  getTargetUsersWithWallets: SimpleUserWithWalletsPaginateType;
  getTargetWallets: Array<WalletType>;
  getTask: TaskType;
  getTaskSection: TaskSectionType;
  getTaskSections: Array<TaskSectionType>;
  getTaskSectionsByTargetPaginated: TaskSectionPaginatedType;
  getTaskSectionsWithTasks: Array<TaskSectionWithTasksType>;
  getTasks: Array<TaskType>;
  getTasksBySection: Array<TaskType>;
  getTaxes: Array<TaxType>;
  getTaxesByCompany: Array<TaxType>;
  getTaxesByCompanyPaginated: TaxPaginateType;
  getTickets: Array<TicketType>;
  getTicketsByExcel: InvoicePdfType;
  getTicketsByTarget: Array<TicketType>;
  getTicketsByTargetWithFilter: TicketsPaginateType;
  getTicketsStatsWithFilter: TicketStatsType;
  getTimeTracks: Array<TimeTrackType>;
  getTimeTracksByHolder: Array<TimeTrackType>;
  getTimeTracksByHolderPaginated: TimeTrackPaginateType;
  getTopActivitiesDeductingPoints: Array<GamificationEngagmentPointsEarnedPerActivityDashboardType>;
  getTopPerformingQuests: GamificationTopPerformingQuestsDashboardType;
  getUpcomingChallengesByTargetAndUserAudiencePaginated: ChallengePaginateType;
  getUpcomingChallengesByTargetAndUserAudienceWithLinkedAccountsPaginated: PaginatedChallengesWithLinkedAccountsType;
  getUserDistributionsByLevel: Array<GamificationUserDistributionsByLevelDashboardType>;
  getUserDistributionsByState: GamificationUserDistributionsByStateDashboardType;
  getUserSubscribedTargets: Array<TargetType>;
  getUserWalletTransactionsStatsByAffected: TotalType;
  getUserWalletWithReputations: WalletWithReputationDtoType;
  getUsers: Array<UserType>;
  getUsersByPermissionPaginated: UserPaginateType;
  getUsersCumulativeCount: DateValueChartType;
  getUsersMissingFields: GamificationUsersMissingFieldsDashboardType;
  getUsersNonCumulativeCount: DateValueChartType;
  getUsersPaginated: UserPaginateType;
  getUsersPagination: UserPaginateType;
  getUsersProfilesCompletnessByStage: GamificationUsersProfilesCompletnessByStageDashboardType;
  getVapidKey: VapidKeyType;
  getVersion: VersionType;
  getVersions: Array<VersionType>;
  getVersionsPaginated: VersionsPaginateType;
  getVersionsWithFilterPaginated: VersionsPaginateType;
  getVisuals: Array<VisualsType>;
  getWaitersByPoss: AccountPaginateType;
  getWalletByOwnerWithReputations: WalletWithCurrentAndNextReputationType;
  getWalletTopupsByTargetPaginated: WalletTopupPaginateType;
  getWalletTopupsPagination: WalletTopupPaginateType;
  getWalletTopupsSettingsByTarget: WalletTopupSettingsType;
  getWalletTopupsSettingsByTargetPaginated: WalletTopupSettingsPaginateType;
  getWalletTopupsSettingsPagination: WalletTopupSettingsPaginateType;
  getWalletTopupsValue: WalletTopupCurrencyType;
  getWalletTransactionsByAffectedPaginated: WalletTransactionPaginateType;
  getWalletTransactionsByAffectedPaginatedByCsv: InvoicePdfType;
  getWalletTransactionsByAffectedPaginatedByExcel: InvoicePdfType;
  getWalletTransactionsPagination: WalletTransactionPaginateType;
  getWalletTransactionsStatsByAffected: WalletTransactionsStatsType;
  getWalletTransactionsStatsChartWithFilter: WalletDateValueChartType;
  getWalletsPagination: WalletPaginateType;
  getWarehouses: Array<WarehouseType>;
  getWarehousesByCompany: Array<WarehouseType>;
  getWarehousesByCompanyPaginated: WarehousePaginateType;
  getWebsiteIntegration: Array<WebsiteIntegrationType>;
  getWebsiteIntegrationByTarget: WebsiteIntegrationType;
  getWebsiteIntegrationByTargetCache: WebsiteIntegrationType;
  getWholesalers: Array<WholesalerType>;
  getWholesalersPagination: WholesalerPaginateType;
  getWidgetData: WidgetDataType;
  getWidgetForTarget: GetWidgetForTargetType;
  getWidgetGuestUserForTarget: GetWidgetGuestUserForTargetType;
  getWidgetIntegration: Array<WidgetIntegrationType>;
  getWidgetIntegrationByTarget: WidgetIntegrationType;
  getWidgetIntegrationByTargetCache: WidgetIntegrationType;
  getWidgetUserForTarget: GetWidgetUserForTargetType;
  getWidgetVisuals: Array<WidgetVisualsType>;
  getWidgetVisualsByTargetAndAppCache: Array<WidgetVisualsType>;
  getWidgetVisualsByTargetAndAppPaginated: WidgetVisualsPaginateType;
  getWidgetVisualsByTargetAndAppPaginatedCache: WidgetVisualsPaginateType;
  googleAnalytics: GoogleAnalyticsType;
  helpdeskIntegration: HelpdeskIntegrationType;
  integrationIntegration: IntegrationIntegrationType;
  inventoryCategory: InventoryCategoryType;
  inventoryIntegration: InventoryIntegrationType;
  isCouponValid: IsCouponValidType;
  isCurrentUserLinkedToAggregator: IsLinkedAccountType;
  isEmailExist: UserExistType;
  isFavoriteInternalProduct: IsFavoriteInternalProductType;
  isFavoriteProduct: IsFavoriteProductType;
  isFreebiesRedeemable: SuccessResponseDtoType;
  isLoggedIn: IsLoggedInType;
  isLoginExist: UserExistType;
  isLoginForTargetExist: CorporateUserExistType;
  isUserNearPOS: IsUserNearPosDtoType;
  isUserSubscribedToTarget: IsUserSubscribedToTargetType;
  jobApplication: JobApplicationType;
  jobDefinition: JobDefinitionType;
  label: LabelType;
  landingPage: LandingPagesType;
  location: LocationType;
  login: LoginType;
  loginForApp: LoginType;
  loginForTarget: LoginType;
  loginWithApple: LoginType;
  loginWithAppleForTarget: LoginType;
  loginWithFacebook: LoginType;
  loginWithFacebookForTarget: LoginType;
  loginWithGoogle: LoginType;
  loginWithGoogleForTarget: LoginType;
  logistic: LogisticType;
  logisticsIntegration: LogisticsIntegrationType;
  logoutUserByTarget: SuccessResponseDtoType;
  logoutUserForTarget: SuccessResponseDtoType;
  loyaltyProgram: LoyaltyProgramType;
  manufacturer: ManufacturerType;
  moduleAssignment: ModulesAssignmentType;
  moduleDefinition: ModulesDefinitionType;
  notificationIntegration: NotificationIntegrationType;
  orderSettings: OrderSettingsType;
  outbound: OutboundType;
  partnerReferral: PartnerReferralType;
  permission: PermissionType;
  permissionDefinition: PermissionDefinitionType;
  pointOfSale: PointOfSaleType;
  pointOfSaleByOrigin: PointOfSaleType;
  pointOfSaleCache: PointOfSaleType;
  posCategory: PosCategoryType;
  posServices: PosServicesType;
  predefined: PredefinedType;
  price: PriceType;
  product: ProductType;
  productAttribute: ProductAttributeType;
  productRating: ProductRatingType;
  productRatingDefinition: ProductRatingDefinitionType;
  productclicks: ProductClicksType;
  project: ProjectType;
  promotion: PromotionType;
  purchaseIntegration: PurchaseIntegrationType;
  purchaseInvoice: PurchaseInvoiceType;
  purchaseOrder: PurchaseOrderType;
  purchasedeliverynote: PurchaseDeliveryNoteType;
  pushRechargeToUser: DeleteResponseDtoType;
  pushRunpayRechargeToUser: DeleteResponseDtoType;
  quantitativeWalletsByOwnerPagination: WalletPaginateType;
  quest: QuestType;
  questActionDefinition: QuestActionDefinitionType;
  questActivity: QuestActivityType;
  questType: QuestTypeType;
  question: QuestionDtoType;
  quotation: QuotationType;
  referral: ReferralType;
  refreshAudienceViews: AudienceReachType;
  reputation: ReputationType;
  response: ResponseDtoType;
  saleInvoice: SaleInvoiceType;
  saleIssueNote: SaleIssueNoteType;
  saleOrder: SaleOrderType;
  saledeliverynote: SaleDeliveryNoteType;
  salesIntegration: SalesIntegrationType;
  searchAccount: AccountPaginateType;
  searchAttribute: AttributePaginateType;
  searchAttributeByTarget: AttributePaginateType;
  searchAttributeValue: AttributeValuePaginateType;
  searchAttributeValueByTarget: AttributeValuePaginateType;
  searchBarcodesByTarget: BarcodePaginateType;
  searchBarcodesByTargetAndSupplier: BarcodePaginateType;
  searchBarcodesByTargetWithStock: BarcodeWithStockPaginatedType;
  searchBlogs: PaginatedBlogsType;
  searchBrand: BrandPaginateType;
  searchCatalogueCategories: CatalogueCategoryPaginateType;
  searchCompany: CompanyPaginateType;
  searchCorporateUsersByTarget: CorporateUserPaginateType;
  searchCustomersByTargetAndPhase: CompanyPaginateType;
  searchDepartmentsByTarget: DepartmentPaginatedType;
  searchFavoriteInternalProduct: InternalProductPaginateType;
  searchFavoriteProduct: ProductPaginateType;
  searchForms: FormPaginateType;
  searchInternalMessageGroup: MessageGroupPaginateType;
  searchInternalProduct: InternalProductPaginateType;
  searchInternalProductByCatalogueCategory: InternalProductPaginateType;
  searchInternalProductByTarget: InternalProductPaginateType;
  searchInventoryCategory: InventoryCategoryPaginateType;
  searchJobDefinitionsByTarget: JobDefinitionPaginatedType;
  searchLandingPages: PaginatedLandingPagesType;
  searchLogisticCompaniesByTarget: CompanyPaginateType;
  searchLoyaltyProgram: LoyaltyProgramPaginateType;
  searchManufacturer: ManufacturerPaginateType;
  searchMessageByMessageGroupPagination: MessagePaginateType;
  searchMessageGroup: MessageGroupPaginateType;
  searchPOSNearbyPagination: PointOfSalePaginateType;
  searchPos: PointOfSalePaginateType;
  searchPosCategory: PosCategoryPaginateType;
  searchPosServices: PosServicesPaginateType;
  searchProduct: ProductPaginateType;
  searchProductAttribute: ProductAttributePaginateType;
  searchProductAttributeByTarget: ProductAttributePaginateType;
  searchQuestTypesByTargetWithFilterPaginated: QuestTypePaginateType;
  searchResponse: ResponsePaginateType;
  searchSimpleBarcodesByTargetWithStock: BarcodeWithStockPaginatedType;
  searchSimpleEquipments: InternalProductPaginateWithFilterType;
  searchSimpleServices: BarcodePaginateType;
  searchSimpleStocksByTarget: StockPaginateType;
  searchSlides: PaginatedSlidesType;
  searchStocksByTarget: StockPaginateType;
  searchSupplierPaginated: PaginatedSupplierType;
  searchSuppliersByTarget: CompanyPaginateType;
  searchSupportMessageGroup: MessageGroupPaginateType;
  searchTargetQualitativeWallets: WalletPaginateType;
  searchTargetSubscribers: SubscribersWithReputationsPaginateType;
  searchUser: UserPaginateType;
  searchUserTargetSubscriptions: TargetPaginateType;
  searchWholesaler: WholesalerPaginateType;
  sendAdhocCorporateNotificationTest: AdhocCorporateNotificationTestType;
  sendAdhocNotificationTest: AdhocNotificationTestType;
  sendCatalogueTemplateBymail: MailResponseDto;
  sendCorporateEmail: MailResponseDto;
  sendCouponsBymail: MailResponseDto;
  sendEmail: MailResponseDto;
  sendEmailSes: DeleteResponseDtoType;
  sendEventTicketEmail: SuccessResponseDtoType;
  sendFullCatalogueBymail: MailResponseDto;
  sendInvoicingBymail: MailResponseDto;
  sendInvoicingPDFDocumentByEmail: MailResponseDto;
  sendInvoicingTemplateBymail: MailResponseDto;
  sendJobApplicationsByMail: MailResponseDto;
  sendJobDefinitionsBymail: MailResponseDto;
  sendLiveLeaderboardByCycleBymail: MailResponseDto;
  sendNewslettersBymail: MailResponseDto;
  sendNotification: SuccessResponseDtoType;
  sendOrderByEmailAndSms: SuccessResponseDtoType;
  sendPosTemplateBymail: MailResponseDto;
  sendProjectsBymail: MailResponseDto;
  sendProjectsTemplateBymail: MailResponseDto;
  sendQualitativeWalletsBymail: MailResponseDto;
  sendRequestsBymail: MailResponseDto;
  sendServicesCatalogueTemplateBymail: MailResponseDto;
  sendSimpleCatalogueByMail: MailResponseDto;
  sendSms: SmsIntegrationResponseType;
  sendTargetOrdersBymail: MailResponseDto;
  sendTargetSubscribersBymail: MailResponseDto;
  sendTargetTransactionsBymail: MailResponseDto;
  sendTargetUserCardsBymail: MailResponseDto;
  sendTargetUsersBymail: MailResponseDto;
  sendThemAndLanguageToWidget: SuccessResponseDtoType;
  sendTicketsBymail: MailResponseDto;
  sendUserAdhocNotification: AdhocNotificationTestType;
  shoppingCart: ShoppingCartType;
  slide: SlidesType;
  smsIntegration: SmsIntegrationType;
  staticTranslation: StaticTranslationType;
  supplier: SupplierType;
  targetHasStaticTranslationsReference: StaticTranslationReferenceCheckType;
  targetPlugin: TargetPluginType;
  tax: TaxType;
  template: CorporateTemplateType;
  ticket: TicketType;
  timetrack: TimeTrackType;
  uploadImage: PictureType;
  user: UserType;
  userByEmail: UserType;
  validateCatalogueByExcel: CatalogueImportValidationType;
  validateRegisterPhoneNumber: SmsLogType;
  validateShoppingCartByCurrentUser: Array<ValidatedCartProductType>;
  validateSmsCode: SuccessResponseDtoType;
  verifyApiSettings: SuccessResponseDtoType;
  visuals: VisualsType;
  wallet: WalletType;
  walletOwnerHasEnoughBalance: WalletOwnerHasEnoughBalanceType;
  walletTopup: WalletTopupType;
  walletTopupSettings: WalletTopupSettingsType;
  walletTransaction: WalletTransactionType;
  walletsByOwner: Array<WalletType>;
  walletsByOwnerPagination: WalletPaginateType;
  warehouse: WarehouseType;
  websiteIntegration: WebsiteIntegrationType;
  wholesaler: WholesalerType;
  widgetIntegration: WidgetIntegrationType;
  widgetVisuals: WidgetVisualsType;
};


export type QueryActivityLogArgs = {
  id: Scalars['String']['input'];
};


export type QueryAccountArgs = {
  id: Scalars['String']['input'];
};


export type QueryAccountByUserIdArgs = {
  userId: Scalars['String']['input'];
};


export type QueryActivityTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdhocTransactionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAttributeArgs = {
  id: Scalars['String']['input'];
};


export type QueryAttributeValueArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAudienceArgs = {
  id: Scalars['String']['input'];
};


export type QueryAudienceCriteriaArgs = {
  id: Scalars['String']['input'];
};


export type QueryBadgeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBarcodeArgs = {
  id: Scalars['String']['input'];
};


export type QueryBlogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBrandArgs = {
  id: Scalars['String']['input'];
};


export type QueryCalculateQuestBudgetArgs = {
  maxAnswers: Scalars['Int']['input'];
  quest?: InputMaybe<Scalars['ID']['input']>;
  remunerationAmount?: InputMaybe<Scalars['String']['input']>;
  wallet?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCalculateShoppingCartArgs = {
  products: Array<CartProductInput>;
};


export type QueryCalculateTargetShoppingCartArgs = {
  input: CalculateTargetShoppingCartInput;
};


export type QueryCatalogueCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCatalogueCategoryCacheArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCauseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChallengeArgs = {
  id: Scalars['String']['input'];
};


export type QueryCheckWalletAndReputationArgs = {
  input: QuestActionCheckInput;
};


export type QueryCoinArgs = {
  id: Scalars['String']['input'];
};


export type QueryCommentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyContactArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCorporateRatingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCorporateRatingAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCorporateRatingDefinitionArgs = {
  id: Scalars['String']['input'];
};


export type QueryCorporateUserCardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCorporateUserCardByIdentifierArgs = {
  identifier: Scalars['String']['input'];
};


export type QueryCountUnseenCorporateNotificationsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryCountUnseenCorporateNotificationsByTargetWithLinkedAccountsArgs = {
  target: TargetAciInput;
};


export type QueryCountUnseenCorporateNotificationsForUserArgs = {
  target: TargetAciInput;
};


export type QueryCountUnseenNotificationsByPosArgs = {
  posId: Scalars['String']['input'];
};


export type QueryCouponArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCreateInvoicingPdfDocumentArgs = {
  document: EmailTempVariablesDocumentInput;
};


export type QueryDeleteFileFromAwsArgs = {
  fileName: Scalars['String']['input'];
};


export type QueryDepartmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmailIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmailTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryErpIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEventLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExportMarketPlaceOrdersWithFilterArgs = {
  input: MarketPlaceOrderFilterInput;
};


export type QueryExportMarketPlaceOrdersWithFilterByMailArgs = {
  brand: EmailTempVariablesBrandInput;
  emails: Array<Scalars['String']['input']>;
  input: MarketPlaceOrderFilterInput;
  subject: Scalars['String']['input'];
};


export type QueryExportMarketPlaceOrdersWithFilterCsvArgs = {
  input: MarketPlaceOrderFilterInput;
};


export type QueryExportResponsesByMailArgs = {
  email: Scalars['String']['input'];
  input: ResponseFilterInput;
  subject: Scalars['String']['input'];
};


export type QueryFavoriteInternalProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFavoriteProductArgs = {
  id: Scalars['String']['input'];
};


export type QueryFbCatalogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFbPixelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindAllCoinsWithoutCountryArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindAttributeByExternalIdAndTargetArgs = {
  externalId: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
};


export type QueryFindAttributeValueByExternalIdAndTargetArgs = {
  externalId: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
};


export type QueryFindBankByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindBankDetailsByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindBanksDetailsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindBanksPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindBlogsByAuthorArgs = {
  author: Scalars['ID']['input'];
};


export type QueryFindBlogsByAuthorPaginatedArgs = {
  author: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindBlogsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryFindBlogsByTargetAndUrlArgs = {
  language?: InputMaybe<Scalars['ID']['input']>;
  target: TargetAciInput;
  url: Scalars['String']['input'];
};


export type QueryFindBlogsByTargetPaginatedArgs = {
  language?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<VisibilityStatusEnum>>;
  target: TargetAciInput;
};


export type QueryFindBrandByExternalIdAndTargetArgs = {
  externalId: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
};


export type QueryFindBrowserByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindBrowsersPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindCatalogueCategoryByExternalIdAndTargetArgs = {
  externalId: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
};


export type QueryFindContentTypeByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindContentTypeByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryFindContentTypeByTypeArgs = {
  type: Scalars['String']['input'];
};


export type QueryFindContentTypesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindCorporateEmailTemplateByNameArgs = {
  name: EmailTemplateTypeEnum;
};


export type QueryFindCorporateTemplateByNameArgs = {
  name: CorporateTemplateTypeEnum;
};


export type QueryFindCorporateTemplateByNameAndTargetArgs = {
  name: CorporateTemplateTypeEnum;
  target: TargetAciInput;
};


export type QueryFindCorporateTemplateByTargetArgs = {
  target: TargetAciInput;
};


export type QueryFindCounteryByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindCountriesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindCouponByTargetAndCodeArgs = {
  couponCode: Scalars['String']['input'];
  target: TargetAciInput;
};


export type QueryFindCouponSettingsByTargetArgs = {
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  target: TargetAciInput;
};


export type QueryFindCouponsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryFindCouponsByTargetWithFilterPaginatedArgs = {
  filter?: InputMaybe<CouponFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryFindCurrenciesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindCurrencyByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindCurrentCorporateUserCardsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryFindDeliveryZonesByTargetArgs = {
  target: TargetAciInput;
};


export type QueryFindDeliveryZonesByTargetCacheArgs = {
  target: TargetAciInput;
};


export type QueryFindDeviceTypeByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindDeviceTypesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindDocumentByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindDocumentsByOwnerPaginationArgs = {
  owner: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindDocumentsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindEmailTemplateByNameArgs = {
  name: EmailTemplateTypeEnum;
};


export type QueryFindFavoriteInternalProductByCurrentUserArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindFavoriteProductByCurrentUserArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindFontByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindGlobalCategoriesByProviderPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  provider: GlobalCategoryProviderEnum;
};


export type QueryFindGlobalCategoriesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindGlobalCategoryByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindGlobalCategoryByProviderAndIdentifierArgs = {
  identifier: Scalars['Int']['input'];
  provider: GlobalCategoryProviderEnum;
};


export type QueryFindInternalProductByExternalIdAndTargetArgs = {
  externalId: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
};


export type QueryFindLabelsByCategoryAndTargetArgs = {
  category: LabelTypeEnum;
  target: TargetAciInput;
};


export type QueryFindLandingPagesByTargetArgs = {
  target: TargetAciInput;
};


export type QueryFindLandingPagesByTargetAndTypeAndStatusPaginatedArgs = {
  pageType?: InputMaybe<Array<LandingPageTypeEnum>>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<VisibilityStatusEnum>>;
  target: TargetAciInput;
};


export type QueryFindLandingPagesByTargetAndTypeAndStatusPaginatedCacheArgs = {
  pageType?: InputMaybe<Array<LandingPageTypeEnum>>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<VisibilityStatusEnum>>;
  target: TargetAciInput;
};


export type QueryFindLandingPagesByTargetAndTypePaginatedArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  pageType: Array<LandingPageTypeEnum>;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryFindLandingPagesByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryFindLandingPagesByUrlArgs = {
  target: TargetAciInput;
  url: Scalars['String']['input'];
};


export type QueryFindLanguageByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindLoyaltySettingsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryFindLoyaltySettingsByTargetCacheArgs = {
  target: TargetAciInput;
};


export type QueryFindLoyaltySettingsRedeemByTargetArgs = {
  target: TargetAciInput;
};


export type QueryFindMarketPlaceOrdersByUserArgs = {
  input: MarketPlaceOrderFilterConsumerInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindModuleAssignmentsforFrameArgs = {
  posId: Scalars['String']['input'];
};


export type QueryFindModuleDefinitionsByTargetArgs = {
  target: TargetTypeEnum;
};


export type QueryFindNonPredefinedQuestsByTargetArgs = {
  advertiser?: InputMaybe<TargetAciInput>;
  filter?: InputMaybe<QuestsFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryFindNotesByLabelAndTargetArgs = {
  label: Scalars['ID']['input'];
  target: TargetAciInput;
};


export type QueryFindOneByEanArgs = {
  ean: Scalars['String']['input'];
};


export type QueryFindOperatingSystemByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindOperatingSystemsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindOrderSettingsByQueryArgs = {
  query: Scalars['String']['input'];
};


export type QueryFindPosNearbyPaginationArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
  pagination?: InputMaybe<PaginationInput>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  rad: Scalars['Float']['input'];
};


export type QueryFindPosNearbyWithFollowersPaginationArgs = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
  pagination?: InputMaybe<PaginationInput>;
  rad: Scalars['Float']['input'];
};


export type QueryFindPaymentByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindPaymentsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindPluginByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindPluginByTargetAndPluginArgs = {
  id: Scalars['ID']['input'];
  target: TargetAciInput;
};


export type QueryFindPluginByUrlArgs = {
  url: Scalars['String']['input'];
};


export type QueryFindPluginsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindPredefinedQuestsByTargetArgs = {
  filter?: InputMaybe<QuestsFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryFindPredefinedQuestsByTargetWithRepeatDateArgs = {
  filter?: InputMaybe<QuestsFilterInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryFindProductClicksByOwnerPaginatedArgs = {
  owner: TargetAciInput;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<TargetAciInput>;
};


export type QueryFindProductClicksByProductPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  product: Scalars['ID']['input'];
};


export type QueryFindProductClicksByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryFindProductsToCompareByUserPaginateArgs = {
  pagination?: InputMaybe<PaginationInput>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFindQuestsByCategoryAndTargetArgs = {
  target: TargetAciInput;
};


export type QueryFindSeoByTargetArgs = {
  target: TargetAciInput;
};


export type QueryFindSeoByTargetCacheArgs = {
  target: TargetAciInput;
};


export type QueryFindSeoByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryFindShoppingCartByUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFindShoppingCartByUserAndTargetArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  target: TargetAciInput;
};


export type QueryFindSlideByTargetAndReferenceArgs = {
  reference: Scalars['String']['input'];
  target: TargetAciInput;
};


export type QueryFindSlideByTargetAndReferenceCacheArgs = {
  reference: Scalars['String']['input'];
  target: TargetAciInput;
};


export type QueryFindSlidesByTargetArgs = {
  language?: InputMaybe<Scalars['ID']['input']>;
  target: TargetAciInput;
};


export type QueryFindSlidesByTargetCacheArgs = {
  language?: InputMaybe<Scalars['ID']['input']>;
  target: TargetAciInput;
};


export type QueryFindSlidesByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryFindSocialByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryFindSocialByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindSocialsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindStateByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindStatesByCountryPaginationArgs = {
  country: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindStatesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindSuppliersByTargetArgs = {
  target: TargetAciInput;
};


export type QueryFindSuppliersByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryFindTargetOrdersArgs = {
  input: MarketPlaceOrderFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindTargetOrdersByCurrentUserArgs = {
  input?: InputMaybe<MarketPlaceOrderFilterConsumerInput>;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryFindTargetPartnersAccelerateCountArgs = {
  target: TargetAciInput;
};


export type QueryFindTargetPartnersReferralCountArgs = {
  target: TargetAciInput;
};


export type QueryFindTargetPartnersWithAccelerateSettingsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryFindTargetPartnersWithReferralSettingsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryFindTargetShoppingCartsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryFindTechDeviceBrandByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindTechDeviceBrandsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindTechDeviceByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindTechDevicesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindVisualsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryFindVisualsByTargetCacheArgs = {
  target: TargetAciInput;
};


export type QueryFindVisualsByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryFindWarehousesByLocationArgs = {
  location: Scalars['ID']['input'];
};


export type QueryFindWarehousesByLocationPaginatedArgs = {
  location: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindfontsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindlanguagesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFormArgs = {
  id: Scalars['String']['input'];
};


export type QueryFreebieArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFreebietransactionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGameArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGameOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGenerateCampaignInsightsArgs = {
  input: GenerateInsightsInput;
};


export type QueryGenerateCloudinarySignatureArgs = {
  folder: Scalars['String']['input'];
  public_id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGenerateJwtTokenArgs = {
  expiration: Scalars['String']['input'];
  payload: Array<KeyValueInput>;
};


export type QueryGenerateLoyaltySettingsByAiArgs = {
  input: SetupLoyaltyLevelsAiInput;
};


export type QueryGenerateS3SignedUrlArgs = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
};


export type QueryGetAccelerationSettingsByTargetWithLinkedAccountArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetAccountsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target?: InputMaybe<TargetAciInput>;
};


export type QueryGetAccountsByTargetAndRolesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  role: Array<UserRole>;
  target: TargetAciInput;
};


export type QueryGetAccountsByTargetWithStatsPaginateArgs = {
  pagination?: InputMaybe<PaginationInput>;
  targets?: InputMaybe<TargetsInput>;
};


export type QueryGetActiveQuestsStatsArgs = {
  target: TargetAciInput;
};


export type QueryGetActivityLogsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<Array<ActivityLogTypeEnum>>;
};


export type QueryGetActivityTypesPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetAdhocTransactionsByTargetPaginatedArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetAllInternalProductsArgs = {
  target?: InputMaybe<TargetAciInput>;
};


export type QueryGetAllInternalProductsByTargetGroupedByClassArgs = {
  target: TargetAciInput;
};


export type QueryGetAllInternalProductsByTargetGroupedByClassWithFavoriteStatusArgs = {
  target: TargetAciInput;
};


export type QueryGetAnalyticsAudienceMetricsArgs = {
  input: AnalyticsDashboardInput;
};


export type QueryGetAnalyticsAudienceSessionsByCountryArgs = {
  input: AnalyticsDashboardInput;
};


export type QueryGetAnalyticsSessionsByCountriesArgs = {
  input: AnalyticsDashboardInput;
};


export type QueryGetAnalyticsStatsArgs = {
  input: AnalyticsDashboardInput;
};


export type QueryGetAnalyticsTopOperatingSystemsArgs = {
  input: AnalyticsDashboardInput;
};


export type QueryGetAnalyticsTopPagesArgs = {
  input: AnalyticsDashboardInput;
};


export type QueryGetAnalyticsUserByCountryArgs = {
  input: AnalyticsDashboardInput;
};


export type QueryGetAnalyticsUsersByDeviceArgs = {
  input: AnalyticsDashboardInput;
};


export type QueryGetAppCorporateEmailsPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetArchivedBoardCardsPaginatedArgs = {
  boardId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetArchivedMessageGroupsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetAttributeValuesByAttributeArgs = {
  attributId: Scalars['ID']['input'];
};


export type QueryGetAttributeValuesByAttributePaginatedArgs = {
  attributId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetAttributeValuesByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetAttributeValuesByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetAttributeValuesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetAttributesByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetAttributesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetAttributesTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetAudienceCriteriasPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAudienceReachArgs = {
  segments: Array<AudienceSegmentInput>;
  target: TargetAciInput;
};


export type QueryGetAudienceUsersPaginatedArgs = {
  id: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetAudiencesByTargetPaginatedArgs = {
  advertiser?: InputMaybe<TargetAciInput>;
  pagination?: InputMaybe<PaginationInput>;
  questType?: InputMaybe<Scalars['ID']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetAudiencesPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetAuthEventLogsByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetAverageCorporateProductRatingsByProductArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryGetAverageProductRatingsByProductArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryGetBadgesByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetBadgesPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetBarcodeByBarcodeAndTargetArgs = {
  barcode: Scalars['String']['input'];
  target: TargetAciInput;
};


export type QueryGetBarcodeByProductAndAttributesArgs = {
  input: BarcodeFindInput;
};


export type QueryGetBarcodeByProductAndAttributesCacheArgs = {
  input: BarcodeFindInput;
};


export type QueryGetBarcodeStatsArgs = {
  barcodeId: Scalars['ID']['input'];
};


export type QueryGetBarcodeWithProductAttributesAndStockArgs = {
  id: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetBarcodeWithStockArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetBarcodesByBarcodesAndTargetArgs = {
  barcodes: Array<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetBarcodesByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetBarcodesByTargetWithInternalProductPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetBarcodesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetBarcodesWithFilterArgs = {
  filter: BarcodeFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetBarcodesWithVarietyAndStructureWithFilterArgs = {
  filter: BarcodeWithVarietyAndStructureFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetBlogSeojsonArgs = {
  blogId: Scalars['ID']['input'];
};


export type QueryGetBoardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBoardCardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBoardCardsByBoardListArgs = {
  boardList: Scalars['ID']['input'];
};


export type QueryGetBoardCardsByBoardWithFilterPaginatedArgs = {
  board: Scalars['ID']['input'];
  filter?: InputMaybe<BoardCardFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetBoardCardsByCrmBoardWithFilterPaginatedArgs = {
  input: CrmDashboardWithFilterInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetBoardCardsStatsWithFilterArgs = {
  filter: BoardCardStatsFilterInput;
  target: TargetAciInput;
};


export type QueryGetBoardListArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBoardListByBoardArgs = {
  boardId: Scalars['ID']['input'];
};


export type QueryGetBoardWithListsAndCardsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBoardsByMemberAndTargetArgs = {
  member: Scalars['ID']['input'];
  target: TargetAciInput;
};


export type QueryGetBoardsByMemberAndTargetPaginatedArgs = {
  category?: InputMaybe<BoardCategoryEnum>;
  member: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetBoardsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetBoardsByTargetPaginatedArgs = {
  category: BoardCategoryEnum;
  filter?: InputMaybe<BoardsFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetBrandsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetBrandsByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetBrandsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetBudgetStatsChartsArgs = {
  filter?: InputMaybe<QuestDashboardFilterInput>;
};


export type QueryGetByVersionArgs = {
  version: Scalars['String']['input'];
};


export type QueryGetCrmBoardArgs = {
  target: TargetAciInput;
};


export type QueryGetCrmBoardCardProceduresWithFilterArgs = {
  input: CrmDashboardWithTaskFilterInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCampaignsStatsArgs = {
  target: TargetAciInput;
};


export type QueryGetCatalogueCategoriesArgs = {
  target: TargetAciInput;
};


export type QueryGetCatalogueCategoriesByLayerAndParentArgs = {
  layer: Scalars['Int']['input'];
  parent?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
  variety?: InputMaybe<ProductVarietyEnum>;
};


export type QueryGetCatalogueCategoriesByLayerAndParentCacheArgs = {
  layer: Scalars['Int']['input'];
  parent?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
  variety?: InputMaybe<ProductVarietyEnum>;
};


export type QueryGetCatalogueCategoriesByLayerAndParentForPortalArgs = {
  layer: Scalars['Int']['input'];
  parent?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetCatalogueCategoriesByTargetAndUrlKeyArgs = {
  language?: InputMaybe<Scalars['ID']['input']>;
  target: TargetAciInput;
  urlKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCatalogueCategoriesByTargetForPortalArgs = {
  target: TargetAciInput;
};


export type QueryGetCatalogueCategoriesByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetCatalogueCategoriesByTargetWithChildrenArgs = {
  language?: InputMaybe<Scalars['ID']['input']>;
  target: TargetAciInput;
  variety?: InputMaybe<ProductVarietyEnum>;
};


export type QueryGetCatalogueCategoriesByTargetWithChildrenCacheArgs = {
  language?: InputMaybe<Scalars['ID']['input']>;
  target: TargetAciInput;
  variety?: InputMaybe<ProductVarietyEnum>;
};


export type QueryGetCatalogueCategoryPathArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCatalogueTemplateByExcelArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCausesByOrganizationPaginatedArgs = {
  organization: TargetAciInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCausesByTargetAndOrganizationPaginatedArgs = {
  organization: TargetAciInput;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetCausesByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetCausesPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetChallengeLeaderboardArgs = {
  id: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetChallengeLeaderboardWithCurrentUserArgs = {
  id: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetChallengesByTargetAndCreatorPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetChallengesByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetChallengesByTargetWithDonationProgressPaginatedArgs = {
  filter?: InputMaybe<ChallengeFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetChallengesPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCoinOneByOwnerArgs = {
  target: TargetAciInput;
};


export type QueryGetCoinsByCategoryPaginatedArgs = {
  categories?: InputMaybe<Array<CoinCategoryEnum>>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCoinsByCountryAndCategoryPaginatedArgs = {
  categories?: InputMaybe<Array<CoinCategoryEnum>>;
  country: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCoinsByCountryPaginatedArgs = {
  country?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCoinsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCollaborationAnalyticsStatsArgs = {
  input: AnalyticsDashboardInput;
};


export type QueryGetCollaborationProjectsOverviewArgs = {
  input: CrmDashboardInput;
};


export type QueryGetCollaborationProjectsStatusArgs = {
  input: AnalyticsDashboardInput;
};


export type QueryGetComingSoonQuestsByTargetAndUserAudiencePaginatedArgs = {
  input: QuestsByTargetAndUserAudienceInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetComingSoonQuestsByTargetAndUserAudienceWithLinkedAccountsPaginatedArgs = {
  input: QuestsByTargetAndUserAudienceInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCommentsByHolderArgs = {
  holder: CommentHolderInput;
};


export type QueryGetCommentsByHolderPaginatedArgs = {
  holder: CommentHolderInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCommentsRepliesArgs = {
  id: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCompaniesByTargetArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetCompaniesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCompanyContactsByCompanyArgs = {
  company: Scalars['ID']['input'];
};


export type QueryGetCompanyContactsByCompanyPaginatedArgs = {
  company: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCompanyContactsByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  phase: CustomerPhaseEnum;
  target: TargetAciInput;
};


export type QueryGetConversionsByAgeArgs = {
  filter?: InputMaybe<QuestDashboardFilterInput>;
};


export type QueryGetConversionsByGenderArgs = {
  filter?: InputMaybe<QuestDashboardFilterInput>;
};


export type QueryGetCorporateDashboardByTargetAndUserArgs = {
  target: TargetAciInput;
};


export type QueryGetCorporateEmailsByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetCorporateNotificationsByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetCorporateNotificationsByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetCorporateNotificationsByUserArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetCorporateNotificationsForUserPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetCorporateNotificationsForUserWithLinkedAccountsPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetCorporateRatingAssignmentByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetCorporateRatingAssignmentByTargetCacheArgs = {
  target: TargetAciInput;
};


export type QueryGetCorporateRatingAssignmentsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCorporateRatingDefinitionByReviewTypeArgs = {
  reviewType: Scalars['String']['input'];
};


export type QueryGetCorporateRatingDefinitionByReviewTypeCacheArgs = {
  reviewType: Scalars['String']['input'];
};


export type QueryGetCorporateRatingDefinitionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCorporateRatingsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCorporateRatingsByProductArgs = {
  pagination?: InputMaybe<PaginationInput>;
  productId: Scalars['ID']['input'];
};


export type QueryGetCorporateRatingsByProductWithStatsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  productId: Scalars['ID']['input'];
};


export type QueryGetCorporateRatingsBytargetArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetCorporateTargetDashboardDataArgs = {
  target: TargetAciInput;
};


export type QueryGetCorporateUserAnalyticsArgs = {
  from: Scalars['DateTime']['input'];
  target: TargetAciInput;
  to: Scalars['DateTime']['input'];
};


export type QueryGetCorporateUserByDayInPeriodAnalyticsArgs = {
  from: Scalars['DateTime']['input'];
  target: TargetAciInput;
  to: Scalars['DateTime']['input'];
};


export type QueryGetCorporateUserCardByUserAndTargetArgs = {
  target: TargetAciInput;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetCorporateUserCardsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetCorporateUserCardsByTargetPaginatedArgs = {
  cardType?: InputMaybe<CardTypeEnum>;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetCorporateUserCardsByTargetWithReputationsPaginatedArgs = {
  filter?: InputMaybe<CorporateUserCardFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetCorporateUserCardsByUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetCorporateUsersByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetCorporateUsersByTargetAndWholesalerArgs = {
  target: TargetAciInput;
};


export type QueryGetCorporateUsersDashboardDataArgs = {
  from: Scalars['DateTime']['input'];
  target: TargetAciInput;
  to: Scalars['DateTime']['input'];
};


export type QueryGetCorporateUsersRequestsAnalyticsArgs = {
  from: Scalars['DateTime']['input'];
  target: TargetAciInput;
  to: Scalars['DateTime']['input'];
};


export type QueryGetCorporateUsersStatsArgs = {
  target: TargetAciInput;
};


export type QueryGetCorporateUsersTechnologiesDashboardDataArgs = {
  from: Scalars['DateTime']['input'];
  target: TargetAciInput;
  to: Scalars['DateTime']['input'];
};


export type QueryGetCorporateWarehouseDashboardDataArgs = {
  from: Scalars['DateTime']['input'];
  target: TargetAciInput;
  to: Scalars['DateTime']['input'];
};


export type QueryGetCouponSettingsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCouponsByCsvArgs = {
  filter?: InputMaybe<CouponFilterInput>;
  path?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetCouponsByExcelArgs = {
  filter?: InputMaybe<CouponFilterInput>;
  path?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetCrmAnalyticsBalanceOverviewArgs = {
  input: CrmDashboardInput;
};


export type QueryGetCrmAnalyticsDealTypeArgs = {
  input: AnalyticsDashboardInput;
};


export type QueryGetCrmAnalyticsSalesForecastArgs = {
  input: AnalyticsDashboardInput;
};


export type QueryGetCrmAnalyticsStatsArgs = {
  input: AnalyticsDashboardInput;
};


export type QueryGetCurrentDayRewardsArgs = {
  input: CurrentRewardsFilterInput;
};


export type QueryGetCurrentUserCorporateRatingsByProductArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryGetCurrentUserCouponsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCurrentUserDailyStatsArgs = {
  gameCode?: InputMaybe<Scalars['String']['input']>;
  gameGroup?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetCurrentUserLastUnredeemedCouponArgs = {
  target: TargetAciInput;
};


export type QueryGetCurrentUserLinkedCorporateAccountByTargetArgs = {
  target: TargetWithoutUserInput;
};


export type QueryGetCurrentUserQualitativeWalletArgs = {
  target: TargetAciInput;
};


export type QueryGetCurrentUserQuantitativeWalletsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  userToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCurrentUserRankArgs = {
  input?: InputMaybe<LeaderboardWithRequiredCycleInput>;
};


export type QueryGetCurrentUserReputationsLossDateArgs = {
  userToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCurrentUserReputationsTurnoverLossDateArgs = {
  userToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCurrentUserWeeklyStatsArgs = {
  gameCode?: InputMaybe<Scalars['String']['input']>;
  gameGroup?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetCurrentWeekRewardsArgs = {
  input: CurrentRewardsFilterInput;
};


export type QueryGetCustomersArgs = {
  pagination?: InputMaybe<PaginationInput>;
  phase: CustomerPhaseEnum;
  target: TargetAciInput;
};


export type QueryGetCustomersTemplateByExcelArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDefaultAudiencesPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDefaultBadgesPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDeliveryManByPosArgs = {
  pagination?: InputMaybe<PaginationInput>;
  posId: Scalars['String']['input'];
};


export type QueryGetDeliveryTargetOrdersArgs = {
  open?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetDeliveryZoneArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetDepartmentsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetDirectMessageGroupArgs = {
  receiverId: Scalars['ID']['input'];
  target: TargetAciInput;
};


export type QueryGetDonationActivityTypesByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetEcommerceAnalyticsStatsArgs = {
  input: AnalyticsDashboardInput;
};


export type QueryGetEcommerceBestSellerProductsWithFilterPaginatedArgs = {
  input: AnalyticsDashboardInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetEcommerceEventLogsByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetEcommerceFinanceDashboardDataArgs = {
  from: Scalars['DateTime']['input'];
  target: TargetAciInput;
  to: Scalars['DateTime']['input'];
};


export type QueryGetEcommerceRevenueChartStatsArgs = {
  input: CrmDashboardInput;
};


export type QueryGetEcommerceSalesByLocationArgs = {
  input: AnalyticsDashboardInput;
};


export type QueryGetEcommerceTopCatalogueCategoriesArgs = {
  input: EcommerceVarietyDashboardInput;
};


export type QueryGetEmailIntegrationByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetEnabledPricesByCompanyArgs = {
  company: Scalars['ID']['input'];
};


export type QueryGetEngagementProgressionOverTimeArgs = {
  target: TargetAciInput;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetEngagementProgressionStatsArgs = {
  target: TargetAciInput;
};


export type QueryGetEngagmentPointsEarnedPerActivityArgs = {
  target: TargetAciInput;
};


export type QueryGetEngagmentStatsArgs = {
  target: TargetAciInput;
};


export type QueryGetErpIntegrationByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetEventByTargetAndCodeArgs = {
  code: Scalars['String']['input'];
  target: TargetAciInput;
};


export type QueryGetEventInvitesWithFilterArgs = {
  filter: EventInviteFilterInput;
};


export type QueryGetEventInvitesWithFilterPaginatedArgs = {
  filter: EventInviteFilterInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetEventLogsByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetEventLogsPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetEventTicketByReferenceArgs = {
  reference: Scalars['String']['input'];
  target: TargetAciInput;
};


export type QueryGetEventTicketsWithFilterArgs = {
  filter: EventTicketFilterInput;
};


export type QueryGetEventTicketsWithFilterPaginatedArgs = {
  filter: EventTicketFilterInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetEventsByTargetPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetEventsByUserPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  userId: Scalars['String']['input'];
};


export type QueryGetFbCatalogSyncByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetFbPixelByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetFacebookPixelSourceForEventArgs = {
  event: PixelRecommendedEventsEnum;
  input?: InputMaybe<FbPixelEventDataInput>;
  target: TargetAciInput;
};


export type QueryGetFavoriteSimpleProductByCurrentUserArgs = {
  language?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetFeaturedCorporatesByTargetArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: FeaturedCorporateTargetEnum;
};


export type QueryGetFlowsByTargetPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetFlowsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetFormResponsesArgs = {
  form: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetFormsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetFormsWithFiltersArgs = {
  input: FormFiltersInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetFreebieByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetFreebieTransactionByByPartnershipNetworkArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  target: TargetAciInput;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryGetFreebieTransactionByByPartnershipNetworkPast45MinutesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetFreebieTransactionByTargetArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  target: TargetAciInput;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryGetFreebieTransactionByTargetCacheArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  target: TargetAciInput;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryGetFreebieTransactionByTargetPaginatedArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryGetFreebieTransactionByTargetPast45MinutesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetFullCatalogueByExcelArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
  withStock: Scalars['Boolean']['input'];
};


export type QueryGetFuturePromotionsByTargetPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetGameByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetGameIntegrationByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetGameOrdersByTargetAndGamePaginatedArgs = {
  gameId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetGameRewardsWithFilterArgs = {
  filter: GameRewardsFilterInput;
};


export type QueryGetGameWinnersArgs = {
  cycle?: InputMaybe<LeaderboardCycleEnum>;
  gameCode?: InputMaybe<Scalars['String']['input']>;
  gameGroup?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetGamesPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetGeneralSeoArgs = {
  target: TargetAciInput;
};


export type QueryGetGeneralSeojsonArgs = {
  target: TargetAciInput;
};


export type QueryGetGlobalPurchasesTaxesByCompanyArgs = {
  company: Scalars['ID']['input'];
};


export type QueryGetGlobalSalesTaxesByCompanyArgs = {
  company: Scalars['ID']['input'];
};


export type QueryGetGoogleAnalyticsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetGoogleTagsSourceForEventArgs = {
  event: GaRecommendedEventsEnum;
  input: GoogleAnalyticsEventDataInput;
  target: TargetAciInput;
};


export type QueryGetHelpdeskIntegrationByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetImagesFromFolderArgs = {
  path: Scalars['String']['input'];
};


export type QueryGetIntegrationIntegrationByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetInternalProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetInternalProductBarcodesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetInternalProductBarcodesPaginatedArgs = {
  id: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetInternalProductStatsArgs = {
  internalProductId: Scalars['ID']['input'];
};


export type QueryGetInternalProductWithFavoriteStatusArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetInternalProductWithFilterArgs = {
  filter?: InputMaybe<InternalProductFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<ProductSortInput>>;
};


export type QueryGetInternalProductWithStockArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetInternalProductsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target?: InputMaybe<TargetAciInput>;
};


export type QueryGetInternalProductsByCatalogueCategoryArgs = {
  catalogueCategoryIds: Array<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetInternalProductsByCatalogueCategoryForPortalArgs = {
  catalogueCategoryIds: Array<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetInternalProductsByCatalogueCategoryWithFavoriteStatusArgs = {
  catalogueCategoryIds: Array<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetInternalProductsByCategoryArgs = {
  category: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetInternalProductsByClassArgs = {
  classification: Array<ProductClassEnum>;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetInternalProductsByProductArgs = {
  pagination?: InputMaybe<PaginationInput>;
  productId: Scalars['ID']['input'];
};


export type QueryGetInternalProductsByTargetAndCatalogueCategoryArgs = {
  category: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetInternalProductsByTargetAndCatalogueCategoryUrlKeyArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
  urlKey: Scalars['String']['input'];
};


export type QueryGetInternalProductsByTargetAndCatalogueCategoryUrlKeyWithFavoriteStatusArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
  urlKey: Scalars['String']['input'];
};


export type QueryGetInternalProductsWithRatingsWithFavoriteStatusWithFilterArgs = {
  filter?: InputMaybe<InternalProductFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<ProductSortInput>>;
};


export type QueryGetInternalProductsWithRatingsWithFilterArgs = {
  filter?: InputMaybe<InternalProductFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<ProductSortInput>>;
};


export type QueryGetInventoryCategoriesByLayerandParentArgs = {
  layer: Scalars['Int']['input'];
  parent?: InputMaybe<Scalars['String']['input']>;
  returnEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetInventoryCategoriesByParentArgs = {
  parent: Scalars['String']['input'];
};


export type QueryGetInventoryCategoriesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetInventoryIntegrationByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetInvoicingByExcelArgs = {
  category: SequenceCategoryEnum;
  filter?: InputMaybe<InvoicingFilterInput>;
  path?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetInvoicingTemplateByExcelArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetJobApplicationsByCsvArgs = {
  filter?: InputMaybe<JobApplicationFilterInput>;
  path?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetJobApplicationsByExcelArgs = {
  filter?: InputMaybe<JobApplicationFilterInput>;
  path?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetJobApplicationsByJobDefinitionArgs = {
  jobDefinition: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetJobApplicationsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetJobApplicationsByTargetAndStatusPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  status: JobApplicationStatusEnum;
  target: TargetAciInput;
};


export type QueryGetJobApplicationsByTargetPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetJobApplicationsByTargetWithFilterPaginationArgs = {
  filter: JobApplicationFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetJobDefinitionsByCsvArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<JobDefinitionStatusEnum>>;
  target: TargetAciInput;
};


export type QueryGetJobDefinitionsByExcelArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<JobDefinitionStatusEnum>>;
  target: TargetAciInput;
};


export type QueryGetJobDefinitionsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetJobDefinitionsByTargetAndStatusPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  status: JobDefinitionStatusEnum;
  target: TargetAciInput;
};


export type QueryGetJobDefinitionsByTargetPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetKycDashboardArgs = {
  target: TargetAciInput;
};


export type QueryGetLabelsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetLandingPagesPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetLastReferralArgs = {
  userToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetLastVersionByPlatformArgs = {
  platform: PlatformEnum;
};


export type QueryGetLastVersionByPlatformAndTargetArgs = {
  platform: PlatformEnum;
  target: TargetAciInput;
};


export type QueryGetLastWidgetOutboundsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetLeaderboardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetLeaderboardByCyclePaginatedArgs = {
  input?: InputMaybe<LeaderboardWithRequiredCycleInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetLeaderboardByDatesAndCyclePaginatedArgs = {
  input?: InputMaybe<GetLeaderboardByDatesAndCycleInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetLinkedAccountsCorporateUserCardsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetLiveLeaderboardByCycleByExcelArgs = {
  input?: InputMaybe<LeaderboardWithRequiredCycleInput>;
  path?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetLiveLeaderboardByCycleForCurrentUserPaginatedArgs = {
  input?: InputMaybe<LeaderboardWithRequiredCycleInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetLiveLeaderboardByCyclePaginatedArgs = {
  input?: InputMaybe<LeaderboardWithRequiredCycleInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetLiveTopGamesLeaderboardByCycleArgs = {
  cycle: LeaderboardCycleEnum;
  target: TargetAciInput;
};


export type QueryGetLocationsByCompanyArgs = {
  company: Scalars['ID']['input'];
};


export type QueryGetLocationsByCompanyPaginatedArgs = {
  company: Scalars['ID']['input'];
  filter?: InputMaybe<LocationFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetLogisticsIntegrationByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetLoyaltyProgramsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetMainCategorySeoArgs = {
  categoryId: Scalars['ID']['input'];
};


export type QueryGetMainCategorySeojsonArgs = {
  categoryId: Scalars['ID']['input'];
};


export type QueryGetMainDashboardStatsArgs = {
  target: TargetAciInput;
};


export type QueryGetMainPageSeoArgs = {
  target: TargetAciInput;
};


export type QueryGetMainPageSeojsonArgs = {
  target: TargetAciInput;
};


export type QueryGetMaintenanceBoardArgs = {
  target: TargetAciInput;
};


export type QueryGetManufacturersPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetMediaOfMessageGroupPaginationArgs = {
  mediaType: MediaTypeEnum;
  messageGroup: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetMenuBadgesArgs = {
  target: TargetAciInput;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetMessageGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetMessageGroupByMemberArgs = {
  memberId: Scalars['ID']['input'];
  target?: InputMaybe<TargetAciInput>;
};


export type QueryGetMessageGroupMembersArgs = {
  id: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetMessageGroupsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetMessagesByMemberArgs = {
  memberId: Scalars['ID']['input'];
  target: TargetAciInput;
  type: MessageGroupTypeEnum;
};


export type QueryGetMessagesByMemberPaginatedArgs = {
  memberId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
  type: MessageGroupTypeEnum;
};


export type QueryGetMessagesByMessageGroupPaginationArgs = {
  messageGroup: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetModuleAssignmentsByAssigneeArgs = {
  assignee: AssigneeInput;
};


export type QueryGetNewslettersByExcelArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetNonPredefinedActivityTypesPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetNoteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetNotesByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetNotificationIntegrationByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetOneInternalProductByBarcodeAndTargetArgs = {
  barcode: Scalars['ID']['input'];
  target: TargetAciInput;
};


export type QueryGetOngoingChallengesByTargetAndUserAudiencePaginatedArgs = {
  filter: ChallengeByAudienceFilterInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetOngoingChallengesByTargetAndUserAudienceWithLinkedAccountsPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetOngoingPromotionsByTargetPaginationArgs = {
  filter?: InputMaybe<PromotionFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetOrderInstallmentArgs = {
  installmentId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
};


export type QueryGetOrderSettingsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetOrderSettingsByTargetCacheArgs = {
  target: TargetAciInput;
};


export type QueryGetOutboundsByTargetPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetOutboundsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPosCategoriesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPosServicesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPosWithFollowersPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetPagesSeoArgs = {
  pageId: Scalars['ID']['input'];
};


export type QueryGetPagesSeojsonArgs = {
  pageId: Scalars['ID']['input'];
};


export type QueryGetPaginatedBlogsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPaginatedCouponsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPaginatedProductClicksArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPaginatedSuppliersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPaginatedVisualsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPartnerReferralsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPartnershipNetworksByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetPartnershipNetworksByPartnerAndPartnershipPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  partner: TargetAciInput;
  partnership: Array<PartnershipTypeEnum>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPartnershipNetworksByTargetAndPartnershipPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  partnership: Array<PartnershipTypeEnum>;
  target: TargetAciInput;
};


export type QueryGetPartnershipNetworksByTargetAndPartnershipWithSettingsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  partnership: Array<PartnershipTypeEnum>;
  target: TargetAciInput;
};


export type QueryGetPartnershipNetworksByTargetPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetPerformanceByMetricArgs = {
  filter: PerformanceMetricInput;
};


export type QueryGetPermissionsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetPointOfSalesAggregatorPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPointOfSalesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  posCategory?: InputMaybe<Scalars['ID']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetPosTemplateByExcelArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPosTransactionsArgs = {
  activityType?: InputMaybe<Array<ActivityLogTypeEnum>>;
  pagination?: InputMaybe<PaginationInput>;
  posId: Scalars['String']['input'];
};


export type QueryGetPredefinedActivityTypesByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetPredefinedActivityTypesByTargetWithActiveStatusPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetPredefinedActivityTypesPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPredefinedPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPricesByCompanyPaginatedArgs = {
  company: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPricesCalculationsArgs = {
  input: CalculationsInput;
};


export type QueryGetProductAttributesByAttributeArgs = {
  attributId: Scalars['String']['input'];
};


export type QueryGetProductAttributesByAttributeAndTargetArgs = {
  attributId: Scalars['String']['input'];
  target: TargetAciInput;
};


export type QueryGetProductAttributesByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetProductAttributesByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetProductAttributesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetProductBarcodesArgs = {
  productId: Scalars['String']['input'];
};


export type QueryGetProductBarcodesCacheArgs = {
  productId: Scalars['String']['input'];
};


export type QueryGetProductPurchasesTaxesByCompanyArgs = {
  company: Scalars['ID']['input'];
};


export type QueryGetProductRatingDefinitionByReviewTypeArgs = {
  reviewType: Scalars['String']['input'];
};


export type QueryGetProductRatingDefinitionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetProductRatingsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetProductRatingsByProductArgs = {
  pagination?: InputMaybe<PaginationInput>;
  productId: Scalars['ID']['input'];
};


export type QueryGetProductRatingsByProductWithStatsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  productId: Scalars['ID']['input'];
};


export type QueryGetProductSeoArgs = {
  barcodeId: Scalars['ID']['input'];
  target: TargetAciInput;
};


export type QueryGetProductSeojsonArgs = {
  barcodeId: Scalars['ID']['input'];
  target: TargetAciInput;
};


export type QueryGetProductSalesTaxesByCompanyArgs = {
  company: Scalars['ID']['input'];
};


export type QueryGetProductWithClickCountArgs = {
  input: GetProductWithClicksCountInput;
};


export type QueryGetProductWithFilterArgs = {
  filter?: InputMaybe<ProductFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<ProductSortInput>>;
};


export type QueryGetProductsByCategoryPaginationArgs = {
  category_ids: Array<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetProductsByClassArgs = {
  classification: Array<ProductClassEnum>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetProductsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetProductsWithClicksCountByOwnerPaginatedArgs = {
  filter: GetProductsWithClicksCountByOwnerPaginatedFilterInput;
};


export type QueryGetProfileCompletnessProgressArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  userToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetProgramsByEventPaginationArgs = {
  event: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetProjectsBoardCardsByTargetPaginatedArgs = {
  filter: ProjectsBoardCardFilterInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetProjectsByExcelArgs = {
  filter?: InputMaybe<ProjectFilterInput>;
  path?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetProjectsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetProjectsByTargetWithFilterArgs = {
  filter?: InputMaybe<ProjectFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetProjectsTemplateByExcelArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPromotionsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetPromotionsByTargetPaginationArgs = {
  filter: PromotionFilterBaseInput;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetPurchaseDeliveryNoteStatsWithFilterArgs = {
  filter?: InputMaybe<InvoicingStatsFilterInput>;
  target: TargetAciInput;
};


export type QueryGetPurchaseDeliveryNotesByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetPurchaseDeliveryNotesByTargetPaginatedArgs = {
  filter?: InputMaybe<InvoicingFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetPurchaseIntegrationByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetPurchaseInvoicesByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetPurchaseInvoicesByTargetPaginatedArgs = {
  filter?: InputMaybe<InvoicingFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetPurchaseInvoicesStatsWithFilterArgs = {
  filter?: InputMaybe<InvoicingStatsFilterInput>;
  target: TargetAciInput;
};


export type QueryGetPurchaseOrderesByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetPurchaseOrdersByTargetPaginatedArgs = {
  filter?: InputMaybe<InvoicingFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetPurchaseOrdersStatsWithFilterArgs = {
  filter?: InputMaybe<InvoicingStatsFilterInput>;
  target: TargetAciInput;
};


export type QueryGetQuestActionDefinitionsPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetQuestActionsByQuestPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  quest: Scalars['ID']['input'];
};


export type QueryGetQuestActionsPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetQuestActivitiesByQuestArgs = {
  quest: Scalars['ID']['input'];
};


export type QueryGetQuestActivitiesByQuestCacheArgs = {
  quest: Scalars['ID']['input'];
};


export type QueryGetQuestActivitiesByQuestPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  quest: Scalars['ID']['input'];
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetQuestActivitiesPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetQuestByActivityTypeArgs = {
  activityType: Scalars['ID']['input'];
};


export type QueryGetQuestConversionStatsArgs = {
  filter?: InputMaybe<QuestDashboardFilterInput>;
};


export type QueryGetQuestDashboardChartDataArgs = {
  posId?: InputMaybe<Scalars['ID']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetQuestDashboardDataArgs = {
  posId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetQuestKpiDashboardDataArgs = {
  posId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetQuestOverviewArgs = {
  quest: Scalars['ID']['input'];
};


export type QueryGetQuestPerformanceMetricsChartDashboardDataArgs = {
  posId?: InputMaybe<Scalars['ID']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetQuestPerformanceMetricsStatsDashboardDataArgs = {
  posId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetQuestPerformanceOverTimeChartArgs = {
  filter?: InputMaybe<QuestDashboardFilterInput>;
};


export type QueryGetQuestReccurencyStatusArgs = {
  quest: Scalars['ID']['input'];
};


export type QueryGetQuestStatisticsArgs = {
  quest: Scalars['ID']['input'];
};


export type QueryGetQuestTopAggregateDashboardDataArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  posId?: InputMaybe<Scalars['ID']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryGetQuestTypesByTargetAndAdvertiserPaginatedArgs = {
  advertiser?: InputMaybe<TargetAciInput>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetQuestTypesByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetQuestTypesPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetQuestTypesStatsDashboardDataArgs = {
  posId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetQuestionResponsesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  questionId: Scalars['String']['input'];
};


export type QueryGetQuestionsByChallengeStepArgs = {
  id: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetQuestionsByFormArgs = {
  id: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetQuestionsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetQuestionsbyFormWithResponsesStatsPaginatedArgs = {
  id: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetQuestsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetQuestsByTargetAndCreatorPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetQuestsByTargetAndUserAudiencePaginatedArgs = {
  input: QuestsByTargetAndUserAudienceWithPerformedInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetQuestsByTargetAndUserAudienceWithLinkedAccountsPaginatedArgs = {
  input: QuestsByTargetAndUserAudienceWithPerformedInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetQuestsByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetQuotationsByTargetArgs = {
  filter?: InputMaybe<InvoicingFilterInput>;
  target: TargetAciInput;
};


export type QueryGetQuotationsByTargetPaginatedArgs = {
  filter?: InputMaybe<InvoicingFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetQuotationsStatsWithFilterArgs = {
  filter?: InputMaybe<InvoicingStatsFilterInput>;
  target: TargetAciInput;
};


export type QueryGetRecentlyViewedProductsByUserPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetReferralSettingsByTargetWithLinkedAccountArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetReferralsByTargetPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetRentalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetRentalsInPeriodArgs = {
  input: RentalFilterInput;
};


export type QueryGetRentalsInPeriodPaginatedArgs = {
  input?: InputMaybe<RentalFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetReputationsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetReputationsByTargetCacheArgs = {
  target: TargetAciInput;
};


export type QueryGetReputationsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetRequestsByExcelArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
  type?: InputMaybe<RequestTypeEnum>;
};


export type QueryGetRequestsByPlatformAndTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  platform?: InputMaybe<PlatformEnum>;
  target: TargetAciInput;
};


export type QueryGetRequestsByTypeAndTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
  type?: InputMaybe<RequestTypeEnum>;
};


export type QueryGetRequestsByTypePaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  type: RequestTypeEnum;
};


export type QueryGetRequestsPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetResponsesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetResponsesWithFilterArgs = {
  input: ResponseFilterInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetSeoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSeoPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetSaleDeliveryNoteStatsWithFilterArgs = {
  filter?: InputMaybe<InvoicingStatsFilterInput>;
  target: TargetAciInput;
};


export type QueryGetSaleDeliveryNotesByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetSaleDeliveryNotesByTargetPaginatedArgs = {
  filter?: InputMaybe<InvoicingFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetSaleInvoicesByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetSaleInvoicesByTargetPaginatedArgs = {
  filter?: InputMaybe<InvoicingFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetSaleInvoicesStatsWithFilterArgs = {
  filter?: InputMaybe<InvoicingStatsFilterInput>;
  target: TargetAciInput;
};


export type QueryGetSaleIssueNotesByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetSaleIssueNotesByTargetPaginatedArgs = {
  filter?: InputMaybe<InvoicingFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetSaleIssueNotesStatsWithFilterArgs = {
  filter?: InputMaybe<InvoicingStatsFilterInput>;
  target: TargetAciInput;
};


export type QueryGetSaleOrderesByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetSaleOrdersByTargetPaginatedArgs = {
  filter?: InputMaybe<InvoicingFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetSaleOrdersStatsWithFilterArgs = {
  filter?: InputMaybe<InvoicingStatsFilterInput>;
  target: TargetAciInput;
};


export type QueryGetSalesAnalyticsStatsArgs = {
  input: AnalyticsDashboardInput;
};


export type QueryGetSalesByLocationArgs = {
  input: AnalyticsDashboardInput;
};


export type QueryGetSalesIntegrationByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetSalesOrdersBestSellerProductsWithFilterPaginatedArgs = {
  input: SalesDashboardInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetSalesRevenueChartStatsArgs = {
  input: CrmDashboardInput;
};


export type QueryGetSalesTopCatalogueCategoriesArgs = {
  input: SalesDashboardInput;
};


export type QueryGetServiceProductArgs = {
  target: TargetAciInput;
};


export type QueryGetServicesCatalogueTemplateByExcelArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetShortcutsByUserAndTargetPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
  userId: Scalars['String']['input'];
};


export type QueryGetShortcutsByUserPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  userId: Scalars['String']['input'];
};


export type QueryGetSimpleBarcodeByBarcodeAndTargetArgs = {
  barcode: Scalars['String']['input'];
  target: TargetAciInput;
};


export type QueryGetSimpleBarcodesByBarcodesAndTargetArgs = {
  barcodes: Array<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetSimpleCatalogueByCsvArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
  sheets?: InputMaybe<Array<SheetsNames>>;
  target: TargetAciInput;
  variety?: InputMaybe<ProductVarietyEnum>;
};


export type QueryGetSimpleCatalogueByExcelArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
  sheets?: InputMaybe<Array<SheetsNames>>;
  target: TargetAciInput;
  variety?: InputMaybe<ProductVarietyEnum>;
};


export type QueryGetSimpleOngoingPromotionsByTargetPaginateArgs = {
  filter?: InputMaybe<PromotionFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetSimpleProductSeojsonArgs = {
  barcodeId: Scalars['ID']['input'];
  target: TargetAciInput;
};


export type QueryGetSimpleProductWithFavoriteStatusArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSimpleProductWithFavoriteStatusByUrlKeyArgs = {
  language?: InputMaybe<Scalars['ID']['input']>;
  target: TargetAciInput;
  urlKey: Scalars['String']['input'];
};


export type QueryGetSimpleProductWithFilterArgs = {
  filter?: InputMaybe<InternalProductFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<ProductSortInput>>;
};


export type QueryGetSimpleProductWithProductAttributesAndFavoriteStatusArgs = {
  id: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSimpleProductWithProductAttributesAndFavoriteStatusByUrlKeyArgs = {
  language?: InputMaybe<Scalars['ID']['input']>;
  target: TargetAciInput;
  urlKey: Scalars['String']['input'];
};


export type QueryGetSimpleProductsByCatalogueCategoryWithFavoriteStatusArgs = {
  catalogueCategoryIds: Array<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<Array<ProductStatusEnum>>;
};


export type QueryGetSimpleProductsByTargetAndCatalogueCategoryUrlKeyWithFavoriteStatusArgs = {
  language?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
  urlKey: Scalars['String']['input'];
};


export type QueryGetSimpleProductsByTargetAndCatalogueCategoryUrlKeyWithProductAttributesAndFavoriteStatusArgs = {
  language?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
  urlKey: Scalars['String']['input'];
};


export type QueryGetSimpleProductsByTargetGroupedByClassWithFavoriteStatusArgs = {
  language?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Array<ProductStatusEnum>>;
  target: TargetAciInput;
};


export type QueryGetSimpleProductsByTargetGroupedByClassWithProductAttributesAndFavoriteStatusArgs = {
  status?: InputMaybe<Array<ProductStatusEnum>>;
  target: TargetAciInput;
};


export type QueryGetSimpleProductsForPartnerhipNetworkAsGiftsForCurrentUserArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetSimpleProductsForPartnerhipNetworkWithRatingsAndFavoriteStatusAndRemunerationsAndFilterArgs = {
  input: GetInternalProductForPartnershipNetworkWithFilterPaginatedInput;
};


export type QueryGetSimpleProductsForPartnerhipNetworkWithRatingsWithFavoriteStatusWithFilterArgs = {
  input: GetInternalProductForPartnershipNetworkWithFilterPaginatedInput;
};


export type QueryGetSimpleProductsWithRatingsWithFavoriteStatusArgs = {
  input: GetInternalProductWithFilterPaginatedInput;
};


export type QueryGetSimpleProductsWithRatingsWithFavoriteStatusWithFilterArgs = {
  input: GetInternalProductWithFilterPaginatedInput;
};


export type QueryGetSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusArgs = {
  input: GetInternalProductWithFilterPaginatedInput;
};


export type QueryGetSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusWithFilterArgs = {
  input: GetInternalProductWithFilterPaginatedInput;
};


export type QueryGetSimpleServicesWithFilterArgs = {
  filter?: InputMaybe<BarcodesFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<ProductSortInput>>;
  target: TargetAciInput;
};


export type QueryGetSlidesPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetSmsIntegrationByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetStaticDataByKeyArgs = {
  key: Scalars['String']['input'];
};


export type QueryGetStaticTranslationsByTargetAndLanguageArgs = {
  app?: InputMaybe<TranslationAppEnum>;
  language?: InputMaybe<Scalars['ID']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetStaticTranslationsByTargetAndLanguageCacheArgs = {
  app?: InputMaybe<TranslationAppEnum>;
  language?: InputMaybe<Scalars['ID']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetStaticTranslationsByTargetAndLanguagePaginatedArgs = {
  app?: InputMaybe<TranslationAppEnum>;
  language?: InputMaybe<Scalars['ID']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetStaticTranslationsByTargetPaginatedArgs = {
  app?: InputMaybe<TranslationAppEnum>;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetStockArgs = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  barcodeId?: InputMaybe<Scalars['ID']['input']>;
  target: TargetAciInput;
  warehouse?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetStockByTargetAndBarcodeArgs = {
  barcode: Scalars['String']['input'];
  target: TargetAciInput;
};


export type QueryGetStockByTargetAndBarcodeCacheArgs = {
  barcode: Scalars['String']['input'];
  target: TargetAciInput;
};


export type QueryGetStocksByTargetArgs = {
  outOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetStocksByTargetInAllWarehousesArgs = {
  outOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetStoriesArgs = {
  filter: StoriesFilterInput;
};


export type QueryGetStoriesByTargetArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetWithGroupInput;
};


export type QueryGetStoriesViewsStatusArgs = {
  filter: StoriesViewsStatusFilterInput;
};


export type QueryGetStoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSubCategorySeoArgs = {
  categoryId: Scalars['ID']['input'];
};


export type QueryGetSubCategorySeojsonArgs = {
  categoryId: Scalars['ID']['input'];
};


export type QueryGetSubscribersToNewsletterArgs = {
  target: TargetAciInput;
};


export type QueryGetSubscribersToNewsletterPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetSuppliersStatsArgs = {
  input: AnalyticsDashboardInput;
};


export type QueryGetSuppliersTemplateByExcelArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTargetFreebiesWalletArgs = {
  target: TargetAciInput;
};


export type QueryGetTargetFundsWalletArgs = {
  target: TargetAciInput;
};


export type QueryGetTargetOrderInvoiceArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryGetTargetOrdersByExcelArgs = {
  input: MarketPlaceOrderFilterInput;
  path?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTargetPluginsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetTargetStatsArgs = {
  target: TargetAciInput;
};


export type QueryGetTargetSubscribersByCsvArgs = {
  input: GetTargetSubscribersByExcelInput;
};


export type QueryGetTargetSubscribersByExcelArgs = {
  input: GetTargetSubscribersByExcelInput;
};


export type QueryGetTargetSubscribersPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  status: Array<SubscriptionStatus>;
  target: TargetAciInput;
};


export type QueryGetTargetTransactionsArgs = {
  activityType?: InputMaybe<Array<ActivityLogTypeEnum>>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetTargetTransactionsByExcelArgs = {
  activityType?: InputMaybe<Array<ActivityLogTypeEnum>>;
  path?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetTargetUserCardsByCsvArgs = {
  cardType?: InputMaybe<CardTypeEnum>;
  path?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetTargetUserCardsByExcelArgs = {
  cardType?: InputMaybe<CardTypeEnum>;
  path?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetTargetUsersByCsvArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  sortingField?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<UserStatus>>;
  target: TargetAciInput;
};


export type QueryGetTargetUsersByExcelArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  sortingField?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<UserStatus>>;
  target: TargetAciInput;
};


export type QueryGetTargetUsersWithWalletsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetTargetWalletsArgs = {
  target: TargetAciInput;
};


export type QueryGetTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTaskSectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTaskSectionsArgs = {
  target: TargetAciInput;
};


export type QueryGetTaskSectionsByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetTaskSectionsWithTasksArgs = {
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetTasksBySectionArgs = {
  taskSection: Scalars['ID']['input'];
};


export type QueryGetTaxesByCompanyArgs = {
  company: Scalars['ID']['input'];
};


export type QueryGetTaxesByCompanyPaginatedArgs = {
  company: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTicketsByExcelArgs = {
  filter?: InputMaybe<TicketsFilterInput>;
  path?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetTicketsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetTicketsByTargetWithFilterArgs = {
  filter: TicketsFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetTicketsStatsWithFilterArgs = {
  filter: TicketsStatsFilterInput;
  target: TargetAciInput;
};


export type QueryGetTimeTracksByHolderArgs = {
  holder: TimeTrackOnInput;
};


export type QueryGetTimeTracksByHolderPaginatedArgs = {
  holder: TimeTrackOnInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetTopActivitiesDeductingPointsArgs = {
  target: TargetAciInput;
};


export type QueryGetTopPerformingQuestsArgs = {
  count: Scalars['Int']['input'];
  target: TargetAciInput;
};


export type QueryGetUpcomingChallengesByTargetAndUserAudiencePaginatedArgs = {
  filter: ChallengeByAudienceFilterInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetUpcomingChallengesByTargetAndUserAudienceWithLinkedAccountsPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetUserDistributionsByLevelArgs = {
  target: TargetAciInput;
};


export type QueryGetUserDistributionsByStateArgs = {
  target: TargetAciInput;
};


export type QueryGetUserSubscribedTargetsArgs = {
  statuses?: InputMaybe<Array<SubscriptionStatus>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserWalletTransactionsStatsByAffectedArgs = {
  affected: TargetAciInput;
};


export type QueryGetUserWalletWithReputationsArgs = {
  userToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUsersByPermissionPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  permission: Scalars['ID']['input'];
};


export type QueryGetUsersCumulativeCountArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  target: TargetAciInput;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryGetUsersMissingFieldsArgs = {
  target: TargetAciInput;
};


export type QueryGetUsersNonCumulativeCountArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  target: TargetAciInput;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryGetUsersPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<Array<UserStatus>>;
};


export type QueryGetUsersPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetUsersProfilesCompletnessByStageArgs = {
  target: TargetAciInput;
};


export type QueryGetVapidKeyArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetVersionArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetVersionsPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetVersionsWithFilterPaginatedArgs = {
  filter: VersionsFilterInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetWaitersByPossArgs = {
  pagination?: InputMaybe<PaginationInput>;
  posId: Scalars['String']['input'];
};


export type QueryGetWalletByOwnerWithReputationsArgs = {
  target: TargetAciInput;
  user: Scalars['ID']['input'];
};


export type QueryGetWalletTopupsByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetWalletTopupsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetWalletTopupsSettingsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetWalletTopupsSettingsByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetWalletTopupsSettingsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetWalletTopupsValueArgs = {
  amount: Scalars['String']['input'];
  wallet: Scalars['ID']['input'];
};


export type QueryGetWalletTransactionsByAffectedPaginatedArgs = {
  filter: WalletTransactionsByAffectedFilterInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetWalletTransactionsByAffectedPaginatedByCsvArgs = {
  filter?: InputMaybe<WalletTransactionsByAffectedFilterInput>;
  path?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetWalletTransactionsByAffectedPaginatedByExcelArgs = {
  filter?: InputMaybe<WalletTransactionsByAffectedFilterInput>;
  path?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetWalletTransactionsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetWalletTransactionsStatsByAffectedArgs = {
  affected: TargetAciInput;
};


export type QueryGetWalletTransactionsStatsChartWithFilterArgs = {
  filter: WalletTransactionsStatsChartFilterInput;
};


export type QueryGetWalletsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetWarehousesByCompanyArgs = {
  company: Scalars['ID']['input'];
};


export type QueryGetWarehousesByCompanyPaginatedArgs = {
  company: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetWebsiteIntegrationByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetWebsiteIntegrationByTargetCacheArgs = {
  target: TargetAciInput;
};


export type QueryGetWholesalersPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetWidgetDataArgs = {
  input: WidgetDataInput;
};


export type QueryGetWidgetForTargetArgs = {
  app: TranslationAppEnum;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetWidgetGuestUserForTargetArgs = {
  target: TargetTransferInput;
};


export type QueryGetWidgetIntegrationByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetWidgetIntegrationByTargetCacheArgs = {
  target: TargetAciInput;
};


export type QueryGetWidgetUserForTargetArgs = {
  target: TargetTransferInput;
  userToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetWidgetVisualsByTargetAndAppCacheArgs = {
  app: TranslationAppEnum;
  target: TargetAciInput;
};


export type QueryGetWidgetVisualsByTargetAndAppPaginatedArgs = {
  app: TranslationAppEnum;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetWidgetVisualsByTargetAndAppPaginatedCacheArgs = {
  app: TranslationAppEnum;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGoogleAnalyticsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHelpdeskIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIntegrationIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInventoryCategoryArgs = {
  id: Scalars['String']['input'];
};


export type QueryInventoryIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIsCouponValidArgs = {
  couponCode: Scalars['String']['input'];
  target: TargetAciInput;
};


export type QueryIsEmailExistArgs = {
  email: Scalars['String']['input'];
};


export type QueryIsFavoriteInternalProductArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryIsFavoriteProductArgs = {
  productId: Scalars['String']['input'];
};


export type QueryIsFreebiesRedeemableArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIsLoginExistArgs = {
  input: IsLoginExistInput;
};


export type QueryIsLoginForTargetExistArgs = {
  input: IsLoginForTargetExistInput;
};


export type QueryIsUserNearPosArgs = {
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
  posId: Scalars['ID']['input'];
};


export type QueryIsUserSubscribedToTargetArgs = {
  target: TargetAciInput;
};


export type QueryJobApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLabelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLandingPageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLoginArgs = {
  input: LoginInput;
};


export type QueryLoginForAppArgs = {
  input: LoginInput;
};


export type QueryLoginForTargetArgs = {
  login?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phone?: InputMaybe<IPhoneInput>;
  source?: InputMaybe<UserEventsSourceEnum>;
  target: TargetAciInput;
};


export type QueryLoginWithAppleArgs = {
  authorizationData: AuthorizationDataInput;
};


export type QueryLoginWithAppleForTargetArgs = {
  authorizationData: AuthorizationDataInput;
  target: TargetAciInput;
};


export type QueryLoginWithFacebookArgs = {
  token: Scalars['String']['input'];
};


export type QueryLoginWithFacebookForTargetArgs = {
  target: TargetAciInput;
  token: Scalars['String']['input'];
};


export type QueryLoginWithGoogleArgs = {
  token: Scalars['String']['input'];
};


export type QueryLoginWithGoogleForTargetArgs = {
  target: TargetAciInput;
  token: Scalars['String']['input'];
};


export type QueryLogisticArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLogisticsIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLogoutUserByTargetArgs = {
  input: LogoutUserByTargetInput;
};


export type QueryLogoutUserForTargetArgs = {
  source?: InputMaybe<UserEventsSourceEnum>;
};


export type QueryLoyaltyProgramArgs = {
  id: Scalars['String']['input'];
};


export type QueryManufacturerArgs = {
  id: Scalars['String']['input'];
};


export type QueryModuleAssignmentArgs = {
  id: Scalars['String']['input'];
};


export type QueryModuleDefinitionArgs = {
  id: Scalars['String']['input'];
};


export type QueryNotificationIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrderSettingsArgs = {
  id: Scalars['String']['input'];
};


export type QueryOutboundArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPartnerReferralArgs = {
  id: Scalars['String']['input'];
};


export type QueryPermissionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPermissionDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPointOfSaleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPointOfSaleByOriginArgs = {
  website?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPointOfSaleCacheArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPosCategoryArgs = {
  id: Scalars['String']['input'];
};


export type QueryPosServicesArgs = {
  id: Scalars['String']['input'];
};


export type QueryPredefinedArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPriceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductArgs = {
  id: Scalars['String']['input'];
};


export type QueryProductAttributeArgs = {
  id: Scalars['String']['input'];
};


export type QueryProductRatingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductRatingDefinitionArgs = {
  id: Scalars['String']['input'];
};


export type QueryProductclicksArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPromotionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPurchaseIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPurchaseInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPurchaseOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPurchasedeliverynoteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPushRechargeToUserArgs = {
  amount: Scalars['String']['input'];
  number: Scalars['String']['input'];
  operator: Scalars['String']['input'];
  points: Scalars['String']['input'];
  wallet: Scalars['ID']['input'];
};


export type QueryPushRunpayRechargeToUserArgs = {
  amount: Scalars['Float']['input'];
  number: Scalars['String']['input'];
  operator: RunpayOperatorEnum;
  points: Scalars['String']['input'];
  wallet: Scalars['ID']['input'];
};


export type QueryQuantitativeWalletsByOwnerPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<TargetTransferInput>;
};


export type QueryQuestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuestActionDefinitionArgs = {
  id: Scalars['String']['input'];
};


export type QueryQuestActivityArgs = {
  id: Scalars['String']['input'];
};


export type QueryQuestTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuotationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReferralArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRefreshAudienceViewsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReputationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryResponseArgs = {
  id: Scalars['String']['input'];
};


export type QuerySaleInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySaleIssueNoteArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySaleOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySaledeliverynoteArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySalesIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySearchAccountArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QuerySearchAttributeArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchAttributeByTargetArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
  variety?: InputMaybe<ProductVarietyEnum>;
};


export type QuerySearchAttributeValueArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchAttributeValueByTargetArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QuerySearchBarcodesByTargetArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QuerySearchBarcodesByTargetAndSupplierArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  supplier: Scalars['ID']['input'];
  target: TargetAciInput;
};


export type QuerySearchBarcodesByTargetWithStockArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QuerySearchBlogsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchBrandArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<TargetAciInput>;
};


export type QuerySearchCatalogueCategoriesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchCompanyArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchCorporateUsersByTargetArgs = {
  input: SearchCorporateUsersByTargetInput;
};


export type QuerySearchCustomersByTargetAndPhaseArgs = {
  pagination?: InputMaybe<PaginationInput>;
  phase: CustomerPhaseEnum;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QuerySearchDepartmentsByTargetArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QuerySearchFavoriteInternalProductArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchFavoriteProductArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchFormsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchInternalMessageGroupArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MessageGroupStatusEnum>;
  target: TargetAciInput;
};


export type QuerySearchInternalProductArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchInternalProductByCatalogueCategoryArgs = {
  catalogueCategoryId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchInternalProductByTargetArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QuerySearchInventoryCategoryArgs = {
  layer?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchJobDefinitionsByTargetArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<JobDefinitionStatusEnum>>;
  target: TargetAciInput;
};


export type QuerySearchLandingPagesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchLogisticCompaniesByTargetArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QuerySearchLoyaltyProgramArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchManufacturerArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchMessageByMessageGroupPaginationArgs = {
  messageGroup: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchMessageGroupArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MessageGroupStatusEnum>;
  target?: InputMaybe<TargetAciInput>;
  type?: InputMaybe<MessageGroupTypeEnum>;
};


export type QuerySearchPosNearbyPaginationArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
  pagination?: InputMaybe<PaginationInput>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  rad: Scalars['Float']['input'];
  searchString: Scalars['String']['input'];
};


export type QuerySearchPosArgs = {
  pagination?: InputMaybe<PaginationInput>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchPosCategoryArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchPosServicesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchProductArgs = {
  catId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchProductAttributeArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchProductAttributeByTargetArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QuerySearchQuestTypesByTargetWithFilterPaginatedArgs = {
  advertiser?: InputMaybe<TargetAciInput>;
  filter: QuestTypesFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QuerySearchResponseArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchSimpleBarcodesByTargetWithStockArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QuerySearchSimpleEquipmentsArgs = {
  searchInput: SearchSimpleProductInput;
};


export type QuerySearchSimpleServicesArgs = {
  searchInput: SearchSimpleProductInput;
};


export type QuerySearchSimpleStocksByTargetArgs = {
  outOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  sortingField?: InputMaybe<Scalars['String']['input']>;
  sortingOrder?: InputMaybe<Scalars['Float']['input']>;
  target: TargetAciInput;
  warehouses?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QuerySearchSlidesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchStocksByTargetArgs = {
  outOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  sortingField?: InputMaybe<Scalars['String']['input']>;
  sortingOrder?: InputMaybe<Scalars['Float']['input']>;
  target: TargetAciInput;
  warehouses?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QuerySearchSupplierPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QuerySearchSuppliersByTargetArgs = {
  kinds?: InputMaybe<Array<SupplierTypeEnum>>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QuerySearchSupportMessageGroupArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MessageGroupStatusEnum>;
  target: TargetAciInput;
};


export type QuerySearchTargetQualitativeWalletsArgs = {
  input: SearchTargetQualitativeWalletsPaginatedInput;
};


export type QuerySearchTargetSubscribersArgs = {
  input: SearchTargetSubscribersPaginatedInput;
};


export type QuerySearchUserArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchUserTargetSubscriptionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<SubscriptionStatus>>;
  target: TargetAciInput;
};


export type QuerySearchWholesalerArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySendAdhocCorporateNotificationTestArgs = {
  input: CorporateNotificationInput;
};


export type QuerySendAdhocNotificationTestArgs = {
  description: Scalars['String']['input'];
  picture: PictureInput;
  title: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QuerySendCatalogueTemplateBymailArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  subject: Scalars['String']['input'];
};


export type QuerySendCorporateEmailArgs = {
  input: CorporateEmailTempInput;
};


export type QuerySendCouponsBymailArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  filter?: InputMaybe<CouponFilterInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
};


export type QuerySendEmailArgs = {
  input: EmailTempInput;
};


export type QuerySendEmailSesArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  htmlBody: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  to: Array<Scalars['String']['input']>;
};


export type QuerySendEventTicketEmailArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySendFullCatalogueBymailArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  subject: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
  withStock: Scalars['Boolean']['input'];
};


export type QuerySendInvoicingBymailArgs = {
  category: SequenceCategoryEnum;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  filter?: InputMaybe<InvoicingFilterInput>;
  subject: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
};


export type QuerySendInvoicingPdfDocumentByEmailArgs = {
  document: EmailTempVariablesDocumentInput;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  subject: Scalars['String']['input'];
};


export type QuerySendInvoicingTemplateBymailArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  subject: Scalars['String']['input'];
};


export type QuerySendJobApplicationsByMailArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  filter?: InputMaybe<JobApplicationFilterInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
};


export type QuerySendJobDefinitionsBymailArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<JobDefinitionStatusEnum>>;
  subject: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
};


export type QuerySendLiveLeaderboardByCycleBymailArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  input?: InputMaybe<LeaderboardWithRequiredCycleInput>;
  subject: Scalars['String']['input'];
};


export type QuerySendNewslettersBymailArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
};


export type QuerySendNotificationArgs = {
  input: Array<NotificationIntergrationInput>;
  target: TargetAciInput;
};


export type QuerySendOrderByEmailAndSmsArgs = {
  orderId: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
  target: TargetAciInput;
};


export type QuerySendPosTemplateBymailArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  subject: Scalars['String']['input'];
};


export type QuerySendProjectsBymailArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  filter?: InputMaybe<ProjectFilterInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
};


export type QuerySendProjectsTemplateBymailArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  subject: Scalars['String']['input'];
};


export type QuerySendQualitativeWalletsBymailArgs = {
  input: SendTargetQualitativeWalletsByEmailInput;
};


export type QuerySendRequestsBymailArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
  type?: InputMaybe<RequestTypeEnum>;
};


export type QuerySendServicesCatalogueTemplateBymailArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  subject: Scalars['String']['input'];
};


export type QuerySendSimpleCatalogueByMailArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  sheets?: InputMaybe<Array<SheetsNames>>;
  subject: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
  variety?: InputMaybe<ProductVarietyEnum>;
};


export type QuerySendSmsArgs = {
  content: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  target: TargetAciInput;
};


export type QuerySendTargetOrdersBymailArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  input: MarketPlaceOrderFilterInput;
  subject: Scalars['String']['input'];
};


export type QuerySendTargetSubscribersBymailArgs = {
  input: SendTargetSubscribersBymailnput;
};


export type QuerySendTargetTransactionsBymailArgs = {
  activityType?: InputMaybe<Array<ActivityLogTypeEnum>>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
};


export type QuerySendTargetUserCardsBymailArgs = {
  cardType?: InputMaybe<CardTypeEnum>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  subject: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
};


export type QuerySendTargetUsersBymailArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  sortingField?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<UserStatus>>;
  subject: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
};


export type QuerySendThemAndLanguageToWidgetArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  reference: Scalars['String']['input'];
  target: TargetAciInput;
  theme?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySendTicketsBymailArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  filter?: InputMaybe<TicketsFilterInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
};


export type QuerySendUserAdhocNotificationArgs = {
  description: Scalars['String']['input'];
  executedAt?: InputMaybe<Scalars['DateTime']['input']>;
  picture: PictureInput;
  title: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryShoppingCartArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySlideArgs = {
  id: Scalars['String']['input'];
};


export type QuerySmsIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStaticTranslationArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupplierArgs = {
  id: Scalars['String']['input'];
};


export type QueryTargetHasStaticTranslationsReferenceArgs = {
  app: TranslationAppEnum;
  reference: Scalars['String']['input'];
  target: TargetAciInput;
};


export type QueryTargetPluginArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTaxArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTicketArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTimetrackArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUploadImageArgs = {
  localPath: Scalars['String']['input'];
  remotePath: Scalars['String']['input'];
};


export type QueryUserArgs = {
  id: Scalars['String']['input'];
};


export type QueryUserByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryValidateCatalogueByExcelArgs = {
  base64?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
};


export type QueryValidateRegisterPhoneNumberArgs = {
  phone: IPhoneInput;
  smsNumber: Scalars['Int']['input'];
};


export type QueryValidateShoppingCartByCurrentUserArgs = {
  location?: InputMaybe<LonLatInput>;
};


export type QueryValidateSmsCodeArgs = {
  input: ValidateSmsCodeInput;
};


export type QueryVerifyApiSettingsArgs = {
  input?: InputMaybe<VerifyApiSettingsInput>;
};


export type QueryVisualsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWalletArgs = {
  id: Scalars['String']['input'];
};


export type QueryWalletOwnerHasEnoughBalanceArgs = {
  input: WalletOwnerHasEnoughBalanceInput;
};


export type QueryWalletTopupArgs = {
  id: Scalars['String']['input'];
};


export type QueryWalletTopupSettingsArgs = {
  id: Scalars['String']['input'];
};


export type QueryWalletTransactionArgs = {
  id: Scalars['String']['input'];
};


export type QueryWalletsByOwnerArgs = {
  target?: InputMaybe<TargetTransferInput>;
};


export type QueryWalletsByOwnerPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target?: InputMaybe<TargetTransferInput>;
};


export type QueryWarehouseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWebsiteIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWholesalerArgs = {
  id: Scalars['String']['input'];
};


export type QueryWidgetIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWidgetVisualsArgs = {
  id: Scalars['ID']['input'];
};

export type QuestActionActionGameInput = {
  jigsaw?: InputMaybe<QuestActionActionPerformedInput>;
  memory?: InputMaybe<QuestActionActionPerformedInput>;
  quizz?: InputMaybe<QuestActionActionPerformedInput>;
  sliding?: InputMaybe<QuestActionActionPerformedInput>;
};

export type QuestActionActionGamePerformedType = {
  __typename?: 'QuestActionActionGamePerformedType';
  jigsaw?: Maybe<QuestActionActionPerformedType>;
  memory?: Maybe<QuestActionActionPerformedType>;
  quizz?: Maybe<QuestActionActionPerformedType>;
  sliding?: Maybe<QuestActionActionPerformedType>;
};

export type QuestActionActionPerformedInput = {
  performed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestActionActionPerformedType = {
  __typename?: 'QuestActionActionPerformedType';
  performed?: Maybe<Scalars['Boolean']['output']>;
};

export type QuestActionActionType = {
  __typename?: 'QuestActionActionType';
  api?: Maybe<QuestActionActionPerformedType>;
  appDownload?: Maybe<QuestActionActionPerformedType>;
  form?: Maybe<QuestActionFormType>;
  game?: Maybe<QuestActionActionGamePerformedType>;
  lead?: Maybe<QuestActionActionPerformedType>;
  socialMedia?: Maybe<QuestActionActionPerformedType>;
  video?: Maybe<QuestActionActionPerformedType>;
};

export type QuestActionActivityApiInput = {
  activity?: InputMaybe<Scalars['ID']['input']>;
  params?: InputMaybe<Array<KeyValueInput>>;
};

export type QuestActionActivityWatchedInput = {
  activity?: InputMaybe<Scalars['ID']['input']>;
  watched?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestActionCheckInput = {
  card?: InputMaybe<Scalars['String']['input']>;
  coin?: InputMaybe<Scalars['ID']['input']>;
  referral?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<TargetAciInput>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type QuestActionDefinitionDefinitionApiInput = {
  headers?: InputMaybe<Array<KeyValueInput>>;
  link?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<ApiMethods>;
  params?: InputMaybe<Array<QuestActionDefinitionDefinitionApiParamsInput>>;
};

export type QuestActionDefinitionDefinitionApiParamsInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<QuestActionDefinitionDefinitionApiParamsUserInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type QuestActionDefinitionDefinitionApiParamsType = {
  __typename?: 'QuestActionDefinitionDefinitionApiParamsType';
  key?: Maybe<Scalars['String']['output']>;
  user?: Maybe<QuestActionDefinitionDefinitionApiParamsUserType>;
  value?: Maybe<Scalars['String']['output']>;
};

export type QuestActionDefinitionDefinitionApiParamsUserInput = {
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type QuestActionDefinitionDefinitionApiParamsUserType = {
  __typename?: 'QuestActionDefinitionDefinitionApiParamsUserType';
  enable?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type QuestActionDefinitionDefinitionApiType = {
  __typename?: 'QuestActionDefinitionDefinitionApiType';
  headers?: Maybe<Array<KeyValueType>>;
  link?: Maybe<Scalars['String']['output']>;
  method?: Maybe<ApiMethods>;
  params?: Maybe<Array<QuestActionDefinitionDefinitionApiParamsType>>;
};

export type QuestActionDefinitionDefinitionAppDownloadInput = {
  appgallery?: InputMaybe<Scalars['String']['input']>;
  appstore?: InputMaybe<Scalars['String']['input']>;
  playstore?: InputMaybe<Scalars['String']['input']>;
};

export type QuestActionDefinitionDefinitionAppDownloadType = {
  __typename?: 'QuestActionDefinitionDefinitionAppDownloadType';
  appgallery?: Maybe<Scalars['String']['output']>;
  appstore?: Maybe<Scalars['String']['output']>;
  playstore?: Maybe<Scalars['String']['output']>;
};

export type QuestActionDefinitionDefinitionGameInput = {
  gameType?: InputMaybe<GameTypeEnum>;
  jigsaw?: InputMaybe<QuestActionDefinitionDefinitionGameJigsawInput>;
  memory?: InputMaybe<QuestActionDefinitionDefinitionGameMemoryInput>;
  quizz?: InputMaybe<QuestActionDefinitionDefinitionGameQuizzInput>;
  sliding?: InputMaybe<QuestActionDefinitionDefinitionGamePuzzleInput>;
};

export type QuestActionDefinitionDefinitionGameJigsawInput = {
  picture?: InputMaybe<PictureInput>;
  pieces?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestActionDefinitionDefinitionGameJigsawType = {
  __typename?: 'QuestActionDefinitionDefinitionGameJigsawType';
  picture?: Maybe<PictureType>;
  pieces?: Maybe<Scalars['Int']['output']>;
};

export type QuestActionDefinitionDefinitionGameMemoryInput = {
  pictures?: InputMaybe<Array<PictureInput>>;
  setup?: InputMaybe<MemorySetupEnum>;
  timer?: InputMaybe<GameTimerEnum>;
};

export type QuestActionDefinitionDefinitionGameMemoryType = {
  __typename?: 'QuestActionDefinitionDefinitionGameMemoryType';
  pictures?: Maybe<Array<PictureType>>;
  setup?: Maybe<MemorySetupEnum>;
  timer?: Maybe<GameTimerEnum>;
};

export type QuestActionDefinitionDefinitionGamePuzzleInput = {
  picture?: InputMaybe<PictureInput>;
  threshold?: InputMaybe<Array<QuestActionDefinitionDefinitionGamePuzzleThresholdInput>>;
};

export type QuestActionDefinitionDefinitionGamePuzzleThresholdInput = {
  bonus?: InputMaybe<Array<RemunerationInput>>;
  timer?: InputMaybe<GameTimerEnum>;
};

export type QuestActionDefinitionDefinitionGamePuzzleThresholdType = {
  __typename?: 'QuestActionDefinitionDefinitionGamePuzzleThresholdType';
  bonus?: Maybe<Array<RemunerationDtoType>>;
  timer?: Maybe<GameTimerEnum>;
};

export type QuestActionDefinitionDefinitionGamePuzzleType = {
  __typename?: 'QuestActionDefinitionDefinitionGamePuzzleType';
  picture?: Maybe<PictureType>;
  threshold?: Maybe<Array<QuestActionDefinitionDefinitionGamePuzzleThresholdType>>;
};

export type QuestActionDefinitionDefinitionGameQuizzChoicesInput = {
  correct?: InputMaybe<Scalars['Boolean']['input']>;
  item?: InputMaybe<Scalars['String']['input']>;
};

export type QuestActionDefinitionDefinitionGameQuizzChoicesType = {
  __typename?: 'QuestActionDefinitionDefinitionGameQuizzChoicesType';
  correct?: Maybe<Scalars['Boolean']['output']>;
  item?: Maybe<Scalars['String']['output']>;
};

export type QuestActionDefinitionDefinitionGameQuizzInput = {
  choices?: InputMaybe<Array<QuestActionDefinitionDefinitionGameQuizzChoicesInput>>;
  picture?: InputMaybe<PictureInput>;
  quizzType?: InputMaybe<QuestionTypeEnum>;
};

export type QuestActionDefinitionDefinitionGameQuizzType = {
  __typename?: 'QuestActionDefinitionDefinitionGameQuizzType';
  choices?: Maybe<Array<QuestActionDefinitionDefinitionGameQuizzChoicesType>>;
  picture?: Maybe<PictureType>;
  quizzType?: Maybe<QuestionTypeEnum>;
};

export type QuestActionDefinitionDefinitionGameType = {
  __typename?: 'QuestActionDefinitionDefinitionGameType';
  gameType?: Maybe<GameTypeEnum>;
  jigsaw?: Maybe<QuestActionDefinitionDefinitionGameJigsawType>;
  memory?: Maybe<QuestActionDefinitionDefinitionGameMemoryType>;
  quizz?: Maybe<QuestActionDefinitionDefinitionGameQuizzType>;
  sliding?: Maybe<QuestActionDefinitionDefinitionGamePuzzleType>;
};

export type QuestActionDefinitionDefinitionInput = {
  api?: InputMaybe<QuestActionDefinitionDefinitionApiInput>;
  appDownload?: InputMaybe<QuestActionDefinitionDefinitionAppDownloadInput>;
  form?: InputMaybe<QuestActionDefinitionDefinitionQuestionInput>;
  game?: InputMaybe<QuestActionDefinitionDefinitionGameInput>;
  lead?: InputMaybe<QuestActionDefinitionDefinitionLeadInput>;
  socialMedia?: InputMaybe<QuestActionDefinitionDefinitionSocialMediaInput>;
  video?: InputMaybe<QuestActionDefinitionDefinitionVideoInput>;
};

export type QuestActionDefinitionDefinitionLeadInput = {
  image?: InputMaybe<Scalars['String']['input']>;
  minSeconds?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type QuestActionDefinitionDefinitionLeadType = {
  __typename?: 'QuestActionDefinitionDefinitionLeadType';
  image?: Maybe<Scalars['String']['output']>;
  minSeconds?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type QuestActionDefinitionDefinitionQuestionInput = {
  form?: InputMaybe<Scalars['ID']['input']>;
  random?: InputMaybe<Scalars['Boolean']['input']>;
  scoring?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestActionDefinitionDefinitionQuestionType = {
  __typename?: 'QuestActionDefinitionDefinitionQuestionType';
  form?: Maybe<FormDtoType>;
  random?: Maybe<Scalars['Boolean']['output']>;
  scoring?: Maybe<Scalars['Boolean']['output']>;
};

export type QuestActionDefinitionDefinitionSocialMediaInput = {
  action?: InputMaybe<SocialActionEnum>;
  hashtag?: InputMaybe<Scalars['String']['input']>;
  socialContent?: InputMaybe<SocialContentTypeEnum>;
  socialMedia?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type QuestActionDefinitionDefinitionSocialMediaType = {
  __typename?: 'QuestActionDefinitionDefinitionSocialMediaType';
  action?: Maybe<SocialActionEnum>;
  hashtag?: Maybe<Scalars['String']['output']>;
  socialContent?: Maybe<SocialContentTypeEnum>;
  socialMedia?: Maybe<SocialType>;
  url?: Maybe<Scalars['String']['output']>;
};

export type QuestActionDefinitionDefinitionType = {
  __typename?: 'QuestActionDefinitionDefinitionType';
  api?: Maybe<QuestActionDefinitionDefinitionApiType>;
  appDownload?: Maybe<QuestActionDefinitionDefinitionAppDownloadType>;
  form?: Maybe<QuestActionDefinitionDefinitionQuestionType>;
  game?: Maybe<QuestActionDefinitionDefinitionGameType>;
  lead?: Maybe<QuestActionDefinitionDefinitionLeadType>;
  socialMedia?: Maybe<QuestActionDefinitionDefinitionSocialMediaType>;
  video?: Maybe<QuestActionDefinitionDefinitionVideoType>;
};

export type QuestActionDefinitionDefinitionVideoInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  minSeconds?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<QuestActionDefinitionVideo>;
};

export type QuestActionDefinitionDefinitionVideoType = {
  __typename?: 'QuestActionDefinitionDefinitionVideoType';
  action?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  minSeconds?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<QuestActionDefinitionVideo>;
};

export type QuestActionDefinitionInput = {
  activityType?: InputMaybe<Scalars['String']['input']>;
  definition?: InputMaybe<QuestActionDefinitionDefinitionInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestActionDefinitionPaginateType = {
  __typename?: 'QuestActionDefinitionPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<QuestActionDefinitionType>;
};

export type QuestActionDefinitionType = {
  __typename?: 'QuestActionDefinitionType';
  activityType?: Maybe<ActivityTypeType>;
  createdAt: Scalars['DateTime']['output'];
  definition?: Maybe<QuestActionDefinitionDefinitionType>;
  id: Scalars['ID']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum QuestActionDefinitionVideo {
  FACEBOOK_REEL = 'FACEBOOK_REEL',
  FACEBOOK_VIDEO = 'FACEBOOK_VIDEO',
  FILE = 'FILE',
  PICTURE = 'PICTURE',
  TIKTOK_REEL = 'TIKTOK_REEL',
  YOUTUBE = 'YOUTUBE',
  YOUTUBE_SHORT = 'YOUTUBE_SHORT'
}

export type QuestActionDeviceDataType = {
  __typename?: 'QuestActionDeviceDataType';
  brand?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
};

export type QuestActionFormType = {
  __typename?: 'QuestActionFormType';
  form?: Maybe<FormDtoType>;
  performed?: Maybe<Scalars['Boolean']['output']>;
};

export type QuestActionGameInput = {
  activity: Scalars['ID']['input'];
  duration: Scalars['Int']['input'];
  movesCount: Scalars['Int']['input'];
  timer?: InputMaybe<GameTimerEnum>;
};

export type QuestActionPaginateType = {
  __typename?: 'QuestActionPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<QuestActionType>;
};

export type QuestActionSuccessType = {
  __typename?: 'QuestActionSuccessType';
  deductedAmount?: Maybe<Scalars['Decimal']['output']>;
  fundsWallet?: Maybe<PushResponseWalletType>;
  message: Scalars['String']['output'];
  qualitativeAmount?: Maybe<Scalars['Decimal']['output']>;
  quantitativeAmount?: Maybe<Scalars['Decimal']['output']>;
  success: Scalars['Boolean']['output'];
  wallet?: Maybe<PushResponseWalletType>;
};

export type QuestActionType = {
  __typename?: 'QuestActionType';
  action: QuestActionActionType;
  activity: QuestActivityType;
  createdAt: Scalars['DateTime']['output'];
  deviceData?: Maybe<QuestActionDeviceDataType>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type QuestActionsRecurrenceInput = {
  cycle?: InputMaybe<Scalars['Int']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestActionsRecurrenceType = {
  __typename?: 'QuestActionsRecurrenceType';
  cycle?: Maybe<Scalars['Int']['output']>;
  enable?: Maybe<Scalars['Boolean']['output']>;
};

export type QuestActivityInput = {
  activity?: InputMaybe<IQuestActivityActivitiesInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  quest: Scalars['ID']['input'];
  rank?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type QuestActivityIntType = {
  __typename?: 'QuestActivityIntType';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<MediaType>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type QuestActivityPaginateType = {
  __typename?: 'QuestActivityPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<QuestActivityType>;
};

export type QuestActivityType = {
  __typename?: 'QuestActivityType';
  activity?: Maybe<IQuestActivityActivitiesType>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<MediaType>;
  quest?: Maybe<QuestType>;
  rank?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuestAnalyticsType = {
  __typename?: 'QuestAnalyticsType';
  click?: Maybe<Scalars['Boolean']['output']>;
  hover?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  impressionRendered?: Maybe<Scalars['Boolean']['output']>;
  impressionViewed?: Maybe<Scalars['Boolean']['output']>;
  impressionVisible?: Maybe<Scalars['Boolean']['output']>;
  quest?: Maybe<Scalars['ID']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  target?: Maybe<TargetType>;
  user?: Maybe<UserType>;
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type QuestAnalyticsUpdateInput = {
  click?: InputMaybe<Scalars['Boolean']['input']>;
  hover?: InputMaybe<Scalars['Boolean']['input']>;
  impressionRendered?: InputMaybe<Scalars['Boolean']['input']>;
  impressionViewed?: InputMaybe<Scalars['Boolean']['input']>;
  impressionVisible?: InputMaybe<Scalars['Boolean']['input']>;
  quest: Scalars['ID']['input'];
  sessionId: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export type QuestAudienceSegmentFilterValuesAnswersInput = {
  date?: InputMaybe<TimeFromToInput>;
  multipleChoices?: InputMaybe<Array<Scalars['String']['input']>>;
  number?: InputMaybe<QuestAudienceSegmentFilterValuesAnswersNumberInput>;
  paragraph?: InputMaybe<Array<Scalars['String']['input']>>;
  rating?: InputMaybe<Array<Scalars['Int']['input']>>;
  shortAnswer?: InputMaybe<Array<Scalars['String']['input']>>;
  singleChoice?: InputMaybe<Array<Scalars['String']['input']>>;
  smiley?: InputMaybe<Array<ResponseAnswerSmileyObjInput>>;
};

export type QuestAudienceSegmentFilterValuesAnswersNumberInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type QuestAudienceSegmentFilterValuesAnswersNumberType = {
  __typename?: 'QuestAudienceSegmentFilterValuesAnswersNumberType';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type QuestAudienceSegmentFrequencyInput = {
  frequency?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<PeriodCycleEnum>;
};

export type QuestAudienceSegmentFrequencyType = {
  __typename?: 'QuestAudienceSegmentFrequencyType';
  frequency?: Maybe<Scalars['Int']['output']>;
  period?: Maybe<PeriodCycleEnum>;
};

export type QuestBudgetStatsChartsDataItemType = {
  __typename?: 'QuestBudgetStatsChartsDataItemType';
  day: Scalars['Int']['output'];
  stats: QuestBudgetStatsChartsType;
};

export type QuestBudgetStatsChartsReturnType = {
  __typename?: 'QuestBudgetStatsChartsReturnType';
  CPA?: Maybe<Array<Array<Scalars['Float']['output']>>>;
  CPC?: Maybe<Array<Array<Scalars['Float']['output']>>>;
  CPM?: Maybe<Array<Array<Scalars['Float']['output']>>>;
  clicks?: Maybe<Array<Array<Scalars['Float']['output']>>>;
  conversion?: Maybe<Array<Array<Scalars['Float']['output']>>>;
  impressions?: Maybe<Array<Array<Scalars['Float']['output']>>>;
};

export type QuestBudgetStatsChartsType = {
  __typename?: 'QuestBudgetStatsChartsType';
  CPA: Scalars['String']['output'];
  CPC: Scalars['String']['output'];
  CPM: Scalars['String']['output'];
  CTR: Scalars['String']['output'];
  amountSpent: Scalars['String']['output'];
  clicks: Scalars['String']['output'];
  conversion: Scalars['String']['output'];
  conversionRate: Scalars['String']['output'];
  impressions: Scalars['String']['output'];
};

export type QuestBudgetType = {
  __typename?: 'QuestBudgetType';
  budget?: Maybe<Scalars['Decimal']['output']>;
  maxAnswers?: Maybe<Scalars['Int']['output']>;
  pricePerUser?: Maybe<Scalars['Decimal']['output']>;
  remainingBudget?: Maybe<Scalars['Decimal']['output']>;
  remainingCoins?: Maybe<Scalars['Decimal']['output']>;
};

export enum QuestCategoryEnum {
  FAMILY = 'FAMILY',
  FITNESS = 'FITNESS',
  GASTRONOMY = 'GASTRONOMY',
  INDUSTRY = 'INDUSTRY'
}

export type QuestConversionStatsDataItemType = {
  __typename?: 'QuestConversionStatsDataItemType';
  day: Scalars['Int']['output'];
  stats: QuestConversionStatsType;
};

export type QuestConversionStatsEntryType = {
  __typename?: 'QuestConversionStatsEntryType';
  data: Array<QuestConversionStatsDataItemType>;
  year: Scalars['Int']['output'];
};

export type QuestConversionStatsSummedType = {
  __typename?: 'QuestConversionStatsSummedType';
  CPA: Scalars['String']['output'];
  CPC: Scalars['String']['output'];
  CPM: Scalars['String']['output'];
  CTR: Scalars['String']['output'];
  amountSpent: Scalars['String']['output'];
  clicks: Scalars['String']['output'];
  conversion: Scalars['String']['output'];
  conversionRate: Scalars['String']['output'];
  impressions: Scalars['String']['output'];
};

export type QuestConversionStatsType = {
  __typename?: 'QuestConversionStatsType';
  CPA: Scalars['String']['output'];
  CPC: Scalars['String']['output'];
  CPM: Scalars['String']['output'];
  CTR: Scalars['String']['output'];
  amountSpent: Scalars['String']['output'];
  clicks: Scalars['String']['output'];
  conversion: Scalars['String']['output'];
  conversionRate: Scalars['String']['output'];
  impressions: Scalars['String']['output'];
};

export type QuestDashboardFilterInput = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  questTypes?: InputMaybe<QuestDashboardTypesFilterInput>;
  quests?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Source IDs to filter - references nested source in dashboard data (getQuestConversionStats, etc.), NOT quest source */
  sources?: InputMaybe<Array<Scalars['ID']['input']>>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuestDashboardType = {
  __typename?: 'QuestDashboardType';
  averageRatio?: Maybe<Scalars['Decimal']['output']>;
  finishedQuests?: Maybe<Scalars['Int']['output']>;
  questActions?: Maybe<Scalars['Int']['output']>;
  questActionsUsers?: Maybe<Scalars['Int']['output']>;
  totalQuests?: Maybe<Scalars['Int']['output']>;
};

export type QuestDashboardTypesFilterInput = {
  api?: InputMaybe<Scalars['Boolean']['input']>;
  appDownload?: InputMaybe<Scalars['Boolean']['input']>;
  form?: InputMaybe<Scalars['Boolean']['input']>;
  games?: InputMaybe<Array<GameTypeEnum>>;
  lead?: InputMaybe<Scalars['Boolean']['input']>;
  socialMedia?: InputMaybe<Array<Scalars['ID']['input']>>;
  videos?: InputMaybe<Array<QuestActionDefinitionVideo>>;
};

export type QuestInput = {
  activityType?: InputMaybe<Scalars['ID']['input']>;
  advertiser?: InputMaybe<TargetAciInput>;
  audience?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<QuestCategoryEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  leaderboard?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<MediaInput>;
  questType?: InputMaybe<Scalars['ID']['input']>;
  recurrence?: InputMaybe<QuestActionsRecurrenceInput>;
  remuneration?: InputMaybe<Array<QuestRemunerationInput>>;
  rewards?: InputMaybe<Scalars['String']['input']>;
  sponsored?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<QuestStatusEnum>;
  target: TargetAciInput;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type QuestKpiDashboardType = {
  __typename?: 'QuestKPIDashboardType';
  earningsAmount?: Maybe<DateStatsType>;
  earningsValue?: Maybe<DateStatsType>;
  questActionsUsers?: Maybe<DateStatsType>;
  quests?: Maybe<DateStatsType>;
};

export type QuestOverviewType = {
  __typename?: 'QuestOverviewType';
  consumedBudget?: Maybe<AmountPercentageDecimalType>;
  totalActions?: Maybe<AmountPercentageDecimalType>;
  totalAudience?: Maybe<AmountPercentageDecimalType>;
  totalBudget?: Maybe<AmountPercentageDecimalType>;
  totalReplies?: Maybe<AmountPercentageDecimalType>;
  totalSteps?: Maybe<AmountPercentageDecimalType>;
};

export type QuestPaginateType = {
  __typename?: 'QuestPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<QuestType>;
};

export type QuestPerformanceMetricsStatsDashboardType = {
  __typename?: 'QuestPerformanceMetricsStatsDashboardType';
  actionsCount: Scalars['Float']['output'];
  objectives: Scalars['Float']['output'];
  usersCount: Scalars['Float']['output'];
};

export type QuestPerformanceOverTimeChartType = {
  __typename?: 'QuestPerformanceOverTimeChartType';
  clicks: Array<YearlyChartType>;
  conversion: Array<YearlyChartType>;
  impressions: Array<YearlyChartType>;
};

export type QuestPerformedType = {
  __typename?: 'QuestPerformedType';
  activityType?: Maybe<ActivityTypeType>;
  advertiser?: Maybe<TargetType>;
  audience?: Maybe<AudienceType>;
  budget?: Maybe<QuestBudgetType>;
  category?: Maybe<QuestCategoryEnum>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  leaderboard?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<MediaType>;
  performed?: Maybe<Scalars['Boolean']['output']>;
  progress?: Maybe<Scalars['Decimal']['output']>;
  questType?: Maybe<QuestTypeType>;
  recurrence?: Maybe<QuestActionsRecurrenceType>;
  remuneration?: Maybe<Array<RemunerationDtoType>>;
  rewards?: Maybe<Scalars['String']['output']>;
  sponsored?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<QuestStatusEnum>;
  target: TargetType;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuestRecurrencyStatusType = {
  __typename?: 'QuestRecurrencyStatusType';
  isReccurent: Scalars['Boolean']['output'];
  repeatDate?: Maybe<Scalars['DateTime']['output']>;
};

export type QuestRemunerationInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  wallet?: InputMaybe<Scalars['ID']['input']>;
  walletType: WalletTypeEnum;
};

export type QuestStatisticsChartType = {
  __typename?: 'QuestStatisticsChartType';
  actions: Array<Array<Scalars['Float']['output']>>;
  budget: Array<Array<Scalars['Float']['output']>>;
  replies: Array<Array<Scalars['Float']['output']>>;
};

export type QuestStatisticsType = {
  __typename?: 'QuestStatisticsType';
  chart?: Maybe<QuestStatisticsChartType>;
  lastDayActions?: Maybe<Scalars['Decimal']['output']>;
  lastDayBudget?: Maybe<Scalars['Decimal']['output']>;
  lastDayReplies?: Maybe<Scalars['Decimal']['output']>;
  totalReplies?: Maybe<Scalars['Decimal']['output']>;
};

export type QuestStatsType = {
  __typename?: 'QuestStatsType';
  quest?: Maybe<QuestWithoutTargetType>;
  questActionsCount?: Maybe<Scalars['Float']['output']>;
};

export enum QuestStatusEnum {
  DRAFT = 'DRAFT',
  FINISHED = 'FINISHED',
  IN_REVIEW = 'IN_REVIEW',
  ONGOING = 'ONGOING',
  ON_HOLD = 'ON_HOLD'
}

export type QuestTopAggregateDashboardType = {
  __typename?: 'QuestTopAggregateDashboardType';
  ongoingQuests?: Maybe<Scalars['Int']['output']>;
  rewardsAmount?: Maybe<Scalars['Decimal']['output']>;
  rewardsValue?: Maybe<Scalars['Decimal']['output']>;
  totalQuests?: Maybe<Scalars['Int']['output']>;
  totalUsers?: Maybe<Scalars['Int']['output']>;
};

export type QuestType = {
  __typename?: 'QuestType';
  activityType?: Maybe<ActivityTypeType>;
  advertiser?: Maybe<TargetType>;
  audience?: Maybe<AudienceType>;
  budget?: Maybe<QuestBudgetType>;
  category?: Maybe<QuestCategoryEnum>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  leaderboard?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<MediaType>;
  progress?: Maybe<Scalars['Decimal']['output']>;
  questType?: Maybe<QuestTypeType>;
  recurrence?: Maybe<QuestActionsRecurrenceType>;
  remuneration?: Maybe<Array<RemunerationDtoType>>;
  rewards?: Maybe<Scalars['String']['output']>;
  sponsored?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<QuestStatusEnum>;
  target: TargetType;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuestTypeAudienceInput = {
  criteria?: InputMaybe<Scalars['ID']['input']>;
  fields?: InputMaybe<Array<AudienceCriteriaFieldInput>>;
};

export type QuestTypeAudienceType = {
  __typename?: 'QuestTypeAudienceType';
  criteria?: Maybe<AudienceCriteriaType>;
  fields?: Maybe<Array<AudienceCriteriaFieldType>>;
};

export type QuestTypeInput = {
  activityTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  advertiser?: InputMaybe<TargetAciInput>;
  audience?: InputMaybe<Array<QuestTypeAudienceInput>>;
  condition?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  maxActivities?: InputMaybe<Scalars['Int']['input']>;
  maxQuestions?: InputMaybe<Scalars['Int']['input']>;
  media?: InputMaybe<MediaInput>;
  profile?: InputMaybe<Scalars['Boolean']['input']>;
  qualitative?: InputMaybe<QuestTypeRemunerationInput>;
  quantitative?: InputMaybe<QuestTypeRemunerationInput>;
  questionTypes?: InputMaybe<Array<QuestionTypeEnum>>;
  rewardPoints?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Boolean']['input']>;
  social?: InputMaybe<Array<Scalars['ID']['input']>>;
  target?: InputMaybe<TargetAciInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  transition?: InputMaybe<Scalars['Boolean']['input']>;
  wallet?: InputMaybe<Scalars['ID']['input']>;
};

export type QuestTypePaginateType = {
  __typename?: 'QuestTypePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<QuestTypeType>;
};

export type QuestTypeRemunerationInput = {
  max?: InputMaybe<Scalars['String']['input']>;
  min?: InputMaybe<Scalars['String']['input']>;
};

export type QuestTypeRemunerationType = {
  __typename?: 'QuestTypeRemunerationType';
  max?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
};

export type QuestTypeType = {
  __typename?: 'QuestTypeType';
  activityTypes?: Maybe<Array<ActivityTypeType>>;
  admin?: Maybe<Scalars['Boolean']['output']>;
  advertiser?: Maybe<TargetType>;
  audience?: Maybe<Array<QuestTypeAudienceType>>;
  condition?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enable?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maxActivities?: Maybe<Scalars['Int']['output']>;
  maxQuestions?: Maybe<Scalars['Int']['output']>;
  media?: Maybe<MediaType>;
  profile?: Maybe<Scalars['Boolean']['output']>;
  qualitative?: Maybe<QuestTypeRemunerationType>;
  quantitative?: Maybe<QuestTypeRemunerationType>;
  questionTypes?: Maybe<Array<QuestionTypeEnum>>;
  rewardPoints?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Boolean']['output']>;
  social?: Maybe<Array<SocialType>>;
  target?: Maybe<TargetType>;
  title?: Maybe<Scalars['String']['output']>;
  transition?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  wallet?: Maybe<WalletType>;
};

export type QuestTypesFilterInput = {
  activityTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  condition?: InputMaybe<Scalars['Boolean']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  maxActivities?: InputMaybe<NumberRangeInput>;
  maxQuestions?: InputMaybe<NumberRangeInput>;
  profile?: InputMaybe<Scalars['Boolean']['input']>;
  questionTypes?: InputMaybe<Array<QuestionTypeEnum>>;
  rewardPoints?: InputMaybe<NumberRangeInput>;
  score?: InputMaybe<Scalars['Boolean']['input']>;
  transition?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestTypesStatsDashboardType = {
  __typename?: 'QuestTypesStatsDashboardType';
  api?: Maybe<Scalars['Int']['output']>;
  appDownload?: Maybe<Scalars['Int']['output']>;
  form?: Maybe<Scalars['Int']['output']>;
  jigsaw?: Maybe<Scalars['Int']['output']>;
  lead?: Maybe<Scalars['Int']['output']>;
  memory?: Maybe<Scalars['Int']['output']>;
  puzzle?: Maybe<Scalars['Int']['output']>;
  quizz?: Maybe<Scalars['Int']['output']>;
  sliding?: Maybe<Scalars['Int']['output']>;
  socialMedia?: Maybe<Scalars['Int']['output']>;
  video?: Maybe<Scalars['Int']['output']>;
};

export type QuestUpdateInput = {
  activityType?: InputMaybe<Scalars['ID']['input']>;
  audience?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<QuestCategoryEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  leaderboard?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<MediaInput>;
  questType?: InputMaybe<Scalars['ID']['input']>;
  recurrence?: InputMaybe<QuestActionsRecurrenceInput>;
  remuneration?: InputMaybe<Array<QuestRemunerationInput>>;
  rewards?: InputMaybe<Scalars['String']['input']>;
  sponsored?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<QuestStatusEnum>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type QuestWithActionsType = {
  __typename?: 'QuestWithActionsType';
  actions?: Maybe<Scalars['Int']['output']>;
  activityType?: Maybe<ActivityTypeType>;
  advertiser?: Maybe<TargetType>;
  audience?: Maybe<AudienceType>;
  budget?: Maybe<QuestBudgetType>;
  category?: Maybe<QuestCategoryEnum>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  leaderboard?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<MediaType>;
  progress?: Maybe<Scalars['Decimal']['output']>;
  questType?: Maybe<QuestTypeType>;
  recurrence?: Maybe<QuestActionsRecurrenceType>;
  remuneration?: Maybe<Array<RemunerationDtoType>>;
  rewards?: Maybe<Scalars['String']['output']>;
  sponsored?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<QuestStatusEnum>;
  target: TargetType;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuestWithPerformedPaginateType = {
  __typename?: 'QuestWithPerformedPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<QuestPerformedType>;
};

export type QuestWithQualitativePictureType = {
  __typename?: 'QuestWithQualitativePictureType';
  activityType?: Maybe<ActivityTypeType>;
  advertiser?: Maybe<TargetType>;
  audience?: Maybe<AudienceType>;
  budget?: Maybe<QuestBudgetType>;
  category?: Maybe<QuestCategoryEnum>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isAccountLinked?: Maybe<Scalars['Boolean']['output']>;
  leaderboard?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<MediaType>;
  performed?: Maybe<Scalars['Boolean']['output']>;
  progress?: Maybe<Scalars['Decimal']['output']>;
  qualitativePicture?: Maybe<PictureType>;
  questType?: Maybe<QuestTypeType>;
  recurrence?: Maybe<QuestActionsRecurrenceType>;
  remuneration?: Maybe<Array<RemunerationDtoType>>;
  rewards?: Maybe<Scalars['String']['output']>;
  sponsored?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<QuestStatusEnum>;
  target: TargetType;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuestWithRepeatDateType = {
  __typename?: 'QuestWithRepeatDateType';
  activityType?: Maybe<ActivityTypeType>;
  advertiser?: Maybe<TargetType>;
  audience?: Maybe<AudienceType>;
  budget?: Maybe<QuestBudgetType>;
  category?: Maybe<QuestCategoryEnum>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  leaderboard?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<MediaType>;
  progress?: Maybe<Scalars['Decimal']['output']>;
  questType?: Maybe<QuestTypeType>;
  recurrence?: Maybe<QuestActionsRecurrenceType>;
  remuneration?: Maybe<Array<RemunerationDtoType>>;
  repeatDate?: Maybe<Scalars['DateTime']['output']>;
  rewards?: Maybe<Scalars['String']['output']>;
  sponsored?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<QuestStatusEnum>;
  target: TargetType;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuestWithoutTargetType = {
  __typename?: 'QuestWithoutTargetType';
  activityType?: Maybe<ActivityTypeType>;
  audience?: Maybe<AudienceType>;
  budget?: Maybe<QuestBudgetType>;
  category?: Maybe<QuestCategoryEnum>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  leaderboard?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<MediaType>;
  progress?: Maybe<Scalars['Decimal']['output']>;
  questType?: Maybe<QuestTypeType>;
  recurrence?: Maybe<QuestActionsRecurrenceType>;
  remuneration?: Maybe<Array<RemunerationDtoType>>;
  rewards?: Maybe<Scalars['String']['output']>;
  sponsored?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<QuestStatusEnum>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuestionChoiceDtoType = {
  __typename?: 'QuestionChoiceDtoType';
  enable?: Maybe<Scalars['Boolean']['output']>;
  item: Scalars['String']['output'];
};

export type QuestionChoiceInput = {
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  item: Scalars['String']['input'];
};

export type QuestionDtoType = {
  __typename?: 'QuestionDtoType';
  choices?: Maybe<Array<QuestionChoiceDtoType>>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  form?: Maybe<FormDtoType>;
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  settings?: Maybe<QuestionSettingsType>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<QuestionTypeEnum>;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuestionInput = {
  challengeStep?: InputMaybe<Scalars['ID']['input']>;
  choices?: InputMaybe<Array<QuestionChoiceInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  form?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  settings?: InputMaybe<QuestionSettingsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<QuestionTypeEnum>;
};

export type QuestionPaginateType = {
  __typename?: 'QuestionPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<QuestionDtoType>;
};

export type QuestionResponsesStatsType = {
  __typename?: 'QuestionResponsesStatsType';
  answer?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Decimal']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Array<ResponseUserType>>;
};

export type QuestionSettingsDateInput = {
  interval: Scalars['Boolean']['input'];
  outdated: Scalars['Boolean']['input'];
};

export type QuestionSettingsDateType = {
  __typename?: 'QuestionSettingsDateType';
  interval?: Maybe<Scalars['Boolean']['output']>;
  outdated?: Maybe<Scalars['Boolean']['output']>;
};

export type QuestionSettingsInput = {
  date?: InputMaybe<QuestionSettingsDateInput>;
  multipleChoice?: InputMaybe<QuestionSettingsPollInput>;
  number?: InputMaybe<QuestionSettingsNumberInput>;
  paragraph?: InputMaybe<QuestionSettingsTextInput>;
  rating?: InputMaybe<QuestionSettingsRatingInput>;
  shortAnswer?: InputMaybe<QuestionSettingsTextInput>;
  singleChoice?: InputMaybe<QuestionSettingsToggleInput>;
  smiley?: InputMaybe<QuestionSettingsSmileyInput>;
};

export type QuestionSettingsNumberInput = {
  maxValue?: InputMaybe<Scalars['Int']['input']>;
  minValue?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionSettingsNumberType = {
  __typename?: 'QuestionSettingsNumberType';
  maxValue?: Maybe<Scalars['Int']['output']>;
  minValue?: Maybe<Scalars['Int']['output']>;
};

export type QuestionSettingsPollInput = {
  poll: Scalars['Boolean']['input'];
};

export type QuestionSettingsPollType = {
  __typename?: 'QuestionSettingsPollType';
  poll: Scalars['Boolean']['output'];
};

export type QuestionSettingsRatingInput = {
  levels: Array<Scalars['Int']['input']>;
};

export type QuestionSettingsRatingType = {
  __typename?: 'QuestionSettingsRatingType';
  levels: Array<Scalars['Int']['output']>;
};

export type QuestionSettingsSmileyInput = {
  levels: Array<QuestionSettingsSmileyObjInput>;
};

export type QuestionSettingsSmileyObjInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  rank: Scalars['Float']['input'];
};

export type QuestionSettingsSmileyObjType = {
  __typename?: 'QuestionSettingsSmileyObjType';
  icon?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  rank: Scalars['Float']['output'];
};

export type QuestionSettingsSmileyType = {
  __typename?: 'QuestionSettingsSmileyType';
  levels?: Maybe<Array<QuestionSettingsSmileyObjType>>;
};

export type QuestionSettingsTextInput = {
  max: Scalars['Float']['input'];
  min: Scalars['Float']['input'];
};

export type QuestionSettingsTextType = {
  __typename?: 'QuestionSettingsTextType';
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
};

export type QuestionSettingsToggleInput = {
  poll: Scalars['Boolean']['input'];
  toggle: Scalars['Boolean']['input'];
};

export type QuestionSettingsToggleType = {
  __typename?: 'QuestionSettingsToggleType';
  poll: Scalars['Boolean']['output'];
  toggle: Scalars['Boolean']['output'];
};

export type QuestionSettingsType = {
  __typename?: 'QuestionSettingsType';
  date?: Maybe<QuestionSettingsDateType>;
  multipleChoice?: Maybe<QuestionSettingsPollType>;
  number?: Maybe<QuestionSettingsNumberType>;
  paragraph?: Maybe<QuestionSettingsTextType>;
  rating?: Maybe<QuestionSettingsRatingType>;
  shortAnswer?: Maybe<QuestionSettingsTextType>;
  singleChoice?: Maybe<QuestionSettingsToggleType>;
  smiley?: Maybe<QuestionSettingsSmileyType>;
};

export type QuestionSimplePaginateType = {
  __typename?: 'QuestionSimplePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<QuestionSimpleType>;
};

export type QuestionSimpleType = {
  __typename?: 'QuestionSimpleType';
  choices?: Maybe<Array<QuestionChoiceDtoType>>;
  description?: Maybe<Scalars['String']['output']>;
  response: ResponseAnswerType;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<QuestionTypeEnum>;
  user: SimpleUserType;
};

export enum QuestionTypeEnum {
  DATETIME = 'DATETIME',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  NUMBER = 'NUMBER',
  PARAGRAPH = 'PARAGRAPH',
  RATING = 'RATING',
  SHORT_ANSWER = 'SHORT_ANSWER',
  SINGLE_CHOICE = 'SINGLE_CHOICE',
  SMILEY = 'SMILEY'
}

export type QuestionWithResponsesStatsPaginateType = {
  __typename?: 'QuestionWithResponsesStatsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<QuestionWithResponsesStatsType>;
};

export type QuestionWithResponsesStatsType = {
  __typename?: 'QuestionWithResponsesStatsType';
  choices?: Maybe<Array<QuestionChoiceDtoType>>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  form?: Maybe<FormDtoType>;
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  responses?: Maybe<Array<QuestionResponsesStatsType>>;
  settings?: Maybe<QuestionSettingsType>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<QuestionTypeEnum>;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuestsByTargetAndUserAudienceInput = {
  reversed?: InputMaybe<Scalars['Boolean']['input']>;
  target: TargetAciInput;
};

export type QuestsByTargetAndUserAudienceWithPerformedInput = {
  performed?: InputMaybe<Scalars['Boolean']['input']>;
  reversed?: InputMaybe<Scalars['Boolean']['input']>;
  target: TargetAciInput;
};

export type QuestsFilterInput = {
  createdAt?: InputMaybe<TimeFromToInput>;
  dueDate?: InputMaybe<TimeFromToInput>;
  reversed?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<TimeFromToInput>;
  status?: InputMaybe<Array<QuestStatusEnum>>;
  users?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QuotationConversionInput = {
  deliveryNote?: InputMaybe<Scalars['ID']['input']>;
  invoice?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<Scalars['ID']['input']>;
};

export type QuotationConversionType = {
  __typename?: 'QuotationConversionType';
  deliveryNote?: Maybe<SaleDeliveryNoteType>;
  invoice?: Maybe<SaleInvoiceType>;
  order?: Maybe<SaleOrderType>;
};

export type QuotationInput = {
  address?: InputMaybe<InvoicingAddressInput>;
  bank?: InputMaybe<Scalars['ID']['input']>;
  company: Scalars['ID']['input'];
  conversion?: InputMaybe<QuotationConversionInput>;
  currency: Scalars['ID']['input'];
  customer: SaleCustomerInput;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  details?: InputMaybe<Array<KeyValueInput>>;
  discount?: InputMaybe<DiscountDtoInput>;
  installments?: InputMaybe<Array<InstallmentInput>>;
  logistic?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  products: Array<InvoicingProductsBundleInput>;
  project?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<GenericInvoicingStatusEnum>;
  target: TargetAciInput;
  taxes?: InputMaybe<Array<TaxRankInput>>;
  toPay?: InputMaybe<Scalars['Decimal']['input']>;
  totalPrice?: InputMaybe<TotalPriceInput>;
  totalReductions?: InputMaybe<Scalars['Decimal']['input']>;
  totalTax?: InputMaybe<Scalars['Decimal']['input']>;
};

export type QuotationPaginateType = {
  __typename?: 'QuotationPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<QuotationType>;
};

export type QuotationType = {
  __typename?: 'QuotationType';
  address?: Maybe<InvoicingAddressType>;
  bank?: Maybe<BankDetailsType>;
  conversion?: Maybe<QuotationConversionType>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  currency: CurrencyType;
  customer?: Maybe<SaleCustomerType>;
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<KeyValueType>>;
  id: Scalars['ID']['output'];
  installments?: Maybe<Array<InstallmentType>>;
  logistic?: Maybe<LogisticType>;
  note?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  products?: Maybe<Array<InvoicingProductsBundleType>>;
  project?: Maybe<ProjectType>;
  status?: Maybe<GenericInvoicingStatusEnum>;
  target: TargetType;
  taxes?: Maybe<Array<TaxRankType>>;
  toPay?: Maybe<Scalars['Decimal']['output']>;
  totalPrice?: Maybe<InvoicingPriceType>;
  totalTax?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuotationUpdateInput = {
  address?: InputMaybe<InvoicingAddressInput>;
  bank?: InputMaybe<Scalars['ID']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  conversion?: InputMaybe<QuotationConversionInput>;
  currency?: InputMaybe<Scalars['ID']['input']>;
  customer?: InputMaybe<SaleCustomerInput>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  details?: InputMaybe<Array<KeyValueInput>>;
  discount?: InputMaybe<DiscountDtoInput>;
  id: Scalars['ID']['input'];
  installments?: InputMaybe<Array<InstallmentInput>>;
  logistic?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<InvoicingProductsBundleInput>>;
  project?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<GenericInvoicingStatusEnum>;
  target?: InputMaybe<TargetAciInput>;
  taxes?: InputMaybe<Array<TaxRankInput>>;
  toPay?: InputMaybe<Scalars['Decimal']['input']>;
  totalPrice?: InputMaybe<TotalPriceInput>;
  totalReductions?: InputMaybe<Scalars['Decimal']['input']>;
  totalTax?: InputMaybe<Scalars['Decimal']['input']>;
};

export type QuotationsStatsType = {
  __typename?: 'QuotationsStatsType';
  CANCELED: CurrentPreviousType;
  CONFIRMED: CurrentPreviousType;
  NEGOCIATION: CurrentPreviousType;
  OPEN: CurrentPreviousType;
};

export type RankEntryType = {
  __typename?: 'RankEntryType';
  compare?: Maybe<CompareRankType>;
  credit: Scalars['Decimal']['output'];
  currentReputationLevel?: Maybe<ReputationWithoutTargetType>;
  entryDate: Scalars['DateTime']['output'];
  nextReputationLevel?: Maybe<ReputationWithoutTargetType>;
  rank: Scalars['Int']['output'];
};

export type RatingsCountType = {
  __typename?: 'RatingsCountType';
  fiveStarsDaily: Array<PeriodStatsType>;
  fourStarsDaily: Array<PeriodStatsType>;
  inPeriod: Scalars['Int']['output'];
  oneStarDaily: Array<PeriodStatsType>;
  threeStarsDaily: Array<PeriodStatsType>;
  total: Scalars['Int']['output'];
  twoStarsDaily: Array<PeriodStatsType>;
};

export type RecentlyViewedInternalProductWithFavoriteStatusPaginateType = {
  __typename?: 'RecentlyViewedInternalProductWithFavoriteStatusPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<RecentlyViewedInternalProductWithFavoriteStatusType>;
};

export type RecentlyViewedInternalProductWithFavoriteStatusType = {
  __typename?: 'RecentlyViewedInternalProductWithFavoriteStatusType';
  barcodes?: Maybe<Array<BarcodeWithPublicPriceType>>;
  brand?: Maybe<BrandType>;
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  classification?: Maybe<Array<ProductClassEnum>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  discount?: Maybe<DiscountDtoType>;
  externalId?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<ProductFlagEnum>>;
  globalCategory?: Maybe<GlobalCategoryProductType>;
  id?: Maybe<Scalars['ID']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  longdesc?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<ProductType>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  sku?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<Array<ProductSpecsType>>;
  status?: Maybe<ProductStatusEnum>;
  structure?: Maybe<ProductStructureEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetType;
  tax?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<InternalProductTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variety?: Maybe<ProductVarietyEnum>;
};

export type RecentlyViewedType = {
  __typename?: 'RecentlyViewedType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  product: InternalProductType;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type RecommendationsAiType = {
  __typename?: 'RecommendationsAiType';
  actionsToMaxLevel: Scalars['Float']['output'];
  actionsToUpgrade: Scalars['Float']['output'];
  pointsConversion: Scalars['String']['output'];
};

export enum RecurrenceType {
  DAILY = 'DAILY',
  HOURLY = 'HOURLY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  YEARLY = 'YEARLY'
}

export type ReduciblePriceInput = {
  afterReduction?: InputMaybe<Scalars['Decimal']['input']>;
  beforeReduction?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ReduciblePriceType = {
  __typename?: 'ReduciblePriceType';
  afterReduction?: Maybe<Scalars['Decimal']['output']>;
  beforeReduction?: Maybe<Scalars['Decimal']['output']>;
};

export type ReferralPaginateType = {
  __typename?: 'ReferralPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ReferralType>;
};

export type ReferralRemunerationObjectType = {
  __typename?: 'ReferralRemunerationObjectType';
  qualitative?: Maybe<RemunerationWithReputationAmountType>;
  quantitative?: Maybe<RemunerationWithReputationQuantitativeType>;
};

export type ReferralRemunerationType = {
  __typename?: 'ReferralRemunerationType';
  referred?: Maybe<ReferralRemunerationObjectType>;
  referrer?: Maybe<ReferralRemunerationObjectType>;
};

export type ReferralType = {
  __typename?: 'ReferralType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  reference: Scalars['String']['output'];
  referred?: Maybe<UserType>;
  referrer: UserType;
  remuneration?: Maybe<ReferralRemunerationType>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type RemoveGameFromGameGroupInput = {
  gameGroupCode: Scalars['String']['input'];
  gameId: Scalars['ID']['input'];
  target: TargetAciInput;
};

export type RemoveGameGroupInput = {
  code: Scalars['String']['input'];
  target: TargetAciInput;
};

export type RemunerationBaseInput = {
  qualitative?: InputMaybe<RemunerationWithReputationAmountInput>;
  quantitative?: InputMaybe<RemunerationWithReputationQuantitativeInput>;
};

export type RemunerationDtoType = {
  __typename?: 'RemunerationDtoType';
  amount: Scalars['Decimal']['output'];
  wallet?: Maybe<WalletType>;
  walletType?: Maybe<WalletTypeEnum>;
};

export type RemunerationInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  walletType: WalletTypeEnum;
};

export type RemunerationWithOutReputationDtoType = {
  __typename?: 'RemunerationWithOutReputationDtoType';
  qualitative?: Maybe<RemunerationWithReputationAmountType>;
  quantitative?: Maybe<RemunerationWithReputationQuantitativeType>;
};

export type RemunerationWithReputationAmountInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
};

export type RemunerationWithReputationAmountType = {
  __typename?: 'RemunerationWithReputationAmountType';
  amount: Scalars['Decimal']['output'];
};

export type RemunerationWithReputationDtoType = {
  __typename?: 'RemunerationWithReputationDtoType';
  qualitative?: Maybe<RemunerationWithReputationAmountType>;
  quantitative?: Maybe<RemunerationWithReputationQuantitativeType>;
  reputationLevel?: Maybe<ReputationType>;
};

export type RemunerationWithReputationInput = {
  qualitative?: InputMaybe<RemunerationWithReputationAmountInput>;
  quantitative?: InputMaybe<RemunerationWithReputationQuantitativeInput>;
  reputationLevel?: InputMaybe<Scalars['ID']['input']>;
};

export type RemunerationWithReputationLeanDtoType = {
  __typename?: 'RemunerationWithReputationLeanDtoType';
  qualitative: RemunerationWithReputationAmountType;
  quantitative: RemunerationWithReputationQuantitativeType;
  reputationLevel?: Maybe<Scalars['ID']['output']>;
};

export type RemunerationWithReputationQuantitativeInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  wallet?: InputMaybe<Scalars['ID']['input']>;
};

export type RemunerationWithReputationQuantitativeType = {
  __typename?: 'RemunerationWithReputationQuantitativeType';
  amount: Scalars['Decimal']['output'];
  wallet?: Maybe<WalletType>;
};

export type RentalFilterInput = {
  from: Scalars['DateTime']['input'];
  origins?: InputMaybe<Array<RentalOriginEnum>>;
  projects?: InputMaybe<Array<Scalars['ID']['input']>>;
  target: TargetAciInput;
  to: Scalars['DateTime']['input'];
};

export type RentalInvoicingProductsType = {
  __typename?: 'RentalInvoicingProductsType';
  article?: Maybe<BarcodeType>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<DiscountDtoType>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Decimal']['output']>;
};

export type RentalInvoicingType = {
  __typename?: 'RentalInvoicingType';
  address?: Maybe<InvoicingAddressType>;
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logistic?: Maybe<LogisticType>;
  number: Scalars['String']['output'];
  project?: Maybe<ProjectType>;
  status?: Maybe<GenericInvoicingStatusEnum>;
  toPay?: Maybe<Scalars['Decimal']['output']>;
  totalPrice?: Maybe<InvoicingPriceType>;
  totalTax?: Maybe<Scalars['Decimal']['output']>;
};

export type RentalNoteInput = {
  delivery?: InputMaybe<Scalars['String']['input']>;
  returning?: InputMaybe<Scalars['String']['input']>;
};

export type RentalNoteType = {
  __typename?: 'RentalNoteType';
  delivery?: Maybe<Scalars['String']['output']>;
  returning?: Maybe<Scalars['String']['output']>;
};

export enum RentalOriginEnum {
  DELIVERY_NOTE = 'DELIVERY_NOTE',
  INVOICE = 'INVOICE',
  ORDER = 'ORDER'
}

export type RentalPaginateType = {
  __typename?: 'RentalPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<RentalType>;
};

export type RentalRefInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<RentalNoteInput>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<RentalStatusEnum>;
};

export type RentalRefType = {
  __typename?: 'RentalRefType';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  end: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  note?: Maybe<RentalNoteType>;
  start: Scalars['DateTime']['output'];
  status?: Maybe<RentalStatusEnum>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum RentalStatusEnum {
  DELIVERED = 'DELIVERED',
  DELIVERING = 'DELIVERING',
  READY_FOR_PICKUP = 'READY_FOR_PICKUP',
  RETURNED = 'RETURNED',
  RETURNING = 'RETURNING'
}

export type RentalType = {
  __typename?: 'RentalType';
  createdAt: Scalars['DateTime']['output'];
  deliveryNote?: Maybe<RentalInvoicingType>;
  description?: Maybe<Scalars['String']['output']>;
  end: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invoice?: Maybe<RentalInvoicingType>;
  location?: Maybe<Scalars['String']['output']>;
  note?: Maybe<RentalNoteType>;
  order?: Maybe<RentalInvoicingType>;
  product?: Maybe<RentalInvoicingProductsType>;
  start: Scalars['DateTime']['output'];
  status?: Maybe<RentalStatusEnum>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RentalUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<RentalNoteInput>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<RentalStatusEnum>;
};

export type ReputationContentInput = {
  description: Scalars['String']['input'];
  reputationLevel: Scalars['String']['input'];
};

export type ReputationLossAiType = {
  __typename?: 'ReputationLossAiType';
  inactiveAfterDays: Scalars['Float']['output'];
  lossRules: Array<LossRuleAiType>;
};

export type ReputationPaginateType = {
  __typename?: 'ReputationPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ReputationType>;
};

export type ReputationSimpleType = {
  __typename?: 'ReputationSimpleType';
  color?: Maybe<Scalars['String']['output']>;
  perks?: Maybe<PerksType>;
  reputationLevel?: Maybe<Scalars['String']['output']>;
};

export type ReputationTranslationContentType = {
  __typename?: 'ReputationTranslationContentType';
  description: Scalars['String']['output'];
  reputationLevel: Scalars['String']['output'];
};

export type ReputationTranslationInput = {
  content: ReputationContentInput;
  language: Scalars['ID']['input'];
};

export type ReputationTranslationType = {
  __typename?: 'ReputationTranslationType';
  content: ReputationTranslationContentType;
  language: LanguageType;
};

export type ReputationType = {
  __typename?: 'ReputationType';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  frequencyGoalEnabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  inactivityCycle?: Maybe<Scalars['Int']['output']>;
  levelInterval?: Maybe<LevelIntervalType>;
  lossAmount?: Maybe<Scalars['Int']['output']>;
  lossPoints?: Maybe<Scalars['Int']['output']>;
  nextLevelMax?: Maybe<Scalars['Int']['output']>;
  period?: Maybe<Scalars['Int']['output']>;
  perks?: Maybe<PerksType>;
  picture?: Maybe<PictureType>;
  rank?: Maybe<Scalars['Int']['output']>;
  reputationLevel?: Maybe<Scalars['String']['output']>;
  target: TargetType;
  translation?: Maybe<Array<ReputationTranslationType>>;
  turnoverGoalEnabled?: Maybe<Scalars['Boolean']['output']>;
  turnoverPoints?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ReputationWithoutTargetType = {
  __typename?: 'ReputationWithoutTargetType';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  frequencyGoalEnabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  inactivityCycle?: Maybe<Scalars['Int']['output']>;
  levelInterval?: Maybe<LevelIntervalType>;
  lossAmount?: Maybe<Scalars['Int']['output']>;
  lossPoints?: Maybe<Scalars['Int']['output']>;
  nextLevelMax?: Maybe<Scalars['Int']['output']>;
  period?: Maybe<Scalars['Int']['output']>;
  perks?: Maybe<PerksType>;
  picture?: Maybe<PictureType>;
  rank?: Maybe<Scalars['Int']['output']>;
  reputationLevel?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Array<ReputationTranslationType>>;
  turnoverGoalEnabled?: Maybe<Scalars['Boolean']['output']>;
  turnoverPoints?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RequestCompanyInput = {
  address?: InputMaybe<FullAddressInput>;
  email: Scalars['String']['input'];
  licenceNo: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<IPhoneInput>;
  registerNo: Scalars['String']['input'];
  vatId: Scalars['String']['input'];
  website: Scalars['String']['input'];
};

export type RequestCompanyType = {
  __typename?: 'RequestCompanyType';
  address?: Maybe<FullAddressType>;
  email?: Maybe<Scalars['String']['output']>;
  licenceNo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<IPhoneType>;
  registerNo?: Maybe<Scalars['String']['output']>;
  vatId?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type RequestInput = {
  company?: InputMaybe<RequestCompanyInput>;
  data?: InputMaybe<Array<RequestKeyValueInput>>;
  request?: InputMaybe<RequestRequestInput>;
  requestor?: InputMaybe<RequestRequestorInput>;
  target?: InputMaybe<TargetAciInput>;
  type?: InputMaybe<RequestTypeEnum>;
};

export type RequestKeyValueInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type RequestKeyValueType = {
  __typename?: 'RequestKeyValueType';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type RequestPaginateType = {
  __typename?: 'RequestPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<RequestType>;
};

export type RequestRequestInput = {
  content: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type RequestRequestType = {
  __typename?: 'RequestRequestType';
  content?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type RequestRequestorInput = {
  address?: InputMaybe<FullAddressInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<IPhoneInput>;
};

export type RequestRequestorType = {
  __typename?: 'RequestRequestorType';
  address?: Maybe<FullAddressType>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<IPhoneType>;
};

export enum RequestStatusEnum {
  CLOSED = 'CLOSED',
  REQUESTED = 'REQUESTED',
  TREATED = 'TREATED'
}

export type RequestType = {
  __typename?: 'RequestType';
  company?: Maybe<RequestCompanyType>;
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Array<RequestKeyValueType>>;
  id: Scalars['ID']['output'];
  request?: Maybe<RequestRequestType>;
  requestor?: Maybe<RequestRequestorType>;
  status?: Maybe<RequestStatusEnum>;
  target?: Maybe<TargetType>;
  type?: Maybe<RequestTypeEnum>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum RequestTypeEnum {
  CONTACT = 'CONTACT',
  DEMO = 'DEMO',
  PARTNER = 'PARTNER'
}

export type ResetPasswordForAppInput = {
  password: Scalars['String']['input'];
  phone?: InputMaybe<IPhoneInput>;
  smsValidationCode?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type ResponseAnswerInput = {
  date?: InputMaybe<TimeFromToInput>;
  multipleChoices?: InputMaybe<Array<Scalars['String']['input']>>;
  number?: InputMaybe<Scalars['Int']['input']>;
  paragraph?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  shortAnswer?: InputMaybe<Scalars['String']['input']>;
  singleChoice?: InputMaybe<Scalars['String']['input']>;
  smiley?: InputMaybe<ResponseAnswerSmileyObjInput>;
};

export type ResponseAnswerSmileyObjInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
};

export type ResponseAnswerSmileyObjType = {
  __typename?: 'ResponseAnswerSmileyObjType';
  icon?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
};

export type ResponseAnswerType = {
  __typename?: 'ResponseAnswerType';
  date?: Maybe<TimeFromToType>;
  multipleChoices?: Maybe<Array<Scalars['String']['output']>>;
  number?: Maybe<Scalars['Int']['output']>;
  paragraph?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  shortAnswer?: Maybe<Scalars['String']['output']>;
  singleChoice?: Maybe<Scalars['String']['output']>;
  smiley?: Maybe<ResponseAnswerSmileyObjType>;
};

export type ResponseDtoType = {
  __typename?: 'ResponseDtoType';
  answers: ResponseAnswerType;
  createdAt: Scalars['DateTime']['output'];
  executor: UserType;
  id: Scalars['ID']['output'];
  question: QuestionDtoType;
  target: TargetDtoType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ResponseFilterInput = {
  executors?: InputMaybe<Array<Scalars['String']['input']>>;
  forms?: InputMaybe<Array<Scalars['String']['input']>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  pos?: InputMaybe<Array<Scalars['String']['input']>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  users?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ResponseInput = {
  answers: ResponseAnswerInput;
  question: Scalars['ID']['input'];
  target?: InputMaybe<TargetInput>;
};

export type ResponsePaginateType = {
  __typename?: 'ResponsePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ResponseDtoType>;
};

export type ResponseUserType = {
  __typename?: 'ResponseUserType';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
};

export type RolesCountType = {
  __typename?: 'RolesCountType';
  countByRoles: Array<AccountsByRoleCountType>;
  numberOfManufacturersRoles: Scalars['Int']['output'];
  numberOfPosRoles: Scalars['Int']['output'];
  numberOfWholesalersRoles: Scalars['Int']['output'];
};

export type RoundType = {
  __typename?: 'RoundType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  league: Scalars['Int']['output'];
  rounds: Array<Scalars['String']['output']>;
  season: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum RunpayOperatorEnum {
  OOREDOO = 'OOREDOO',
  ORANGE = 'ORANGE',
  TT = 'TT'
}

export type SeoAuditDataType = {
  __typename?: 'SEOAuditDataType';
  brokenImages?: Maybe<Array<Scalars['String']['output']>>;
  brokenImagesCount?: Maybe<Scalars['Int']['output']>;
  brokenLinks?: Maybe<Array<Scalars['String']['output']>>;
  brokenLinksCount?: Maybe<Scalars['Int']['output']>;
  externalBrokenLinks?: Maybe<Array<Scalars['String']['output']>>;
  externalBrokenLinksCount?: Maybe<Scalars['Int']['output']>;
  faviconExists?: Maybe<Scalars['Boolean']['output']>;
  h1?: Maybe<Scalars['String']['output']>;
  internalNoFollowLinks?: Maybe<Array<Scalars['String']['output']>>;
  internalNoFollowLinksCount?: Maybe<Scalars['Int']['output']>;
  isAmp?: Maybe<Scalars['Boolean']['output']>;
  isCharacterEncode?: Maybe<Scalars['Boolean']['output']>;
  isContentEnoughLong?: Maybe<Scalars['Boolean']['output']>;
  isDoctype?: Maybe<Scalars['Boolean']['output']>;
  isGoogleAnalyticsFunc?: Maybe<Scalars['Boolean']['output']>;
  isGoogleAnalyticsObject?: Maybe<Scalars['Boolean']['output']>;
  isH1?: Maybe<Scalars['Boolean']['output']>;
  isH1OnlyOne?: Maybe<Scalars['Boolean']['output']>;
  isH2?: Maybe<Scalars['Boolean']['output']>;
  isLoaded?: Maybe<Scalars['Boolean']['output']>;
  isMetaDescription?: Maybe<Scalars['Boolean']['output']>;
  isMetaDescriptionEnoughLong?: Maybe<Scalars['Boolean']['output']>;
  isNotIframe?: Maybe<Scalars['Boolean']['output']>;
  isTitle?: Maybe<Scalars['Boolean']['output']>;
  isTitleEnoughLong?: Maybe<Scalars['Boolean']['output']>;
  isTooEnoughLinks?: Maybe<Scalars['Boolean']['output']>;
  isViewport?: Maybe<Scalars['Boolean']['output']>;
  linksCount?: Maybe<Scalars['Int']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  notOptimizedImages?: Maybe<Array<Scalars['String']['output']>>;
  notOptimizedImagesCount?: Maybe<Scalars['Int']['output']>;
  pageIsBlocked?: Maybe<Scalars['Boolean']['output']>;
  robotsFileExists?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  wordsCount?: Maybe<Scalars['Int']['output']>;
};

export type SeoInput = {
  googleAnalyticsId?: InputMaybe<Scalars['String']['input']>;
  headerTags?: InputMaybe<Array<TagInput>>;
  metaDescriptionTag?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
  titleTag?: InputMaybe<Scalars['String']['input']>;
};

export type SeoType = {
  __typename?: 'SEOType';
  createdAt: Scalars['DateTime']['output'];
  googleAnalyticsId?: Maybe<Scalars['String']['output']>;
  headerTags?: Maybe<Array<TagType>>;
  id: Scalars['ID']['output'];
  metaDescriptionTag?: Maybe<Scalars['String']['output']>;
  target: TargetType;
  titleTag?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SaleAvoirInput = {
  address?: InputMaybe<InvoicingAddressInput>;
  avoir: Scalars['ID']['input'];
  bank?: InputMaybe<Scalars['ID']['input']>;
  company: Scalars['ID']['input'];
  currency: Scalars['ID']['input'];
  customer: SaleCustomerInput;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  details?: InputMaybe<Array<KeyValueInput>>;
  discount?: InputMaybe<DiscountDtoInput>;
  installments?: InputMaybe<Array<InstallmentInput>>;
  logistic?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<SaleInvoiceOriginInput>;
  products: Array<InvoicingProductsBundleInput>;
  project?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<GenericInvoicingStatusEnum>;
  target: TargetAciInput;
  taxes?: InputMaybe<Array<TaxRankInput>>;
  toPay?: InputMaybe<Scalars['Decimal']['input']>;
  totalPrice?: InputMaybe<TotalPriceInput>;
  totalReductions?: InputMaybe<Scalars['Decimal']['input']>;
  totalTax?: InputMaybe<Scalars['Decimal']['input']>;
};

export type SaleCustomerInput = {
  customer: Scalars['ID']['input'];
  details?: InputMaybe<Array<KeyValueInput>>;
};

export type SaleCustomerType = {
  __typename?: 'SaleCustomerType';
  customer?: Maybe<CompanyType>;
  details?: Maybe<Array<KeyValueType>>;
};

export type SaleDeliveryNoteInput = {
  address?: InputMaybe<InvoicingAddressInput>;
  bank?: InputMaybe<Scalars['ID']['input']>;
  company: Scalars['ID']['input'];
  currency: Scalars['ID']['input'];
  customer: SaleCustomerInput;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  details?: InputMaybe<Array<KeyValueInput>>;
  discount?: InputMaybe<DiscountDtoInput>;
  installments?: InputMaybe<Array<InstallmentInput>>;
  logistic?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<SaleDeliveryNoteOriginInput>;
  products: Array<InvoicingProductsBundleInput>;
  project?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<GenericInvoicingStatusEnum>;
  target: TargetAciInput;
  taxes?: InputMaybe<Array<TaxRankInput>>;
  toPay?: InputMaybe<Scalars['Decimal']['input']>;
  totalPrice?: InputMaybe<TotalPriceInput>;
  totalReductions?: InputMaybe<Scalars['Decimal']['input']>;
  totalTax?: InputMaybe<Scalars['Decimal']['input']>;
  warehouse: Scalars['ID']['input'];
};

export type SaleDeliveryNoteOriginInput = {
  order?: InputMaybe<Scalars['ID']['input']>;
  quotation?: InputMaybe<Scalars['ID']['input']>;
};

export type SaleDeliveryNoteOriginType = {
  __typename?: 'SaleDeliveryNoteOriginType';
  order?: Maybe<SaleOrderType>;
  quotation?: Maybe<QuotationType>;
};

export type SaleDeliveryNotePaginateType = {
  __typename?: 'SaleDeliveryNotePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<SaleDeliveryNoteType>;
};

export type SaleDeliveryNoteType = {
  __typename?: 'SaleDeliveryNoteType';
  address?: Maybe<InvoicingAddressType>;
  bank?: Maybe<BankDetailsType>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  currency: CurrencyType;
  customer?: Maybe<SaleCustomerType>;
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<KeyValueType>>;
  id: Scalars['ID']['output'];
  installments?: Maybe<Array<InstallmentType>>;
  logistic?: Maybe<LogisticType>;
  note?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  origin?: Maybe<SaleDeliveryNoteOriginType>;
  products?: Maybe<Array<InvoicingProductsBundleType>>;
  project?: Maybe<ProjectType>;
  status?: Maybe<GenericInvoicingStatusEnum>;
  target: TargetType;
  taxes?: Maybe<Array<TaxRankType>>;
  toPay?: Maybe<Scalars['Decimal']['output']>;
  totalPrice?: Maybe<InvoicingPriceType>;
  totalTax?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  warehouse?: Maybe<WarehouseType>;
};

export type SaleInvoiceInput = {
  address?: InputMaybe<InvoicingAddressInput>;
  bank?: InputMaybe<Scalars['ID']['input']>;
  company: Scalars['ID']['input'];
  currency: Scalars['ID']['input'];
  customer: SaleCustomerInput;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  details?: InputMaybe<Array<KeyValueInput>>;
  discount?: InputMaybe<DiscountDtoInput>;
  installments?: InputMaybe<Array<InstallmentInput>>;
  logistic?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<SaleInvoiceOriginInput>;
  products: Array<InvoicingProductsBundleInput>;
  project?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<GenericInvoicingStatusEnum>;
  target: TargetAciInput;
  taxes?: InputMaybe<Array<TaxRankInput>>;
  toPay?: InputMaybe<Scalars['Decimal']['input']>;
  totalPrice?: InputMaybe<TotalPriceInput>;
  totalReductions?: InputMaybe<Scalars['Decimal']['input']>;
  totalTax?: InputMaybe<Scalars['Decimal']['input']>;
};

export type SaleInvoiceOriginInput = {
  order?: InputMaybe<Scalars['ID']['input']>;
  quotation?: InputMaybe<Scalars['ID']['input']>;
};

export type SaleInvoiceOriginType = {
  __typename?: 'SaleInvoiceOriginType';
  order?: Maybe<SaleOrderType>;
  quotation?: Maybe<QuotationType>;
};

export type SaleInvoicePaginateType = {
  __typename?: 'SaleInvoicePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<SaleInvoiceType>;
};

export type SaleInvoiceType = {
  __typename?: 'SaleInvoiceType';
  address?: Maybe<InvoicingAddressType>;
  bank?: Maybe<BankDetailsType>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  currency: CurrencyType;
  customer?: Maybe<SaleCustomerType>;
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<KeyValueType>>;
  id: Scalars['ID']['output'];
  installments?: Maybe<Array<InstallmentType>>;
  logistic?: Maybe<LogisticType>;
  note?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  origin?: Maybe<SaleInvoiceOriginType>;
  products?: Maybe<Array<InvoicingProductsBundleType>>;
  project?: Maybe<ProjectType>;
  status?: Maybe<GenericInvoicingStatusEnum>;
  target: TargetType;
  taxes?: Maybe<Array<TaxRankType>>;
  toPay?: Maybe<Scalars['Decimal']['output']>;
  totalPrice?: Maybe<InvoicingPriceType>;
  totalTax?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SaleInvoicesStatsType = {
  __typename?: 'SaleInvoicesStatsType';
  CANCELED: CurrentPreviousType;
  DELIVERED: CurrentPreviousType;
  DRAFT: CurrentPreviousType;
  ISSUED: CurrentPreviousType;
};

export type SaleIssueNoteInput = {
  address?: InputMaybe<InvoicingAddressInput>;
  bank?: InputMaybe<Scalars['ID']['input']>;
  company: Scalars['ID']['input'];
  currency: Scalars['ID']['input'];
  customer: SaleCustomerInput;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  details?: InputMaybe<Array<KeyValueInput>>;
  discount?: InputMaybe<DiscountDtoInput>;
  installments?: InputMaybe<Array<InstallmentInput>>;
  logistic?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  products: Array<InvoicingProductsBundleInput>;
  project?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<GenericInvoicingStatusEnum>;
  target: TargetAciInput;
  taxes?: InputMaybe<Array<TaxRankInput>>;
  toPay?: InputMaybe<Scalars['Decimal']['input']>;
  totalPrice?: InputMaybe<TotalPriceInput>;
  totalReductions?: InputMaybe<Scalars['Decimal']['input']>;
  totalTax?: InputMaybe<Scalars['Decimal']['input']>;
};

export type SaleIssueNotePaginateType = {
  __typename?: 'SaleIssueNotePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<SaleIssueNoteType>;
};

export type SaleIssueNoteStatsType = {
  __typename?: 'SaleIssueNoteStatsType';
  CANCELED: CurrentPreviousType;
  DELIVERED: CurrentPreviousType;
  DRAFT: CurrentPreviousType;
  OPEN: CurrentPreviousType;
};

export type SaleIssueNoteType = {
  __typename?: 'SaleIssueNoteType';
  address?: Maybe<InvoicingAddressType>;
  bank?: Maybe<BankDetailsType>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  currency: CurrencyType;
  customer?: Maybe<SaleCustomerType>;
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<KeyValueType>>;
  id: Scalars['ID']['output'];
  installments?: Maybe<Array<InstallmentType>>;
  logistic?: Maybe<LogisticType>;
  note?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  products?: Maybe<Array<InvoicingProductsBundleType>>;
  project?: Maybe<ProjectType>;
  status?: Maybe<GenericInvoicingStatusEnum>;
  target: TargetType;
  taxes?: Maybe<Array<TaxRankType>>;
  toPay?: Maybe<Scalars['Decimal']['output']>;
  totalPrice?: Maybe<InvoicingPriceType>;
  totalTax?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SaleOrderConversionInput = {
  deliveryNote?: InputMaybe<Scalars['ID']['input']>;
  invoice?: InputMaybe<Scalars['ID']['input']>;
};

export type SaleOrderConversionType = {
  __typename?: 'SaleOrderConversionType';
  deliveryNote?: Maybe<SaleDeliveryNoteType>;
  invoice?: Maybe<SaleInvoiceType>;
};

export type SaleOrderInput = {
  address?: InputMaybe<InvoicingAddressInput>;
  bank?: InputMaybe<Scalars['ID']['input']>;
  company: Scalars['ID']['input'];
  conversion?: InputMaybe<SaleOrderConversionInput>;
  currency: Scalars['ID']['input'];
  customer: SaleCustomerInput;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  details?: InputMaybe<Array<KeyValueInput>>;
  discount?: InputMaybe<DiscountDtoInput>;
  installments?: InputMaybe<Array<InstallmentInput>>;
  logistic?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<SaleOrderOriginInput>;
  products: Array<InvoicingProductsBundleInput>;
  project?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<GenericInvoicingStatusEnum>;
  target: TargetAciInput;
  taxes?: InputMaybe<Array<TaxRankInput>>;
  toPay?: InputMaybe<Scalars['Decimal']['input']>;
  totalPrice?: InputMaybe<TotalPriceInput>;
  totalReductions?: InputMaybe<Scalars['Decimal']['input']>;
  totalTax?: InputMaybe<Scalars['Decimal']['input']>;
};

export type SaleOrderOriginInput = {
  quotation?: InputMaybe<Scalars['ID']['input']>;
};

export type SaleOrderOriginType = {
  __typename?: 'SaleOrderOriginType';
  quotation?: Maybe<QuotationType>;
};

export type SaleOrderPaginateType = {
  __typename?: 'SaleOrderPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<SaleOrderType>;
};

export type SaleOrderType = {
  __typename?: 'SaleOrderType';
  address?: Maybe<InvoicingAddressType>;
  bank?: Maybe<BankDetailsType>;
  conversion?: Maybe<SaleOrderConversionType>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  currency: CurrencyType;
  customer?: Maybe<SaleCustomerType>;
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<KeyValueType>>;
  id: Scalars['ID']['output'];
  installments?: Maybe<Array<InstallmentType>>;
  logistic?: Maybe<LogisticType>;
  note?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  origin?: Maybe<SaleOrderOriginType>;
  products?: Maybe<Array<InvoicingProductsBundleType>>;
  project?: Maybe<ProjectType>;
  status?: Maybe<GenericInvoicingStatusEnum>;
  target: TargetType;
  taxes?: Maybe<Array<TaxRankType>>;
  toPay?: Maybe<Scalars['Decimal']['output']>;
  totalPrice?: Maybe<InvoicingPriceType>;
  totalTax?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SaleOrdersStatsType = {
  __typename?: 'SaleOrdersStatsType';
  CANCELED: CurrentPreviousType;
  CONFIRMED: CurrentPreviousType;
  DRAFT: CurrentPreviousType;
  OPEN: CurrentPreviousType;
};

export type SalesAnalyticsRevenueStatsChartType = {
  __typename?: 'SalesAnalyticsRevenueStatsChartType';
  orders: Array<Scalars['Decimal']['output']>;
  paid: Array<Scalars['Decimal']['output']>;
  partiallyPaid: Array<Scalars['Decimal']['output']>;
  unpaid: Array<Scalars['Decimal']['output']>;
};

export type SalesAnalyticsRevenueStatsType = {
  __typename?: 'SalesAnalyticsRevenueStatsType';
  chart?: Maybe<SalesAnalyticsRevenueStatsChartType>;
  conversions: Scalars['Decimal']['output'];
  orders: Scalars['Decimal']['output'];
  paid: Scalars['Decimal']['output'];
  partiallyPaid: Scalars['Decimal']['output'];
  unpaid: Scalars['Decimal']['output'];
};

export type SalesAnalyticsSalesByCountrySegmentsType = {
  __typename?: 'SalesAnalyticsSalesByCountrySegmentsType';
  country?: Maybe<CountryType>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type SalesAnalyticsSalesByCountryType = {
  __typename?: 'SalesAnalyticsSalesByCountryType';
  layers?: Maybe<Array<AnalyticsUsersByCountryLayersType>>;
  segments?: Maybe<Array<SalesAnalyticsSalesByCountrySegmentsType>>;
};

export type SalesAnalyticsStatsType = {
  __typename?: 'SalesAnalyticsStatsType';
  orders?: Maybe<AnalyticsStatsInfoType>;
  partiallyPaidInvoices?: Maybe<AnalyticsStatsInfoType>;
  totalEarnings?: Maybe<AnalyticsStatsInfoType>;
  unpaidInvoices?: Maybe<AnalyticsStatsInfoType>;
};

export type SalesAnalyticsTopCatalogueCategoriesType = {
  __typename?: 'SalesAnalyticsTopCatalogueCategoriesType';
  category: CatalogueCategoryType;
  value: Array<Scalars['Decimal']['output']>;
};

export type SalesDashboardInput = {
  from: Scalars['DateTime']['input'];
  target?: InputMaybe<TargetAciInput>;
  to: Scalars['DateTime']['input'];
  variety?: InputMaybe<ProductVarietyEnum>;
};

export type SalesIntegrationDocumentInput = {
  deliveryNote?: InputMaybe<SalesIntegrationDocumentQuotationInput>;
  invoice?: InputMaybe<SalesIntegrationDocumentQuotationInput>;
  issueNote?: InputMaybe<SalesIntegrationDocumentQuotationInput>;
  order?: InputMaybe<SalesIntegrationDocumentQuotationInput>;
  quotation?: InputMaybe<SalesIntegrationDocumentQuotationInput>;
};

export type SalesIntegrationDocumentQuotationInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<DocumentReferenceModelEnum>;
  validity?: InputMaybe<SalesIntegrationDocumentQuotationValidityInput>;
};

export type SalesIntegrationDocumentQuotationType = {
  __typename?: 'SalesIntegrationDocumentQuotationType';
  color?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<DocumentReferenceModelEnum>;
  validity?: Maybe<SalesIntegrationDocumentQuotationValidityType>;
};

export type SalesIntegrationDocumentQuotationValidityInput = {
  cycle?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
};

export type SalesIntegrationDocumentQuotationValidityType = {
  __typename?: 'SalesIntegrationDocumentQuotationValidityType';
  cycle?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['String']['output']>;
};

export type SalesIntegrationDocumentType = {
  __typename?: 'SalesIntegrationDocumentType';
  deliveryNote?: Maybe<SalesIntegrationDocumentQuotationType>;
  invoice?: Maybe<SalesIntegrationDocumentQuotationType>;
  issueNote?: Maybe<SalesIntegrationDocumentQuotationType>;
  order?: Maybe<SalesIntegrationDocumentQuotationType>;
  quotation?: Maybe<SalesIntegrationDocumentQuotationType>;
};

export type SalesIntegrationInput = {
  document?: InputMaybe<SalesIntegrationDocumentInput>;
  multicurrency?: InputMaybe<WebsiteIntegrationMulticurrencyInput>;
  picture?: InputMaybe<PictureInput>;
  target?: InputMaybe<TargetAciInput>;
};

export type SalesIntegrationType = {
  __typename?: 'SalesIntegrationType';
  createdAt: Scalars['DateTime']['output'];
  document?: Maybe<SalesIntegrationDocumentType>;
  id: Scalars['ID']['output'];
  multicurrency?: Maybe<WebsiteIntegrationMulticurrencyType>;
  picture?: Maybe<PictureType>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ScriptItemType = {
  __typename?: 'ScriptItemType';
  content?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SearchCorporateUsersByTargetInput = {
  createdAt?: InputMaybe<FromToInput>;
  dateOfBirthRange?: InputMaybe<FromToInput>;
  gender?: InputMaybe<Array<Gender>>;
  maritalStatus?: InputMaybe<Array<MaritalStatus>>;
  pagination?: InputMaybe<PaginationInput>;
  roles?: InputMaybe<Array<UserRole>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  sortingField?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<UserStatus>>;
  target: TargetAciInput;
};

export type SearchSimpleProductInput = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<ProductStatusEnum>>;
  target: TargetAciInput;
};

export type SearchTargetQualitativeWalletsPaginatedInput = {
  isPrelevel?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  reputationsLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};

export type SearchTargetSubscribersPaginatedInput = {
  isPrelevel?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  reputationsLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<SubscriptionStatus>>;
  target: TargetAciInput;
};

export type SeasonType = {
  __typename?: 'SeasonType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  season: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SeasonsType = {
  __typename?: 'SeasonsType';
  coverage?: Maybe<CoverageType>;
  current?: Maybe<Scalars['Boolean']['output']>;
  end?: Maybe<Scalars['DateTime']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type SegmentsDefinitionsInput = {
  criteria?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AudienceSegmentFilterInput>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<AudienceSegmentFilterValueInput>;
};

export type SegmentsDefinitionsType = {
  __typename?: 'SegmentsDefinitionsType';
  criteria?: Maybe<AudienceCriteriaType>;
  filter?: Maybe<AudienceSegmentFilterType>;
  rank?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<AudienceSegmentFilterValuesType>;
};

export type SendMessageToTargetInput = {
  custom?: InputMaybe<CustomMessageInput>;
  gif?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LonLatInput>;
  media?: InputMaybe<MessageMediaInput>;
  seenBy?: InputMaybe<Array<Scalars['ID']['input']>>;
  sticker?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SendTargetQualitativeWalletsByEmailInput = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  isPrelevel?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  reputationsLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};

export type SendTargetSubscribersBymailnput = {
  emails: Array<Scalars['String']['input']>;
  isPrelevel?: InputMaybe<Scalars['Boolean']['input']>;
  reputationsLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<SubscriptionStatus>>;
  subject: Scalars['String']['input'];
  target: TargetAciInput;
};

export type SeoComponentInput = {
  metaDesription?: InputMaybe<Scalars['String']['input']>;
  metaKeywords?: InputMaybe<Array<TagInput>>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
};

export type SeoComponentType = {
  __typename?: 'SeoComponentType';
  metaDesription?: Maybe<Scalars['String']['output']>;
  metaKeywords?: Maybe<Array<TagType>>;
  metaTitle?: Maybe<Scalars['String']['output']>;
};

export enum SequenceCategoryEnum {
  PURCHASE_DELIVERY_NOTE = 'PURCHASE_DELIVERY_NOTE',
  PURCHASE_INVOICE = 'PURCHASE_INVOICE',
  PURCHASE_ORDER = 'PURCHASE_ORDER',
  QUOTATION = 'QUOTATION',
  SALE_DELIVERY_NOTE = 'SALE_DELIVERY_NOTE',
  SALE_INVOICE = 'SALE_INVOICE',
  SALE_ISSUE_NOTE = 'SALE_ISSUE_NOTE',
  SALE_ORDER = 'SALE_ORDER'
}

export type SesSendDataPointDto = {
  __typename?: 'SesSendDataPointDto';
  bounces: Scalars['Int']['output'];
  complaints: Scalars['Int']['output'];
  deliveryAttempts: Scalars['Int']['output'];
  rejects: Scalars['Int']['output'];
  timestamp: Scalars['String']['output'];
};

export type SesSnsNotificationDto = {
  __typename?: 'SesSnsNotificationDto';
  Message: Scalars['String']['output'];
  MessageId: Scalars['String']['output'];
  Signature: Scalars['String']['output'];
  SignatureVersion: Scalars['String']['output'];
  SigningCertURL: Scalars['String']['output'];
  Timestamp: Scalars['String']['output'];
  TopicArn: Scalars['String']['output'];
  Type: Scalars['String']['output'];
  UnsubscribeURL: Scalars['String']['output'];
};

export type SettingsAttributeType = {
  __typename?: 'SettingsAttributeType';
  attribute: BookingAttributeType;
  value: Scalars['String']['output'];
};

export type SetupLoyaltyLevelsAiInput = {
  avgBasketValue?: InputMaybe<Scalars['Float']['input']>;
  avgMonthlyVisits?: InputMaybe<Scalars['Float']['input']>;
  brandColors?: InputMaybe<Array<Scalars['String']['input']>>;
  businessDescription?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  inactiveDays?: InputMaybe<Scalars['Float']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  numLevels?: InputMaybe<Scalars['Float']['input']>;
  pointValue?: InputMaybe<Scalars['Float']['input']>;
  rewardPercent?: InputMaybe<Scalars['Float']['input']>;
  tone?: InputMaybe<Scalars['String']['input']>;
};

export type SetupLoyaltyLevelsAiType = {
  __typename?: 'SetupLoyaltyLevelsAiType';
  explanation: ExplanationAiType;
  generationDetails: GenerationDetailsAiType;
  levels: Array<LevelDefinitionAiType>;
  recommendations: RecommendationsAiType;
  reputationLoss: ReputationLossAiType;
};

export enum ShareContentTypeEnum {
  CATEGORY = 'CATEGORY',
  PRODUCT = 'PRODUCT'
}

export enum ShareMethodEnum {
  APPLE = 'APPLE',
  FACEBOOK = 'FACEBOOK',
  GOOGLE = 'GOOGLE',
  REGULAR = 'REGULAR',
  TWITTER = 'TWITTER'
}

export enum SheetsNames {
  ARTICLES = 'ARTICLES',
  ATTRIBUTES = 'ATTRIBUTES',
  ATTRIBUTES_VALUES = 'ATTRIBUTES_VALUES',
  BANK = 'BANK',
  BRANDS = 'BRANDS',
  CARDS = 'CARDS',
  CATEGORIES = 'CATEGORIES',
  COMPANY = 'COMPANY',
  CONTACT = 'CONTACT',
  DISCOUNT = 'DISCOUNT',
  EXTRA_FEES = 'EXTRA_FEES',
  INSTALLMENTS = 'INSTALLMENTS',
  INVOICING = 'INVOICING',
  LOCATIONS = 'LOCATIONS',
  ORDERS = 'ORDERS',
  POS = 'POS',
  PRODUCTS = 'PRODUCTS',
  PROJECTS = 'PROJECTS',
  RENT = 'RENT',
  SERVICES = 'SERVICES',
  STOCK = 'STOCK',
  TAXES = 'TAXES',
  TRANSACTIONS = 'TRANSACTIONS',
  USERS = 'USERS',
  WAREHOUSES = 'WAREHOUSES'
}

export enum ShippingTierTypeEnum {
  DHL = 'DHL',
  DPD = 'DPD',
  GLS = 'GLS',
  INTERNAL = 'INTERNAL',
  POST = 'POST'
}

export type ShoppingCartType = {
  __typename?: 'ShoppingCartType';
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<DiscountDtoType>;
  id: Scalars['ID']['output'];
  price?: Maybe<PriceFullType>;
  products?: Maybe<Array<CartProductType>>;
  target?: Maybe<TargetType>;
  taxValue?: Maybe<ReduciblePriceType>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type ShoppingCartsForTargetPaginatedType = {
  __typename?: 'ShoppingCartsForTargetPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ShoppingCartsForTargetType>;
};

export type ShoppingCartsForTargetType = {
  __typename?: 'ShoppingCartsForTargetType';
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<DiscountDtoType>;
  id: Scalars['ID']['output'];
  price?: Maybe<PriceFullType>;
  products?: Maybe<Array<CartProductForTargetType>>;
  target?: Maybe<TargetType>;
  taxValue?: Maybe<ReduciblePriceType>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type ShoppingCartsType = {
  __typename?: 'ShoppingCartsType';
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<DiscountDtoType>;
  id: Scalars['ID']['output'];
  price?: Maybe<PriceFullType>;
  products?: Maybe<Array<CartProductForTargetType>>;
  target?: Maybe<TargetType>;
  taxValue?: Maybe<ReduciblePriceType>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type ShortcutInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  icon: Scalars['String']['input'];
  label: Scalars['String']['input'];
  link: Scalars['String']['input'];
  picture?: InputMaybe<PictureInput>;
  router: Scalars['Boolean']['input'];
  target?: InputMaybe<TargetAciInput>;
  user: Scalars['String']['input'];
};

export type ShortcutPaginateType = {
  __typename?: 'ShortcutPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ShortcutType>;
};

export type ShortcutType = {
  __typename?: 'ShortcutType';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  link: Scalars['String']['output'];
  picture?: Maybe<PictureType>;
  router: Scalars['Boolean']['output'];
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type ShortcutUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  router?: InputMaybe<Scalars['Boolean']['input']>;
  target?: InputMaybe<TargetAciInput>;
};

export type SidelinedInnerType = {
  __typename?: 'SidelinedInnerType';
  end?: Maybe<Scalars['DateTime']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SidelinedType = {
  __typename?: 'SidelinedType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  sideLined: Array<SidelinedInnerType>;
  target: ApiTargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type SimpleBrandType = {
  __typename?: 'SimpleBrandType';
  createdAt: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SimpleProductsForPartnerhipNetworkWithRatingsAndFavoriteStatusAndRemunerationsAndFilterPaginationType = {
  __typename?: 'SimpleProductsForPartnerhipNetworkWithRatingsAndFavoriteStatusAndRemunerationsAndFilterPaginationType';
  count?: Maybe<Scalars['Int']['output']>;
  filter?: Maybe<InternalProductForPartnershipNetworkFilterType>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<SimpleProductsForPartnerhipNetworkWithRatingsAndFavoriteStatusAndRemunerationsAndFilterType>;
};

export type SimpleProductsForPartnerhipNetworkWithRatingsAndFavoriteStatusAndRemunerationsAndFilterType = {
  __typename?: 'SimpleProductsForPartnerhipNetworkWithRatingsAndFavoriteStatusAndRemunerationsAndFilterType';
  barcodes?: Maybe<Array<BarcodeWithPublicPriceAndRemunerationsType>>;
  brand?: Maybe<SimpleBrandType>;
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  classification?: Maybe<Array<ProductClassEnum>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  discount?: Maybe<DiscountDtoType>;
  externalId?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<ProductFlagEnum>>;
  id?: Maybe<Scalars['ID']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  longdesc?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<ProductType>;
  ratings?: Maybe<Scalars['Decimal']['output']>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  sku?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<Array<ProductSpecsType>>;
  status?: Maybe<ProductStatusEnum>;
  structure?: Maybe<ProductStructureEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetWithPictureFilterType;
  tax?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<InternalProductTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variety?: Maybe<ProductVarietyEnum>;
};

export type SimpleTargetWithUserType = {
  __typename?: 'SimpleTargetWithUserType';
  /** manufacturer id. */
  manufacturer?: Maybe<Scalars['ID']['output']>;
  /** PointOfSale id. */
  pos?: Maybe<Scalars['ID']['output']>;
  /** user */
  user?: Maybe<UserType>;
  /** wholesaler id. */
  wholesaler?: Maybe<Scalars['ID']['output']>;
};

export type SimpleUserType = {
  __typename?: 'SimpleUserType';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
};

export type SimpleUserWithWalletsPaginateType = {
  __typename?: 'SimpleUserWithWalletsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<SimpleUserWithWalletsType>;
};

export type SimpleUserWithWalletsType = {
  __typename?: 'SimpleUserWithWalletsType';
  about?: Maybe<Scalars['String']['output']>;
  apps?: Maybe<Array<App>>;
  billingAddress?: Maybe<Array<FullAddressType>>;
  chatContact?: Maybe<Array<SocialValueType>>;
  covers?: Maybe<Array<PictureType>>;
  createdAt: Scalars['DateTime']['output'];
  custom?: Maybe<Array<UserCustomType>>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  education?: Maybe<Array<UserEducationType>>;
  email?: Maybe<Scalars['String']['output']>;
  fcmTokens?: Maybe<Array<FcmTokenType>>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  hasAutoGeneratedEmail?: Maybe<Scalars['Boolean']['output']>;
  hobbies?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  interests?: Maybe<Array<Scalars['String']['output']>>;
  isMailValid?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Array<LanguageType>>;
  lastName?: Maybe<Scalars['String']['output']>;
  lived?: Maybe<Array<StateType>>;
  locale?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<MaritalStatus>;
  mobileTheme?: Maybe<MobileThemesEnum>;
  nationality?: Maybe<CountryType>;
  newsletterSubs?: Maybe<Scalars['Boolean']['output']>;
  permission?: Maybe<PermissionType>;
  phone?: Maybe<PhoneType>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  placeOfBirth?: Maybe<Scalars['String']['output']>;
  plugged?: Maybe<Scalars['Boolean']['output']>;
  residentialAddress?: Maybe<Array<FullAddressType>>;
  roles?: Maybe<Array<UserRole>>;
  shippingAddress?: Maybe<Array<FullAddressType>>;
  socialLoginData?: Maybe<SocialLoginDataType>;
  socialMedia?: Maybe<Array<SocialValueType>>;
  source?: Maybe<SourcesEnum>;
  status?: Maybe<UserStatus>;
  target?: Maybe<TargetIdsType>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  username?: Maybe<Scalars['String']['output']>;
  wallets?: Maybe<Array<SimpleWalletType>>;
  widget?: Maybe<Scalars['Boolean']['output']>;
  work?: Maybe<Array<UserWorkType>>;
};

export type SimpleWalletType = {
  __typename?: 'SimpleWalletType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  coin?: Maybe<CoinSimpleType>;
  fee?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  usage?: Maybe<WalletUsageEnum>;
  walletType?: Maybe<WalletTypeEnum>;
};

export type SingleAnswerDtoType = {
  __typename?: 'SingleAnswerDtoType';
  answer: ResponseAnswerType;
  count: Scalars['Int']['output'];
  percentage: Scalars['Decimal']['output'];
};

export type SingleMediaInput = {
  deg360?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<PictureInput>;
  videos?: InputMaybe<Scalars['String']['input']>;
};

export enum SlideVisualTypeEnum {
  ICON = 'ICON',
  PICTURE = 'PICTURE'
}

export type SlidesContentCallToActionInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type SlidesContentCallToActionType = {
  __typename?: 'SlidesContentCallToActionType';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

export type SlidesContentInput = {
  calltoaction?: InputMaybe<SlidesContentCallToActionInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<PictureInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SlidesContentType = {
  __typename?: 'SlidesContentType';
  calltoaction?: Maybe<SlidesContentCallToActionType>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  image?: Maybe<PictureType>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SlidesInput = {
  content?: InputMaybe<Array<SlidesContentInput>>;
  reference?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
  translation?: InputMaybe<Array<SlidesTranslationInput>>;
  visualType?: InputMaybe<SlideVisualTypeEnum>;
};

export type SlidesTranslationInput = {
  content: Array<SlidesContentInput>;
  language: Scalars['ID']['input'];
};

export type SlidesTranslationType = {
  __typename?: 'SlidesTranslationType';
  content: Array<SlidesContentType>;
  language: LanguageType;
};

export type SlidesType = {
  __typename?: 'SlidesType';
  content?: Maybe<Array<SlidesContentType>>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  target: TargetType;
  translation?: Maybe<Array<SlidesTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  visualType?: Maybe<SlideVisualTypeEnum>;
};

export type SlidesWithoutTranslationType = {
  __typename?: 'SlidesWithoutTranslationType';
  content?: Maybe<Array<SlidesContentType>>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  visualType?: Maybe<SlideVisualTypeEnum>;
};

export enum SmsActionEnum {
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  ORDER_CREATED = 'ORDER_CREATED',
  PRODUCT_CANCELED = 'PRODUCT_CANCELED',
  PRODUCT_CONFIRMED = 'PRODUCT_CONFIRMED',
  PRODUCT_DELIVERED = 'PRODUCT_DELIVERED',
  PRODUCT_PICKUP_READY = 'PRODUCT_PICKUP_READY',
  REGISTRATION_CONFIRMATION = 'REGISTRATION_CONFIRMATION',
  REGISTRATION_REQUEST = 'REGISTRATION_REQUEST',
  VALIDATE_PHONE = 'VALIDATE_PHONE'
}

export enum SmsGatewayEnum {
  TUNISIE_SMS = 'TUNISIE_SMS'
}

export type SmsIntegrationAccessInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
};

export type SmsIntegrationAccessType = {
  __typename?: 'SmsIntegrationAccessType';
  key?: Maybe<Scalars['String']['output']>;
  sender?: Maybe<Scalars['String']['output']>;
};

export type SmsIntegrationActionInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  definition?: InputMaybe<SmsActionEnum>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  translation?: InputMaybe<Array<SmsIntegrationActionTranslationInput>>;
};

export type SmsIntegrationActionTranslationInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['ID']['input']>;
};

export type SmsIntegrationActionTranslationType = {
  __typename?: 'SmsIntegrationActionTranslationType';
  content?: Maybe<Scalars['String']['output']>;
  language?: Maybe<LanguageType>;
};

export type SmsIntegrationActionType = {
  __typename?: 'SmsIntegrationActionType';
  content?: Maybe<Scalars['String']['output']>;
  definition?: Maybe<SmsActionEnum>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  translation?: Maybe<Array<SmsIntegrationActionTranslationType>>;
};

export type SmsIntegrationInput = {
  access?: InputMaybe<SmsIntegrationAccessInput>;
  actions?: InputMaybe<Array<SmsIntegrationActionInput>>;
  gateway?: InputMaybe<SmsGatewayEnum>;
  target?: InputMaybe<TargetAciInput>;
};

export type SmsIntegrationResponseType = {
  __typename?: 'SmsIntegrationResponseType';
  messageId: Scalars['String']['output'];
  statusCode: Scalars['String']['output'];
  statusMobile: Scalars['String']['output'];
  statusMsg: Scalars['String']['output'];
};

export type SmsIntegrationType = {
  __typename?: 'SmsIntegrationType';
  access?: Maybe<SmsIntegrationAccessType>;
  actions?: Maybe<Array<SmsIntegrationActionType>>;
  createdAt: Scalars['DateTime']['output'];
  gateway?: Maybe<SmsGatewayEnum>;
  id: Scalars['ID']['output'];
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type SmsLogType = {
  __typename?: 'SmsLogType';
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  expirationDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  phone?: Maybe<IPhoneType>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  validationNumber?: Maybe<Scalars['Int']['output']>;
};

export enum SocialActionEnum {
  LIKE = 'LIKE',
  SHARE = 'SHARE'
}

export enum SocialContentTypeEnum {
  PAGE = 'PAGE',
  POST = 'POST',
  PROFILE = 'PROFILE',
  REEL = 'REEL',
  STORY = 'STORY',
  VIDEO = 'VIDEO'
}

export enum SocialImageStyleEnum {
  BUBBLE = 'BUBBLE',
  COLOR = 'COLOR',
  COLOR_HAND_DROWN = 'COLOR_HAND_DROWN',
  STICKER = 'STICKER'
}

export type SocialImagesImagesInput = {
  png?: InputMaybe<SocialImagesImagesSetInput>;
  svg?: InputMaybe<SocialImagesImagesSetInput>;
};

export type SocialImagesImagesSetInput = {
  size48?: InputMaybe<PictureInput>;
  size96?: InputMaybe<PictureInput>;
  size144?: InputMaybe<PictureInput>;
  size240?: InputMaybe<PictureInput>;
  size480?: InputMaybe<PictureInput>;
};

export type SocialImagesImagesSetType = {
  __typename?: 'SocialImagesImagesSetType';
  size48?: Maybe<PictureType>;
  size96?: Maybe<PictureType>;
  size144?: Maybe<PictureType>;
  size240?: Maybe<PictureType>;
  size480?: Maybe<PictureType>;
};

export type SocialImagesImagesType = {
  __typename?: 'SocialImagesImagesType';
  png?: Maybe<SocialImagesImagesSetType>;
  svg?: Maybe<SocialImagesImagesSetType>;
};

export type SocialImagesInput = {
  images?: InputMaybe<Array<SocialImagesImagesInput>>;
  style: SocialImageStyleEnum;
};

export type SocialImagesType = {
  __typename?: 'SocialImagesType';
  images?: Maybe<Array<SocialImagesImagesType>>;
  style: SocialImageStyleEnum;
};

export type SocialInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  fontIcon?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<SocialImagesInput>>;
  name: Scalars['String']['input'];
};

export type SocialLoginDataType = {
  __typename?: 'SocialLoginDataType';
  apple?: Maybe<AppleDataType>;
  facebook?: Maybe<FacebookDataType>;
  google?: Maybe<GoogleDataType>;
  ooredoo?: Maybe<OoredooDataType>;
  partner?: Maybe<PartnerLoginType>;
};

export type SocialPaginatedType = {
  __typename?: 'SocialPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<SocialType>;
};

export type SocialType = {
  __typename?: 'SocialType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fontIcon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<SocialImagesType>>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SocialValueInput = {
  name: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

export type SocialValueType = {
  __typename?: 'SocialValueType';
  name?: Maybe<SocialType>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum SourcesEnum {
  FIGAMY = 'FIGAMY',
  OOREDOO = 'OOREDOO'
}

export type SpecialOfferType = {
  __typename?: 'SpecialOfferType';
  hours?: Maybe<Array<OpeningHoursDayType>>;
  offerType?: Maybe<SpecialOffersType>;
};

export enum SpecialOffersType {
  BAR = 'BAR',
  BREAKFAST = 'BREAKFAST',
  BRUNCH = 'BRUNCH',
  DINNER = 'DINNER',
  HAPPY_HOUR = 'HAPPY_HOUR',
  LUNCH = 'LUNCH'
}

export type SpecilOfferInput = {
  hours?: InputMaybe<Array<OpeningHoursDayInput>>;
  offerType?: InputMaybe<SpecialOffersType>;
};

export type SquadsPlayersType = {
  __typename?: 'SquadsPlayersType';
  age?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
};

export type SquadsTeamType = {
  __typename?: 'SquadsTeamType';
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SquadsType = {
  __typename?: 'SquadsType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  players?: Maybe<Array<SquadsPlayersType>>;
  team?: Maybe<SquadsTeamType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type StandingLeagueType = {
  __typename?: 'StandingLeagueType';
  country?: Maybe<Scalars['String']['output']>;
  flag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
  standings?: Maybe<Array<Array<StandingType>>>;
};

export type StandingStatGoalsType = {
  __typename?: 'StandingStatGoalsType';
  against?: Maybe<Scalars['Float']['output']>;
  forstat?: Maybe<Scalars['Float']['output']>;
};

export type StandingStatType = {
  __typename?: 'StandingStatType';
  goals?: Maybe<StandingStatGoalsType>;
  lose?: Maybe<Scalars['Float']['output']>;
  played?: Maybe<Scalars['Float']['output']>;
  win?: Maybe<Scalars['Float']['output']>;
};

export type StandingTeamType = {
  __typename?: 'StandingTeamType';
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type StandingType = {
  __typename?: 'StandingType';
  all?: Maybe<StandingStatType>;
  away?: Maybe<StandingStatType>;
  description?: Maybe<Scalars['String']['output']>;
  form?: Maybe<Scalars['String']['output']>;
  goalsDiff?: Maybe<Scalars['Float']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  home?: Maybe<StandingStatType>;
  points?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  team?: Maybe<StandingTeamType>;
  update?: Maybe<Scalars['DateTime']['output']>;
};

export type StandingsType = {
  __typename?: 'StandingsType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  league?: Maybe<StandingLeagueType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type StatBiggestType = {
  __typename?: 'StatBiggestType';
  goals?: Maybe<StatFaType>;
  loses?: Maybe<StatHaType>;
  streak?: Maybe<StatWdlType>;
  wins?: Maybe<StatHaType>;
};

export type StatCardsType = {
  __typename?: 'StatCardsType';
  red?: Maybe<StatMinuteType>;
  yellow?: Maybe<StatMinuteType>;
};

export type StatFaType = {
  __typename?: 'StatFAType';
  against?: Maybe<StatHaType>;
  forstat?: Maybe<StatHaType>;
};

export type StatFixturesType = {
  __typename?: 'StatFixturesType';
  draws?: Maybe<StatHatType>;
  loses?: Maybe<StatHatType>;
  played?: Maybe<StatHatType>;
  wins?: Maybe<StatHatType>;
};

export type StatFpType = {
  __typename?: 'StatFpType';
  formation?: Maybe<Scalars['String']['output']>;
  played?: Maybe<Scalars['Float']['output']>;
};

export type StatGoalsType = {
  __typename?: 'StatGoalsType';
  against?: Maybe<StatTamType>;
  forstat?: Maybe<StatTamType>;
};

export type StatHatType = {
  __typename?: 'StatHATType';
  away?: Maybe<Scalars['Float']['output']>;
  home?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type StatHaType = {
  __typename?: 'StatHAType';
  away?: Maybe<Scalars['String']['output']>;
  home?: Maybe<Scalars['String']['output']>;
};

export type StatLeagueType = {
  __typename?: 'StatLeagueType';
  country?: Maybe<Scalars['String']['output']>;
  flag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
};

export type StatMinuteType = {
  __typename?: 'StatMinuteType';
  fixtyoneToSeventyfive?: Maybe<StatTpType>;
  fourtysixToSixty?: Maybe<StatTpType>;
  hundredsixToHundredtwenty?: Maybe<StatTpType>;
  ninetyoneToHundredfive?: Maybe<StatTpType>;
  seventysixToNinety?: Maybe<StatTpType>;
  sixteenToThirty?: Maybe<StatTpType>;
  thirtyoneToFourtyfive?: Maybe<StatTpType>;
  zeroToFifteen?: Maybe<StatTpType>;
};

export type StatPenaltyType = {
  __typename?: 'StatPenaltyType';
  missed?: Maybe<StatTpType>;
  scored?: Maybe<StatTpType>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type StatTamType = {
  __typename?: 'StatTAMType';
  average?: Maybe<StatHatType>;
  minute?: Maybe<StatMinuteType>;
  total?: Maybe<StatHatType>;
};

export type StatTaType = {
  __typename?: 'StatTAType';
  average?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type StatTpType = {
  __typename?: 'StatTPType';
  percentage?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type StatTeamType = {
  __typename?: 'StatTeamType';
  id?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type StatWdlType = {
  __typename?: 'StatWDLType';
  draws?: Maybe<Scalars['Float']['output']>;
  loses?: Maybe<Scalars['Float']['output']>;
  wins?: Maybe<Scalars['Float']['output']>;
};

export enum StateCapitalEnum {
  ADMIN = 'ADMIN',
  MINOR = 'MINOR',
  PRIMARY = 'PRIMARY'
}

export type StateInput = {
  adminName: Scalars['String']['input'];
  ascii: Scalars['String']['input'];
  capital: StateCapitalEnum;
  country?: InputMaybe<Scalars['ID']['input']>;
  flagSquare?: InputMaybe<PictureInput>;
  flagWide?: InputMaybe<PictureInput>;
  lat: Scalars['Decimal']['input'];
  lng: Scalars['Decimal']['input'];
  name: Scalars['String']['input'];
  population?: InputMaybe<Scalars['Decimal']['input']>;
};

export type StatePaginatedType = {
  __typename?: 'StatePaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<StateType>;
};

export type StateType = {
  __typename?: 'StateType';
  adminName?: Maybe<Scalars['String']['output']>;
  ascii?: Maybe<Scalars['String']['output']>;
  capital?: Maybe<StateCapitalEnum>;
  country?: Maybe<CountryType>;
  createdAt: Scalars['DateTime']['output'];
  flagSquare?: Maybe<PictureType>;
  flagWide?: Maybe<PictureType>;
  id: Scalars['ID']['output'];
  lat?: Maybe<Scalars['Decimal']['output']>;
  lng?: Maybe<Scalars['Decimal']['output']>;
  name: Scalars['String']['output'];
  population?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type StaticDataInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type StaticDataType = {
  __typename?: 'StaticDataType';
  createdAt: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type StaticTranslationInput = {
  app?: InputMaybe<TranslationAppEnum>;
  reference: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
  translation: Array<StaticTranslationTranslationInput>;
};

export type StaticTranslationPaginateType = {
  __typename?: 'StaticTranslationPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<StaticTranslationType>;
};

export type StaticTranslationReferenceCheckType = {
  __typename?: 'StaticTranslationReferenceCheckType';
  hasReference: Scalars['Boolean']['output'];
};

export type StaticTranslationSimplePaginateType = {
  __typename?: 'StaticTranslationSimplePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<StaticTranslationSimpleType>;
};

export type StaticTranslationSimpleType = {
  __typename?: 'StaticTranslationSimpleType';
  app: TranslationAppEnum;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  reference: Scalars['String']['output'];
  target?: Maybe<TargetSimpleType>;
  translation: Array<StaticTranslationTranslationSimpleType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type StaticTranslationTranslationInput = {
  content: Scalars['String']['input'];
  language?: InputMaybe<Scalars['ID']['input']>;
};

export type StaticTranslationTranslationSimpleType = {
  __typename?: 'StaticTranslationTranslationSimpleType';
  _id: Scalars['ID']['output'];
  content: Scalars['String']['output'];
  language?: Maybe<Scalars['ID']['output']>;
};

export type StaticTranslationTranslationType = {
  __typename?: 'StaticTranslationTranslationType';
  _id: Scalars['ID']['output'];
  content: Scalars['String']['output'];
  language?: Maybe<LanguageType>;
};

export type StaticTranslationType = {
  __typename?: 'StaticTranslationType';
  app: TranslationAppEnum;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  reference: Scalars['String']['output'];
  target?: Maybe<TargetType>;
  translation: Array<StaticTranslationTranslationType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type StatisticsIntType = {
  __typename?: 'StatisticsIntType';
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type StatisticsTeamsType = {
  __typename?: 'StatisticsTeamsType';
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type StatisticsType = {
  __typename?: 'StatisticsType';
  createdAt: Scalars['DateTime']['output'];
  fixture?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  statistics?: Maybe<Array<StatisticsIntType>>;
  team?: Maybe<StatisticsTeamsType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type StatsEntry = {
  __typename?: 'StatsEntry';
  compare?: Maybe<CompareRankType>;
  credit: Scalars['String']['output'];
  entryDate?: Maybe<Scalars['DateTime']['output']>;
  rank: Scalars['Float']['output'];
};

export type StatsType = {
  __typename?: 'StatsType';
  numberOfFollowers: Scalars['Int']['output'];
  numberOfProducts: Scalars['Int']['output'];
  numberOfSubscribers: Scalars['Int']['output'];
};

export type StockPaginateType = {
  __typename?: 'StockPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<StockType>;
};

export type StockPixelInput = {
  quantityToSellOnFacebook?: InputMaybe<Scalars['Int']['input']>;
};

export type StockPixelType = {
  __typename?: 'StockPixelType';
  quantityToSellOnFacebook?: Maybe<Scalars['Int']['output']>;
};

export type StockRawType = {
  __typename?: 'StockRawType';
  createdAt: Scalars['DateTime']['output'];
  currentStock: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  minimumStockQuantity: Scalars['Int']['output'];
  outOfStock: Scalars['Boolean']['output'];
  pixel?: Maybe<StockPixelType>;
  stockCapacity: Scalars['Int']['output'];
  stockPercentage: Scalars['Decimal']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type StockStatsType = {
  __typename?: 'StockStatsType';
  daily: Array<PeriodStatsType>;
  total: Scalars['Int']['output'];
};

export type StockType = {
  __typename?: 'StockType';
  barcode: BarcodeType;
  createdAt: Scalars['DateTime']['output'];
  currentStock: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  minimumStockQuantity: Scalars['Int']['output'];
  outOfStock: Scalars['Boolean']['output'];
  pixel?: Maybe<StockPixelType>;
  stockCapacity: Scalars['Int']['output'];
  stockPercentage: Scalars['Decimal']['output'];
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  warehouse?: Maybe<WarehouseType>;
};

export type StockValidationType = {
  __typename?: 'StockValidationType';
  headersValid?: Maybe<Scalars['Boolean']['output']>;
  isBarcodeComplete?: Maybe<Scalars['Boolean']['output']>;
  isCapacityComplete?: Maybe<Scalars['Boolean']['output']>;
  isMinimumComplete?: Maybe<Scalars['Boolean']['output']>;
  isStockComplete?: Maybe<Scalars['Boolean']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  overallValidation?: Maybe<Scalars['Boolean']['output']>;
};

export type StocksCountType = {
  __typename?: 'StocksCountType';
  inPeriod: Scalars['Int']['output'];
  inStock: StockStatsType;
  outOfStock: StockStatsType;
  total: Scalars['Int']['output'];
};

export enum StoriesContentTypeEnum {
  EMOJI = 'EMOJI',
  GIF = 'GIF',
  STICKER = 'STICKER',
  TEXT = 'TEXT'
}

export type StoriesFilterInput = {
  forConsumer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group id */
  group?: InputMaybe<Scalars['ID']['input']>;
  /** Manufacturer id */
  manufacturer?: InputMaybe<Scalars['ID']['input']>;
  /** Pos id */
  pos?: InputMaybe<Scalars['ID']['input']>;
  /** User id */
  user?: InputMaybe<Scalars['ID']['input']>;
  /** wholesaler id */
  wholesaler?: InputMaybe<Scalars['ID']['input']>;
};

export type StoriesInput = {
  content?: InputMaybe<Array<StoryContentContentInput>>;
  /** Group id */
  group?: InputMaybe<Scalars['ID']['input']>;
  manufacturer?: InputMaybe<Scalars['ID']['input']>;
  picture?: InputMaybe<PictureInput>;
  pos?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
  video?: InputMaybe<PictureInput>;
  wholesaler?: InputMaybe<Scalars['ID']['input']>;
};

export type StoriesPaginatedType = {
  __typename?: 'StoriesPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isAllStoriesSeen: Scalars['Boolean']['output'];
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<StoriesType>;
};

export type StoriesType = {
  __typename?: 'StoriesType';
  content?: Maybe<Array<StoryContentContentType>>;
  createdAt: Scalars['DateTime']['output'];
  /** group */
  group?: Maybe<GroupType>;
  id: Scalars['ID']['output'];
  manufacturer?: Maybe<ManufacturerType>;
  media?: Maybe<StoryMediaType>;
  pos?: Maybe<PointOfSaleType>;
  seen?: Maybe<Scalars['Boolean']['output']>;
  seenBy?: Maybe<Array<UserType>>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
  wholesaler?: Maybe<WholesalerType>;
};

export type StoriesViewsStatusFilterInput = {
  /** Group id */
  group?: InputMaybe<Scalars['ID']['input']>;
  /** manufacturer id */
  manufacturer?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Pos id */
  pos?: InputMaybe<Array<Scalars['String']['input']>>;
  /** User id */
  user?: InputMaybe<Array<Scalars['String']['input']>>;
  /** wholesaler id */
  wholesaler?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StoriesViewsStatusType = {
  __typename?: 'StoriesViewsStatusType';
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  manufacturer?: Maybe<Scalars['String']['output']>;
  pos?: Maybe<Scalars['String']['output']>;
  seen: Scalars['Boolean']['output'];
  user?: Maybe<Scalars['String']['output']>;
  wholesaler?: Maybe<Scalars['String']['output']>;
};

export type StoryContentContentInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<StoriesContentTypeEnum>;
  dimension?: InputMaybe<StoryContentDimensionInput>;
  position?: InputMaybe<StoryContentPositionInput>;
};

export type StoryContentContentType = {
  __typename?: 'StoryContentContentType';
  color?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<StoriesContentTypeEnum>;
  dimension?: Maybe<StoryContentDimensionType>;
  position?: Maybe<StoryContentPositionType>;
};

export type StoryContentDimensionInput = {
  fontSize?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type StoryContentDimensionType = {
  __typename?: 'StoryContentDimensionType';
  fontSize?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type StoryContentPositionInput = {
  bottom?: InputMaybe<Scalars['Float']['input']>;
  left?: InputMaybe<Scalars['Float']['input']>;
  right?: InputMaybe<Scalars['Float']['input']>;
  top?: InputMaybe<Scalars['Float']['input']>;
};

export type StoryContentPositionType = {
  __typename?: 'StoryContentPositionType';
  bottom?: Maybe<Scalars['Float']['output']>;
  left?: Maybe<Scalars['Float']['output']>;
  right?: Maybe<Scalars['Float']['output']>;
  top?: Maybe<Scalars['Float']['output']>;
};

export type StoryMediaType = {
  __typename?: 'StoryMediaType';
  picture?: Maybe<PictureType>;
  video?: Maybe<PictureType>;
};

export type StringListType = {
  __typename?: 'StringListType';
  list?: Maybe<Array<Scalars['String']['output']>>;
};

export type SubjectsFullType = {
  __typename?: 'SubjectsFullType';
  consumer?: Maybe<UserType>;
  deliveryMan?: Maybe<UserType>;
  pos?: Maybe<PointOfSaleType>;
  user?: Maybe<UserType>;
};

export type SubjectsType = {
  __typename?: 'SubjectsType';
  consumer?: Maybe<Scalars['String']['output']>;
  deliveryMan?: Maybe<Scalars['String']['output']>;
  pos?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type SubscribersFullType = {
  __typename?: 'SubscribersFullType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  status?: Maybe<SubscriptionStatus>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type SubscribersFullWithReputationType = {
  __typename?: 'SubscribersFullWithReputationType';
  createdAt: Scalars['DateTime']['output'];
  currentReputationLevel?: Maybe<ReputationWithoutTargetType>;
  id: Scalars['ID']['output'];
  nextReputationLevel?: Maybe<ReputationWithoutTargetType>;
  status?: Maybe<SubscriptionStatus>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
  wallet?: Maybe<WalletType>;
};

export type SubscribersInput = {
  target: TargetAciInput;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type SubscribersWithReputationsPaginateType = {
  __typename?: 'SubscribersWithReputationsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<SubscribersFullWithReputationType>;
};

export type Subscription = {
  __typename?: 'Subscription';
  listenForAmountPushedEvent: ListenForAmountPushedEventType;
  listenForAudienceCriteriaStarted: AudienceCriteriaType;
  listenForAudienceStarted: AudienceType;
  listenForBrandCreated: BrandType;
  listenForChallengeStarted: ChallengeType;
  listenForChallengeWon: ChallengeType;
  listenForCompanyCreated: CompanyType;
  listenForCorporateUserStatusChanged: UserStatsType;
  listenForDeliveryMarketPlaceOrderCreated: MarketPlaceOrderDtoType;
  listenForFormCreated: FormDtoType;
  listenForLinkAccountApproved: LinkAccountType;
  listenForLoyaltyProgramCreated: LoyaltyProgramType;
  listenForManufacturerCreated: ManufacturerType;
  listenForMessageGroupUpdated: MessageGroupType;
  listenForNewAdhocCorporateNotification: CorporateNotificationFullType;
  listenForNewAdhocNotification: NotificationFullType;
  listenForNewMessage: MessageType;
  listenForPOSCategoryCreated: PosCategoryType;
  listenForPartnershipReferral: PartnerReferralType;
  listenForProductCreated: ProductType;
  listenForQuestActionDefinitionStarted: QuestActionDefinitionType;
  listenForQuestActivityStarted: QuestActivityType;
  listenForQuestTypeStarted: QuestTypeType;
  listenForQuestionCreated: QuestionDtoType;
  listenForRequest: RequestType;
  listenForResponseCreated: ResponseDtoType;
  listenForSendAdhocCorporateNotificationTest: AdhocCorporateNotificationTestType;
  listenForSendAdhocNotificationTest: AdhocNotificationTestType;
  listenForSendThemAndLanguageToWidget: ThemAndLanguageToWidgetType;
  listenForSubscriptionReply: SubscribersFullType;
  listenForSubscriptionRequest: SubscribersFullType;
  listenForUpdateProductMarketPlaceOrderStatus: MarketPlaceOrderDtoType;
  listenForUpdateProductPaymentStatus: MarketPlaceOrderDtoType;
  listenForUserAuthentication: UserAuthenticationType;
  listenForUserCreated: UserType;
  listenForUserEvents: EventLogBaseType;
  listenForUserLoggedInByTarget: LoginType;
  listenForUserLoggedInForTarget: CorporateLoginWithActionTypeType;
  listenForUserLoggedOutByTarget: DeleteResponseDtoType;
  listenForUserStatusChanged: UserType;
  listenForWalletTransactionCreated: WalletTransactionForSubscriptionType;
  listenForWholesalerCreated: WholesalerType;
  pointOfSaleCreated: PointOfSaleType;
};


export type SubscriptionListenForAmountPushedEventArgs = {
  reference: Scalars['String']['input'];
};


export type SubscriptionListenForAudienceCriteriaStartedArgs = {
  targets: TargetsInput;
};


export type SubscriptionListenForAudienceStartedArgs = {
  targets: TargetsInput;
};


export type SubscriptionListenForChallengeStartedArgs = {
  target: TargetAciInput;
};


export type SubscriptionListenForChallengeWonArgs = {
  user: Scalars['ID']['input'];
};


export type SubscriptionListenForCorporateUserStatusChangedArgs = {
  target: TargetAciInput;
};


export type SubscriptionListenForDeliveryMarketPlaceOrderCreatedArgs = {
  posId: Scalars['ID']['input'];
};


export type SubscriptionListenForLinkAccountApprovedArgs = {
  requestId: Scalars['ID']['input'];
};


export type SubscriptionListenForMessageGroupUpdatedArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionListenForNewAdhocCorporateNotificationArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionListenForNewMessageArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionListenForQuestActionDefinitionStartedArgs = {
  targets: TargetsInput;
};


export type SubscriptionListenForQuestActivityStartedArgs = {
  targets: TargetsInput;
};


export type SubscriptionListenForQuestTypeStartedArgs = {
  targets: TargetsInput;
};


export type SubscriptionListenForSendAdhocCorporateNotificationTestArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionListenForSendAdhocNotificationTestArgs = {
  userId: Scalars['String']['input'];
};


export type SubscriptionListenForSendThemAndLanguageToWidgetArgs = {
  reference: Scalars['String']['input'];
  target: TargetAciInput;
};


export type SubscriptionListenForSubscriptionReplyArgs = {
  userId: Scalars['String']['input'];
};


export type SubscriptionListenForSubscriptionRequestArgs = {
  target: TargetAciInput;
};


export type SubscriptionListenForUpdateProductMarketPlaceOrderStatusArgs = {
  deliveryManId?: InputMaybe<Scalars['ID']['input']>;
  posId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionListenForUpdateProductPaymentStatusArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionListenForUserEventsArgs = {
  target: TargetAciInput;
};


export type SubscriptionListenForUserLoggedInByTargetArgs = {
  reference: Scalars['String']['input'];
};


export type SubscriptionListenForUserLoggedInForTargetArgs = {
  reference: Scalars['String']['input'];
  target: TargetAciInput;
};


export type SubscriptionListenForUserLoggedOutByTargetArgs = {
  reference: Scalars['String']['input'];
};


export type SubscriptionListenForWalletTransactionCreatedArgs = {
  posId: Scalars['ID']['input'];
};

export enum SubscriptionCycleEnum {
  ADHOC = 'ADHOC',
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  YEARLY = 'YEARLY'
}

export enum SubscriptionStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export type SuccessResponseDtoType = {
  __typename?: 'SuccessResponseDtoType';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SuccessResponseWithAmountPushedDtoType = {
  __typename?: 'SuccessResponseWithAmountPushedDtoType';
  amountPushed: Scalars['Decimal']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SuccessResponseWithOrderIdType = {
  __typename?: 'SuccessResponseWithOrderIdType';
  message: Scalars['String']['output'];
  orderId: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type SuccessResponseWithTokenDtoType = {
  __typename?: 'SuccessResponseWithTokenDtoType';
  accessToken?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SupplierInput = {
  externalId: Scalars['String']['input'];
  reference: Scalars['String']['input'];
  supplier: TargetAciInput;
  target: TargetAciInput;
};

export type SupplierType = {
  __typename?: 'SupplierType';
  createdAt: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  reference: Scalars['String']['output'];
  supplier: TargetType;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum SupplierTypeEnum {
  FRANCHISE = 'FRANCHISE',
  MANUFACTURER = 'MANUFACTURER',
  WHOLESALER = 'WHOLESALER'
}

export type SupplliersChartDashboardType = {
  __typename?: 'SupplliersChartDashboardType';
  earnings: Array<Scalars['Decimal']['output']>;
  orders: Array<Scalars['Decimal']['output']>;
  refunds: Array<Scalars['Decimal']['output']>;
};

export type SupplliersDashboardType = {
  __typename?: 'SupplliersDashboardType';
  chart: SupplliersChartDashboardType;
  conversion: Scalars['Decimal']['output'];
  earnings: Scalars['Decimal']['output'];
  orders: Scalars['Int']['output'];
  refunds: Scalars['Decimal']['output'];
};

export type TagInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TagType = {
  __typename?: 'TagType';
  content?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TargetAciInput = {
  /** manufacturer id */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** pos id */
  pos?: InputMaybe<Scalars['String']['input']>;
  /** Commercial id */
  user?: InputMaybe<Scalars['String']['input']>;
  /** wholesaler id */
  wholesaler?: InputMaybe<Scalars['String']['input']>;
};

export type TargetCreateInput = {
  /** manufacturer input */
  manufacturer?: InputMaybe<ManufacturerCreateInput>;
  /** pos input */
  pos?: InputMaybe<PointOfSaleInput>;
  /** User input */
  user: UserInput;
  /** wholesaler input */
  wholesaler?: InputMaybe<WholesalerCreateInput>;
};

export type TargetCurrencyInput = {
  currency?: InputMaybe<Scalars['ID']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TargetCurrencyType = {
  __typename?: 'TargetCurrencyType';
  currency?: Maybe<CurrencyType>;
  default?: Maybe<Scalars['Boolean']['output']>;
};

export type TargetDtoType = {
  __typename?: 'TargetDtoType';
  pos?: Maybe<PointOfSaleType>;
  user?: Maybe<UserType>;
};

export type TargetFilterType = {
  __typename?: 'TargetFilterType';
  /** manufacturer */
  manufacturer?: Maybe<FilterNameFieldType>;
  /** PointOfSale */
  pos?: Maybe<FilterNamePictureFieldType>;
  /** wholesaler */
  wholesaler?: Maybe<FilterNameFieldType>;
};

export type TargetIdsType = {
  __typename?: 'TargetIdsType';
  /** manufacturer id */
  manufacturer?: Maybe<Scalars['ID']['output']>;
  /** pos id */
  pos?: Maybe<Scalars['ID']['output']>;
  /** wholesaler id */
  wholesaler?: Maybe<Scalars['ID']['output']>;
};

export type TargetInput = {
  pos?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type TargetPaginateType = {
  __typename?: 'TargetPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<TargetType>;
};

export type TargetPluginInput = {
  plugin: Scalars['ID']['input'];
  target: TargetAciInput;
};

export type TargetPluginType = {
  __typename?: 'TargetPluginType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  plugin: PluginType;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type TargetPluginUpdateInput = {
  id: Scalars['ID']['input'];
  plugin?: InputMaybe<Scalars['ID']['input']>;
  target?: InputMaybe<TargetAciInput>;
};

export type TargetSettingsHappyHourType = {
  __typename?: 'TargetSettingsHappyHourType';
  mobile: Scalars['Boolean']['output'];
  store: Scalars['Boolean']['output'];
  web: Scalars['Boolean']['output'];
};

export type TargetSettingsType = {
  __typename?: 'TargetSettingsType';
  catalogue?: Maybe<Scalars['Boolean']['output']>;
  coupons?: Maybe<CouponsSettingsType>;
  freebies?: Maybe<Scalars['Boolean']['output']>;
  happyHour?: Maybe<TargetSettingsHappyHourType>;
  mobile?: Maybe<Scalars['Boolean']['output']>;
  quests?: Maybe<Scalars['Boolean']['output']>;
  referral?: Maybe<LoyaltySettingsReferralType>;
  store?: Maybe<Scalars['Boolean']['output']>;
  web?: Maybe<Scalars['Boolean']['output']>;
};

export type TargetShoppingCartType = {
  __typename?: 'TargetShoppingCartType';
  deliveryFees?: Maybe<Scalars['Decimal']['output']>;
  discount?: Maybe<DiscountDtoType>;
  extraFees?: Maybe<Array<MarketPlaceOrderDtoFeesType>>;
  price?: Maybe<PriceFullType>;
  taxValue?: Maybe<ReduciblePriceType>;
};

export type TargetSimpleType = {
  __typename?: 'TargetSimpleType';
  /** manufacturer id. */
  manufacturer?: Maybe<Scalars['ID']['output']>;
  /** PointOfSale id. */
  pos?: Maybe<Scalars['ID']['output']>;
  /** wholesaler id. */
  wholesaler?: Maybe<Scalars['ID']['output']>;
};

export type TargetStatsType = {
  __typename?: 'TargetStatsType';
  freebies: Scalars['Int']['output'];
  funds?: Maybe<WalletType>;
  quests: Scalars['Int']['output'];
};

export type TargetTransferInput = {
  /** manufacturer id */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** pos id */
  pos?: InputMaybe<Scalars['String']['input']>;
  /** user id */
  user?: InputMaybe<Scalars['String']['input']>;
  /** wholesaler id */
  wholesaler?: InputMaybe<Scalars['String']['input']>;
};

export type TargetType = {
  __typename?: 'TargetType';
  /** manufacturer */
  manufacturer?: Maybe<ManufacturerType>;
  /** PointOfSale */
  pos?: Maybe<PointOfSaleType>;
  /** wholesaler */
  wholesaler?: Maybe<WholesalerType>;
};

export enum TargetTypeEnum {
  MANUFACTURER = 'MANUFACTURER',
  POS = 'POS',
  USER = 'USER'
}

export type TargetWithGroupAndStoriesType = {
  __typename?: 'TargetWithGroupAndStoriesType';
  /** group */
  group?: Maybe<GroupType>;
  /** is all Stories are seen */
  isAllStoriesSeen: Scalars['Boolean']['output'];
  /** manufacturer */
  manufacturer?: Maybe<ManufacturerType>;
  /** PointOfSale */
  pos?: Maybe<PointOfSaleType>;
  /** Stories list */
  stories?: Maybe<Array<StoriesType>>;
  /** user */
  user?: Maybe<UserType>;
  /** wholesaler */
  wholesaler?: Maybe<WholesalerType>;
};

export type TargetWithGroupInput = {
  /** Group id */
  group?: InputMaybe<Scalars['ID']['input']>;
  /** manufacturer id */
  manufacturer?: InputMaybe<Scalars['ID']['input']>;
  /** pos id */
  pos?: InputMaybe<Scalars['ID']['input']>;
  /** User id */
  user?: InputMaybe<Scalars['ID']['input']>;
  /** wholesaler id */
  wholesaler?: InputMaybe<Scalars['ID']['input']>;
};

export type TargetWithGroupType = {
  __typename?: 'TargetWithGroupType';
  /** group */
  group?: Maybe<GroupType>;
  /** manufacturer */
  manufacturer?: Maybe<ManufacturerType>;
  /** PointOfSale */
  pos?: Maybe<PointOfSaleType>;
  /** user */
  user?: Maybe<UserType>;
  /** wholesaler */
  wholesaler?: Maybe<WholesalerType>;
};

export type TargetWithPictureFilterType = {
  __typename?: 'TargetWithPictureFilterType';
  /** manufacturer */
  manufacturer?: Maybe<FilterNamePictureFieldType>;
  /** PointOfSale */
  pos?: Maybe<FilterNamePictureFieldType>;
  /** wholesaler */
  wholesaler?: Maybe<FilterNamePictureFieldType>;
};

export type TargetWithUserType = {
  __typename?: 'TargetWithUserType';
  /** manufacturer */
  manufacturer?: Maybe<ManufacturerType>;
  /** PointOfSale */
  pos?: Maybe<PointOfSaleType>;
  /** user */
  user?: Maybe<UserType>;
  /** wholesaler */
  wholesaler?: Maybe<WholesalerType>;
};

export type TargetWithoutUserInput = {
  /** manufacturer id */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** pos id */
  pos?: InputMaybe<Scalars['String']['input']>;
  /** wholesaler id */
  wholesaler?: InputMaybe<Scalars['String']['input']>;
};

export type TargetsInput = {
  /** list of manufacturers ids */
  manufacturer?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** list of pointOfSales ids */
  pos?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** list of wholesalers ids */
  wholesaler?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TargetsType = {
  __typename?: 'TargetsType';
  /** list of manufacturers */
  manufacturer?: Maybe<Array<ManufacturerType>>;
  /** list of pointOfSales */
  pos?: Maybe<Array<PointOfSaleType>>;
  /** list of wholesalers */
  wholesaler?: Maybe<Array<WholesalerType>>;
};

export type TaskInput = {
  done?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export enum TaskPriorityEnum {
  HIGH = 'HIGH',
  LOW = 'LOW',
  NORMAL = 'NORMAL'
}

export type TaskSectionPaginatedType = {
  __typename?: 'TaskSectionPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<TaskSectionType>;
};

export type TaskSectionType = {
  __typename?: 'TaskSectionType';
  archived: Scalars['Boolean']['output'];
  completed: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  priority: TaskPriorityEnum;
  rank: Scalars['Int']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetType;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TaskSectionWithTasksType = {
  __typename?: 'TaskSectionWithTasksType';
  archived: Scalars['Boolean']['output'];
  completed: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  priority: TaskPriorityEnum;
  rank: Scalars['Int']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetType;
  tasks: Array<GenericTaskType>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TaskType = {
  __typename?: 'TaskType';
  archived: Scalars['Boolean']['output'];
  completed: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  priority: TaskPriorityEnum;
  rank: Scalars['Int']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  taskSection: TaskSectionType;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TasksStatsType = {
  __typename?: 'TasksStatsType';
  done: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TaxInput = {
  company?: InputMaybe<Scalars['ID']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['Boolean']['input']>;
  use?: InputMaybe<Array<TaxUseEnum>>;
  value?: InputMaybe<TaxValueInput>;
};

export type TaxPaginateType = {
  __typename?: 'TaxPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<TaxType>;
};

export enum TaxSignEnum {
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE'
}

export type TaxType = {
  __typename?: 'TaxType';
  company?: Maybe<CompanyType>;
  createdAt: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  use?: Maybe<Array<TaxUseEnum>>;
  value?: Maybe<TaxVaType>;
};

export enum TaxUseEnum {
  PURCHASE = 'PURCHASE',
  SALE = 'SALE'
}

export type TaxVaType = {
  __typename?: 'TaxVaType';
  sign: TaxSignEnum;
  type: DiscountType;
  value?: Maybe<Scalars['Decimal']['output']>;
};

export type TaxValueInput = {
  sign?: InputMaybe<TaxSignEnum>;
  type?: InputMaybe<DiscountType>;
  value?: InputMaybe<Scalars['Decimal']['input']>;
};

export type TaxValueType = {
  __typename?: 'TaxValueType';
  total?: Maybe<Scalars['Decimal']['output']>;
  unit?: Maybe<Scalars['Decimal']['output']>;
};

export type TeamInformationType = {
  __typename?: 'TeamInformationType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  team?: Maybe<TeamType>;
  updatedAt: Scalars['DateTime']['output'];
  venue?: Maybe<VenueType>;
};

export type TeamSeasonsType = {
  __typename?: 'TeamSeasonsType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  seasons?: Maybe<Array<Scalars['Float']['output']>>;
  team?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TeamStatisticsType = {
  __typename?: 'TeamStatisticsType';
  biggest?: Maybe<StatBiggestType>;
  cards?: Maybe<StatCardsType>;
  clean_sheet?: Maybe<StatHatType>;
  createdAt: Scalars['DateTime']['output'];
  failed_to_score?: Maybe<StatHatType>;
  fixtures?: Maybe<StatFixturesType>;
  form?: Maybe<Scalars['String']['output']>;
  goals?: Maybe<StatGoalsType>;
  id?: Maybe<Scalars['ID']['output']>;
  league?: Maybe<StatLeagueType>;
  lineups?: Maybe<Array<StatFpType>>;
  penalty?: Maybe<StatPenaltyType>;
  team?: Maybe<StatTeamType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TeamType = {
  __typename?: 'TeamType';
  country?: Maybe<Scalars['String']['output']>;
  founded?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logo64?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  national?: Maybe<Scalars['String']['output']>;
};

export type TechDeviceBrandInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<DeviceBrandLogoInput>;
  name: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TechDeviceBrandPaginatedType = {
  __typename?: 'TechDeviceBrandPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<TechDeviceBrandType>;
};

export type TechDeviceBrandType = {
  __typename?: 'TechDeviceBrandType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  logo?: Maybe<DeviceBrandLogoType>;
  name: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TechDeviceInput = {
  batterySize?: InputMaybe<Scalars['String']['input']>;
  batteryType?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['ID']['input']>;
  cameraPixels?: InputMaybe<Scalars['String']['input']>;
  chipset?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  displayResolution?: InputMaybe<Scalars['String']['input']>;
  displaySize?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  os?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  ram?: InputMaybe<Scalars['String']['input']>;
  releasedat?: InputMaybe<Scalars['String']['input']>;
  specifications?: InputMaybe<TechDeviceSpecsInput>;
  storage?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  videoPixels?: InputMaybe<Scalars['String']['input']>;
};

export type TechDevicePaginatedType = {
  __typename?: 'TechDevicePaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<TechDeviceType>;
};

export type TechDeviceSpecsInput = {
  alarm?: InputMaybe<Scalars['String']['input']>;
  alertTypes?: InputMaybe<Scalars['String']['input']>;
  announced?: InputMaybe<Scalars['String']['input']>;
  band2g?: InputMaybe<Scalars['String']['input']>;
  bluetooth?: InputMaybe<Scalars['String']['input']>;
  browser?: InputMaybe<Scalars['String']['input']>;
  callRecords?: InputMaybe<Scalars['String']['input']>;
  cardSlot?: InputMaybe<Scalars['String']['input']>;
  clock?: InputMaybe<Scalars['String']['input']>;
  colors?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Scalars['String']['input']>;
  edge?: InputMaybe<Scalars['String']['input']>;
  games?: InputMaybe<Scalars['String']['input']>;
  gprs?: InputMaybe<Scalars['String']['input']>;
  gps?: InputMaybe<Scalars['String']['input']>;
  jack35mm?: InputMaybe<Scalars['String']['input']>;
  java?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Scalars['String']['input']>;
  loudspeaker?: InputMaybe<Scalars['String']['input']>;
  messaging?: InputMaybe<Scalars['String']['input']>;
  phonebook?: InputMaybe<Scalars['String']['input']>;
  radio?: InputMaybe<Scalars['String']['input']>;
  resolution?: InputMaybe<Scalars['String']['input']>;
  sensors?: InputMaybe<Scalars['String']['input']>;
  sim?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  technology?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  usb?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
  wlan?: InputMaybe<Scalars['String']['input']>;
};

export type TechDeviceSpecsType = {
  __typename?: 'TechDeviceSpecsType';
  alarm?: Maybe<Scalars['String']['output']>;
  alertTypes?: Maybe<Scalars['String']['output']>;
  announced?: Maybe<Scalars['String']['output']>;
  band2g?: Maybe<Scalars['String']['output']>;
  bluetooth?: Maybe<Scalars['String']['output']>;
  browser?: Maybe<Scalars['String']['output']>;
  callRecords?: Maybe<Scalars['String']['output']>;
  cardSlot?: Maybe<Scalars['String']['output']>;
  clock?: Maybe<Scalars['String']['output']>;
  colors?: Maybe<Scalars['String']['output']>;
  dimensions?: Maybe<Scalars['String']['output']>;
  edge?: Maybe<Scalars['String']['output']>;
  games?: Maybe<Scalars['String']['output']>;
  gprs?: Maybe<Scalars['String']['output']>;
  gps?: Maybe<Scalars['String']['output']>;
  jack35mm?: Maybe<Scalars['String']['output']>;
  java?: Maybe<Scalars['String']['output']>;
  languages?: Maybe<Scalars['String']['output']>;
  loudspeaker?: Maybe<Scalars['String']['output']>;
  messaging?: Maybe<Scalars['String']['output']>;
  phonebook?: Maybe<Scalars['String']['output']>;
  radio?: Maybe<Scalars['String']['output']>;
  resolution?: Maybe<Scalars['String']['output']>;
  sensors?: Maybe<Scalars['String']['output']>;
  sim?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  technology?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  usb?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['String']['output']>;
  wlan?: Maybe<Scalars['String']['output']>;
};

export type TechDeviceType = {
  __typename?: 'TechDeviceType';
  batterySize?: Maybe<Scalars['String']['output']>;
  batteryType?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<TechDeviceBrandType>;
  cameraPixels?: Maybe<Scalars['String']['output']>;
  chipset?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  displayResolution?: Maybe<Scalars['String']['output']>;
  displaySize?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  ram?: Maybe<Scalars['String']['output']>;
  releasedat?: Maybe<Scalars['String']['output']>;
  specifications?: Maybe<TechDeviceSpecsType>;
  storage?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
  videoPixels?: Maybe<Scalars['String']['output']>;
};

export type TechDeviceTypeInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nodeName?: InputMaybe<Scalars['String']['input']>;
  pictureSquare?: InputMaybe<PictureInput>;
  pictureWide?: InputMaybe<PictureInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TechDeviceTypePaginatedType = {
  __typename?: 'TechDeviceTypePaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<TechDeviceTypeType>;
};

export type TechDeviceTypeType = {
  __typename?: 'TechDeviceTypeType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nodeName?: Maybe<Scalars['String']['output']>;
  pictureSquare?: Maybe<PictureType>;
  pictureWide?: Maybe<PictureType>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ThemAndLanguageToWidgetType = {
  __typename?: 'ThemAndLanguageToWidgetType';
  language?: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  theme?: Maybe<Scalars['String']['output']>;
};

export type TicketInput = {
  assignedTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  attachments?: InputMaybe<Array<Scalars['ID']['input']>>;
  color?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['ID']['input'];
  customer?: InputMaybe<Scalars['ID']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<TicketPriorityEnum>;
  project?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<TicketStatusEnum>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  target: TargetAciInput;
};

export enum TicketPriorityEnum {
  CRITICAL = 'CRITICAL',
  HIGH = 'HIGH',
  LOW = 'LOW',
  NORMAL = 'NORMAL'
}

export type TicketStatsType = {
  __typename?: 'TicketStatsType';
  BLOCKED: CurrentPreviousType;
  IN_PROGRESS: CurrentPreviousType;
  OPEN: CurrentPreviousType;
  RESOLVED: CurrentPreviousType;
};

export enum TicketStatusEnum {
  BLOCKED = 'BLOCKED',
  IN_PROGRESS = 'IN_PROGRESS',
  ON_HOLD = 'ON_HOLD',
  OPEN = 'OPEN',
  RESOLVED = 'RESOLVED'
}

export type TicketType = {
  __typename?: 'TicketType';
  assignedTo?: Maybe<Array<UserType>>;
  attachments?: Maybe<Array<DocumentType>>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<CompanyType>;
  deadline?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<TicketPriorityEnum>;
  project?: Maybe<ProjectType>;
  status?: Maybe<TicketStatusEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TicketUpdateInput = {
  assignedTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  attachments?: InputMaybe<Array<Scalars['ID']['input']>>;
  color?: InputMaybe<Scalars['String']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<TicketPriorityEnum>;
  project?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<TicketStatusEnum>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  target?: InputMaybe<TargetAciInput>;
};

export type TicketsFilterInput = {
  attachments?: InputMaybe<Array<Scalars['ID']['input']>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  members?: InputMaybe<Array<Scalars['ID']['input']>>;
  priority?: InputMaybe<Array<TicketPriorityEnum>>;
  status?: InputMaybe<Array<TicketStatusEnum>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TicketsPaginateType = {
  __typename?: 'TicketsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<TicketType>;
};

export type TicketsStatsFilterInput = {
  attachments?: InputMaybe<Array<Scalars['ID']['input']>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  members?: InputMaybe<Array<Scalars['ID']['input']>>;
  priority?: InputMaybe<Array<TicketPriorityEnum>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimeEntryType = {
  __typename?: 'TimeEntryType';
  card: BoardCardType;
  createdAt: Scalars['DateTime']['output'];
  end: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  member: UserType;
  start: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TimeFromToInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimeFromToType = {
  __typename?: 'TimeFromToType';
  from?: Maybe<Scalars['DateTime']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
};

export type TimeTrackInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  holder?: InputMaybe<TimeTrackOnInput>;
  idle?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type TimeTrackOnInput = {
  card?: InputMaybe<Scalars['ID']['input']>;
  project?: InputMaybe<Scalars['ID']['input']>;
  ticket?: InputMaybe<Scalars['ID']['input']>;
};

export type TimeTrackOnType = {
  __typename?: 'TimeTrackOnType';
  card?: Maybe<BoardCardType>;
  project?: Maybe<ProjectType>;
  ticket?: Maybe<TicketType>;
};

export type TimeTrackPaginateType = {
  __typename?: 'TimeTrackPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<TimeTrackType>;
};

export type TimeTrackType = {
  __typename?: 'TimeTrackType';
  createdAt: Scalars['DateTime']['output'];
  end?: Maybe<Scalars['DateTime']['output']>;
  holder?: Maybe<TimeTrackOnType>;
  id: Scalars['ID']['output'];
  idle?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type TimezoneType = {
  __typename?: 'TimezoneType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  timezone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TopAssistsType = {
  __typename?: 'TopAssistsType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  league?: Maybe<Scalars['Int']['output']>;
  season?: Maybe<Scalars['Int']['output']>;
  topAssists?: Maybe<Array<PlayersStatsType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TopChartCategoryItemType = {
  __typename?: 'TopChartCategoryItemType';
  cron: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TopChartGenreType = {
  __typename?: 'TopChartGenreType';
  category: TopChartCategoryItemType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  platform: ChartPlatformEnum;
  updatedAt: Scalars['DateTime']['output'];
};

export type TopChartLeaderboardType = {
  __typename?: 'TopChartLeaderboardType';
  artist_name?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Scalars['String']['output']>;
  ext_id?: Maybe<Scalars['String']['output']>;
  feed_type?: Maybe<Scalars['String']['output']>;
  genre_id?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  pos?: Maybe<Scalars['Float']['output']>;
  pos_curr?: Maybe<Scalars['Float']['output']>;
  pos_diff?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  rating_avg?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type TopLeaderboardsType = {
  __typename?: 'TopLeaderboardsType';
  closingDate?: Maybe<Scalars['DateTime']['output']>;
  leaderboards: Array<LeaderboardType>;
};

export type TopRedCardsType = {
  __typename?: 'TopRedCardsType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  league?: Maybe<Scalars['Int']['output']>;
  season?: Maybe<Scalars['Int']['output']>;
  topRedCards?: Maybe<Array<PlayersStatsType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TopScorersType = {
  __typename?: 'TopScorersType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  league?: Maybe<Scalars['Int']['output']>;
  season?: Maybe<Scalars['Int']['output']>;
  topScorers?: Maybe<Array<PlayersStatsType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TopYellowCardsType = {
  __typename?: 'TopYellowCardsType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  league?: Maybe<Scalars['Int']['output']>;
  season?: Maybe<Scalars['Int']['output']>;
  topYellowCards?: Maybe<Array<PlayersStatsType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TopupWalletInput = {
  amount: Scalars['Decimal']['input'];
  card?: InputMaybe<Scalars['String']['input']>;
  source: OnsiteConverterTypeEnum;
  target: TargetAciInput;
  transactionId?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type TotalAndInPeriodCountsType = {
  __typename?: 'TotalAndInPeriodCountsType';
  inPeriod: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TotalPriceInput = {
  gross?: InputMaybe<Scalars['Decimal']['input']>;
  net?: InputMaybe<Scalars['Decimal']['input']>;
};

export type TotalPriceType = {
  __typename?: 'TotalPriceType';
  gross?: Maybe<Scalars['Decimal']['output']>;
  net?: Maybe<Scalars['Decimal']['output']>;
};

export type TotalType = {
  __typename?: 'TotalType';
  total: Scalars['Decimal']['output'];
};

export enum TransactionChallengeTypeEnum {
  MOBILE_ONSITE_ACTIVITY = 'MOBILE_ONSITE_ACTIVITY',
  PHYSICAL_ONSITE_ACTIVITY = 'PHYSICAL_ONSITE_ACTIVITY',
  QUEST_FULFILLED = 'QUEST_FULFILLED',
  WEB_ONSITE_ACTIVITY = 'WEB_ONSITE_ACTIVITY'
}

export enum TransactionPartnerEnum {
  BITAKA = 'BITAKA'
}

export enum TransactionTypeEnum {
  CONVERSION = 'CONVERSION',
  DEAL_ORDER_ADDED = 'DEAL_ORDER_ADDED',
  DONATION = 'DONATION',
  FREEBIES_REDEEM = 'FREEBIES_REDEEM',
  FREEBIES_TOPUP = 'FREEBIES_TOPUP',
  GAME_FEES = 'GAME_FEES',
  GAME_WIN = 'GAME_WIN',
  MOBILE_ONSITE_ACTIVITY = 'MOBILE_ONSITE_ACTIVITY',
  MOBILE_REDEEM = 'MOBILE_REDEEM',
  ORDER_ADDED = 'ORDER_ADDED',
  ORDER_PAYMENT = 'ORDER_PAYMENT',
  PHONE_RECHARGE = 'PHONE_RECHARGE',
  PHYSICAL_ONSITE_ACTIVITY = 'PHYSICAL_ONSITE_ACTIVITY',
  PROFILE_LEVEL_COMPLETED = 'PROFILE_LEVEL_COMPLETED',
  PURCHASE_COUPON = 'PURCHASE_COUPON',
  QUEST_FULFILLED = 'QUEST_FULFILLED',
  REDEEM = 'REDEEM',
  REFERRAL = 'REFERRAL',
  REPUTATION_LOST = 'REPUTATION_LOST',
  TURNOVER_LOST = 'TURNOVER_LOST',
  WALLET_TOPUP = 'WALLET_TOPUP',
  WALLET_WITHDRAW = 'WALLET_WITHDRAW',
  WEB_ONSITE_ACTIVITY = 'WEB_ONSITE_ACTIVITY',
  WEB_REDEEM = 'WEB_REDEEM',
  WELCOME_BONUS = 'WELCOME_BONUS'
}

export type TransfersPlayerType = {
  __typename?: 'TransfersPlayerType';
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TransfersTransfersTeamsInOutType = {
  __typename?: 'TransfersTransfersTeamsInOutType';
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TransfersTransfersTeamsType = {
  __typename?: 'TransfersTransfersTeamsType';
  teamIn?: Maybe<TransfersTransfersTeamsInOutType>;
  teamOut?: Maybe<TransfersTransfersTeamsInOutType>;
};

export type TransfersTransfersType = {
  __typename?: 'TransfersTransfersType';
  date?: Maybe<Scalars['DateTime']['output']>;
  teams?: Maybe<TransfersTransfersTeamsType>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TransfersType = {
  __typename?: 'TransfersType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  player?: Maybe<TransfersPlayerType>;
  transfers?: Maybe<Array<TransfersTransfersType>>;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum TranslationAppEnum {
  WEBSITE = 'WEBSITE',
  WIDGET_MOBILE = 'WIDGET_MOBILE',
  WIDGET_WEB = 'WIDGET_WEB'
}

export enum TriggerEnum {
  INSTANT = 'INSTANT',
  SCHEDULED = 'SCHEDULED'
}

export type TrophiesInnerType = {
  __typename?: 'TrophiesInnerType';
  country?: Maybe<Scalars['String']['output']>;
  league?: Maybe<Scalars['String']['output']>;
  place?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['String']['output']>;
};

export type TrophiesType = {
  __typename?: 'TrophiesType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  target: ApiTargetType;
  trophies: Array<TrophiesInnerType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type UnseenCorporateNotificationCountType = {
  __typename?: 'UnseenCorporateNotificationCountType';
  count: Scalars['Int']['output'];
};

export type UnseenMessagesCountType = {
  __typename?: 'UnseenMessagesCountType';
  unseenMessagesCount: Scalars['Int']['output'];
};

export type UpdateBlogInput = {
  pictures?: InputMaybe<Array<PictureInput>>;
  sectionData?: InputMaybe<Array<BlogDataInput>>;
  seo?: InputMaybe<SeoComponentInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Array<BlogTranslationInput>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCouponInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  couponPrefix?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<DiscountDtoInput>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  isOffline?: InputMaybe<Scalars['Boolean']['input']>;
  max?: InputMaybe<Scalars['String']['input']>;
  min?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateCouponSettingsInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  discount?: InputMaybe<DiscountDtoInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<NumberInput>;
};

export type UpdateFormInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  owner?: InputMaybe<FormOwnerInput>;
  status?: InputMaybe<FormStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FormType>;
};

export type UpdateInternalProductInput = {
  /** list of barcodes ids */
  barcodes?: InputMaybe<Array<Scalars['ID']['input']>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  catalogueCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  classification?: InputMaybe<Array<ProductClassEnum>>;
  condition?: InputMaybe<ProductConditionEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionList?: InputMaybe<Array<Scalars['String']['input']>>;
  discount?: InputMaybe<DiscountDtoInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Array<ProductFlagEnum>>;
  globalCategory?: InputMaybe<GlobalCategoryInput>;
  id: Scalars['ID']['input'];
  internalProductAttributes?: InputMaybe<InternalProductAttributeInput>;
  longdesc?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<Array<PictureInput>>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  rent?: InputMaybe<Scalars['Boolean']['input']>;
  seo?: InputMaybe<CatalogueCategorySeoInput>;
  sku?: InputMaybe<Scalars['String']['input']>;
  specs?: InputMaybe<Array<ProductSpecsInput>>;
  status?: InputMaybe<ProductStatusEnum>;
  structure?: InputMaybe<ProductStructureEnum>;
  /** list of suppliers ids */
  suppliers?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translation?: InputMaybe<Array<InternalProductTranslationInput>>;
  url?: InputMaybe<Scalars['String']['input']>;
  variety?: InputMaybe<ProductVarietyEnum>;
};

export type UpdateLandingPagesInput = {
  pageDescription?: InputMaybe<Scalars['String']['input']>;
  pageReference?: InputMaybe<Scalars['String']['input']>;
  pageTitle?: InputMaybe<Scalars['String']['input']>;
  pageType?: InputMaybe<LandingPageTypeEnum>;
  sectionData?: InputMaybe<Array<LandingPagesDataInput>>;
  seo?: InputMaybe<SeoComponentInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translation?: InputMaybe<Array<LandingPagesTranslationInput>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMediaInput = {
  id: Scalars['ID']['input'];
  media: SingleMediaInput;
};

export enum UpdateOrderProductStatusForPosEnum {
  CONFIRMED = 'CONFIRMED',
  DELIVERED = 'DELIVERED',
  OPEN = 'OPEN',
  READY_FOR_PICKUP = 'READY_FOR_PICKUP'
}

export type UpdatePictureInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
  x?: InputMaybe<Scalars['Int']['input']>;
  y?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateProductRatingDefinitionInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  reviewType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductRatingInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  mark?: InputMaybe<Scalars['Int']['input']>;
  product?: InputMaybe<Scalars['ID']['input']>;
  reviewType?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateReputationInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  inactivityCycle?: InputMaybe<Scalars['Int']['input']>;
  lossAmount?: InputMaybe<Scalars['Int']['input']>;
  lossPoints?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<Scalars['Int']['input']>;
  perks?: InputMaybe<PerksInput>;
  picture?: InputMaybe<UpdatePictureInput>;
  reputationLevel?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Array<ReputationTranslationInput>>;
  turnoverPoints?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSeoInput = {
  googleAnalyticsId?: InputMaybe<Scalars['String']['input']>;
  headerTags?: InputMaybe<Array<TagInput>>;
  metaDescriptionTag?: InputMaybe<Scalars['String']['input']>;
  titleTag?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSimpleProductInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  catalogueCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  classification?: InputMaybe<Array<ProductClassEnum>>;
  condition?: InputMaybe<ProductConditionEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionList?: InputMaybe<Array<Scalars['String']['input']>>;
  discount?: InputMaybe<DiscountDtoInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Array<ProductFlagEnum>>;
  globalCategory?: InputMaybe<GlobalCategoryInput>;
  id: Scalars['ID']['input'];
  longdesc?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<Array<PictureInput>>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  rent?: InputMaybe<Scalars['Boolean']['input']>;
  seo?: InputMaybe<CatalogueCategorySeoInput>;
  sku?: InputMaybe<Scalars['String']['input']>;
  specs?: InputMaybe<Array<ProductSpecsInput>>;
  status?: InputMaybe<ProductStatusEnum>;
  structure?: InputMaybe<ProductStructureEnum>;
  /** list of suppliers ids */
  suppliers?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translation?: InputMaybe<Array<InternalProductTranslationInput>>;
  url?: InputMaybe<Scalars['String']['input']>;
  variety?: InputMaybe<ProductVarietyEnum>;
};

export type UpdateSlidesInput = {
  content?: InputMaybe<Array<SlidesContentInput>>;
  reference?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Array<SlidesTranslationInput>>;
  visualType?: InputMaybe<SlideVisualTypeEnum>;
};

export type UpdateStaticTranslationInput = {
  app?: InputMaybe<TranslationAppEnum>;
  /** required when contentId is sent. */
  content?: InputMaybe<Scalars['String']['input']>;
  /** required when editing content. */
  contentId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  /** can't exists if only editing reference. */
  language?: InputMaybe<Scalars['ID']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupplierInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<TargetAciInput>;
};

export type UpdateVersionInput = {
  id: Scalars['ID']['input'];
  platform?: InputMaybe<PlatformEnum>;
  requireUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  versionContent?: InputMaybe<Array<VersionContentInput>>;
};

export type UpdateVisualsInput = {
  favicon?: InputMaybe<VisualsFaviconInput>;
  logo?: InputMaybe<PictureInput>;
  pageTitle?: InputMaybe<Scalars['String']['input']>;
  square?: InputMaybe<PictureInput>;
  wide?: InputMaybe<PictureInput>;
};

export type UserAccountInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  apps?: InputMaybe<Array<App>>;
  billingAddress?: InputMaybe<Array<FullAddressInput>>;
  chatContact?: InputMaybe<Array<SocialValueInput>>;
  covers?: InputMaybe<Array<PictureInput>>;
  custom?: InputMaybe<Array<UserCustomInput>>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  education?: InputMaybe<Array<UserEducationInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  hobbies?: InputMaybe<Array<Scalars['String']['input']>>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isMailValid?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lived?: InputMaybe<Array<Scalars['ID']['input']>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<MaritalStatus>;
  mobileTheme?: InputMaybe<MobileThemesEnum>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  newsletterSubs?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  permission?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<PhoneInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<Array<PictureInput>>;
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
  plugged?: InputMaybe<Scalars['Boolean']['input']>;
  residentialAddress?: InputMaybe<Array<FullAddressInput>>;
  roles: Array<UserRole>;
  shippingAddress?: InputMaybe<Array<FullAddressInput>>;
  socialMedia?: InputMaybe<Array<SocialValueInput>>;
  source?: InputMaybe<SourcesEnum>;
  status?: InputMaybe<UserStatus>;
  target: TargetAciInput;
  title?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  widget?: InputMaybe<Scalars['Boolean']['input']>;
  work?: InputMaybe<Array<UserWorkInput>>;
};

export type UserAuthenticationType = {
  __typename?: 'UserAuthenticationType';
  actionType: ActionTypeEnum;
  user: UserType;
};

export type UserByStatesType = {
  __typename?: 'UserByStatesType';
  count: Scalars['Int']['output'];
  country?: Maybe<CountryType>;
  percentage: Scalars['Decimal']['output'];
  state?: Maybe<StateType>;
};

export type UserCheckType = {
  __typename?: 'UserCheckType';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<IPhoneType>;
  widget?: Maybe<Scalars['Boolean']['output']>;
};

export type UserCustomInput = {
  customKey?: InputMaybe<Scalars['String']['input']>;
  customValue?: InputMaybe<Scalars['String']['input']>;
};

export type UserCustomType = {
  __typename?: 'UserCustomType';
  customKey?: Maybe<Scalars['String']['output']>;
  customValue?: Maybe<Scalars['String']['output']>;
};

export type UserDataType = {
  __typename?: 'UserDataType';
  firstName: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  picture: PictureType;
};

export type UserEducationInput = {
  city?: InputMaybe<Scalars['ID']['input']>;
  country?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  graduated?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<AcademicLevel>;
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserEducationType = {
  __typename?: 'UserEducationType';
  city?: Maybe<StateType>;
  country?: Maybe<CountryType>;
  description?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['DateTime']['output']>;
  graduated?: Maybe<Scalars['Boolean']['output']>;
  level?: Maybe<AcademicLevel>;
  name?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  to?: Maybe<Scalars['DateTime']['output']>;
};

export enum UserEventsSourceEnum {
  MOBILE = 'MOBILE',
  STORE = 'STORE',
  WEB = 'WEB',
  WIDGET_MOBILE = 'WIDGET_MOBILE',
  WIDGET_WEB = 'WIDGET_WEB'
}

export type UserExistType = {
  __typename?: 'UserExistType';
  exist: Scalars['Boolean']['output'];
  user?: Maybe<UserType>;
};

export type UserInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  apps?: InputMaybe<Array<App>>;
  billingAddress?: InputMaybe<Array<FullAddressInput>>;
  chatContact?: InputMaybe<Array<SocialValueInput>>;
  covers?: InputMaybe<Array<PictureInput>>;
  custom?: InputMaybe<Array<UserCustomInput>>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  education?: InputMaybe<Array<UserEducationInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  hobbies?: InputMaybe<Array<Scalars['String']['input']>>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isMailValid?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lived?: InputMaybe<Array<Scalars['ID']['input']>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<MaritalStatus>;
  mobileTheme?: InputMaybe<MobileThemesEnum>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  newsletterSubs?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  permission?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<PhoneInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<Array<PictureInput>>;
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
  plugged?: InputMaybe<Scalars['Boolean']['input']>;
  residentialAddress?: InputMaybe<Array<FullAddressInput>>;
  roles: Array<UserRole>;
  shippingAddress?: InputMaybe<Array<FullAddressInput>>;
  socialMedia?: InputMaybe<Array<SocialValueInput>>;
  source?: InputMaybe<SourcesEnum>;
  status?: InputMaybe<UserStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  widget?: InputMaybe<Scalars['Boolean']['input']>;
  work?: InputMaybe<Array<UserWorkInput>>;
};

export type UserPaginateType = {
  __typename?: 'UserPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<UserType>;
};

export enum UserRole {
  ADMIN = 'ADMIN',
  API = 'API',
  CATALOG = 'CATALOG',
  COMMERCIAL = 'COMMERCIAL',
  COMMUNITY = 'COMMUNITY',
  CONSUMER = 'CONSUMER',
  CONTENT = 'CONTENT',
  CUSTOMERS = 'CUSTOMERS',
  DASHBOARDS_ANALYTICS = 'DASHBOARDS_ANALYTICS',
  DASHBOARDS_FINANCE = 'DASHBOARDS_FINANCE',
  DASHBOARDS_MERCHANDISING = 'DASHBOARDS_MERCHANDISING',
  DASHBOARDS_SALES = 'DASHBOARDS_SALES',
  DASHBOARDS_WAREHOUSE = 'DASHBOARDS_WAREHOUSE',
  DELIVERY_MAN = 'DELIVERY_MAN',
  EDITOR = 'EDITOR',
  FINANCIAL = 'FINANCIAL',
  GROUP_MODERATOR = 'GROUP_MODERATOR',
  INVENTORY = 'INVENTORY',
  LOYALTY = 'LOYALTY',
  MANAGER = 'MANAGER',
  MANUFACTURER_ASSISTANT = 'MANUFACTURER_ASSISTANT',
  MANUFACTURER_MANAGER = 'MANUFACTURER_MANAGER',
  MANUFACTURER_OWNER = 'MANUFACTURER_OWNER',
  MERCHANDISER = 'MERCHANDISER',
  MERCHANDISING = 'MERCHANDISING',
  NETWORK = 'NETWORK',
  NOT_SPECIFIED = 'NOT_SPECIFIED',
  ORGANIZATION = 'ORGANIZATION',
  POS_ASSISTANT = 'POS_ASSISTANT',
  POS_MANAGER = 'POS_MANAGER',
  POS_OWNER = 'POS_OWNER',
  POS_WAITER = 'POS_WAITER',
  SALES = 'SALES',
  SYSTEM = 'SYSTEM',
  WAREHOUSE = 'WAREHOUSE',
  WHOLESALER_ASSISTANT = 'WHOLESALER_ASSISTANT',
  WHOLESALER_MANAGER = 'WHOLESALER_MANAGER',
  WHOLESALER_OWNER = 'WHOLESALER_OWNER'
}

export type UserStatsType = {
  __typename?: 'UserStatsType';
  allUsers: Scalars['Int']['output'];
  onlineUsers: Scalars['Int']['output'];
  user: UserType;
};

export enum UserStatus {
  AWAY = 'AWAY',
  BUSY = 'BUSY',
  OFFLINE = 'OFFLINE',
  ONLINE = 'ONLINE'
}

export type UserType = {
  __typename?: 'UserType';
  about?: Maybe<Scalars['String']['output']>;
  apps?: Maybe<Array<App>>;
  billingAddress?: Maybe<Array<FullAddressType>>;
  chatContact?: Maybe<Array<SocialValueType>>;
  covers?: Maybe<Array<PictureType>>;
  createdAt: Scalars['DateTime']['output'];
  custom?: Maybe<Array<UserCustomType>>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  education?: Maybe<Array<UserEducationType>>;
  email?: Maybe<Scalars['String']['output']>;
  fcmTokens?: Maybe<Array<FcmTokenType>>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  hasAutoGeneratedEmail?: Maybe<Scalars['Boolean']['output']>;
  hobbies?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  interests?: Maybe<Array<Scalars['String']['output']>>;
  isMailValid?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Array<LanguageType>>;
  lastName?: Maybe<Scalars['String']['output']>;
  lived?: Maybe<Array<StateType>>;
  locale?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<MaritalStatus>;
  mobileTheme?: Maybe<MobileThemesEnum>;
  nationality?: Maybe<CountryType>;
  newsletterSubs?: Maybe<Scalars['Boolean']['output']>;
  permission?: Maybe<PermissionType>;
  phone?: Maybe<PhoneType>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  placeOfBirth?: Maybe<Scalars['String']['output']>;
  plugged?: Maybe<Scalars['Boolean']['output']>;
  residentialAddress?: Maybe<Array<FullAddressType>>;
  roles?: Maybe<Array<UserRole>>;
  shippingAddress?: Maybe<Array<FullAddressType>>;
  socialLoginData?: Maybe<SocialLoginDataType>;
  socialMedia?: Maybe<Array<SocialValueType>>;
  source?: Maybe<SourcesEnum>;
  status?: Maybe<UserStatus>;
  target?: Maybe<TargetIdsType>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  username?: Maybe<Scalars['String']['output']>;
  widget?: Maybe<Scalars['Boolean']['output']>;
  work?: Maybe<Array<UserWorkType>>;
};

export type UserUpdateInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  apps?: InputMaybe<Array<App>>;
  billingAddress?: InputMaybe<Array<FullAddressInput>>;
  chatContact?: InputMaybe<Array<SocialValueInput>>;
  covers?: InputMaybe<Array<PictureInput>>;
  custom?: InputMaybe<Array<UserCustomInput>>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  education?: InputMaybe<Array<UserEducationInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  hobbies?: InputMaybe<Array<Scalars['String']['input']>>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isMailValid?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lived?: InputMaybe<Array<Scalars['ID']['input']>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<MaritalStatus>;
  mobileTheme?: InputMaybe<MobileThemesEnum>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  newsletterSubs?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permission?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<IPhoneInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<Array<PictureInput>>;
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
  plugged?: InputMaybe<Scalars['Boolean']['input']>;
  residentialAddress?: InputMaybe<Array<FullAddressInput>>;
  roles?: InputMaybe<Array<UserRole>>;
  shippingAddress?: InputMaybe<Array<FullAddressInput>>;
  socialMedia?: InputMaybe<Array<SocialValueInput>>;
  source?: InputMaybe<SourcesEnum>;
  status?: InputMaybe<UserStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  vapidKey?: InputMaybe<Scalars['String']['input']>;
  widget?: InputMaybe<Scalars['Boolean']['input']>;
  work?: InputMaybe<Array<UserWorkInput>>;
};

export type UserWithTargetInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  apps?: InputMaybe<Array<App>>;
  billingAddress?: InputMaybe<Array<FullAddressInput>>;
  chatContact?: InputMaybe<Array<SocialValueInput>>;
  covers?: InputMaybe<Array<PictureInput>>;
  custom?: InputMaybe<Array<UserCustomInput>>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  education?: InputMaybe<Array<UserEducationInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  hobbies?: InputMaybe<Array<Scalars['String']['input']>>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isMailValid?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lived?: InputMaybe<Array<Scalars['ID']['input']>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<MaritalStatus>;
  mobileTheme?: InputMaybe<MobileThemesEnum>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  newsletterSubs?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  permission?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<PhoneInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<Array<PictureInput>>;
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
  plugged?: InputMaybe<Scalars['Boolean']['input']>;
  residentialAddress?: InputMaybe<Array<FullAddressInput>>;
  roles: Array<UserRole>;
  shippingAddress?: InputMaybe<Array<FullAddressInput>>;
  socialMedia?: InputMaybe<Array<SocialValueInput>>;
  source?: InputMaybe<SourcesEnum>;
  status?: InputMaybe<UserStatus>;
  subject?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
  title?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  widget?: InputMaybe<Scalars['Boolean']['input']>;
  work?: InputMaybe<Array<UserWorkInput>>;
};

export type UserWorkInput = {
  city?: InputMaybe<Scalars['ID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['ID']['input']>;
  current?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserWorkType = {
  __typename?: 'UserWorkType';
  city?: Maybe<StateType>;
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryType>;
  current?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['DateTime']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  to?: Maybe<Scalars['DateTime']['output']>;
};

export type ValidateSmsCodeInput = {
  code: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<IPhoneInput>;
  target: TargetAciInput;
};

export type ValidatedCartProductType = {
  __typename?: 'ValidatedCartProductType';
  activateDelivery: Scalars['Boolean']['output'];
  activatePickup: Scalars['Boolean']['output'];
  barcode?: Maybe<BarcodeWithPublicPriceType>;
  deliveryFees: Scalars['Decimal']['output'];
  facebookDelivery: Scalars['Boolean']['output'];
  facebookPickup: Scalars['Boolean']['output'];
  inDeliveryZone: Scalars['Boolean']['output'];
  mobileDelivery: Scalars['Boolean']['output'];
  mobilePickup: Scalars['Boolean']['output'];
  portalDelivery: Scalars['Boolean']['output'];
  portalPickup: Scalars['Boolean']['output'];
  price: ProductPriceType;
  priceCredit?: Maybe<PriceCreditType>;
  productAttributesValues?: Maybe<Array<AttributeValueType>>;
  quantity: Scalars['Int']['output'];
  rent?: Maybe<RentalRefType>;
  taxValue: TaxValueType;
};

export type VapidKeyInput = {
  userId: Scalars['String']['input'];
  vapidKey: Scalars['String']['input'];
};

export type VapidKeyType = {
  __typename?: 'VapidKeyType';
  vapidKey: Scalars['String']['output'];
};

export type VenueType = {
  __typename?: 'VenueType';
  address?: Maybe<Scalars['String']['output']>;
  capacity?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  surface?: Maybe<Scalars['String']['output']>;
};

export type VenueTypeFull = {
  __typename?: 'VenueTypeFull';
  address?: Maybe<Scalars['String']['output']>;
  capacity?: Maybe<Scalars['Float']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  surface?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  venueId?: Maybe<Scalars['Float']['output']>;
};

export type VerifyApiSettingsInput = {
  /** Login phone number/username or email. */
  login?: InputMaybe<Scalars['String']['input']>;
  /** password for login */
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<IPhoneInput>;
  target: TargetAciInput;
};

export type VersionContentInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<VersionContentTypeEnum>;
};

export type VersionContentType = {
  __typename?: 'VersionContentType';
  content: Scalars['String']['output'];
  contentType: VersionContentTypeEnum;
};

export enum VersionContentTypeEnum {
  ADDED = 'ADDED',
  CHANGED = 'CHANGED',
  FIXED = 'FIXED'
}

export type VersionType = {
  __typename?: 'VersionType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  platform: PlatformEnum;
  requireUpdate?: Maybe<Scalars['Boolean']['output']>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['String']['output'];
  versionContent?: Maybe<Array<VersionContentType>>;
};

export type VersionsFilterInput = {
  platform?: InputMaybe<Array<PlatformEnum>>;
  requireUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};

export type VersionsPaginateType = {
  __typename?: 'VersionsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<VersionType>;
};

export enum VisibilityStatusEnum {
  DELETED = 'DELETED',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

export type VisitsFieldType = {
  __typename?: 'VisitsFieldType';
  current: Scalars['Int']['output'];
  percentage?: Maybe<Scalars['Decimal']['output']>;
  previous: Scalars['Int']['output'];
  weeklyVisits: Array<PeriodStatsType>;
};

export type VisualsFaviconInput = {
  size16?: InputMaybe<PictureInput>;
  size32?: InputMaybe<PictureInput>;
  size57?: InputMaybe<PictureInput>;
  size60?: InputMaybe<PictureInput>;
  size72?: InputMaybe<PictureInput>;
  size76?: InputMaybe<PictureInput>;
  size96?: InputMaybe<PictureInput>;
  size114?: InputMaybe<PictureInput>;
  size120?: InputMaybe<PictureInput>;
  size144?: InputMaybe<PictureInput>;
  size152?: InputMaybe<PictureInput>;
  size180?: InputMaybe<PictureInput>;
  size192?: InputMaybe<PictureInput>;
};

export type VisualsFaviconType = {
  __typename?: 'VisualsFaviconType';
  size16?: Maybe<PictureType>;
  size32?: Maybe<PictureType>;
  size57?: Maybe<PictureType>;
  size60?: Maybe<PictureType>;
  size72?: Maybe<PictureType>;
  size76?: Maybe<PictureType>;
  size96?: Maybe<PictureType>;
  size114?: Maybe<PictureType>;
  size120?: Maybe<PictureType>;
  size144?: Maybe<PictureType>;
  size152?: Maybe<PictureType>;
  size180?: Maybe<PictureType>;
  size192?: Maybe<PictureType>;
};

export type VisualsInput = {
  favicon?: InputMaybe<VisualsFaviconInput>;
  logo?: InputMaybe<PictureInput>;
  pageTitle?: InputMaybe<Scalars['String']['input']>;
  square?: InputMaybe<PictureInput>;
  target: TargetAciInput;
  wide?: InputMaybe<PictureInput>;
};

export type VisualsType = {
  __typename?: 'VisualsType';
  createdAt: Scalars['DateTime']['output'];
  favicon?: Maybe<VisualsFaviconType>;
  id: Scalars['ID']['output'];
  logo?: Maybe<PictureType>;
  pageTitle?: Maybe<Scalars['String']['output']>;
  square?: Maybe<PictureType>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  wide?: Maybe<PictureType>;
};

export type WalletBaseType = {
  __typename?: 'WalletBaseType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  coin?: Maybe<CoinType>;
  createdAt: Scalars['DateTime']['output'];
  currentReputationLevel?: Maybe<ReputationWithoutTargetType>;
  fee?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  nextReputationLevel?: Maybe<ReputationWithoutTargetType>;
  updatedAt: Scalars['DateTime']['output'];
  usage?: Maybe<WalletUsageEnum>;
  walletType?: Maybe<WalletTypeEnum>;
};

export type WalletCheckType = {
  __typename?: 'WalletCheckType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  coin?: Maybe<CoinSimpleType>;
  usage?: Maybe<WalletUsageEnum>;
  walletType?: Maybe<WalletTypeEnum>;
};

export type WalletConversionEntryInput = {
  amount: Scalars['Decimal']['input'];
  wallet: Scalars['ID']['input'];
};

export type WalletConversionInput = {
  debitor: WalletConversionEntryInput;
  receiver: WalletConversionEntryInput;
};

export type WalletDateValueChartType = {
  __typename?: 'WalletDateValueChartType';
  chart: Array<Array<Scalars['Float']['output']>>;
  wallet: WalletType;
};

export type WalletInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  coin?: InputMaybe<Scalars['ID']['input']>;
  fee?: InputMaybe<Scalars['Int']['input']>;
  owner?: InputMaybe<TargetTransferInput>;
  target?: InputMaybe<TargetAciInput>;
  usage?: InputMaybe<WalletUsageEnum>;
  walletType?: InputMaybe<WalletTypeEnum>;
};

export type WalletOwnerHasEnoughBalanceInput = {
  amount: Scalars['Decimal']['input'];
  coin: Scalars['ID']['input'];
  owner: TargetTransferInput;
};

export type WalletOwnerHasEnoughBalanceType = {
  __typename?: 'WalletOwnerHasEnoughBalanceType';
  hasEnoughBalance: Scalars['Boolean']['output'];
};

export type WalletPaginateType = {
  __typename?: 'WalletPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<WalletType>;
};

export type WalletTopupCurrencyType = {
  __typename?: 'WalletTopupCurrencyType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  currency?: Maybe<CurrencyType>;
};

export type WalletTopupInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  wallet?: InputMaybe<Scalars['ID']['input']>;
};

export type WalletTopupPaginateType = {
  __typename?: 'WalletTopupPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<WalletTopupType>;
};

export type WalletTopupPlatformInput = {
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  prelevel?: InputMaybe<WalletTopupPrelevelInput>;
  remunerations?: InputMaybe<Array<WalletTopupRemunerationInput>>;
};

export type WalletTopupPlatformType = {
  __typename?: 'WalletTopupPlatformType';
  enable: Scalars['Boolean']['output'];
  prelevel?: Maybe<WalletTopupPrelevelType>;
  remunerations?: Maybe<Array<WalletTopupRemunerationType>>;
};

export type WalletTopupPrelevelInput = {
  qualitative?: InputMaybe<WalletTopupPrelevelQualitativeInput>;
  quantitative?: InputMaybe<WalletTopupPrelevelQuantitativeInput>;
};

export type WalletTopupPrelevelQualitativeInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
};

export type WalletTopupPrelevelQualitativeType = {
  __typename?: 'WalletTopupPrelevelQualitativeType';
  amount?: Maybe<Scalars['Decimal']['output']>;
};

export type WalletTopupPrelevelQuantitativeInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  wallet?: InputMaybe<Scalars['ID']['input']>;
};

export type WalletTopupPrelevelQuantitativeType = {
  __typename?: 'WalletTopupPrelevelQuantitativeType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  wallet: WalletType;
};

export type WalletTopupPrelevelType = {
  __typename?: 'WalletTopupPrelevelType';
  qualitative: WalletTopupPrelevelQualitativeType;
  quantitative: WalletTopupPrelevelQuantitativeType;
};

export type WalletTopupSettingsInput = {
  mobile?: InputMaybe<WalletTopupPlatformInput>;
  physical?: InputMaybe<WalletTopupPlatformInput>;
  target: TargetAciInput;
  web?: InputMaybe<WalletTopupPlatformInput>;
};

export type WalletTopupSettingsPaginateType = {
  __typename?: 'WalletTopupSettingsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<WalletTopupSettingsType>;
};

export type WalletTopupSettingsType = {
  __typename?: 'WalletTopupSettingsType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mobile?: Maybe<WalletTopupPlatformType>;
  physical?: Maybe<WalletTopupPlatformType>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  web?: Maybe<WalletTopupPlatformType>;
};

export type WalletTopupSettingsUpdateInput = {
  mobile?: InputMaybe<WalletTopupPlatformInput>;
  physical?: InputMaybe<WalletTopupPlatformInput>;
  web?: InputMaybe<WalletTopupPlatformInput>;
};

export enum WalletTopupStatusEnum {
  CONFIRMED = 'CONFIRMED',
  DELIVERED = 'DELIVERED',
  OPEN = 'OPEN'
}

export type WalletTopupType = {
  __typename?: 'WalletTopupType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['DateTime']['output'];
  executor?: Maybe<UserType>;
  id?: Maybe<Scalars['ID']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  status?: Maybe<WalletTopupStatusEnum>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<WalletTopupCurrencyType>;
  wallet?: Maybe<WalletType>;
};

export type WalletTransactionAmountType = {
  __typename?: 'WalletTransactionAmountType';
  qualitative?: Maybe<Scalars['Decimal']['output']>;
  quantitative?: Maybe<Scalars['Decimal']['output']>;
};

export type WalletTransactionBalanceType = {
  __typename?: 'WalletTransactionBalanceType';
  debitor?: Maybe<WalletTransactionAmountType>;
  funds?: Maybe<WalletTransactionAmountType>;
  receiver?: Maybe<WalletTransactionAmountType>;
};

export type WalletTransactionForSubscriptionType = {
  __typename?: 'WalletTransactionForSubscriptionType';
  amount: WalletTransactionAmountType;
  challenge?: Maybe<ChallengeType>;
  createdAt: Scalars['DateTime']['output'];
  debitor?: Maybe<DebitorWalletWithStringCoinType>;
  externalId?: Maybe<ExternalIdType>;
  funds?: Maybe<WalletWithStringCoinType>;
  game?: Maybe<ChallengeType>;
  location?: Maybe<Scalars['String']['output']>;
  newBalance: WalletTransactionBalanceType;
  questActions?: Maybe<Array<QuestActionType>>;
  reason: TransactionTypeEnum;
  receiver?: Maybe<WalletWithStringCoinType>;
  reputationLevel?: Maybe<ReputationType>;
  target: TargetType;
};

export type WalletTransactionPaginateType = {
  __typename?: 'WalletTransactionPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<WalletTransactionType>;
};

export type WalletTransactionType = {
  __typename?: 'WalletTransactionType';
  amount: WalletTransactionAmountType;
  challenge?: Maybe<ChallengeType>;
  createdAt: Scalars['DateTime']['output'];
  debitor?: Maybe<WalletType>;
  externalId?: Maybe<ExternalIdType>;
  funds?: Maybe<WalletType>;
  game?: Maybe<ChallengeType>;
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  newBalance: WalletTransactionBalanceType;
  questActions?: Maybe<Array<QuestActionType>>;
  reason: TransactionTypeEnum;
  receiver?: Maybe<WalletType>;
  reference?: Maybe<WalletTransactionsReferenceType>;
  reputationLevel?: Maybe<ReputationType>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type WalletTransactionsByAffectedFilterInput = {
  affected?: InputMaybe<Array<TargetTransferInput>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  includeAllCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Array<TransactionTypeEnum>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  transactionId?: InputMaybe<Array<Scalars['String']['input']>>;
  walletId?: InputMaybe<Scalars['ID']['input']>;
  walletType?: InputMaybe<Array<WalletTypeEnum>>;
};

export type WalletTransactionsReferenceType = {
  __typename?: 'WalletTransactionsReferenceType';
  partner?: Maybe<TransactionPartnerEnum>;
  reference?: Maybe<Scalars['String']['output']>;
};

export type WalletTransactionsStatsChartFilterInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  wallet: Scalars['ID']['input'];
};

export type WalletTransactionsStatsType = {
  __typename?: 'WalletTransactionsStatsType';
  myWallet: CurrentPreviousPercentageType;
  overallReturns: CurrentPreviousPercentageType;
  overallVolume: CurrentPreviousPercentageType;
  todayReturns: CurrentPreviousPercentageType;
  todayVolume: CurrentPreviousPercentageType;
};

export type WalletType = {
  __typename?: 'WalletType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  coin?: Maybe<CoinType>;
  createdAt: Scalars['DateTime']['output'];
  currentReputationLevel?: Maybe<ReputationWithoutTargetType>;
  fee?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  nextReputationLevel?: Maybe<ReputationWithoutTargetType>;
  owner?: Maybe<TargetWithUserType>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  usage?: Maybe<WalletUsageEnum>;
  walletType?: Maybe<WalletTypeEnum>;
};

export enum WalletTypeEnum {
  QUALITATIVE = 'QUALITATIVE',
  QUANTITATIVE = 'QUANTITATIVE'
}

export enum WalletUsageEnum {
  FREEBIES = 'FREEBIES',
  FUNDS = 'FUNDS',
  MAIN = 'MAIN'
}

export type WalletWithCurrentAndNextReputationType = {
  __typename?: 'WalletWithCurrentAndNextReputationType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  coin?: Maybe<CoinType>;
  createdAt: Scalars['DateTime']['output'];
  currentReputationLevel?: Maybe<ReputationWithoutTargetType>;
  fee?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  nextReputationLevel?: Maybe<ReputationWithoutTargetType>;
  owner?: Maybe<TargetWithUserType>;
  prelevel?: Maybe<LoyaltySettingsPrelevelType>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  usage?: Maybe<WalletUsageEnum>;
  walletType?: Maybe<WalletTypeEnum>;
};

export type WalletWithReputationDtoType = {
  __typename?: 'WalletWithReputationDtoType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  coin?: Maybe<CoinType>;
  createdAt: Scalars['DateTime']['output'];
  currentReputationLevel?: Maybe<ReputationWithoutTargetType>;
  fee?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  nextReputationLevel?: Maybe<ReputationWithoutTargetType>;
  owner?: Maybe<TargetWithUserType>;
  prelevel?: Maybe<LoyaltySettingsPrelevelType>;
  reputationLevels?: Maybe<Array<ReputationWithoutTargetType>>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  usage?: Maybe<WalletUsageEnum>;
  walletType?: Maybe<WalletTypeEnum>;
};

export type WalletWithStringCoinType = {
  __typename?: 'WalletWithStringCoinType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  coin?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentReputationLevel?: Maybe<ReputationWithoutTargetType>;
  fee?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  nextReputationLevel?: Maybe<ReputationWithoutTargetType>;
  owner?: Maybe<TargetWithUserType>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  usage?: Maybe<WalletUsageEnum>;
  walletType?: Maybe<WalletTypeEnum>;
};

export type WarehouseInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  location: Scalars['ID']['input'];
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonStorageSurface?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  totalSurface?: InputMaybe<Scalars['Float']['input']>;
};

export type WarehousePaginateType = {
  __typename?: 'WarehousePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<WarehouseType>;
};

export type WarehouseType = {
  __typename?: 'WarehouseType';
  createdAt: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<LocationType>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  nonStorageSurface?: Maybe<Scalars['Float']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  totalSurface?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type WarehouseUpdateInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonStorageSurface?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  totalSurface?: InputMaybe<Scalars['Float']['input']>;
};

export type WebsiteIntegrationInput = {
  multicurrency?: InputMaybe<WebsiteIntegrationMulticurrencyInput>;
  multilanguage?: InputMaybe<WebsiteIntegrationMultilanguageInput>;
};

export type WebsiteIntegrationMulticurrencyCurrencyInput = {
  currency?: InputMaybe<Scalars['ID']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WebsiteIntegrationMulticurrencyCurrencyType = {
  __typename?: 'WebsiteIntegrationMulticurrencyCurrencyType';
  currency?: Maybe<CurrencyType>;
  default?: Maybe<Scalars['Boolean']['output']>;
};

export type WebsiteIntegrationMulticurrencyInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  currencies?: InputMaybe<Array<WebsiteIntegrationMulticurrencyCurrencyInput>>;
};

export type WebsiteIntegrationMulticurrencyType = {
  __typename?: 'WebsiteIntegrationMulticurrencyType';
  active?: Maybe<Scalars['Boolean']['output']>;
  currencies?: Maybe<Array<WebsiteIntegrationMulticurrencyCurrencyType>>;
};

export type WebsiteIntegrationMultilanguageInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Array<WebsiteIntegrationMultilanguageLanguageInput>>;
};

export type WebsiteIntegrationMultilanguageLanguageInput = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['ID']['input']>;
};

export type WebsiteIntegrationMultilanguageLanguageType = {
  __typename?: 'WebsiteIntegrationMultilanguageLanguageType';
  default?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<LanguageType>;
};

export type WebsiteIntegrationMultilanguageType = {
  __typename?: 'WebsiteIntegrationMultilanguageType';
  active?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Array<WebsiteIntegrationMultilanguageLanguageType>>;
};

export type WebsiteIntegrationType = {
  __typename?: 'WebsiteIntegrationType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  multicurrency?: Maybe<WebsiteIntegrationMulticurrencyType>;
  multilanguage?: Maybe<WebsiteIntegrationMultilanguageType>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type WeeklyStatsFirstUserType = {
  __typename?: 'WeeklyStatsFirstUserType';
  currentWeek: StatsEntry;
  email: Scalars['String']['output'];
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastname: Scalars['String']['output'];
  picture: Scalars['String']['output'];
};

export type WholesalerCreateInput = {
  address?: InputMaybe<FullAddressInput>;
  company?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  currencies?: InputMaybe<Array<TargetCurrencyInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<IPhoneInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<IPhoneInput>;
  picture?: InputMaybe<PictureInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type WholesalerPaginateType = {
  __typename?: 'WholesalerPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<WholesalerType>;
};

export type WholesalerType = {
  __typename?: 'WholesalerType';
  address?: Maybe<FullAddressType>;
  company?: Maybe<CompanyType>;
  contactEmails?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  currencies?: Maybe<Array<TargetCurrencyType>>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<IPhoneType>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<IPhoneType>;
  picture?: Maybe<PictureType>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type WholesalerUpdateInput = {
  address?: InputMaybe<FullAddressInput>;
  company?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  currencies?: InputMaybe<Array<TargetCurrencyInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<IPhoneInput>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<IPhoneInput>;
  picture?: InputMaybe<PictureInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type WidgetDataInput = {
  corporateUserCardFilter?: InputMaybe<CorporateUserCardFilterInput>;
  cycle?: InputMaybe<LeaderboardCycleEnum>;
  freebiePagination?: InputMaybe<PaginationInput>;
  leaderboardPagination?: InputMaybe<PaginationInput>;
  questPagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
  walletPagination?: InputMaybe<PaginationInput>;
};

export type WidgetDataType = {
  __typename?: 'WidgetDataType';
  aggregatorGameIntegration?: Maybe<GameIntegrationType>;
  corporateUserCards?: Maybe<Array<CorporateUserCardType>>;
  currentDayRewards?: Maybe<GameRewardWithGameAndClosingDateType>;
  currentWeekRewards?: Maybe<GameRewardWithGameAndClosingDateType>;
  freebieTransactions?: Maybe<FreebieTransactionPaginateType>;
  gameIntegration?: Maybe<GameIntegrationType>;
  gameWinners?: Maybe<Array<LeaderboardType>>;
  liveTopGamesLeaderboard?: Maybe<LeaderboardWithClosingDateType>;
  profileCompleteness?: Maybe<ProfileCompletnessProgressType>;
  quantitativeWallets?: Maybe<WalletPaginateType>;
  quests?: Maybe<QuestWithPerformedPaginateType>;
};

export type WidgetIntegrationActionsBaseInput = {
  activity: Scalars['ID']['input'];
  target: TargetAciInput;
};

export type WidgetIntegrationActionsInput = {
  activity: Scalars['ID']['input'];
  recurrence?: InputMaybe<QuestActionsRecurrenceInput>;
  remuneration?: InputMaybe<Array<QuestRemunerationInput>>;
  target: TargetAciInput;
};

export type WidgetIntegrationActionsType = {
  __typename?: 'WidgetIntegrationActionsType';
  definition?: Maybe<ActivityTypeType>;
  recurrence?: Maybe<QuestActionsRecurrenceType>;
  remuneration?: Maybe<Array<RemunerationDtoType>>;
};

export type WidgetIntegrationApiType = {
  __typename?: 'WidgetIntegrationApiType';
  endPoint?: Maybe<Scalars['String']['output']>;
  secretKey?: Maybe<Scalars['String']['output']>;
};

export type WidgetIntegrationContentGamesInput = {
  betting?: InputMaybe<Scalars['Boolean']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  football?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WidgetIntegrationContentGamesType = {
  __typename?: 'WidgetIntegrationContentGamesType';
  betting?: Maybe<Scalars['Boolean']['output']>;
  enable?: Maybe<Scalars['Boolean']['output']>;
  football?: Maybe<Scalars['Boolean']['output']>;
};

export type WidgetIntegrationContentInput = {
  affiliate?: InputMaybe<Scalars['Boolean']['input']>;
  badges?: InputMaybe<Scalars['Boolean']['input']>;
  buttons?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Scalars['Boolean']['input']>;
  challenge?: InputMaybe<Scalars['Boolean']['input']>;
  chat?: InputMaybe<Scalars['Boolean']['input']>;
  games?: InputMaybe<WidgetIntegrationContentGamesInput>;
  leaderboard?: InputMaybe<Scalars['Boolean']['input']>;
  marketplace?: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceCoin?: InputMaybe<Scalars['ID']['input']>;
  mobileApp?: InputMaybe<Scalars['Boolean']['input']>;
  notification?: InputMaybe<Scalars['Boolean']['input']>;
  profile?: InputMaybe<Scalars['Boolean']['input']>;
  theme?: InputMaybe<Scalars['Boolean']['input']>;
  wallet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WidgetIntegrationContentType = {
  __typename?: 'WidgetIntegrationContentType';
  affiliate?: Maybe<Scalars['Boolean']['output']>;
  badges?: Maybe<Scalars['Boolean']['output']>;
  buttons?: Maybe<Scalars['Boolean']['output']>;
  campaigns?: Maybe<Scalars['Boolean']['output']>;
  challenge?: Maybe<Scalars['Boolean']['output']>;
  chat?: Maybe<Scalars['Boolean']['output']>;
  games?: Maybe<WidgetIntegrationContentGamesType>;
  leaderboard?: Maybe<Scalars['Boolean']['output']>;
  marketplace?: Maybe<Scalars['Boolean']['output']>;
  marketplaceCoin?: Maybe<CoinType>;
  mobileApp?: Maybe<Scalars['Boolean']['output']>;
  notification?: Maybe<Scalars['Boolean']['output']>;
  profile?: Maybe<Scalars['Boolean']['output']>;
  theme?: Maybe<Scalars['Boolean']['output']>;
  wallet?: Maybe<Scalars['Boolean']['output']>;
};

export type WidgetIntegrationInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<WidgetIntegrationContentInput>;
  font?: InputMaybe<Scalars['ID']['input']>;
  guestMode?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  login?: InputMaybe<WidgetIntegrationLoginInput>;
  multilanguage?: InputMaybe<WidgetIntegrationMultilanguageInput>;
  picture?: InputMaybe<PictureInput>;
  position?: InputMaybe<WidgetIntegrationPositionInput>;
  target?: InputMaybe<TargetAciInput>;
  test?: InputMaybe<WidgetIntegrationTestInput>;
  theme?: InputMaybe<Scalars['String']['input']>;
};

export type WidgetIntegrationLoginInput = {
  api?: InputMaybe<ApiInput>;
  app?: InputMaybe<EnableableFieldInput>;
  apple?: InputMaybe<EnableableFieldInput>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  facebook?: InputMaybe<EnableableFieldInput>;
  google?: InputMaybe<EnableableFieldInput>;
  privacy?: InputMaybe<EnableableFieldInput>;
  qr?: InputMaybe<EnableableFieldInput>;
  terms?: InputMaybe<EnableableFieldInput>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type WidgetIntegrationLoginType = {
  __typename?: 'WidgetIntegrationLoginType';
  api?: Maybe<WidgetIntegrationApiType>;
  app?: Maybe<EnableableFieldType>;
  apple?: Maybe<EnableableFieldType>;
  enable?: Maybe<Scalars['Boolean']['output']>;
  facebook?: Maybe<EnableableFieldType>;
  google?: Maybe<EnableableFieldType>;
  privacy?: Maybe<EnableableFieldType>;
  qr?: Maybe<EnableableFieldType>;
  terms?: Maybe<EnableableFieldType>;
  url?: Maybe<Scalars['String']['output']>;
};

export type WidgetIntegrationMultilanguageInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Array<WidgetIntegrationMultilanguageLanguageInput>>;
};

export type WidgetIntegrationMultilanguageLanguageInput = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['ID']['input']>;
};

export type WidgetIntegrationMultilanguageLanguageType = {
  __typename?: 'WidgetIntegrationMultilanguageLanguageType';
  default?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<LanguageType>;
};

export type WidgetIntegrationMultilanguageType = {
  __typename?: 'WidgetIntegrationMultilanguageType';
  active?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Array<WidgetIntegrationMultilanguageLanguageType>>;
};

export type WidgetIntegrationPositionInput = {
  alignment?: InputMaybe<PositionEnum>;
  positioning?: InputMaybe<Scalars['Float']['input']>;
  scale?: InputMaybe<WidgetIntegrationScaleInput>;
};

export type WidgetIntegrationPositionType = {
  __typename?: 'WidgetIntegrationPositionType';
  alignment?: Maybe<PositionEnum>;
  positioning?: Maybe<Scalars['Float']['output']>;
  scale?: Maybe<WidgetIntegrationScaleType>;
};

export type WidgetIntegrationScaleInput = {
  mobile?: InputMaybe<Scalars['Float']['input']>;
  web?: InputMaybe<Scalars['Float']['input']>;
};

export type WidgetIntegrationScaleType = {
  __typename?: 'WidgetIntegrationScaleType';
  mobile?: Maybe<Scalars['Float']['output']>;
  web?: Maybe<Scalars['Float']['output']>;
};

export type WidgetIntegrationTestInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  ips?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WidgetIntegrationTestType = {
  __typename?: 'WidgetIntegrationTestType';
  active?: Maybe<Scalars['Boolean']['output']>;
  ips?: Maybe<Array<Scalars['String']['output']>>;
};

export type WidgetIntegrationType = {
  __typename?: 'WidgetIntegrationType';
  actions?: Maybe<Array<WidgetIntegrationActionsType>>;
  active?: Maybe<Scalars['Boolean']['output']>;
  content?: Maybe<WidgetIntegrationContentType>;
  createdAt: Scalars['DateTime']['output'];
  font?: Maybe<FontType>;
  guestMode?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  login?: Maybe<WidgetIntegrationLoginType>;
  multilanguage?: Maybe<WidgetIntegrationMultilanguageType>;
  picture?: Maybe<PictureType>;
  position?: Maybe<WidgetIntegrationPositionType>;
  target: TargetType;
  test?: Maybe<WidgetIntegrationTestType>;
  theme?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type WidgetVisualsInput = {
  app?: InputMaybe<TranslationAppEnum>;
  picture?: InputMaybe<PictureInput>;
  reference?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<TargetAciInput>;
};

export type WidgetVisualsPaginateType = {
  __typename?: 'WidgetVisualsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<WidgetVisualsType>;
};

export type WidgetVisualsType = {
  __typename?: 'WidgetVisualsType';
  app?: Maybe<TranslationAppEnum>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  picture?: Maybe<PictureType>;
  reference?: Maybe<Scalars['String']['output']>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type YearlyChartType = {
  __typename?: 'YearlyChartType';
  chart: Array<Array<Scalars['Float']['output']>>;
  year: Scalars['Int']['output'];
};

export enum ZoneTypesCategoryEnum {
  TARIF = 'TARIF',
  ZONE = 'ZONE'
}

export enum ZoneTypesEnum {
  POINT = 'POINT',
  POLYGON = 'POLYGON'
}

export type AddRewardInput = {
  cycle: LeaderboardCycleEnum;
  cycleNumber: Scalars['Int']['input'];
  /** game id */
  game?: InputMaybe<Scalars['ID']['input']>;
  /** game group code */
  gameGroup?: InputMaybe<Scalars['String']['input']>;
  rewards: Array<GameIntegrationRewardInnerInput>;
  target?: InputMaybe<TargetAciInput>;
  year: Scalars['Int']['input'];
};

export type TaxRankInput = {
  rank: Scalars['Int']['input'];
  tax: Scalars['ID']['input'];
};

export type TaxRankType = {
  __typename?: 'taxRankType';
  rank?: Maybe<Scalars['String']['output']>;
  tax?: Maybe<TaxType>;
};

export type UpdateRewardInput = {
  id: Scalars['ID']['input'];
  rewards: Array<GameIntegrationRewardInnerInput>;
};

export type WalletTopupRemunerationInput = {
  qualitative?: InputMaybe<WalletTopupPrelevelQualitativeInput>;
  quantitative?: InputMaybe<WalletTopupPrelevelQuantitativeInput>;
  reputationLevel?: InputMaybe<Scalars['ID']['input']>;
};

export type WalletTopupRemunerationType = {
  __typename?: 'walletTopupRemunerationType';
  qualitative: WalletTopupPrelevelQualitativeType;
  quantitative: WalletTopupPrelevelQuantitativeType;
  reputationLevel: ReputationType;
};

export type LoginForAppQueryVariables = Exact<{
  input: LoginInput;
}>;


export type LoginForAppQuery = { __typename?: 'Query', loginForApp: { __typename?: 'LoginType', accessToken: string, expiresIn: number } };

export type RegisterForAppMutationVariables = Exact<{
  subject: Scalars['String']['input'];
  input: UserInput;
  brand: EmailTempVariablesBrandInput;
}>;


export type RegisterForAppMutation = { __typename?: 'Mutation', registerForApp: { __typename?: 'LoginType', accessToken: string, expiresIn: number } };

export type FindBlogsByTargetAndUrlQueryVariables = Exact<{
  target: TargetAciInput;
  url: Scalars['String']['input'];
}>;


export type FindBlogsByTargetAndUrlQuery = { __typename?: 'Query', findBlogsByTargetAndUrl: { __typename?: 'BlogType', id: string, url?: string | null, title: string, tags?: Array<string> | null, status: string, createdAt: any, updatedAt: any, author: { __typename?: 'UserType', id: string, email?: string | null, lastName?: string | null, username?: string | null, firstName?: string | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, seo?: { __typename?: 'SeoComponentType', metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'TagType', name?: string | null, content?: string | null }> | null } | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null }, sectionData?: Array<{ __typename?: 'BlogDataType', sectionTitle?: string | null, sectionContent?: string | null, sectionReference?: string | null, sectionPictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null }> | null } };

export type FindBlogsByTargetPaginatedQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
  status?: InputMaybe<Array<VisibilityStatusEnum> | VisibilityStatusEnum>;
}>;


export type FindBlogsByTargetPaginatedQuery = { __typename?: 'Query', findBlogsByTargetPaginated: { __typename?: 'PaginatedBlogsType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'BlogType', id: string, url?: string | null, title: string, tags?: Array<string> | null, status: string, createdAt: any, updatedAt: any, author: { __typename?: 'UserType', id: string, email?: string | null, lastName?: string | null, username?: string | null, firstName?: string | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, seo?: { __typename?: 'SeoComponentType', metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'TagType', name?: string | null, content?: string | null }> | null } | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null }, sectionData?: Array<{ __typename?: 'BlogDataType', sectionTitle?: string | null, sectionContent?: string | null, sectionReference?: string | null, sectionPictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null }> | null }> } };

export type CatalogueCategoryCacheQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CatalogueCategoryCacheQuery = { __typename?: 'Query', catalogueCategoryCache: { __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number, icon?: string | null, createdAt: any, updatedAt: any, variety?: ProductVarietyEnum | null, externalId?: string | null, hasChildren: boolean, description?: string | null, portal?: boolean | null, pickup?: boolean | null, booking?: boolean | null, delivery?: boolean | null, seo?: { __typename?: 'CatalogueCategorySeoType', urlKey?: string | null, metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'MetaKeywordsType', name?: string | null, content?: string | null }> | null } | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } } };

export type GetCatalogueCategoriesByTargetWithChildrenCacheQueryVariables = Exact<{
  target: TargetAciInput;
  variety?: InputMaybe<ProductVarietyEnum>;
}>;


export type GetCatalogueCategoriesByTargetWithChildrenCacheQuery = { __typename?: 'Query', getCatalogueCategoriesByTargetWithChildrenCache: Array<{ __typename?: 'CatalogueCategoryWithChildrenType', id: string, name?: string | null, rank?: number | null, layer: number, icon?: string | null, createdAt: any, updatedAt: any, variety?: ProductVarietyEnum | null, externalId?: string | null, hasChildren: boolean, description?: string | null, portal?: boolean | null, pickup?: boolean | null, booking?: boolean | null, delivery?: boolean | null, seo?: { __typename?: 'CatalogueCategorySeoType', urlKey?: string | null, metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'MetaKeywordsType', name?: string | null, content?: string | null }> | null } | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null }, children?: Array<{ __typename?: 'CatalogueCategoryWithChildrenType', id: string, name?: string | null, rank?: number | null, layer: number, icon?: string | null, createdAt: any, updatedAt: any, variety?: ProductVarietyEnum | null, externalId?: string | null, hasChildren: boolean, description?: string | null, portal?: boolean | null, pickup?: boolean | null, booking?: boolean | null, delivery?: boolean | null, seo?: { __typename?: 'CatalogueCategorySeoType', urlKey?: string | null, metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'MetaKeywordsType', name?: string | null, content?: string | null }> | null } | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null }, children?: Array<{ __typename?: 'CatalogueCategoryWithChildrenType', id: string, name?: string | null, rank?: number | null, layer: number, icon?: string | null, createdAt: any, updatedAt: any, variety?: ProductVarietyEnum | null, externalId?: string | null, hasChildren: boolean, description?: string | null, portal?: boolean | null, pickup?: boolean | null, booking?: boolean | null, delivery?: boolean | null, seo?: { __typename?: 'CatalogueCategorySeoType', urlKey?: string | null, metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'MetaKeywordsType', name?: string | null, content?: string | null }> | null } | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null }, children?: Array<{ __typename?: 'CatalogueCategoryWithChildrenType', id: string, name?: string | null, rank?: number | null, layer: number, icon?: string | null, createdAt: any, updatedAt: any, variety?: ProductVarietyEnum | null, externalId?: string | null, hasChildren: boolean, description?: string | null, portal?: boolean | null, pickup?: boolean | null, booking?: boolean | null, delivery?: boolean | null, seo?: { __typename?: 'CatalogueCategorySeoType', urlKey?: string | null, metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'MetaKeywordsType', name?: string | null, content?: string | null }> | null } | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null }, children?: Array<{ __typename?: 'CatalogueCategoryWithChildrenType', id: string, name?: string | null, rank?: number | null, layer: number, icon?: string | null, createdAt: any, updatedAt: any, variety?: ProductVarietyEnum | null, externalId?: string | null, hasChildren: boolean, description?: string | null, portal?: boolean | null, pickup?: boolean | null, booking?: boolean | null, delivery?: boolean | null, seo?: { __typename?: 'CatalogueCategorySeoType', urlKey?: string | null, metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'MetaKeywordsType', name?: string | null, content?: string | null }> | null } | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null }, children?: Array<{ __typename?: 'CatalogueCategoryWithChildrenType', id: string, name?: string | null, rank?: number | null, layer: number, icon?: string | null, createdAt: any, updatedAt: any, variety?: ProductVarietyEnum | null, externalId?: string | null, hasChildren: boolean, description?: string | null, portal?: boolean | null, pickup?: boolean | null, booking?: boolean | null, delivery?: boolean | null, seo?: { __typename?: 'CatalogueCategorySeoType', urlKey?: string | null, metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'MetaKeywordsType', name?: string | null, content?: string | null }> | null } | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } }> | null }> | null }> | null }> | null }> | null }> };

export type GetCatalogueCategoriesByTargetAndUrlKeyQueryVariables = Exact<{
  target: TargetAciInput;
  urlKey: Scalars['String']['input'];
}>;


export type GetCatalogueCategoriesByTargetAndUrlKeyQuery = { __typename?: 'Query', getCatalogueCategoriesByTargetAndUrlKey: { __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number, icon?: string | null, createdAt: any, updatedAt: any, variety?: ProductVarietyEnum | null, externalId?: string | null, hasChildren: boolean, description?: string | null, portal?: boolean | null, pickup?: boolean | null, booking?: boolean | null, delivery?: boolean | null, seo?: { __typename?: 'CatalogueCategorySeoType', urlKey?: string | null, metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'MetaKeywordsType', name?: string | null, content?: string | null }> | null } | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } } };

export type SearchCatalogueCategoriesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchCatalogueCategoriesQuery = { __typename?: 'Query', searchCatalogueCategories: { __typename?: 'CatalogueCategoryPaginateType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number, icon?: string | null, createdAt: any, updatedAt: any, variety?: ProductVarietyEnum | null, externalId?: string | null, hasChildren: boolean, description?: string | null, portal?: boolean | null, pickup?: boolean | null, booking?: boolean | null, delivery?: boolean | null, seo?: { __typename?: 'CatalogueCategorySeoType', urlKey?: string | null, metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'MetaKeywordsType', name?: string | null, content?: string | null }> | null } | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } }> } };

export type GetCatalogueCategoriesByLayerAndParentCacheQueryVariables = Exact<{
  target: TargetAciInput;
  layer: Scalars['Int']['input'];
  variety?: InputMaybe<ProductVarietyEnum>;
  parent?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCatalogueCategoriesByLayerAndParentCacheQuery = { __typename?: 'Query', getCatalogueCategoriesByLayerAndParentCache: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number, icon?: string | null, createdAt: any, updatedAt: any, variety?: ProductVarietyEnum | null, externalId?: string | null, hasChildren: boolean, description?: string | null, portal?: boolean | null, pickup?: boolean | null, booking?: boolean | null, delivery?: boolean | null, seo?: { __typename?: 'CatalogueCategorySeoType', urlKey?: string | null, metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'MetaKeywordsType', name?: string | null, content?: string | null }> | null } | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } }> };

export type FindContentTypeByTypeQueryVariables = Exact<{
  type: Scalars['String']['input'];
}>;


export type FindContentTypeByTypeQuery = { __typename?: 'Query', findContentTypeByType: { __typename?: 'ContentTypeType', id: string, name: string, type?: string | null } };

export type LoginForTargetQueryVariables = Exact<{
  login?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<IPhoneInput>;
  password: Scalars['String']['input'];
  target: TargetAciInput;
  source?: InputMaybe<UserEventsSourceEnum>;
}>;


export type LoginForTargetQuery = { __typename?: 'Query', loginForTarget: { __typename?: 'LoginType', expiresIn: number, accessToken: string, user: { __typename?: 'UserType', id: string, apps?: Array<App> | null, email?: string | null, roles?: Array<UserRole> | null, title?: string | null, about?: string | null, gender?: Gender | null, locale?: string | null, source?: SourcesEnum | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, plugged?: boolean | null, createdAt: any, updatedAt: any, isMailValid?: boolean | null, dateOfBirth?: any | null, phoneNumber?: string | null, mobileTheme?: MobileThemesEnum | null, placeOfBirth?: string | null, maritalStatus?: MaritalStatus | null, newsletterSubs?: boolean | null, hasAutoGeneratedEmail?: boolean | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, target?: { __typename?: 'TargetIdsType', pos?: string | null, wholesaler?: string | null } | null } } };

export type LogoutUserForTargetQueryVariables = Exact<{
  source?: InputMaybe<UserEventsSourceEnum>;
}>;


export type LogoutUserForTargetQuery = { __typename?: 'Query', logoutUserForTarget: { __typename?: 'SuccessResponseDtoType', success: boolean, message: string } };

export type IsLoginForTargetExistQueryVariables = Exact<{
  input: IsLoginForTargetExistInput;
}>;


export type IsLoginForTargetExistQuery = { __typename?: 'Query', isLoginForTargetExist: { __typename?: 'CorporateUserExistType', exist: boolean, user?: { __typename?: 'CorporateUserType', id: string } | null } };

export type RegisterForTargetMutationVariables = Exact<{
  input: UserWithTargetInput;
}>;


export type RegisterForTargetMutation = { __typename?: 'Mutation', registerForTarget: { __typename?: 'LoginType', expiresIn: number, accessToken: string, user: { __typename?: 'UserType', id: string, apps?: Array<App> | null, email?: string | null, roles?: Array<UserRole> | null, title?: string | null, about?: string | null, gender?: Gender | null, locale?: string | null, source?: SourcesEnum | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, plugged?: boolean | null, createdAt: any, updatedAt: any, isMailValid?: boolean | null, dateOfBirth?: any | null, phoneNumber?: string | null, mobileTheme?: MobileThemesEnum | null, placeOfBirth?: string | null, maritalStatus?: MaritalStatus | null, newsletterSubs?: boolean | null, hasAutoGeneratedEmail?: boolean | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } } };

export type RegisterForTargetWithWholesalerMutationVariables = Exact<{
  input: UserWithTargetInput;
}>;


export type RegisterForTargetWithWholesalerMutation = { __typename?: 'Mutation', registerForTargetWithWholesaler: { __typename?: 'LoginType', expiresIn: number, accessToken: string, user: { __typename?: 'UserType', id: string, apps?: Array<App> | null, email?: string | null, roles?: Array<UserRole> | null, title?: string | null, about?: string | null, gender?: Gender | null, locale?: string | null, source?: SourcesEnum | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, plugged?: boolean | null, createdAt: any, updatedAt: any, isMailValid?: boolean | null, dateOfBirth?: any | null, phoneNumber?: string | null, mobileTheme?: MobileThemesEnum | null, placeOfBirth?: string | null, maritalStatus?: MaritalStatus | null, newsletterSubs?: boolean | null, hasAutoGeneratedEmail?: boolean | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } } };

export type InvitePartnerToNetworkMutationVariables = Exact<{
  input: PartnershipNetworkInput;
}>;


export type InvitePartnerToNetworkMutation = { __typename?: 'Mutation', invitePartnerToNetwork: { __typename?: 'PartnershipNetworkType', id: string, partnership?: Array<PartnershipTypeEnum> | null } };

export type SendValidationEmailForTargetMutationVariables = Exact<{
  target: TargetAciInput;
  email: Scalars['String']['input'];
  subject: Scalars['String']['input'];
}>;


export type SendValidationEmailForTargetMutation = { __typename?: 'Mutation', sendValidationEmailForTarget: { __typename?: 'MailResponseDto', accepted: Array<string>, rejected: Array<string>, response: string, messageId: string, messageTime: number, messageSize: number, envelopeTime: number } };

export type ValidateEmailForTargetMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ValidateEmailForTargetMutation = { __typename?: 'Mutation', validateEmailForTarget: { __typename?: 'CorporateUserType', id: string, apps?: Array<App> | null, email?: string | null, roles?: Array<UserRole> | null, title?: string | null, about?: string | null, gender?: Gender | null, locale?: string | null, source?: SourcesEnum | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, plugged?: boolean | null, createdAt: any, updatedAt: any, isMailValid?: boolean | null, dateOfBirth?: any | null, phoneNumber?: string | null, mobileTheme?: MobileThemesEnum | null, placeOfBirth?: string | null, maritalStatus?: MaritalStatus | null, newsletterSubs?: boolean | null, hasAutoGeneratedEmail?: boolean | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } };

export type ResetPasswordForTargetMutationVariables = Exact<{
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
  target: TargetAciInput;
  source?: InputMaybe<UserEventsSourceEnum>;
}>;


export type ResetPasswordForTargetMutation = { __typename?: 'Mutation', resetPasswordForTarget: { __typename?: 'CorporateUserType', id: string, apps?: Array<App> | null, email?: string | null, roles?: Array<UserRole> | null, title?: string | null, about?: string | null, gender?: Gender | null, locale?: string | null, source?: SourcesEnum | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, plugged?: boolean | null, createdAt: any, updatedAt: any, isMailValid?: boolean | null, dateOfBirth?: any | null, phoneNumber?: string | null, mobileTheme?: MobileThemesEnum | null, placeOfBirth?: string | null, maritalStatus?: MaritalStatus | null, newsletterSubs?: boolean | null, hasAutoGeneratedEmail?: boolean | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } };

export type SaveCurrentCorporateUserStatusMutationVariables = Exact<{
  status: UserStatus;
  target: TargetAciInput;
}>;


export type SaveCurrentCorporateUserStatusMutation = { __typename?: 'Mutation', saveCurrentCorporateUserStatus: { __typename?: 'UserType', id: string, apps?: Array<App> | null, email?: string | null, roles?: Array<UserRole> | null, title?: string | null, about?: string | null, gender?: Gender | null, locale?: string | null, source?: SourcesEnum | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, plugged?: boolean | null, createdAt: any, updatedAt: any, isMailValid?: boolean | null, dateOfBirth?: any | null, phoneNumber?: string | null, mobileTheme?: MobileThemesEnum | null, placeOfBirth?: string | null, maritalStatus?: MaritalStatus | null, newsletterSubs?: boolean | null, hasAutoGeneratedEmail?: boolean | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } };

export type SendForgotPasswordMailToTargetMutationVariables = Exact<{
  email: Scalars['String']['input'];
  target: TargetAciInput;
  subject?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendForgotPasswordMailToTargetMutation = { __typename?: 'Mutation', sendForgotPasswordMailToTarget: { __typename?: 'MailResponseDto', accepted: Array<string>, rejected: Array<string>, response: string, messageId: string, messageTime: number, messageSize: number, envelopeTime: number } };

export type DeleteUserMutationVariables = Exact<{
  password: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  reason: DeleteUserReasonEnum;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'DeleteResponseDtoType', message: string, success: boolean } };

export type GetCorporateRatingAssignmentByTargetCacheQueryVariables = Exact<{
  target: TargetAciInput;
}>;


export type GetCorporateRatingAssignmentByTargetCacheQuery = { __typename?: 'Query', getCorporateRatingAssignmentByTargetCache: Array<{ __typename?: 'CorporateRatingAssignmentType', id?: string | null, active?: boolean | null, createdAt: any, updatedAt: any, reviewDefinition?: { __typename?: 'CorporateRatingDefinitionType', id?: string | null, reviewType?: string | null } | null }> };

export type GetCorporateRatingDefinitionByReviewTypeCacheQueryVariables = Exact<{
  reviewType: Scalars['String']['input'];
}>;


export type GetCorporateRatingDefinitionByReviewTypeCacheQuery = { __typename?: 'Query', getCorporateRatingDefinitionByReviewTypeCache: { __typename?: 'CorporateRatingDefinitionType', id?: string | null, reviewType?: string | null } };

export type GetCorporateRatingsByProductWithStatsQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetCorporateRatingsByProductWithStatsQuery = { __typename?: 'Query', getCorporateRatingsByProductWithStats: { __typename?: 'CorporateRatingWithStatsPaginatedType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'CorporateRatingType', id: string, mark: number, comment?: string | null, createdAt: any, updatedAt: any, user: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null }, product?: { __typename?: 'InternalProductType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, flags?: Array<ProductFlagEnum> | null, price?: any | null, status?: ProductStatusEnum | null, condition?: ProductConditionEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null }> | null, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null }> | null } | null, reviewType: { __typename?: 'CorporateRatingDefinitionType', id?: string | null, reviewType?: string | null } }>, stats?: Array<{ __typename?: 'ByMarkRatingType', mark: number, count: number }> | null } };

export type GetCurrentUserCorporateRatingsByProductQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type GetCurrentUserCorporateRatingsByProductQuery = { __typename?: 'Query', getCurrentUserCorporateRatingsByProduct: { __typename?: 'CorporateRatingType', id: string, mark: number, comment?: string | null, createdAt: any, updatedAt: any, user: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null }, product?: { __typename?: 'InternalProductType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, flags?: Array<ProductFlagEnum> | null, price?: any | null, status?: ProductStatusEnum | null, condition?: ProductConditionEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null }> | null, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null }> | null } | null, reviewType: { __typename?: 'CorporateRatingDefinitionType', id?: string | null, reviewType?: string | null } } };

export type GetAverageCorporateProductRatingsByProductQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type GetAverageCorporateProductRatingsByProductQuery = { __typename?: 'Query', getAverageCorporateProductRatingsByProduct: { __typename?: 'AverageRatingType', overAllAverage: any, byMark: Array<{ __typename?: 'ByMarkRatingType', mark: number, count: number }> } };

export type GetCorporateRatingsByProductQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetCorporateRatingsByProductQuery = { __typename?: 'Query', getCorporateRatingsByProduct: { __typename?: 'CorporateRatingPaginateType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'CorporateRatingType', id: string, mark: number, comment?: string | null, createdAt: any, updatedAt: any, user: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null }, product?: { __typename?: 'InternalProductType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, flags?: Array<ProductFlagEnum> | null, price?: any | null, status?: ProductStatusEnum | null, condition?: ProductConditionEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null }> | null, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null }> | null } | null, reviewType: { __typename?: 'CorporateRatingDefinitionType', id?: string | null, reviewType?: string | null } }> } };

export type CreateCorporateRatingMutationVariables = Exact<{
  input: CorporateRatingInput;
}>;


export type CreateCorporateRatingMutation = { __typename?: 'Mutation', createCorporateRating: { __typename?: 'CorporateRatingType', id: string, mark: number, comment?: string | null, createdAt: any, updatedAt: any, user: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null }, product?: { __typename?: 'InternalProductType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, flags?: Array<ProductFlagEnum> | null, price?: any | null, status?: ProductStatusEnum | null, condition?: ProductConditionEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null }> | null, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null }> | null } | null, reviewType: { __typename?: 'CorporateRatingDefinitionType', id?: string | null, reviewType?: string | null } } };

export type UpdateCorporateRatingMutationVariables = Exact<{
  input: CorporateUpdateRatingInput;
  id: Scalars['ID']['input'];
}>;


export type UpdateCorporateRatingMutation = { __typename?: 'Mutation', updateCorporateRating: { __typename?: 'CorporateRatingType', id: string, mark: number, comment?: string | null, createdAt: any, updatedAt: any, user: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null }, product?: { __typename?: 'InternalProductType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, flags?: Array<ProductFlagEnum> | null, price?: any | null, status?: ProductStatusEnum | null, condition?: ProductConditionEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null }> | null, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null }> | null } | null, reviewType: { __typename?: 'CorporateRatingDefinitionType', id?: string | null, reviewType?: string | null } } };

export type DeleteCorporateRatingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCorporateRatingMutation = { __typename?: 'Mutation', deleteCorporateRating: { __typename?: 'DeleteResponseDtoType', success: boolean, message: string } };

export type FindCountriesPaginationQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type FindCountriesPaginationQuery = { __typename?: 'Query', findCountriesPagination: { __typename?: 'CountryPaginatedType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any }> } };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { __typename?: 'Query', getCountries: Array<{ __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any }> };

export type IsCouponValidQueryVariables = Exact<{
  couponCode: Scalars['String']['input'];
  target: TargetAciInput;
}>;


export type IsCouponValidQuery = { __typename?: 'Query', isCouponValid: { __typename?: 'IsCouponValidType', isValid: boolean, coupon?: { __typename?: 'CouponType', id: string, to?: any | null, from?: any | null, redeemed?: boolean | null, couponCode?: string | null, createdAt: any, updatedAt: any, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null } | null } };

export type FindCouponByTargetAndCodeQueryVariables = Exact<{
  couponCode: Scalars['String']['input'];
  target: TargetAciInput;
}>;


export type FindCouponByTargetAndCodeQuery = { __typename?: 'Query', findCouponByTargetAndCode: { __typename?: 'CouponType', id: string, to?: any | null, from?: any | null, redeemed?: boolean | null, couponCode?: string | null, createdAt: any, updatedAt: any, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } } };

export type RedeemCouponMutationVariables = Exact<{
  couponCode: Scalars['String']['input'];
  target: TargetAciInput;
}>;


export type RedeemCouponMutation = { __typename?: 'Mutation', redeemCoupon: { __typename?: 'CouponType', id: string, to?: any | null, from?: any | null, redeemed?: boolean | null, couponCode?: string | null, createdAt: any, updatedAt: any, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } } };

export type FindDeliveryZonesByTargetCacheQueryVariables = Exact<{
  target: TargetAciInput;
}>;


export type FindDeliveryZonesByTargetCacheQuery = { __typename?: 'Query', findDeliveryZonesByTargetCache: Array<{ __typename?: 'DeliveryZonesType', id: string, category: ZoneTypesCategoryEnum, order?: number | null, color?: string | null, radius?: number | null, minPrice?: any | null, extraFees?: any | null, type: ZoneTypesEnum, createdAt: any, updatedAt: any, paths: Array<{ __typename?: 'DeliveryZonePathType', lat: number, lng: number, order: number }> }> };

export type CreateDocumentMutationVariables = Exact<{
  input: DocumentInput;
}>;


export type CreateDocumentMutation = { __typename?: 'Mutation', createDocument: { __typename?: 'DocumentType', id: string, name: string, size?: number | null, createdAt: any, updatedAt: any, content?: { __typename?: 'DocumentContentType', base64?: string | null, url?: string | null, type?: { __typename?: 'ContentTypeType', id: string, name: string, type?: string | null } | null } | null } };

export type GetEventByTargetAndCodeQueryVariables = Exact<{
  target: TargetAciInput;
  code: Scalars['String']['input'];
}>;


export type GetEventByTargetAndCodeQuery = { __typename?: 'Query', getEventByTargetAndCode: { __typename?: 'EventType', id: string, code?: string | null, title?: string | null, description?: string | null, date?: any | null, createdAt: any, updatedAt: any, duration?: { __typename?: 'EventDurationType', amount?: number | null, unit?: PeriodCycleEnum | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, target?: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } | null } };

export type CreateEventInviteMutationVariables = Exact<{
  input: EventInviteInput;
}>;


export type CreateEventInviteMutation = { __typename?: 'Mutation', createEventInvite: { __typename?: 'EventInviteType', id: string, title: string, status: EventInviteStatusEnum, from?: any | null, to?: any | null } };

export type GetEventInvitesWithFilterQueryVariables = Exact<{
  pos: Scalars['String']['input'];
  userId: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetEventInvitesWithFilterQuery = { __typename?: 'Query', getEventInvitesWithFilter: Array<{ __typename?: 'EventInviteType', id: string, title: string, status: EventInviteStatusEnum, from?: any | null, to?: any | null, invitee: { __typename?: 'UserType', email?: string | null, lastName?: string | null, firstName?: string | null }, invitor: { __typename?: 'EventInvitorType', user?: { __typename?: 'UserType', firstName?: string | null, lastName?: string | null, id: string } | null } }> };

export type GetPartnershipNetworksByTargetPaginationQueryVariables = Exact<{
  pos: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetPartnershipNetworksByTargetPaginationQuery = { __typename?: 'Query', getPartnershipNetworksByTargetPagination: { __typename?: 'PartnershipNetworkPaginateType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'PartnershipNetworkType', id: string, partnership?: Array<PartnershipTypeEnum> | null, partner?: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string, name?: string | null, email?: Array<string> | null } | null, wholesaler?: { __typename?: 'WholesalerType', id: string, name?: string | null, email?: string | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null } | null } | null } | null }> } };

export type GetCorporateUsersByTargetAndWholesalerQueryVariables = Exact<{
  pos: Scalars['String']['input'];
  wholesalerId: Scalars['String']['input'];
}>;


export type GetCorporateUsersByTargetAndWholesalerQuery = { __typename?: 'Query', getCorporateUsersByTargetAndWholesaler: Array<{ __typename?: 'CorporateUserType', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null } | null }> };

export type InsertEventTicketsMutationVariables = Exact<{
  input: EventTicketInput;
}>;


export type InsertEventTicketsMutation = { __typename?: 'Mutation', insertEventTickets: Array<{ __typename?: 'EventTicketType', id: string, target?: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null } | null }> };

export type GetEventTicketsWithFilterQueryVariables = Exact<{
  pos: Scalars['String']['input'];
  userId: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetEventTicketsWithFilterQuery = { __typename?: 'Query', getEventTicketsWithFilter: Array<{ __typename?: 'EventTicketType', id: string, status: EventTicketStatusEnum, reference: string, price?: any | null, zone?: string | null, title?: string | null, ticketUser: { __typename?: 'EventTicketUserType', firstName: string, lastName: string } }> };

export type GetEventTicketByReferenceQueryVariables = Exact<{
  reference: Scalars['String']['input'];
  pos: Scalars['String']['input'];
}>;


export type GetEventTicketByReferenceQuery = { __typename?: 'Query', getEventTicketByReference: { __typename?: 'EventTicketType', id: string, status: EventTicketStatusEnum, title?: string | null, reference: string, zone?: string | null, price?: any | null, event: { __typename?: 'EventType', id: string, code?: string | null }, validity: { __typename?: 'EventTicketValidityType', from?: any | null, to?: any | null }, ticketUser: { __typename?: 'EventTicketUserType', firstName: string, lastName: string } } };

export type MarkTicketAsAttendedMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MarkTicketAsAttendedMutation = { __typename?: 'Mutation', markTicketAsAttended: { __typename?: 'EventTicketType', id: string, status: EventTicketStatusEnum } };

export type GetFavoriteSimpleProductByCurrentUserQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetFavoriteSimpleProductByCurrentUserQuery = { __typename?: 'Query', getFavoriteSimpleProductByCurrentUser: { __typename?: 'InternalProductWithBarcodesWithPublicPricePaginateType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'InternalProductWithBarcodesWithPublicPriceType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, flags?: Array<ProductFlagEnum> | null, price?: any | null, status?: ProductStatusEnum | null, condition?: ProductConditionEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null }> | null, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, publicPrice?: any | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null }> | null }> } };

export type MarkSimpleProductAsFavoriteMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type MarkSimpleProductAsFavoriteMutation = { __typename?: 'Mutation', markSimpleProductAsFavorite: { __typename?: 'InternalProductWithBarcodesWithPublicPriceType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, flags?: Array<ProductFlagEnum> | null, price?: any | null, status?: ProductStatusEnum | null, condition?: ProductConditionEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null }> | null, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null }> | null } };

export type RemoveSimpleProductFromFavoritesMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type RemoveSimpleProductFromFavoritesMutation = { __typename?: 'Mutation', removeSimpleProductFromFavorites: { __typename?: 'InternalProductWithBarcodesWithPublicPriceType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, flags?: Array<ProductFlagEnum> | null, price?: any | null, status?: ProductStatusEnum | null, condition?: ProductConditionEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null }> | null, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null }> | null } };

export type GetGamesPaginatedQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetGamesPaginatedQuery = { __typename?: 'Query', getGamesPaginated: { __typename?: 'GamePaginateType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'GameType', id: string, url?: string | null, code?: string | null, title?: string | null, description?: string | null, globalRatio?: number | null, media?: { __typename?: 'MediaType', pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null }> | null } | null, point: { __typename?: 'GamePointType', name: string, code: string, picture: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null } }, translation?: Array<{ __typename?: 'GameTranslationType', language: { __typename?: 'LanguageType', id: string, name: string }, content: { __typename?: 'GameContentType', title: string, description: string } }> | null, assets?: { __typename?: 'GameAssetsType', images?: Array<{ __typename?: 'GameAssetDetailType', reference: string, value: string }> | null, font?: { __typename?: 'FontType', id: string, name: string, family?: string | null, url?: string | null, preview?: string | null } | null, sound?: Array<{ __typename?: 'GameAssetDetailType', reference: string, value: string }> | null } | null, settings?: { __typename?: 'GameSettingsType', color?: string | null, gameConfigs?: string | null, cost?: { __typename?: 'GameSettingsCostType', amount: string, coin: { __typename?: 'CoinType', id: string, name: string } } | null, items?: Array<{ __typename?: 'GameSettingsItemType', title?: string | null, description?: string | null, emoji?: string | null, color?: string | null, weight?: number | null, isRare?: boolean | null, points?: any | null, fallback?: string | null, qualitative?: any | null, empty?: boolean | null, again?: boolean | null, price?: any | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null } | null }> | null } | null }> } };

export type GetOrderInstallmentQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
  installmentId: Scalars['ID']['input'];
}>;


export type GetOrderInstallmentQuery = { __typename?: 'Query', getOrderInstallment: { __typename?: 'InstallmentType', _id: string, amount: any, paymentStatus: PaymentStatusEnum, paidAt?: any | null, deadline?: any | null, paymentMethod: { __typename?: 'PaymentType', id: string, name: string, code?: string | null, paymentType?: PaymentTypeEnum | null, materialIcon?: string | null, createdAt: any, updatedAt: any, images?: { __typename?: 'PaymentImagesType', svg?: { __typename?: 'PaymentImagesSvgType', default?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null } | null } } };

export type CreateMarketPlaceOrderMutationVariables = Exact<{
  input: MarketPlaceOrderInput;
}>;


export type CreateMarketPlaceOrderMutation = { __typename?: 'Mutation', createMarketPlaceOrder: Array<{ __typename?: 'MarketPlaceOrderDtoType', id: string, notes?: string | null, createdAt: any, orderTime?: any | null, orderType?: OrderTypeEnum | null, updatedAt: any, number: string, hasInvoice?: boolean | null, deliveryFees?: any | null, user?: { __typename?: 'UserType', id: string, apps?: Array<App> | null, email?: string | null, roles?: Array<UserRole> | null, title?: string | null, about?: string | null, gender?: Gender | null, locale?: string | null, source?: SourcesEnum | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, plugged?: boolean | null, createdAt: any, updatedAt: any, isMailValid?: boolean | null, dateOfBirth?: any | null, phoneNumber?: string | null, mobileTheme?: MobileThemesEnum | null, placeOfBirth?: string | null, maritalStatus?: MaritalStatus | null } | null, billingAddress?: { __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null } | null, deliveryAddress?: { __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null } | null, guestUser?: { __typename?: 'GuestUserType', email?: string | null, lastName?: string | null, firstName?: string | null, phone?: { __typename?: 'IPhoneType', number?: string | null, countryCode?: string | null } | null } | null, extraFees?: Array<{ __typename?: 'MarketPlaceOrderDtoFeesType', key?: string | null, value?: any | null }> | null, installments?: Array<{ __typename?: 'InstallmentType', _id: string, amount: any, paymentStatus: PaymentStatusEnum, paidAt?: any | null, deadline?: any | null, paymentMethod: { __typename?: 'PaymentType', id: string, name: string, code?: string | null, paymentType?: PaymentTypeEnum | null, materialIcon?: string | null, createdAt: any, updatedAt: any, images?: { __typename?: 'PaymentImagesType', svg?: { __typename?: 'PaymentImagesSvgType', default?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null } | null } }> | null, shoppingCart: { __typename?: 'MarketPlaceOrderShoppingCartType', price?: { __typename?: 'PriceFullType', net?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, gross?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, toPay?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null } | null, target?: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, taxValue?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, products?: Array<{ __typename?: 'OrderShoppingCartProductType', quantity: number, orderProductStatus: OrderStatus, name?: string | null, price: { __typename?: 'ProductPriceType', unitNet?: any | null, unitGross?: any | null, net?: any | null, gross?: any | null }, taxValue: { __typename?: 'TaxValueType', unit?: any | null, total?: any | null }, barcode: { __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, condition?: ProductConditionEnum | null, status?: ProductStatusEnum | null, createdAt: any, updatedAt: any, prices?: Array<{ __typename?: 'BarcodePricesType', price?: any | null, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any } | null }> | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number }> | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, externalId: string, createdAt: any, updatedAt: any, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null }, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } }> | null } | null, internalProduct?: { __typename?: 'InternalProductType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, price?: any | null, status?: ProductStatusEnum | null, condition?: ProductConditionEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null }> | null } | null } }> | null }, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any } | null }> };

export type CancelProductByConsumerMutationVariables = Exact<{
  input: MarketPlaceOrderProductInput;
}>;


export type CancelProductByConsumerMutation = { __typename?: 'Mutation', cancelProductByConsumer: { __typename?: 'MarketPlaceOrderDtoType', id: string, notes?: string | null, createdAt: any, orderTime?: any | null, orderType?: OrderTypeEnum | null, updatedAt: any, number: string, hasInvoice?: boolean | null, deliveryFees?: any | null, user?: { __typename?: 'UserType', id: string, apps?: Array<App> | null, email?: string | null, roles?: Array<UserRole> | null, title?: string | null, about?: string | null, gender?: Gender | null, locale?: string | null, source?: SourcesEnum | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, plugged?: boolean | null, createdAt: any, updatedAt: any, isMailValid?: boolean | null, dateOfBirth?: any | null, phoneNumber?: string | null, mobileTheme?: MobileThemesEnum | null, placeOfBirth?: string | null, maritalStatus?: MaritalStatus | null } | null, billingAddress?: { __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null } | null, deliveryAddress?: { __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null } | null, guestUser?: { __typename?: 'GuestUserType', email?: string | null, lastName?: string | null, firstName?: string | null, phone?: { __typename?: 'IPhoneType', number?: string | null, countryCode?: string | null } | null } | null, extraFees?: Array<{ __typename?: 'MarketPlaceOrderDtoFeesType', key?: string | null, value?: any | null }> | null, installments?: Array<{ __typename?: 'InstallmentType', _id: string, amount: any, paymentStatus: PaymentStatusEnum, paidAt?: any | null, deadline?: any | null, paymentMethod: { __typename?: 'PaymentType', id: string, name: string, code?: string | null, paymentType?: PaymentTypeEnum | null, materialIcon?: string | null, createdAt: any, updatedAt: any, images?: { __typename?: 'PaymentImagesType', svg?: { __typename?: 'PaymentImagesSvgType', default?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null } | null } }> | null, shoppingCart: { __typename?: 'MarketPlaceOrderShoppingCartType', price?: { __typename?: 'PriceFullType', net?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, gross?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, toPay?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null } | null, target?: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, taxValue?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, products?: Array<{ __typename?: 'OrderShoppingCartProductType', quantity: number, orderProductStatus: OrderStatus, name?: string | null, price: { __typename?: 'ProductPriceType', unitNet?: any | null, unitGross?: any | null, net?: any | null, gross?: any | null }, taxValue: { __typename?: 'TaxValueType', unit?: any | null, total?: any | null }, barcode: { __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, condition?: ProductConditionEnum | null, status?: ProductStatusEnum | null, createdAt: any, updatedAt: any, prices?: Array<{ __typename?: 'BarcodePricesType', price?: any | null, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any } | null }> | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number }> | null, pixel?: { __typename?: 'PixelBarcodeType', include?: boolean | null } | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, externalId: string, createdAt: any, updatedAt: any, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null }, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } }> | null } | null, internalProduct?: { __typename?: 'InternalProductType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, price?: any | null, status?: ProductStatusEnum | null, condition?: ProductConditionEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null }> | null } | null } }> | null }, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any } | null } };

export type PayMarketplaceOrderInstallmentsMutationVariables = Exact<{
  input: InstallmentPaymentInput;
}>;


export type PayMarketplaceOrderInstallmentsMutation = { __typename?: 'Mutation', payMarketplaceOrderInstallments: { __typename?: 'MarketPlaceOrderDtoType', id: string, notes?: string | null, createdAt: any, orderTime?: any | null, orderType?: OrderTypeEnum | null, updatedAt: any, number: string, hasInvoice?: boolean | null, deliveryFees?: any | null, user?: { __typename?: 'UserType', id: string, apps?: Array<App> | null, email?: string | null, roles?: Array<UserRole> | null, title?: string | null, about?: string | null, gender?: Gender | null, locale?: string | null, source?: SourcesEnum | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, plugged?: boolean | null, createdAt: any, updatedAt: any, isMailValid?: boolean | null, dateOfBirth?: any | null, phoneNumber?: string | null, mobileTheme?: MobileThemesEnum | null, placeOfBirth?: string | null, maritalStatus?: MaritalStatus | null } | null, billingAddress?: { __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null } | null, deliveryAddress?: { __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null } | null, guestUser?: { __typename?: 'GuestUserType', email?: string | null, lastName?: string | null, firstName?: string | null, phone?: { __typename?: 'IPhoneType', number?: string | null, countryCode?: string | null } | null } | null, extraFees?: Array<{ __typename?: 'MarketPlaceOrderDtoFeesType', key?: string | null, value?: any | null }> | null, installments?: Array<{ __typename?: 'InstallmentType', _id: string, amount: any, paymentStatus: PaymentStatusEnum, paidAt?: any | null, deadline?: any | null, paymentMethod: { __typename?: 'PaymentType', id: string, name: string, code?: string | null, paymentType?: PaymentTypeEnum | null, materialIcon?: string | null, createdAt: any, updatedAt: any, images?: { __typename?: 'PaymentImagesType', svg?: { __typename?: 'PaymentImagesSvgType', default?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null } | null } }> | null, shoppingCart: { __typename?: 'MarketPlaceOrderShoppingCartType', price?: { __typename?: 'PriceFullType', net?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, gross?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, toPay?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null } | null, target?: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, taxValue?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, products?: Array<{ __typename?: 'OrderShoppingCartProductType', quantity: number, orderProductStatus: OrderStatus, name?: string | null, price: { __typename?: 'ProductPriceType', unitNet?: any | null, unitGross?: any | null, net?: any | null, gross?: any | null }, taxValue: { __typename?: 'TaxValueType', unit?: any | null, total?: any | null }, barcode: { __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, condition?: ProductConditionEnum | null, status?: ProductStatusEnum | null, createdAt: any, updatedAt: any, prices?: Array<{ __typename?: 'BarcodePricesType', price?: any | null, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null } | null }> | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, priceCredit?: Array<{ __typename?: 'BarcodePeriodCreditType', periodCycle: RecurrenceType, periodValue: number, amount?: any | null }> | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number }> | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, externalId: string, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null }, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } }> | null } | null, internalProduct?: { __typename?: 'InternalProductType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, price?: any | null, status?: ProductStatusEnum | null, condition?: ProductConditionEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null }> | null } | null } }> | null }, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null } | null } };

export type GetSimpleProductWithProductAttributesAndFavoriteStatusQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSimpleProductWithProductAttributesAndFavoriteStatusQuery = { __typename?: 'Query', getSimpleProductWithProductAttributesAndFavoriteStatus: { __typename?: 'InternalProductWithFavoriteStatusType', id?: string | null, url?: string | null, name?: string | null, price?: any | null, flags?: Array<ProductFlagEnum> | null, createdAt: any, description?: string | null, longdesc?: string | null, descriptionList?: Array<string> | null, isFavorite?: boolean | null, seo?: { __typename?: 'CatalogueCategorySeoType', urlKey?: string | null, metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'MetaKeywordsType', name?: string | null, content?: string | null }> | null } | null, translation?: Array<{ __typename?: 'InternalProductTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'InternalProductTranslationContentType', name: string, description: string, longdesc?: string | null, descriptionList?: Array<string> | null, specs?: Array<{ __typename?: 'ProductSpecsType', key?: string | null, value?: string | null }> | null } }> | null, specs?: Array<{ __typename?: 'ProductSpecsType', key?: string | null, value?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string, title?: string | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null } | null } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null }, product?: { __typename?: 'ProductType', id?: string | null, brand?: { __typename?: 'BrandType', id?: string | null, name?: string | null, website?: string | null } | null } | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number, seo?: { __typename?: 'CatalogueCategorySeoType', urlKey?: string | null, metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'MetaKeywordsType', name?: string | null, content?: string | null }> | null } | null }> | null, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, createdAt: any, updatedAt: any, publicPrice?: any | null, publicPriceBeforeReduction?: any | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number }> | null, internalProduct?: { __typename?: 'InternalProductType', id?: string | null, seo?: { __typename?: 'CatalogueCategorySeoType', urlKey?: string | null, metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'MetaKeywordsType', name?: string | null, content?: string | null }> | null } | null, specs?: Array<{ __typename?: 'ProductSpecsType', key?: string | null, value?: string | null }> | null } | null, productAttributes?: Array<{ __typename?: 'AttributeWithAttributeValueType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, productAttributesValues?: Array<{ __typename?: 'AttributeValueBaseType', id: string, label: string, price?: any | null, externalId: string, createdAt: any, updatedAt: any }> | null }> | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, price?: any | null, externalId: string, createdAt: any, updatedAt: any, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null, maintenance?: { __typename?: 'InternalProductMaintenanceType', active?: boolean | null, prevMaintenanceDuration?: number | null, maintenanceDuration?: number | null, expectedMeantime?: number | null, owner?: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, technician?: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null } | null }> | null } };

export type GetSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusWithFilterQueryVariables = Exact<{
  input: GetInternalProductWithFilterPaginatedInput;
}>;


export type GetSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusWithFilterQuery = { __typename?: 'Query', getSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusWithFilter: { __typename?: 'InternalProductWithRatingsPaginateWithFavoriteStatusWithFilterType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'InternalProductWithRatingsWithFavoriteStatusType', id?: string | null, url?: string | null, name?: string | null, flags?: Array<ProductFlagEnum> | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, longdesc?: string | null, ratings?: any | null, isFavorite?: boolean | null, specs?: Array<{ __typename?: 'ProductSpecsType', key?: string | null, value?: string | null }> | null, brand?: { __typename?: 'BrandType', id?: string | null, name?: string | null } | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, target: { __typename?: 'TargetFilterType', pos?: { __typename?: 'FilterNamePictureFieldType', id: string, name?: string | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null } | null } | null, wholesaler?: { __typename?: 'FilterNameFieldType', id: string, name?: string | null } | null, manufacturer?: { __typename?: 'FilterNameFieldType', id: string, name?: string | null } | null }, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null }> | null, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, createdAt: any, updatedAt: any, publicPrice?: any | null, publicPriceBeforeReduction?: any | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, productAttributes?: Array<{ __typename?: 'AttributeWithAttributeValueType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, productAttributesValues?: Array<{ __typename?: 'AttributeValueBaseType', id: string, label: string, price?: any | null, createdAt: any, updatedAt: any }> | null }> | null }> | null }>, filter?: { __typename?: 'InternalProductFilterType', targets?: { __typename?: 'TargetsType', pos?: Array<{ __typename?: 'PointOfSaleType', id: string, name?: string | null }> | null, wholesaler?: Array<{ __typename?: 'WholesalerType', id: string, name?: string | null }> | null, manufacturer?: Array<{ __typename?: 'ManufacturerType', id: string, name?: string | null }> | null } | null, brands?: Array<{ __typename?: 'FilterNameFieldType', id: string, name?: string | null }> | null, priceRange?: { __typename?: 'PriceRangeType', min?: any | null, max?: any | null } | null, createdAtRange?: { __typename?: 'DateRangeType', min?: any | null, max?: any | null } | null, updatedAtRange?: { __typename?: 'DateRangeType', min?: any | null, max?: any | null } | null, catalogueCategories?: Array<{ __typename?: 'FilterNameFieldType', id: string, name?: string | null }> | null, productAttributesValues?: Array<{ __typename?: 'AttributeWithValueFilterType', id: string, label?: string | null, attributeValues?: Array<{ __typename?: 'FilterLabelFieldType', id: string, label?: string | null }> | null }> | null } | null } };

export type GetSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusQueryVariables = Exact<{
  input: GetInternalProductWithFilterPaginatedInput;
}>;


export type GetSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusQuery = { __typename?: 'Query', getSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatus: { __typename?: 'InternalProductWithRatingsPaginateWithFavoriteStatusType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'InternalProductWithRatingsWithFavoriteStatusType', id?: string | null, name?: string | null, flags?: Array<ProductFlagEnum> | null, createdAt: any, updatedAt: any, description?: string | null, ratings?: any | null, isFavorite?: boolean | null, brand?: { __typename?: 'BrandType', id?: string | null, name?: string | null } | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, target: { __typename?: 'TargetFilterType', pos?: { __typename?: 'FilterNamePictureFieldType', id: string, name?: string | null } | null }, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null }> | null, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, createdAt: any, updatedAt: any, publicPrice?: any | null, publicPriceBeforeReduction?: any | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, media?: { __typename?: 'MediaType', pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, productAttributes?: Array<{ __typename?: 'AttributeWithAttributeValueType', id: string, label: string }> | null }> | null }> } };

export type GetSimpleProductWithProductAttributesAndFavoriteStatusByUrlKeyQueryVariables = Exact<{
  target: TargetAciInput;
  urlKey: Scalars['String']['input'];
  language?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetSimpleProductWithProductAttributesAndFavoriteStatusByUrlKeyQuery = { __typename?: 'Query', getSimpleProductWithProductAttributesAndFavoriteStatusByUrlKey: { __typename?: 'InternalProductWithFavoriteStatusType', id?: string | null, url?: string | null, name?: string | null, price?: any | null, flags?: Array<ProductFlagEnum> | null, description?: string | null, longdesc?: string | null, descriptionList?: Array<string> | null, isFavorite?: boolean | null, translation?: Array<{ __typename?: 'InternalProductTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, createdAt: any, updatedAt: any }, content: { __typename?: 'InternalProductTranslationContentType', name: string, description: string, longdesc?: string | null, descriptionList?: Array<string> | null, specs?: Array<{ __typename?: 'ProductSpecsType', key?: string | null, value?: string | null }> | null } }> | null, specs?: Array<{ __typename?: 'ProductSpecsType', key?: string | null, value?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null }, product?: { __typename?: 'ProductType', id?: string | null, brand?: { __typename?: 'BrandType', id?: string | null, name?: string | null, website?: string | null } | null } | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null }> | null, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, createdAt: any, updatedAt: any, publicPrice?: any | null, publicPriceBeforeReduction?: any | null, prices?: Array<{ __typename?: 'BarcodePricesType', price?: any | null }> | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, productAttributes?: Array<{ __typename?: 'AttributeWithAttributeValueType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, productAttributesValues?: Array<{ __typename?: 'AttributeValueBaseType', id: string, label: string, price?: any | null, externalId: string, createdAt: any, updatedAt: any }> | null }> | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, price?: any | null, externalId: string, createdAt: any, updatedAt: any, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null }> | null } };

export type GetSimpleProductWithFavoriteStatusQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSimpleProductWithFavoriteStatusQuery = { __typename?: 'Query', getSimpleProductWithFavoriteStatus: { __typename?: 'InternalProductWithFavoriteStatusType', id?: string | null, name?: string | null, price?: any | null, description?: string | null, longdesc?: string | null, descriptionList?: Array<string> | null, isFavorite?: boolean | null, seo?: { __typename?: 'CatalogueCategorySeoType', urlKey?: string | null, metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'MetaKeywordsType', name?: string | null, content?: string | null }> | null } | null, specs?: Array<{ __typename?: 'ProductSpecsType', key?: string | null, value?: string | null }> | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null }, product?: { __typename?: 'ProductType', id?: string | null, brand?: { __typename?: 'BrandType', id?: string | null, name?: string | null, website?: string | null } | null } | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null }> | null, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, publicPrice?: any | null, publicPriceBeforeReduction?: any | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null, productAttributes?: Array<{ __typename?: 'AttributeWithAttributeValueType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, translation?: Array<{ __typename?: 'AttributeTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, createdAt: any, updatedAt: any }, content: { __typename?: 'AttributeTranslationContentType', label: string } }> | null, productAttributesValues?: Array<{ __typename?: 'AttributeValueBaseType', id: string, label: string, price?: any | null, externalId: string, createdAt: any, updatedAt: any, translation?: Array<{ __typename?: 'AttributeValueTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null }, content: { __typename?: 'AttributeValueTranslationContentType', label: string } }> | null }> | null }> | null }> | null } };

export type GetSimpleProductsByCatalogueCategoryWithFavoriteStatusQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  catalogueCategoryIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  status?: InputMaybe<Array<ProductStatusEnum> | ProductStatusEnum>;
}>;


export type GetSimpleProductsByCatalogueCategoryWithFavoriteStatusQuery = { __typename?: 'Query', getSimpleProductsByCatalogueCategoryWithFavoriteStatus: { __typename?: 'InternalProductWithFavoriteStatusPaginateType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'InternalProductWithFavoriteStatusType', id?: string | null, name?: string | null, price?: any | null, description?: string | null, isFavorite?: boolean | null, seo?: { __typename?: 'CatalogueCategorySeoType', urlKey?: string | null, metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'MetaKeywordsType', name?: string | null, content?: string | null }> | null } | null, specs?: Array<{ __typename?: 'ProductSpecsType', key?: string | null, value?: string | null }> | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null }, product?: { __typename?: 'ProductType', id?: string | null, brand?: { __typename?: 'BrandType', id?: string | null, name?: string | null, website?: string | null } | null } | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null }> | null, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, publicPrice?: any | null, publicPriceBeforeReduction?: any | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, productAttributes?: Array<{ __typename?: 'AttributeWithAttributeValueType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, pixel?: { __typename?: 'AttributePixelType', pixelAttribute?: string | null } | null, translation?: Array<{ __typename?: 'AttributeTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeTranslationContentType', label: string } }> | null, productAttributesValues?: Array<{ __typename?: 'AttributeValueBaseType', id: string, label: string, price?: any | null, externalId: string, createdAt: any, updatedAt: any, translation?: Array<{ __typename?: 'AttributeValueTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeValueTranslationContentType', label: string } }> | null }> | null }> | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, price?: any | null, externalId: string, createdAt: any, updatedAt: any, translation?: Array<{ __typename?: 'AttributeValueTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeValueTranslationContentType', label: string } }> | null, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, pixel?: { __typename?: 'AttributePixelType', pixelAttribute?: string | null } | null, translation?: Array<{ __typename?: 'AttributeTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeTranslationContentType', label: string } }> | null }, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } }> | null } | null }> | null }> } };

export type SearchInternalProductQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchInternalProductQuery = { __typename?: 'Query', searchInternalProduct: { __typename?: 'InternalProductPaginateType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'InternalProductType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, flags?: Array<ProductFlagEnum> | null, price?: any | null, status?: ProductStatusEnum | null, condition?: ProductConditionEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, classification?: Array<ProductClassEnum> | null, specs?: Array<{ __typename?: 'ProductSpecsType', key?: string | null, value?: string | null }> | null, brand?: { __typename?: 'BrandType', id?: string | null, name?: string | null, website?: string | null, createdAt: any, updatedAt: any, externalId?: string | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, seo?: { __typename?: 'CatalogueCategorySeoType', urlKey?: string | null, metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'MetaKeywordsType', name?: string | null, content?: string | null }> | null } | null, globalCategory?: { __typename?: 'GlobalCategoryProductType', googleCategory?: { __typename?: 'GlobalCategoryType', id: string, identifier: number, name: string, provider?: GlobalCategoryProviderEnum | null } | null, facebookCategory?: { __typename?: 'GlobalCategoryType', id: string, identifier: number, name: string, provider?: GlobalCategoryProviderEnum | null } | null } | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null }, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, condition?: ProductConditionEnum | null, status?: ProductStatusEnum | null, createdAt: any, updatedAt: any, prices?: Array<{ __typename?: 'BarcodePricesType', price?: any | null, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null } | null }> | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, priceCredit?: Array<{ __typename?: 'BarcodePeriodCreditType', periodCycle: RecurrenceType, periodValue: number, amount?: any | null }> | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number }> | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, externalId: string, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null }, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } }> | null } | null, internalProduct?: { __typename?: 'InternalProductType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, flags?: Array<ProductFlagEnum> | null, price?: any | null, status?: ProductStatusEnum | null, condition?: ProductConditionEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null }> | null } | null }> | null, product?: { __typename?: 'ProductType', id?: string | null, brand?: { __typename?: 'BrandType', id?: string | null, name?: string | null, website?: string | null } | null } | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number, icon?: string | null }> | null }> } };

export type GetInternalProductWithFilterQueryVariables = Exact<{
  searchString?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<InternalProductFilterInput>;
  sort?: InputMaybe<Array<ProductSortInput> | ProductSortInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetInternalProductWithFilterQuery = { __typename?: 'Query', getInternalProductWithFilter: { __typename?: 'InternalProductPaginateWithFilterType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'InternalProductType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, flags?: Array<ProductFlagEnum> | null, price?: any | null, status?: ProductStatusEnum | null, condition?: ProductConditionEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, priceBeforeReduction?: any | null, classification?: Array<ProductClassEnum> | null, specs?: Array<{ __typename?: 'ProductSpecsType', key?: string | null, value?: string | null }> | null, brand?: { __typename?: 'BrandType', id?: string | null, name?: string | null, website?: string | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, globalCategory?: { __typename?: 'GlobalCategoryProductType', googleCategory?: { __typename?: 'GlobalCategoryType', id: string, identifier: number, name: string, provider?: GlobalCategoryProviderEnum | null } | null, facebookCategory?: { __typename?: 'GlobalCategoryType', id: string, identifier: number, name: string, provider?: GlobalCategoryProviderEnum | null } | null } | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null }, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, condition?: ProductConditionEnum | null, status?: ProductStatusEnum | null, createdAt: any, updatedAt: any, prices?: Array<{ __typename?: 'BarcodePricesType', price?: any | null, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null } | null }> | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, priceCredit?: Array<{ __typename?: 'BarcodePeriodCreditType', periodCycle: RecurrenceType, periodValue: number, amount?: any | null }> | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number }> | null, pixel?: { __typename?: 'PixelBarcodeType', include?: boolean | null } | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, externalId: string, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null, internalProduct?: { __typename?: 'InternalProductType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, flags?: Array<ProductFlagEnum> | null, price?: any | null, status?: ProductStatusEnum | null, condition?: ProductConditionEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null }> | null, translation?: Array<{ __typename?: 'InternalProductTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'InternalProductTranslationContentType', name: string } }> | null } | null }> | null, product?: { __typename?: 'ProductType', id?: string | null, brand?: { __typename?: 'BrandType', id?: string | null, name?: string | null, website?: string | null } | null } | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number, icon?: string | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null }> | null }>, filter?: { __typename?: 'InternalProductFilterType', targets?: { __typename?: 'TargetsType', pos?: Array<{ __typename?: 'PointOfSaleType', id: string, name?: string | null }> | null, wholesaler?: Array<{ __typename?: 'WholesalerType', id: string, name?: string | null }> | null, manufacturer?: Array<{ __typename?: 'ManufacturerType', id: string, name?: string | null }> | null } | null, brands?: Array<{ __typename?: 'FilterNameFieldType', id: string, name?: string | null }> | null, priceRange?: { __typename?: 'PriceRangeType', min?: any | null, max?: any | null } | null, createdAtRange?: { __typename?: 'DateRangeType', min?: any | null, max?: any | null } | null, updatedAtRange?: { __typename?: 'DateRangeType', min?: any | null, max?: any | null } | null, catalogueCategories?: Array<{ __typename?: 'FilterNameFieldType', id: string, name?: string | null }> | null, productAttributesValues?: Array<{ __typename?: 'AttributeWithValueFilterType', id: string, label?: string | null, attributeValues?: Array<{ __typename?: 'FilterLabelFieldType', id: string, label?: string | null }> | null }> | null } | null } };

export type GetSimpleProductsWithRatingsWithFavoriteStatusWithFilterQueryVariables = Exact<{
  input: GetInternalProductWithFilterPaginatedInput;
}>;


export type GetSimpleProductsWithRatingsWithFavoriteStatusWithFilterQuery = { __typename?: 'Query', getSimpleProductsWithRatingsWithFavoriteStatusWithFilter: { __typename?: 'InternalProductWithRatingsPaginateWithFavoriteStatusWithFilterType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'InternalProductWithRatingsWithFavoriteStatusType', id?: string | null, url?: string | null, sku?: string | null, name?: string | null, price?: any | null, flags?: Array<ProductFlagEnum> | null, status?: ProductStatusEnum | null, condition?: ProductConditionEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, classification?: Array<ProductClassEnum> | null, ratings?: any | null, isFavorite?: boolean | null, specs?: Array<{ __typename?: 'ProductSpecsType', key?: string | null, value?: string | null }> | null, seo?: { __typename?: 'CatalogueCategorySeoType', urlKey?: string | null, metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'MetaKeywordsType', name?: string | null, content?: string | null }> | null } | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null }> | null, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, publicPrice?: any | null, publicPriceBeforeReduction?: any | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, media?: { __typename?: 'MediaType', pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, productAttributes?: Array<{ __typename?: 'AttributeWithAttributeValueType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, pixel?: { __typename?: 'AttributePixelType', pixelAttribute?: string | null } | null, translation?: Array<{ __typename?: 'AttributeTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeTranslationContentType', label: string } }> | null, productAttributesValues?: Array<{ __typename?: 'AttributeValueBaseType', id: string, label: string, price?: any | null, externalId: string, createdAt: any, updatedAt: any, translation?: Array<{ __typename?: 'AttributeValueTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeValueTranslationContentType', label: string } }> | null }> | null }> | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, price?: any | null, externalId: string, createdAt: any, updatedAt: any, translation?: Array<{ __typename?: 'AttributeValueTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeValueTranslationContentType', label: string } }> | null, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, pixel?: { __typename?: 'AttributePixelType', pixelAttribute?: string | null } | null, translation?: Array<{ __typename?: 'AttributeTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeTranslationContentType', label: string } }> | null }, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } }> | null } | null }> | null }>, filter?: { __typename?: 'InternalProductFilterType', targets?: { __typename?: 'TargetsType', pos?: Array<{ __typename?: 'PointOfSaleType', id: string, name?: string | null }> | null, wholesaler?: Array<{ __typename?: 'WholesalerType', id: string, name?: string | null }> | null, manufacturer?: Array<{ __typename?: 'ManufacturerType', id: string, name?: string | null }> | null } | null, brands?: Array<{ __typename?: 'FilterNameFieldType', id: string, name?: string | null }> | null, priceRange?: { __typename?: 'PriceRangeType', min?: any | null, max?: any | null } | null, createdAtRange?: { __typename?: 'DateRangeType', min?: any | null, max?: any | null } | null, updatedAtRange?: { __typename?: 'DateRangeType', min?: any | null, max?: any | null } | null, catalogueCategories?: Array<{ __typename?: 'FilterNameFieldType', id: string, name?: string | null }> | null, productAttributesValues?: Array<{ __typename?: 'AttributeWithValueFilterType', id: string, label?: string | null, attributeValues?: Array<{ __typename?: 'FilterLabelFieldType', id: string, label?: string | null }> | null }> | null } | null } };

export type GetInternalProductsByClassQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  classification: Array<ProductClassEnum> | ProductClassEnum;
  target: TargetAciInput;
}>;


export type GetInternalProductsByClassQuery = { __typename?: 'Query', getInternalProductsByClass: { __typename?: 'InternalProductPaginateType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'InternalProductType', id?: string | null, url?: string | null, name?: string | null, flags?: Array<ProductFlagEnum> | null, status?: ProductStatusEnum | null, createdAt: any, updatedAt: any, description?: string | null, brand?: { __typename?: 'BrandType', id?: string | null, name?: string | null } | null, media?: { __typename?: 'MediaType', pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, publicPrice?: any | null, publicPriceBeforeReduction?: any | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, productAttributes?: Array<{ __typename?: 'AttributeWithAttributeValueType', id: string, label: string, isRequired?: boolean | null, isMultipleChoice?: boolean | null, productAttributesValues?: Array<{ __typename?: 'AttributeValueBaseType', id: string, label: string, price?: any | null }> | null }> | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, price?: any | null, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, pixel?: { __typename?: 'AttributePixelType', pixelAttribute?: string | null } | null, translation?: Array<{ __typename?: 'AttributeTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeTranslationContentType', label: string } }> | null } }> | null } | null }> | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number }> | null }> } };

export type GetSimpleProductsByTargetGroupedByClassWithFavoriteStatusQueryVariables = Exact<{
  target: TargetAciInput;
  status?: InputMaybe<Array<ProductStatusEnum> | ProductStatusEnum>;
}>;


export type GetSimpleProductsByTargetGroupedByClassWithFavoriteStatusQuery = { __typename?: 'Query', getSimpleProductsByTargetGroupedByClassWithFavoriteStatus: { __typename?: 'InternalProductByClassTypeWithFavoriteStatus', PROMO?: Array<{ __typename?: 'InternalProductWithoutClassWithFavoriteStatusType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, flags?: Array<ProductFlagEnum> | null, price?: any | null, status?: ProductStatusEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, priceBeforeReduction?: any | null, ratings?: any | null, isFavorite?: boolean | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, publicPrice?: any | null, publicPriceBeforeReduction?: any | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, productAttributes?: Array<{ __typename?: 'AttributeWithAttributeValueType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, productAttributesValues?: Array<{ __typename?: 'AttributeValueBaseType', id: string, label: string, price?: any | null, externalId: string, createdAt: any, updatedAt: any }> | null }> | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, price?: any | null, externalId: string, createdAt: any, updatedAt: any, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null }> | null }> | null, BEST_SELLERS?: Array<{ __typename?: 'InternalProductWithoutClassWithFavoriteStatusType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, flags?: Array<ProductFlagEnum> | null, price?: any | null, status?: ProductStatusEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, priceBeforeReduction?: any | null, ratings?: any | null, isFavorite?: boolean | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, publicPrice?: any | null, publicPriceBeforeReduction?: any | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, productAttributes?: Array<{ __typename?: 'AttributeWithAttributeValueType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, productAttributesValues?: Array<{ __typename?: 'AttributeValueBaseType', id: string, label: string, price?: any | null, externalId: string, createdAt: any, updatedAt: any }> | null }> | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, price?: any | null, externalId: string, createdAt: any, updatedAt: any, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null }> | null }> | null, NEW_ARRIVALS?: Array<{ __typename?: 'InternalProductWithoutClassWithFavoriteStatusType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, flags?: Array<ProductFlagEnum> | null, price?: any | null, status?: ProductStatusEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, priceBeforeReduction?: any | null, ratings?: any | null, isFavorite?: boolean | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, publicPrice?: any | null, publicPriceBeforeReduction?: any | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, productAttributes?: Array<{ __typename?: 'AttributeWithAttributeValueType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, productAttributesValues?: Array<{ __typename?: 'AttributeValueBaseType', id: string, label: string, price?: any | null, externalId: string, createdAt: any, updatedAt: any }> | null }> | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, price?: any | null, externalId: string, createdAt: any, updatedAt: any, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null }> | null }> | null, TOP_PRODUCTS?: Array<{ __typename?: 'InternalProductWithoutClassWithFavoriteStatusType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, flags?: Array<ProductFlagEnum> | null, price?: any | null, status?: ProductStatusEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, priceBeforeReduction?: any | null, ratings?: any | null, isFavorite?: boolean | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, publicPrice?: any | null, publicPriceBeforeReduction?: any | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, productAttributes?: Array<{ __typename?: 'AttributeWithAttributeValueType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, productAttributesValues?: Array<{ __typename?: 'AttributeValueBaseType', id: string, label: string, price?: any | null, externalId: string, createdAt: any, updatedAt: any }> | null }> | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, price?: any | null, externalId: string, createdAt: any, updatedAt: any, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null }> | null }> | null, FEATURED_PRODUCTS?: Array<{ __typename?: 'InternalProductWithoutClassWithFavoriteStatusType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, flags?: Array<ProductFlagEnum> | null, price?: any | null, status?: ProductStatusEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, priceBeforeReduction?: any | null, ratings?: any | null, isFavorite?: boolean | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, publicPrice?: any | null, publicPriceBeforeReduction?: any | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, productAttributes?: Array<{ __typename?: 'AttributeWithAttributeValueType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, productAttributesValues?: Array<{ __typename?: 'AttributeValueBaseType', id: string, label: string, price?: any | null, externalId: string, createdAt: any, updatedAt: any }> | null }> | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, price?: any | null, externalId: string, createdAt: any, updatedAt: any, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null }> | null }> | null } };

export type GetSimpleProductsByTargetAndCatalogueCategoryUrlKeyWithFavoriteStatusQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
  target: TargetAciInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetSimpleProductsByTargetAndCatalogueCategoryUrlKeyWithFavoriteStatusQuery = { __typename?: 'Query', getSimpleProductsByTargetAndCatalogueCategoryUrlKeyWithFavoriteStatus: { __typename?: 'InternalProductWithFavoriteStatusPaginateType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'InternalProductWithFavoriteStatusType', id?: string | null, name?: string | null, price?: any | null, flags?: Array<ProductFlagEnum> | null, description?: string | null, isFavorite?: boolean | null, seo?: { __typename?: 'CatalogueCategorySeoType', urlKey?: string | null, metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'MetaKeywordsType', name?: string | null, content?: string | null }> | null } | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null }, product?: { __typename?: 'ProductType', id?: string | null, brand?: { __typename?: 'BrandType', id?: string | null, name?: string | null, website?: string | null } | null } | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null }> | null, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, publicPrice?: any | null, publicPriceBeforeReduction?: any | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null }> | null }> } };

export type GetSimpleProductWithFavoriteStatusByUrlKeyQueryVariables = Exact<{
  target: TargetAciInput;
  urlKey: Scalars['String']['input'];
}>;


export type GetSimpleProductWithFavoriteStatusByUrlKeyQuery = { __typename?: 'Query', getSimpleProductWithFavoriteStatusByUrlKey: { __typename?: 'InternalProductWithFavoriteStatusType', id?: string | null, name?: string | null, price?: any | null, flags?: Array<ProductFlagEnum> | null, description?: string | null, longdesc?: string | null, descriptionList?: Array<string> | null, isFavorite?: boolean | null, seo?: { __typename?: 'CatalogueCategorySeoType', urlKey?: string | null, metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'MetaKeywordsType', name?: string | null, content?: string | null }> | null } | null, specs?: Array<{ __typename?: 'ProductSpecsType', key?: string | null, value?: string | null }> | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null }, product?: { __typename?: 'ProductType', id?: string | null, brand?: { __typename?: 'BrandType', id?: string | null, name?: string | null, website?: string | null } | null } | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number, seo?: { __typename?: 'CatalogueCategorySeoType', urlKey?: string | null, metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'MetaKeywordsType', name?: string | null, content?: string | null }> | null } | null }> | null, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, publicPrice?: any | null, publicPriceBeforeReduction?: any | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null, productAttributes?: Array<{ __typename?: 'AttributeWithAttributeValueType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, translation?: Array<{ __typename?: 'AttributeTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, createdAt: any, updatedAt: any }, content: { __typename?: 'AttributeTranslationContentType', label: string } }> | null, productAttributesValues?: Array<{ __typename?: 'AttributeValueBaseType', id: string, label: string, price?: any | null, externalId: string, createdAt: any, updatedAt: any, translation?: Array<{ __typename?: 'AttributeValueTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null }, content: { __typename?: 'AttributeValueTranslationContentType', label: string } }> | null }> | null }> | null }> | null } };

export type GetBarcodeByProductAndAttributesCacheQueryVariables = Exact<{
  input: BarcodeFindInput;
}>;


export type GetBarcodeByProductAndAttributesCacheQuery = { __typename?: 'Query', getBarcodeByProductAndAttributesCache: { __typename?: 'BarcodeType', id: string, name?: string | null, price?: any | null, barcode: string, condition?: ProductConditionEnum | null, status?: ProductStatusEnum | null, createdAt: any, updatedAt: any, prices?: Array<{ __typename?: 'BarcodePricesType', price?: any | null, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null } | null }> | null, media?: { __typename?: 'MediaType', pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, priceList?: Array<{ __typename?: 'ProductPriceListType', value?: any | null, price?: { __typename?: 'PriceType', id: string, label?: string | null } | null }> | null, taxes?: Array<{ __typename?: 'ProductTaxesType', rank?: number | null, tax?: { __typename?: 'TaxType', id: string, label?: string | null, externalId?: string | null, use?: Array<TaxUseEnum> | null, product?: boolean | null, createdAt: any, updatedAt: any, value?: { __typename?: 'TaxVaType', sign: TaxSignEnum, value?: any | null, type: DiscountType } | null, company?: { __typename?: 'CompanyType', id: string, name?: string | null } | null } | null }> | null, priceCredit?: Array<{ __typename?: 'BarcodePeriodCreditType', periodCycle: RecurrenceType, periodValue: number, amount?: any | null }> | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number }> | null, pixel?: { __typename?: 'PixelBarcodeType', include?: boolean | null } | null, supplier?: { __typename?: 'CompanyType', id: string, name?: string | null, description?: string | null, media?: { __typename?: 'MediaType', pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null } | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, externalId: string, createdAt: any, updatedAt: any, translation?: Array<{ __typename?: 'AttributeValueTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeValueTranslationContentType', label: string } }> | null, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, pixel?: { __typename?: 'AttributePixelType', pixelAttribute?: string | null } | null, translation?: Array<{ __typename?: 'AttributeTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeTranslationContentType', label: string } }> | null }, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } }> | null } | null, productAttributes?: Array<{ __typename?: 'AttributeWithAttributeValueType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, productAttributesValues?: Array<{ __typename?: 'AttributeValueBaseType', id: string, label: string }> | null }> | null, internalProduct?: { __typename?: 'InternalProductType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, price?: any | null, status?: ProductStatusEnum | null, condition?: ProductConditionEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, descriptionList?: Array<string> | null, priceBeforeReduction?: any | null, media?: { __typename?: 'MediaType', pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null }> | null } | null } };

export type GetProductBarcodesCacheQueryVariables = Exact<{
  productId: Scalars['String']['input'];
}>;


export type GetProductBarcodesCacheQuery = { __typename?: 'Query', getProductBarcodesCache: Array<{ __typename?: 'BarcodeType', id: string, name?: string | null, price?: any | null, barcode: string, condition?: ProductConditionEnum | null, status?: ProductStatusEnum | null, createdAt: any, updatedAt: any, prices?: Array<{ __typename?: 'BarcodePricesType', price?: any | null, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null }> | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, priceList?: Array<{ __typename?: 'ProductPriceListType', value?: any | null, price?: { __typename?: 'PriceType', id: string, label?: string | null } | null }> | null, taxes?: Array<{ __typename?: 'ProductTaxesType', rank?: number | null, tax?: { __typename?: 'TaxType', id: string, label?: string | null, externalId?: string | null, use?: Array<TaxUseEnum> | null, product?: boolean | null, createdAt: any, updatedAt: any, value?: { __typename?: 'TaxVaType', sign: TaxSignEnum, value?: any | null, type: DiscountType } | null, company?: { __typename?: 'CompanyType', id: string, name?: string | null } | null } | null }> | null, priceCredit?: Array<{ __typename?: 'BarcodePeriodCreditType', periodCycle: RecurrenceType, periodValue: number, amount?: any | null }> | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number }> | null, pixel?: { __typename?: 'PixelBarcodeType', include?: boolean | null } | null, translation?: Array<{ __typename?: 'BarcodeTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'BarcodeTranslationContentType', name: string } }> | null, productAttributes?: Array<{ __typename?: 'AttributeWithAttributeValueType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, pixel?: { __typename?: 'AttributePixelType', pixelAttribute?: string | null } | null, translation?: Array<{ __typename?: 'AttributeTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeTranslationContentType', label: string } }> | null, productAttributesValues?: Array<{ __typename?: 'AttributeValueBaseType', id: string, label: string, price?: any | null, externalId: string, createdAt: any, updatedAt: any, translation?: Array<{ __typename?: 'AttributeValueTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeValueTranslationContentType', label: string } }> | null }> | null }> | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, price?: any | null, externalId: string, createdAt: any, updatedAt: any, translation?: Array<{ __typename?: 'AttributeValueTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeValueTranslationContentType', label: string } }> | null, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, pixel?: { __typename?: 'AttributePixelType', pixelAttribute?: string | null } | null, translation?: Array<{ __typename?: 'AttributeTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeTranslationContentType', label: string } }> | null }, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } }> | null } | null, internalProduct?: { __typename?: 'InternalProductType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, price?: any | null, status?: ProductStatusEnum | null, condition?: ProductConditionEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, descriptionList?: Array<string> | null, priceBeforeReduction?: any | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null }> | null, translation?: Array<{ __typename?: 'InternalProductTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'InternalProductTranslationContentType', name: string } }> | null } | null }> };

export type GetProductAttributesCacheQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductAttributesCacheQuery = { __typename?: 'Query', getProductAttributesCache: Array<{ __typename?: 'ProductAttributeType', id: string, createdAt: any, updatedAt: any, reference: string, isRequired: boolean, possibleValues: Array<string>, isMultipleChoice: boolean, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, pixel?: { __typename?: 'AttributePixelType', pixelAttribute?: string | null } | null, translation?: Array<{ __typename?: 'AttributeTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeTranslationContentType', label: string } }> | null, target?: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } | null }, target?: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } | null }> };

export type CreateJobApplicationMutationVariables = Exact<{
  input: JobApplicationInput;
}>;


export type CreateJobApplicationMutation = { __typename?: 'Mutation', createJobApplication: { __typename?: 'JobApplicationType', id: string, firstName: string, lastName: string, email: string, message: string, status: JobApplicationStatusEnum, createdAt: any, updatedAt: any, cv?: { __typename?: 'DocumentType', id: string, name: string, size?: number | null, createdAt: any, updatedAt: any, content?: { __typename?: 'DocumentContentType', url?: string | null, type?: { __typename?: 'ContentTypeType', id: string, name: string, type?: string | null, image?: { __typename?: 'ContentTypeImageType', icon?: string | null, background?: { __typename?: 'ContentTypeImageFormatType', png?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, svg?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, black?: { __typename?: 'ContentTypeImageFormatType', png?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, svg?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, white?: { __typename?: 'ContentTypeImageFormatType', png?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, svg?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null } | null } | null } | null } | null, cover?: { __typename?: 'DocumentType', id: string, name: string, size?: number | null, createdAt: any, updatedAt: any, content?: { __typename?: 'DocumentContentType', url?: string | null, type?: { __typename?: 'ContentTypeType', id: string, name: string, type?: string | null, image?: { __typename?: 'ContentTypeImageType', icon?: string | null, background?: { __typename?: 'ContentTypeImageFormatType', png?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, svg?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, black?: { __typename?: 'ContentTypeImageFormatType', png?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, svg?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, white?: { __typename?: 'ContentTypeImageFormatType', png?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, svg?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null } | null } | null } | null } | null, jobDefinition: { __typename?: 'JobDefinitionType', id: string, title: string } } };

export type GetJobDefinitionsByTargetAndStatusPaginationQueryVariables = Exact<{
  target: TargetAciInput;
  status: JobDefinitionStatusEnum;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetJobDefinitionsByTargetAndStatusPaginationQuery = { __typename?: 'Query', getJobDefinitionsByTargetAndStatusPagination: { __typename?: 'JobDefinitionPaginatedType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'JobDefinitionType', id: string, title: string, status: JobDefinitionStatusEnum, createdAt: any, updatedAt: any, department: { __typename?: 'DepartmentType', id: string, name: string, createdAt: any, updatedAt: any, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } }, specs?: Array<{ __typename?: 'JobSpecsType', key?: JobDefinitionSpecEnum | null, value?: string | null }> | null, description?: { __typename?: 'JobDescriptionType', description?: string | null, descriptionList?: Array<string> | null } | null, responsibility?: { __typename?: 'JobDescriptionType', description?: string | null, descriptionList?: Array<string> | null } | null, offer?: { __typename?: 'JobDescriptionType', description?: string | null, descriptionList?: Array<string> | null } | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } }> } };

export type JobDefinitionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type JobDefinitionQuery = { __typename?: 'Query', jobDefinition: { __typename?: 'JobDefinitionType', id: string, title: string, status: JobDefinitionStatusEnum, createdAt: any, updatedAt: any, department: { __typename?: 'DepartmentType', id: string, name: string, createdAt: any, updatedAt: any, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } }, specs?: Array<{ __typename?: 'JobSpecsType', key?: JobDefinitionSpecEnum | null, value?: string | null }> | null, description?: { __typename?: 'JobDescriptionType', description?: string | null, descriptionList?: Array<string> | null } | null, responsibility?: { __typename?: 'JobDescriptionType', description?: string | null, descriptionList?: Array<string> | null } | null, offer?: { __typename?: 'JobDescriptionType', description?: string | null, descriptionList?: Array<string> | null } | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } } };

export type FindLandingPagesByUrlQueryVariables = Exact<{
  url: Scalars['String']['input'];
  target: TargetAciInput;
}>;


export type FindLandingPagesByUrlQuery = { __typename?: 'Query', findLandingPagesByUrl: { __typename?: 'LandingPagesType', id: string, url?: string | null, tags?: Array<string> | null, pageTitle: string, pageReference: string, pageDescription?: string | null, status: VisibilityStatusEnum, pageType: LandingPageTypeEnum, createdAt: any, updatedAt: any, seo?: { __typename?: 'SeoComponentType', metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'TagType', name?: string | null, content?: string | null }> | null } | null, sectionData?: Array<{ __typename?: 'LandingPagesDataType', sectionTitle?: string | null, sectionContent?: string | null, sectionReference?: string | null, sectionPictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null }> | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } } };

export type FindLandingPagesByTargetAndTypePaginatedQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  pageType: Array<LandingPageTypeEnum> | LandingPageTypeEnum;
  target: TargetAciInput;
  language?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindLandingPagesByTargetAndTypePaginatedQuery = { __typename?: 'Query', findLandingPagesByTargetAndTypePaginated: { __typename?: 'PaginatedLandingPagesWithoutTranslationType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'LandingPagesWithoutTranslationType', id: string, url?: string | null, tags?: Array<string> | null, pageTitle: string, pageReference: string, pageDescription?: string | null, status: VisibilityStatusEnum, pageType: LandingPageTypeEnum, createdAt: any, updatedAt: any, seo?: { __typename?: 'SeoComponentType', metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'TagType', name?: string | null, content?: string | null }> | null } | null, sectionData?: Array<{ __typename?: 'LandingPagesDataType', sectionTitle?: string | null, sectionContent?: string | null, sectionReference?: string | null, sectionPictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null }> | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } }> } };

export type AddUserToNewsLetterMutationVariables = Exact<{
  email: Scalars['String']['input'];
  target: TargetAciInput;
}>;


export type AddUserToNewsLetterMutation = { __typename?: 'Mutation', addUserToNewsLetter: { __typename?: 'NewsletterType', id: string, email: string, createdAt: any, updatedAt: any, user?: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } } };

export type GetOrderSettingsByTargetCacheQueryVariables = Exact<{
  target: TargetAciInput;
}>;


export type GetOrderSettingsByTargetCacheQuery = { __typename?: 'Query', getOrderSettingsByTargetCache: { __typename?: 'OrderSettingsFullType', id: string, pickup?: boolean | null, delivery?: boolean | null, mobilePickup?: boolean | null, portalPickup?: boolean | null, facebookPickup?: boolean | null, mobileDelivery?: boolean | null, portalDelivery?: boolean | null, showMenuInPortal?: boolean | null, facebookDelivery?: boolean | null, createdAt: any, updatedAt: any, pickupTime?: { __typename?: 'MilitaryTimeFromToType', from?: string | null, to?: string | null } | null, deliveryTime?: { __typename?: 'MilitaryTimeFromToType', from?: string | null, to?: string | null } | null, nonPickupDays?: Array<{ __typename?: 'MonthDaysType', month: number, days?: Array<number> | null }> | null, nonDeliveryDays?: Array<{ __typename?: 'MonthDaysType', month: number, days?: Array<number> | null }> | null, deliveryCountries?: Array<{ __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null }> | null, deliveryStates?: Array<{ __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, country?: { __typename?: 'CountryType', id: string } | null }> | null, extraFees?: Array<{ __typename?: 'OrderSettingsExtraFeesType', key?: string | null, value?: any | null }> | null, emails?: Array<{ __typename?: 'OrderSettingsEmailsType', definition?: OrderEmailActionEnum | null, enabled?: boolean | null }> | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } } };

export type PointOfSaleCacheQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PointOfSaleCacheQuery = { __typename?: 'Query', pointOfSaleCache: { __typename?: 'PointOfSaleType', id: string, tags?: Array<string> | null, name?: string | null, title?: string | null, email?: Array<string> | null, phone?: Array<string> | null, website?: string | null, subtitle?: string | null, turnover?: any | null, reference?: string | null, published?: boolean | null, createdAt: any, updatedAt: any, brandColor?: string | null, isFollowed?: boolean | null, description?: string | null, contactEmails?: Array<string> | null, averageCustomers?: number | null, currencies?: Array<{ __typename?: 'TargetCurrencyType', default?: boolean | null, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null }> | null, languages?: Array<{ __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }> | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, outsidePictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, insidePictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, openingHours?: { __typename?: 'OpeningHoursType', status?: OpeningStatus | null, hours?: Array<{ __typename?: 'OpeningHoursDayType', day?: DayEnum | null, from?: string | null, to?: string | null }> | null } | null, specialOffers?: Array<{ __typename?: 'SpecialOfferType', offerType?: SpecialOffersType | null, hours?: Array<{ __typename?: 'OpeningHoursDayType', day?: DayEnum | null, from?: string | null, to?: string | null }> | null }> | null, locations?: Array<{ __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null }> | null, chatContact?: Array<{ __typename?: 'SocialValueType', value?: string | null, name?: { __typename?: 'SocialType', id: string, name: string, code?: string | null, fontIcon?: string | null, createdAt: any, updatedAt: any, images?: Array<{ __typename?: 'SocialImagesType', style: SocialImageStyleEnum, images?: Array<{ __typename?: 'SocialImagesImagesType', svg?: { __typename?: 'SocialImagesImagesSetType', size48?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size96?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size144?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size240?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size480?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null }> | null }> | null } | null }> | null, socialMedia?: Array<{ __typename?: 'SocialValueType', value?: string | null, name?: { __typename?: 'SocialType', id: string, name: string, code?: string | null, fontIcon?: string | null, createdAt: any, updatedAt: any, images?: Array<{ __typename?: 'SocialImagesType', style: SocialImageStyleEnum, images?: Array<{ __typename?: 'SocialImagesImagesType', svg?: { __typename?: 'SocialImagesImagesSetType', size48?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size96?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size144?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size240?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size480?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null }> | null }> | null } | null }> | null, company?: { __typename?: 'CompanyType', id: string, name?: string | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentType', id: string, name: string, code?: string | null, paymentType?: PaymentTypeEnum | null, materialIcon?: string | null, createdAt: any, updatedAt: any, images?: { __typename?: 'PaymentImagesType', svg?: { __typename?: 'PaymentImagesSvgType', alt?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, card_flat?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, dark?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flat?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, light?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, default?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null } | null }> | null } };

export type GetProgramsByEventPaginationQueryVariables = Exact<{
  event: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetProgramsByEventPaginationQuery = { __typename?: 'Query', getProgramsByEventPagination: { __typename?: 'ProgramPaginateType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'ProgramType', id: string, from?: any | null, to?: any | null, title?: string | null, description?: string | null, createdAt: any, updatedAt: any, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, booking?: { __typename?: 'ProgramBookingType', status?: EventProgramStatusEnum | null, capacity?: number | null } | null, address?: { __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null } | null, event?: { __typename?: 'EventType', id: string, code?: string | null, title?: string | null, description?: string | null, date?: any | null, createdAt: any, updatedAt: any, duration?: { __typename?: 'EventDurationType', amount?: number | null, unit?: PeriodCycleEnum | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, target?: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } | null } | null }> } };

export type GetSimpleOngoingPromotionsByTargetPaginateQueryVariables = Exact<{
  target: TargetAciInput;
  filter?: InputMaybe<PromotionFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetSimpleOngoingPromotionsByTargetPaginateQuery = { __typename?: 'Query', getSimpleOngoingPromotionsByTargetPaginate: { __typename?: 'PromotionPaginateType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'PromotionType', id: string, status: PromotionStatusEnum, endDate: any, startDate: any, createdAt: any, updatedAt: any, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null }, promotion: Array<{ __typename?: 'PromotionProductsType', discount: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null }, barcode: { __typename?: 'BarcodeType', id: string, name?: string | null, price?: any | null, barcode: string, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, internalProduct?: { __typename?: 'InternalProductType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, flags?: Array<ProductFlagEnum> | null, price?: any | null, status?: ProductStatusEnum | null, condition?: ProductConditionEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, priceBeforeReduction?: any | null, classification?: Array<ProductClassEnum> | null, brand?: { __typename?: 'BrandType', id?: string | null, name?: string | null, website?: string | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null }, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, condition?: ProductConditionEnum | null, status?: ProductStatusEnum | null, createdAt: any, updatedAt: any, prices?: Array<{ __typename?: 'BarcodePricesType', price?: any | null, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null } | null }> | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, priceCredit?: Array<{ __typename?: 'BarcodePeriodCreditType', periodCycle: RecurrenceType, periodValue: number, amount?: any | null }> | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number }> | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null, internalProduct?: { __typename?: 'InternalProductType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, flags?: Array<ProductFlagEnum> | null, price?: any | null, status?: ProductStatusEnum | null, condition?: ProductConditionEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null }> | null } | null }> | null, product?: { __typename?: 'ProductType', id?: string | null, brand?: { __typename?: 'BrandType', id?: string | null, name?: string | null, website?: string | null } | null } | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number, icon?: string | null }> | null } | null } }> }> } };

export type GetRecentlyViewedProductsByUserPaginatedQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetRecentlyViewedProductsByUserPaginatedQuery = { __typename?: 'Query', getRecentlyViewedProductsByUserPaginated: { __typename?: 'RecentlyViewedInternalProductWithFavoriteStatusPaginateType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'RecentlyViewedInternalProductWithFavoriteStatusType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, flags?: Array<ProductFlagEnum> | null, price?: any | null, status?: ProductStatusEnum | null, condition?: ProductConditionEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, priceBeforeReduction?: any | null, classification?: Array<ProductClassEnum> | null, specs?: Array<{ __typename?: 'ProductSpecsType', key?: string | null, value?: string | null }> | null, brand?: { __typename?: 'BrandType', id?: string | null, name?: string | null, website?: string | null, createdAt: any, updatedAt: any, externalId?: string | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null }, barcodes?: Array<{ __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, condition?: ProductConditionEnum | null, status?: ProductStatusEnum | null, createdAt: any, updatedAt: any, prices?: Array<{ __typename?: 'BarcodePricesType', price?: any | null, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null } | null }> | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, priceCredit?: Array<{ __typename?: 'BarcodePeriodCreditType', periodCycle: RecurrenceType, periodValue: number, amount?: any | null }> | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number }> | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, externalId: string, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null, internalProduct?: { __typename?: 'InternalProductType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, flags?: Array<ProductFlagEnum> | null, price?: any | null, status?: ProductStatusEnum | null, condition?: ProductConditionEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null }> | null } | null }> | null, product?: { __typename?: 'ProductType', id?: string | null, brand?: { __typename?: 'BrandType', id?: string | null, name?: string | null, website?: string | null } | null } | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number, icon?: string | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null }> | null }> } };

export type CreateRecentlyViewedMutationVariables = Exact<{
  product: Scalars['ID']['input'];
}>;


export type CreateRecentlyViewedMutation = { __typename?: 'Mutation', createRecentlyViewed: { __typename?: 'SuccessResponseDtoType', success: boolean, message: string } };

export type CreateRequestMutationVariables = Exact<{
  input: RequestInput;
}>;


export type CreateRequestMutation = { __typename?: 'Mutation', createRequest: { __typename?: 'RequestType', id: string, type?: RequestTypeEnum | null, status?: RequestStatusEnum | null, createdAt: any, updatedAt: any, requestor?: { __typename?: 'RequestRequestorType', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: { __typename?: 'IPhoneType', number?: string | null, countryCode?: string | null } | null } | null, company?: { __typename?: 'RequestCompanyType', name?: string | null, vatId?: string | null, registerNo?: string | null, licenceNo?: string | null, website?: string | null, email?: string | null, address?: { __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null } | null, phone?: { __typename?: 'IPhoneType', number?: string | null, countryCode?: string | null } | null } | null, data?: Array<{ __typename?: 'RequestKeyValueType', key: string, value: string }> | null, request?: { __typename?: 'RequestRequestType', subject?: string | null, content?: string | null } | null, target?: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } | null } };

export type FindSeoByTargetCacheQueryVariables = Exact<{
  target: TargetAciInput;
}>;


export type FindSeoByTargetCacheQuery = { __typename?: 'Query', findSEOByTargetCache: { __typename?: 'SEOType', id: string, titleTag?: string | null, googleAnalyticsId?: string | null, metaDescriptionTag?: string | null, createdAt: any, updatedAt: any, headerTags?: Array<{ __typename?: 'TagType', name?: string | null, content?: string | null }> | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } } };

export type GetBlogSeojsonQueryVariables = Exact<{
  blogId: Scalars['ID']['input'];
}>;


export type GetBlogSeojsonQuery = { __typename?: 'Query', getBlogSEOJSON: { __typename?: 'ContentJSONType', title?: string | null, description?: string | null, metas?: Array<{ __typename?: 'MetaItemType', name?: string | null, content?: string | null, property?: string | null }> | null, links?: Array<{ __typename?: 'LinkItemType', rel?: string | null, href?: string | null, type?: string | null, sizes?: string | null }> | null, scripts?: Array<{ __typename?: 'ScriptItemType', type?: string | null, content?: string | null }> | null } };

export type GetGeneralSeojsonQueryVariables = Exact<{
  target: TargetAciInput;
}>;


export type GetGeneralSeojsonQuery = { __typename?: 'Query', getGeneralSEOJSON: { __typename?: 'ContentJSONType', title?: string | null, description?: string | null, metas?: Array<{ __typename?: 'MetaItemType', name?: string | null, content?: string | null, property?: string | null }> | null, links?: Array<{ __typename?: 'LinkItemType', rel?: string | null, href?: string | null, type?: string | null, sizes?: string | null }> | null, scripts?: Array<{ __typename?: 'ScriptItemType', type?: string | null, content?: string | null }> | null } };

export type GetMainCategorySeojsonQueryVariables = Exact<{
  categoryId: Scalars['ID']['input'];
}>;


export type GetMainCategorySeojsonQuery = { __typename?: 'Query', getMainCategorySEOJSON: { __typename?: 'ContentJSONType', title?: string | null, description?: string | null, metas?: Array<{ __typename?: 'MetaItemType', name?: string | null, content?: string | null, property?: string | null }> | null, links?: Array<{ __typename?: 'LinkItemType', rel?: string | null, href?: string | null, type?: string | null, sizes?: string | null }> | null, scripts?: Array<{ __typename?: 'ScriptItemType', type?: string | null, content?: string | null }> | null } };

export type GetMainPageSeojsonQueryVariables = Exact<{
  target: TargetAciInput;
}>;


export type GetMainPageSeojsonQuery = { __typename?: 'Query', getMainPageSEOJSON: { __typename?: 'ContentJSONType', title?: string | null, description?: string | null, metas?: Array<{ __typename?: 'MetaItemType', name?: string | null, content?: string | null, property?: string | null }> | null, links?: Array<{ __typename?: 'LinkItemType', rel?: string | null, href?: string | null, type?: string | null, sizes?: string | null }> | null, scripts?: Array<{ __typename?: 'ScriptItemType', type?: string | null, content?: string | null }> | null } };

export type GetPagesSeojsonQueryVariables = Exact<{
  pageId: Scalars['ID']['input'];
}>;


export type GetPagesSeojsonQuery = { __typename?: 'Query', getPagesSEOJSON: { __typename?: 'ContentJSONType', title?: string | null, description?: string | null, metas?: Array<{ __typename?: 'MetaItemType', name?: string | null, content?: string | null, property?: string | null }> | null, links?: Array<{ __typename?: 'LinkItemType', rel?: string | null, href?: string | null, type?: string | null, sizes?: string | null }> | null, scripts?: Array<{ __typename?: 'ScriptItemType', type?: string | null, content?: string | null }> | null } };

export type GetSimpleProductSeojsonQueryVariables = Exact<{
  barcodeId: Scalars['ID']['input'];
  target: TargetAciInput;
}>;


export type GetSimpleProductSeojsonQuery = { __typename?: 'Query', getSimpleProductSEOJSON: { __typename?: 'ContentJSONType', title?: string | null, description?: string | null, metas?: Array<{ __typename?: 'MetaItemType', name?: string | null, content?: string | null, property?: string | null }> | null, links?: Array<{ __typename?: 'LinkItemType', rel?: string | null, href?: string | null, type?: string | null, sizes?: string | null }> | null, scripts?: Array<{ __typename?: 'ScriptItemType', type?: string | null, content?: string | null }> | null } };

export type GetSubCategorySeojsonQueryVariables = Exact<{
  categoryId: Scalars['ID']['input'];
}>;


export type GetSubCategorySeojsonQuery = { __typename?: 'Query', getSubCategorySEOJSON: { __typename?: 'ContentJSONType', title?: string | null, description?: string | null, metas?: Array<{ __typename?: 'MetaItemType', name?: string | null, content?: string | null, property?: string | null }> | null, links?: Array<{ __typename?: 'LinkItemType', rel?: string | null, href?: string | null, type?: string | null, sizes?: string | null }> | null, scripts?: Array<{ __typename?: 'ScriptItemType', type?: string | null, content?: string | null }> | null } };

export type CalculateShoppingCartQueryVariables = Exact<{
  products: Array<CartProductInput> | CartProductInput;
}>;


export type CalculateShoppingCartQuery = { __typename?: 'Query', calculateShoppingCart: { __typename?: 'CalculatedShoppingCartType', price?: { __typename?: 'PriceFullType', net?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, gross?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, toPay?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, taxValue?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, products?: Array<{ __typename?: 'CartProductType', barcode?: { __typename?: 'BarcodeWithPublicPriceType', publicPriceBeforeReduction?: any | null, internalProduct?: { __typename?: 'InternalProductType', id?: string | null, description?: string | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null } | null }> | null } };

export type ValidateShoppingCartByCurrentUserQueryVariables = Exact<{
  location?: InputMaybe<LonLatInput>;
}>;


export type ValidateShoppingCartByCurrentUserQuery = { __typename?: 'Query', validateShoppingCartByCurrentUser: Array<{ __typename?: 'ValidatedCartProductType', deliveryFees: any, mobilePickup: boolean, portalPickup: boolean, mobileDelivery: boolean, portalDelivery: boolean, inDeliveryZone: boolean, activatePickup: boolean, facebookPickup: boolean, activateDelivery: boolean, facebookDelivery: boolean, quantity: number, price: { __typename?: 'ProductPriceType', unitNet?: any | null, unitGross?: any | null, net?: any | null, gross?: any | null }, taxValue: { __typename?: 'TaxValueType', unit?: any | null, total?: any | null }, priceCredit?: { __typename?: 'PriceCreditType', periodCycle?: RecurrenceType | null, periodValue?: number | null, amount?: any | null } | null, barcode?: { __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, createdAt: any, updatedAt: any, prices?: Array<{ __typename?: 'BarcodePricesType', price?: any | null, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null } | null }> | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, priceList?: Array<{ __typename?: 'ProductPriceListType', value?: any | null, price?: { __typename?: 'PriceType', id: string, label?: string | null } | null }> | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number }> | null, internalProduct?: { __typename?: 'InternalProductType', id?: string | null, seo?: { __typename?: 'CatalogueCategorySeoType', urlKey?: string | null, metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'MetaKeywordsType', name?: string | null, content?: string | null }> | null } | null, specs?: Array<{ __typename?: 'ProductSpecsType', key?: string | null, value?: string | null }> | null } | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null } | null }> };

export type FindShoppingCartByUserAndTargetQueryVariables = Exact<{
  target: TargetAciInput;
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type FindShoppingCartByUserAndTargetQuery = { __typename?: 'Query', findShoppingCartByUserAndTarget: { __typename?: 'ShoppingCartType', id: string, createdAt: any, updatedAt: any, user?: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, target?: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } | null, price?: { __typename?: 'PriceFullType', net?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, gross?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, toPay?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, taxValue?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, products?: Array<{ __typename?: 'CartProductType', quantity: number, price: { __typename?: 'ProductPriceType', unitNet?: any | null, unitGross?: any | null, net?: any | null, gross?: any | null }, taxValue: { __typename?: 'TaxValueType', unit?: any | null, total?: any | null }, priceCredit?: { __typename?: 'PriceCreditType', periodCycle?: RecurrenceType | null, periodValue?: number | null, amount?: any | null } | null, barcode?: { __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, createdAt: any, updatedAt: any, publicPrice?: any | null, publicPriceBeforeReduction?: any | null, prices?: Array<{ __typename?: 'BarcodePricesType', price?: any | null, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null } | null }> | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, priceList?: Array<{ __typename?: 'ProductPriceListType', value?: any | null, price?: { __typename?: 'PriceType', id: string, label?: string | null } | null }> | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number }> | null, internalProduct?: { __typename?: 'InternalProductType', id?: string | null, description?: string | null, specs?: Array<{ __typename?: 'ProductSpecsType', key?: string | null, value?: string | null }> | null } | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null, productAttributes?: Array<{ __typename?: 'AttributeWithAttributeValueType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, pixel?: { __typename?: 'AttributePixelType', pixelAttribute?: string | null } | null, translation?: Array<{ __typename?: 'AttributeTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeTranslationContentType', label: string } }> | null, productAttributesValues?: Array<{ __typename?: 'AttributeValueBaseType', id: string, label: string, price?: any | null, externalId: string, createdAt: any, updatedAt: any, translation?: Array<{ __typename?: 'AttributeValueTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeValueTranslationContentType', label: string } }> | null }> | null }> | null } | null }> | null } };

export type FindShoppingCartByUserQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type FindShoppingCartByUserQuery = { __typename?: 'Query', findShoppingCartByUser: { __typename?: 'ShoppingCartType', id: string, createdAt: any, updatedAt: any, user?: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, target?: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } | null, price?: { __typename?: 'PriceFullType', net?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, gross?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, toPay?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, taxValue?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, products?: Array<{ __typename?: 'CartProductType', quantity: number, price: { __typename?: 'ProductPriceType', unitNet?: any | null, unitGross?: any | null, net?: any | null, gross?: any | null }, taxValue: { __typename?: 'TaxValueType', unit?: any | null, total?: any | null }, priceCredit?: { __typename?: 'PriceCreditType', periodCycle?: RecurrenceType | null, periodValue?: number | null, amount?: any | null } | null, barcode?: { __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, createdAt: any, updatedAt: any, prices?: Array<{ __typename?: 'BarcodePricesType', price?: any | null, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null } | null }> | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, priceList?: Array<{ __typename?: 'ProductPriceListType', value?: any | null, price?: { __typename?: 'PriceType', id: string, label?: string | null } | null }> | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number }> | null, internalProduct?: { __typename?: 'InternalProductType', id?: string | null, specs?: Array<{ __typename?: 'ProductSpecsType', key?: string | null, value?: string | null }> | null } | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null } | null }> | null } };

export type AddProductsToCartMutationVariables = Exact<{
  products: Array<CartProductInput> | CartProductInput;
  target?: InputMaybe<TargetAciInput>;
}>;


export type AddProductsToCartMutation = { __typename?: 'Mutation', addProductsToCart: { __typename?: 'ShoppingCartType', id: string, createdAt: any, updatedAt: any, user?: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, target?: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } | null, price?: { __typename?: 'PriceFullType', net?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, gross?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, toPay?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, taxValue?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, products?: Array<{ __typename?: 'CartProductType', quantity: number, price: { __typename?: 'ProductPriceType', unitNet?: any | null, unitGross?: any | null, net?: any | null, gross?: any | null }, taxValue: { __typename?: 'TaxValueType', unit?: any | null, total?: any | null }, priceCredit?: { __typename?: 'PriceCreditType', periodCycle?: RecurrenceType | null, periodValue?: number | null, amount?: any | null } | null, barcode?: { __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, createdAt: any, updatedAt: any, publicPrice?: any | null, publicPriceBeforeReduction?: any | null, prices?: Array<{ __typename?: 'BarcodePricesType', price?: any | null, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null }> | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, priceList?: Array<{ __typename?: 'ProductPriceListType', value?: any | null, price?: { __typename?: 'PriceType', id: string, label?: string | null } | null }> | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number }> | null, internalProduct?: { __typename?: 'InternalProductType', id?: string | null, description?: string | null, seo?: { __typename?: 'CatalogueCategorySeoType', urlKey?: string | null, metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'MetaKeywordsType', name?: string | null, content?: string | null }> | null } | null, specs?: Array<{ __typename?: 'ProductSpecsType', key?: string | null, value?: string | null }> | null } | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, pixel?: { __typename?: 'AttributePixelType', pixelAttribute?: string | null } | null, translation?: Array<{ __typename?: 'AttributeTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeTranslationContentType', label: string } }> | null } }> | null } | null, productAttributes?: Array<{ __typename?: 'AttributeWithAttributeValueType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, pixel?: { __typename?: 'AttributePixelType', pixelAttribute?: string | null } | null, translation?: Array<{ __typename?: 'AttributeTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeTranslationContentType', label: string } }> | null, productAttributesValues?: Array<{ __typename?: 'AttributeValueBaseType', id: string, label: string, price?: any | null, externalId: string, createdAt: any, updatedAt: any, translation?: Array<{ __typename?: 'AttributeValueTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeValueTranslationContentType', label: string } }> | null }> | null }> | null, maintenance?: { __typename?: 'InternalProductMaintenanceType', active?: boolean | null, prevMaintenanceDuration?: number | null, maintenanceDuration?: number | null, expectedMeantime?: number | null, owner?: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, technician?: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null } | null } | null }> | null } };

export type RemoveFromCartMutationVariables = Exact<{
  product: CartProductInput;
  target?: InputMaybe<TargetAciInput>;
}>;


export type RemoveFromCartMutation = { __typename?: 'Mutation', removeFromCart: { __typename?: 'ShoppingCartType', id: string, createdAt: any, updatedAt: any, user?: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, target?: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } | null, price?: { __typename?: 'PriceFullType', net?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, gross?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, toPay?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, taxValue?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, products?: Array<{ __typename?: 'CartProductType', quantity: number, price: { __typename?: 'ProductPriceType', unitNet?: any | null, unitGross?: any | null, net?: any | null, gross?: any | null }, taxValue: { __typename?: 'TaxValueType', unit?: any | null, total?: any | null }, priceCredit?: { __typename?: 'PriceCreditType', periodCycle?: RecurrenceType | null, periodValue?: number | null, amount?: any | null } | null, barcode?: { __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, createdAt: any, updatedAt: any, publicPrice?: any | null, publicPriceBeforeReduction?: any | null, prices?: Array<{ __typename?: 'BarcodePricesType', price?: any | null, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null } | null }> | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, priceList?: Array<{ __typename?: 'ProductPriceListType', value?: any | null, price?: { __typename?: 'PriceType', id: string, label?: string | null } | null }> | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number }> | null, internalProduct?: { __typename?: 'InternalProductType', id?: string | null, description?: string | null, specs?: Array<{ __typename?: 'ProductSpecsType', key?: string | null, value?: string | null }> | null } | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null } | null }> | null } };

export type AddDiscountToCartMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: DiscountDtoInput;
}>;


export type AddDiscountToCartMutation = { __typename?: 'Mutation', addDiscountToCart: { __typename?: 'ShoppingCartType', id: string, createdAt: any, updatedAt: any, user?: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, target?: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } | null, price?: { __typename?: 'PriceFullType', net?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, gross?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, toPay?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, taxValue?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, products?: Array<{ __typename?: 'CartProductType', quantity: number, price: { __typename?: 'ProductPriceType', unitNet?: any | null, unitGross?: any | null, net?: any | null, gross?: any | null }, taxValue: { __typename?: 'TaxValueType', unit?: any | null, total?: any | null }, priceCredit?: { __typename?: 'PriceCreditType', periodCycle?: RecurrenceType | null, periodValue?: number | null, amount?: any | null } | null, barcode?: { __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, createdAt: any, updatedAt: any, prices?: Array<{ __typename?: 'BarcodePricesType', price?: any | null, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null } | null }> | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, priceList?: Array<{ __typename?: 'ProductPriceListType', value?: any | null, price?: { __typename?: 'PriceType', id: string, label?: string | null } | null }> | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number }> | null, internalProduct?: { __typename?: 'InternalProductType', id?: string | null, specs?: Array<{ __typename?: 'ProductSpecsType', key?: string | null, value?: string | null }> | null } | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null } | null }> | null } };

export type EmptyCartMutationVariables = Exact<{ [key: string]: never; }>;


export type EmptyCartMutation = { __typename?: 'Mutation', emptyCart: { __typename?: 'ShoppingCartType', id: string, createdAt: any, updatedAt: any, user?: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, target?: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } | null, price?: { __typename?: 'PriceFullType', net?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, gross?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, toPay?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, taxValue?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, products?: Array<{ __typename?: 'CartProductType', quantity: number, price: { __typename?: 'ProductPriceType', unitNet?: any | null, unitGross?: any | null, net?: any | null, gross?: any | null }, taxValue: { __typename?: 'TaxValueType', unit?: any | null, total?: any | null }, priceCredit?: { __typename?: 'PriceCreditType', periodCycle?: RecurrenceType | null, periodValue?: number | null, amount?: any | null } | null, barcode?: { __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, createdAt: any, updatedAt: any, prices?: Array<{ __typename?: 'BarcodePricesType', price?: any | null, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null }> | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, priceList?: Array<{ __typename?: 'ProductPriceListType', value?: any | null, price?: { __typename?: 'PriceType', id: string, label?: string | null } | null }> | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number }> | null, internalProduct?: { __typename?: 'InternalProductType', id?: string | null, seo?: { __typename?: 'CatalogueCategorySeoType', urlKey?: string | null, metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'MetaKeywordsType', name?: string | null, content?: string | null }> | null } | null, specs?: Array<{ __typename?: 'ProductSpecsType', key?: string | null, value?: string | null }> | null } | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, pixel?: { __typename?: 'AttributePixelType', pixelAttribute?: string | null } | null, translation?: Array<{ __typename?: 'AttributeTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeTranslationContentType', label: string } }> | null } }> | null } | null, productAttributes?: Array<{ __typename?: 'AttributeWithAttributeValueType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, pixel?: { __typename?: 'AttributePixelType', pixelAttribute?: string | null } | null, translation?: Array<{ __typename?: 'AttributeTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeTranslationContentType', label: string } }> | null, productAttributesValues?: Array<{ __typename?: 'AttributeValueBaseType', id: string, label: string, price?: any | null, externalId: string, createdAt: any, updatedAt: any, translation?: Array<{ __typename?: 'AttributeValueTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeValueTranslationContentType', label: string } }> | null }> | null }> | null, maintenance?: { __typename?: 'InternalProductMaintenanceType', active?: boolean | null, prevMaintenanceDuration?: number | null, maintenanceDuration?: number | null, expectedMeantime?: number | null, owner?: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, technician?: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null } | null } | null }> | null } };

export type EmptyTargetCartMutationVariables = Exact<{
  target: TargetAciInput;
}>;


export type EmptyTargetCartMutation = { __typename?: 'Mutation', emptyTargetCart: { __typename?: 'ShoppingCartType', id: string, createdAt: any, updatedAt: any, user?: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, target?: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } | null, price?: { __typename?: 'PriceFullType', net?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, gross?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, toPay?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, taxValue?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, products?: Array<{ __typename?: 'CartProductType', quantity: number, price: { __typename?: 'ProductPriceType', unitNet?: any | null, unitGross?: any | null, net?: any | null, gross?: any | null }, taxValue: { __typename?: 'TaxValueType', unit?: any | null, total?: any | null }, priceCredit?: { __typename?: 'PriceCreditType', periodCycle?: RecurrenceType | null, periodValue?: number | null, amount?: any | null } | null, barcode?: { __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, createdAt: any, updatedAt: any, prices?: Array<{ __typename?: 'BarcodePricesType', price?: any | null, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null }> | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, priceList?: Array<{ __typename?: 'ProductPriceListType', value?: any | null, price?: { __typename?: 'PriceType', id: string, label?: string | null } | null }> | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number }> | null, internalProduct?: { __typename?: 'InternalProductType', id?: string | null, seo?: { __typename?: 'CatalogueCategorySeoType', urlKey?: string | null, metaTitle?: string | null, metaDesription?: string | null, metaKeywords?: Array<{ __typename?: 'MetaKeywordsType', name?: string | null, content?: string | null }> | null } | null, specs?: Array<{ __typename?: 'ProductSpecsType', key?: string | null, value?: string | null }> | null } | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, pixel?: { __typename?: 'AttributePixelType', pixelAttribute?: string | null } | null, translation?: Array<{ __typename?: 'AttributeTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeTranslationContentType', label: string } }> | null } }> | null } | null, productAttributes?: Array<{ __typename?: 'AttributeWithAttributeValueType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, pixel?: { __typename?: 'AttributePixelType', pixelAttribute?: string | null } | null, translation?: Array<{ __typename?: 'AttributeTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeTranslationContentType', label: string } }> | null, productAttributesValues?: Array<{ __typename?: 'AttributeValueBaseType', id: string, label: string, price?: any | null, externalId: string, createdAt: any, updatedAt: any, translation?: Array<{ __typename?: 'AttributeValueTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeValueTranslationContentType', label: string } }> | null }> | null }> | null, maintenance?: { __typename?: 'InternalProductMaintenanceType', active?: boolean | null, prevMaintenanceDuration?: number | null, maintenanceDuration?: number | null, expectedMeantime?: number | null, owner?: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, technician?: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null } | null } | null }> | null } };

export type UpdateProductCreditMutationVariables = Exact<{
  productToAdd: CartProductUpdateCreditInput;
  productToRemove: CartProductInput;
}>;


export type UpdateProductCreditMutation = { __typename?: 'Mutation', updateProductCredit: { __typename?: 'ShoppingCartType', id: string, createdAt: any, updatedAt: any, user?: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, target?: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } | null, price?: { __typename?: 'PriceFullType', net?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, gross?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, toPay?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, taxValue?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, products?: Array<{ __typename?: 'CartProductType', quantity: number, price: { __typename?: 'ProductPriceType', unitNet?: any | null, unitGross?: any | null, net?: any | null, gross?: any | null }, taxValue: { __typename?: 'TaxValueType', unit?: any | null, total?: any | null }, priceCredit?: { __typename?: 'PriceCreditType', periodCycle?: RecurrenceType | null, periodValue?: number | null, amount?: any | null } | null, barcode?: { __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, createdAt: any, updatedAt: any, prices?: Array<{ __typename?: 'BarcodePricesType', price?: any | null, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null } | null }> | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, priceList?: Array<{ __typename?: 'ProductPriceListType', value?: any | null, price?: { __typename?: 'PriceType', id: string, label?: string | null } | null }> | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number }> | null, internalProduct?: { __typename?: 'InternalProductType', id?: string | null, specs?: Array<{ __typename?: 'ProductSpecsType', key?: string | null, value?: string | null }> | null } | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null } | null }> | null } };

export type FindSlideByTargetAndReferenceCacheQueryVariables = Exact<{
  target: TargetAciInput;
  reference: Scalars['String']['input'];
}>;


export type FindSlideByTargetAndReferenceCacheQuery = { __typename?: 'Query', findSlideByTargetAndReferenceCache: { __typename?: 'SlidesType', id: string, reference?: string | null, visualType?: SlideVisualTypeEnum | null, createdAt: any, updatedAt: any, content?: Array<{ __typename?: 'SlidesContentType', icon?: string | null, title?: string | null, description?: string | null, image?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, calltoaction?: { __typename?: 'SlidesContentCallToActionType', label?: string | null, link?: string | null } | null }> | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } } };

export type FindSlidesByTargetCacheQueryVariables = Exact<{
  target: TargetAciInput;
}>;


export type FindSlidesByTargetCacheQuery = { __typename?: 'Query', findSlidesByTargetCache: Array<{ __typename?: 'SlidesWithoutTranslationType', id: string, reference?: string | null, visualType?: SlideVisualTypeEnum | null, createdAt: any, updatedAt: any, content?: Array<{ __typename?: 'SlidesContentType', icon?: string | null, title?: string | null, description?: string | null, image?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, calltoaction?: { __typename?: 'SlidesContentCallToActionType', label?: string | null, link?: string | null } | null }> | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } }> };

export type FindSocialsPaginationQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type FindSocialsPaginationQuery = { __typename?: 'Query', findSocialsPagination: { __typename?: 'SocialPaginatedType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'SocialType', id: string, name: string, code?: string | null, fontIcon?: string | null, createdAt: any, updatedAt: any, images?: Array<{ __typename?: 'SocialImagesType', style: SocialImageStyleEnum, images?: Array<{ __typename?: 'SocialImagesImagesType', svg?: { __typename?: 'SocialImagesImagesSetType', size48?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size96?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size144?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size240?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size480?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null }> | null }> | null }> } };

export type FindStatesByCountryPaginationQueryVariables = Exact<{
  country: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type FindStatesByCountryPaginationQuery = { __typename?: 'Query', findStatesByCountryPagination: { __typename?: 'StatePaginatedType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null } | null }> } };

export type GetStockByTargetAndBarcodeCacheQueryVariables = Exact<{
  barcode: Scalars['String']['input'];
  target: TargetAciInput;
}>;


export type GetStockByTargetAndBarcodeCacheQuery = { __typename?: 'Query', getStockByTargetAndBarcodeCache: { __typename?: 'StockType', id: string, outOfStock: boolean, currentStock: number, barcode: { __typename?: 'BarcodeType', id: string } } };

export type FindTargetOrdersByCurrentUserQueryVariables = Exact<{
  target: TargetAciInput;
  pagination?: InputMaybe<PaginationInput>;
  input?: InputMaybe<MarketPlaceOrderFilterConsumerInput>;
}>;


export type FindTargetOrdersByCurrentUserQuery = { __typename?: 'Query', findTargetOrdersByCurrentUser: { __typename?: 'MarketPlaceOrderPaginateType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'MarketPlaceOrderDtoType', id: string, notes?: string | null, createdAt: any, orderTime?: any | null, orderType?: OrderTypeEnum | null, updatedAt: any, number: string, hasInvoice?: boolean | null, deliveryFees?: any | null, user?: { __typename?: 'UserType', id: string } | null, billingAddress?: { __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null } | null, deliveryAddress?: { __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null } | null, guestUser?: { __typename?: 'GuestUserType', email?: string | null, lastName?: string | null, firstName?: string | null, phone?: { __typename?: 'IPhoneType', number?: string | null, countryCode?: string | null } | null } | null, extraFees?: Array<{ __typename?: 'MarketPlaceOrderDtoFeesType', key?: string | null, value?: any | null }> | null, installments?: Array<{ __typename?: 'InstallmentType', _id: string, amount: any, paymentStatus: PaymentStatusEnum, paidAt?: any | null, deadline?: any | null, paymentMethod: { __typename?: 'PaymentType', id: string, name: string, code?: string | null, paymentType?: PaymentTypeEnum | null, materialIcon?: string | null, createdAt: any, updatedAt: any, images?: { __typename?: 'PaymentImagesType', svg?: { __typename?: 'PaymentImagesSvgType', default?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null } | null } }> | null, shoppingCart: { __typename?: 'MarketPlaceOrderShoppingCartType', price?: { __typename?: 'PriceFullType', net?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, gross?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, toPay?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null } | null, target?: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, taxValue?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, products?: Array<{ __typename?: 'OrderShoppingCartProductType', quantity: number, orderProductStatus: OrderStatus, name?: string | null, price: { __typename?: 'ProductPriceType', unitNet?: any | null, unitGross?: any | null, net?: any | null, gross?: any | null }, taxValue: { __typename?: 'TaxValueType', unit?: any | null, total?: any | null }, barcode: { __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, condition?: ProductConditionEnum | null, status?: ProductStatusEnum | null, createdAt: any, updatedAt: any, publicPrice?: any | null, publicPriceBeforeReduction?: any | null, prices?: Array<{ __typename?: 'BarcodePricesType', price?: any | null, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null } | null }> | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, priceCredit?: Array<{ __typename?: 'BarcodePeriodCreditType', periodCycle: RecurrenceType, periodValue: number, amount?: any | null }> | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number }> | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, externalId: string, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null } }> | null } | null, internalProduct?: { __typename?: 'InternalProductType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, price?: any | null, status?: ProductStatusEnum | null, condition?: ProductConditionEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null }> | null } | null } }> | null }, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null } | null }> } };

export type GetTargetOrderInvoiceQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type GetTargetOrderInvoiceQuery = { __typename?: 'Query', getTargetOrderInvoice: { __typename?: 'InvoicePDFType', content?: string | null } };

export type CreateTargetOrderByCartMutationVariables = Exact<{
  input: MarketPlaceOrderInput;
  target: TargetAciInput;
}>;


export type CreateTargetOrderByCartMutation = { __typename?: 'Mutation', createTargetOrderByCart: { __typename?: 'SuccessResponseWithOrderIdType', orderId: string } };

export type CreateTargetOrderWithCartAndRegisterUserMutationVariables = Exact<{
  input: MarketPlaceOrderWithCartAfterRegisterInput;
}>;


export type CreateTargetOrderWithCartAndRegisterUserMutation = { __typename?: 'Mutation', createTargetOrderWithCartAndRegisterUser: { __typename?: 'MarketPlaceOrderWithLoginType', accessToken: string, orderId: string, user: { __typename?: 'UserType', id: string } } };

export type CreateTargetOrderWithCartForGuestUserMutationVariables = Exact<{
  input: MarketPlaceOrderWithCartForGuestInput;
}>;


export type CreateTargetOrderWithCartForGuestUserMutation = { __typename?: 'Mutation', createTargetOrderWithCartForGuestUser: { __typename?: 'MarketPlaceOrderDtoType', id: string, notes?: string | null, createdAt: any, orderTime?: any | null, orderType?: OrderTypeEnum | null, updatedAt: any, number: string, hasInvoice?: boolean | null, deliveryFees?: any | null, user?: { __typename?: 'UserType', id: string, apps?: Array<App> | null, email?: string | null, roles?: Array<UserRole> | null, title?: string | null, about?: string | null, gender?: Gender | null, locale?: string | null, source?: SourcesEnum | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, plugged?: boolean | null, createdAt: any, updatedAt: any, isMailValid?: boolean | null, dateOfBirth?: any | null, phoneNumber?: string | null, mobileTheme?: MobileThemesEnum | null, placeOfBirth?: string | null, maritalStatus?: MaritalStatus | null, newsletterSubs?: boolean | null, hasAutoGeneratedEmail?: boolean | null, hobbies?: Array<string> | null, interests?: Array<string> | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, permission?: { __typename?: 'PermissionType', id: string, name?: string | null, createdAt: any, updatedAt: any, permissions?: Array<{ __typename?: 'PermissionPermissionsType', read?: boolean | null, update?: boolean | null, create?: boolean | null, permission: { __typename?: 'PermissionDefinitionType', id: string, name?: string | null, createdAt: any, updatedAt: any } }> | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } } | null, languages?: Array<{ __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }> | null, nationality?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, billingAddress?: Array<{ __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null }> | null, shippingAddress?: Array<{ __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null }> | null, residentialAddress?: Array<{ __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null }> | null, chatContact?: Array<{ __typename?: 'SocialValueType', value?: string | null, name?: { __typename?: 'SocialType', id: string, name: string, code?: string | null, fontIcon?: string | null, createdAt: any, updatedAt: any, images?: Array<{ __typename?: 'SocialImagesType', style: SocialImageStyleEnum, images?: Array<{ __typename?: 'SocialImagesImagesType', svg?: { __typename?: 'SocialImagesImagesSetType', size48?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size96?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size144?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size240?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size480?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, png?: { __typename?: 'SocialImagesImagesSetType', size48?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size96?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size144?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size240?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size480?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null }> | null }> | null } | null }> | null, socialMedia?: Array<{ __typename?: 'SocialValueType', value?: string | null, name?: { __typename?: 'SocialType', id: string, name: string, code?: string | null, fontIcon?: string | null, createdAt: any, updatedAt: any, images?: Array<{ __typename?: 'SocialImagesType', style: SocialImageStyleEnum, images?: Array<{ __typename?: 'SocialImagesImagesType', svg?: { __typename?: 'SocialImagesImagesSetType', size48?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size96?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size144?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size240?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size480?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, png?: { __typename?: 'SocialImagesImagesSetType', size48?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size96?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size144?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size240?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size480?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null }> | null }> | null } | null }> | null, socialLoginData?: { __typename?: 'SocialLoginDataType', ooredoo?: { __typename?: 'OoredooDataType', id?: string | null } | null, facebook?: { __typename?: 'FacebookDataType', id: string, name?: string | null, token: string, email: string, last_name?: string | null, first_name?: string | null } | null, google?: { __typename?: 'GoogleDataType', sub: string, name?: string | null, email: string, token: string, locale?: string | null, picture?: string | null, given_name?: string | null, family_name?: string | null, email_verified?: boolean | null } | null, apple?: { __typename?: 'AppleDataType', email?: string | null, status?: string | null, givenName?: string | null, familyName?: string | null, identityToken: string, userIdentifier?: string | null, authorizationCode?: string | null } | null } | null, education?: Array<{ __typename?: 'UserEducationType', level?: AcademicLevel | null, name?: string | null, description?: string | null, tags?: Array<string> | null, from?: any | null, to?: any | null, graduated?: boolean | null, city?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null }> | null, work?: Array<{ __typename?: 'UserWorkType', company?: string | null, position?: string | null, description?: string | null, tags?: Array<string> | null, from?: any | null, to?: any | null, current?: boolean | null, city?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null }> | null, custom?: Array<{ __typename?: 'UserCustomType', customKey?: string | null, customValue?: string | null }> | null, lived?: Array<{ __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }> | null } | null, billingAddress?: { __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null } | null, deliveryAddress?: { __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null } | null, guestUser?: { __typename?: 'GuestUserType', email?: string | null, lastName?: string | null, firstName?: string | null, phone?: { __typename?: 'IPhoneType', number?: string | null, countryCode?: string | null } | null } | null, extraFees?: Array<{ __typename?: 'MarketPlaceOrderDtoFeesType', key?: string | null, value?: any | null }> | null, installments?: Array<{ __typename?: 'InstallmentType', _id: string, amount: any, paymentStatus: PaymentStatusEnum, paidAt?: any | null, deadline?: any | null, paymentMethod: { __typename?: 'PaymentType', id: string, name: string, code?: string | null, paymentType?: PaymentTypeEnum | null, materialIcon?: string | null, createdAt: any, updatedAt: any, images?: { __typename?: 'PaymentImagesType', png?: { __typename?: 'PaymentImagesPngType', alt?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, alt2x?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, alt_128?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, alt_256?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, alt_512?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, card_flat?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, card_flat2x?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, card_flat_128?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, card_flat_256?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, card_flat_512?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, dark?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, dark2x?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, dark_128?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, dark_256?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, dark_512?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flat?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flat2x?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flat_128?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flat_256?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flat_512?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, light?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, light2x?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, light_128?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, light_256?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, light_512?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, default?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, default2x?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, default_128?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, default_256?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, default_512?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, svg?: { __typename?: 'PaymentImagesSvgType', alt?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, card_flat?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, dark?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flat?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, light?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, default?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null } | null } }> | null, shoppingCart: { __typename?: 'MarketPlaceOrderShoppingCartType', price?: { __typename?: 'PriceFullType', net?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, gross?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, toPay?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null } | null, target?: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, taxValue?: { __typename?: 'ReduciblePriceType', beforeReduction?: any | null, afterReduction?: any | null } | null, products?: Array<{ __typename?: 'OrderShoppingCartProductType', quantity: number, orderProductStatus: OrderStatus, name?: string | null, price: { __typename?: 'ProductPriceType', unitNet?: any | null, unitGross?: any | null, net?: any | null, gross?: any | null }, taxValue: { __typename?: 'TaxValueType', unit?: any | null, total?: any | null }, barcode: { __typename?: 'BarcodeWithPublicPriceType', id: string, name?: string | null, price?: any | null, barcode: string, condition?: ProductConditionEnum | null, status?: ProductStatusEnum | null, createdAt: any, updatedAt: any, prices?: Array<{ __typename?: 'BarcodePricesType', price?: any | null, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null }> | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, priceList?: Array<{ __typename?: 'ProductPriceListType', value?: any | null, price?: { __typename?: 'PriceType', id: string, label?: string | null } | null }> | null, priceCredit?: Array<{ __typename?: 'BarcodePeriodCreditType', periodCycle: RecurrenceType, periodValue: number, amount?: any | null }> | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null, rank?: number | null, layer: number }> | null, pixel?: { __typename?: 'PixelBarcodeType', include?: boolean | null } | null, supplier?: { __typename?: 'CompanyType', id: string, name?: string | null, description?: string | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null } | null, translation?: Array<{ __typename?: 'BarcodeTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'BarcodeTranslationContentType', name: string } }> | null, maintenance?: { __typename?: 'InternalProductMaintenanceType', active?: boolean | null, prevMaintenanceDuration?: number | null, maintenanceDuration?: number | null, expectedMeantime?: number | null, owner?: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, technician?: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null } | null, productAttributesValues?: { __typename?: 'InternalProductAttributesValuesType', attributesValues?: Array<{ __typename?: 'AttributeValueType', id: string, label: string, externalId: string, createdAt: any, updatedAt: any, translation?: Array<{ __typename?: 'AttributeValueTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeValueTranslationContentType', label: string } }> | null, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, pixel?: { __typename?: 'AttributePixelType', pixelAttribute?: string | null } | null, translation?: Array<{ __typename?: 'AttributeTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeTranslationContentType', label: string } }> | null }, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } }> | null } | null, internalProduct?: { __typename?: 'InternalProductType', id?: string | null, sku?: string | null, name?: string | null, tags?: Array<string> | null, price?: any | null, status?: ProductStatusEnum | null, condition?: ProductConditionEnum | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, descriptionList?: Array<string> | null, priceBeforeReduction?: any | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, discount?: { __typename?: 'DiscountDtoType', amount?: any | null, discountType?: DiscountType | null } | null, catalogueCategory?: Array<{ __typename?: 'CatalogueCategoryType', id: string, name?: string | null }> | null, translation?: Array<{ __typename?: 'InternalProductTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'InternalProductTranslationContentType', name: string } }> | null } | null, product?: { __typename?: 'ProductType', id?: string | null, ean?: string | null, tax?: any | null, name?: string | null, tags?: Array<string> | null, classification?: Array<ProductClassEnum> | null, price?: any | null, weight?: number | null, createdAt: any, updatedAt: any, externalId?: string | null, description?: string | null, factoryPrice?: any | null, descriptionList?: Array<string> | null, wholesalerPrice?: any | null, specs?: Array<{ __typename?: 'ProductSpecsType', key?: string | null, value?: string | null }> | null, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, category?: Array<{ __typename?: 'InventoryCategoryType', id: string, name: string, rank: number, layer: number, createdAt: any, updatedAt: any, hasChildren: boolean, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }> | null, taxes?: Array<{ __typename?: 'ProductTaxesType', rank?: number | null, tax?: { __typename?: 'TaxType', id: string, label?: string | null, externalId?: string | null, use?: Array<TaxUseEnum> | null, product?: boolean | null, createdAt: any, updatedAt: any, value?: { __typename?: 'TaxVaType', sign: TaxSignEnum, value?: any | null, type: DiscountType } | null, company?: { __typename?: 'CompanyType', id: string, name?: string | null } | null } | null }> | null, brand?: { __typename?: 'BrandType', id?: string | null, name?: string | null, website?: string | null, createdAt: any, updatedAt: any, externalId?: string | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string, email?: string | null, name?: string | null, description?: string | null, website?: string | null, contactEmails?: Array<string> | null, createdAt: any, updatedAt: any, currencies?: Array<{ __typename?: 'TargetCurrencyType', default?: boolean | null, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null }> | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, address?: { __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null } | null, company?: { __typename?: 'CompanyType', id: string, name?: string | null, description?: string | null, logistic?: boolean | null, tags?: Array<string> | null, externalId?: string | null, createdAt: any, updatedAt: any, media?: { __typename?: 'MediaType', videos?: Array<string> | null, deg360?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null, pictures?: Array<{ __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null }> | null } | null, address?: { __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null } | null, legal?: { __typename?: 'CompanyLegalType', vat?: string | null, register?: string | null, licence?: string | null } | null, banks?: Array<{ __typename?: 'BankDetailsType', id: string, account: string, iban?: string | null, externalId?: string | null, createdAt: any, updatedAt: any, holder: { __typename?: 'BankDetailsHolderType', name: string, type?: BankDetailsHolderTypeEnum | null, address: { __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null } }, bank: { __typename?: 'BankType', id: string, name: string, code?: string | null, bic?: string | null, createdAt: any, updatedAt: any, logo?: { __typename?: 'BrowserLogoType', icon?: string | null, svg?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, png?: { __typename?: 'BrowserLogoPngType', default?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size16?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size24?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size32?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size48?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size64?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size128?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size256?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size512?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null } | null } }> | null, contact?: { __typename?: 'CompanyContactDetailsType', website?: string | null, email?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null } | null } | null } | null, target?: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } | null } | null, productAttributes?: Array<{ __typename?: 'ProductAttributeType', id: string, createdAt: any, updatedAt: any, reference: string, isRequired: boolean, possibleValues: Array<string>, isMultipleChoice: boolean, attribute: { __typename?: 'AttributeType', id: string, label: string, externalId: string, variety?: ProductVarietyEnum | null, createdAt: any, updatedAt: any, isRequired?: boolean | null, isMultipleChoice?: boolean | null, pixel?: { __typename?: 'AttributePixelType', pixelAttribute?: string | null } | null, translation?: Array<{ __typename?: 'AttributeTranslationType', language: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null }, content: { __typename?: 'AttributeTranslationContentType', label: string } }> | null, target?: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } | null }, target?: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } | null }> | null } | null } }> | null }, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null } };

export type SendOrderByEmailAndSmsQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
  target: TargetAciInput;
  subject: Scalars['String']['input'];
}>;


export type SendOrderByEmailAndSmsQuery = { __typename?: 'Query', sendOrderByEmailAndSms: { __typename?: 'SuccessResponseDtoType', message: string, success: boolean } };

export type FindCorporateTemplateByNameAndTargetQueryVariables = Exact<{
  target: TargetAciInput;
  name: CorporateTemplateTypeEnum;
}>;


export type FindCorporateTemplateByNameAndTargetQuery = { __typename?: 'Query', findCorporateTemplateByNameAndTarget: { __typename?: 'CorporateTemplateType', id: string, name: CorporateTemplateTypeEnum, content: string, createdAt: any, updatedAt: any, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } } };

export type UpdateUserMutationVariables = Exact<{
  input: UserUpdateInput;
  id: Scalars['ID']['input'];
  source?: InputMaybe<UserEventsSourceEnum>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserType', id: string, apps?: Array<App> | null, email?: string | null, roles?: Array<UserRole> | null, title?: string | null, about?: string | null, gender?: Gender | null, locale?: string | null, source?: SourcesEnum | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, plugged?: boolean | null, createdAt: any, updatedAt: any, isMailValid?: boolean | null, dateOfBirth?: any | null, phoneNumber?: string | null, mobileTheme?: MobileThemesEnum | null, placeOfBirth?: string | null, maritalStatus?: MaritalStatus | null, newsletterSubs?: boolean | null, hasAutoGeneratedEmail?: boolean | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, billingAddress?: Array<{ __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null }> | null, shippingAddress?: Array<{ __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null }> | null, residentialAddress?: Array<{ __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null }> | null } };

export type CurrentUserCompleteQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserCompleteQuery = { __typename?: 'Query', currentUserComplete: { __typename?: 'UserType', id: string, apps?: Array<App> | null, email?: string | null, roles?: Array<UserRole> | null, title?: string | null, about?: string | null, gender?: Gender | null, locale?: string | null, source?: SourcesEnum | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, plugged?: boolean | null, createdAt: any, updatedAt: any, isMailValid?: boolean | null, dateOfBirth?: any | null, phoneNumber?: string | null, mobileTheme?: MobileThemesEnum | null, placeOfBirth?: string | null, maritalStatus?: MaritalStatus | null, newsletterSubs?: boolean | null, hasAutoGeneratedEmail?: boolean | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, billingAddress?: Array<{ __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null }> | null, shippingAddress?: Array<{ __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null }> | null, residentialAddress?: Array<{ __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null }> | null } };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } };

export type UpdateCurrentUserMutationVariables = Exact<{
  input: UserUpdateInput;
  source?: InputMaybe<UserEventsSourceEnum>;
}>;


export type UpdateCurrentUserMutation = { __typename?: 'Mutation', updateCurrentUser: { __typename?: 'UserType', id: string, apps?: Array<App> | null, email?: string | null, roles?: Array<UserRole> | null, title?: string | null, about?: string | null, gender?: Gender | null, locale?: string | null, source?: SourcesEnum | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, plugged?: boolean | null, createdAt: any, updatedAt: any, isMailValid?: boolean | null, dateOfBirth?: any | null, phoneNumber?: string | null, mobileTheme?: MobileThemesEnum | null, placeOfBirth?: string | null, maritalStatus?: MaritalStatus | null, newsletterSubs?: boolean | null, hasAutoGeneratedEmail?: boolean | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, billingAddress?: Array<{ __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null }> | null, shippingAddress?: Array<{ __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null }> | null, residentialAddress?: Array<{ __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null }> | null } };

export type UpdateCurrentUserPasswordForAppMutationVariables = Exact<{
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
}>;


export type UpdateCurrentUserPasswordForAppMutation = { __typename?: 'Mutation', updateCurrentUserPasswordForApp: { __typename?: 'UserType', id: string, apps?: Array<App> | null, email?: string | null, roles?: Array<UserRole> | null, title?: string | null, about?: string | null, gender?: Gender | null, locale?: string | null, source?: SourcesEnum | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, plugged?: boolean | null, createdAt: any, updatedAt: any, isMailValid?: boolean | null, dateOfBirth?: any | null, phoneNumber?: string | null, mobileTheme?: MobileThemesEnum | null, placeOfBirth?: string | null, maritalStatus?: MaritalStatus | null, newsletterSubs?: boolean | null, hasAutoGeneratedEmail?: boolean | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, billingAddress?: Array<{ __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null }> | null, shippingAddress?: Array<{ __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null }> | null, residentialAddress?: Array<{ __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null }> | null } };

export type UpdateCurrentUserPasswordMutationVariables = Exact<{
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
}>;


export type UpdateCurrentUserPasswordMutation = { __typename?: 'Mutation', updateCurrentUserPassword: { __typename?: 'UserType', id: string, apps?: Array<App> | null, email?: string | null, roles?: Array<UserRole> | null, title?: string | null, about?: string | null, gender?: Gender | null, locale?: string | null, source?: SourcesEnum | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, plugged?: boolean | null, createdAt: any, updatedAt: any, isMailValid?: boolean | null, dateOfBirth?: any | null, phoneNumber?: string | null, mobileTheme?: MobileThemesEnum | null, placeOfBirth?: string | null, maritalStatus?: MaritalStatus | null, newsletterSubs?: boolean | null, hasAutoGeneratedEmail?: boolean | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, billingAddress?: Array<{ __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null }> | null, shippingAddress?: Array<{ __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null }> | null, residentialAddress?: Array<{ __typename?: 'FullAddressType', city?: string | null, address?: string | null, postCode?: string | null, location?: { __typename?: 'LonLatType', type?: ZoneTypesEnum | null, coordinates?: Array<number> | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, state?: { __typename?: 'StateType', id: string, name: string, adminName?: string | null, capital?: StateCapitalEnum | null, population?: any | null, ascii?: string | null, lat?: any | null, lng?: any | null, createdAt: any, updatedAt: any, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, owner?: { __typename?: 'FullAddressOwnerType', name?: string | null, phone?: { __typename?: 'FullAddressOwnerPhoneType', number?: string | null, countryCode?: string | null } | null } | null }> | null } };

export type FindVisualsByTargetCacheQueryVariables = Exact<{
  target: TargetAciInput;
}>;


export type FindVisualsByTargetCacheQuery = { __typename?: 'Query', findVisualsByTargetCache: { __typename?: 'VisualsType', id: string, pageTitle?: string | null, createdAt: any, updatedAt: any, logo?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, wide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, square?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, favicon?: { __typename?: 'VisualsFaviconType', size16?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size32?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size57?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size60?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size72?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size76?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size96?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size114?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size120?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size144?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size152?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size180?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, size192?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } } };

export type GetCurrentUserQuantitativeWalletsQueryVariables = Exact<{
  userToken?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetCurrentUserQuantitativeWalletsQuery = { __typename?: 'Query', getCurrentUserQuantitativeWallets: { __typename?: 'WalletPaginateType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'WalletType', id: string, amount?: any | null, fee?: number | null, walletType?: WalletTypeEnum | null, createdAt: any, updatedAt: any, coin?: { __typename?: 'CoinType', id: string, name: string, code?: string | null, category?: CoinCategoryEnum | null, handle?: CoinHandleEnum | null, createdAt: any, updatedAt: any, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, unitValue?: { __typename?: 'CoinValueType', amount?: any | null, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null } | null } | null, country?: { __typename?: 'CountryType', id: string, name: string, code?: string | null, dialCode?: string | null, iconFlag?: string | null } | null, api?: { __typename?: 'CoinApiType', push?: { __typename?: 'CoinApiMethodType', link?: string | null, method?: ApiMethods | null, headers?: Array<{ __typename?: 'CoinApiParamsType', key?: string | null, value?: string | null, user?: boolean | null, amount?: boolean | null }> | null, params?: Array<{ __typename?: 'CoinApiParamsType', key?: string | null, value?: string | null, user?: boolean | null, amount?: boolean | null }> | null } | null, deduct?: { __typename?: 'CoinApiMethodType', link?: string | null, method?: ApiMethods | null, headers?: Array<{ __typename?: 'CoinApiParamsType', key?: string | null, value?: string | null, user?: boolean | null, amount?: boolean | null }> | null, params?: Array<{ __typename?: 'CoinApiParamsType', key?: string | null, value?: string | null, user?: boolean | null, amount?: boolean | null }> | null } | null, check?: { __typename?: 'CoinApiCheckType', link?: string | null, method?: ApiMethods | null, headers?: Array<{ __typename?: 'CoinApiHeadersType', key?: string | null, value?: string | null, user?: boolean | null }> | null, params?: Array<{ __typename?: 'CoinApiHeadersType', key?: string | null, value?: string | null, user?: boolean | null }> | null } | null } | null, owner?: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } | null } | null, owner?: { __typename?: 'TargetWithUserType', pos?: { __typename?: 'PointOfSaleType', id: string, name?: string | null, title?: string | null, email?: Array<string> | null, phone?: Array<string> | null, website?: string | null, subtitle?: string | null, createdAt: any, updatedAt: any, brandColor?: string | null, description?: string | null, company?: { __typename?: 'CompanyType', id: string } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, user?: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } | null, target?: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } | null }> } };

export type GetWebsiteIntegrationByTargetCacheQueryVariables = Exact<{
  target: TargetAciInput;
}>;


export type GetWebsiteIntegrationByTargetCacheQuery = { __typename?: 'Query', getWebsiteIntegrationByTargetCache: { __typename?: 'WebsiteIntegrationType', id: string, createdAt: any, updatedAt: any, multilanguage?: { __typename?: 'WebsiteIntegrationMultilanguageType', active?: boolean | null, languages?: Array<{ __typename?: 'WebsiteIntegrationMultilanguageLanguageType', default?: boolean | null, language?: { __typename?: 'LanguageType', id: string, name: string, code?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null }> | null } | null, multicurrency?: { __typename?: 'WebsiteIntegrationMulticurrencyType', active?: boolean | null, currencies?: Array<{ __typename?: 'WebsiteIntegrationMulticurrencyCurrencyType', default?: boolean | null, currency?: { __typename?: 'CurrencyType', id: string, name: string, code?: string | null, symbol?: string | null, iconFlag?: string | null, createdAt: any, updatedAt: any, flagSquare?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null, flagWide?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } | null }> | null } | null, target: { __typename?: 'TargetType', pos?: { __typename?: 'PointOfSaleType', id: string } | null, wholesaler?: { __typename?: 'WholesalerType', id: string } | null, manufacturer?: { __typename?: 'ManufacturerType', id: string } | null } } };

export type ListenForSendThemAndLanguageToWidgetSubscriptionVariables = Exact<{
  reference: Scalars['String']['input'];
  target: TargetAciInput;
}>;


export type ListenForSendThemAndLanguageToWidgetSubscription = { __typename?: 'Subscription', listenForSendThemAndLanguageToWidget: { __typename?: 'ThemAndLanguageToWidgetType', theme?: string | null, language?: string | null } };

export const LoginForAppDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loginForApp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoginInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginForApp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"expiresIn"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginForAppGQL extends Apollo.Query<LoginForAppQuery, LoginForAppQueryVariables> {
    document = LoginForAppDocument;
    client = 'auth';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterForAppDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"registerForApp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subject"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brand"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmailTempVariablesBrandInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registerForApp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subject"}}},{"kind":"Argument","name":{"kind":"Name","value":"brand"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brand"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"expiresIn"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterForAppGQL extends Apollo.Mutation<RegisterForAppMutation, RegisterForAppMutationVariables> {
    document = RegisterForAppDocument;
    client = 'auth';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindBlogsByTargetAndUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findBlogsByTargetAndUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findBlogsByTargetAndUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}},{"kind":"Argument","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sectionData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sectionTitle"}},{"kind":"Field","name":{"kind":"Name","value":"sectionContent"}},{"kind":"Field","name":{"kind":"Name","value":"sectionReference"}},{"kind":"Field","name":{"kind":"Name","value":"sectionPictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class FindBlogsByTargetAndUrlGQL extends Apollo.Query<FindBlogsByTargetAndUrlQuery, FindBlogsByTargetAndUrlQueryVariables> {
    document = FindBlogsByTargetAndUrlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindBlogsByTargetPaginatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findBlogsByTargetPaginated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchString"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VisibilityStatusEnum"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findBlogsByTargetPaginated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchString"}}},{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sectionData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sectionTitle"}},{"kind":"Field","name":{"kind":"Name","value":"sectionContent"}},{"kind":"Field","name":{"kind":"Name","value":"sectionReference"}},{"kind":"Field","name":{"kind":"Name","value":"sectionPictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class FindBlogsByTargetPaginatedGQL extends Apollo.Query<FindBlogsByTargetPaginatedQuery, FindBlogsByTargetPaginatedQueryVariables> {
    document = FindBlogsByTargetPaginatedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CatalogueCategoryCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogueCategoryCache"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogueCategoryCache"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"portal"}},{"kind":"Field","name":{"kind":"Name","value":"pickup"}},{"kind":"Field","name":{"kind":"Name","value":"booking"}},{"kind":"Field","name":{"kind":"Name","value":"delivery"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class CatalogueCategoryCacheGQL extends Apollo.Query<CatalogueCategoryCacheQuery, CatalogueCategoryCacheQueryVariables> {
    document = CatalogueCategoryCacheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCatalogueCategoriesByTargetWithChildrenCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCatalogueCategoriesByTargetWithChildrenCache"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variety"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVarietyEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCatalogueCategoriesByTargetWithChildrenCache"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}},{"kind":"Argument","name":{"kind":"Name","value":"variety"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variety"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"portal"}},{"kind":"Field","name":{"kind":"Name","value":"pickup"}},{"kind":"Field","name":{"kind":"Name","value":"booking"}},{"kind":"Field","name":{"kind":"Name","value":"delivery"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"portal"}},{"kind":"Field","name":{"kind":"Name","value":"pickup"}},{"kind":"Field","name":{"kind":"Name","value":"booking"}},{"kind":"Field","name":{"kind":"Name","value":"delivery"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"portal"}},{"kind":"Field","name":{"kind":"Name","value":"pickup"}},{"kind":"Field","name":{"kind":"Name","value":"booking"}},{"kind":"Field","name":{"kind":"Name","value":"delivery"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"portal"}},{"kind":"Field","name":{"kind":"Name","value":"pickup"}},{"kind":"Field","name":{"kind":"Name","value":"booking"}},{"kind":"Field","name":{"kind":"Name","value":"delivery"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"portal"}},{"kind":"Field","name":{"kind":"Name","value":"pickup"}},{"kind":"Field","name":{"kind":"Name","value":"booking"}},{"kind":"Field","name":{"kind":"Name","value":"delivery"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"portal"}},{"kind":"Field","name":{"kind":"Name","value":"pickup"}},{"kind":"Field","name":{"kind":"Name","value":"booking"}},{"kind":"Field","name":{"kind":"Name","value":"delivery"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCatalogueCategoriesByTargetWithChildrenCacheGQL extends Apollo.Query<GetCatalogueCategoriesByTargetWithChildrenCacheQuery, GetCatalogueCategoriesByTargetWithChildrenCacheQueryVariables> {
    document = GetCatalogueCategoriesByTargetWithChildrenCacheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCatalogueCategoriesByTargetAndUrlKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCatalogueCategoriesByTargetAndUrlKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"urlKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCatalogueCategoriesByTargetAndUrlKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}},{"kind":"Argument","name":{"kind":"Name","value":"urlKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"urlKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"portal"}},{"kind":"Field","name":{"kind":"Name","value":"pickup"}},{"kind":"Field","name":{"kind":"Name","value":"booking"}},{"kind":"Field","name":{"kind":"Name","value":"delivery"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCatalogueCategoriesByTargetAndUrlKeyGQL extends Apollo.Query<GetCatalogueCategoriesByTargetAndUrlKeyQuery, GetCatalogueCategoriesByTargetAndUrlKeyQueryVariables> {
    document = GetCatalogueCategoriesByTargetAndUrlKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchCatalogueCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchCatalogueCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchString"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchCatalogueCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchString"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"portal"}},{"kind":"Field","name":{"kind":"Name","value":"pickup"}},{"kind":"Field","name":{"kind":"Name","value":"booking"}},{"kind":"Field","name":{"kind":"Name","value":"delivery"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchCatalogueCategoriesGQL extends Apollo.Query<SearchCatalogueCategoriesQuery, SearchCatalogueCategoriesQueryVariables> {
    document = SearchCatalogueCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCatalogueCategoriesByLayerAndParentCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCatalogueCategoriesByLayerAndParentCache"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"layer"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variety"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVarietyEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parent"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCatalogueCategoriesByLayerAndParentCache"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}},{"kind":"Argument","name":{"kind":"Name","value":"layer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"layer"}}},{"kind":"Argument","name":{"kind":"Name","value":"variety"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variety"}}},{"kind":"Argument","name":{"kind":"Name","value":"parent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parent"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"portal"}},{"kind":"Field","name":{"kind":"Name","value":"pickup"}},{"kind":"Field","name":{"kind":"Name","value":"booking"}},{"kind":"Field","name":{"kind":"Name","value":"delivery"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCatalogueCategoriesByLayerAndParentCacheGQL extends Apollo.Query<GetCatalogueCategoriesByLayerAndParentCacheQuery, GetCatalogueCategoriesByLayerAndParentCacheQueryVariables> {
    document = GetCatalogueCategoriesByLayerAndParentCacheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindContentTypeByTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findContentTypeByType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findContentTypeByType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class FindContentTypeByTypeGQL extends Apollo.Query<FindContentTypeByTypeQuery, FindContentTypeByTypeQueryVariables> {
    document = FindContentTypeByTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoginForTargetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loginForTarget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"login"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IPhoneInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserEventsSourceEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginForTarget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"login"},"value":{"kind":"Variable","name":{"kind":"Name","value":"login"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expiresIn"}},{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"apps"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"about"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"plugged"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isMailValid"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"mobileTheme"}},{"kind":"Field","name":{"kind":"Name","value":"placeOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"maritalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"newsletterSubs"}},{"kind":"Field","name":{"kind":"Name","value":"hasAutoGeneratedEmail"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginForTargetGQL extends Apollo.Query<LoginForTargetQuery, LoginForTargetQueryVariables> {
    document = LoginForTargetDocument;
    client = 'auth';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LogoutUserForTargetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"logoutUserForTarget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserEventsSourceEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logoutUserForTarget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class LogoutUserForTargetGQL extends Apollo.Query<LogoutUserForTargetQuery, LogoutUserForTargetQueryVariables> {
    document = LogoutUserForTargetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IsLoginForTargetExistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"isLoginForTargetExist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IsLoginForTargetExistInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isLoginForTargetExist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exist"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class IsLoginForTargetExistGQL extends Apollo.Query<IsLoginForTargetExistQuery, IsLoginForTargetExistQueryVariables> {
    document = IsLoginForTargetExistDocument;
    client = 'auth';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterForTargetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"registerForTarget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWithTargetInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registerForTarget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expiresIn"}},{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"apps"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"about"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"plugged"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isMailValid"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"mobileTheme"}},{"kind":"Field","name":{"kind":"Name","value":"placeOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"maritalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"newsletterSubs"}},{"kind":"Field","name":{"kind":"Name","value":"hasAutoGeneratedEmail"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterForTargetGQL extends Apollo.Mutation<RegisterForTargetMutation, RegisterForTargetMutationVariables> {
    document = RegisterForTargetDocument;
    client = 'auth';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterForTargetWithWholesalerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"registerForTargetWithWholesaler"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWithTargetInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registerForTargetWithWholesaler"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expiresIn"}},{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"apps"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"about"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"plugged"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isMailValid"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"mobileTheme"}},{"kind":"Field","name":{"kind":"Name","value":"placeOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"maritalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"newsletterSubs"}},{"kind":"Field","name":{"kind":"Name","value":"hasAutoGeneratedEmail"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterForTargetWithWholesalerGQL extends Apollo.Mutation<RegisterForTargetWithWholesalerMutation, RegisterForTargetWithWholesalerMutationVariables> {
    document = RegisterForTargetWithWholesalerDocument;
    client = 'auth';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvitePartnerToNetworkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"invitePartnerToNetwork"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PartnershipNetworkInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invitePartnerToNetwork"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partnership"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class InvitePartnerToNetworkGQL extends Apollo.Mutation<InvitePartnerToNetworkMutation, InvitePartnerToNetworkMutationVariables> {
    document = InvitePartnerToNetworkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendValidationEmailForTargetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendValidationEmailForTarget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subject"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendValidationEmailForTarget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"subject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subject"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accepted"}},{"kind":"Field","name":{"kind":"Name","value":"rejected"}},{"kind":"Field","name":{"kind":"Name","value":"response"}},{"kind":"Field","name":{"kind":"Name","value":"messageId"}},{"kind":"Field","name":{"kind":"Name","value":"messageTime"}},{"kind":"Field","name":{"kind":"Name","value":"messageSize"}},{"kind":"Field","name":{"kind":"Name","value":"envelopeTime"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class SendValidationEmailForTargetGQL extends Apollo.Mutation<SendValidationEmailForTargetMutation, SendValidationEmailForTargetMutationVariables> {
    document = SendValidationEmailForTargetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ValidateEmailForTargetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"validateEmailForTarget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateEmailForTarget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"apps"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"about"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"plugged"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isMailValid"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"mobileTheme"}},{"kind":"Field","name":{"kind":"Name","value":"placeOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"maritalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"newsletterSubs"}},{"kind":"Field","name":{"kind":"Name","value":"hasAutoGeneratedEmail"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class ValidateEmailForTargetGQL extends Apollo.Mutation<ValidateEmailForTargetMutation, ValidateEmailForTargetMutationVariables> {
    document = ValidateEmailForTargetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResetPasswordForTargetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"resetPasswordForTarget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserEventsSourceEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetPasswordForTarget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"apps"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"about"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"plugged"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isMailValid"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"mobileTheme"}},{"kind":"Field","name":{"kind":"Name","value":"placeOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"maritalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"newsletterSubs"}},{"kind":"Field","name":{"kind":"Name","value":"hasAutoGeneratedEmail"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class ResetPasswordForTargetGQL extends Apollo.Mutation<ResetPasswordForTargetMutation, ResetPasswordForTargetMutationVariables> {
    document = ResetPasswordForTargetDocument;
    client = 'auth';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveCurrentCorporateUserStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"saveCurrentCorporateUserStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserStatus"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveCurrentCorporateUserStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"apps"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"about"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"plugged"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isMailValid"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"mobileTheme"}},{"kind":"Field","name":{"kind":"Name","value":"placeOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"maritalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"newsletterSubs"}},{"kind":"Field","name":{"kind":"Name","value":"hasAutoGeneratedEmail"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveCurrentCorporateUserStatusGQL extends Apollo.Mutation<SaveCurrentCorporateUserStatusMutation, SaveCurrentCorporateUserStatusMutationVariables> {
    document = SaveCurrentCorporateUserStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendForgotPasswordMailToTargetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendForgotPasswordMailToTarget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"origin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendForgotPasswordMailToTarget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}},{"kind":"Argument","name":{"kind":"Name","value":"subject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subject"}}},{"kind":"Argument","name":{"kind":"Name","value":"origin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"origin"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accepted"}},{"kind":"Field","name":{"kind":"Name","value":"rejected"}},{"kind":"Field","name":{"kind":"Name","value":"response"}},{"kind":"Field","name":{"kind":"Name","value":"messageId"}},{"kind":"Field","name":{"kind":"Name","value":"messageTime"}},{"kind":"Field","name":{"kind":"Name","value":"messageSize"}},{"kind":"Field","name":{"kind":"Name","value":"envelopeTime"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class SendForgotPasswordMailToTargetGQL extends Apollo.Mutation<SendForgotPasswordMailToTargetMutation, SendForgotPasswordMailToTargetMutationVariables> {
    document = SendForgotPasswordMailToTargetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reason"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteUserReasonEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"reason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reason"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUserGQL extends Apollo.Mutation<DeleteUserMutation, DeleteUserMutationVariables> {
    document = DeleteUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCorporateRatingAssignmentByTargetCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCorporateRatingAssignmentByTargetCache"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCorporateRatingAssignmentByTargetCache"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"reviewDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviewType"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCorporateRatingAssignmentByTargetCacheGQL extends Apollo.Query<GetCorporateRatingAssignmentByTargetCacheQuery, GetCorporateRatingAssignmentByTargetCacheQueryVariables> {
    document = GetCorporateRatingAssignmentByTargetCacheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCorporateRatingDefinitionByReviewTypeCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCorporateRatingDefinitionByReviewTypeCache"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reviewType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCorporateRatingDefinitionByReviewTypeCache"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reviewType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reviewType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviewType"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCorporateRatingDefinitionByReviewTypeCacheGQL extends Apollo.Query<GetCorporateRatingDefinitionByReviewTypeCacheQuery, GetCorporateRatingDefinitionByReviewTypeCacheQueryVariables> {
    document = GetCorporateRatingDefinitionByReviewTypeCacheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCorporateRatingsByProductWithStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCorporateRatingsByProductWithStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCorporateRatingsByProductWithStats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mark"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviewType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviewType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"stats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mark"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCorporateRatingsByProductWithStatsGQL extends Apollo.Query<GetCorporateRatingsByProductWithStatsQuery, GetCorporateRatingsByProductWithStatsQueryVariables> {
    document = GetCorporateRatingsByProductWithStatsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCurrentUserCorporateRatingsByProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCurrentUserCorporateRatingsByProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCurrentUserCorporateRatingsByProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mark"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviewType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviewType"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCurrentUserCorporateRatingsByProductGQL extends Apollo.Query<GetCurrentUserCorporateRatingsByProductQuery, GetCurrentUserCorporateRatingsByProductQueryVariables> {
    document = GetCurrentUserCorporateRatingsByProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAverageCorporateProductRatingsByProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAverageCorporateProductRatingsByProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAverageCorporateProductRatingsByProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"overAllAverage"}},{"kind":"Field","name":{"kind":"Name","value":"byMark"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mark"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAverageCorporateProductRatingsByProductGQL extends Apollo.Query<GetAverageCorporateProductRatingsByProductQuery, GetAverageCorporateProductRatingsByProductQueryVariables> {
    document = GetAverageCorporateProductRatingsByProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCorporateRatingsByProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCorporateRatingsByProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCorporateRatingsByProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mark"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviewType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviewType"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCorporateRatingsByProductGQL extends Apollo.Query<GetCorporateRatingsByProductQuery, GetCorporateRatingsByProductQueryVariables> {
    document = GetCorporateRatingsByProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCorporateRatingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCorporateRating"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CorporateRatingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCorporateRating"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mark"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviewType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviewType"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCorporateRatingGQL extends Apollo.Mutation<CreateCorporateRatingMutation, CreateCorporateRatingMutationVariables> {
    document = CreateCorporateRatingDocument;
    client = 'api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCorporateRatingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCorporateRating"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CorporateUpdateRatingInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCorporateRating"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mark"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviewType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviewType"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCorporateRatingGQL extends Apollo.Mutation<UpdateCorporateRatingMutation, UpdateCorporateRatingMutationVariables> {
    document = UpdateCorporateRatingDocument;
    client = 'api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCorporateRatingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteCorporateRating"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCorporateRating"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCorporateRatingGQL extends Apollo.Mutation<DeleteCorporateRatingMutation, DeleteCorporateRatingMutationVariables> {
    document = DeleteCorporateRatingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindCountriesPaginationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findCountriesPagination"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCountriesPagination"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class FindCountriesPaginationGQL extends Apollo.Query<FindCountriesPaginationQuery, FindCountriesPaginationQueryVariables> {
    document = FindCountriesPaginationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCountriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCountries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCountries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCountriesGQL extends Apollo.Query<GetCountriesQuery, GetCountriesQueryVariables> {
    document = GetCountriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IsCouponValidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"isCouponValid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"couponCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isCouponValid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"couponCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"couponCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"coupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"redeemed"}},{"kind":"Field","name":{"kind":"Name","value":"couponCode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class IsCouponValidGQL extends Apollo.Query<IsCouponValidQuery, IsCouponValidQueryVariables> {
    document = IsCouponValidDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindCouponByTargetAndCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findCouponByTargetAndCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"couponCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCouponByTargetAndCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"couponCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"couponCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"redeemed"}},{"kind":"Field","name":{"kind":"Name","value":"couponCode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class FindCouponByTargetAndCodeGQL extends Apollo.Query<FindCouponByTargetAndCodeQuery, FindCouponByTargetAndCodeQueryVariables> {
    document = FindCouponByTargetAndCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RedeemCouponDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"redeemCoupon"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"couponCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redeemCoupon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"couponCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"couponCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"redeemed"}},{"kind":"Field","name":{"kind":"Name","value":"couponCode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class RedeemCouponGQL extends Apollo.Mutation<RedeemCouponMutation, RedeemCouponMutationVariables> {
    document = RedeemCouponDocument;
    client = 'api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindDeliveryZonesByTargetCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findDeliveryZonesByTargetCache"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findDeliveryZonesByTargetCache"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"radius"}},{"kind":"Field","name":{"kind":"Name","value":"minPrice"}},{"kind":"Field","name":{"kind":"Name","value":"extraFees"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"paths"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class FindDeliveryZonesByTargetCacheGQL extends Apollo.Query<FindDeliveryZonesByTargetCacheQuery, FindDeliveryZonesByTargetCacheQueryVariables> {
    document = FindDeliveryZonesByTargetCacheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDocumentGQL extends Apollo.Mutation<CreateDocumentMutation, CreateDocumentMutationVariables> {
    document = CreateDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEventByTargetAndCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEventByTargetAndCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEventByTargetAndCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}},{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEventByTargetAndCodeGQL extends Apollo.Query<GetEventByTargetAndCodeQuery, GetEventByTargetAndCodeQueryVariables> {
    document = GetEventByTargetAndCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateEventInviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createEventInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventInviteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEventInvite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateEventInviteGQL extends Apollo.Mutation<CreateEventInviteMutation, CreateEventInviteMutationVariables> {
    document = CreateEventInviteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEventInvitesWithFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEventInvitesWithFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pos"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEventInvitesWithFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"target"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pos"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pos"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"invitee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invitor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEventInvitesWithFilterGQL extends Apollo.Query<GetEventInvitesWithFilterQuery, GetEventInvitesWithFilterQueryVariables> {
    document = GetEventInvitesWithFilterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPartnershipNetworksByTargetPaginationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPartnershipNetworksByTargetPagination"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pos"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPartnershipNetworksByTargetPagination"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pos"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pos"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partnership"}},{"kind":"Field","name":{"kind":"Name","value":"partner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPartnershipNetworksByTargetPaginationGQL extends Apollo.Query<GetPartnershipNetworksByTargetPaginationQuery, GetPartnershipNetworksByTargetPaginationQueryVariables> {
    document = GetPartnershipNetworksByTargetPaginationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCorporateUsersByTargetAndWholesalerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCorporateUsersByTargetAndWholesaler"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pos"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wholesalerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCorporateUsersByTargetAndWholesaler"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pos"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pos"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"wholesaler"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wholesalerId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCorporateUsersByTargetAndWholesalerGQL extends Apollo.Query<GetCorporateUsersByTargetAndWholesalerQuery, GetCorporateUsersByTargetAndWholesalerQueryVariables> {
    document = GetCorporateUsersByTargetAndWholesalerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertEventTicketsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertEventTickets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventTicketInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertEventTickets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertEventTicketsGQL extends Apollo.Mutation<InsertEventTicketsMutation, InsertEventTicketsMutationVariables> {
    document = InsertEventTicketsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEventTicketsWithFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEventTicketsWithFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pos"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEventTicketsWithFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"target"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pos"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pos"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"ticketUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"zone"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEventTicketsWithFilterGQL extends Apollo.Query<GetEventTicketsWithFilterQuery, GetEventTicketsWithFilterQueryVariables> {
    document = GetEventTicketsWithFilterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEventTicketByReferenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEventTicketByReference"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pos"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEventTicketByReference"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}},{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pos"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pos"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"zone"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"validity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"ticketUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEventTicketByReferenceGQL extends Apollo.Query<GetEventTicketByReferenceQuery, GetEventTicketByReferenceQueryVariables> {
    document = GetEventTicketByReferenceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkTicketAsAttendedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"markTicketAsAttended"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markTicketAsAttended"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkTicketAsAttendedGQL extends Apollo.Mutation<MarkTicketAsAttendedMutation, MarkTicketAsAttendedMutationVariables> {
    document = MarkTicketAsAttendedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFavoriteSimpleProductByCurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFavoriteSimpleProductByCurrentUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getFavoriteSimpleProductByCurrentUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicPrice"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFavoriteSimpleProductByCurrentUserGQL extends Apollo.Query<GetFavoriteSimpleProductByCurrentUserQuery, GetFavoriteSimpleProductByCurrentUserQueryVariables> {
    document = GetFavoriteSimpleProductByCurrentUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkSimpleProductAsFavoriteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"markSimpleProductAsFavorite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markSimpleProductAsFavorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkSimpleProductAsFavoriteGQL extends Apollo.Mutation<MarkSimpleProductAsFavoriteMutation, MarkSimpleProductAsFavoriteMutationVariables> {
    document = MarkSimpleProductAsFavoriteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveSimpleProductFromFavoritesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeSimpleProductFromFavorites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeSimpleProductFromFavorites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveSimpleProductFromFavoritesGQL extends Apollo.Mutation<RemoveSimpleProductFromFavoritesMutation, RemoveSimpleProductFromFavoritesMutationVariables> {
    document = RemoveSimpleProductFromFavoritesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetGamesPaginatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getGamesPaginated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getGamesPaginated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"point"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"globalRatio"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"font"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"family"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"preview"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sound"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"gameConfigs"}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"coin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"isRare"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"fallback"}},{"kind":"Field","name":{"kind":"Name","value":"qualitative"}},{"kind":"Field","name":{"kind":"Name","value":"empty"}},{"kind":"Field","name":{"kind":"Name","value":"again"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetGamesPaginatedGQL extends Apollo.Query<GetGamesPaginatedQuery, GetGamesPaginatedQueryVariables> {
    document = GetGamesPaginatedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOrderInstallmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOrderInstallment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrderInstallment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"installmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"materialIcon"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"svg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOrderInstallmentGQL extends Apollo.Query<GetOrderInstallmentQuery, GetOrderInstallmentQueryVariables> {
    document = GetOrderInstallmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateMarketPlaceOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createMarketPlaceOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarketPlaceOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMarketPlaceOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"orderTime"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"hasInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryFees"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"apps"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"about"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"plugged"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isMailValid"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"mobileTheme"}},{"kind":"Field","name":{"kind":"Name","value":"placeOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"maritalStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"guestUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"extraFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"installments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"materialIcon"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"svg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shoppingCart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"toPay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitNet"}},{"kind":"Field","name":{"kind":"Name","value":"unitGross"}},{"kind":"Field","name":{"kind":"Name","value":"net"}},{"kind":"Field","name":{"kind":"Name","value":"gross"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderProductStatus"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateMarketPlaceOrderGQL extends Apollo.Mutation<CreateMarketPlaceOrderMutation, CreateMarketPlaceOrderMutationVariables> {
    document = CreateMarketPlaceOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelProductByConsumerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cancelProductByConsumer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarketPlaceOrderProductInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelProductByConsumer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"orderTime"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"hasInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryFees"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"apps"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"about"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"plugged"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isMailValid"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"mobileTheme"}},{"kind":"Field","name":{"kind":"Name","value":"placeOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"maritalStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"guestUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"extraFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"installments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"materialIcon"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"svg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shoppingCart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"toPay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitNet"}},{"kind":"Field","name":{"kind":"Name","value":"unitGross"}},{"kind":"Field","name":{"kind":"Name","value":"net"}},{"kind":"Field","name":{"kind":"Name","value":"gross"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderProductStatus"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pixel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"include"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelProductByConsumerGQL extends Apollo.Mutation<CancelProductByConsumerMutation, CancelProductByConsumerMutationVariables> {
    document = CancelProductByConsumerDocument;
    client = 'api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PayMarketplaceOrderInstallmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"payMarketplaceOrderInstallments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InstallmentPaymentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payMarketplaceOrderInstallments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"orderTime"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"hasInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryFees"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"apps"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"about"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"plugged"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isMailValid"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"mobileTheme"}},{"kind":"Field","name":{"kind":"Name","value":"placeOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"maritalStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"guestUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"extraFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"installments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"materialIcon"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"svg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shoppingCart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"toPay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitNet"}},{"kind":"Field","name":{"kind":"Name","value":"unitGross"}},{"kind":"Field","name":{"kind":"Name","value":"net"}},{"kind":"Field","name":{"kind":"Name","value":"gross"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderProductStatus"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceCredit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periodCycle"}},{"kind":"Field","name":{"kind":"Name","value":"periodValue"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class PayMarketplaceOrderInstallmentsGQL extends Apollo.Mutation<PayMarketplaceOrderInstallmentsMutation, PayMarketplaceOrderInstallmentsMutationVariables> {
    document = PayMarketplaceOrderInstallmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSimpleProductWithProductAttributesAndFavoriteStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSimpleProductWithProductAttributesAndFavoriteStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSimpleProductWithProductAttributesAndFavoriteStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"longdesc"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionList"}},{"kind":"Field","name":{"kind":"Name","value":"specs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"specs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"longdesc"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionList"}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isFavorite"}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"specs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"prevMaintenanceDuration"}},{"kind":"Field","name":{"kind":"Name","value":"maintenanceDuration"}},{"kind":"Field","name":{"kind":"Name","value":"expectedMeantime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicPrice"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceBeforeReduction"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSimpleProductWithProductAttributesAndFavoriteStatusGQL extends Apollo.Query<GetSimpleProductWithProductAttributesAndFavoriteStatusQuery, GetSimpleProductWithProductAttributesAndFavoriteStatusQueryVariables> {
    document = GetSimpleProductWithProductAttributesAndFavoriteStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusWithFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusWithFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetInternalProductWithFilterPaginatedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusWithFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"longdesc"}},{"kind":"Field","name":{"kind":"Name","value":"specs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicPrice"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceBeforeReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratings"}},{"kind":"Field","name":{"kind":"Name","value":"isFavorite"}}]}},{"kind":"Field","name":{"kind":"Name","value":"filter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"brands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAtRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAtRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"attributeValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusWithFilterGQL extends Apollo.Query<GetSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusWithFilterQuery, GetSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusWithFilterQueryVariables> {
    document = GetSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusWithFilterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetInternalProductWithFilterPaginatedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicPrice"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceBeforeReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratings"}},{"kind":"Field","name":{"kind":"Name","value":"isFavorite"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusGQL extends Apollo.Query<GetSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusQuery, GetSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusQueryVariables> {
    document = GetSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSimpleProductWithProductAttributesAndFavoriteStatusByUrlKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSimpleProductWithProductAttributesAndFavoriteStatusByUrlKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"urlKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSimpleProductWithProductAttributesAndFavoriteStatusByUrlKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}},{"kind":"Argument","name":{"kind":"Name","value":"urlKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"urlKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"longdesc"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionList"}},{"kind":"Field","name":{"kind":"Name","value":"specs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"specs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"longdesc"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionList"}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isFavorite"}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicPrice"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceBeforeReduction"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSimpleProductWithProductAttributesAndFavoriteStatusByUrlKeyGQL extends Apollo.Query<GetSimpleProductWithProductAttributesAndFavoriteStatusByUrlKeyQuery, GetSimpleProductWithProductAttributesAndFavoriteStatusByUrlKeyQueryVariables> {
    document = GetSimpleProductWithProductAttributesAndFavoriteStatusByUrlKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSimpleProductWithFavoriteStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSimpleProductWithFavoriteStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSimpleProductWithFavoriteStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"specs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"longdesc"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionList"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isFavorite"}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicPrice"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceBeforeReduction"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSimpleProductWithFavoriteStatusGQL extends Apollo.Query<GetSimpleProductWithFavoriteStatusQuery, GetSimpleProductWithFavoriteStatusQueryVariables> {
    document = GetSimpleProductWithFavoriteStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSimpleProductsByCatalogueCategoryWithFavoriteStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSimpleProductsByCatalogueCategoryWithFavoriteStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogueCategoryIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductStatusEnum"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSimpleProductsByCatalogueCategoryWithFavoriteStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogueCategoryIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogueCategoryIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"specs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isFavorite"}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicPrice"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceBeforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"productAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"pixel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pixelAttribute"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"pixel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pixelAttribute"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSimpleProductsByCatalogueCategoryWithFavoriteStatusGQL extends Apollo.Query<GetSimpleProductsByCatalogueCategoryWithFavoriteStatusQuery, GetSimpleProductsByCatalogueCategoryWithFavoriteStatusQueryVariables> {
    document = GetSimpleProductsByCatalogueCategoryWithFavoriteStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchInternalProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchInternalProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchString"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchInternalProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchString"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"specs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"globalCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"googleCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facebookCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceCredit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periodCycle"}},{"kind":"Field","name":{"kind":"Name","value":"periodValue"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchInternalProductGQL extends Apollo.Query<SearchInternalProductQuery, SearchInternalProductQueryVariables> {
    document = SearchInternalProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetInternalProductWithFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInternalProductWithFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchString"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InternalProductFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getInternalProductWithFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"searchString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchString"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"specs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"globalCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"googleCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facebookCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceCredit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periodCycle"}},{"kind":"Field","name":{"kind":"Name","value":"periodValue"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pixel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"include"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"filter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"brands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAtRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAtRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"attributeValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetInternalProductWithFilterGQL extends Apollo.Query<GetInternalProductWithFilterQuery, GetInternalProductWithFilterQueryVariables> {
    document = GetInternalProductWithFilterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSimpleProductsWithRatingsWithFavoriteStatusWithFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSimpleProductsWithRatingsWithFavoriteStatusWithFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetInternalProductWithFilterPaginatedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSimpleProductsWithRatingsWithFavoriteStatusWithFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"specs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"pixel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pixelAttribute"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"pixel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pixelAttribute"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicPrice"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceBeforeReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratings"}},{"kind":"Field","name":{"kind":"Name","value":"isFavorite"}}]}},{"kind":"Field","name":{"kind":"Name","value":"filter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"brands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAtRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAtRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"attributeValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSimpleProductsWithRatingsWithFavoriteStatusWithFilterGQL extends Apollo.Query<GetSimpleProductsWithRatingsWithFavoriteStatusWithFilterQuery, GetSimpleProductsWithRatingsWithFavoriteStatusWithFilterQueryVariables> {
    document = GetSimpleProductsWithRatingsWithFavoriteStatusWithFilterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetInternalProductsByClassDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInternalProductsByClass"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"classification"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductClassEnum"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getInternalProductsByClass"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"classification"},"value":{"kind":"Variable","name":{"kind":"Name","value":"classification"}}},{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"pixel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pixelAttribute"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicPrice"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceBeforeReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetInternalProductsByClassGQL extends Apollo.Query<GetInternalProductsByClassQuery, GetInternalProductsByClassQueryVariables> {
    document = GetInternalProductsByClassDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSimpleProductsByTargetGroupedByClassWithFavoriteStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSimpleProductsByTargetGroupedByClassWithFavoriteStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductStatusEnum"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSimpleProductsByTargetGroupedByClassWithFavoriteStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PROMO"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratings"}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"publicPrice"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceBeforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"productAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isFavorite"}}]}},{"kind":"Field","name":{"kind":"Name","value":"BEST_SELLERS"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratings"}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"publicPrice"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceBeforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"productAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isFavorite"}}]}},{"kind":"Field","name":{"kind":"Name","value":"NEW_ARRIVALS"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratings"}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"publicPrice"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceBeforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"productAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isFavorite"}}]}},{"kind":"Field","name":{"kind":"Name","value":"TOP_PRODUCTS"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratings"}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"publicPrice"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceBeforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"productAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isFavorite"}}]}},{"kind":"Field","name":{"kind":"Name","value":"FEATURED_PRODUCTS"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratings"}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"publicPrice"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceBeforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"productAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isFavorite"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSimpleProductsByTargetGroupedByClassWithFavoriteStatusGQL extends Apollo.Query<GetSimpleProductsByTargetGroupedByClassWithFavoriteStatusQuery, GetSimpleProductsByTargetGroupedByClassWithFavoriteStatusQueryVariables> {
    document = GetSimpleProductsByTargetGroupedByClassWithFavoriteStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSimpleProductsByTargetAndCatalogueCategoryUrlKeyWithFavoriteStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSimpleProductsByTargetAndCatalogueCategoryUrlKeyWithFavoriteStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"urlKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSimpleProductsByTargetAndCatalogueCategoryUrlKeyWithFavoriteStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}},{"kind":"Argument","name":{"kind":"Name","value":"urlKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"urlKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isFavorite"}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicPrice"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceBeforeReduction"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSimpleProductsByTargetAndCatalogueCategoryUrlKeyWithFavoriteStatusGQL extends Apollo.Query<GetSimpleProductsByTargetAndCatalogueCategoryUrlKeyWithFavoriteStatusQuery, GetSimpleProductsByTargetAndCatalogueCategoryUrlKeyWithFavoriteStatusQueryVariables> {
    document = GetSimpleProductsByTargetAndCatalogueCategoryUrlKeyWithFavoriteStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSimpleProductWithFavoriteStatusByUrlKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSimpleProductWithFavoriteStatusByUrlKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"urlKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSimpleProductWithFavoriteStatusByUrlKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}},{"kind":"Argument","name":{"kind":"Name","value":"urlKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"urlKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"specs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"longdesc"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionList"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isFavorite"}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicPrice"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceBeforeReduction"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSimpleProductWithFavoriteStatusByUrlKeyGQL extends Apollo.Query<GetSimpleProductWithFavoriteStatusByUrlKeyQuery, GetSimpleProductWithFavoriteStatusByUrlKeyQueryVariables> {
    document = GetSimpleProductWithFavoriteStatusByUrlKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBarcodeByProductAndAttributesCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBarcodeByProductAndAttributesCache"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BarcodeFindInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBarcodeByProductAndAttributesCache"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sign"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"use"}},{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rank"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceCredit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periodCycle"}},{"kind":"Field","name":{"kind":"Name","value":"periodValue"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pixel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"include"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"pixel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pixelAttribute"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"descriptionList"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBarcodeByProductAndAttributesCacheGQL extends Apollo.Query<GetBarcodeByProductAndAttributesCacheQuery, GetBarcodeByProductAndAttributesCacheQueryVariables> {
    document = GetBarcodeByProductAndAttributesCacheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProductBarcodesCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProductBarcodesCache"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProductBarcodesCache"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sign"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"use"}},{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rank"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceCredit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periodCycle"}},{"kind":"Field","name":{"kind":"Name","value":"periodValue"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pixel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"include"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"pixel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pixelAttribute"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"pixel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pixelAttribute"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionList"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProductBarcodesCacheGQL extends Apollo.Query<GetProductBarcodesCacheQuery, GetProductBarcodesCacheQueryVariables> {
    document = GetProductBarcodesCacheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProductAttributesCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProductAttributesCache"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProductAttributesCache"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"possibleValues"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"pixel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pixelAttribute"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProductAttributesCacheGQL extends Apollo.Query<GetProductAttributesCacheQuery, GetProductAttributesCacheQueryVariables> {
    document = GetProductAttributesCacheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateJobApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createJobApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JobApplicationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createJobApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"cv"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"png"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"svg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"black"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"png"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"svg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"white"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"png"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"svg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cover"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"png"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"svg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"black"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"png"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"svg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"white"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"png"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"svg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"jobDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateJobApplicationGQL extends Apollo.Mutation<CreateJobApplicationMutation, CreateJobApplicationMutationVariables> {
    document = CreateJobApplicationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetJobDefinitionsByTargetAndStatusPaginationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getJobDefinitionsByTargetAndStatusPagination"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JobDefinitionStatusEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getJobDefinitionsByTargetAndStatusPagination"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionList"}}]}},{"kind":"Field","name":{"kind":"Name","value":"responsibility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionList"}}]}},{"kind":"Field","name":{"kind":"Name","value":"offer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionList"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetJobDefinitionsByTargetAndStatusPaginationGQL extends Apollo.Query<GetJobDefinitionsByTargetAndStatusPaginationQuery, GetJobDefinitionsByTargetAndStatusPaginationQueryVariables> {
    document = GetJobDefinitionsByTargetAndStatusPaginationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const JobDefinitionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"jobDefinition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobDefinition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionList"}}]}},{"kind":"Field","name":{"kind":"Name","value":"responsibility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionList"}}]}},{"kind":"Field","name":{"kind":"Name","value":"offer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionList"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class JobDefinitionGQL extends Apollo.Query<JobDefinitionQuery, JobDefinitionQueryVariables> {
    document = JobDefinitionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindLandingPagesByUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findLandingPagesByUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findLandingPagesByUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}},{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageReference"}},{"kind":"Field","name":{"kind":"Name","value":"pageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"pageType"}},{"kind":"Field","name":{"kind":"Name","value":"sectionData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sectionTitle"}},{"kind":"Field","name":{"kind":"Name","value":"sectionContent"}},{"kind":"Field","name":{"kind":"Name","value":"sectionReference"}},{"kind":"Field","name":{"kind":"Name","value":"sectionPictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class FindLandingPagesByUrlGQL extends Apollo.Query<FindLandingPagesByUrlQuery, FindLandingPagesByUrlQueryVariables> {
    document = FindLandingPagesByUrlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindLandingPagesByTargetAndTypePaginatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findLandingPagesByTargetAndTypePaginated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageType"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LandingPageTypeEnum"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findLandingPagesByTargetAndTypePaginated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageType"}}},{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageReference"}},{"kind":"Field","name":{"kind":"Name","value":"pageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"pageType"}},{"kind":"Field","name":{"kind":"Name","value":"sectionData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sectionTitle"}},{"kind":"Field","name":{"kind":"Name","value":"sectionContent"}},{"kind":"Field","name":{"kind":"Name","value":"sectionReference"}},{"kind":"Field","name":{"kind":"Name","value":"sectionPictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class FindLandingPagesByTargetAndTypePaginatedGQL extends Apollo.Query<FindLandingPagesByTargetAndTypePaginatedQuery, FindLandingPagesByTargetAndTypePaginatedQueryVariables> {
    document = FindLandingPagesByTargetAndTypePaginatedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddUserToNewsLetterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addUserToNewsLetter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addUserToNewsLetter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class AddUserToNewsLetterGQL extends Apollo.Mutation<AddUserToNewsLetterMutation, AddUserToNewsLetterMutationVariables> {
    document = AddUserToNewsLetterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOrderSettingsByTargetCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOrderSettingsByTargetCache"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrderSettingsByTargetCache"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pickup"}},{"kind":"Field","name":{"kind":"Name","value":"delivery"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePickup"}},{"kind":"Field","name":{"kind":"Name","value":"portalPickup"}},{"kind":"Field","name":{"kind":"Name","value":"pickupTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facebookPickup"}},{"kind":"Field","name":{"kind":"Name","value":"mobileDelivery"}},{"kind":"Field","name":{"kind":"Name","value":"portalDelivery"}},{"kind":"Field","name":{"kind":"Name","value":"showMenuInPortal"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facebookDelivery"}},{"kind":"Field","name":{"kind":"Name","value":"nonPickupDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"days"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nonDeliveryDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"days"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryCountries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryStates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"extraFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"definition"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOrderSettingsByTargetCacheGQL extends Apollo.Query<GetOrderSettingsByTargetCacheQuery, GetOrderSettingsByTargetCacheQueryVariables> {
    document = GetOrderSettingsByTargetCacheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PointOfSaleCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"pointOfSaleCache"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pointOfSaleCache"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"currencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"default"}}]}},{"kind":"Field","name":{"kind":"Name","value":"turnover"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"brandColor"}},{"kind":"Field","name":{"kind":"Name","value":"isFollowed"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmails"}},{"kind":"Field","name":{"kind":"Name","value":"averageCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"languages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outsidePictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insidePictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialOffers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offerType"}},{"kind":"Field","name":{"kind":"Name","value":"hours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"chatContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"fontIcon"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"style"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"svg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size48"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size96"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size144"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size240"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size480"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"socialMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"fontIcon"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"style"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"svg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size48"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size96"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size144"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size240"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size480"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"materialIcon"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"svg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"card_flat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dark"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"light"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class PointOfSaleCacheGQL extends Apollo.Query<PointOfSaleCacheQuery, PointOfSaleCacheQueryVariables> {
    document = PointOfSaleCacheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProgramsByEventPaginationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProgramsByEventPagination"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProgramsByEventPagination"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"event"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProgramsByEventPaginationGQL extends Apollo.Query<GetProgramsByEventPaginationQuery, GetProgramsByEventPaginationQueryVariables> {
    document = GetProgramsByEventPaginationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSimpleOngoingPromotionsByTargetPaginateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSimpleOngoingPromotionsByTargetPaginate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PromotionFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSimpleOngoingPromotionsByTargetPaginate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceCredit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periodCycle"}},{"kind":"Field","name":{"kind":"Name","value":"periodValue"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSimpleOngoingPromotionsByTargetPaginateGQL extends Apollo.Query<GetSimpleOngoingPromotionsByTargetPaginateQuery, GetSimpleOngoingPromotionsByTargetPaginateQueryVariables> {
    document = GetSimpleOngoingPromotionsByTargetPaginateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRecentlyViewedProductsByUserPaginatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRecentlyViewedProductsByUserPaginated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRecentlyViewedProductsByUserPaginated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"specs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceCredit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periodCycle"}},{"kind":"Field","name":{"kind":"Name","value":"periodValue"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"flags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRecentlyViewedProductsByUserPaginatedGQL extends Apollo.Query<GetRecentlyViewedProductsByUserPaginatedQuery, GetRecentlyViewedProductsByUserPaginatedQueryVariables> {
    document = GetRecentlyViewedProductsByUserPaginatedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateRecentlyViewedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createRecentlyViewed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"product"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRecentlyViewed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"product"},"value":{"kind":"Variable","name":{"kind":"Name","value":"product"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateRecentlyViewedGQL extends Apollo.Mutation<CreateRecentlyViewedMutation, CreateRecentlyViewedMutationVariables> {
    document = CreateRecentlyViewedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"requestor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatId"}},{"kind":"Field","name":{"kind":"Name","value":"registerNo"}},{"kind":"Field","name":{"kind":"Name","value":"licenceNo"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateRequestGQL extends Apollo.Mutation<CreateRequestMutation, CreateRequestMutationVariables> {
    document = CreateRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindSeoByTargetCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findSEOByTargetCache"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findSEOByTargetCache"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleTag"}},{"kind":"Field","name":{"kind":"Name","value":"googleAnalyticsId"}},{"kind":"Field","name":{"kind":"Name","value":"headerTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metaDescriptionTag"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class FindSeoByTargetCacheGQL extends Apollo.Query<FindSeoByTargetCacheQuery, FindSeoByTargetCacheQueryVariables> {
    document = FindSeoByTargetCacheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBlogSeojsonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBlogSEOJSON"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"blogId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBlogSEOJSON"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"blogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"blogId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"metas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rel"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scripts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBlogSeojsonGQL extends Apollo.Query<GetBlogSeojsonQuery, GetBlogSeojsonQueryVariables> {
    document = GetBlogSeojsonDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetGeneralSeojsonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getGeneralSEOJSON"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getGeneralSEOJSON"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"metas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rel"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scripts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetGeneralSeojsonGQL extends Apollo.Query<GetGeneralSeojsonQuery, GetGeneralSeojsonQueryVariables> {
    document = GetGeneralSeojsonDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMainCategorySeojsonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMainCategorySEOJSON"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMainCategorySEOJSON"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"metas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rel"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scripts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMainCategorySeojsonGQL extends Apollo.Query<GetMainCategorySeojsonQuery, GetMainCategorySeojsonQueryVariables> {
    document = GetMainCategorySeojsonDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMainPageSeojsonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMainPageSEOJSON"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMainPageSEOJSON"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"metas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rel"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scripts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMainPageSeojsonGQL extends Apollo.Query<GetMainPageSeojsonQuery, GetMainPageSeojsonQueryVariables> {
    document = GetMainPageSeojsonDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPagesSeojsonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPagesSEOJSON"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPagesSEOJSON"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"metas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rel"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scripts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPagesSeojsonGQL extends Apollo.Query<GetPagesSeojsonQuery, GetPagesSeojsonQueryVariables> {
    document = GetPagesSeojsonDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSimpleProductSeojsonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSimpleProductSEOJSON"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"barcodeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSimpleProductSEOJSON"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"barcodeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"barcodeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"metas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rel"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scripts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSimpleProductSeojsonGQL extends Apollo.Query<GetSimpleProductSeojsonQuery, GetSimpleProductSeojsonQueryVariables> {
    document = GetSimpleProductSeojsonDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSubCategorySeojsonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSubCategorySEOJSON"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSubCategorySEOJSON"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"metas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rel"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scripts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSubCategorySeojsonGQL extends Apollo.Query<GetSubCategorySeojsonQuery, GetSubCategorySeojsonQueryVariables> {
    document = GetSubCategorySeojsonDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CalculateShoppingCartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"calculateShoppingCart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"products"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CartProductInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculateShoppingCart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"products"},"value":{"kind":"Variable","name":{"kind":"Name","value":"products"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"toPay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"barcode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceBeforeReduction"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class CalculateShoppingCartGQL extends Apollo.Query<CalculateShoppingCartQuery, CalculateShoppingCartQueryVariables> {
    document = CalculateShoppingCartDocument;
    client = 'api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ValidateShoppingCartByCurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"validateShoppingCartByCurrentUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LonLatInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateShoppingCartByCurrentUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryFees"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePickup"}},{"kind":"Field","name":{"kind":"Name","value":"portalPickup"}},{"kind":"Field","name":{"kind":"Name","value":"mobileDelivery"}},{"kind":"Field","name":{"kind":"Name","value":"portalDelivery"}},{"kind":"Field","name":{"kind":"Name","value":"inDeliveryZone"}},{"kind":"Field","name":{"kind":"Name","value":"activatePickup"}},{"kind":"Field","name":{"kind":"Name","value":"facebookPickup"}},{"kind":"Field","name":{"kind":"Name","value":"activateDelivery"}},{"kind":"Field","name":{"kind":"Name","value":"facebookDelivery"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitNet"}},{"kind":"Field","name":{"kind":"Name","value":"unitGross"}},{"kind":"Field","name":{"kind":"Name","value":"net"}},{"kind":"Field","name":{"kind":"Name","value":"gross"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceCredit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periodCycle"}},{"kind":"Field","name":{"kind":"Name","value":"periodValue"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"specs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class ValidateShoppingCartByCurrentUserGQL extends Apollo.Query<ValidateShoppingCartByCurrentUserQuery, ValidateShoppingCartByCurrentUserQueryVariables> {
    document = ValidateShoppingCartByCurrentUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindShoppingCartByUserAndTargetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findShoppingCartByUserAndTarget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findShoppingCartByUserAndTarget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"toPay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitNet"}},{"kind":"Field","name":{"kind":"Name","value":"unitGross"}},{"kind":"Field","name":{"kind":"Name","value":"net"}},{"kind":"Field","name":{"kind":"Name","value":"gross"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceCredit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periodCycle"}},{"kind":"Field","name":{"kind":"Name","value":"periodValue"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"specs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"pixel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pixelAttribute"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicPrice"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceBeforeReduction"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class FindShoppingCartByUserAndTargetGQL extends Apollo.Query<FindShoppingCartByUserAndTargetQuery, FindShoppingCartByUserAndTargetQueryVariables> {
    document = FindShoppingCartByUserAndTargetDocument;
    client = 'api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindShoppingCartByUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findShoppingCartByUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findShoppingCartByUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"toPay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitNet"}},{"kind":"Field","name":{"kind":"Name","value":"unitGross"}},{"kind":"Field","name":{"kind":"Name","value":"net"}},{"kind":"Field","name":{"kind":"Name","value":"gross"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceCredit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periodCycle"}},{"kind":"Field","name":{"kind":"Name","value":"periodValue"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"specs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class FindShoppingCartByUserGQL extends Apollo.Query<FindShoppingCartByUserQuery, FindShoppingCartByUserQueryVariables> {
    document = FindShoppingCartByUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddProductsToCartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addProductsToCart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"products"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CartProductInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addProductsToCart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"products"},"value":{"kind":"Variable","name":{"kind":"Name","value":"products"}}},{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"toPay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitNet"}},{"kind":"Field","name":{"kind":"Name","value":"unitGross"}},{"kind":"Field","name":{"kind":"Name","value":"net"}},{"kind":"Field","name":{"kind":"Name","value":"gross"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceCredit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periodCycle"}},{"kind":"Field","name":{"kind":"Name","value":"periodValue"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"specs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"pixel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pixelAttribute"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"pixel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pixelAttribute"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"prevMaintenanceDuration"}},{"kind":"Field","name":{"kind":"Name","value":"maintenanceDuration"}},{"kind":"Field","name":{"kind":"Name","value":"expectedMeantime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicPrice"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceBeforeReduction"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class AddProductsToCartGQL extends Apollo.Mutation<AddProductsToCartMutation, AddProductsToCartMutationVariables> {
    document = AddProductsToCartDocument;
    client = 'api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveFromCartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeFromCart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"product"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CartProductInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeFromCart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"product"},"value":{"kind":"Variable","name":{"kind":"Name","value":"product"}}},{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"toPay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitNet"}},{"kind":"Field","name":{"kind":"Name","value":"unitGross"}},{"kind":"Field","name":{"kind":"Name","value":"net"}},{"kind":"Field","name":{"kind":"Name","value":"gross"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceCredit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periodCycle"}},{"kind":"Field","name":{"kind":"Name","value":"periodValue"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"specs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicPrice"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceBeforeReduction"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveFromCartGQL extends Apollo.Mutation<RemoveFromCartMutation, RemoveFromCartMutationVariables> {
    document = RemoveFromCartDocument;
    client = 'api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddDiscountToCartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addDiscountToCart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DiscountDtoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addDiscountToCart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"toPay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitNet"}},{"kind":"Field","name":{"kind":"Name","value":"unitGross"}},{"kind":"Field","name":{"kind":"Name","value":"net"}},{"kind":"Field","name":{"kind":"Name","value":"gross"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceCredit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periodCycle"}},{"kind":"Field","name":{"kind":"Name","value":"periodValue"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"specs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class AddDiscountToCartGQL extends Apollo.Mutation<AddDiscountToCartMutation, AddDiscountToCartMutationVariables> {
    document = AddDiscountToCartDocument;
    client = 'api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EmptyCartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"emptyCart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emptyCart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"toPay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitNet"}},{"kind":"Field","name":{"kind":"Name","value":"unitGross"}},{"kind":"Field","name":{"kind":"Name","value":"net"}},{"kind":"Field","name":{"kind":"Name","value":"gross"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceCredit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periodCycle"}},{"kind":"Field","name":{"kind":"Name","value":"periodValue"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"specs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"pixel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pixelAttribute"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"pixel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pixelAttribute"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"prevMaintenanceDuration"}},{"kind":"Field","name":{"kind":"Name","value":"maintenanceDuration"}},{"kind":"Field","name":{"kind":"Name","value":"expectedMeantime"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class EmptyCartGQL extends Apollo.Mutation<EmptyCartMutation, EmptyCartMutationVariables> {
    document = EmptyCartDocument;
    client = 'api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EmptyTargetCartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"emptyTargetCart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emptyTargetCart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"toPay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitNet"}},{"kind":"Field","name":{"kind":"Name","value":"unitGross"}},{"kind":"Field","name":{"kind":"Name","value":"net"}},{"kind":"Field","name":{"kind":"Name","value":"gross"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceCredit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periodCycle"}},{"kind":"Field","name":{"kind":"Name","value":"periodValue"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metaDesription"}},{"kind":"Field","name":{"kind":"Name","value":"metaKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"specs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"pixel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pixelAttribute"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"pixel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pixelAttribute"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"prevMaintenanceDuration"}},{"kind":"Field","name":{"kind":"Name","value":"maintenanceDuration"}},{"kind":"Field","name":{"kind":"Name","value":"expectedMeantime"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class EmptyTargetCartGQL extends Apollo.Mutation<EmptyTargetCartMutation, EmptyTargetCartMutationVariables> {
    document = EmptyTargetCartDocument;
    client = 'api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProductCreditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateProductCredit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productToAdd"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CartProductUpdateCreditInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productToRemove"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CartProductInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProductCredit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"productToAdd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productToAdd"}}},{"kind":"Argument","name":{"kind":"Name","value":"productToRemove"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productToRemove"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"toPay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitNet"}},{"kind":"Field","name":{"kind":"Name","value":"unitGross"}},{"kind":"Field","name":{"kind":"Name","value":"net"}},{"kind":"Field","name":{"kind":"Name","value":"gross"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceCredit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periodCycle"}},{"kind":"Field","name":{"kind":"Name","value":"periodValue"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"specs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProductCreditGQL extends Apollo.Mutation<UpdateProductCreditMutation, UpdateProductCreditMutationVariables> {
    document = UpdateProductCreditDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindSlideByTargetAndReferenceCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findSlideByTargetAndReferenceCache"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findSlideByTargetAndReferenceCache"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}},{"kind":"Argument","name":{"kind":"Name","value":"reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"calltoaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"visualType"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class FindSlideByTargetAndReferenceCacheGQL extends Apollo.Query<FindSlideByTargetAndReferenceCacheQuery, FindSlideByTargetAndReferenceCacheQueryVariables> {
    document = FindSlideByTargetAndReferenceCacheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindSlidesByTargetCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findSlidesByTargetCache"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findSlidesByTargetCache"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"calltoaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"visualType"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class FindSlidesByTargetCacheGQL extends Apollo.Query<FindSlidesByTargetCacheQuery, FindSlidesByTargetCacheQueryVariables> {
    document = FindSlidesByTargetCacheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindSocialsPaginationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findSocialsPagination"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findSocialsPagination"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"fontIcon"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"style"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"svg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size48"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size96"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size144"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size240"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size480"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class FindSocialsPaginationGQL extends Apollo.Query<FindSocialsPaginationQuery, FindSocialsPaginationQueryVariables> {
    document = FindSocialsPaginationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindStatesByCountryPaginationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findStatesByCountryPagination"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findStatesByCountryPagination"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class FindStatesByCountryPaginationGQL extends Apollo.Query<FindStatesByCountryPaginationQuery, FindStatesByCountryPaginationQueryVariables> {
    document = FindStatesByCountryPaginationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStockByTargetAndBarcodeCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStockByTargetAndBarcodeCache"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"barcode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getStockByTargetAndBarcodeCache"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}},{"kind":"Argument","name":{"kind":"Name","value":"barcode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"barcode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outOfStock"}},{"kind":"Field","name":{"kind":"Name","value":"currentStock"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStockByTargetAndBarcodeCacheGQL extends Apollo.Query<GetStockByTargetAndBarcodeCacheQuery, GetStockByTargetAndBarcodeCacheQueryVariables> {
    document = GetStockByTargetAndBarcodeCacheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindTargetOrdersByCurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findTargetOrdersByCurrentUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MarketPlaceOrderFilterConsumerInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findTargetOrdersByCurrentUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"orderTime"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"hasInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryFees"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"guestUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"extraFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"installments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"materialIcon"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"svg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shoppingCart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"toPay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitNet"}},{"kind":"Field","name":{"kind":"Name","value":"unitGross"}},{"kind":"Field","name":{"kind":"Name","value":"net"}},{"kind":"Field","name":{"kind":"Name","value":"gross"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderProductStatus"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publicPrice"}},{"kind":"Field","name":{"kind":"Name","value":"publicPriceBeforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceCredit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periodCycle"}},{"kind":"Field","name":{"kind":"Name","value":"periodValue"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class FindTargetOrdersByCurrentUserGQL extends Apollo.Query<FindTargetOrdersByCurrentUserQuery, FindTargetOrdersByCurrentUserQueryVariables> {
    document = FindTargetOrdersByCurrentUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTargetOrderInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTargetOrderInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTargetOrderInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTargetOrderInvoiceGQL extends Apollo.Query<GetTargetOrderInvoiceQuery, GetTargetOrderInvoiceQueryVariables> {
    document = GetTargetOrderInvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTargetOrderByCartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTargetOrderByCart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarketPlaceOrderInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTargetOrderByCart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderId"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTargetOrderByCartGQL extends Apollo.Mutation<CreateTargetOrderByCartMutation, CreateTargetOrderByCartMutationVariables> {
    document = CreateTargetOrderByCartDocument;
    client = 'api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTargetOrderWithCartAndRegisterUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTargetOrderWithCartAndRegisterUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarketPlaceOrderWithCartAfterRegisterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTargetOrderWithCartAndRegisterUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTargetOrderWithCartAndRegisterUserGQL extends Apollo.Mutation<CreateTargetOrderWithCartAndRegisterUserMutation, CreateTargetOrderWithCartAndRegisterUserMutationVariables> {
    document = CreateTargetOrderWithCartAndRegisterUserDocument;
    client = 'api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTargetOrderWithCartForGuestUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTargetOrderWithCartForGuestUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarketPlaceOrderWithCartForGuestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTargetOrderWithCartForGuestUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"orderTime"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"hasInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryFees"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"apps"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"about"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"plugged"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isMailValid"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"mobileTheme"}},{"kind":"Field","name":{"kind":"Name","value":"placeOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"maritalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"newsletterSubs"}},{"kind":"Field","name":{"kind":"Name","value":"hasAutoGeneratedEmail"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"read"}},{"kind":"Field","name":{"kind":"Name","value":"update"}},{"kind":"Field","name":{"kind":"Name","value":"create"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"languages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nationality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"residentialAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"chatContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"fontIcon"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"style"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"svg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size48"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size96"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size144"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size240"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size480"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"png"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size48"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size96"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size144"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size240"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size480"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"socialMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"fontIcon"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"style"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"svg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size48"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size96"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size144"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size240"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size480"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"png"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size48"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size96"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size144"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size240"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size480"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"socialLoginData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ooredoo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facebook"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"google"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sub"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"picture"}},{"kind":"Field","name":{"kind":"Name","value":"given_name"}},{"kind":"Field","name":{"kind":"Name","value":"family_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_verified"}}]}},{"kind":"Field","name":{"kind":"Name","value":"apple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"identityToken"}},{"kind":"Field","name":{"kind":"Name","value":"userIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"authorizationCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"education"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"graduated"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"work"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"current"}}]}},{"kind":"Field","name":{"kind":"Name","value":"custom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customKey"}},{"kind":"Field","name":{"kind":"Name","value":"customValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lived"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"hobbies"}},{"kind":"Field","name":{"kind":"Name","value":"interests"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"guestUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"extraFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"installments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"materialIcon"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"png"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alt2x"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alt_128"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alt_256"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alt_512"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"card_flat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"card_flat2x"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"card_flat_128"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"card_flat_256"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"card_flat_512"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dark"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dark2x"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dark_128"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dark_256"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dark_512"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flat2x"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flat_128"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flat_256"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flat_512"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"light"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"light2x"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"light_128"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"light_256"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"light_512"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default2x"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default_128"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default_256"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default_512"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"svg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"card_flat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dark"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"light"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shoppingCart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"net"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gross"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"toPay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"afterReduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitNet"}},{"kind":"Field","name":{"kind":"Name","value":"unitGross"}},{"kind":"Field","name":{"kind":"Name","value":"net"}},{"kind":"Field","name":{"kind":"Name","value":"gross"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderProductStatus"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"taxValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceCredit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periodCycle"}},{"kind":"Field","name":{"kind":"Name","value":"periodValue"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pixel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"include"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"prevMaintenanceDuration"}},{"kind":"Field","name":{"kind":"Name","value":"maintenanceDuration"}},{"kind":"Field","name":{"kind":"Name","value":"expectedMeantime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributesValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"pixel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pixelAttribute"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"descriptionList"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeReduction"}},{"kind":"Field","name":{"kind":"Name","value":"catalogueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"factoryPrice"}},{"kind":"Field","name":{"kind":"Name","value":"specs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"descriptionList"}},{"kind":"Field","name":{"kind":"Name","value":"wholesalerPrice"}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"layer"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sign"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"use"}},{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rank"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmails"}},{"kind":"Field","name":{"kind":"Name","value":"currencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"default"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"}},{"kind":"Field","name":{"kind":"Name","value":"deg360"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"legal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vat"}},{"kind":"Field","name":{"kind":"Name","value":"register"}},{"kind":"Field","name":{"kind":"Name","value":"licence"}}]}},{"kind":"Field","name":{"kind":"Name","value":"banks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"holder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"}},{"kind":"Field","name":{"kind":"Name","value":"iban"}},{"kind":"Field","name":{"kind":"Name","value":"bank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"bic"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"svg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"png"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size16"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size24"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size32"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size48"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size64"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size128"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size256"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size512"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"logistic"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"possibleValues"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"variety"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isMultipleChoice"}},{"kind":"Field","name":{"kind":"Name","value":"pixel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pixelAttribute"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTargetOrderWithCartForGuestUserGQL extends Apollo.Mutation<CreateTargetOrderWithCartForGuestUserMutation, CreateTargetOrderWithCartForGuestUserMutationVariables> {
    document = CreateTargetOrderWithCartForGuestUserDocument;
    client = 'api';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendOrderByEmailAndSmsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"sendOrderByEmailAndSms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subject"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendOrderByEmailAndSms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}},{"kind":"Argument","name":{"kind":"Name","value":"subject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subject"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class SendOrderByEmailAndSmsGQL extends Apollo.Query<SendOrderByEmailAndSmsQuery, SendOrderByEmailAndSmsQueryVariables> {
    document = SendOrderByEmailAndSmsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindCorporateTemplateByNameAndTargetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findCorporateTemplateByNameAndTarget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CorporateTemplateTypeEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCorporateTemplateByNameAndTarget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class FindCorporateTemplateByNameAndTargetGQL extends Apollo.Query<FindCorporateTemplateByNameAndTargetQuery, FindCorporateTemplateByNameAndTargetQueryVariables> {
    document = FindCorporateTemplateByNameAndTargetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserEventsSourceEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"apps"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"about"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"plugged"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isMailValid"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"mobileTheme"}},{"kind":"Field","name":{"kind":"Name","value":"placeOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"maritalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"newsletterSubs"}},{"kind":"Field","name":{"kind":"Name","value":"hasAutoGeneratedEmail"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"residentialAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserGQL extends Apollo.Mutation<UpdateUserMutation, UpdateUserMutationVariables> {
    document = UpdateUserDocument;
    client = 'auth';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentUserCompleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"currentUserComplete"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUserComplete"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"apps"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"about"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"plugged"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isMailValid"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"mobileTheme"}},{"kind":"Field","name":{"kind":"Name","value":"placeOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"maritalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"newsletterSubs"}},{"kind":"Field","name":{"kind":"Name","value":"hasAutoGeneratedEmail"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"residentialAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentUserCompleteGQL extends Apollo.Query<CurrentUserCompleteQuery, CurrentUserCompleteQueryVariables> {
    document = CurrentUserCompleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentUserGQL extends Apollo.Query<CurrentUserQuery, CurrentUserQueryVariables> {
    document = CurrentUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCurrentUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserEventsSourceEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCurrentUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"apps"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"about"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"plugged"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isMailValid"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"mobileTheme"}},{"kind":"Field","name":{"kind":"Name","value":"placeOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"maritalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"newsletterSubs"}},{"kind":"Field","name":{"kind":"Name","value":"hasAutoGeneratedEmail"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"residentialAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCurrentUserGQL extends Apollo.Mutation<UpdateCurrentUserMutation, UpdateCurrentUserMutationVariables> {
    document = UpdateCurrentUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCurrentUserPasswordForAppDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCurrentUserPasswordForApp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oldPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCurrentUserPasswordForApp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"newPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newPassword"}}},{"kind":"Argument","name":{"kind":"Name","value":"oldPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldPassword"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"apps"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"about"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"plugged"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isMailValid"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"mobileTheme"}},{"kind":"Field","name":{"kind":"Name","value":"placeOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"maritalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"newsletterSubs"}},{"kind":"Field","name":{"kind":"Name","value":"hasAutoGeneratedEmail"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"residentialAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCurrentUserPasswordForAppGQL extends Apollo.Mutation<UpdateCurrentUserPasswordForAppMutation, UpdateCurrentUserPasswordForAppMutationVariables> {
    document = UpdateCurrentUserPasswordForAppDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCurrentUserPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCurrentUserPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oldPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCurrentUserPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"newPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newPassword"}}},{"kind":"Argument","name":{"kind":"Name","value":"oldPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldPassword"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"apps"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"about"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"plugged"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isMailValid"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"mobileTheme"}},{"kind":"Field","name":{"kind":"Name","value":"placeOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"maritalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"newsletterSubs"}},{"kind":"Field","name":{"kind":"Name","value":"hasAutoGeneratedEmail"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"residentialAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"capital"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"ascii"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCurrentUserPasswordGQL extends Apollo.Mutation<UpdateCurrentUserPasswordMutation, UpdateCurrentUserPasswordMutationVariables> {
    document = UpdateCurrentUserPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindVisualsByTargetCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findVisualsByTargetCache"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findVisualsByTargetCache"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"square"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"favicon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size16"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size32"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size57"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size60"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size72"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size76"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size96"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size114"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size120"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size144"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size152"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size180"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size192"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class FindVisualsByTargetCacheGQL extends Apollo.Query<FindVisualsByTargetCacheQuery, FindVisualsByTargetCacheQueryVariables> {
    document = FindVisualsByTargetCacheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCurrentUserQuantitativeWalletsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCurrentUserQuantitativeWallets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userToken"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCurrentUserQuantitativeWallets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userToken"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"walletType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"coin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"dialCode"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"api"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"push"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"headers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"user"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"params"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"user"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"headers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"user"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"params"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"user"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"check"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"headers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"params"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"user"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"brandColor"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCurrentUserQuantitativeWalletsGQL extends Apollo.Query<GetCurrentUserQuantitativeWalletsQuery, GetCurrentUserQuantitativeWalletsQueryVariables> {
    document = GetCurrentUserQuantitativeWalletsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetWebsiteIntegrationByTargetCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWebsiteIntegrationByTargetCache"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getWebsiteIntegrationByTargetCache"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"multilanguage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"languages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"default"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"multicurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"currencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"iconFlag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flagWide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"default"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaler"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetWebsiteIntegrationByTargetCacheGQL extends Apollo.Query<GetWebsiteIntegrationByTargetCacheQuery, GetWebsiteIntegrationByTargetCacheQueryVariables> {
    document = GetWebsiteIntegrationByTargetCacheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListenForSendThemAndLanguageToWidgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"listenForSendThemAndLanguageToWidget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listenForSendThemAndLanguageToWidget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}},{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"theme"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class ListenForSendThemAndLanguageToWidgetGQL extends Apollo.Subscription<ListenForSendThemAndLanguageToWidgetSubscription, ListenForSendThemAndLanguageToWidgetSubscriptionVariables> {
    document = ListenForSendThemAndLanguageToWidgetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }